(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 36160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ N; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78776);
/* harmony import */ var _taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10518);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6767);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33622);
/* harmony import */ var _themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55029);
/* harmony import */ var _Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42990);
var m;(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.s)(".Badge_badge__2{display:inline-block;padding:.25rem .4rem;border-radius:4px;color:#fff;font-size:.75rem;font-weight:700;line-height:100%;text-align:center;text-decoration:none;white-space:nowrap;vertical-align:baseline}.Badge_badge__2 svg{width:16px;min-width:16px;height:16px;min-height:16px}.Badge_badge__icon__19{margin:-6px 4px -4px 0;fill:currentColor}.Badge_badge__removable__22{margin:-6px -4px -4px 4px;fill:#fff}a.Badge_badge__2,a.Badge_badge__2:focus{text-decoration:none}a.Badge_badge__2:hover{text-decoration:underline}button.Badge_badge__2{padding:.188rem .313rem;border:1px solid transparent;border-radius:4px;cursor:pointer}.Badge_badge__2:focus,.Badge_badge__2:hover{color:#fff}.Badge_badge--outline__38{color:#fff;box-shadow:inset 0 0 0 2px #fff}.Badge_badge--pill__41{padding:.25rem .6rem;border-radius:10rem;color:#36394d;box-shadow:inset 0 0 0 1px #36394d}.Badge_badge--pill__41:focus,.Badge_badge--pill__41:hover{color:#36394d}.Badge_badge--pill__41.Badge_badge--dark__48:focus,.Badge_badge--pill__41.Badge_badge--dark__48:hover{color:#fff}.Badge_badge--pill__41 i{margin-right:.25rem}.Badge_badge--primary__53{background:#5668c7;color:#fff}.Badge_badge--primary__53:focus,.Badge_badge--primary__53:hover{color:#fff}.Badge_badge--primary__53.Badge_badge--pill__41{box-shadow:none}.Badge_badge--secondary__61{background:#6f7282;color:#fff}.Badge_badge--secondary__61:focus,.Badge_badge--secondary__61:hover{color:#fff}.Badge_badge--secondary__61.Badge_badge--pill__41{box-shadow:none}.Badge_badge--success__69{background:#379a49;color:#fff}.Badge_badge--success__69:focus,.Badge_badge--success__69:hover{color:#fff}.Badge_badge--success__69.Badge_badge--pill__41{box-shadow:none}.Badge_badge--info__77{background:#139bde;color:#fff}.Badge_badge--info__77:focus,.Badge_badge--info__77:hover{color:#fff}.Badge_badge--info__77.Badge_badge--pill__41{box-shadow:none}.Badge_badge--warning__85{background:#ff7e40;color:#fff}.Badge_badge--warning__85:focus,.Badge_badge--warning__85:hover{color:#fff}.Badge_badge--warning__85.Badge_badge--pill__41{box-shadow:none}.Badge_badge--danger__93{background:#d83232;color:#fff}.Badge_badge--danger__93:focus,.Badge_badge--danger__93:hover{color:#fff}.Badge_badge--danger__93.Badge_badge--pill__41{box-shadow:none}.Badge_badge--light__101{background:#eceffb;color:#fff}.Badge_badge--light__101:focus,.Badge_badge--light__101:hover{color:#fff}.Badge_badge--light__101.Badge_badge--pill__41{box-shadow:none}.Badge_badge--dark__48{background:#100d59;color:#fff}.Badge_badge--dark__48:focus,.Badge_badge--dark__48:hover{color:#fff}.Badge_badge--dark__48.Badge_badge--pill__41{box-shadow:none}.Badge_badge--upsell__117{background:#00a999;color:#fff}.Badge_badge--upsell__117:focus,.Badge_badge--upsell__117:hover{color:#fff}.Badge_badge--upsell__117.Badge_badge--pill__41{box-shadow:none}.Badge_badge--light__101,.Badge_badge--light__101:focus,.Badge_badge--light__101:hover{color:#100d59}",{insertAt:"top"});var h,v,y,x=function(e,a){var d,o,r,_,g,n,i=null===(d=a.color)||void 0===d?void 0:d.primary;if(!(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(i))return null;switch(e){case"primary":return i;case"secondary":return null===(o=a.color)||void 0===o?void 0:o.secondary;case"danger":return null===(r=a.color)||void 0===r?void 0:r.danger;case"info":return null===(_=a.color)||void 0===_?void 0:_.info;case"success":return null===(g=a.color)||void 0===g?void 0:g.success;case"warning":return null===(n=a.color)||void 0===n?void 0:n.warning;case"dark":if(i)return color__WEBPACK_IMPORTED_MODULE_1___default()(i).darken(.3).hex();break;case"light":if(i)return color__WEBPACK_IMPORTED_MODULE_1___default()(i).lighten(.3).mix(color__WEBPACK_IMPORTED_MODULE_1___default()("white"),.5).hex()}return null},w=(0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(m||(m=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  background-color: ",";\n  color: ",";\n"])),(function(e){return x(e.type,e.theme)}),(function(e){return(a=x(e.type,e.theme))&&(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(a)?(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.e)(a,"white")?"white":(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(a).hex():null;var a})),k=["ariaLabel","children","className","hasOutline","href","icon","isPill","isRemovable","type","onClick","onKeyPress"],P=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind({badge:"Badge_badge__2",badge__icon:"Badge_badge__icon__19",badge__removable:"Badge_badge__removable__22","badge--outline":"Badge_badge--outline__38","badge--pill":"Badge_badge--pill__41","badge--dark":"Badge_badge--dark__48","badge--primary":"Badge_badge--primary__53","badge--secondary":"Badge_badge--secondary__61","badge--success":"Badge_badge--success__69","badge--info":"Badge_badge--info__77","badge--warning":"Badge_badge--warning__85","badge--danger":"Badge_badge--danger__93","badge--light":"Badge_badge--light__101","badge--upsell":"Badge_badge--upsell__117"}),C=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(h||(h=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),w),L=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(v||(v=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),w),R=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].span */ .ZP.span(y||(y=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),w),j=function(d){var _,g=d.ariaLabel,n=d.children,i=d.className,l=d.hasOutline,s=d.href,b=d.icon,c=d.isPill,t=d.isRemovable,f=d.type,B=d.onClick,m=d.onKeyPress,h=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__._)(d,k),v=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_7__.T);_=s?C:t?L:R;var y=P("badge",i,{"badge--primary":"primary"===f,"badge--secondary":"secondary"===f,"badge--danger":"danger"===f,"badge--info":"info"===f,"badge--success":"success"===f,"badge--warning":"warning"===f,"badge--dark":"dark"===f,"badge--light":"light"===f,"badge--outline":l,"badge--pill":c,"badge--upsell":"upsell"===f});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__.a)({"aria-label":g,className:y,href:s,isRemovable:t,theme:v,type:f,onClick:B,onKeyPress:m},h),b&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_8__.I,{className:P("badge__icon"),name:b,"aria-hidden":!0}),n,t&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_8__.I,{className:P("badge__removable"),name:"x-dismiss","aria-hidden":!0}))};j.propTypes={ariaLabel:function(e,a,d){var o=e.ariaLabel,r=e.isRemovable;return!o&&r?new Error("Badge Tag has no ariaLabel. Please add a descriptive ariaLabel for accessibility reasons."):o&&"string"!=typeof o?new Error("ariaLabel must be type of string"):null},children:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,hasOutline:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool),href:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),icon:prop_types__WEBPACK_IMPORTED_MODULE_9___default().oneOf(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_8__.a),isPill:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().bool),isRemovable:function(e,a,d){var o=e.isRemovable,r=e.onClick,_=e.onKeyPress;return o&&!r||o&&!_?new Error("Badge Tag has no onClick or onKeyPress. Please add both to ensure the tag can be interacted with (i.e. removed) and for accessibility reasons."):o&&"boolean"!=typeof o?new Error("isRemovable must be type of boolean"):null},type:prop_types__WEBPACK_IMPORTED_MODULE_9___default().oneOf(["primary","secondary","danger","info","success","warning","dark","light","upsell"]),onClick:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().func),onKeyPress:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().func)},j.defaultProps={ariaLabel:null,className:null,hasOutline:!1,href:null,icon:null,isPill:!1,isRemovable:!1,type:"primary",onClick:function(){},onKeyPress:function(){}},j.displayName="Badge",j.filename=__filename;var N=j;
//# sourceMappingURL=Badge-95ef19f1.js.map


/***/ }),

/***/ 79707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ F; },
/* harmony export */   "s": function() { return /* binding */ f; },
/* harmony export */   "w": function() { return /* binding */ U; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78776);
/* harmony import */ var _taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10518);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6767);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33622);
/* harmony import */ var _themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55029);
var f={button:"Button_button__2","button--primary":"Button_button--primary__27",focused:"Button_focused__32",hovered:"Button_hovered__32",pressed:"Button_pressed__37",active:"Button_active__37","button--primary-dark":"Button_button--primary-dark__46","button--danger":"Button_button--danger__68","button--danger-dark":"Button_button--danger-dark__87","button--upgrade":"Button_button--upgrade__109","button--upgrade-dark":"Button_button--upgrade-dark__128","button--secondary":"Button_button--secondary__150","button--secondary-dark":"Button_button--secondary-dark__172","button--secondary-danger":"Button_button--secondary-danger__194","button--secondary-danger-dark":"Button_button--secondary-danger-dark__213","button--secondary-upgrade":"Button_button--secondary-upgrade__235","button--secondary-upgrade-dark":"Button_button--secondary-upgrade-dark__256","button--secondary-success":"Button_button--secondary-success__277","button--secondary-warning":"Button_button--secondary-warning__296","button--secondary-info":"Button_button--secondary-info__315","button--knockout":"Button_button--knockout__334","button--knockout-danger":"Button_button--knockout-danger__354","button--knockout-upgrade":"Button_button--knockout-upgrade__373","button--knockout-dark":"Button_button--knockout-dark__392","button--knockout-danger-dark":"Button_button--knockout-danger-dark__411","button--knockout-upgrade-dark":"Button_button--knockout-upgrade-dark__430","button--link":"Button_button--link__449","button--link-dark":"Button_button--link-dark__472","button--icon-left":"Button_button--icon-left__495",spinner:"Button_spinner__496","button--icon-right":"Button_button--icon-right__501","button--empty-state-upsell":"Button_button--empty-state-upsell__506","button--icon-both":"Button_button--icon-both__508","button--icon-only":"Button_button--icon-only__517","button--icon-only-small":"Button_button--icon-only-small__524","button--block":"Button_button--block__531","button--x-small":"Button_button--x-small__533","button--small":"Button_button--small__536","button--small-tight":"Button_button--small-tight__539","button--large":"Button_button--large__542","button--naked":"Button_button--naked__545","button--utility":"Button_button--utility__549","button--utility-dark":"Button_button--utility-dark__568","button--notification-warning":"Button_button--notification-warning__587",warning:"Button_warning__1","button--notification-danger":"Button_button--notification-danger__609",danger:"Button_danger__1","button--notification-success":"Button_button--notification-success__631",success:"Button_success__1","button--accessible-link":"Button_button--accessible-link__653","button--accessible-link-dark":"Button_button--accessible-link-dark__684","button-group-isolated--left":"Button_button-group-isolated--left__719","button-group-isolated--right":"Button_button-group-isolated--right__731"};(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.s)('.Button_button__2{display:inline-flex;position:relative;flex-shrink:0;align-items:center;justify-content:center;height:40px;padding:0 16px;border:1px solid transparent;border-radius:4px;background-color:transparent;color:#36394d;font-family:Barlow,sans-serif;font-size:.875rem;font-weight:600;letter-spacing:.03125rem;line-height:1.5rem;text-decoration:none;text-transform:uppercase;cursor:pointer}.Button_button__2:disabled,.Button_button__2[aria-disabled=true]{cursor:not-allowed;opacity:.45}.Button_button__2 [class*=icon-]{font-size:1.5rem}.Button_button--primary__27{background-color:#100d59;color:#fff}.Button_button--primary__27 svg{fill:#fff}.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):focus,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):hover{background-color:#5668c7;color:#fff}.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):active{background-color:#3d47a3;color:#fff}.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--primary__27:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--primary__27:disabled,.Button_button--primary__27[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--primary__27:disabled svg,.Button_button--primary__27[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--primary-dark__46{border-color:#fff;background-color:#fff;color:#100d59}.Button_button--primary-dark__46 svg{fill:#100d59}.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):focus,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):hover{border-color:#5668c7;background-color:#5668c7;color:#fff}.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):active{border-color:#3d47a3;background-color:#3d47a3;color:#fff}.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--primary-dark__46:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--primary-dark__46:disabled,.Button_button--primary-dark__46[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--primary-dark__46:disabled svg,.Button_button--primary-dark__46[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}.Button_button--danger__68{background-color:#d83232;color:#fff}.Button_button--danger__68 svg{fill:#fff}.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):focus,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):hover{background-color:#a62626;color:#fff}.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):active{background-color:#731a1a;color:#fff}.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--danger__68:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--danger__68:disabled,.Button_button--danger__68[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--danger__68:disabled svg,.Button_button--danger__68[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--danger-dark__87{border-color:#fff;background-color:#fff;color:#d83232}.Button_button--danger-dark__87 svg{fill:#d83232}.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):focus,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):hover{border-color:#d83232;background-color:#d83232;color:#fff}.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):active{border-color:#a62626;background-color:#a62626;color:#fff}.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--danger-dark__87:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--danger-dark__87:disabled,.Button_button--danger-dark__87[aria-disabled=true]{color:rgba(216,50,50,.45)}.Button_button--danger-dark__87:disabled svg,.Button_button--danger-dark__87[aria-disabled=true] svg{fill:rgba(216,50,50,.45)}.Button_button--upgrade__109{background-color:#00a999;color:#fff}.Button_button--upgrade__109 svg{fill:#fff}.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):focus,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):hover{background-color:#006f63;color:#fff}.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):active{background-color:#122e2c;color:#fff}.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--upgrade__109:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--upgrade__109:disabled,.Button_button--upgrade__109[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--upgrade__109:disabled svg,.Button_button--upgrade__109[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--upgrade-dark__128{border-color:#fff;background-color:#fff;color:#006f63}.Button_button--upgrade-dark__128 svg{fill:#006f63}.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):focus,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):hover{border-color:#00a999;background-color:#00a999;color:#fff}.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):active{border-color:#006f63;background-color:#006f63;color:#fff}.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--upgrade-dark__128:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--upgrade-dark__128:disabled,.Button_button--upgrade-dark__128[aria-disabled=true]{color:rgba(0,169,153,.45)}.Button_button--upgrade-dark__128:disabled svg,.Button_button--upgrade-dark__128[aria-disabled=true] svg{fill:rgba(0,169,153,.45)}.Button_button--secondary__150{border-color:#caccd6;background-color:#fff;color:#100d59}.Button_button--secondary__150 svg{fill:#100d59}.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):hover{border-color:#5668c7;background:#eceffb;color:#100d59}.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):hover svg{fill:#100d59}.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):active{border-color:#3d47a3;background-color:#5668c7;color:#fff}.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary__150:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary__150:disabled,.Button_button--secondary__150[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--secondary__150:disabled svg,.Button_button--secondary__150[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}.Button_button--secondary-dark__172{border-color:#fff;background-color:transparent;color:#fff}.Button_button--secondary-dark__172 svg{fill:#fff}.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):hover{border-color:#fff;background-color:hsla(0,0%,100%,.15);color:#fff}.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):active{border-color:#5668c7;background-color:#5668c7;color:#fff}.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-dark__172:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-dark__172:disabled,.Button_button--secondary-dark__172[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--secondary-dark__172:disabled svg,.Button_button--secondary-dark__172[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--secondary-danger__194{border-color:#fc6767;color:#d83232}.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):hover{border-color:#d83232;background-color:#fff1f1;color:#d83232}.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):hover svg{fill:#d83232}.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):active{border-color:#a62626;background:#d83232;color:#fff}.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-danger__194:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-danger__194:disabled,.Button_button--secondary-danger__194[aria-disabled=true]{color:rgba(216,50,50,.45)}.Button_button--secondary-danger__194:disabled svg,.Button_button--secondary-danger__194[aria-disabled=true] svg{fill:rgba(216,50,50,.45)}.Button_button--secondary-danger-dark__213{border-color:#fc6767;background-color:transparent;color:#fff}.Button_button--secondary-danger-dark__213 svg{fill:#fff}.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):hover{border-color:#fc6767;background-color:hsla(0,0%,100%,.15);color:#fff}.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):active{border-color:#fc6767;background-color:#fc6767;color:#fff}.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-danger-dark__213:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-danger-dark__213:disabled,.Button_button--secondary-danger-dark__213[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--secondary-danger-dark__213:disabled svg,.Button_button--secondary-danger-dark__213[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--secondary-upgrade__235{border:1px solid #006f63;color:#006f63}.Button_button--secondary-upgrade__235 svg{fill:#006f63}.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):hover{border-color:#006f63;background-color:#effaf9;color:#006f63}.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):hover svg{fill:#006f63}.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):active{border-color:#006f63;background-color:#006f63;color:#fff}.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-upgrade__235:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-upgrade__235:disabled,.Button_button--secondary-upgrade__235[aria-disabled=true]{color:rgba(0,111,99,.45)}.Button_button--secondary-upgrade__235:disabled svg,.Button_button--secondary-upgrade__235[aria-disabled=true] svg{fill:rgba(0,111,99,.45)}.Button_button--secondary-upgrade-dark__256{border-color:#00a999;color:#fff}.Button_button--secondary-upgrade-dark__256 svg{fill:#fff}.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):hover{border-color:#00a999;background-color:hsla(0,0%,100%,.15);color:#fff}.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):active{border-color:#00a999;background-color:#00a999;color:#fff}.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-upgrade-dark__256:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-upgrade-dark__256:disabled,.Button_button--secondary-upgrade-dark__256[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--secondary-upgrade-dark__256:disabled svg,.Button_button--secondary-upgrade-dark__256[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--secondary-success__277{border-color:#379a49;color:#379a49}.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):hover{border-color:#379a49;background-color:#216e2f;color:#fff}.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):active{border-color:#216e2f;background:#216e2f;color:#fff}.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-success__277:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-success__277:disabled,.Button_button--secondary-success__277[aria-disabled=true]{color:rgba(55,154,73,.45)}.Button_button--secondary-success__277:disabled svg,.Button_button--secondary-success__277[aria-disabled=true] svg{fill:rgba(55,154,73,.45)}.Button_button--secondary-warning__296{border-color:#ff7e40;color:#ff7e40}.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):hover{border-color:#af4d1e;background-color:#af4d1e;color:#fff}.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):active{border-color:#af4d1e;background:#af4d1e;color:#fff}.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-warning__296:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-warning__296:disabled,.Button_button--secondary-warning__296[aria-disabled=true]{color:rgba(255,126,64,.45)}.Button_button--secondary-warning__296:disabled svg,.Button_button--secondary-warning__296[aria-disabled=true] svg{fill:rgba(255,126,64,.45)}.Button_button--secondary-info__315{border-color:#36394d;color:#36394d}.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):focus,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):hover{border-color:#12131a;background-color:#12131a;color:#fff}.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):active{border-color:#12131a;background:#12131a;color:#fff}.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--secondary-info__315:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--secondary-info__315:disabled,.Button_button--secondary-info__315[aria-disabled=true]{color:rgba(54,57,77,.45)}.Button_button--secondary-info__315:disabled svg,.Button_button--secondary-info__315[aria-disabled=true] svg{fill:rgba(54,57,77,.45)}.Button_button--knockout__334{background-color:transparent;color:#100d59}.Button_button--knockout__334 svg{fill:#100d59}.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):hover{border-color:#5668c7;color:#100d59}.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):hover svg{fill:#100d59}.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):active{border-color:#3d47a3;background-color:#eceffb;color:#100d59}.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout__334:not([disabled]):not([aria-disabled=true]):active svg{fill:#100d59}.Button_button--knockout__334:disabled,.Button_button--knockout__334[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--knockout__334:disabled svg,.Button_button--knockout__334[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}.Button_button--knockout-danger__354{color:#d83232}.Button_button--knockout-danger__354 svg{fill:#d83232}.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):hover{border-color:#d83232;color:#d83232}.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):hover svg{fill:#d83232}.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):active{border-color:#d83232;background-color:#d83232;color:#fff}.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout-danger__354:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--knockout-danger__354:disabled,.Button_button--knockout-danger__354[aria-disabled=true]{color:rgba(216,50,50,.45)}.Button_button--knockout-danger__354:disabled svg,.Button_button--knockout-danger__354[aria-disabled=true] svg{fill:rgba(216,50,50,.45)}.Button_button--knockout-upgrade__373{color:#006f63}.Button_button--knockout-upgrade__373 svg{fill:#006f63}.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):hover{border-color:#006f63;color:#006f63}.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):hover svg{fill:#006f63}.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):active{border-color:#006f63;background-color:#006f63;color:#fff}.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout-upgrade__373:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--knockout-upgrade__373:disabled,.Button_button--knockout-upgrade__373[aria-disabled=true]{color:rgba(0,169,153,.45)}.Button_button--knockout-upgrade__373:disabled svg,.Button_button--knockout-upgrade__373[aria-disabled=true] svg{fill:rgba(0,169,153,.45)}.Button_button--knockout-dark__392{background-color:transparent;color:#fff}.Button_button--knockout-dark__392 svg{fill:#fff}.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):hover{border-color:#fff;color:#fff}.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):active{background-color:#5668c7;color:#fff}.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout-dark__392:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--knockout-dark__392:disabled,.Button_button--knockout-dark__392[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--knockout-dark__392:disabled svg,.Button_button--knockout-dark__392[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--knockout-danger-dark__411{color:#fff}.Button_button--knockout-danger-dark__411 svg{fill:#fff}.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):hover{border-color:#a62626;color:#fff}.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):active{border-color:#a62626;background-color:#a62626;color:#fff}.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout-danger-dark__411:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--knockout-danger-dark__411:disabled,.Button_button--knockout-danger-dark__411[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--knockout-danger-dark__411:disabled svg,.Button_button--knockout-danger-dark__411[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--knockout-upgrade-dark__430{color:#fff}.Button_button--knockout-upgrade-dark__430 svg{fill:#fff}.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_focused__32,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):focus,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):hover{border-color:#006f63;color:#fff}.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_focused__32 svg,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_active__37,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):active{border-color:#006f63;background-color:#006f63;color:#fff}.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_active__37 svg,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--knockout-upgrade-dark__430:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--knockout-upgrade-dark__430:disabled,.Button_button--knockout-upgrade-dark__430[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--knockout-upgrade-dark__430:disabled svg,.Button_button--knockout-upgrade-dark__430[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--link__449{background-color:transparent;color:#5668c7;font-weight:400;letter-spacing:normal;text-transform:none}.Button_button--link__449:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):active{color:#100d59;box-shadow:none}.Button_button--link__449:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):focus,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:not(button){text-decoration:none;color:#3d47a3}.Button_button--link__449:not([disabled]):not([aria-disabled=true]).Button_hovered__32:focus,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):focus:focus,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:focus,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:not(button):focus{text-decoration:none}.Button_button--link__449:not([disabled]):not([aria-disabled=true]).Button_hovered__32:hover,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):focus:hover,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:hover,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:not(button):hover{text-decoration:underline}.Button_button--link__449:not([disabled]):not([aria-disabled=true]).Button_hovered__32 [class*=icon-]:before,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):focus [class*=icon-]:before,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover:not(button) [class*=icon-]:before,.Button_button--link__449:not([disabled]):not([aria-disabled=true]):hover [class*=icon-]:before{display:inline-block;text-decoration:none}.Button_button--link__449:disabled,.Button_button--link__449[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--link__449:disabled svg,.Button_button--link__449[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}.Button_button--link-dark__472{background-color:transparent;color:#fff;font-weight:400;letter-spacing:normal;text-transform:none}.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):active{color:#f2f3f5;box-shadow:none}.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):focus,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:not(button){text-decoration:none;color:#caccd6}.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]).Button_hovered__32:focus,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):focus:focus,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:focus,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:not(button):focus{text-decoration:none}.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]).Button_hovered__32:hover,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):focus:hover,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:hover,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:not(button):hover{text-decoration:underline}.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]).Button_hovered__32 [class*=icon-]:before,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):focus [class*=icon-]:before,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover:not(button) [class*=icon-]:before,.Button_button--link-dark__472:not([disabled]):not([aria-disabled=true]):hover [class*=icon-]:before{display:inline-block;text-decoration:none}.Button_button--link-dark__472:disabled,.Button_button--link-dark__472[aria-disabled=true]{color:hsla(0,0%,100%,.45)}.Button_button--link-dark__472:disabled svg,.Button_button--link-dark__472[aria-disabled=true] svg{fill:hsla(0,0%,100%,.45)}.Button_button--icon-left__495 .Button_spinner__496,.Button_button--icon-left__495 [class*=icon-]{margin-right:8px;margin-left:-4px;font-size:1.5rem;line-height:24px}.Button_button--icon-right__501 [class*=icon-]{margin-right:-4px;margin-left:4px;font-size:1.5rem;line-height:24px}.Button_button--empty-state-upsell__506{vertical-align:middle}.Button_button--icon-both__508 [class*=icon-]{font-size:1.5rem;line-height:24px}.Button_button--icon-both__508 [class*=icon-]:first-child{margin-right:8px;margin-left:-4px}.Button_button--icon-both__508 [class*=icon-]:last-child{margin-right:-4px;margin-left:4px}.Button_button--icon-only__517{width:40px;height:40px;padding:0}.Button_button--icon-only__517 [class*=icon-]{margin:0 auto;font-size:1.5rem}.Button_button--icon-only-small__524{width:32px;height:32px;padding:0}.Button_button--icon-only-small__524 [class*=icon-]{margin:0 auto;font-size:1.5rem}.Button_button--block__531{width:100%}.Button_button--x-small__533{height:24px;padding:0 8px}.Button_button--small__536{height:32px;padding:0 16px}.Button_button--small-tight__539{height:32px;padding:0 8px}.Button_button--large__542{height:48px;padding:0 32px}.Button_button--naked__545,.Button_button--naked__545:focus,.Button_button--naked__545:hover .Button_button--naked__545:active{border-color:transparent}.Button_button--utility__549{background:transparent;color:#002c47}.Button_button--utility__549 svg{fill:#002c47}.Button_button--utility__549:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):focus,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):hover{background:rgba(0,44,71,.1);color:#002c47}.Button_button--utility__549:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):hover svg{fill:#002c47}.Button_button--utility__549:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):active{background:rgba(0,44,71,.05);color:#002c47}.Button_button--utility__549:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--utility__549:not([disabled]):not([aria-disabled=true]):active svg{fill:#002c47}.Button_button--utility__549:disabled,.Button_button--utility__549[aria-disabled=true]{color:rgba(0,44,71,.45)}.Button_button--utility__549:disabled svg,.Button_button--utility__549[aria-disabled=true] svg{fill:rgba(0,44,71,.45)}.Button_button--utility-dark__568{background:transparent;color:#caccd6}.Button_button--utility-dark__568 svg{fill:#caccd6}.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):focus,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):hover{background:hsla(0,0%,100%,.3);color:#fff}.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]).Button_hovered__32 svg,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):focus svg,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):active{background:hsla(0,0%,100%,.15);color:#fff}.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]).Button_pressed__37 svg,.Button_button--utility-dark__568:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Button_button--utility-dark__568:disabled,.Button_button--utility-dark__568[aria-disabled=true]{color:rgba(202,204,214,.45)}.Button_button--utility-dark__568:disabled svg,.Button_button--utility-dark__568[aria-disabled=true] svg{fill:rgba(202,204,214,.45)}.Button_button--notification-warning__587:after{position:absolute;top:6px;right:6px;width:6px;height:6px;border:.5px solid rgba(0,0,0,.25);border-radius:100px;background:#ffde87;content:"";-webkit-animation:Button_warning__1 2s ease infinite;animation:Button_warning__1 2s ease infinite}@-webkit-keyframes Button_warning__1{0%{box-shadow:0 0 0 0 rgba(255,222,135,.5)}30%{box-shadow:0 0 0 4px rgba(255,222,135,.3)}to{box-shadow:0 0 0 4px rgba(255,222,135,0)}}@keyframes Button_warning__1{0%{box-shadow:0 0 0 0 rgba(255,222,135,.5)}30%{box-shadow:0 0 0 4px rgba(255,222,135,.3)}to{box-shadow:0 0 0 4px rgba(255,222,135,0)}}@media screen and (prefers-reduced-motion:reduce){.Button_button--notification-warning__587:after{-webkit-animation:none;animation:none}}.Button_button--notification-danger__609:after{position:absolute;top:6px;right:6px;width:6px;height:6px;border:.5px solid rgba(0,0,0,.25);border-radius:100px;background:#fc6767;content:"";-webkit-animation:Button_danger__1 2s ease infinite;animation:Button_danger__1 2s ease infinite}@-webkit-keyframes Button_danger__1{0%{box-shadow:0 0 0 0 rgba(252,103,103,.5)}30%{box-shadow:0 0 0 4px rgba(252,103,103,.3)}to{box-shadow:0 0 0 4px rgba(252,103,103,0)}}@keyframes Button_danger__1{0%{box-shadow:0 0 0 0 rgba(252,103,103,.5)}30%{box-shadow:0 0 0 4px rgba(252,103,103,.3)}to{box-shadow:0 0 0 4px rgba(252,103,103,0)}}@media screen and (prefers-reduced-motion:reduce){.Button_button--notification-danger__609:after{-webkit-animation:none;animation:none}}.Button_button--notification-success__631:after{position:absolute;top:6px;right:6px;width:6px;height:6px;border:.5px solid rgba(0,0,0,.25);border-radius:100px;background:#72ca83;content:"";-webkit-animation:Button_success__1 2s ease infinite;animation:Button_success__1 2s ease infinite}@-webkit-keyframes Button_success__1{0%{box-shadow:0 0 0 0 rgba(114,202,131,.5)}30%{box-shadow:0 0 0 4px rgba(114,202,131,.3)}to{box-shadow:0 0 0 4px rgba(114,202,131,0)}}@keyframes Button_success__1{0%{box-shadow:0 0 0 0 rgba(114,202,131,.5)}30%{box-shadow:0 0 0 4px rgba(114,202,131,.3)}to{box-shadow:0 0 0 4px rgba(114,202,131,0)}}@media screen and (prefers-reduced-motion:reduce){.Button_button--notification-success__631:after{-webkit-animation:none;animation:none}}.Button_button--accessible-link__653{background-color:transparent;font-weight:400;letter-spacing:normal;text-transform:none;height:auto;color:#5668c7;font-size:inherit;text-decoration:underline}.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):active{color:#100d59;box-shadow:none}.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):focus,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:not(button){text-decoration:none;color:#3d47a3}.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]).Button_hovered__32:focus,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):focus:focus,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:focus,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:not(button):focus{text-decoration:none}.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]).Button_hovered__32:hover,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):focus:hover,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:hover,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:not(button):hover{text-decoration:underline}.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]).Button_hovered__32 [class*=icon-]:before,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):focus [class*=icon-]:before,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover:not(button) [class*=icon-]:before,.Button_button--accessible-link__653:not([disabled]):not([aria-disabled=true]):hover [class*=icon-]:before{display:inline-block;text-decoration:none}.Button_button--accessible-link__653:disabled,.Button_button--accessible-link__653[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--accessible-link__653:disabled svg,.Button_button--accessible-link__653[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}a.Button_button--accessible-link__653,button.Button_button--accessible-link__653{padding:0;line-height:inherit}.Button_button--accessible-link-dark__684{background-color:transparent;font-weight:400;letter-spacing:normal;text-transform:none;height:auto;color:#5668c7;font-size:inherit;text-decoration:underline;color:#fff}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]).Button_pressed__37,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):active{color:#100d59;box-shadow:none}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]).Button_hovered__32,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):focus,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:not(button){text-decoration:none;color:#3d47a3}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]).Button_hovered__32:focus,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):focus:focus,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:focus,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:not(button):focus{text-decoration:none}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]).Button_hovered__32:hover,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):focus:hover,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:hover,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:not(button):hover{text-decoration:underline}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]).Button_hovered__32 [class*=icon-]:before,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):focus [class*=icon-]:before,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover:not(button) [class*=icon-]:before,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover [class*=icon-]:before{display:inline-block;text-decoration:none}.Button_button--accessible-link-dark__684:disabled,.Button_button--accessible-link-dark__684[aria-disabled=true]{color:rgba(16,13,89,.45)}.Button_button--accessible-link-dark__684:disabled svg,.Button_button--accessible-link-dark__684[aria-disabled=true] svg{fill:rgba(16,13,89,.45)}a.Button_button--accessible-link-dark__684,button.Button_button--accessible-link-dark__684{padding:0;line-height:inherit}.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):active,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):focus,.Button_button--accessible-link-dark__684:not([disabled]):not([aria-disabled=true]):hover{color:#caccd6}.Button_button-group-isolated--left__719{border-top-right-radius:0;border-bottom-right-radius:0}.Button_button-group-isolated--left__719:focus,.Button_button-group-isolated--left__719:hover{margin-right:-1px;border:1px solid #5668c7;z-index:1}.Button_button-group-isolated--left__719:focus:not(.Button_button--primary__27),.Button_button-group-isolated--left__719:hover:not(.Button_button--primary__27){margin-right:0}.Button_button-group-isolated--left__719:focus:not(.Button_button--icon-only__517),.Button_button-group-isolated--left__719:hover:not(.Button_button--icon-only__517){padding-right:17px}.Button_button-group-isolated--right__731{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.Button_button-group-isolated--right__731:focus:not([disabled]):not([aria-disabled=true]),.Button_button-group-isolated--right__731:hover:not([disabled]):not([aria-disabled=true]){width:41px;margin-left:-1px;border-left:1px solid #5668c7}.Button_button-group-isolated--right__731:focus.Button_button--primary__27:focus:before,.Button_button-group-isolated--right__731:focus.Button_button--primary__27:hover:before,.Button_button-group-isolated--right__731:focus:before,.Button_button-group-isolated--right__731:hover.Button_button--primary__27:focus:before,.Button_button-group-isolated--right__731:hover.Button_button--primary__27:hover:before,.Button_button-group-isolated--right__731:hover:before{width:0}.Button_button-group-isolated--right__731.Button_button--primary__27:before{position:absolute;top:8px;bottom:8px;left:0;width:1px;background:#6f7282;content:""}',{insertAt:"top"});var v,p,h,y=color__WEBPACK_IMPORTED_MODULE_1___default()("white"),m=function(t){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"white";if(!t||!(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(t))return null;var n=(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o);return"\n    color: ".concat(n,";\n    &.hover,\n    &:hover,\n    &:focus,\n    &:not([disabled]):not([aria-disabled='true']):hover,\n    &:not([disabled]):not([aria-disabled='true']):focus {\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.f)(n)?n.darken(.3):n.lighten(.1).mix(y,.15),";\n    }\n    &.active,\n    &:active {\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.f)(n)?n.darken(.6):n.lighten(.15).mix(y,.3),";\n    }\n  ")},x={primary:function(t){if(!t||!(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(t))return null;var o=(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.f)(t)?color__WEBPACK_IMPORTED_MODULE_1___default()(t).darken(.2).hex():color__WEBPACK_IMPORTED_MODULE_1___default()(t).lighten(4).desaturate(.15).hex(),n=(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.f)(t)?color__WEBPACK_IMPORTED_MODULE_1___default()(t).darken(.4).hex():color__WEBPACK_IMPORTED_MODULE_1___default()(t).lighten(8).desaturate(.4).hex();return"\n    background-color: ".concat(t,";\n    color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t),";\n    &:hover,\n    &:focus,\n    &:not([disabled]):not([aria-disabled='true']):hover,\n    &:not([disabled]):not([aria-disabled='true']):focus,\n    &.hover {\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(o),";\n      background-color: ").concat(o,";\n    }\n    &:active,\n    &.active {\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(n),";\n      background-color: ").concat(n,";\n    }\n  ")},secondary:function(t){if(!t||!(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(t))return null;var o=(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.g)(t)?color__WEBPACK_IMPORTED_MODULE_1___default()(t).lighten(.1).mix(y,.92).hex():color__WEBPACK_IMPORTED_MODULE_1___default()(t).darken(.3).mix(y,.85).hex(),n=(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.g)(t)?color__WEBPACK_IMPORTED_MODULE_1___default()(t).mix(y,.25).hex():color__WEBPACK_IMPORTED_MODULE_1___default()(t).darken(.2).mix(y,.4).hex();return"\n    border-color: ".concat(t,";\n    color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,"white"),";\n\n    &.hover,\n    &:hover,\n    &:not([disabled]):not([aria-disabled='true']):hover,\n    &:not([disabled]):not([aria-disabled='true']):focus,\n    &:focus {\n      background-color: ").concat(o,";\n      border-color: ").concat(t,";\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n\n      svg {\n        fill: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,"white"),";\n      }\n    }\n\n    &.active,\n    &:active {\n      background-color: ").concat(n,";\n      border-color: ").concat(t,";\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(n),";\n\n      svg {\n        fill: white;\n      }\n    }\n\n    svg {\n      fill: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,"white"),";\n    }\n  ")},knockout:function(t){var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"white";return t&&(0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(t)?"\n    color: ".concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n    border-color: transparent;\n    &.hover,\n    &:hover,\n    &:not([disabled]):not([aria-disabled='true']):hover,\n    &:not([disabled]):not([aria-disabled='true']):focus,\n    &:focus {\n      border-color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n      color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n\n      svg {\n        fill: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n      }\n    }\n    &.active,\n    &:active {\n      background-color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n      border-color: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o).darken(.5),";\n      color: #fff;\n\n      svg {\n        fill: white;\n      }\n    }\n\n    svg {\n      fill: ").concat((0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.d)(t,o),";\n    }\n  "):null},link:m,"accessible-link":m},w=function(t){var o,n,a,e=t.color,d=t.hasDanger,r=t.isUpgrade,u=t.isAlternate,_=t.theme;return (0,_utils_9c93357c_js__WEBPACK_IMPORTED_MODULE_3__.j)(e)?e:d||r||u?!d||r||u?r||u?null===(a=_.color)||void 0===a?void 0:a.secondary:null:null===(n=_.color)||void 0===n?void 0:n.danger:null===(o=_.color)||void 0===o?void 0:o.primary},A=(0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(v||(v=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  // Border radius\n  ","\n\n  // Text transform\n  ","\n\n  // Font family\n  ","\n\n  // Font weight\n  ","\n\n  // Button variations\n  ","\n"])),(function(t){var o,n,a,e;return((null===(o=t.theme)||void 0===o||null===(n=o.button)||void 0===n?void 0:n.borderRadius)||0===(null===(a=t.theme)||void 0===a||null===(e=a.button)||void 0===e?void 0:e.borderRadius))&&"\n    border-radius: ".concat(t.theme.button.borderRadius,"px;\n  ")}),(function(t){var o,n;return!1===(null===(o=t.theme)||void 0===o||null===(n=o.button)||void 0===n?void 0:n.allCaps)&&"\n    text-transform: none;\n  "}),(function(t){var o,n;return(null===(o=t.theme)||void 0===o||null===(n=o.button)||void 0===n?void 0:n.fontFamily)&&"\n    font-family: '".concat(t.theme.button.fontFamily,"';\n  ")}),(function(t){var o,n;return(null===(o=t.theme)||void 0===o||null===(n=o.button)||void 0===n?void 0:n.fontWeight)&&"\n    font-weight: ".concat(t.theme.button.fontWeight,";\n  ")}),(function(t){return x[t.appearance]&&w(t)&&"\n  ".concat(x[t.appearance](w(t)))})),z=["className"],D=["appearance","color","children","className","disabled","hasDanger","href","isActive","isAlternate","isDark","isDisabled","isUpgrade","isHover","leftAccessory","rightAccessory","onClick","size","type"],N=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind(f),j=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button */ .ZP.button(p||(p=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),A),C=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(h||(h=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),A),U=function(n){var e=n.position;return function(n){return function(d){var r=d.className,u=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__._)(d,z),_=N(r,{"button--icon-left":"left"===e,"button--icon-right":"right"===e,"button--icon-both":"both"===e});return react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__.a)({className:_},u))}}};U.displayName="withIcon";var F=function(n){var d,r=n.appearance,u=n.color,_=n.children,i=n.className,s=n.disabled,b=n.hasDanger,l=n.href,c=n.isActive,B=n.isAlternate,g=n.isDark,f=n.isDisabled,v=n.isUpgrade,p=n.isHover,h=n.leftAccessory,y=n.rightAccessory,m=n.onClick,x=n.size,w=n.type,A=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__._)(n,D),z=l?C:j,U=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_7__.T),F=N(i,"button",{"button--block":"block"===x,"button--x-small":"x-small"===x,"button--small":"small"===x,"button--small-tight":"small-tight"===x,"button--large":"large"===x,active:c,hover:p,hovered:p}),H=N({"button--icon-left":h,"button--icon-right":y,"button--icon-both":h&&y});d=N(g?{"button--primary-dark":"primary"===r,"button--danger-dark":"primary"===r&&b,"button--upgrade-dark":"primary"===r&&v,"button--secondary-dark":"secondary"===r,"button--secondary-danger-dark":"secondary"===r&&b,"button--secondary-upgrade-dark":"secondary"===r&&v,"button--knockout-dark":"knockout"===r,"button--knockout-upgrade-dark":"knockout"===r&&v,"button--knockout-danger-dark":"knockout"===r&&b,"button--link-dark":"link"===r,"button--utility-dark":"utility"===r}:{"button--primary":"primary"===r,"button--danger":"primary"===r&&b,"button--upgrade":"primary"===r&&v,"button--secondary":"secondary"===r,"button--secondary-danger":"secondary"===r&&b,"button--secondary-upgrade":"secondary"===r&&v,"button--knockout":"knockout"===r,"button--knockout-upgrade":"knockout"===r&&v,"button--knockout-danger":"knockout"===r&&b,"button--link":"link"===r,"button--utility":"utility"===r,"button--accessible-link":"accessible-link"===r});var R=f||s;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(z,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_6__.a)({appearance:r,"aria-disabled":R,className:"".concat(F," ").concat(d," ").concat(H),color:u,hasDanger:b,href:l,isAlternate:B,isUpgrade:v,theme:U,type:w,onClick:R?null:m},A),h,_,y)};F.propTypes={appearance:prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf(["primary","secondary","knockout","link","utility","accessible-link"]),children:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,color:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),hasDanger:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),href:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),isActive:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),isAlternate:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),isDark:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),isDisabled:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),isHover:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),isUpgrade:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool),leftAccessory:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().element),rightAccessory:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().element),size:prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf(["x-small","small","small-tight","large","block"]),type:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),onClick:(prop_types__WEBPACK_IMPORTED_MODULE_8___default().func)},F.defaultProps={isActive:!1,appearance:"primary",className:null,color:null,hasDanger:!1,isAlternate:!1,isDark:!1,isDisabled:!1,isUpgrade:!1,isHover:!1,leftAccessory:null,rightAccessory:null,href:null,size:null,type:"button",onClick:null},F.displayName="Button",F.filename=__filename,F.spreadAttributes=!0;
//# sourceMappingURL=Button-b37f2f11.js.map


/***/ }),

/***/ 52945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ c; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
/* harmony import */ var _Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78618);
var i=["children","className"],t=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),l=function(s){var o=s.children,p=s.className,m=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(s,i),l=t("caption",p);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("small",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:l},m),o)};l.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},l.defaultProps={className:null},l.displayName="Caption",l.filename=__filename;var c=l;
//# sourceMappingURL=Caption-d6d5a7c0.js.map


/***/ }),

/***/ 80579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ h; },
  "a": function() { return /* binding */ I; },
  "b": function() { return /* binding */ CardList_7847c099_x; }
});

// UNUSED EXPORTS: B, u

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/prop-shapes-ac9385ac.js
var prop_shapes_ac9385ac = __webpack_require__(10518);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/slicedToArray-82541484.js
var slicedToArray_82541484 = __webpack_require__(70512);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toaster-a57afb61.js
var toaster_a57afb61 = __webpack_require__(81792);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Modal-06a02338.js
var Modal_06a02338 = __webpack_require__(59675);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/SocialShare-95bd9eeb.js
var p=[{name:"Facebook",logo:"social-facebook",options:"height=380,width=600,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0",url:"https://facebook.com/sharer.php?u="},{name:"LinkedIn",logo:"social-linkedIn",options:"height=1000,width=700,resizable=0,toolbar=0,menubar=0,status=0,location=0,scrollbars=0",url:"https://www.linkedin.com/sharing/share-offsite/?url="},{name:"Twitter",logo:"social-twitter",options:"height=500,width=550,resizable=1,toolbar=0,menubar=0,status=0,location=0",url:"http://twitter.com/intent/tweet?url="}];function d(t,e,r,a,n,o,i){try{var c=t[o](i),s=c.value}catch(t){return void r(t)}c.done?e(s):Promise.resolve(s).then(a,n)}var m=(0,prop_shapes_ac9385ac.a)((function(t){var e=function(t){var e,r=Object.prototype,a=r.hasOwnProperty,n="function"==typeof Symbol?Symbol:{},o=n.iterator||"@@iterator",i=n.asyncIterator||"@@asyncIterator",c=n.toStringTag||"@@toStringTag";function s(t,e,r){return Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}),t[e]}try{s({},"")}catch(t){s=function(t,e,r){return t[e]=r}}function l(t,e,r,a){var n=e&&e.prototype instanceof _?e:_,o=Object.create(n.prototype),i=new T(a||[]);return o._invoke=function(t,e,r){var a=h;return function(n,o){if(a===p)throw new Error("Generator is already running");if(a===d){if("throw"===n)throw o;return O()}for(r.method=n,r.arg=o;;){var i=r.delegate;if(i){var c=E(i,r);if(c){if(c===m)continue;return c}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(a===h)throw a=d,r.arg;r.dispatchException(r.arg)}else"return"===r.method&&r.abrupt("return",r.arg);a=p;var s=u(t,e,r);if("normal"===s.type){if(a=r.done?d:f,s.arg===m)continue;return{value:s.arg,done:r.done}}"throw"===s.type&&(a=d,r.method="throw",r.arg=s.arg)}}}(t,r,i),o}function u(t,e,r){try{return{type:"normal",arg:t.call(e,r)}}catch(t){return{type:"throw",arg:t}}}t.wrap=l;var h="suspendedStart",f="suspendedYield",p="executing",d="completed",m={};function _(){}function y(){}function v(){}var g={};s(g,o,(function(){return this}));var b=Object.getPrototypeOf,S=b&&b(b(j([])));S&&S!==r&&a.call(S,o)&&(g=S);var w=v.prototype=_.prototype=Object.create(g);function x(t){["next","throw","return"].forEach((function(e){s(t,e,(function(t){return this._invoke(e,t)}))}))}function k(t,e){function r(n,o,i,c){var s=u(t[n],t,o);if("throw"!==s.type){var l=s.arg,h=l.value;return h&&"object"==typeof h&&a.call(h,"__await")?e.resolve(h.__await).then((function(t){r("next",t,i,c)}),(function(t){r("throw",t,i,c)})):e.resolve(h).then((function(t){l.value=t,i(l)}),(function(t){return r("throw",t,i,c)}))}c(s.arg)}var n;this._invoke=function(t,a){function o(){return new e((function(e,n){r(t,a,e,n)}))}return n=n?n.then(o,o):o()}}function E(t,r){var a=t.iterator[r.method];if(a===e){if(r.delegate=null,"throw"===r.method){if(t.iterator.return&&(r.method="return",r.arg=e,E(t,r),"throw"===r.method))return m;r.method="throw",r.arg=new TypeError("The iterator does not provide a 'throw' method")}return m}var n=u(a,t.iterator,r.arg);if("throw"===n.type)return r.method="throw",r.arg=n.arg,r.delegate=null,m;var o=n.arg;return o?o.done?(r[t.resultName]=o.value,r.next=t.nextLoc,"return"!==r.method&&(r.method="next",r.arg=e),r.delegate=null,m):o:(r.method="throw",r.arg=new TypeError("iterator result is not an object"),r.delegate=null,m)}function L(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function N(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function T(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(L,this),this.reset(!0)}function j(t){if(t){var r=t[o];if(r)return r.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var n=-1,i=function r(){for(;++n<t.length;)if(a.call(t,n))return r.value=t[n],r.done=!1,r;return r.value=e,r.done=!0,r};return i.next=i}}return{next:O}}function O(){return{value:e,done:!0}}return y.prototype=v,s(w,"constructor",v),s(v,"constructor",y),y.displayName=s(v,c,"GeneratorFunction"),t.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===y||"GeneratorFunction"===(e.displayName||e.name))},t.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,v):(t.__proto__=v,s(t,c,"GeneratorFunction")),t.prototype=Object.create(w),t},t.awrap=function(t){return{__await:t}},x(k.prototype),s(k.prototype,i,(function(){return this})),t.AsyncIterator=k,t.async=function(e,r,a,n,o){void 0===o&&(o=Promise);var i=new k(l(e,r,a,n),o);return t.isGeneratorFunction(r)?i:i.next().then((function(t){return t.done?t.value:i.next()}))},x(w),s(w,c,"Generator"),s(w,o,(function(){return this})),s(w,"toString",(function(){return"[object Generator]"})),t.keys=function(t){var e=[];for(var r in t)e.push(r);return e.reverse(),function r(){for(;e.length;){var a=e.pop();if(a in t)return r.value=a,r.done=!1,r}return r.done=!0,r}},t.values=j,T.prototype={constructor:T,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=e,this.done=!1,this.delegate=null,this.method="next",this.arg=e,this.tryEntries.forEach(N),!t)for(var r in this)"t"===r.charAt(0)&&a.call(this,r)&&!isNaN(+r.slice(1))&&(this[r]=e)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var r=this;function n(a,n){return c.type="throw",c.arg=t,r.next=a,n&&(r.method="next",r.arg=e),!!n}for(var o=this.tryEntries.length-1;o>=0;--o){var i=this.tryEntries[o],c=i.completion;if("root"===i.tryLoc)return n("end");if(i.tryLoc<=this.prev){var s=a.call(i,"catchLoc"),l=a.call(i,"finallyLoc");if(s&&l){if(this.prev<i.catchLoc)return n(i.catchLoc,!0);if(this.prev<i.finallyLoc)return n(i.finallyLoc)}else if(s){if(this.prev<i.catchLoc)return n(i.catchLoc,!0)}else{if(!l)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return n(i.finallyLoc)}}}},abrupt:function(t,e){for(var r=this.tryEntries.length-1;r>=0;--r){var n=this.tryEntries[r];if(n.tryLoc<=this.prev&&a.call(n,"finallyLoc")&&this.prev<n.finallyLoc){var o=n;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var i=o?o.completion:{};return i.type=t,i.arg=e,o?(this.method="next",this.next=o.finallyLoc,m):this.complete(i)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),m},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.finallyLoc===t)return this.complete(r.completion,r.afterLoc),N(r),m}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var r=this.tryEntries[e];if(r.tryLoc===t){var a=r.completion;if("throw"===a.type){var n=a.arg;N(r)}return n}}throw new Error("illegal catch attempt")},delegateYield:function(t,r,a){return this.delegate={iterator:j(t),resultName:r,nextLoc:a},"next"===this.method&&(this.arg=e),m}},t}(t.exports);try{regeneratorRuntime=e}catch(t){"object"==typeof globalThis?globalThis.regeneratorRuntime=e:Function("r","regeneratorRuntime = r")(e)}})),_=function(){var t,e=(t=m.mark((function t(e){return m.wrap((function(t){for(;;)switch(t.prev=t.next){case 0:return t.prev=0,t.next=3,navigator.clipboard.writeText(e);case 3:toaster_a57afb61.t.notice("Successfully copied link to clipboard"),t.next=9;break;case 6:t.prev=6,t.t0=t.catch(0),console.error("Failed to copy: ",t.t0);case 9:case"end":return t.stop()}}),t,null,[[0,6]])})),function(){var e=this,r=arguments;return new Promise((function(a,n){var o=t.apply(e,r);function i(t){d(o,a,n,i,c,"next",t)}function c(t){d(o,a,n,i,c,"throw",t)}i(void 0)}))});return function(t){return e.apply(this,arguments)}}(),y=function(t){var e=t;e.innerHTML="Copied",setTimeout((function(){e.innerHTML="Copy link"}),2e3)},v=function(t,e){var r=t.currentTarget.querySelector(".social-share__text");navigator.clipboard?(_(e),y(r)):(!function(t){var e=document.createElement("input");document.body.appendChild(e),e.value=t,e.select(),document.execCommand("copy"),document.body.removeChild(e),toaster_a57afb61.t.notice("Successfully copied link to clipboard")}(e),y(r))},SocialShare_95bd9eeb_g=function(t){return""!==t?"Check out my ".concat(t,"!"):""},b={"container--fixed":"SocialShare_container--fixed__2",container:"SocialShare_container__2","social-share":"SocialShare_social-share__9","social-share--has-divider":"SocialShare_social-share--has-divider__17","social-share--icon":"SocialShare_social-share--icon__29","social-share__modal":"SocialShare_social-share__modal__38","social-share__links":"SocialShare_social-share__links__41","social-share__button":"SocialShare_social-share__button__48","social-share__divider":"SocialShare_social-share__divider__53"};(0,prop_shapes_ac9385ac.s)('.SocialShare_container--fixed__2{position:absolute;top:8px;right:8px;z-index:1}@media (max-width:952px){.SocialShare_container__2 .SocialShare_social-share__9{font-size:.875rem;font-weight:600}}.SocialShare_container__2 .SocialShare_social-share__9:not([disabled]):not([aria-disabled=true]),.SocialShare_container__2 .SocialShare_social-share__9:not([disabled]):not([aria-disabled=true]):focus,.SocialShare_container__2 .SocialShare_social-share__9:not([disabled]):not([aria-disabled=true]):hover{background:#fff}@media (max-width:952px){.SocialShare_container__2 .SocialShare_social-share--has-divider__17{margin-right:17px}.SocialShare_container__2 .SocialShare_social-share--has-divider__17:before{display:block;position:absolute;top:0;left:calc(100% + 9px);width:1px;height:100%;background:#caccd6;content:""}}.SocialShare_container__2 .SocialShare_social-share--icon__29{display:flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0}@media (min-width:664px){.SocialShare_social-share__modal__38{max-width:420px}}.SocialShare_social-share__links__41{display:flex;flex-direction:column;align-items:flex-start;padding-right:16px;padding-left:16px}.SocialShare_social-share__button__48{margin-bottom:24px}.SocialShare_social-share__button__48:last-of-type{margin-bottom:0}.SocialShare_social-share__divider__53{display:block;width:100%;height:1px;margin-bottom:24px;background:#caccd6}',{insertAt:"top"});var S=prop_shapes_ac9385ac.b.bind(b),w=function(t){var r=t.url,a=t.message;return p.map((function(t){var n=function(t,e,r){var a={name:t.name,vendorUrl:t.url},n=a.vendorUrl+e;return"Twitter"===a.name&&r&&(n+="&text=".concat(r,"&via=thinkific&related=thinkific")),n}(t,r,a),o=function(t,e){return"".concat(t,"?utm_source=").concat(e,"&utm_medium=social&utm_campaign=social-share")}(n,t.name);return react.createElement(react.Fragment,{key:t.name},react.createElement(Button_b37f2f11.B,{appearance:"accessible-link",className:S("social-share__button","button--icon-left"),onClick:function(){return function(t,e,r){return window.open(t,e,r)}(o,"Share to ".concat(t.name),t.options)}},react.createElement(Icon_343b84c4.I,{"aria-hidden":"true",className:"mr-3",name:t.logo}),t.name),react.createElement("span",{className:S("social-share__divider")}))}))};w.propTypes={message:(prop_types_default()).string.isRequired,url:(prop_types_default()).string.isRequired},w.displayName="SocialLinks";var x=w,k=prop_shapes_ac9385ac.b.bind(b),E=function(a){var n,o=a.buttonType,i=a.className,c=a.hasDivider,s=a.isFixed,p=a.productType,d=a.productUrl,m=a.productName,_=a.shareMessage,y="button"===o,g=k("social-share",{"social-share--button":y,"button--icon-left":y,"social-share--icon":"icon"===o,"social-share--has-divider":c}),b=(0,react.useState)(!1),S=(0,slicedToArray_82541484._)(b,2),w=S[0],E=S[1];if("icon"===o)n="utility";else n="knockout";return react.createElement("div",{className:k("container",i,{"container--fixed":s})},react.createElement(Tooltip_00b73669.T,{title:"Share your ".concat(p)},react.createElement(Button_b37f2f11.B,{appearance:n,"aria-label":"Share your ".concat(p," ").concat(m),className:g,size:"small-tight",onClick:function(){return E(!0)}},react.createElement(Icon_343b84c4.I,{"aria-hidden":"true",name:"share"}),y&&"Share")),w&&react.createElement(Modal_06a02338.M,{closeModal:function(){return E(!1)},contentLabel:"Social share modal",extraClassNames:k("social-share__modal"),isOpen:w,title:"Share your ".concat(p)},react.createElement("div",{className:k("social-share__links")},react.createElement(x,{message:_,url:d}),react.createElement(Button_b37f2f11.B,{appearance:"accessible-link",className:k("social-share__button","button--icon-left"),onClick:function(t){return v(t,d)}},react.createElement(Icon_343b84c4.I,{"aria-hidden":"true",className:"mr-3",name:"link"}),react.createElement("span",{"aria-live":"polite",className:"social-share__text"},"Copy link")))))};E.propTypes={buttonType:prop_types_default().oneOf(["button","icon"]),className:prop_shapes_ac9385ac.c,hasDivider:(prop_types_default()).bool,isFixed:(prop_types_default()).bool,productName:(prop_types_default()).string,productType:(prop_types_default()).string.isRequired,productUrl:(prop_types_default()).string.isRequired,shareMessage:(prop_types_default()).string},E.defaultProps={buttonType:"button",className:null,productName:"",hasDivider:!1,isFixed:!1,shareMessage:null},E.displayName="SocialShare";var SocialShare_95bd9eeb_L=E;
//# sourceMappingURL=SocialShare-95bd9eeb.js.map

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Badge-95ef19f1.js
var Badge_95ef19f1 = __webpack_require__(36160);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/CardList-7847c099.js
var CardList_7847c099_filename = "/index.js";
var CardList_7847c099_m={"card-container":"Card_card-container__3","card__footer-status-icon":"Card_card__footer-status-icon__8","card-container--list":"Card_card-container--list__20",card:"Card_card__3","card-list":"Card_card-list__27",disabled:"Card_disabled__29",section__line:"Card_section__line__79",card__image:"Card_card__image__83",card__content:"Card_card__content__90","card__content-title":"Card_card__content-title__94","card__content-caption":"Card_card__content-caption__97",card__footer:"Card_card__footer__8","card__footer-status":"Card_card__footer-status__8","card__footer-status-text":"Card_card__footer-status-text__107","card__footer-status-text--active":"Card_card__footer-status-text--active__110","card__footer-status-text--warning":"Card_card__footer-status-text--warning__113","card__footer-status-text--default":"Card_card__footer-status-text--default__116","card__footer-action":"Card_card__footer-action__119",button:"Card_button__121",card__badge:"Card_card__badge__124","card--shareable":"Card_card--shareable__130",card__button:"Card_card__button__137","card__image--overlay":"Card_card__image--overlay__142","card__image--badge":"Card_card__image--badge__150","card__content-caption--inverted":"Card_card__content-caption--inverted__184",card__caption:"Card_card__caption__209","card-list__image":"Card_card-list__image__235","card-list__content":"Card_card-list__content__242","card-list__content-title":"Card_card-list__content-title__246","card-list__content-caption":"Card_card-list__content-caption__249","card-list__footer":"Card_card-list__footer__252","card-list__footer-status":"Card_card-list__footer-status__256","card-list__footer-status-text":"Card_card-list__footer-status-text__259","card-list__footer-status-text--active":"Card_card-list__footer-status-text--active__262","card-list__footer-status-text--warning":"Card_card-list__footer-status-text--warning__265","card-list__footer-status-text--default":"Card_card-list__footer-status-text--default__268","card-list__footer-action":"Card_card-list__footer-action__271","card-list__badge":"Card_card-list__badge__276","card-list__caption":"Card_card-list__caption__303","card-list__button":"Card_card-list__button__325","card-list__body":"Card_card-list__body__332","card-list__content--extra":"Card_card-list__content--extra__344","card-list__content-title--text":"Card_card-list__content-title--text__351","card-list__content-title--badge":"Card_card-list__content-title--badge__353","card-list__footer-divider":"Card_card-list__footer-divider__369","card-list__footer-status-top":"Card_card-list__footer-status-top__382","card-list__footer-status-bottom":"Card_card-list__footer-status-bottom__389","card-list__footer-status-label":"Card_card-list__footer-status-label__394"};(0,prop_shapes_ac9385ac.s)(".Card_card-container__3{display:flex;flex-flow:row wrap;min-width:280px;margin-left:-16px}.Card_card-container__3 .Card_card__footer-status-icon__8{width:20px;height:20px;margin-right:8px;color:#6f7282;font-size:20px;fill:#6f7282}@media (min-width:952px){.Card_card-container__3 .Card_card__footer-status-icon__8{font-size:24px}}.Card_card-container__3 a{text-decoration:none}.Card_card-container--list__20{display:block;width:100%;margin-left:0}.Card_card-container__3 .Card_card__3{position:relative;margin:0 0 16px 16px}.Card_card-container__3 .Card_card-list__27{margin-bottom:16px}.Card_card-container__3 .Card_disabled__29{opacity:.3;pointer-events:none}@media (max-width:1265px){.Card_card-container__3{justify-content:center}}@media (max-width:952px){.Card_card-container__3{margin-left:-24px}.Card_card-container--list__20{display:inline-flex;margin:0 auto}.Card_card-container__3 .Card_card__3{margin:0 0 24px 24px}.Card_card-container__3 .Card_card-list__27{margin-bottom:12px}}@media (max-width:664px){.Card_card-container__3{margin-left:-16px}.Card_card-container--list__20{width:100%;max-width:640px;margin-left:0}.Card_card-container__3 .Card_card__3{margin:0 0 16px 16px}.Card_card-container__3 .Card_card-list__27{width:100%}}@media (max-width:570px){.Card_card-container__3{width:100%;min-width:304px;margin-left:0}.Card_card-container--list__20{display:flex}.Card_card-container__3 .Card_card-list__27,.Card_card-container__3 .Card_card__3{width:100%;margin:0 0 16px}}.Card_card__3{border-radius:4px;background-color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.1),0 1px 3px 0 rgba(0,0,0,.06);transition-duration:.2s;transition-timing-function:ease-out;position:relative;padding:0;width:256px;min-width:256px}.Card_card__3 .Card_section__line__79{margin:24px -16px}.Card_card__3:focus,.Card_card__3:hover{box-shadow:0 4px 12px 0 rgba(0,0,0,.25)}.Card_card__image__83{background-position:50%;background-size:cover}.Card_card__image__83 img{width:100%;height:100%;-o-object-fit:cover;object-fit:cover}.Card_card__content__90{padding:16px}.Card_card__content__90 a{text-decoration:none}.Card_card__content-title__94{color:#36394d;font-weight:600}.Card_card__content-caption__97{margin-top:8px;color:#6f7282}.Card_card__footer__8{align-items:center;padding:16px}.Card_card__footer-status__8{display:flex;align-items:center}.Card_card__footer-status-text__107{margin-right:8px;text-transform:uppercase}.Card_card__footer-status-text--active__110{color:#379a49;font-weight:600}.Card_card__footer-status-text--warning__113{color:#ff7e40;font-weight:600}.Card_card__footer-status-text--default__116{color:#6f7282;font-style:italic}.Card_card__footer-action__119{margin-right:-8px}.Card_card__footer-action__119 .Card_button__121{width:32px;height:32px}.Card_card__badge__124{max-width:200px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media (min-width:664px){.Card_card--shareable__130 [class*=container--fixed]{transition-duration:.2s;transition-property:opacity;transition-timing-function:ease-in-out;opacity:0}.Card_card--shareable__130:focus [class*=container--fixed],.Card_card--shareable__130:hover [class*=container--fixed]{opacity:1}}.Card_card__button__137:focus,.Card_card__button__137:hover{cursor:pointer}.Card_card__image__83{position:relative;height:160px}.Card_card__image--overlay__142{position:absolute;top:0;width:100%;height:100%;border-radius:4px 4px 0 0;background-color:#12131a;opacity:.3}.Card_card__image--badge__150{position:absolute;right:8px;bottom:8px}.Card_card__image__83 img{border-radius:4px 4px 0 0}.Card_card__content-title__94{margin:0 auto;font-size:16px!important;line-height:1.375!important;-webkit-line-clamp:3;height:66px}.Card_card__content-caption__97,.Card_card__content-title__94{display:flex;display:-webkit-box;text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical}.Card_card__content-caption__97{height:16.1px;font-size:14px!important;line-height:1.15!important;-webkit-line-clamp:1;margin:8px auto 0}.Card_card__content-caption--inverted__184{margin-top:0;margin-bottom:8px}.Card_card__footer__8{display:flex;justify-content:space-between;height:48px;border-radius:0 0 4px 4px;background-color:#f2f3f5}@media (max-width:570px){.Card_card__3{display:block;width:304px;height:auto}.Card_card__image__83{width:100%;height:160px}.Card_card__image__83 img{border-radius:4px 4px 0 0}.Card_card__content__90{width:100%;height:auto;padding:12px 12px 16px}.Card_card__content-title__94{height:66px}.Card_card__caption__209{padding:0 12px 16px}.Card_card__footer__8{height:48px;padding:16px 12px 12px;border-radius:0 0 4px 4px;background-color:#f2f3f5}}.Card_card-list__27{border-radius:4px;background-color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.1),0 1px 3px 0 rgba(0,0,0,.06);transition-duration:.2s;transition-timing-function:ease-out;padding:0;display:flex;position:relative;flex-wrap:wrap;max-width:1080px;min-height:100px}.Card_card-list__27 .Card_section__line__79{margin:24px -16px}.Card_card-list__27:focus,.Card_card-list__27:hover{box-shadow:0 4px 12px 0 rgba(0,0,0,.25)}.Card_card-list__image__235{background-position:50%;background-size:cover}.Card_card-list__content__242{padding:16px}.Card_card-list__content__242 a{text-decoration:none}.Card_card-list__content-title__246{color:#36394d;font-weight:600}.Card_card-list__content-caption__249{margin-top:8px;color:#6f7282}.Card_card-list__footer__252{padding:16px}.Card_card-list__footer-status__256,.Card_card-list__footer__252{display:flex;align-items:center}.Card_card-list__footer-status-text__259{margin-right:8px;text-transform:uppercase}.Card_card-list__footer-status-text--active__262{color:#379a49;font-weight:600}.Card_card-list__footer-status-text--warning__265{color:#ff7e40;font-weight:600}.Card_card-list__footer-status-text--default__268{color:#6f7282;font-style:italic}.Card_card-list__footer-action__271{margin-right:-8px}.Card_card-list__footer-action__271 .Card_button__121{width:32px;height:32px}.Card_card-list__badge__276{max-width:200px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}@media (min-width:570px){.Card_card-list__27{flex-wrap:nowrap}}@media (max-width:952px){.Card_card-list__27{width:640px}}@media (max-width:570px){.Card_card-list__27{display:block;width:304px;height:auto}.Card_card-list__image__235{width:100%;height:160px}.Card_card-list__image__235 img{border-radius:4px 4px 0 0}.Card_card-list__content__242{width:100%;height:auto;padding:12px 12px 16px}.Card_card-list__content-title__246{height:66px}.Card_card-list__caption__303{padding:0 12px 16px}.Card_card-list__footer__252{height:48px;padding:16px 12px 12px;border-radius:0 0 4px 4px;background-color:#f2f3f5}}.Card_card-list__image__235{flex-shrink:0;width:100%}@media (min-width:570px){.Card_card-list__image__235{width:140px;height:100%}}@media (min-width:952px){.Card_card-list__image__235{width:120px}}.Card_card-list__image__235 img{width:100%;height:100%;border-radius:4px 0 0 4px;-o-object-fit:cover;object-fit:cover}.Card_card-list__button__325{display:flex;flex-direction:column;flex-grow:1}@media (min-width:570px){.Card_card-list__button__325{flex-direction:row}}.Card_card-list__body__332{display:flex;flex-grow:1;flex-wrap:wrap;justify-content:space-between}@media (min-width:570px){.Card_card-list__body__332{flex-wrap:nowrap}}@media (min-width:952px){.Card_card-list__content__242{padding-right:0}}@media (max-width:952px){.Card_card-list__content--extra__344{padding-bottom:56px}}@media (max-width:570px){.Card_card-list__content--extra__344{padding-bottom:16px}}.Card_card-list__content-title__246{height:auto}.Card_card-list__content-title--text__351{margin-right:8px}.Card_card-list__content-title--badge__353{display:inline-flex}.Card_card-list__footer__252{width:100%}@media (min-width:570px){.Card_card-list__footer__252{position:absolute;right:0;bottom:0;width:calc(100% - 140px)}}@media (min-width:952px){.Card_card-list__footer__252{position:static;flex:0 1 0;padding-right:24px;padding-left:0}}.Card_card-list__footer-divider__369{height:56px;margin-right:24px;margin-left:24px;border-left:1px solid #caccd6}@media (max-width:952px){.Card_card-list__footer-divider__369{display:none}}.Card_card-list__footer-status__256{display:block;flex:1 0 155px;min-width:155px;margin-right:24px}.Card_card-list__footer-status-top__382{display:flex;align-items:center;margin-bottom:4px}@media (max-width:952px){.Card_card-list__footer-status-top__382{margin-bottom:0}}.Card_card-list__footer-status-bottom__389{color:#36394d}@media (max-width:952px){.Card_card-list__footer-status-bottom__389{display:none}}.Card_card-list__footer-status-label__394{font-weight:600}.Card_card-list__footer-action__271 .Card_button__121{width:40px;height:40px}@media (max-width:952px){.Card_card-list__footer-action__271 .Card_button__121{width:32px;height:32px}}.Card_card-list__badge__276{max-width:250px}",{insertAt:"top"});var g=prop_shapes_ac9385ac.b.bind(CardList_7847c099_m);function CardList_7847c099_x(a){var e=a.children,r=a.variation,_=g("card-container",{"card-container--list":"list"===r});return react.createElement("div",{className:_},e)}CardList_7847c099_x.propTypes={children:(prop_types_default()).node.isRequired,variation:prop_types_default().oneOf(["default","list"])},CardList_7847c099_x.defaultProps={variation:"default"},CardList_7847c099_x.filename=CardList_7847c099_filename,CardList_7847c099_x.displayName="CardContainer";var f=prop_shapes_ac9385ac.b.bind(CardList_7847c099_m),u=function(a){var e=a.image,r=a.imageAlt,_=a.imageSrcSet,i=a.name,d=a.caption,o=a.badgeIcon,n=a.badgeText,c=a.badgeType,s=a.invertedCaption,p=react.createElement("div",{"aria-level":"2",className:f("card__content-title"),"data-qa":"card__content-title",role:"heading"},i),m=react.createElement("div",{className:f("card__content-caption",{"card__content-caption--inverted":s}),"data-qa":"card__content-caption"},d);return react.createElement(react.Fragment,null,react.createElement("div",{className:f("card__image")},n&&react.createElement(react.Fragment,null,react.createElement("div",{className:f("card__image--overlay")}),react.createElement(Badge_95ef19f1.B,{className:f("card__badge","card__image--badge"),icon:o,title:n,type:c},n)),react.createElement("img",{alt:r,loading:"lazy",src:e,srcSet:_})),react.createElement("div",{className:f("card__content")},s?react.createElement(react.Fragment,null,m,p):react.createElement(react.Fragment,null,p,m)))},C=function(a){var e=a.ariaLabel,r=a.badgeIcon,_=a.badgeText,i=a.badgeType,d=a.caption,l=a.className,p=a.footerActions,m=a.href,g=a.image,x=a.imageAlt,C=a.imageSrcSet,h=a.invertedCaption,b=a.isDisabled,w=a.landingPage,v=a.name,y=a.productType,E=a.shareLandingPage,N=a.statusList,T=w&&E,S=p||Boolean(N.length);return react.createElement("section",{className:f("card",l,{disabled:b,"card--shareable":T})},T&&react.createElement(SocialShare_95bd9eeb_L,{buttonType:"icon",productName:v,productType:y,productUrl:w,shareMessage:SocialShare_95bd9eeb_g(y),isFixed:!0}),m?react.createElement("a",{"aria-label":e||v,className:f("card__button"),href:m},react.createElement(u,{badgeIcon:r,badgeText:_,badgeType:i,caption:d,image:g,imageAlt:x,imageSrcSet:C,invertedCaption:h,name:v})):react.createElement(u,{badgeIcon:r,badgeText:_,badgeType:i,caption:d,image:g,imageAlt:x,imageSrcSet:C,invertedCaption:h,name:v}),S&&react.createElement("div",{className:f("card__footer")},react.createElement("div",{className:f("card__footer-status")},N.map((function(a,e){if(a.icon&&a.tooltip)return react.createElement(Tooltip_00b73669.T,{key:e,title:a.tooltip},react.createElement(Icon_343b84c4.I,{className:f("card__footer-status-icon"),name:a.icon,title:a.tooltip}));if(a.text&&a.type){var r=f("card__footer-status-text",{"card__footer-status-text--active":"active"===a.type,"card__footer-status-text--warning":"warning"===a.type,"card__footer-status-text--default":"inactive"===a.type});return react.createElement("small",{className:r,key:e},a.text)}return a}))),p&&!b&&react.createElement("div",{className:f("card__footer-action")},p)))};C.propTypes={ariaLabel:(prop_types_default()).string,badgeIcon:(prop_types_default()).string,badgeText:(prop_types_default()).string,badgeType:(prop_types_default()).string,caption:(prop_types_default()).node.isRequired,className:prop_shapes_ac9385ac.c,footerActions:(prop_types_default()).node,href:(prop_types_default()).string,image:(prop_types_default()).string.isRequired,imageAlt:(prop_types_default()).string,imageSrcSet:(prop_types_default()).string,invertedCaption:(prop_types_default()).bool,isDisabled:(prop_types_default()).bool,landingPage:(prop_types_default()).string,name:(prop_types_default()).node.isRequired,productType:(prop_types_default()).string,shareLandingPage:(prop_types_default()).bool,statusList:(prop_types_default()).array},C.defaultProps={ariaLabel:"",badgeIcon:null,badgeText:"",badgeType:"secondary",footerActions:null,imageAlt:"",className:null,imageSrcSet:null,invertedCaption:!1,isDisabled:!1,landingPage:null,productType:"",shareLandingPage:!1,statusList:[],href:null},C.displayName="Card",C.filename=CardList_7847c099_filename;var h=C,CardList_7847c099_b="(min-width: ".concat(570,"px)"),CardList_7847c099_w="(max-width: ".concat(569,"px)"),CardList_7847c099_v="(min-width: ".concat(992,"px)"),CardList_7847c099_y="(min-width: ".concat(952,"px)"),CardList_7847c099_E="(max-width: ".concat(951,"px)"),N="".concat(CardList_7847c099_b," and ").concat(CardList_7847c099_E),T=function(t){var r="undefined"!=typeof window&&window.matchMedia(t).matches,_=(0,react.useState)(r),i=(0,slicedToArray_82541484._)(_,2),d=i[0],o=i[1];return (0,react.useEffect)((function(){var a=window.matchMedia(t),e=function(){var t;(t=a).matches!==d&&o(t.matches)};return a.addListener(e),function(){a.removeListener(e)}}),[d,t]),d},CardList_7847c099_S=prop_shapes_ac9385ac.b.bind(CardList_7847c099_m),CardList_7847c099_k=function(a){var e=a.badgeIcon,r=a.badgeText,_=a.badgeType,i=a.name,d=a.caption,o=a.hasFooter,n=a.image,c=a.imageSrcSet;return react.createElement(react.Fragment,null,react.createElement("div",{className:CardList_7847c099_S("card-list__image")},react.createElement("img",{alt:"",loading:"lazy",src:n,srcSet:c})),react.createElement("div",{className:CardList_7847c099_S("card-list__body")},react.createElement("div",{className:CardList_7847c099_S("card-list__content",{"card-list__content--extra":o})},react.createElement("div",{"aria-level":"2",className:CardList_7847c099_S("card-list__content-title"),role:"heading"},react.createElement("span",{className:CardList_7847c099_S({"card-list__content-title--text":r}),"data-qa":"card-list__content-title"},i),r&&react.createElement("div",{className:CardList_7847c099_S("card-list__content-title--badge")},react.createElement(Badge_95ef19f1.B,{className:CardList_7847c099_S("card__badge","card-list__badge"),icon:e,title:r,type:_},r))),react.createElement("div",{className:CardList_7847c099_S("card-list__content-caption")},react.createElement("small",{"data-qa":"card-list__content-caption"},d)))))},L=function(a){var e=a.ariaLabel,r=a.badgeIcon,_=a.badgeText,i=a.badgeType,d=a.caption,l=a.footerActions,p=a.href,m=a.image,g=a.imageSrcSet,x=a.isDisabled,f=a.landingPage,u=a.name,C=a.productType,h=a.shareLandingPage,b=a.statusList,v=T(CardList_7847c099_w),E=T(N),L=T(CardList_7847c099_y),I=f&&h,P=I&&C&&react.createElement(SocialShare_95bd9eeb_L,{productName:u,productType:C,productUrl:f,shareMessage:SocialShare_95bd9eeb_g(C),hasDivider:!0}),A=Boolean(b.length),j=l||A||P;return react.createElement("section",{className:CardList_7847c099_S("card-list",{disabled:x,"card--shareable":I})},I&&v&&react.createElement(SocialShare_95bd9eeb_L,{buttonType:"icon",productName:u,productType:C,productUrl:f,shareMessage:SocialShare_95bd9eeb_g(C),isFixed:!0}),p?react.createElement("a",{"aria-label":e||u,className:CardList_7847c099_S("card__button","card-list__button"),href:p,tabIndex:0},react.createElement(CardList_7847c099_k,{badgeIcon:r,badgeText:_,badgeType:i,caption:d,hasFooter:j,image:m,imageSrcSet:g,name:u})):react.createElement("div",{className:CardList_7847c099_S("card-list__body")},react.createElement(CardList_7847c099_k,{badgeIcon:r,badgeText:_,badgeType:i,caption:d,hasFooter:j,image:m,imageSrcSet:g,name:u})),j&&react.createElement("div",{className:CardList_7847c099_S("card-list__footer")},L&&P,(l||A)&&react.createElement("span",{className:CardList_7847c099_S("card-list__footer-divider")}),A&&react.createElement("div",{className:CardList_7847c099_S("card-list__footer-status")},react.createElement("div",{className:CardList_7847c099_S("card-list__footer-status-top")},b.map((function(a,e){if(a.icon&&a.tooltip)return react.createElement(Tooltip_00b73669.T,{key:e,title:a.tooltip},react.createElement(Icon_343b84c4.I,{className:CardList_7847c099_S("card__footer-status-icon"),name:a.icon,title:a.tooltip}));if(a.text&&a.type){var r=CardList_7847c099_S("card-list__footer-status-text",{"card-list__footer-status-text--active":"active"===a.type,"card-list__footer-status-text--warning":"warning"===a.type,"card-list__footer-status-text--default":"inactive"===a.type});return react.createElement("small",{className:r,key:e},a.text)}return a})))),E&&P,l&&!x&&react.createElement("div",{className:CardList_7847c099_S("card-list__footer-action")},l)))};L.propTypes={ariaLabel:(prop_types_default()).string,badgeIcon:(prop_types_default()).string,badgeText:(prop_types_default()).string,badgeType:(prop_types_default()).string,caption:(prop_types_default()).string.isRequired,footerActions:(prop_types_default()).node,href:(prop_types_default()).string,image:(prop_types_default()).string.isRequired,imageSrcSet:(prop_types_default()).string,isDisabled:(prop_types_default()).bool,landingPage:(prop_types_default()).string,name:(prop_types_default()).node.isRequired,productType:(prop_types_default()).string,shareLandingPage:(prop_types_default()).bool,statusList:(prop_types_default()).array},L.defaultProps={ariaLabel:"",badgeIcon:null,badgeText:"",badgeType:"secondary",footerActions:null,href:null,imageSrcSet:null,isDisabled:!1,landingPage:null,productType:"",shareLandingPage:!1,statusList:[]},L.displayName="CardList",L.filename=CardList_7847c099_filename;var I=L;
//# sourceMappingURL=CardList-7847c099.js.map


/***/ }),

/***/ 95483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
/* harmony import */ var _Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78618);
var i=["children","className"],t=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),c=function(s){var o=s.children,m=s.className,p=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(s,i),c=t("h2",m);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h2",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:c},p),o)};c.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},c.defaultProps={className:null},c.displayName="H2",c.filename=__filename;var l=c;
//# sourceMappingURL=H2-6b37956c.js.map


/***/ }),

/***/ 92320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ v; },
/* harmony export */   "c": function() { return /* binding */ P; }
/* harmony export */ });
/* unused harmony exports H, a, d */
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
/* harmony import */ var _Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78618);
var i=["children","className"],m=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),d=function(l){var r=l.children,n=l.className,c=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(l,i),d=m("h1",n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:d},c),r)};d.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},d.defaultProps={className:null},d.displayName="H1",d.filename=__filename;var p=(/* unused pure expression or super */ null && (d)),o=["children","className"],t=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),N=function(l){var r=l.children,n=l.className,c=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(l,o),i=t("h3",n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:i},c),r)};N.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},N.defaultProps={className:null},N.displayName="H3";var h=(/* unused pure expression or super */ null && (N)),u=["children","className"],f=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),y=function(l){var r=l.children,n=l.className,c=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(l,u),i=f("h4",n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h4",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:i},c),r)};y.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},y.defaultProps={className:null},y.displayName="H4",y.filename=__filename;var v=y,_=["children","className"],b=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),H=function(l){var r=l.children,n=l.className,c=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(l,_),i=b("h5",n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h5",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:i},c),r)};H.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},H.defaultProps={className:null},H.displayName="H5",H.filename=__filename;var P=H,T=["children","className"],q=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),E=function(l){var r=l.children,n=l.className,c=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(l,T),i=q("h6",n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("h6",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:i},c),r)};E.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},E.defaultProps={className:null},E.displayName="H6",E.filename=__filename;var R=(/* unused pure expression or super */ null && (E));
//# sourceMappingURL=H6-b9b7adb2.js.map


/***/ }),

/***/ 42990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ $d; },
/* harmony export */   "a": function() { return /* binding */ Jd; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78776);
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11841);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10518);
var c=["title","width","height"],s={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},o=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,c);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.242 3.006a.662.662 0 0 0-.4.214l-2.027 2.14-1.593-1.68a1.52 1.52 0 0 0-2.224.007L10.86 7.012a.74.74 0 0 0 0 1l5.396 5.702c.17.18.419.25.652.184a.694.694 0 0 0 .477-.503.74.74 0 0 0-.175-.688l-4.926-5.199 2.667-2.821c.094-.1.22-.102.315 0l4.126 4.354a.237.237 0 0 1 0 .34l-1.347 1.423a.736.736 0 0 0-.207.704c.06.257.252.457.496.519s.5-.024.665-.224l1.348-1.421a1.73 1.73 0 0 0 0-2.34l-1.586-1.674 2.035-2.148a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.396zm-10.104 7.109a.662.662 0 0 0-.4.215l-1.431 1.51-.54-.577a.655.655 0 0 0-.955 0L3.67 14.58c-.608.64-.608 1.706 0 2.347l1.593 1.681-2.035 2.148a.736.736 0 0 0-.207.704c.06.257.252.457.496.52.244.061.5-.025.665-.224l2.035-2.14 1.579 1.666a1.527 1.527 0 0 0 2.224 0l3.143-3.318a.74.74 0 0 0 0-1l-.533-.57 1.432-1.51a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.397.662.662 0 0 0-.4.214l-1.432 1.511L9.26 12.84l1.432-1.51a.74.74 0 0 0 .136-.818.667.667 0 0 0-.69-.397zM7.29 12.774l4.441 4.695-2.666 2.814c-.096.101-.22.101-.316 0L4.623 15.92c-.096-.102-.096-.232 0-.333l2.667-2.814z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:s},l))};o.displayName="Apps",o.defaultProps={height:24,title:null,width:24},o.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var d=o,p=["title","width","height"],m={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},u=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,p);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.148 17.262L11.14 4.82c0-.21.084-.42.252-.58a.89.89 0 0 1 1.216 0c.168.16.252.37.252.58v12.431l3.459-3.632a.815.815 0 0 1 .58-.244c.225 0 .429.093.579.244.149.155.24.37.24.608a.877.877 0 0 1-.24.608l-4.755 4.98a1 1 0 0 1-1.447 0l-4.755-4.978a.879.879 0 0 1-.24-.608c0-.475.367-.86.82-.86.226 0 .43.096.579.252l3.468 3.64z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:m},l))};u.displayName="Arrowdown",u.defaultProps={height:24,title:null,width:24},u.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var w=u,g=["title","width","height"],v={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},f=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,g);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5.72 17.103l3.997-4.005a.86.86 0 0 1 1.216 1.216l-3.995 3.995 2.367-.001a.876.876 0 0 1 .86.86.855.855 0 0 1-.86.86l-4.298-.007a1 1 0 0 1-.998-.998L4 14.727a.86.86 0 1 1 1.72 0v2.376zm8.551-6.154a.86.86 0 0 1-1.216-1.216l3.996-3.996-2.367.001a.876.876 0 0 1-.86-.86.855.855 0 0 1 .86-.86l4.297.007a1 1 0 0 1 .999.998l.007 4.296a.86.86 0 1 1-1.72 0V6.943l-3.996 4.006z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:v},l))};f.displayName="Arrowgrow",f.defaultProps={height:24,title:null,width:24},f.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var E=f,b=["title","width","height"],C={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},z=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,b);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M6.895 11.15l12.234-.008c.223 0 .446.084.616.252.34.335.34.88 0 1.215a.874.874 0 0 1-.616.252H6.905l3.723 3.673a.87.87 0 0 1 0 1.216.872.872 0 0 1-.616.253.872.872 0 0 1-.616-.253l-5.1-5.043a.99.99 0 0 1 0-1.412l5.098-5.043A.874.874 0 0 1 10.01 6c.481 0 .871.385.871.86a.851.851 0 0 1-.255.608l-3.73 3.682z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:C},l))};z.displayName="Arrowleft",z.defaultProps={height:24,title:null,width:24},z.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var y=z,M=["title","width","height"],H={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},A=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,M);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.83 8.778c2.061 0 3.93.77 5.369 2.023L20 8v6.503a.5.5 0 0 1-.5.5h-6.503l2.817-2.817a6.189 6.189 0 0 0-3.985-1.462 6.234 6.234 0 0 0-5.914 4.28c-.19.672-.594.907-1.212.704-.618-.203-.828-.64-.632-1.312 1.082-3.26 4.14-5.618 7.758-5.618z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:H},l))};A.displayName="Arrowredo",A.defaultProps={height:24,title:null,width:24},A.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var L=A,V=["title","width","height"],R={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},S=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,V);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.26 12.853l-12.44.008a.797.797 0 0 1-.58-.252.89.89 0 0 1 0-1.215.797.797 0 0 1 .58-.252h12.43l-3.631-3.46a.815.815 0 0 1-.245-.58c0-.224.093-.428.244-.578a.877.877 0 0 1 .608-.241c.238 0 .453.092.608.24l4.981 4.756a1 1 0 0 1 0 1.446l-4.979 4.755a.879.879 0 0 1-.608.24c-.474 0-.86-.367-.86-.82 0-.225.097-.43.253-.578l3.64-3.469z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:R},l))};S.displayName="Arrowright",S.defaultProps={height:24,title:null,width:24},S.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var x=S,P=["title","width","height"],B={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},F=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,P);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.466 15.77l-3.997 4.006a.86.86 0 0 1-1.216-1.216l3.996-3.995H5.882a.876.876 0 0 1-.86-.86.855.855 0 0 1 .86-.859l4.297.006a1 1 0 0 1 .999.998l.007 4.297a.86.86 0 1 1-1.72 0V15.77zm9.053-11.5a.86.86 0 0 1 1.216 1.216L15.74 9.482l2.367-.001a.876.876 0 0 1 .86.86.855.855 0 0 1-.86.86l-4.298-.007a1 1 0 0 1-.998-.998L12.803 5.9a.86.86 0 1 1 1.72 0v2.376l3.996-4.005z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:B},l))};F.displayName="Arrowshrink",F.defaultProps={height:24,title:null,width:24},F.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var N=F,T=["title","width","height"],k={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Z=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,T);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.17 8.778c-2.061 0-3.93.77-5.369 2.023L4 8v6.503a.5.5 0 0 0 .5.5h6.503l-2.817-2.817a6.189 6.189 0 0 1 3.985-1.462 6.234 6.234 0 0 1 5.914 4.28c.19.672.594.907 1.212.704.618-.203.828-.64.632-1.312-1.082-3.26-4.14-5.618-7.758-5.618z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:k},l))};Z.displayName="Arrowundo",Z.defaultProps={height:24,title:null,width:24},Z.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var O=Z,D=["title","width","height"],j={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},W=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,D);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M16.941 6h.02c.024 0 .05.002.074.004L16.94 6a1.067 1.067 0 0 1 .206.02l.021.004a1.051 1.051 0 0 1 .315.125l.084.055a1.063 1.063 0 0 1 .123.106l.008.009c.023.023.044.047.065.072l-.073-.08a.911.911 0 0 1 .096.11l.01.012.055.084a1.05 1.05 0 0 1 .15.543v7.059a1.059 1.059 0 0 1-2.118 0V9.614L7.808 17.69a1.059 1.059 0 0 1-1.498-1.498l8.075-8.075H9.882a1.059 1.059 0 1 1 0-2.117h7.06z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:j},l))};W.displayName="Arrowupright",W.defaultProps={height:24,title:null,width:24},W.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var I=W,_=["title","width","height"],U={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},G=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,_);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.852 6.897l.008 12.233a.874.874 0 0 1-.252.616.852.852 0 0 1-1.216 0 .874.874 0 0 1-.252-.616V6.906L7.467 10.63a.87.87 0 0 1-1.216 0A.872.872 0 0 1 6 10.015a.87.87 0 0 1 .252-.616l5.043-5.1a.99.99 0 0 1 1.413 0l5.043 5.097a.874.874 0 0 1 .251.616.866.866 0 0 1-.86.872.851.851 0 0 1-.607-.256l-3.682-3.73z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:U},l))};G.displayName="Arrowup",G.defaultProps={height:24,title:null,width:24},G.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var q=G,K=["title","width","height"],X={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},J=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,K);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.7058823529411765 0.7058823529411765)",d:"M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm0-1h30a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.7058823529411765 0.7058823529411765)",d:"M5 5.03h2.222c1.012 0 1.747.143 2.204.431.458.289.686.747.686 1.375 0 .426-.1.776-.3 1.05a1.2 1.2 0 0 1-.798.493v.049c.452.1.778.29.979.566.2.277.3.645.3 1.104 0 .65-.235 1.159-.706 1.523-.47.365-1.109.547-1.916.547H5V5.029zm1.514 2.826h.879c.41 0 .707-.063.89-.19.185-.127.277-.337.277-.63 0-.273-.1-.47-.3-.588-.2-.12-.517-.178-.95-.178h-.796v1.586zm0 1.202v1.86H7.5c.417 0 .724-.08.923-.24.198-.159.298-.403.298-.732 0-.592-.423-.888-1.27-.888h-.937zm9.316 3.11h-4.11V5.029h4.111v1.24h-2.598v1.568h2.417v1.24h-2.417v1.841h2.598v1.25zm4.243 0H18.56V6.289h-1.94V5.03h5.39v1.26h-1.938v5.879zm7.407 0l-.517-1.7H24.36l-.517 1.7h-1.631L24.732 5h1.85l2.53 7.168H27.48zm-.878-2.969a502.62 502.62 0 0 1-.809-2.612 7.374 7.374 0 0 1-.129-.479c-.107.417-.415 1.447-.923 3.091h1.86z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:X},l))};J.displayName="Beta",J.defaultProps={height:24,title:null,width:24},J.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Q=J,Y=["title","width","height"],$={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ee=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Y);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.18 4.5c.453 0 .84.167 1.16.5.32.333.48.727.48 1.18V19.5L12 17l-5.82 2.5V6.18c0-.453.16-.847.48-1.18.32-.333.707-.5 1.16-.5h8.36z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:$},l))};ee.displayName="Bookmarkfill",ee.defaultProps={height:24,title:null,width:24},ee.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var te=ee,ae=["title","width","height"],ie={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},le=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ae);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.82 11.334V19.5L12 17l-5.82 2.5V6.18c0-.453.16-.847.48-1.18.32-.333.707-.5 1.16-.5h3.157a2.873 2.873 0 0 0 .006 1.68H7.82V17L12 15.16 16.18 17v-5.656a2.873 2.873 0 0 0 1.64-.01zM16.126 4.47h-2.412a.86.86 0 0 0 0 1.72l2.418-.01-.008 2.419a.86.86 0 1 0 1.72 0V6.188h2.41a.855.855 0 0 0 .603-1.462.876.876 0 0 0-.603-.258l-2.412.002V2.059a.86.86 0 1 0-1.72 0l.004 2.41z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ie},l))};le.displayName="Bookmarkoutlineadd",le.defaultProps={height:24,title:null,width:24},le.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var re=le,he=["title","width","height"],ne={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ce=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,he);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.18 17.5V6.68H7.82V17.5L12 15.66l4.18 1.84zm0-12.5c.453 0 .84.167 1.16.5.32.333.48.727.48 1.18V20L12 17.5 6.18 20V6.68c0-.453.16-.847.48-1.18.32-.333.707-.5 1.16-.5h8.36z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ne},l))};ce.displayName="Bookmarkoutline",ce.defaultProps={height:24,title:null,width:24},ce.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var se=ce,oe=["title","width","height"],de={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},pe=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,oe);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"12",cy:"12",r:"4",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:de},l))};pe.displayName="Bullet",pe.defaultProps={height:24,title:null,width:24},pe.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var me=pe,ue=["title","width","height"],we={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ge=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ue);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M7.854 10.854A.5.5 0 0 1 8.207 10h7.586a.5.5 0 0 1 .353.854l-3.439 3.439a1 1 0 0 1-1.414 0l-3.44-3.44z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:we},l))};ge.displayName="Caretfilldown",ge.defaultProps={height:24,title:null,width:24},ge.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ve=ge,fe=["title","width","height"],Ee={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},be=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,fe);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13.146 7.854a.5.5 0 0 1 .854.353v7.586a.5.5 0 0 1-.854.353l-3.439-3.439a1 1 0 0 1 0-1.414l3.44-3.44z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ee},l))};be.displayName="Caretfillleft",be.defaultProps={height:24,title:null,width:24},be.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ce=be,ze=["title","width","height"],ye={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Me=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ze);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M10.854 16.146a.5.5 0 0 1-.854-.353V8.207a.5.5 0 0 1 .854-.353l3.439 3.439a1 1 0 0 1 0 1.414l-3.44 3.44z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ye},l))};Me.displayName="Caretfillright",Me.defaultProps={height:24,title:null,width:24},Me.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var He=Me,Ae=["title","width","height"],Le={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ve=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ae);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{id:"System/caretFill-upDown",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.1464466,9.14644661 C16.2402148,9.2402148 16.2928932,9.36739176 16.2928932,9.5 C16.2928932,9.77614237 16.0690356,10 15.7928932,10 L8.20710678,10 C8.07449854,10 7.94732158,9.94732158 7.85355339,9.85355339 C7.65829124,9.65829124 7.65829124,9.34170876 7.85355339,9.14644661 L11.2928932,5.70710678 C11.6834175,5.31658249 12.3165825,5.31658249 12.7071068,5.70710678 L16.1464466,9.14644661 Z",id:"IconAppearance",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M7.85355339,14.8535534 C7.7597852,14.7597852 7.70710678,14.6326082 7.70710678,14.5 C7.70710678,14.2238576 7.93096441,14 8.20710678,14 L15.7928932,14 C15.9255015,14 16.0526784,14.0526784 16.1464466,14.1464466 C16.3417088,14.3417088 16.3417088,14.6582912 16.1464466,14.8535534 L12.7071068,18.2928932 C12.3165825,18.6834175 11.6834175,18.6834175 11.2928932,18.2928932 L7.85355339,14.8535534 Z",id:"IconAppearance-Copy",fill:"#12131A"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Le},l))};Ve.displayName="Caretfillupdown",Ve.defaultProps={height:24,title:null,width:24},Ve.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Re=Ve,Se=["title","width","height"],xe={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Pe=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Se);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.146 13.146a.5.5 0 0 1-.353.854H8.207a.5.5 0 0 1-.353-.854l3.439-3.439a1 1 0 0 1 1.414 0l3.44 3.44z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:xe},l))};Pe.displayName="Caretfillup",Pe.defaultProps={height:24,title:null,width:24},Pe.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Be=Pe,Fe=["title","width","height"],Ne={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Te=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Fe);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.295 15.5l-5.043-5.032a.86.86 0 0 1 1.216-1.216L12 13.785l4.533-4.535a.876.876 0 0 1 1.216 0 .855.855 0 0 1 0 1.216l-5.043 5.033a1 1 0 0 1-1.412 0z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ne},l))};Te.displayName="Caretstrokedown",Te.defaultProps={height:24,title:null,width:24},Te.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ke=Te,Ze=["title","width","height"],Oe={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},De=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ze);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.61 18h-.144a.858.858 0 0 1-.536-.25l-5.033-5.042a1 1 0 0 1 0-1.413l5.031-5.043a.86.86 0 1 1 1.216 1.216L10.61 12l4.536 4.533a.877.877 0 0 1 0 1.217.858.858 0 0 1-.536.249z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Oe},l))};De.displayName="Caretstrokeleft",De.defaultProps={height:24,title:null,width:24},De.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var je=De,We=["title","width","height"],Ie={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},_e=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,We);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.39 6.003h.144c.21.017.397.11.536.249l5.033 5.044a1 1 0 0 1 0 1.413l-5.031 5.042a.86.86 0 0 1-1.216-1.215l4.534-4.534-4.535-4.533a.881.881 0 0 1-.001-1.217.858.858 0 0 1 .536-.25z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ie},l))};_e.displayName="Caretstrokeright",_e.defaultProps={height:24,title:null,width:24},_e.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ue=_e,Ge=["title","width","height"],qe={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ke=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ge);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.295 8.5a1 1 0 0 1 1.412 0l5.043 5.034a.855.855 0 0 1-.608 1.46.876.876 0 0 1-.608-.244l-4.533-4.535-4.533 4.533a.86.86 0 0 1-1.216-1.216l5.043-5.031z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:qe},l))};Ke.displayName="Caretstrokeup",Ke.defaultProps={height:24,title:null,width:24},Ke.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Xe=Ke,Je=["title","width","height"],Qe={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ye=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Je);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 4.3a3.654 3.654 0 0 0-3.65 3.65C8.35 9.975 10 11.6 12 11.6c2.025 0 3.65-1.65 3.65-3.65S14.025 4.3 12 4.3zm.275 4.6l-.825.825-.825-.825-.8-.8.825-.825.8.8 1.9-1.9.825.825-1.9 1.9zM19.3 6.925c-.325-.3-.45-.775-.275-1.175l.15-.375c.25-.575-.075-1.225-.675-1.4l-.4-.1a1.044 1.044 0 0 1-.75-.95V2.5a1.035 1.035 0 0 0-1.2-.975l-.4.075c-.45.075-.875-.125-1.075-.525l-.2-.35c-.3-.55-1-.7-1.5-.35L12.65.6c-.35.25-.85.25-1.2 0l-.325-.25C10.625-.025 9.9.15 9.6.7l-.2.35c-.225.4-.65.6-1.1.525L7.9 1.5c-.625-.1-1.175.35-1.225.975l-.025.4c-.025.45-.325.825-.75.95l-.4.125c-.6.175-.925.825-.675 1.4l.15.375c.175.4.05.875-.275 1.175l-.3.275c-.475.4-.475 1.15 0 1.55L4.7 9c.325.3.45.775.275 1.175l-.15.375c-.25.575.075 1.225.675 1.4l.4.1c.425.125.725.5.75.95l.025.4c.025.625.6 1.075 1.2.975l.4-.075c.45-.075.875.125 1.075.525l.2.35c.3.55 1 .7 1.5.35l.325-.225c.35-.25.85-.25 1.2 0l.325.25c.5.375 1.225.2 1.525-.35l.2-.35c.225-.4.65-.6 1.1-.525l.4.075c.625.1 1.175-.35 1.225-.975l.025-.4c.025-.45.325-.825.75-.95l.4-.1c.6-.175.925-.825.675-1.4l-.15-.375c-.175-.4-.05-.875.275-1.175l.3-.275c.475-.4.475-1.15 0-1.55l-.325-.275zm-7.3 6.1c-2.8 0-5.05-2.275-5.05-5.05 0-2.8 2.275-5.05 5.05-5.05 2.8 0 5.05 2.275 5.05 5.05s-2.25 5.05-5.05 5.05zm-7.85 8.8L6.6 15.7c.325.15.7.25 1.075.25.15 0 .3-.025.45-.05h.05l.025.05c.425.8 1.3 1.3 2.25 1.3.25 0 .525-.05.75-.125L8.625 23.6a.244.244 0 0 1-.45.025l-1.225-2.15c-.05-.075-.125-.1-.2-.075l-2.3.725c-.2.075-.375-.125-.3-.3zm11.225 1.85l-2.6-6.5c.25.075.5.125.75.125.95 0 1.8-.5 2.25-1.325l.025-.05h.05c.15.025.3.05.45.05.4 0 .75-.1 1.1-.25l2.45 6.175c.075.2-.1.4-.3.325l-2.3-.725c-.075-.025-.15 0-.2.075l-1.225 2.15c-.1.15-.375.125-.45-.05z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Qe},l))};Ye.displayName="Certificate",Ye.defaultProps={height:24,title:null,width:24},Ye.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var $e=Ye,et=["title","width","height"],tt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},at=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,et);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5 6.347v11.306C5 18.396 5.604 19 6.347 19h11.306c.743 0 1.347-.604 1.347-1.347V6.347C19 5.604 18.396 5 17.653 5H6.347C5.604 5 5 5.604 5 6.347zm-1 0A2.348 2.348 0 0 1 6.347 4h11.306A2.348 2.348 0 0 1 20 6.347v11.306A2.348 2.348 0 0 1 17.653 20H6.347A2.348 2.348 0 0 1 4 17.653V6.347z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:tt},l))};at.displayName="Checkboxempty",at.defaultProps={height:24,title:null,width:24},at.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var it=at,lt=["title","width","height"],rt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ht=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,lt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M4 6.347A2.348 2.348 0 0 1 6.347 4h11.306A2.348 2.348 0 0 1 20 6.347v11.306A2.348 2.348 0 0 1 17.653 20H6.347A2.348 2.348 0 0 1 4 17.653V6.347zM16 13a1 1 0 0 0 0-2H8a1 1 0 0 0 0 2h8z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:rt},l))};ht.displayName="Checkboxindeterminate",ht.defaultProps={height:24,title:null,width:24},ht.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var nt=ht,ct=["title","width","height"],st={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ot=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ct);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M4 6.347A2.348 2.348 0 0 1 6.347 4h11.306A2.348 2.348 0 0 1 20 6.347v11.306A2.348 2.348 0 0 1 17.653 20H6.347A2.348 2.348 0 0 1 4 17.653V6.347zm14 2.709c.379-.518.379-.97 0-1.354-.379-.385-.808-.464-1.286-.239L10 14.184l-2.338-2.37c-.532-.223-.96-.161-1.284.186-.324.347-.354.795-.09 1.344l3.005 3.005a1 1 0 0 0 1.414 0L18 9.056z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:st},l))};ot.displayName="Checkboxselected",ot.defaultProps={height:24,title:null,width:24},ot.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var dt=ot,pt=["title","width","height"],mt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ut=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,pt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18 9.056l-7.293 7.293a1 1 0 0 1-1.414 0l-3.005-3.005c-.264-.549-.234-.997.09-1.344.324-.347.752-.41 1.284-.186L10 14.184l6.714-6.72c.478-.226.907-.147 1.286.238s.379.836 0 1.354z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:mt},l))};ut.displayName="Checkmark",ut.defaultProps={height:24,title:null,width:24},ut.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var wt=ut,gt=["title","width","height"],vt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ft=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,gt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-1.814-5.515L8.24 12.541a.75.75 0 0 0-1.06 1.06l2.474 2.475a.75.75 0 0 0 1.06 0l6.011-6.01a.75.75 0 1 0-1.06-1.06l-5.48 5.48z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:vt},l))};ft.displayName="Circlefillcheck",ft.defaultProps={height:24,title:null,width:24},ft.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Et=ft,bt=["title","width","height"],Ct={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},zt=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,bt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm-4.25-8.75a.75.75 0 1 0 0 1.5h8.5a.75.75 0 1 0 0-1.5h-8.5z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ct},l))};zt.displayName="Circlefilldash",zt.defaultProps={height:24,title:null,width:24},zt.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var yt=zt,Mt=["title","width","height"],Ht={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},At=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Mt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-9a.75.75 0 0 0-.75.75v3.5a.75.75 0 1 0 1.5 0v-3.5A.75.75 0 0 0 12 11zm0-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ht},l))};At.displayName="Circlefillinfo",At.defaultProps={height:24,title:null,width:24},At.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Lt=At,Vt=["title","width","height"],Rt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},St=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Vt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M6.657 17.97A8 8 0 1 1 17.97 6.658 8 8 0 0 1 6.657 17.97zm5.657-6.717L9.839 8.778a.75.75 0 1 0-1.06 1.06l2.474 2.476-2.475 2.475a.75.75 0 0 0 1.06 1.06l2.476-2.475 2.475 2.475a.75.75 0 0 0 1.06-1.06l-2.475-2.475 2.475-2.475a.75.75 0 0 0-1.06-1.06l-2.475 2.474z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Rt},l))};St.displayName="Circlefillx",St.defaultProps={height:24,title:null,width:24},St.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var xt=St,Pt=["title","width","height"],Bt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ft=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Pt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zm0-7.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5A.75.75 0 0 1 12 11zm0-3a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Bt},l))};Ft.displayName="Circleoutlineinfo",Ft.defaultProps={height:24,title:null,width:24},Ft.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Nt=Ft,Tt=["title","width","height"],kt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Zt=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Tt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM10 8l6 4-6 4V8z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:kt},l))};Zt.displayName="Circleoutlineplay",Zt.defaultProps={height:24,title:null,width:24},Zt.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ot=Zt,Dt=["title","width","height"],jt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Wt=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Dt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 21.75c-5.385 0-9.75-4.365-9.75-9.75S6.615 2.25 12 2.25s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75zm0-1.5a8.25 8.25 0 1 0 0-16.5 8.25 8.25 0 0 0 0 16.5z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.2 16.483c-.72-.102-1.29-.338-1.711-.706-.46-.401-.689-.914-.689-1.538v-.512c0-.06.02-.107.057-.141a.229.229 0 0 1 .158-.051h.919c.067 0 .12.017.157.051a.18.18 0 0 1 .058.14v.244c0 .436.17.795.51 1.077.339.282.81.423 1.413.423.564 0 .997-.126 1.298-.378.302-.252.452-.575.452-.968a.873.873 0 0 0-.23-.602 2.13 2.13 0 0 0-.588-.449 19.78 19.78 0 0 0-1.061-.512c-.421-.17-.814-.35-1.177-.538-.66-.308-1.143-.628-1.45-.961-.306-.333-.459-.773-.459-1.32 0-.666.216-1.202.646-1.608.403-.38.968-.619 1.697-.718V6.034c0-.24.205-.434.457-.434h.686c.252 0 .457.194.457.434v1.381c.674.1 1.21.324 1.61.674.48.419.718.965.718 1.64v.372a.18.18 0 0 1-.057.14.229.229 0 0 1-.158.052h-.918a.25.25 0 0 1-.158-.045.146.146 0 0 1-.058-.122v-.153c0-.462-.16-.835-.48-1.122-.32-.286-.787-.429-1.4-.429-.535 0-.949.111-1.24.333-.292.222-.438.534-.438.936 0 .247.074.457.222.628.148.17.342.311.581.422.24.111.593.257 1.062.436l.732.282c.823.333 1.425.705 1.808 1.115a2.1 2.1 0 0 1 .574 1.486c0 .7-.24 1.269-.717 1.704-.412.375-.973.614-1.683.717v1.485c0 .24-.205.434-.457.434h-.686a.446.446 0 0 1-.457-.434v-1.483z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:jt},l))};Wt.displayName="Circleoutlineprice",Wt.defaultProps={height:24,title:null,width:24},Wt.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var It=Wt,_t=["title","width","height"],Ut={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Gt=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,_t);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 4c-4.416 0-8 3.584-8 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4A6.398 6.398 0 0 1 5.6 12c0-1.48.504-2.84 1.352-3.92l8.968 8.968A6.322 6.322 0 0 1 12 18.4zm5.048-2.48L8.08 6.952A6.322 6.322 0 0 1 12 5.6c3.536 0 6.4 2.864 6.4 6.4 0 1.48-.504 2.84-1.352 3.92z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ut},l))};Gt.displayName="Circleslash",Gt.defaultProps={height:24,title:null,width:24},Gt.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var qt=Gt,Kt=["title","width","height"],Xt={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Jt=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Kt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.75 10.355c.3.053.583.199.85.44.267.24.4.537.4.889v1.25a.99.99 0 0 1-.4.82 2.35 2.35 0 0 1-.85.43l-1.621.39a9.12 9.12 0 0 1-.205.557 5.344 5.344 0 0 1-.244.517l.86 1.446c.168.26.272.56.312.898.039.339-.066.632-.313.88l-.879.878a1.129 1.129 0 0 1-.898.342 1.84 1.84 0 0 1-.918-.283l-1.407-.899c-.182.091-.364.176-.546.254a6.24 6.24 0 0 1-.586.215L13.953 21c-.052.3-.198.583-.44.85-.24.267-.536.4-.888.4h-1.25a.99.99 0 0 1-.82-.4 2.332 2.332 0 0 1-.43-.85l-.39-1.602a8.002 8.002 0 0 1-.626-.224 6.421 6.421 0 0 1-.605-.283l-1.445.918c-.248.169-.55.263-.909.283a1.084 1.084 0 0 1-.888-.342l-.899-.879a1.047 1.047 0 0 1-.293-.879c.04-.338.137-.638.293-.898l.918-1.524a10.757 10.757 0 0 1-.224-.478 4.038 4.038 0 0 1-.186-.518l-1.621-.39a2.332 2.332 0 0 1-.85-.43.99.99 0 0 1-.4-.82v-1.25c0-.352.133-.648.4-.89.267-.24.55-.386.85-.439l1.602-.351c.052-.182.117-.365.195-.547.078-.182.156-.358.234-.527l-.918-1.524a2.218 2.218 0 0 1-.293-.898 1.05 1.05 0 0 1 .293-.88l.899-.878c.234-.247.53-.361.888-.342.358.02.661.114.909.283l1.445.918a7.1 7.1 0 0 1 1.21-.507l.411-1.602a2.1 2.1 0 0 1 .41-.85c.208-.267.488-.4.84-.4h1.25c.352 0 .645.133.879.4.234.267.384.544.45.83l.35 1.641a8.71 8.71 0 0 1 1.133.469l1.407-.899c.26-.169.566-.263.918-.283.351-.02.65.095.898.342l.88.879c.246.247.35.54.312.879a2.07 2.07 0 0 1-.313.898l-.86 1.446c.092.182.18.367.264.556.085.189.153.388.205.596l1.602.351zm0 2.48l.02-1.112a.687.687 0 0 0-.098-.069.521.521 0 0 0-.176-.068l-2.324-.527-.215-.684a3.298 3.298 0 0 0-.156-.469 5.478 5.478 0 0 0-.235-.488l-.312-.625 1.23-2.05a.632.632 0 0 0 .088-.157.374.374 0 0 0 .03-.117l-.82-.801a.464.464 0 0 0-.255.078l-2.011 1.29-.645-.333a15.34 15.34 0 0 0-.469-.224 2.539 2.539 0 0 0-.488-.167l-.684-.234-.507-2.363a.575.575 0 0 0-.059-.147l-.039-.068h-1.152a.454.454 0 0 0-.078.117.694.694 0 0 0-.06.196l-.565 2.265-.665.215a5.737 5.737 0 0 0-1.015.43l-.645.332-2.09-1.328-.097-.05a.895.895 0 0 0-.117-.048l-.82.82c0 .04.01.085.029.137.02.052.048.11.088.176l1.269 2.11-.312.605c-.079.169-.147.325-.206.468a3.72 3.72 0 0 0-.146.43l-.215.684-2.363.527a.716.716 0 0 0-.127.059.265.265 0 0 1-.088.039v1.152a.327.327 0 0 0 .117.068c.052.02.117.036.196.05l2.285.585.215.664c.039.13.087.264.146.4.059.137.127.277.205.42l.293.606-1.27 2.129a.632.632 0 0 0-.087.156.398.398 0 0 0-.03.137l.82.8c.04 0 .082-.01.128-.029a.787.787 0 0 0 .127-.068l2.05-1.309.645.332a5.875 5.875 0 0 0 1.015.43l.665.215.585 2.305a.82.82 0 0 0 .05.166.34.34 0 0 0 .068.107h1.132a.687.687 0 0 0 .069-.098.545.545 0 0 0 .068-.156l.508-2.324.684-.235a6.854 6.854 0 0 0 .937-.39l.645-.332 2.05 1.308.098.05c.04.019.078.035.117.048l.82-.82c0-.04-.01-.085-.029-.137a1.101 1.101 0 0 0-.088-.176l-1.23-2.031.312-.625c.079-.143.147-.29.205-.44.06-.15.114-.302.166-.458l.215-.645 2.325-.586a.847.847 0 0 0 .166-.049.34.34 0 0 0 .107-.068zM12 8.5c1.042 0 1.93.365 2.666 1.094.736.729 1.104 1.614 1.104 2.656s-.368 1.927-1.104 2.656C13.93 15.636 13.042 16 12 16c-1.029 0-1.91-.365-2.646-1.094-.736-.729-1.104-1.614-1.104-2.656s.368-1.927 1.104-2.656C10.089 8.864 10.97 8.5 12 8.5zm0 6.25c.69 0 1.28-.244 1.768-.732a2.409 2.409 0 0 0 .732-1.768c0-.69-.244-1.28-.732-1.768A2.409 2.409 0 0 0 12 9.75c-.69 0-1.28.244-1.768.732A2.409 2.409 0 0 0 9.5 12.25c0 .69.244 1.28.732 1.768A2.409 2.409 0 0 0 12 14.75z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Xt},l))};Jt.displayName="Cog",Jt.defaultProps={height:24,title:null,width:24},Jt.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Qt=Jt,Yt=["title","width","height"],$t={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ea=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Yt);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M10 18V6h4.127v12H10zm-6 0V6h4.127v12H4zm12.873-1H19V7h-2.127v10zm-1-11H20v12h-4.127V6z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:$t},l))};ea.displayName="Columnselect",ea.defaultProps={height:24,title:null,width:24},ea.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ta=ea,aa=["title","width","height"],ia={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},la=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,aa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.763 6l-1.049 1.201L20.903 12l-4.189 4.799L17.763 18 23 12l-5.237-6zM7.286 7.201L6.237 6 1 12l5.237 6 1.049-1.201L3.097 12l4.189-4.799zm0 6.435H9.38v-2.181H7.286v2.181zm3.143 0h2.095v-2.181h-2.095v2.181zm6.285-2.181H14.62v2.181h2.095v-2.181z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ia},l))};la.displayName="Connection",la.defaultProps={height:24,title:null,width:24},la.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ra=la,ha=["title","width","height"],na={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ca=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ha);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.775 22.642c1.866-.269 3.111-1.712 3.453-3.578h-3.453v3.578zm3.421-4.822V9.55l1.245-1.235v10.233a5.4 5.4 0 0 1-5.084 5.387c-.08.052-10.658.052-10.658.052-1.367 0-2.299-1.159-2.299-2.523V3.588c0-1.364.913-2.571 2.277-2.571h12.904l-1.256 1.246H4.673c-.675 0-1.034.646-1.034 1.325v17.88c0 .675.362 1.329 1.04 1.329h9.879v-4.023c0-.333.225-.955.57-.955l.002.001h4.066zM6.952 6.236l4.78.02c.266.002.48.217.48.484l-.001.184a.481.481 0 0 1-.484.48l-4.78-.02a.482.482 0 0 1-.48-.483l.002-.187c0-.266.217-.48.483-.478zm5.615 10.168l-5.62-.025a.481.481 0 0 1-.48-.484l.002-.185a.48.48 0 0 1 .483-.478l5.619.023c.266 0 .481.218.48.482l-.002.187a.48.48 0 0 1-.482.48zM22.8 2.295a.166.166 0 0 0 .002-.235l-.856-.864a.167.167 0 0 0-.235 0l-1.274 1.262 1.096 1.095L22.8 2.295zm-8.44 8.37l6.153-6.101-1.094-1.096-6.149 6.096-.004 1.096 1.094.004zm9.257-9.415c.511.516.507 1.35-.007 1.86l-8.78 8.706-2.717-.013-5.166-.022a.48.48 0 0 1-.48-.482l.002-.187c0-.266.217-.48.483-.478l5.165.02.008-1.57L20.902.38a1.316 1.316 0 0 1 1.86.009l.855.861z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:na},l))};ca.displayName="Contentassignment",ca.defaultProps={height:24,title:null,width:24},ca.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var sa=ca,oa=["title","width","height"],da={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},pa=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,oa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.43.894a.591.591 0 0 0-.63.083l-7.157 6.001H5.591A.591.591 0 0 0 5 7.57v8.566c0 .326.265.591.59.591h5.404l7.812 6.304a.591.591 0 0 0 .963-.458V1.428a.591.591 0 0 0-.336-.534h-.003zm-.842 20.44l-7.013-5.66a.586.586 0 0 0-.37-.13H6.183V8.16h5.674a.59.59 0 0 0 .382-.14l6.35-5.325v18.64z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:da},l))};pa.displayName="Contentaudio",pa.defaultProps={height:24,title:null,width:24},pa.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ma=pa,ua=["title","width","height"],wa={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ga=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ua);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5.356 9.662a.643.643 0 1 1-1.286 0 .643.643 0 0 1 1.286 0zm3.12 0a.643.643 0 1 1-1.286 0 .643.643 0 0 1 1.286 0zm3.121 0a.643.643 0 1 1-1.287 0 .643.643 0 0 1 1.287 0zm5.28 3.361a.643.643 0 1 1-1.287 0 .643.643 0 0 1 1.287 0zm3.12 0a.643.643 0 1 1-1.287 0 .643.643 0 0 1 1.287 0z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.934 7.906h-3.718a.215.215 0 0 1-.13-.166c-.456-1.869-1.567-3.434-4.44-3.434H5.224a4.495 4.495 0 0 0-4.48 4.487v1.672a4.16 4.16 0 0 0 3.68 4.133c.074.01.117.057.117.115v.009l.118 1.577a.437.437 0 0 0 .266.356c.116.048.243 0 .457-.114l2.66-1.86a.192.192 0 0 1 .075-.053h1.08a.13.13 0 0 1 .126.102c.296 1.983 1.088 3.258 3.944 3.258h2.815c.033.011.06.03.082.055l2.606 1.94a.742.742 0 0 0 .444.148c.183 0 .524-.125.546-.636v-1.409l-.001-.013c0-.059.043-.107.098-.116 2.141-.258 3.457-1.887 3.457-4.092v-1.54c-.008-2.58-1.848-4.419-4.378-4.419h-.002zM8 13.93a1.002 1.002 0 0 0-.487.063l-1.968 1.464a.137.137 0 0 1-.216-.1l-.048-.65c-.07-.72-.072-.686-.113-.758-.04-.072-.285-.086-.48-.103-2.071-.192-3.144-1.88-3.156-3.638V8.936c0-2.024 1.769-3.68 3.792-3.68l5.566-.04a3.582 3.582 0 0 1 3.533 3.58v1.798c-.088 2.136-1.764 3.336-3.691 3.336H8zm14.584-.064c0 1.92-1.342 3.295-3.254 3.295-.404 0-.336.46-.336.46l-.02 1.277v.002a.14.14 0 0 1-.223.11l-2.016-1.602a.378.378 0 0 0-.223-.084l-3.265-.034c-1.94-.142-2.88-.77-3.046-2.4l-.001-.021c0-.07.051-.13.119-.142l.68-.036c2.961-.108 4.286-2.138 4.214-4.62V8.816c0-.076.062-.137.137-.137h3.818c2.035 0 3.42 1.92 3.42 3.562v1.618l-.004.007z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:wa},l))};ga.displayName="Contentdiscussions",ga.defaultProps={height:24,title:null,width:24},ga.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var va=ga,fa=["title","width","height"],Ea={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ba=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,fa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.793 9.509c-.431-2.91-2.912-5.119-5.909-5.119a5.962 5.962 0 0 0-4.886 2.54 4.718 4.718 0 0 0-2.206-.554h-.009a4.534 4.534 0 0 0-4.528 4.534v.005c.001.243.022.48.06.711A3.687 3.687 0 0 0 .08 15.027v.016a3.702 3.702 0 0 0 3.607 3.701H19.35c2.456 0 4.53-2.104 4.53-4.629a4.656 4.656 0 0 0-4.063-4.603l-.024-.003zm-.443 8.21H3.69a2.666 2.666 0 0 1-2.588-2.665v-.028c0-1.224.808-2.26 1.919-2.604a.52.52 0 0 0 .384-.624A3.497 3.497 0 0 1 8.85 8.09a.512.512 0 0 0 .734-.163c.87-1.503 2.467-2.496 4.298-2.496a4.949 4.949 0 0 1 4.936 4.59c.02.283.241.493.512.493h.031a3.608 3.608 0 0 1-.004 7.206h-.007z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13.769 12.665l-1.257 1.418V9.862c0-.3-.22-.547-.509-.588H12a.61.61 0 0 0-.512.601v4.205l-1.295-1.416a.511.511 0 0 0-.733-.038.511.511 0 0 0-.033.732l2.143 2.339c.087.14.24.23.413.23H12v.026a.462.462 0 0 0 .354-.166c.086-.1.014 0 .019 0l2.155-2.435a.512.512 0 1 0-.76-.686z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ea},l))};ba.displayName="Contentdownload",ba.defaultProps={height:24,title:null,width:24},ba.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ca=ba,za=["title","width","height"],ya={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ma=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,za);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.242 10.458h-6.885a.443.443 0 0 0 0 .887h6.885a.443.443 0 0 0 0-.887zm0-2.363h-6.885a.443.443 0 0 0 0 .887h6.885a.443.443 0 0 0 0-.887zm0 8.271h-6.885a.443.443 0 0 0 0 .886h6.885a.443.443 0 0 0 0-.886zm0-2.363h-6.885a.443.443 0 0 0 0 .886h6.885a.443.443 0 0 0 0-.886zM10.29 6.982a.555.555 0 0 0-.783 0l-2.99 2.886L5.12 8.184a.556.556 0 0 0-.853.708l1.772 2.152a.559.559 0 0 0 .394.2h.033c.15 0 .286-.06.386-.156l3.426-3.323a.553.553 0 0 0 .012-.783zM8.16 14.78c0-.592-.48-1.072-1.073-1.072h-1.4c-.593 0-1.073.48-1.073 1.072v1.401c0 .592.48 1.072 1.073 1.072h1.4c.593 0 1.073-.48 1.073-1.072v-1.4zm-.886 1.414a.168.168 0 0 1-.168.168H5.67a.167.167 0 0 1-.168-.165v-1.435c0-.093.076-.168.168-.168h1.433c.093 0 .168.076.168.168v1.432h.003z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M21.73 20.706H2.27a1.773 1.773 0 0 1-1.772-1.773V5.535c0-.979.793-1.773 1.772-1.773h19.46c.979 0 1.772.794 1.772 1.773v13.398c0 .979-.793 1.773-1.772 1.773zM2.27 4.952a.591.591 0 0 0-.59.591v13.384c0 .326.264.59.59.59h19.46a.59.59 0 0 0 .59-.59V5.534a.591.591 0 0 0-.59-.59H2.27v.008z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ya},l))};Ma.displayName="Contentexam",Ma.defaultProps={height:24,title:null,width:24},Ma.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ha=Ma,Aa=["title","width","height"],La={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Va=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Aa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{id:"LessonType/contentLive",stroke:"none",strokeWidth:"1",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12,7.4 C13.4359403,7.4 14.6,8.56405965 14.6,10 C14.6,11.1448714 13.8600271,12.1169128 12.8322628,12.4639427 L14.41,16.41 L14.4242641,16.4242641 L14.418,16.43 L16.557086,21.7771656 C16.787869,22.354123 16.1074259,22.8375253 15.6435518,22.4837087 L15.5757359,22.4242641 L12,18.849 L8.42426407,22.4242641 C7.98486638,22.8636618 7.27250991,22.4286573 7.41498976,21.8629146 L7.44291399,21.7771656 L9.581,16.43 L9.57573593,16.4242641 L9.589,16.41 L11.1677372,12.4639427 C10.1399729,12.1169128 9.4,11.1448714 9.4,10 C9.4,8.56405965 10.5640597,7.4 12,7.4 Z M10.504,17.353 L9.643,19.507 L11.151,18 L10.504,17.353 Z M13.495,17.353 L12.849,18 L14.356,19.507 L13.495,17.353 Z M11.999,13.616 L10.99,16.141 L12,17.151 L13.009,16.141 L11.999,13.616 Z M12,1.4 C16.7496488,1.4 20.6,5.25035115 20.6,10 C20.6,12.6324665 19.4090256,15.0707357 17.400494,16.6932315 C17.1427208,16.9014612 16.7649508,16.8612983 16.5567211,16.603525 C16.3484914,16.3457518 16.3886543,15.9679818 16.6464275,15.7597521 C18.3758658,14.3627085 19.4,12.2660094 19.4,10 C19.4,5.91309285 16.0869071,2.6 12,2.6 C7.91309285,2.6 4.6,5.91309285 4.6,10 C4.6,12.2675128 5.62550432,14.3654582 7.35690067,15.7624391 C7.61479357,15.9705205 7.65517374,16.3482674 7.44709228,16.6061603 C7.23901083,16.8640532 6.86126398,16.9044333 6.60337108,16.6963519 C4.59256579,15.0739293 3.4,12.6342147 3.4,10 C3.4,5.25035115 7.25035115,1.4 12,1.4 Z M12,4.4 C15.0927946,4.4 17.6,6.9072054 17.6,10 C17.6,11.4009188 17.082833,12.7228974 16.16488,13.7435632 C15.9432908,13.9899468 15.5639239,14.0100465 15.3175403,13.7884573 C15.0711567,13.5668681 15.051057,13.1875012 15.2726462,12.9411176 C15.9943312,12.138681 16.4,11.1017132 16.4,10 C16.4,7.5699471 14.4300529,5.6 12,5.6 C9.5699471,5.6 7.6,7.5699471 7.6,10 C7.6,11.1053681 8.00838282,12.1455229 8.73439279,12.9489256 C8.9565661,13.1947826 8.93736668,13.5741961 8.69150969,13.7963694 C8.4456527,14.0185427 8.06623917,13.9993433 7.84406586,13.7534863 C6.92062307,12.7316045 6.4,11.4055727 6.4,10 C6.4,6.9072054 8.9072054,4.4 12,4.4 Z M12,8.6 C11.2268014,8.6 10.6,9.22680135 10.6,10 C10.6,10.7731986 11.2268014,11.4 12,11.4 C12.7731986,11.4 13.4,10.7731986 13.4,10 C13.4,9.22680135 12.7731986,8.6 12,8.6 Z",id:"LiveLesson-Icon",fillRule:"nonzero"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:La},l))};Va.displayName="Contentlive",Va.defaultProps={height:24,title:null,width:24},Va.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ra=Va,Sa=["title","width","height"],xa={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Pa=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Sa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M22.494 2.075H1.612c-.732 0-1.371.318-1.371 1.051v16.227c0 .732.647 1.646 1.371 1.646h20.882c.732 0 1.328-.92 1.328-1.646V3.126c0-.732-.595-1.05-1.328-1.05zm.23 17.006a.823.823 0 0 1-.822.823H2.153a.84.84 0 0 1-.823-.822V5.367h21.395V19.08zm0-14.537H1.33v-.976c0-.219.177-.395.395-.395H22.33c.219 0 .396.176.396.395v.976z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M2.556 3.83a.331.331 0 1 1-.663.001.331.331 0 0 1 .663 0zm1.254 0a.331.331 0 1 1-.663.001.331.331 0 0 1 .663 0zm1.256 0a.331.331 0 1 1-.663.001.331.331 0 0 1 .663 0zm.781 14.154h10.028c1.84 0 3.292-1.646 3.292-3.492V8.488c0-.527-.373-.65-.9-.65H5.847c-.527 0-.952.126-.952.65v8.388c0 .526.425 1.108.952 1.108zm10.029-1.097h-.274v-2.194h2.52a2.306 2.306 0 0 1-2.243 2.194h-.003zM6.002 8.933H18.07v4.662h-2.973c-.302 0-.601.055-.601.36v2.932H5.993V8.933h.009z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:xa},l))};Pa.displayName="Contentmultimedia",Pa.defaultProps={height:24,title:null,width:24},Pa.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ba=Pa,Fa=["title","width","height"],Na={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ta=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Fa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.819.192H5.033c-1.402 0-2.342 1.242-2.342 2.643v18.387c0 1.402.96 2.595 2.365 2.595 0 0 10.88 0 10.963-.054a5.553 5.553 0 0 0 5.229-5.54V2.834c0-1.395-1.024-2.643-2.429-2.643v.001zm-3.037 17.28c-.355 0-.586.64-.586.982v4.138H5.036c-.698 0-1.069-.672-1.069-1.366V2.836c0-.698.368-1.363 1.062-1.363h13.789c.698 0 1.149.666 1.149 1.363v14.637h-4.182l-.003-.001zm.666 4.96v-3.68H20c-.352 1.92-1.632 3.405-3.552 3.68z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5.114 8.24v-.006c0-.292.236-.528.528-.528h1.453c1.155 0 1.856.685 1.856 1.674 0 1.123-.874 1.702-1.958 1.702h-.81v.96a.534.534 0 0 1-1.066.002V8.241l-.003-.001zm1.92 1.92a.75.75 0 0 0 .845-.732v-.001c0-.477-.32-.733-.864-.733h-.832v1.482h.845l.006-.016zm2.707-1.92v-.006c0-.292.236-.528.528-.528h1.363c1.523 0 2.56 1.046 2.56 2.41 0 1.363-1.053 2.422-2.56 2.422h-1.366a.527.527 0 0 1-.528-.528V8.24h.003zm1.891 3.35a1.378 1.378 0 0 0 1.459-1.45v.003a1.392 1.392 0 0 0-1.39-1.461l-.072.002h-.822v2.922h.822l.003-.016zm3.523-3.35v-.006c0-.292.236-.528.528-.528H18.4a.484.484 0 0 1 .003.96h-2.181v1.03h1.859a.486.486 0 0 1 .539.48.483.483 0 0 1-.541.48h-1.857v1.408a.534.534 0 0 1-1.066.002V8.24h-.001z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Na},l))};Ta.displayName="Contentpdf",Ta.defaultProps={height:24,title:null,width:24},Ta.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ka=Ta,Za=["title","width","height"],Oa={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Da=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Za);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M23.481 2.649l.001-.036a1.2 1.2 0 0 0-1.16-1.199H1.645c-.676.016-1.22.56-1.238 1.234V2.7c0 .586.425 1.071.983 1.165l.008 13.43c0 .295.363.664.906.664h8.841v1.258l-6.867 2.806a.543.543 0 0 0 .623.885l6.962-2.855 7.21 2.865a.484.484 0 0 0 .27.084c.186 0 .35-.1.441-.246a.544.544 0 0 0-.198-.734l-7.26-2.799v-1.267h9.309c.381 0 .695-.29.732-.662V3.872a1.275 1.275 0 0 0 1.117-1.222l-.002-.001zM2.577 16.774V3.777h18.61v12.997H2.576zM22.321 2.89H1.644a.295.295 0 0 1-.133-.297.294.294 0 0 1 .132-.293h20.678a.295.295 0 0 1 .133.297.294.294 0 0 1-.132.293h-.001z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.135 7.646l-3.13 3.126-2.251-1.837a.53.53 0 0 0-.689.015l-3.907 3.48a.532.532 0 0 0 .706.793l3.57-3.177 2.272 1.856a.528.528 0 0 0 .712-.036l3.48-3.48a.532.532 0 0 0-.763-.737v-.003z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Oa},l))};Da.displayName="Contentpresentation",Da.defaultProps={height:24,title:null,width:24},Da.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ja=Da,Wa=["title","width","height"],Ia={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},_a=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Wa);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.813.192H5.053c-1.402 0-2.349 1.28-2.349 2.672v18.371c0 1.402.96 2.595 2.368 2.595 0 0 10.88 0 10.96-.054a5.552 5.552 0 0 0 5.216-5.539V2.861c0-1.398-1.034-2.669-2.435-2.669zm-3.034 17.28c-.352 0-.611.563-.611.915v3.885H5.04c-.694 0-1.069-.339-1.069-1.034V2.86c0-.694.374-1.392 1.069-1.392H18.8c.694 0 1.155.698 1.155 1.392v14.611h-4.173l-.003.001zm.669 4.97v-3.69H20c-.358 1.92-1.632 3.414-3.552 3.69z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.907 8.95l-2.285 2.317-1.034-1.146a.528.528 0 0 0-.346-.201l-.033-.001a.417.417 0 0 0-.29.116.48.48 0 0 0-.019.704l1.28 1.414a.61.61 0 0 0 .414.195h.042c.12 0 .229-.045.313-.119l2.646-2.636a.558.558 0 0 0 .182-.403v-.014a.44.44 0 0 0-.125-.307.503.503 0 0 0-.745.079v.002z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M8.358 6.122a4.182 4.182 0 1 0 4.182 4.185 4.19 4.19 0 0 0-4.182-4.186v.001zm0 7.494a3.309 3.309 0 1 1 3.322-3.309A3.313 3.313 0 0 1 8.368 13.6h-.01v.016zm8.093-3.254l1.28-1.28a.451.451 0 0 0-.32-.773.451.451 0 0 0-.32.133l-1.28 1.28-1.28-1.28a.451.451 0 0 0-.773.32c0 .125.051.238.133.32l1.28 1.28-1.28 1.28a.442.442 0 0 0 0 .64.447.447 0 0 0 .64.001l1.28-1.28 1.28 1.28a.451.451 0 0 0 .773-.32.451.451 0 0 0-.133-.32l-1.28-1.281z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.84 6.323a4 4 0 1 0 4 4 4.007 4.007 0 0 0-4-4zm0 7.165a3.165 3.165 0 1 1 0-6.33 3.165 3.165 0 0 1 0 6.33z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ia},l))};_a.displayName="Contentquiz",_a.defaultProps={height:24,title:null,width:24},_a.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ua=_a,Ga=["title","width","height"],qa={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ka=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ga);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.563.95a.967.967 0 0 0-1.067-.944H8.648A.967.967 0 0 0 7.585.95H5.348A2.333 2.333 0 0 0 3 3.29l.002.097V21.45c0 1.38.969 2.55 2.33 2.55 0 0 10.544 0 10.627-.053 2.834-.17 5.068-2.54 5.068-5.439V3.382c0-1.38-.963-2.43-2.312-2.43L16.563.95zm-1.44 17.695v4.032H5.35a1.124 1.124 0 0 1-1.1-1.233V3.38a1.076 1.076 0 0 1 1.065-1.172l2.043.001v-.063a1.52 1.52 0 0 0 1.288 1.321l6.856.001c.59 0 .864-.724.864-1.322v.063h2.352c.674 0 1.066.485 1.066 1.17v14.574h-4.008a.712.712 0 0 0-.654.691zm1.242 3.99v-3.422h3.496c-.268 1.81-1.692 3.213-3.474 3.421l-.022.001z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.44 10.26h-4.548a.458.458 0 0 0-.454.461c0 .255.203.461.454.461h4.548a.458.458 0 0 0 .455-.46.458.458 0 0 0-.455-.462zm0 3.994h-4.548a.458.458 0 0 0-.454.46c0 .255.203.462.454.462h4.548a.458.458 0 0 0 .455-.461.458.458 0 0 0-.455-.46zM12.316 7.09a.556.556 0 0 0-.793 0L8.49 10.07 7.084 8.325a.56.56 0 0 0-.434-.204.569.569 0 0 0-.565.573c0 .14.05.27.132.37l1.8 2.207c.098.12.24.197.402.206h.032a.556.556 0 0 0 .385-.172l3.462-3.41a.572.572 0 0 0 .018-.805zm-2.719 5.935H8.132c-.6 0-1.089.494-1.089 1.103v1.484c0 .61.487 1.104 1.089 1.104h1.465c.6 0 1.088-.494 1.088-1.104v-1.484c0-.608-.487-1.103-1.088-1.103zm.179 2.593a.17.17 0 0 1-.17.172h-1.48a.17.17 0 0 1-.17-.172v-1.495a.17.17 0 0 1 .17-.172h1.476a.17.17 0 0 1 .17.172v1.495h.004z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:qa},l))};Ka.displayName="Contentsurvey",Ka.defaultProps={height:24,title:null,width:24},Ka.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Xa=Ka,Ja=["title","width","height"],Qa={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ya=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ja);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.842.192H5.082c-1.402 0-2.323 1.28-2.323 2.691v18.362c0 1.402.96 2.592 2.352 2.592 0 0 10.88 0 10.966-.054a5.558 5.558 0 0 0 5.235-5.546V2.881c0-1.398-1.072-2.688-2.47-2.688V.192zm-2.33 22.259v-3.699h3.52c-.352 1.92-1.6 3.424-3.52 3.699zm3.52-4.979h-4.224c-.352 0-.579.573-.579.925v3.875H5.072c-.694 0-1.043-.32-1.043-1.027V2.88c0-.694.349-1.411 1.043-1.411h13.76c.694 0 1.19.717 1.19 1.411v14.592h.01z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.213 14.272H6.973a.48.48 0 0 0 0 .96h10.24a.48.48 0 0 0 0-.96zm-3.84 2.88h-6.4a.48.48 0 0 0 0 .96h6.4a.48.48 0 0 0 0-.96zM7.872 11.04c0 .506.275.96.797.96a.832.832 0 0 0 .803-.926V6.271h1.84a.779.779 0 0 0 .689-.772L12 5.47v-.009a.79.79 0 0 0-.79-.79l-.047.001H6.26l-.045-.001a.79.79 0 0 0-.79.79v.024c0 .4.302.73.691.773h1.751v4.781l.005.001zm3.542-3.235a.756.756 0 0 0 .199.487l.985 1.206-1.082 1.357a.651.651 0 0 0-.157.426v.016c0 .3.244.544.544.544h.017a.687.687 0 0 0 .519-.317l.84-1.2.851 1.187a.677.677 0 0 0 .559.32h.005a.55.55 0 0 0 .55-.55l-.001-.037a.753.753 0 0 0-.199-.485L13.989 9.48l1.024-1.28a.695.695 0 0 0 .185-.427v-.012c0-.3-.244-.544-.544-.544h-.017a.687.687 0 0 0-.519.317l-.798 1.107-.781-1.104a.677.677 0 0 0-.559-.32h-.018a.55.55 0 0 0-.55.55l.001.04.001-.002z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Qa},l))};Ya.displayName="Contenttext",Ya.defaultProps={height:24,title:null,width:24},Ya.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var $a=Ya,ei=["title","width","height"],ti={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ai=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ei);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.05 17.931H2.057A1.428 1.428 0 0 1 .63 16.517V7.194a1.43 1.43 0 0 1 1.426-1.426H14.05c.789 0 1.427.638 1.429 1.426v9.322a1.428 1.428 0 0 1-1.429 1.415zM2.057 6.876a.33.33 0 0 0-.33.329v9.311a.33.33 0 0 0 .33.33H14.05c.183 0 .33-.148.332-.33V7.194a.332.332 0 0 0-.33-.33H2.058v.012zM22.64 17.849h-.005a.714.714 0 0 1-.274-.054l-.06-.028-5.22-2.926a.72.72 0 0 1-.41-.65V9.489c0-.286.167-.532.41-.647l5.295-2.93a.722.722 0 0 1 .985.672V17.13a.722.722 0 0 1-.722.722l.001-.002zm-4.87-3.883l4.495 2.518V7.22l-4.494 2.504v4.241z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ti},l))};ai.displayName="Contentvideo",ai.defaultProps={height:24,title:null,width:24},ai.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ii=ai,li=["title","width","height"],ri={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},hi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,li);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.105 16.43l2.285 2.285V7.645a.6.6 0 0 1 .186-.44.6.6 0 0 1 .44-.185.617.617 0 0 1 .625.625v11.03l2.265-2.245a.567.567 0 0 1 .44-.196c.175 0 .322.065.439.196.13.117.195.26.195.43a.615.615 0 0 1-.195.448L11.995 21l-3.788-3.692a.89.89 0 0 1-.127-.214.605.605 0 0 1-.049-.235c0-.078.016-.156.049-.234a.597.597 0 0 1 .127-.195c.13-.13.28-.196.449-.196.17 0 .319.065.45.196zM2 4.163c0-.327.12-.603.361-.827.241-.224.537-.336.889-.336h17.5c.352 0 .648.112.889.336.24.224.361.5.361.827v7.674c0 .315-.12.588-.361.818-.241.23-.537.345-.889.345h-5.645v-1.181h4.883a.78.78 0 0 0 .537-.2.632.632 0 0 0 .225-.49V4.87a.66.66 0 0 0-.225-.5.761.761 0 0 0-.537-.208L4.012 4.18a.761.761 0 0 0-.537.209.66.66 0 0 0-.225.5v6.239a.63.63 0 0 0 .225.49c.15.133.328.2.537.2h4.863V13H3.25c-.352 0-.648-.115-.889-.345A1.094 1.094 0 0 1 2 11.837V4.163z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ri},l))};hi.displayName="Datadownload",hi.defaultProps={height:24,title:null,width:24},hi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ni=hi,ci=["title","width","height"],si={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},oi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ci);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.895 7.57L12.61 5.285v11.07a.6.6 0 0 1-.186.44.6.6 0 0 1-.44.185.617.617 0 0 1-.625-.625V5.325L9.095 7.57a.567.567 0 0 1-.44.196.567.567 0 0 1-.439-.196.556.556 0 0 1-.195-.43c0-.169.065-.318.195-.448L12.005 3l3.788 3.692a.89.89 0 0 1 .127.214.605.605 0 0 1 .049.235.605.605 0 0 1-.049.234.597.597 0 0 1-.127.195.618.618 0 0 1-.449.196.618.618 0 0 1-.45-.196zM22 19.837c0 .327-.12.603-.361.827a1.256 1.256 0 0 1-.889.336H3.25c-.352 0-.648-.112-.889-.336-.24-.224-.361-.5-.361-.827v-7.674c0-.315.12-.588.361-.818.241-.23.537-.345.889-.345h5.645v1.181H4.012a.78.78 0 0 0-.537.2.632.632 0 0 0-.225.49v6.258c0 .193.075.36.225.5a.76.76 0 0 0 .537.208l15.976-.018a.76.76 0 0 0 .537-.209.66.66 0 0 0 .225-.5v-6.239a.632.632 0 0 0-.225-.49.78.78 0 0 0-.537-.2h-4.863V11h5.625c.352 0 .648.115.889.345.24.23.361.503.361.818v7.674z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:si},l))};oi.displayName="Dataexport",oi.defaultProps={height:24,title:null,width:24},oi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var di=oi,pi=["title","width","height"],mi={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ui=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,pi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.919 10.577l-2.3-2.289v11.086a.6.6 0 0 1-.187.44.606.606 0 0 1-.442.186.597.597 0 0 1-.452-.186.617.617 0 0 1-.177-.44V8.327l-2.28 2.25a.572.572 0 0 1-.442.195.572.572 0 0 1-.442-.195.556.556 0 0 1-.197-.43c0-.17.066-.32.197-.45L12.01 6l3.813 3.697a.89.89 0 0 1 .128.215.596.596 0 0 1 .049.234.604.604 0 0 1-.05.235.597.597 0 0 1-.127.196.623.623 0 0 1-.452.195.623.623 0 0 1-.452-.195zM2 4.279c0-.36.12-.663.361-.91.241-.246.537-.369.889-.369h17.5c.352 0 .648.123.889.37.24.246.361.55.361.91v8.44c0 .347-.12.647-.361.9s-.537.38-.889.38h-5.645v-1.3h4.883a.74.74 0 0 0 .537-.219.726.726 0 0 0 .225-.54V5.06a.759.759 0 0 0-.225-.55.725.725 0 0 0-.537-.23L4.012 4.3a.725.725 0 0 0-.537.23.759.759 0 0 0-.225.55v6.862c0 .214.075.394.225.54a.74.74 0 0 0 .537.22h4.863V14H3.25a1.18 1.18 0 0 1-.889-.38 1.26 1.26 0 0 1-.361-.9V4.28z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:mi},l))};ui.displayName="Dataimport",ui.defaultProps={height:24,title:null,width:24},ui.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var wi=ui,gi=["title","width","height"],vi={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},fi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,gi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.8 8.8h-1.6V16H7.8v1.6c0 .44.36.8.8.8h8.8l3.2 3.2v-12c0-.44-.36-.8-.8-.8zm-3.2 4.8V6.4c0-.44-.36-.8-.8-.8H5.4c-.44 0-.8.36-.8.8v11.2l3.2-3.2h8c.44 0 .8-.36.8-.8z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:vi},l))};fi.displayName="Discussions",fi.defaultProps={height:24,title:null,width:24},fi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ei=fi,bi=["title","width","height"],Ci={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},zi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,bi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.958 8.375c.028.083.042.208.042.375v10.167c0 .277-.083.527-.25.75-.167.222-.375.333-.625.333H7c-.25 0-.48-.111-.688-.333a1.07 1.07 0 0 1-.312-.75V4.958c0-.25.104-.472.313-.666A.982.982 0 0 1 7 4h6.667c.166 0 .291.028.375.083.166.084.264.14.291.167l3.459 3.833c.083.084.139.18.166.292zm-3.916-2.417v2.625h2.416l-2.416-2.625zM7.333 18.667h9.334v-8.75h-2.792c-.306 0-.576-.118-.813-.354a1.117 1.117 0 0 1-.354-.813V5.333H7.333v13.334z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ci},l))};zi.displayName="Document",zi.defaultProps={height:24,title:null,width:24},zi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var yi=zi,Mi=["title","width","height"],Hi={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ai=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Mi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19 18a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h14zM15 5a1 1 0 0 1 1 1v4h2.67a.5.5 0 0 1 .329.876l-6.67 5.836a.5.5 0 0 1-.658 0L5 10.876A.5.5 0 0 1 5.33 10H8V6a1 1 0 0 1 1-1h6z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Hi},l))};Ai.displayName="Download",Ai.defaultProps={height:24,title:null,width:24},Ai.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Li=Ai,Vi=["title","width","height"],Ri={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Si=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Vi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.18 15c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18 0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5-.453 0-.847-.167-1.18-.5a1.614 1.614 0 0 1-.5-1.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5zm0-5c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18 0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5-.453 0-.847-.167-1.18-.5a1.614 1.614 0 0 1-.5-1.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5zm0-1.64c-.453 0-.847-.167-1.18-.5a1.614 1.614 0 0 1-.5-1.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5.453 0 .847.167 1.18.5.333.333.5.727.5 1.18 0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ri},l))};Si.displayName="Ellipsisv",Si.defaultProps={height:24,title:null,width:24},Si.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var xi=Si,Pi=["title","width","height"],Bi={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Fi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Pi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19 11.254a6.948 6.948 0 0 0-1.5-.794V4.5H15V5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-.5H4.5v16h4.436A7.01 7.01 0 0 0 10.1 22H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3a1 1 0 0 1 1 1v7.254zM8.015 16.548a7.04 7.04 0 0 0 .047 1.384.75.75 0 1 1-.047-1.384zM10.75 8.5h3.5a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5zm-3 1.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 4a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm3.007 7.243a6 6 0 1 1 8.486-8.486 6 6 0 0 1-8.486 8.486zm4.993-4.993v-2.5a.75.75 0 1 0-1.5 0v2.5h-2.5a.75.75 0 1 0 0 1.5h2.5v2.5a.75.75 0 1 0 1.5 0v-2.5h2.5a.75.75 0 1 0 0-1.5h-2.5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Bi},l))};Fi.displayName="Enrollmentadd",Fi.defaultProps={height:24,title:null,width:24},Fi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ni=Fi,Ti=["title","width","height"],ki={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Zi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ti);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19 11.254a6.948 6.948 0 0 0-1.5-.794V4.5H15V5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-.5H4.5v16h4.436A7.01 7.01 0 0 0 10.1 22H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1h3a1 1 0 0 1 1 1v7.254zM8.015 16.548a7.04 7.04 0 0 0 .047 1.384.75.75 0 1 1-.047-1.384zM10.75 8.5h3.5a.75.75 0 1 1 0 1.5h-3.5a.75.75 0 1 1 0-1.5zm-3 1.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm0 4a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm3.007 7.243a6 6 0 1 1 8.486-8.486 6 6 0 0 1-8.486 8.486zm7.493-4.993h-6.5a.75.75 0 1 0 0 1.5h6.5a.75.75 0 1 0 0-1.5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ki},l))};Zi.displayName="Enrollmentremove",Zi.defaultProps={height:24,title:null,width:24},Zi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Oi=Zi,Di=["title","width","height"],ji={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Wi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Di);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 11.18L18.68 7H5.32L12 11.18zM18.68 17V8.68L12 12.82 5.32 8.68V17h13.36zm0-11.68c.453 0 .84.167 1.16.5.32.333.48.727.48 1.18v10c0 .453-.16.847-.48 1.18-.32.333-.707.5-1.16.5H5.32a1.55 1.55 0 0 1-1.16-.5A1.647 1.647 0 0 1 3.68 17V7c0-.453.16-.847.48-1.18.32-.333.707-.5 1.16-.5h13.36z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ji},l))};Wi.displayName="Envelope",Wi.defaultProps={height:24,title:null,width:24},Wi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ii=Wi,_i=["title","width","height"],Ui={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Gi=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,_i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.182 7.339a4.175 4.175 0 0 1 4.174 4.174 4.07 4.07 0 0 1-.3 1.527l2.437 2.438a9.864 9.864 0 0 0 2.863-3.965c-1.444-3.665-5.009-6.26-9.182-6.26a9.72 9.72 0 0 0-3.322.583l1.803 1.803c.475-.192.985-.3 1.527-.3zM3.835 5.06l1.903 1.903.384.384A9.853 9.853 0 0 0 3 11.513c1.444 3.664 5.008 6.26 9.182 6.26a9.83 9.83 0 0 0 3.656-.701l.35.35 2.447 2.438 1.06-1.06L4.895 4l-1.06 1.06zM8.45 9.676l1.294 1.294a2.355 2.355 0 0 0-.067.543 2.5 2.5 0 0 0 2.504 2.504c.184 0 .367-.025.543-.067l1.294 1.294a4.138 4.138 0 0 1-1.837.442 4.175 4.175 0 0 1-4.174-4.173c0-.66.167-1.278.443-1.837zm3.598-.65l2.629 2.629.017-.134a2.5 2.5 0 0 0-2.505-2.504l-.141.008z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ui},l))};Gi.displayName="Eyeslash",Gi.defaultProps={height:24,title:null,width:24},Gi.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var qi=Gi,Ki=["title","width","height"],Xi={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ji=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ki);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 9.5c.44 0 .853.113 1.24.34.387.227.693.533.92.92.227.387.34.8.34 1.24 0 .44-.113.853-.34 1.24a2.536 2.536 0 0 1-.92.92c-.387.227-.8.34-1.24.34a2.41 2.41 0 0 1-1.24-.34 2.536 2.536 0 0 1-.92-.92A2.41 2.41 0 0 1 9.5 12c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92.387-.227.8-.34 1.24-.34zm0 6.68c.76 0 1.46-.187 2.1-.56a4.155 4.155 0 0 0 1.52-1.52c.373-.64.56-1.34.56-2.1s-.187-1.46-.56-2.1a4.155 4.155 0 0 0-1.52-1.52 4.094 4.094 0 0 0-2.1-.56c-.76 0-1.46.187-2.1.56-.64.373-1.147.88-1.52 1.52s-.56 1.34-.56 2.1.187 1.46.56 2.1c.373.64.88 1.147 1.52 1.52s1.34.56 2.1.56zm0-10.44a9.752 9.752 0 0 1 7.09 3A9.785 9.785 0 0 1 21.18 12a9.677 9.677 0 0 1-2.09 3.25A9.817 9.817 0 0 1 12 18.24 9.817 9.817 0 0 1 2.82 12a9.785 9.785 0 0 1 2.09-3.26 9.752 9.752 0 0 1 7.09-3z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Xi},l))};Ji.displayName="Eye",Ji.defaultProps={height:24,title:null,width:24},Ji.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Qi=Ji,Yi=["title","width","height"],$i={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},el=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Yi);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M7 12.82v-1.64h10v1.64H7zM4.5 7h15v1.68h-15V7zm5.82 10v-1.68h3.36V17h-3.36z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:$i},l))};el.displayName="Filter",el.defaultProps={height:24,title:null,width:24},el.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var tl=el,al=["title","width","height"],il={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ll=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,al);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13.507 6.806H18v7.988h-5.626l-.307-1.575H7.574v5.587H6V5.194h7.2z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:il},l))};ll.displayName="Flag",ll.defaultProps={height:24,title:null,width:24},ll.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var rl=ll,hl=["title","width","height"],nl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},cl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,hl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.82 8.125c.443 0 .834.17 1.172.508.339.338.508.729.508 1.172v7.265c0 .443-.17.834-.508 1.172-.338.339-.729.508-1.172.508H4.68c-.443 0-.834-.17-1.172-.508C3.169 17.904 3 17.513 3 17.07V7.93c0-.443.17-.834.508-1.172.338-.339.729-.508 1.172-.508h5.39l1.68 1.875h7.07zm.43 8.945V9.805c0-.287-.143-.43-.43-.43H4.25v7.695c0 .287.143.43.43.43h14.14c.287 0 .43-.143.43-.43z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:nl},l))};cl.displayName="Folder",cl.defaultProps={height:24,title:null,width:24},cl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var sl=cl,ol=["title","width","height"],dl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},pl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ol);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M8.75 17.75V5.25h2.5v12.5h-2.5zm-3.75 0V14h2.5v3.75H5zm7.5 0V11.5H15v6.25h-2.5zm3.75 0V9h2.5v8.75h-2.5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:dl},l))};pl.displayName="Graphbar",pl.defaultProps={height:24,title:null,width:24},pl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ml=pl,ul=["title","width","height"],wl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},gl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ul);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M8.68,7.18 C8.2399978,7.18 7.8266686,7.0666678 7.44,6.84 C7.0533314,6.6133322 6.7466678,6.3066686 6.52,5.92 C6.2933322,5.5333314 6.18,5.1200022 6.18,4.68 C6.18,4.2399978 6.2933322,3.8266686 6.52,3.44 C6.7466678,3.0533314 7.0533314,2.7466678 7.44,2.52 C7.8266686,2.2933322 8.2399978,2.18 8.68,2.18 C9.1200022,2.18 9.5299981,2.2933322 9.91,2.52 C10.2900019,2.7466678 10.5899989,3.0499981 10.81,3.43 C11.0300011,3.8100019 11.14,4.2266644 11.14,4.68 C11.14,5.1333356 11.0300011,5.5499981 10.81,5.93 C10.5899989,6.3100019 10.2900019,6.6133322 9.91,6.84 C9.5299981,7.0666678 9.1200022,7.18 8.68,7.18 Z M8.68,8.82 C9.4000036,8.82 10.193329,8.9266656 11.06,9.14 C12.0333382,9.3933346 12.82,9.719998 13.42,10.12 L13.4846811,10.1650836 C12.2260533,10.4428783 11.0292371,11.071268 10.0502525,12.0502525 C7.94931593,14.1511891 7.46303455,17.2553439 8.59140839,19.8206889 L2.82,19.82 L2.82,11.74 C2.82,11.139997 3.1799964,10.6000024 3.9,10.12 C4.5133364,9.719998 5.3066618,9.3933346 6.28,9.14 C7.1600044,8.9266656 7.9599964,8.82 8.68,8.82 Z M15.32,8.82 C16.04,8.82 16.8399956,8.9266656 17.72,9.14 C18.6933382,9.3933346 19.4866636,9.719998 20.1,10.12 C20.8200036,10.6000024 21.18,11.139997 21.18,11.74 L21.1798527,13.7082856 C20.8621308,13.1123051 20.4520957,12.5526008 19.9497475,12.0502525 C18.7580494,10.8585544 17.2435747,10.1863573 15.6877417,10.0336613 C15.4172492,9.60713196 15.0345505,9.21583511 14.54,8.86 C14.7266676,8.8333332 14.986665,8.82 15.32,8.82 Z M15.32,2.18 C15.7600022,2.18 16.1733314,2.2933322 16.56,2.52 C16.9466686,2.7466678 17.2533322,3.0533314 17.48,3.44 C17.7066678,3.8266686 17.82,4.2399978 17.82,4.68 C17.82,5.1200022 17.7066678,5.5333314 17.48,5.92 C17.2533322,6.3066686 16.9466686,6.6133322 16.56,6.84 C16.1733314,7.0666678 15.7600022,7.18 15.32,7.18 C14.8799978,7.18 14.4666686,7.0666678 14.08,6.84 C13.6933314,6.6133322 13.3866678,6.3066686 13.16,5.92 C12.9333322,5.5333314 12.82,5.1200022 12.82,4.68 C12.82,4.2399978 12.9333322,3.8266686 13.16,3.44 C13.3866678,3.0533314 13.6933314,2.7466678 14.08,2.52 C14.4666686,2.2933322 14.8799978,2.18 15.32,2.18 Z M10.7573593,21.2426407 C8.41421356,18.8994949 8.41421356,15.1005051 10.7573593,12.7573593 C13.1005051,10.4142136 16.8994949,10.4142136 19.2426407,12.7573593 C21.5857864,15.1005051 21.5857864,18.8994949 19.2426407,21.2426407 C16.8994949,23.5857864 13.1005051,23.5857864 10.7573593,21.2426407 Z M15.75,16.25 L15.75,13.75 C15.75,13.3357864 15.4142136,13 15,13 C14.5857864,13 14.25,13.3357864 14.25,13.75 L14.25,16.25 L11.75,16.25 C11.3357864,16.25 11,16.5857864 11,17 C11,17.4142136 11.3357864,17.75 11.75,17.75 L14.25,17.75 L14.25,20.25 C14.25,20.6642136 14.5857864,21 15,21 C15.4142136,21 15.75,20.6642136 15.75,20.25 L15.75,17.75 L18.25,17.75 C18.6642136,17.75 19,17.4142136 19,17 C19,16.5857864 18.6642136,16.25 18.25,16.25 L15.75,16.25 Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:wl},l))};gl.displayName="Groupadd",gl.defaultProps={height:24,title:null,width:24},gl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var vl=gl,fl=["title","width","height"],El={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},bl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,fl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M8.68,7.18 C8.2399978,7.18 7.8266686,7.0666678 7.44,6.84 C7.0533314,6.6133322 6.7466678,6.3066686 6.52,5.92 C6.2933322,5.5333314 6.18,5.1200022 6.18,4.68 C6.18,4.2399978 6.2933322,3.8266686 6.52,3.44 C6.7466678,3.0533314 7.0533314,2.7466678 7.44,2.52 C7.8266686,2.2933322 8.2399978,2.18 8.68,2.18 C9.1200022,2.18 9.5299981,2.2933322 9.91,2.52 C10.2900019,2.7466678 10.5899989,3.0499981 10.81,3.43 C11.0300011,3.8100019 11.14,4.2266644 11.14,4.68 C11.14,5.1333356 11.0300011,5.5499981 10.81,5.93 C10.5899989,6.3100019 10.2900019,6.6133322 9.91,6.84 C9.5299981,7.0666678 9.1200022,7.18 8.68,7.18 Z M19.2426407,12.7573593 C21.5857864,15.1005051 21.5857864,18.8994949 19.2426407,21.2426407 C16.8994949,23.5857864 13.1005051,23.5857864 10.7573593,21.2426407 C8.41421356,18.8994949 8.41421356,15.1005051 10.7573593,12.7573593 C13.1005051,10.4142136 16.8994949,10.4142136 19.2426407,12.7573593 Z M8.68,8.82 C9.4000036,8.82 10.193329,8.9266656 11.06,9.14 C12.0333382,9.3933346 12.82,9.719998 13.42,10.12 L13.4846811,10.1650836 C12.2260533,10.4428783 11.0292371,11.071268 10.0502525,12.0502525 C7.94931593,14.1511891 7.46303455,17.2553439 8.59140839,19.8206889 L2.82,19.82 L2.82,11.74 C2.82,11.139997 3.1799964,10.6000024 3.9,10.12 C4.5133364,9.719998 5.3066618,9.3933346 6.28,9.14 C7.1600044,8.9266656 7.9599964,8.82 8.68,8.82 Z M18.25,16.25 L11.75,16.25 C11.3357864,16.25 11,16.5857864 11,17 C11,17.4142136 11.3357864,17.75 11.75,17.75 L18.25,17.75 C18.6642136,17.75 19,17.4142136 19,17 C19,16.5857864 18.6642136,16.25 18.25,16.25 Z M15.32,8.82 C16.04,8.82 16.8399956,8.9266656 17.72,9.14 C18.6933382,9.3933346 19.4866636,9.719998 20.1,10.12 C20.8200036,10.6000024 21.18,11.139997 21.18,11.74 L21.1798527,13.7082856 C20.8621308,13.1123051 20.4520957,12.5526008 19.9497475,12.0502525 C18.7580494,10.8585544 17.2435747,10.1863573 15.6877417,10.0336613 C15.4172492,9.60713196 15.0345505,9.21583511 14.54,8.86 C14.7266676,8.8333332 14.986665,8.82 15.32,8.82 Z M15.32,2.18 C15.7600022,2.18 16.1733314,2.2933322 16.56,2.52 C16.9466686,2.7466678 17.2533322,3.0533314 17.48,3.44 C17.7066678,3.8266686 17.82,4.2399978 17.82,4.68 C17.82,5.1200022 17.7066678,5.5333314 17.48,5.92 C17.2533322,6.3066686 16.9466686,6.6133322 16.56,6.84 C16.1733314,7.0666678 15.7600022,7.18 15.32,7.18 C14.8799978,7.18 14.4666686,7.0666678 14.08,6.84 C13.6933314,6.6133322 13.3866678,6.3066686 13.16,5.92 C12.9333322,5.5333314 12.82,5.1200022 12.82,4.68 C12.82,4.2399978 12.9333322,3.8266686 13.16,3.44 C13.3866678,3.0533314 13.6933314,2.7466678 14.08,2.52 C14.4666686,2.2933322 14.8799978,2.18 15.32,2.18 Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:El},l))};bl.displayName="Groupremove",bl.defaultProps={height:24,title:null,width:24},bl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Cl=bl,zl=["title","width","height"],yl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ml=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,zl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.35 5h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3A.35.35 0 0 1 9 6.65v-1.3A.35.35 0 0 1 9.35 5zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3A.35.35 0 0 1 9.35 9zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35zm4-12h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35zm0 4h1.3a.35.35 0 0 1 .35.35v1.3a.35.35 0 0 1-.35.35h-1.3a.35.35 0 0 1-.35-.35v-1.3a.35.35 0 0 1 .35-.35z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:yl},l))};Ml.displayName="Handledrag",Ml.defaultProps={height:24,title:null,width:24},Ml.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Hl=Ml,Al=["title","width","height"],Ll={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Vl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Al);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M6 4.5A1.5 1.5 0 0 0 4.5 6v12A1.5 1.5 0 0 0 6 19.5h12a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 18 4.5H6zm0-1h12A2.5 2.5 0 0 1 20.5 6v12a2.5 2.5 0 0 1-2.5 2.5H6A2.5 2.5 0 0 1 3.5 18V6A2.5 2.5 0 0 1 6 3.5z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M6 4h12a2 2 0 0 1 2 2v5H4V6a2 2 0 0 1 2-2z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ll},l))};Vl.displayName="Header",Vl.defaultProps={height:24,title:null,width:24},Vl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Rl=Vl,Sl=["title","width","height"],xl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Pl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Sl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M12.0009939,5.09691001 C12.5647974,4.5618729 13.5865214,3.58080957 13.6442229,3.50171037 C15.2521899,1.8318815 16.7894385,1.42987486 18.2280896,1.50945993 C20.6682594,1.64453105 22.7837856,3.32670095 23.5842235,5.58209714 C24.2836352,7.55306658 24.0969311,9.44901811 23.0521849,11.2518775 C22.8230304,11.6471791 22.5346202,12.0197422 22.2197878,12.3517839 C18.8560059,15.8992957 15.4814415,19.4365071 12.109597,22.9763422 C12.0819119,23.0054942 12.0510212,23.0315367 11.9994396,23.0798319 C11.9417382,23.0252204 11.8836481,22.9749818 11.8308037,22.9195929 C8.92231946,19.8663054 6.00985246,16.8169048 3.10943089,13.7560377 C2.4204132,13.0288887 1.7028362,12.3130117 1.12086736,11.5038483 C0.195798212,10.2175631 -0.126222603,8.73362704 0.0432875996,7.15407232 C0.166461776,6.0059678 0.552692473,4.95027525 1.23792168,4.01896474 C2.22584075,2.67593024 3.53179786,1.82459349 5.19532923,1.58107678 C7.11647724,1.29985677 8.7677689,1.87648412 10.1675638,3.20708041",id:"Like",fill:"#36394D"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:xl},l))};Pl.displayName="Heartfill",Pl.defaultProps={height:24,title:null,width:24},Pl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Bl=Pl,Fl=["title","width","height"],Nl={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Tl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Fl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M11.9885558,19.6512605 C12.037396,19.6089442 12.0631217,19.5901154 12.0848822,19.5673073 C14.871867,16.6365145 17.6691033,13.7153302 20.4409042,10.769979 C21.8255473,9.29871069 21.9509844,7.07603671 20.7990332,5.45743778 C19.4942752,3.62424857 17.0325369,3.39937037 15.4361886,4.9852615 C14.7322131,5.68474237 14.0643116,6.42081326 13.379582,7.1398994 C12.924643,7.61770491 12.4689303,8.09463692 12.0049003,8.58117745 C11.9357504,8.51605304 11.8816877,8.46966038 11.8327508,8.41822083 C11.2816789,7.83938027 10.7336051,7.25772509 10.1804055,6.6809227 C9.55467095,6.02870799 8.9623992,5.33757392 8.2885015,4.73951632 C6.77581006,3.39713808 4.41291272,3.75100339 3.19451961,5.45869951 C2.01684275,7.10913272 2.19779318,9.35102375 3.63282391,10.8629584 C5.90007187,13.2518889 8.16809355,15.64014 10.4365988,18.0280029 C10.9473413,18.5655948 11.461372,19.1000808 11.9885558,19.6512605 M12.0009939,5.09691001 C12.5647974,4.5618729 13.5865214,3.58080957 13.6442229,3.50171037 C15.2521899,1.8318815 16.7894385,1.42987486 18.2280896,1.50945993 C20.6682594,1.64453105 22.7837856,3.32670095 23.5842235,5.58209714 C24.2836352,7.55306658 24.0969311,9.44901811 23.0521849,11.2518775 C22.8230304,11.6471791 22.5346202,12.0197422 22.2197878,12.3517839 C18.8560059,15.8992957 15.4814415,19.4365071 12.109597,22.9763422 C12.0819119,23.0054942 12.0510212,23.0315367 11.9994396,23.0798319 C11.9417382,23.0252204 11.8836481,22.9749818 11.8308037,22.9195929 C8.92231946,19.8663054 6.00985246,16.8169048 3.10943089,13.7560377 C2.4204132,13.0288887 1.7028362,12.3130117 1.12086736,11.5038483 C0.195798212,10.2175631 -0.126222603,8.73362704 0.0432875996,7.15407232 C0.166461776,6.0059678 0.552692473,4.95027525 1.23792168,4.01896474 C2.22584075,2.67593024 3.53179786,1.82459349 5.19532923,1.58107678 C7.11647724,1.29985677 8.7677689,1.87648412 10.1675638,3.20708041",id:"Like",fill:"#36394D"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Nl},l))};Tl.displayName="Heartoutline",Tl.defaultProps={height:24,title:null,width:24},Tl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var kl=Tl,Zl=["title","width","height"],Ol={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Dl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Zl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M4.20046 11.8065C3.91042 11.477 3.93843 10.972 4.26299 10.6788L11.4136 4.21591C11.7382 3.92273 12.2585 3.92888 12.5762 4.22976L19.7512 11.0233C20.0689 11.3242 20.0845 11.8286 19.7857 12.1494L19.6058 12.3429C19.3074 12.6637 18.825 12.702 18.529 12.4281L17.9928 11.9321V19.1938C17.9928 19.6393 17.6433 20 17.2123 20H14.4155C13.9845 20 13.635 19.6393 13.635 19.1938V14.1135H10.0677V19.1938C10.0739 19.639 9.76547 19.9997 9.33446 19.9997H6.37055C5.93954 19.9997 5.59004 19.639 5.59004 19.1935V12.0343C5.59004 12.0343 5.44192 12.1684 5.25922 12.3342C5.07683 12.4998 4.69375 12.3671 4.40371 12.0372L4.20046 11.8065Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ol},l))};Dl.displayName="Home",Dl.defaultProps={height:24,title:null,width:24},Dl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var jl=Dl,Wl=["title","width","height"],Il={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},_l=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Wl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"35.196",cy:"2.959",r:"2.042"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"4.956",cy:"53.044",r:"2.042"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"63.787",cy:"53.044",r:"2.042"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M2.076 43.593a1.31 1.31 0 0 1-1.309-1.074C-2.426 25.537 7.288 8.774 23.611 3.103a1.31 1.31 0 0 1 .864 2.474A32.36 32.36 0 0 0 2.809 36.092c.002 1.993.186 3.983.55 5.943a1.31 1.31 0 0 1-1.047 1.532l-.236.026zm66.136 0h-.236a1.31 1.31 0 0 1-1.047-1.532A32.348 32.348 0 0 0 45.813 5.577a1.31 1.31 0 1 1 .864-2.474 34.992 34.992 0 0 1 23.42 32.989 35.804 35.804 0 0 1-.59 6.427 1.31 1.31 0 0 1-1.295 1.074zM35.144 71.044a34.9 34.9 0 0 1-22.87-8.535 1.31 1.31 0 0 1 1.715-1.977c12.144 10.527 30.179 10.527 42.323 0a1.31 1.31 0 0 1 1.715 1.977 34.927 34.927 0 0 1-22.883 8.535zm12.685-16.782H22.564a1.31 1.31 0 0 1-1.31-1.31V43.79a9.255 9.255 0 0 1 9.243-9.242h9.412a9.255 9.255 0 0 1 9.242 9.242v9.164a1.31 1.31 0 0 1-1.322 1.309zm-23.956-2.618H46.52v-7.855a6.637 6.637 0 0 0-6.624-6.624h-9.412a6.637 6.637 0 0 0-6.611 6.598v7.88zm11.035-22.36a7.501 7.501 0 1 1 7.488-7.5 7.514 7.514 0 0 1-7.488 7.5zm0-12.37a4.883 4.883 0 1 0-.026 9.765 4.883 4.883 0 0 0 .026-9.766z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Il},l))};_l.displayName="Iconcommunities",_l.defaultProps={height:24,title:null,width:24},_l.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ul=_l,Gl=["title","width","height"],ql={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Kl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Gl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.08 13.24L6.18 17h11.64l-3.74-5-2.9 3.74-2.1-2.5zm10.42 4.58c0 .453-.167.847-.5 1.18-.333.333-.727.5-1.18.5H6.18c-.453 0-.847-.167-1.18-.5a1.614 1.614 0 0 1-.5-1.18V6.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5h11.64c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18v11.64z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ql},l))};Kl.displayName="Image",Kl.defaultProps={height:24,title:null,width:24},Kl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Xl=Kl,Jl=["title","width","height"],Ql={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Yl=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Jl);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.532 10.333C11.86 8.392 10.045 7 7.909 7 5.201 7 3 9.242 3 12s2.2 5 4.91 5c2.135 0 3.95-1.392 4.622-3.333h3.559V17h3.273v-3.333H21v-3.334h-8.468zm-4.623 3.334c-.9 0-1.636-.75-1.636-1.667s.736-1.667 1.636-1.667c.9 0 1.636.75 1.636 1.667s-.736 1.667-1.636 1.667z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ql},l))};Yl.displayName="Key",Yl.defaultProps={height:24,title:null,width:24},Yl.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var $l=Yl,er=["title","width","height"],tr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ar=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,er);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.18 7.82c.747 0 1.44.187 2.08.56A4.15 4.15 0 0 1 20.32 12a4.15 4.15 0 0 1-2.06 3.62 4.06 4.06 0 0 1-2.08.56h-3.36v-1.6h3.36a2.5 2.5 0 0 0 1.28-.35c.4-.233.717-.55.95-.95a2.5 2.5 0 0 0 .35-1.28 2.5 2.5 0 0 0-.35-1.28c-.233-.4-.55-.717-.95-.95a2.5 2.5 0 0 0-1.28-.35h-3.36v-1.6h3.36zm-7.5 5v-1.64h6.64v1.64H8.68zM5.24 12c0 .453.117.88.35 1.28.233.4.55.717.95.95.4.233.827.35 1.28.35h3.36v1.6H7.82a4.06 4.06 0 0 1-2.08-.56A4.15 4.15 0 0 1 3.68 12a4.15 4.15 0 0 1 2.06-3.62 4.057 4.057 0 0 1 2.08-.56h3.36v1.6H7.82a2.5 2.5 0 0 0-1.28.35c-.4.233-.717.55-.95.95A2.5 2.5 0 0 0 5.24 12z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:tr},l))};ar.displayName="Link",ar.defaultProps={height:24,title:null,width:24},ar.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ir=ar,lr=["title","width","height"],rr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},hr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,lr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20.75c-1.948 0-7.75-7.296-7.75-11.1 0-4.45 3.285-7.4 7.75-7.4s7.75 2.95 7.75 7.4c0 3.804-5.802 11.1-7.75 11.1zm0-1.5c-.1 0-.008-.046.121-.136a8.57 8.57 0 0 0 .834-.693 22.77 22.77 0 0 0 2.286-2.489c1.855-2.331 3.009-4.623 3.009-6.282 0-3.583-2.58-5.9-6.25-5.9s-6.25 2.317-6.25 5.9c0 1.659 1.154 3.95 3.009 6.282a22.77 22.77 0 0 0 2.286 2.49c.323.297.61.535.834.692.13.09.221.136.121.136z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 13.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5zm0-1.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:rr},l))};hr.displayName="Location",hr.defaultProps={height:24,title:null,width:24},hr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var nr=hr,cr=["title","width","height"],sr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},or=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,cr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.667 9.333h-.762V7.81A3.81 3.81 0 0 0 12.095 4a3.81 3.81 0 0 0-3.81 3.81v1.523h-.761A1.53 1.53 0 0 0 6 10.857v7.62A1.53 1.53 0 0 0 7.524 20h9.143c.838 0 1.523-.686 1.523-1.524v-7.619c0-.838-.685-1.524-1.523-1.524zm-4.572 6.857a1.528 1.528 0 0 1-1.524-1.523c0-.838.686-1.524 1.524-1.524s1.524.686 1.524 1.524-.686 1.523-1.524 1.523zm2.362-6.857H9.733V7.81a2.364 2.364 0 0 1 2.362-2.362 2.364 2.364 0 0 1 2.362 2.362v1.523z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:sr},l))};or.displayName="Lock",or.defaultProps={height:24,title:null,width:24},or.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var dr=or,pr=["title","width","height"],mr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ur=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,pr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.786 17.753l-3.381-3.382a5.82 5.82 0 0 0-.483-7.669A5.774 5.774 0 0 0 10.812 5a5.773 5.773 0 0 0-4.11 1.702A5.773 5.773 0 0 0 5 10.812c0 1.552.605 3.012 1.702 4.11a5.774 5.774 0 0 0 4.11 1.702c1.306 0 2.545-.43 3.56-1.219l3.38 3.381a.728.728 0 0 0 1.034 0 .731.731 0 0 0 0-1.033zm-11.05-3.865a4.323 4.323 0 0 1-1.275-3.076 4.32 4.32 0 0 1 1.275-3.076 4.321 4.321 0 0 1 3.076-1.275c1.162 0 2.255.453 3.077 1.275a4.355 4.355 0 0 1 0 6.152 4.323 4.323 0 0 1-3.077 1.275 4.323 4.323 0 0 1-3.077-1.275z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:mr},l))};ur.displayName="Magnifyingglass",ur.defaultProps={height:24,title:null,width:24},ur.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var wr=ur,gr=["title","width","height"],vr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},fr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,gr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M4.5 7h15v1.68h-15V7zm0 5.82v-1.64h15v1.64h-15zm0 4.18v-1.68h15V17h-15z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:vr},l))};fr.displayName="Menu",fr.defaultProps={height:24,title:null,width:24},fr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Er=fr,br=["title","width","height"],Cr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},zr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,br);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.32 9V7.32h-10V9h10zm0 2.5V9.82h-10v1.68h10zm0 2.5v-1.68h-10V14h10zM19 4c.453 0 .84.16 1.16.48.32.32.48.707.48 1.16v10c0 .453-.16.847-.48 1.18-.32.333-.707.5-1.16.5H7.32L4 20.64v-15c0-.453.16-.84.48-1.16.32-.32.707-.48 1.16-.48H19z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Cr},l))};zr.displayName="Message",zr.defaultProps={height:24,title:null,width:24},zr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var yr=zr,Mr=["title","width","height"],Hr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ar=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Mr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.155 12.996L4.846 13a.783.783 0 0 1-.598-.293 1.131 1.131 0 0 1 0-1.413.783.783 0 0 1 .598-.292h6.309l1.69-.002h6.309c.216 0 .433.098.598.293.33.39.33 1.022 0 1.413a.783.783 0 0 1-.598.292l-6.316-.009-1.683.007z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Hr},l))};Ar.displayName="Minus",Ar.defaultProps={height:24,title:null,width:24},Ar.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Lr=Ar,Vr=["title","width","height"],Rr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Sr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Vr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.458 6.43l-5.228 5.227a.787.787 0 0 0 1.113 1.113l5.226-5.225v1.748a.716.716 0 0 0 1.431 0V5.715A.712.712 0 0 0 18.285 5h-3.579a.716.716 0 0 0 0 1.43h1.752zM19 13.4v-3.328 7.183C19 18.22 18.306 19 17.448 19H6.552C5.695 19 5 18.217 5 17.255V6.745C5 5.78 5.694 5 6.552 5h7.472H10.6a.7.7 0 0 1 0 1.4H6.799c-.223 0-.399.21-.399.467v10.266c0 .253.178.467.399.467H17.2c.223 0 .399-.21.399-.467V13.4a.7.7 0 0 1 1.4 0z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Rr},l))};Sr.displayName="Newwindow",Sr.defaultProps={height:24,title:null,width:24},Sr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var xr=Sr,Pr=["title","width","height"],Br={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Fr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Pr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5.285 16.24V3.897a.687.687 0 0 1 .66-.737h8.863c.303 0 .528.395.528.692v1.746h.985v-1.93c-.008-.75-.58-1.49-1.333-1.49H5.484c-.624 0-1.181.631-1.181 1.256v13.194c.017.72.602 1.296 1.323 1.301h1.826v-.984H6.014a.765.765 0 0 1-.728-.703l-.001-.003z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M18.792 5.919H8.871c-.952 0-1.223.607-1.223 1.144V20.29a1.271 1.271 0 0 0 1.22 1.181h7.362c2.396 0 3.433-1.534 3.433-3.741V7.165c-.002-.535-.107-1.247-.87-1.247h-.001zM16.206 20.49v-2.458a.197.197 0 0 1 .214-.197h2.346c-.008 1.58-.778 2.688-2.56 2.649v.006zm2.58-3.572H16a.788.788 0 0 0-.787.787v2.777H9.017a.469.469 0 0 1-.47-.469V7.411a.512.512 0 0 1 .51-.51h9.296c.185 0 .435.105.435.628v9.374l-.002.016z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.991 13.238c0-.16-.06-.43-.474-.43h-1.575v-1.716a.621.621 0 0 0-.104-.43.38.38 0 0 0-.265-.106h-.02a.346.346 0 0 0-.345.194.808.808 0 0 0-.046.31v-.002 1.752h-1.497c-.319 0-.515.166-.515.43a.441.441 0 0 0 .432.433c.237.005.03 0 1.645 0v1.592c.01.257.067.459.372.459.12 0 .345-.053.345-.467v-1.589h1.575c.29-.037.473-.2.473-.43z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Br},l))};Fr.displayName="Pageduplicate",Fr.defaultProps={height:24,title:null,width:24},Fr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Nr=Fr,Tr=["title","width","height"],kr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Zr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Tr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.873 3.08H6.2c-1.12 0-1.439.715-1.439 1.347v15.561a1.495 1.495 0 0 0 1.437 1.39h8.66c2.82 0 4.038-1.805 4.038-4.402V4.547c-.002-.63-.125-1.467-1.023-1.467h-.001zM14.83 20.226v-2.892a.231.231 0 0 1 .251-.231h2.76c-.009 1.857-.915 3.162-3.011 3.116v.007zm3.035-4.203H14.59a.927.927 0 0 0-.927.927v3.266h-7.29a.552.552 0 0 1-.552-.551V4.837a.603.603 0 0 1 .6-.6h10.935c.218 0 .512.122.512.739v11.027l-.002.02z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.578 11.692c0-.188-.072-.505-.558-.505h-1.853v-2.02a.731.731 0 0 0-.123-.506.447.447 0 0 0-.311-.125h-.024a.408.408 0 0 0-.405.229.95.95 0 0 0-.055.364v-.002 2.062H9.49c-.376 0-.607.195-.607.505.005.28.23.505.509.51.279.005.035 0 1.935 0v1.872c.012.303.079.54.438.54.141 0 .405-.062.405-.549v-1.869h1.854c.34-.044.556-.236.556-.505v-.001z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:kr},l))};Zr.displayName="Pagenew",Zr.defaultProps={height:24,title:null,width:24},Zr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Or=Zr,Dr=["title","width","height"],jr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Wr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Dr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.873 3.08H6.2c-1.12 0-1.439.715-1.439 1.347v15.561a1.495 1.495 0 0 0 1.437 1.39h8.66c2.82 0 4.038-1.805 4.038-4.402V4.547c-.002-.63-.125-1.467-1.023-1.467h-.001zM14.83 20.226v-2.892a.231.231 0 0 1 .251-.231h2.76c-.009 1.857-.915 3.162-3.011 3.116v.007zm3.035-4.203H14.59a.927.927 0 0 0-.927.927v3.266h-7.29a.552.552 0 0 1-.552-.551V4.837a.603.603 0 0 1 .6-.6h10.935c.218 0 .512.122.512.739v11.027l-.002.02z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:jr},l))};Wr.displayName="Page",Wr.defaultProps={height:24,title:null,width:24},Wr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ir=Wr,_r=["title","width","height"],Ur={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Gr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,_r);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.26 7.86l-1.52 1.52-3.12-3.12 1.52-1.52c.16-.16.357-.24.59-.24.233 0 .43.08.59.24l1.94 1.94c.16.16.24.357.24.59 0 .233-.08.43-.24.59zM4.5 16.38l9.22-9.22 3.12 3.12-9.22 9.22H4.5v-3.12z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ur},l))};Gr.displayName="Pencil",Gr.defaultProps={height:24,title:null,width:24},Gr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var qr=Gr,Kr=["title","width","height"],Xr={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Jr=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Kr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.32 12.82c.72 0 1.52.107 2.4.32.973.253 1.767.58 2.38.98.72.48 1.08 1.02 1.08 1.62v2.08h-5v-2.08c0-1.133-.547-2.093-1.64-2.88.187-.027.447-.04.78-.04zm-6.64 0c.72 0 1.513.107 2.38.32.973.253 1.76.58 2.36.98.72.48 1.08 1.02 1.08 1.62v2.08H2.82v-2.08c0-.6.36-1.14 1.08-1.62.613-.4 1.407-.727 2.38-.98.88-.213 1.68-.32 2.4-.32zm0-1.64a2.41 2.41 0 0 1-1.24-.34 2.536 2.536 0 0 1-.92-.92 2.41 2.41 0 0 1-.34-1.24c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92a2.412 2.412 0 0 1 2.47 0c.38.227.68.53.9.91.22.38.33.797.33 1.25 0 .453-.11.87-.33 1.25-.22.38-.52.683-.9.91-.38.227-.79.34-1.23.34zm6.64 0a2.41 2.41 0 0 1-1.24-.34 2.536 2.536 0 0 1-.92-.92 2.41 2.41 0 0 1-.34-1.24c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92.387-.227.8-.34 1.24-.34.44 0 .853.113 1.24.34.387.227.693.533.92.92.227.387.34.8.34 1.24 0 .44-.113.853-.34 1.24a2.536 2.536 0 0 1-.92.92c-.387.227-.8.34-1.24.34z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Xr},l))};Jr.displayName="People",Jr.defaultProps={height:24,title:null,width:24},Jr.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Qr=Jr,Yr=["title","width","height"],$r={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},eh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Yr);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13.61 17.42c.338-.512.487-1.074.43-1.56-.043-.355-.046-.846.158-1.14l3.096-4.457c.204-.294.381-.521.395-.507l.026.025c.393.393 1.07.389 1.68.041.312-.176.309-.598.055-.851l-4.786-4.786c-.253-.253-.675-.257-.851.054-.347.612-.352 1.288.042 1.682l.025.025c.014.014-.213.191-.508.395L8.916 9.437c-.295.204-.785.202-1.14.16-.487-.059-1.048.09-1.56.428-.3.197-.296.616-.043.869L9.01 13.73l-3.15 3.15.006.008c-1.262 1.33-2.062 2.522-1.824 2.76.238.238 1.43-.562 2.76-1.825l.007.007 3.151-3.15 2.781 2.781c.254.253.672.257.87-.043z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:$r},l))};eh.displayName="Pin",eh.defaultProps={height:24,title:null,width:24},eh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var th=eh,ah=["title","width","height"],ih={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},lh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ah);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M12.404 12.512l-6.435.633-1.693 5.5a.861.861 0 0 0 .252.903.83.83 0 0 0 .917.12l14.102-6.935a.816.816 0 0 0 .45-.733.816.816 0 0 0-.45-.732L5.455 4.327a.83.83 0 0 0-.917.12.861.861 0 0 0-.252.902l1.693 5.5 6.422.633a.51.51 0 0 1 .457.512.512.512 0 0 1-.457.513l.003.005z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ih},l))};lh.displayName="Plane",lh.defaultProps={height:24,title:null,width:24},lh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var rh=lh,hh=["title","width","height"],nh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ch=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,hh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M8.68 6.18L17.82 12l-9.14 5.82z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:nh},l))};ch.displayName="Play",ch.defaultProps={height:24,title:null,width:24},ch.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var sh=ch,oh=["title","width","height"],dh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ph=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,oh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13 11h5a1 1 0 0 1 0 2h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:dh},l))};ph.displayName="Plus",ph.defaultProps={height:24,title:null,width:24},ph.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var mh=ph,uh=["title","width","height"],wh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},gh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,uh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:wh},l))};gh.displayName="Radioempty",gh.defaultProps={height:24,title:null,width:24},gh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var vh=gh,fh=["title","width","height"],Eh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},bh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,fh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"12",cy:"12",r:"4.8"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1a7 7 0 1 0 0-14 7 7 0 0 0 0 14z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Eh},l))};bh.displayName="Radioselected",bh.defaultProps={height:24,title:null,width:24},bh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ch=bh,zh=["title","width","height"],yh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Mh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,zh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:yh},l))};Mh.displayName="Record",Mh.defaultProps={height:24,title:null,width:24},Mh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Hh=Mh,Ah=["title","width","height"],Lh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Vh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ah);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.75 14.0002V12.0002C16.75 11.332 17.5579 10.9974 18.0303 11.4699L21.0303 14.4699C21.3232 14.7628 21.3232 15.2377 21.0303 15.5305L18.0303 18.5305C17.5579 19.003 16.75 18.6684 16.75 18.0002V16.0002H12.0217C11.6474 16.0081 11.2841 15.8045 11.1056 15.4474L6.38197 8.00022H3C2.44772 8.00022 2 7.5525 2 7.00022C2 6.44793 2.44772 6.00022 3 6.00022H6.97834C7.35258 5.99237 7.7159 6.19595 7.89443 6.55301L12.618 14.0002H16.75Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M10.7324 6H21.0003C21.5526 6 22.0003 6.44772 22.0003 7C22.0003 7.55228 21.5526 8 21.0003 8H11.7364L10.7892 6.10557C10.7712 6.0696 10.7522 6.0344 10.7324 6Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Lh},l))};Vh.displayName="Redirect",Vh.defaultProps={height:24,title:null,width:24},Vh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Rh=Vh,Sh=["title","width","height"],xh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ph=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Sh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M14.907 15.717a.804.804 0 0 1 1.114.196.787.787 0 0 1-.196 1.103 6.663 6.663 0 0 1-3.812 1.199 6.86 6.86 0 0 1-.665-.037c-.045-.004-.089-.012-.134-.017-.123-.015-.247-.027-.37-.049-.037-.006-.072-.016-.109-.023-.088-.018-.175-.04-.262-.06a4.448 4.448 0 0 1-.596-.168 6.249 6.249 0 0 1-.43-.155l-.123-.055a6.35 6.35 0 0 1-.485-.232l-.044-.025a6.542 6.542 0 0 1-1.498-1.113l-.037-.038a6.897 6.897 0 0 1-.384-.418c-.032-.038-.06-.079-.092-.118-.082-.103-.167-.203-.244-.313-.01-.014-.017-.03-.026-.045a6.521 6.521 0 0 1-1.18-3.744H4l2.133-3.171 2.134 3.17H6.933c0 1.183.418 2.27 1.111 3.13l.06.074c.096.115.197.225.302.33l.017.018c.34.337.728.625 1.152.855l.017.01c.126.067.255.127.386.184a4.787 4.787 0 0 0 .419.158c.048.016.095.034.143.048.1.03.203.054.306.077.063.016.126.031.19.044.107.02.214.035.321.048.056.008.113.017.168.022.137.012.276.018.415.02a5.056 5.056 0 0 0 2.967-.905zm3.76-4.112H20l-2.133 3.17-2.134-3.17h1.334a4.977 4.977 0 0 0-1.15-3.18l-.01-.012a5.083 5.083 0 0 0-1.91-1.42 4.949 4.949 0 0 0-.418-.155c-.036-.01-.071-.024-.106-.034a4.93 4.93 0 0 0-.344-.088c-.051-.011-.102-.025-.154-.035a4.893 4.893 0 0 0-.358-.054l-.134-.017a5.058 5.058 0 0 0-3.388.883.804.804 0 0 1-1.114-.194.788.788 0 0 1 .196-1.104 6.653 6.653 0 0 1 3.806-1.193L12.001 5c.031 0 .062.004.094.005.176.002.352.01.53.026.073.007.145.019.217.028.107.013.212.021.317.04.039.006.076.018.115.025.079.015.156.035.234.053.142.033.281.066.42.107.057.017.113.037.17.057.16.051.316.107.47.17l.08.035A6.594 6.594 0 0 1 17.136 7.4c.013.014.023.03.035.044.1.122.2.244.291.373.013.018.02.036.03.054a6.527 6.527 0 0 1 1.176 3.735z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:xh},l))};Ph.displayName="Refresh",Ph.defaultProps={height:24,title:null,width:24},Ph.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Bh=Ph,Fh=["title","width","height"],Nh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Th=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Fh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.875 9.669V5.333a.334.334 0 0 0-.193-.308.299.299 0 0 0-.34.072l-6.25 6.667a.35.35 0 0 0 0 .471l6.25 6.667a.303.303 0 0 0 .34.073.334.334 0 0 0 .193-.308v-4.322c1.354.072 6.636.558 7.513 3.749a.31.31 0 0 0 .344.236A.327.327 0 0 0 20 18c0-7.647-6.661-8.284-8.125-8.331z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Nh},l))};Th.displayName="Reply",Th.defaultProps={height:24,title:null,width:24},Th.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var kh=Th,Zh=["title","width","height"],Oh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Dh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Zh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.359 1.333c.203 0 .338.141.338.353v1.101h5.477c.205 0 .341.14.341.348v19.22c0 .173-.17.312-.34.312H2.006c-.204 0-.34-.14-.34-.347V3.135c0-.208.136-.347.34-.347H7.97V1.685c0-.212.135-.353.338-.353h8.05zm-8.39 2.148h-5.62v18.527H21.8V3.482h-5.103v1.413c0 .176-.17.317-.338.317H8.308c-.203 0-.338-.14-.338-.352V3.48zM19.017 16.5c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM8.25 9.75v3.75H12a3.75 3.75 0 1 1-3.75-3.75zm10.766 4.5c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zm0-2.25c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM9 9a3.75 3.75 0 0 1 3.75 3.75H9zm10.016.75c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM16.02 2.039H8.646v2.468h7.374V2.039z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Oh},l))};Dh.displayName="Report",Dh.defaultProps={height:24,title:null,width:24},Dh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var jh=Dh,Wh=["title","width","height"],Ih={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},_h=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Wh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{stroke:"none",strokeWidth:"1",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.5,5 C16.0396852,5 16.5079345,5.19841071 16.9047619,5.5952381 C17.3015893,5.99206548 17.5,6.46031476 17.5,7 C17.5,7.53968524 17.3015893,8.00793452 16.9047619,8.4047619 C16.5079345,8.80158929 16.0396852,9 15.5,9 C14.9958496,9 14.5540376,8.82685726 14.1745527,8.48056693 L8.95340504,11.5637869 C8.98446839,11.7035995 9,11.8490037 9,12 C9,12.1611109 8.98231791,12.3158554 8.94695357,12.4642341 L14.17,15.525 L14.2301592,15.4703111 C14.5970028,15.156769 15.0202798,15 15.5,15 C16.0396852,15 16.5079345,15.1984107 16.9047619,15.5952381 C17.3015893,15.9920655 17.5,16.4603148 17.5,17 C17.5,17.5396852 17.3015893,18.0079345 16.9047619,18.4047619 C16.5079345,18.8015893 16.0396852,19 15.5,19 C14.9603148,19 14.4920655,18.8015893 14.0952381,18.4047619 C13.6984107,18.0079345 13.5,17.5396852 13.5,17 C13.5,16.8450301 13.5163598,16.6959505 13.5490796,16.5527607 L8.315,13.486 L8.26984084,13.5296889 C7.9029972,13.843231 7.47972021,14 7,14 C6.46031476,14 5.99206548,13.8015893 5.5952381,13.4047619 C5.19841071,13.0079345 5,12.5396852 5,12 C5,11.4603148 5.19841071,10.9920655 5.5952381,10.5952381 C5.99206548,10.1984107 6.46031476,10 7,10 C7.50992482,10 7.95607499,10.1771317 8.33846236,10.5314002 L13.5506943,7.45424388 C13.5168981,7.30891301 13.5,7.1574985 13.5,7 C13.5,6.46031476 13.6984107,5.99206548 14.0952381,5.5952381 C14.4920655,5.19841071 14.9603148,5 15.5,5 Z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ih},l))};_h.displayName="Share",_h.defaultProps={height:24,title:null,width:24},_h.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Uh=_h,Gh=["title","width","height"],qh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Kh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Gh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 2.82l7.5 3.36v5c0 1.52-.327 2.987-.98 4.4a10.849 10.849 0 0 1-2.66 3.56c-1.16 1.013-2.447 1.693-3.86 2.04-1.413-.347-2.7-1.027-3.86-2.04a10.849 10.849 0 0 1-2.66-3.56 10.372 10.372 0 0 1-.98-4.4v-5L12 2.82zM12 12v7.46a7.576 7.576 0 0 0 2.77-1.59 9.188 9.188 0 0 0 2.05-2.64 9.247 9.247 0 0 0 1-3.23H12zm0 0V4.66L6.18 7.24V12H12z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:qh},l))};Kh.displayName="Shield",Kh.defaultProps={height:24,title:null,width:24},Kh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Xh=Kh,Jh=["title","width","height"],Qh={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Yh=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Jh);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12 3c4.95 0 9 4.05 9 9s-4.05 9-9 9-9-4.05-9-9 4.05-9 9-9zm0 1.059c-4.368 0-7.941 3.573-7.941 7.941S7.632 19.941 12 19.941s7.941-3.573 7.941-7.941S16.368 4.059 12 4.059zM8.453 14.806a.512.512 0 0 1 .741 0c1.535 1.535 4.077 1.535 5.612 0a.512.512 0 0 1 .741 0 .512.512 0 0 1 0 .741A4.992 4.992 0 0 1 12 17.03a4.992 4.992 0 0 1-3.547-1.482.512.512 0 0 1 0-.741zm.9-6.247a1.324 1.324 0 1 1 0 2.647 1.324 1.324 0 0 1 0-2.647zm5.294 0a1.324 1.324 0 1 1 0 2.647 1.324 1.324 0 0 1 0-2.647z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Qh},l))};Yh.displayName="Smileyface",Yh.defaultProps={height:24,title:null,width:24},Yh.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var $h=Yh,en=["title","width","height"],tn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},an=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,en);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M10.397 20v-7.156H8V10h2.397V7.76c0-2.435 1.487-3.76 3.66-3.76 1.04 0 1.934.078 2.193.112v2.544h-1.506c-1.181 0-1.41.563-1.41 1.385V10H16l-.366 2.844h-2.3V20",fill:"#3B5998"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:tn},l))};an.displayName="Socialfacebook",an.defaultProps={height:24,title:null,width:24},an.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ln=an,rn=["title","width","height"],hn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},nn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,rn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12,6.48 C13.69,6.48 14.83,7.21 15.48,7.82 L18.02,5.34 C16.46,3.89 14.43,3 12,3 C8.48,3 5.44,5.02 3.96,7.96 L6.87,10.22 C7.6,8.05 9.62,6.48 12,6.48 L12,6.48 Z",fill:"#EA4335"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.64,12.2 C20.64,11.46 20.58,10.92 20.45,10.36 L12,10.36 L12,13.7 L16.96,13.7 C16.86,14.53 16.32,15.78 15.12,16.62 L17.96,18.82 C19.66,17.25 20.64,14.94 20.64,12.2 L20.64,12.2 Z",fill:"#4285F4"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M6.88,13.78 C6.69,13.22 6.58,12.62 6.58,12 C6.58,11.38 6.69,10.78 6.87,10.22 L3.96,7.96 C3.35,9.18 3,10.55 3,12 C3,13.45 3.35,14.82 3.96,16.04 L6.88,13.78 L6.88,13.78 Z",fill:"#FBBC05"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12,21 C14.43,21 16.47,20.2 17.96,18.82 L15.12,16.62 C14.36,17.15 13.34,17.52 12,17.52 C9.62,17.52 7.6,15.95 6.88,13.78 L3.97,16.04 C5.45,18.98 8.48,21 12,21 L12,21 Z",fill:"#34A853"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:hn},l))};nn.displayName="Socialgooglecolorized",nn.defaultProps={height:24,title:null,width:24},nn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var cn=nn,sn=["title","width","height"],on={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},dn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,sn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.4966094,10.71075 C20.5825781,11.1650625 20.6439375,11.619375 20.6439375,12.2086875 C20.6439375,17.3533594 17.1937031,21 12,21 C7.0273125,21 3,16.9727344 3,12 C3,7.02726563 7.0273125,3 12,3 C14.431125,3 16.4570156,3.88401563 18.0286406,5.3574375 L15.5852344,7.70259375 C14.9221875,7.06410938 13.7557969,6.31514063 12,6.31514063 C8.9304375,6.31514063 6.425625,8.85675 6.425625,12 C6.425625,15.14325 8.9304375,17.6848594 12,17.6848594 C15.5606719,17.6848594 16.8990469,15.1186875 17.1077344,13.804875 L12,13.804875 L12,10.7107031 L20.4966094,10.7107031 L20.4966094,10.71075 Z",fill:"#12131A"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:on},l))};dn.displayName="Socialgoogle",dn.defaultProps={height:24,title:null,width:24},dn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var pn=dn,mn=["title","width","height"],un={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},wn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,mn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M7.582 20H4.264V9.318h3.318V20zM5.922 7.86A1.936 1.936 0 0 1 4 5.922a1.922 1.922 0 0 1 3.843 0c0 1.061-.86 1.94-1.922 1.94zM20 20h-3.31v-5.2c0-1.24-.026-2.829-1.726-2.829-1.725 0-1.989 1.347-1.989 2.74V20H9.661V9.318h3.182v1.457h.046c.443-.84 1.525-1.725 3.14-1.725 3.357 0 3.975 2.21 3.975 5.082V20H20z",fill:"#0077B5"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:un},l))};wn.displayName="SociallinkedIn",wn.defaultProps={height:24,title:null,width:24},wn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var gn=wn,vn=["title","width","height"],fn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},En=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,vn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.948 6.62a6.435 6.435 0 0 1-1.858.51 3.24 3.24 0 0 0 1.422-1.79 6.486 6.486 0 0 1-2.053.786 3.234 3.234 0 0 0-5.51 2.95 9.183 9.183 0 0 1-6.668-3.38 3.232 3.232 0 0 0 1.001 4.318 3.225 3.225 0 0 1-1.465-.404v.04a3.237 3.237 0 0 0 2.595 3.172 3.252 3.252 0 0 1-1.461.055 3.238 3.238 0 0 0 3.02 2.246 6.488 6.488 0 0 1-4.787 1.34 9.152 9.152 0 0 0 4.957 1.452c5.95 0 9.202-4.928 9.202-9.202 0-.14-.003-.28-.009-.419a6.55 6.55 0 0 0 1.614-1.673z",fill:"#00ACED"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:fn},l))};En.displayName="Socialtwitter",En.defaultProps={height:24,title:null,width:24},En.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var bn=En,Cn=["title","width","height"],zn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},yn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Cn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.256 6.05a.666.666 0 0 1 .411.616v10.667a.666.666 0 0 1-1.138.472l-2.862-3.138h-2A.669.669 0 0 1 6 14v-4c0-.367.3-.667.667-.667h2l2.862-3.137a.665.665 0 0 1 .727-.145zM15 9a3.066 3.066 0 0 1 3.063 3.063A3.066 3.066 0 0 1 15 15.125v-2.042a1.022 1.022 0 0 0 0-2.041V9z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:zn},l))};yn.displayName="Speaker",yn.defaultProps={height:24,title:null,width:24},yn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Mn=yn,Hn=["title","width","height"],An={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ln=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Hn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.46 9.888a.538.538 0 0 0-.44-.343l-5.238-.594-2.455-4.531a.582.582 0 0 0-.476-.313h-.015a.57.57 0 0 0-.477.335L9.142 9.064l-5.184.873a.536.536 0 0 0-.45.52c0 .152.066.29.173.386L7.55 14.29l-.755 5.022a.533.533 0 0 0 .537.597.554.554 0 0 0 .267-.068l4.594-2.477 4.726 2.244a.55.55 0 0 0 .237.052c.3 0 .543-.234.543-.522a.483.483 0 0 0-.01-.101l-1.026-4.976 3.676-3.627a.509.509 0 0 0 .121-.55v.005z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:An},l))};Ln.displayName="Starfill",Ln.defaultProps={height:24,title:null,width:24},Ln.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Vn=Ln,Rn=["title","width","height"],Sn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},xn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Rn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M20.494 9.867a.54.54 0 0 0-.44-.344L14.8 8.926 12.33 4.41a.55.55 0 0 0-.48-.281h-.016a.538.538 0 0 0-.48.304L9.139 9.057l-5.21.866a.532.532 0 0 0-.452.517c0 .152.067.29.174.385l3.882 3.461-.758 5.039a.535.535 0 0 0 .54.594.558.558 0 0 0 .259-.063l4.62-2.486 4.745 2.253c.07.034.153.054.241.054a.535.535 0 0 0 .545-.525.531.531 0 0 0-.013-.115l-1.03-4.982 3.689-3.648a.512.512 0 0 0 .123-.544v.004zm-4.792 3.654a.513.513 0 0 0-.144.471l.873 4.22-4.012-1.905a.555.555 0 0 0-.507.015l-3.899 2.102.64-4.267a.513.513 0 0 0-.172-.45l-3.284-2.929 4.407-.732a.544.544 0 0 0 .401-.293l1.876-3.914 2.084 3.815a.55.55 0 0 0 .414.277l4.434.508-3.111 3.082z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Sn},l))};xn.displayName="Staroutline",xn.defaultProps={height:24,title:null,width:24},xn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Pn=xn,Bn=["title","width","height"],Fn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Nn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Bn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.75 12.5V9a.75.75 0 1 0-1.5 0v3.5a.75.75 0 1 0 1.5 0zm0 3a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0zM4 14.586V9.414a1 1 0 0 1 .293-.707l4.414-4.414A1 1 0 0 1 9.414 4h5.172a1 1 0 0 1 .707.293l4.414 4.414a1 1 0 0 1 .293.707v5.172a1 1 0 0 1-.293.707l-4.414 4.414a1 1 0 0 1-.707.293H9.414a1 1 0 0 1-.707-.293l-4.414-4.414A1 1 0 0 1 4 14.586z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Fn},l))};Nn.displayName="Stopsign",Nn.defaultProps={height:24,title:null,width:24},Nn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Tn=Nn,kn=["title","width","height"],Zn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},On=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,kn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",clipRule:"evenodd",d:"M18.0156 4.77123H19.5745L19.5707 4.77138C19.5973 4.77043 19.6241 4.76995 19.6509 4.76995C20.9227 4.76995 21.954 5.84505 21.9561 7.17231V14.8227C21.9561 18.0978 19.412 20.9667 16.267 20.9693H6.63015C4.78307 20.9693 3 19.2007 3 17.2726V7.17228C3 5.79951 4.35453 4.77123 5.67705 4.77123H6.93307V3.64268C6.93307 3.28775 7.20874 3 7.54877 3C7.8888 3 8.16446 3.28775 8.16446 3.64268V4.77123H16.7842V3.64268C16.7842 3.28775 17.0599 3 17.3999 3C17.7399 3 18.0156 3.28775 18.0156 3.64268V4.77123ZM5.66967 5.54244C4.74365 5.54244 3.73145 6.20571 3.73145 7.17228V8.6273H21.2172V7.17228C21.2172 6.20312 20.5005 5.54244 19.5745 5.54244H18.0156V5.96661C18.0156 6.32154 17.7399 6.60929 17.3999 6.60929C17.0599 6.60929 16.7842 6.32154 16.7842 5.96661V5.54244H8.16446V5.96661C8.16446 6.32154 7.8888 6.60929 7.54877 6.60929C7.20874 6.60929 6.93307 6.32154 6.93307 5.96661V5.54244H5.66967ZM17.4984 16.0824L17.523 20.0258L17.5588 20.0078C19.3263 19.4549 20.7128 17.9821 21.2172 16.0824H17.4984ZM17.1191 15.4126H21.2172V9.49999H3.73141V17.3715C3.73141 18.8882 5.17214 20.297 6.62273 20.297L16.2755 20.2967C16.4583 20.2898 16.6385 20.2723 16.7899 20.2523C16.7807 20.2115 16.7754 20.169 16.7744 20.1248L16.7497 15.7545C16.7502 15.653 16.7917 15.5617 16.8576 15.4979C16.9183 15.4436 16.9973 15.4107 17.0835 15.4107C17.0961 15.4107 17.1085 15.4114 17.1191 15.4126Z",fill:"#36394D"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Zn},l))};On.displayName="Systemcalendar",On.defaultProps={height:24,title:null,width:24},On.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Dn=On,jn=["title","width","height"],Wn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},In=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,jn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M10 9.938v5.624c0 .092-.03.167-.088.225a.304.304 0 0 1-.225.088h-.624a.304.304 0 0 1-.225-.088.304.304 0 0 1-.088-.225V9.939c0-.092.03-.167.088-.225a.304.304 0 0 1 .225-.088h.624c.092 0 .167.03.225.088a.304.304 0 0 1 .088.225zm2.5 0v5.624c0 .092-.03.167-.088.225a.304.304 0 0 1-.225.088h-.624a.304.304 0 0 1-.225-.088.304.304 0 0 1-.088-.225V9.939c0-.092.03-.167.088-.225a.304.304 0 0 1 .225-.088h.624c.092 0 .167.03.225.088a.304.304 0 0 1 .088.225zm2.5 0v5.624c0 .092-.03.167-.088.225a.304.304 0 0 1-.225.088h-.624a.304.304 0 0 1-.225-.088.304.304 0 0 1-.088-.225V9.939c0-.092.03-.167.088-.225a.304.304 0 0 1 .225-.088h.624c.092 0 .167.03.225.088a.304.304 0 0 1 .088.225zm1.25 7.07V7.75H7.5v9.258a1.109 1.109 0 0 0 .21.659c.049.055.083.083.103.083h8.125c.019 0 .053-.028.102-.083a1.109 1.109 0 0 0 .21-.66zM9.687 6.5h4.376l-.47-1.143a.276.276 0 0 0-.165-.107h-3.096a.276.276 0 0 0-.166.107L9.687 6.5zm9.063.313v.625c0 .09-.03.166-.088.224a.304.304 0 0 1-.224.088H17.5v9.258c0 .54-.153 1.007-.459 1.401-.306.394-.674.591-1.104.591H7.813c-.43 0-.798-.19-1.104-.571-.306-.381-.459-.842-.459-1.382V7.75h-.938a.304.304 0 0 1-.224-.088A.304.304 0 0 1 5 7.438v-.625c0-.092.03-.167.088-.225a.304.304 0 0 1 .224-.088H8.33l.684-1.63c.097-.242.273-.447.527-.616.254-.17.511-.254.771-.254h3.126c.26 0 .517.085.771.254.254.17.43.374.527.615L15.42 6.5h3.018c.09 0 .166.03.224.088a.304.304 0 0 1 .088.224z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Wn},l))};In.displayName="Trashcan",In.defaultProps={height:24,title:null,width:24},In.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var _n=In,Un=["title","width","height"],Gn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},qn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Un);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.375 20.375h-8.79a.6.6 0 0 0-.439.186.6.6 0 0 0-.185.439.6.6 0 0 0 .185.44.6.6 0 0 0 .44.185h8.789a.6.6 0 0 0 .44-.186A.6.6 0 0 0 17 21a.6.6 0 0 0-.186-.44.6.6 0 0 0-.439-.185zm5.488-15.742c.013.039.04.488.078 1.347.04.86-.247 1.667-.859 2.422-.352.43-.8.759-1.348.987-.547.228-1.185.348-1.914.361a6.642 6.642 0 0 1-.81 1.64 6.562 6.562 0 0 1-1.201 1.339 6.198 6.198 0 0 1-1.504.937 5.81 5.81 0 0 1-1.739.459v4.355H14.5a.6.6 0 0 1 .44.186.6.6 0 0 1 .185.44.6.6 0 0 1-.186.439.6.6 0 0 1-.439.185H9.46a.617.617 0 0 1-.625-.625.617.617 0 0 1 .626-.625h1.855v-4.355a5.79 5.79 0 0 1-1.718-.459 6.198 6.198 0 0 1-1.504-.937 6.562 6.562 0 0 1-1.201-1.338 6.642 6.642 0 0 1-.811-1.641c-.703-.026-1.322-.15-1.855-.371a3.184 3.184 0 0 1-1.309-.977c-.612-.755-.898-1.562-.86-2.422.04-.859.066-1.308.079-1.347a.57.57 0 0 1 .215-.371.621.621 0 0 1 .39-.137h2.969V3.5a.6.6 0 0 1 .185-.44.6.6 0 0 1 .44-.185h11.23a.617.617 0 0 1 .625.625v.625h3.067a.62.62 0 0 1 .39.137.57.57 0 0 1 .215.37zM3.875 7.62c.208.247.472.443.791.586a3.51 3.51 0 0 0 1.123.273 6.244 6.244 0 0 1-.078-.996V5.375H3.309c-.013.286.01.648.068 1.084.059.436.225.824.498 1.162zm13.066-.137V4.125h-9.98v3.36c0 .755.13 1.461.39 2.119a5.41 5.41 0 0 0 1.075 1.718 5.2 5.2 0 0 0 1.592 1.162c.605.287 1.253.43 1.943.43.69 0 1.338-.143 1.943-.43a5.082 5.082 0 0 0 1.582-1.162 5.503 5.503 0 0 0 1.065-1.718c.26-.658.39-1.364.39-2.12zm3.184.137a2.3 2.3 0 0 0 .498-1.162c.059-.436.081-.798.068-1.084h-2.5v2.11a6.137 6.137 0 0 1-.078.995c.456-.026.85-.113 1.182-.263a2.45 2.45 0 0 0 .83-.596z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Gn},l))};qn.displayName="Trophy",qn.defaultProps={height:24,title:null,width:24},qn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Kn=qn,Xn=["title","width","height"],Jn={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Qn=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Xn);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.5 9.286V15.5a.5.5 0 1 1-1 0V9.293l-1.974 1.975a.5.5 0 0 1-.707-.707L12 7.379l.003.003.003-.003 3.182 3.182a.5.5 0 0 1-.707.707L12.5 9.286zM12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-1.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Jn},l))};Qn.displayName="Upgrade",Qn.defaultProps={height:24,title:null,width:24},Qn.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Yn=Qn,$n=["title","width","height"],ec={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},tc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,$n);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.41 15.16l2.285-2.285H2.625a.6.6 0 0 1-.44-.186A.6.6 0 0 1 2 12.25a.617.617 0 0 1 .625-.625h12.031L12.41 9.359a.567.567 0 0 1-.195-.44c0-.175.065-.321.195-.439a.556.556 0 0 1 .43-.195.62.62 0 0 1 .45.195l3.69 3.79-3.69 3.789a.89.89 0 0 1-.216.127.605.605 0 0 1-.234.048.605.605 0 0 1-.235-.048.597.597 0 0 1-.195-.127.617.617 0 0 1-.195-.45c0-.169.065-.319.195-.449zm8.34-12.91c.352 0 .648.12.889.361.24.241.361.537.361.889V21c0 .352-.12.648-.361.889-.241.24-.537.361-.889.361H9.5c-.339 0-.632-.12-.879-.361A1.192 1.192 0 0 1 8.25 21v-5.645h1.27v4.883a.75.75 0 0 0 .214.537c.144.15.32.225.528.225h9.726a.733.733 0 0 0 .537-.225.733.733 0 0 0 .225-.537l-.02-15.976a.733.733 0 0 0-.224-.537.733.733 0 0 0-.537-.225h-9.707a.701.701 0 0 0-.528.225.75.75 0 0 0-.214.537v4.863H8.25V3.5c0-.352.124-.648.371-.889.247-.24.54-.361.879-.361h11.25z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ec},l))};tc.displayName="Userlogin",tc.defaultProps={height:24,title:null,width:24},tc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ac=tc,ic=["title","width","height"],lc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},rc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ic);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.41 14.91l2.286-2.285H7.626a.6.6 0 0 1-.44-.186A.6.6 0 0 1 7 12c0-.182.062-.331.186-.448a.617.617 0 0 1 .44-.176h12.03L17.41 9.109a.567.567 0 0 1-.195-.44c0-.175.065-.322.195-.439a.556.556 0 0 1 .43-.195c.17 0 .32.065.45.195l3.69 3.79-3.69 3.788a.89.89 0 0 1-.215.127.605.605 0 0 1-.235.05.605.605 0 0 1-.234-.05.597.597 0 0 1-.196-.127.617.617 0 0 1-.195-.449.62.62 0 0 1 .195-.45zM3.25 2c-.352 0-.648.12-.889.361-.24.241-.361.537-.361.889v17.5c0 .352.12.648.361.889.241.24.537.361.889.361H14.5c.339 0 .632-.12.879-.361s.371-.537.371-.889v-5.645h-1.27v4.883a.75.75 0 0 1-.214.537.701.701 0 0 1-.528.225H4.012a.733.733 0 0 1-.537-.225.733.733 0 0 1-.225-.537l.02-15.976c0-.209.074-.388.224-.537a.733.733 0 0 1 .537-.225h9.707c.209 0 .384.075.528.225a.75.75 0 0 1 .214.537v4.863h1.27V3.25c0-.352-.124-.648-.371-.889A1.217 1.217 0 0 0 14.5 2H3.25z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:lc},l))};rc.displayName="Userlogout",rc.defaultProps={height:24,title:null,width:24},rc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var hc=rc,nc=["title","width","height"],cc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},sc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,nc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M19.364 4H4.636C3.736 4 3 4.736 3 5.636v9.819c0 .9.736 1.636 1.636 1.636h5.728v1.636H8.727v1.637h6.546v-1.637h-1.637v-1.636h5.728c.9 0 1.636-.736 1.636-1.636V5.636C21 4.736 20.264 4 19.364 4zm0 11.455H4.636V5.636h14.728v9.819z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:cc},l))};sc.displayName="Viewdevicedesktop",sc.defaultProps={height:24,title:null,width:24},sc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var oc=sc,dc=["title","width","height"],pc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},mc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,dc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M16.629 3.008L7.77 3C6.797 3 6 3.76 6 4.69v15.22c0 .93.797 1.69 1.771 1.69h8.858c.974 0 1.771-.76 1.771-1.69V4.69c0-.93-.797-1.682-1.771-1.682zm0 16.497H7.77V5.095h8.858v14.41z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:pc},l))};mc.displayName="Viewdevicephone",mc.defaultProps={height:24,title:null,width:24},mc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var uc=mc,wc=["title","width","height"],gc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},vc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,wc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M15.32 6.18h4.18v5h-4.18v-5zm-5 5v-5h4.18v5h-4.18zm5 5.82v-5h4.18v5h-4.18zm-5 0v-5h4.18v5h-4.18zm-5 0v-5H9.5v5H5.32zm0-5.82v-5H9.5v5H5.32z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:gc},l))};vc.displayName="Viewgrid",vc.defaultProps={height:24,title:null,width:24},vc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var fc=vc,Ec=["title","width","height"],bc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Cc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ec);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M8.82 7.82H20.5V9.5H8.82V7.82zm0 8.36V14.5H20.5v1.68H8.82zm0-3.36v-1.64H20.5v1.64H8.82zM5.5 9.5V7.82h1.68V9.5H5.5zm0 6.68V14.5h1.68v1.68H5.5zm0-3.36v-1.64h1.68v1.64H5.5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:bc},l))};Cc.displayName="Viewlist",Cc.defaultProps={height:24,title:null,width:24},Cc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var zc=Cc,yc=["title","width","height"],Mc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Hc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,yc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M5 7h15v1.68H5V7zm0 5.82v-1.64h15v1.64H5zM5 17v-1.68h15V17H5z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Mc},l))};Hc.displayName="Viewmenu",Hc.defaultProps={height:24,title:null,width:24},Hc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ac=Hc,Lc=["title","width","height"],Vc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Rc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Lc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M12.75 13.75v-3.5a.75.75 0 1 0-1.5 0v3.5a.75.75 0 1 0 1.5 0zm0 3a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0zm-8.622 1.23L11.18 5.005c.263-.483.843-.648 1.295-.367a.982.982 0 0 1 .344.367l7.053 12.977c.262.483.109 1.102-.344 1.382a.902.902 0 0 1-.476.137H4.947c-.523 0-.947-.453-.947-1.012 0-.178.044-.353.128-.507z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Vc},l))};Rc.displayName="Warning",Rc.defaultProps={height:24,title:null,width:24},Rc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Sc=Rc,xc=["title","width","height"],Pc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Bc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,xc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M17.588 16.96a1.16 1.16 0 0 1 .954-.492c.639 0 1.157.507 1.157 1.133 0 .625-.518 1.133-1.157 1.133-.427 0-.8-.227-1-.565h-8.65C8.616 19.776 7.19 21 5.47 21 3.554 21 2 19.478 2 17.6c0-1.156.59-2.177 1.49-2.791l.663.928a2.25 2.25 0 0 0-.996 1.864c0 1.251 1.036 2.266 2.313 2.266 1.14 0 2.088-.808 2.279-1.87V16.96h9.84zm-13.153.17a1.156 1.156 0 0 1 1.065-.71l4.338-7.395a3.366 3.366 0 0 1-.789-4.323c.955-1.627 3.069-2.185 4.722-1.246a3.391 3.391 0 0 1 1.714 2.651l-1.147.1a2.26 2.26 0 0 0-1.144-1.769 2.325 2.325 0 0 0-3.147.831 2.247 2.247 0 0 0 .775 3.058l.634.36-4.913 8.374c.14.287.154.628.021.935-.162.432-.585.74-1.081.74a1.143 1.143 0 0 1-1.153-1.133c0-.169.038-.33.105-.474zm7.506-9.605a1.14 1.14 0 0 1-.932-.557 1.119 1.119 0 0 1 .428-1.54 1.157 1.157 0 0 1 1.569.405c.206.351.195.767.01 1.101l4.315 7.356c1.56-.592 3.36-.007 4.214 1.448.945 1.61.37 3.679-1.283 4.618a3.514 3.514 0 0 1-3.193.146l.49-1.022c.658.3 1.452.29 2.132-.096 1.103-.626 1.486-2.005.855-3.08-.63-1.073-2.035-1.436-3.137-.81l-.015.008-.01-.016-.579.329-4.864-8.29z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Pc},l))};Bc.displayName="Webhook",Bc.defaultProps={height:24,title:null,width:24},Bc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Fc=Bc,Nc=["title","width","height"],Tc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},kc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Nc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.155 6.996L4.846 7a.783.783 0 0 1-.598-.293 1.131 1.131 0 0 1 0-1.413.783.783 0 0 1 .598-.292h6.309L12.845 5h6.309c.216 0 .433.098.598.293.33.39.33 1.022 0 1.413a.783.783 0 0 1-.598.292l-6.316-.009-1.683.007z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Tc},l))};kc.displayName="Windowmaximize",kc.defaultProps={height:24,title:null,width:24},kc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Zc=kc,Oc=["title","width","height"],Dc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},jc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Oc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M11.155 18.996L4.846 19a.783.783 0 0 1-.598-.293 1.131 1.131 0 0 1 0-1.413.783.783 0 0 1 .598-.292h6.309l1.69-.002h6.309c.216 0 .433.098.598.293.33.39.33 1.022 0 1.413a.783.783 0 0 1-.598.292l-6.316-.009-1.683.007z",fillRule:"evenodd"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Dc},l))};jc.displayName="Windowminimize",jc.defaultProps={height:24,title:null,width:24},jc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Wc=jc,Ic=["title","width","height"],_c={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Uc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ic);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M13.214 12.001l4.532-4.533A.858.858 0 0 0 17.138 6a.856.856 0 0 0-.608.252L12 10.797 7.468 6.252a.858.858 0 0 0-1.467.608c0 .237.096.452.252.608L10.785 12l-4.532 4.533a.856.856 0 0 0 0 1.217.877.877 0 0 0 1.216 0L12 13.214l4.532 4.533A.858.858 0 0 0 18 17.14a.857.857 0 0 0-.252-.608L13.214 12v.001z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:_c},l))};Uc.displayName="Xdismiss",Uc.defaultProps={height:24,title:null,width:24},Uc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Gc={apps:d,"arrow-down":w,"arrow-grow":E,"arrow-left":y,"arrow-redo":L,"arrow-right":x,"arrow-shrink":N,"arrow-undo":O,"arrow-up-right":I,"arrow-up":q,beta:Q,"bookmark-fill":te,"bookmark-outline-add":re,"bookmark-outline":se,bullet:me,"caret-fill-down":ve,"caret-fill-left":Ce,"caret-fill-right":He,"caret-fill-up-down":Re,"caret-fill-up":Be,"caret-stroke-down":ke,"caret-stroke-left":je,"caret-stroke-right":Ue,"caret-stroke-up":Xe,certificate:$e,"checkbox-empty":it,"checkbox-indeterminate":nt,"checkbox-selected":dt,checkmark:wt,"circle-fill-check":Et,"circle-fill-dash":yt,"circle-fill-info":Lt,"circle-fill-x":xt,"circle-outline-info":Nt,"circle-outline-play":Ot,"circle-outline-price":It,"circle-slash":qt,cog:Qt,"column-select":ta,connection:ra,"content-assignment":sa,"content-audio":ma,"content-discussions":va,"content-download":Ca,"content-exam":Ha,"content-live":Ra,"content-multimedia":Ba,"content-pdf":ka,"content-presentation":ja,"content-quiz":Ua,"content-survey":Xa,"content-text":$a,"content-video":ii,"data-download":ni,"data-export":di,"data-import":wi,discussions:Ei,document:yi,download:Li,"ellipsis-v":xi,"enrollment-add":Ni,"enrollment-remove":Oi,envelope:Ii,"eye-slash":qi,eye:Qi,filter:tl,flag:rl,folder:sl,"graph-bar":ml,"group-add":vl,"group-remove":Cl,"handle-drag":Hl,header:Rl,"heart-fill":Bl,"heart-outline":kl,home:jl,"icon-communities":Ul,image:Xl,key:$l,link:ir,location:nr,lock:dr,"magnifying-glass":wr,menu:Er,message:yr,minus:Lr,"new-window":xr,"page-duplicate":Nr,"page-new":Or,page:Ir,pencil:qr,people:Qr,pin:th,plane:rh,play:sh,plus:mh,"radio-empty":vh,"radio-selected":Ch,record:Hh,redirect:Rh,refresh:Bh,reply:kh,report:jh,share:Uh,shield:Xh,"smiley-face":$h,"social-facebook":ln,"social-google-colorized":cn,"social-google":pn,"social-linkedIn":gn,"social-twitter":bn,speaker:Mn,"star-fill":Vn,"star-outline":Pn,"stop-sign":Tn,"system-calendar":Dn,"trash-can":_n,trophy:Kn,upgrade:Yn,"user-login":ac,"user-logout":hc,"view-device-desktop":oc,"view-device-phone":uc,"view-grid":fc,"view-list":zc,"view-menu":Ac,warning:Sc,webhook:Fc,"window-maximize":Zc,"window-minimize":Wc,"x-dismiss":Uc},qc=["title","width","height"],Kc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Xc=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,qc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M15.951 14.689a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm0-6.853a2.871 2.871 0 1 1 0 5.742 2.871 2.871 0 0 1 0-5.742zm3.142 13.373a1.262 1.262 0 1 1 0 2.524 1.262 1.262 0 0 1 0-2.524zM20.2 17.2a4.151 4.151 0 0 1 4.151 4.147v4.355c-.356.29-.727.562-1.111.814V21.4a3.044 3.044 0 0 0-3.04-3.04h-8.498a3.044 3.044 0 0 0-3.04 3.04v5.116a14.23 14.23 0 0 1-1.11-.814v-4.355a4.151 4.151 0 0 1 4.15-4.147H20.2zM15.951.431C7.497.431.644 7.284.644 15.738c0 8.453 6.853 15.306 15.307 15.306s15.307-6.853 15.307-15.306A15.302 15.302 0 0 0 15.95.43zm0 29.498c-7.83-.017-14.174-6.36-14.191-14.191v-.236c0-7.835 6.352-14.186 14.187-14.186 7.835 0 14.186 6.351 14.186 14.186v.222c-.002 7.838-6.345 14.196-14.182 14.218v-.013z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Kc},l))};Xc.displayName="Account",Xc.defaultProps={height:24,title:null,width:24},Xc.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Jc=Xc,Qc=["title","width","height"],Yc={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},$c=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Qc);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M9.19738415,10.1666667 C9.2878707,10.1666667 9.37461014,10.2028557 9.43833092,10.2671934 C9.56990944,10.3997472 9.56990944,10.6138266 9.43833092,10.7463804 L9.43833092,10.7463804 L7.66686309,12.5169933 L11.4778945,16.3436923 L13.2459687,14.5730794 C13.3099326,14.5066213 13.3981385,14.4690768 13.4903091,14.4690768 C13.5824796,14.4690768 13.6706855,14.5066213 13.7346494,14.5730794 C13.866228,14.7056332 13.866228,14.9197126 13.7346494,15.0522664 L13.7346494,15.0522664 L11.9631816,16.8228793 L13.0966495,17.9579748 C13.1601735,18.0221106 13.1955859,18.1089346 13.1950644,18.1992675 C13.1946895,18.2884234 13.1593446,18.3738613 13.0966495,18.4371618 L13.0966495,18.4371618 L9.03109694,22.488161 C8.42322785,23.0948002 7.43990251,23.0948002 6.83203343,22.488161 L6.83203343,22.488161 L4.40899123,20.0616396 L1.55835335,22.9197692 C1.42289853,23.0343544 1.22218917,23.0251955 1.09770177,22.8987484 C0.973214376,22.7723014 0.966916336,22.5711941 1.08324703,22.4371837 L1.08324703,22.4371837 L3.93388491,19.5824527 L1.52441718,17.1559313 C1.23095574,16.8648841 1.0658507,16.4684336 1.0658507,16.0548207 C1.0658507,15.6412079 1.23095574,15.2447574 1.52441718,14.9537102 L1.52441718,14.9537102 L5.57639531,10.9027109 C5.6401161,10.8383732 5.72685553,10.8021842 5.81734209,10.8021842 C5.90782864,10.8021842 5.99456808,10.8383732 6.05828886,10.9027109 L6.05828886,10.9027109 L7.18836316,12.0378064 L8.95643737,10.2671934 C9.02015816,10.2028557 9.10689759,10.1666667 9.19738415,10.1666667 Z M5.80716124,11.6265891 L2.00291711,15.4362957 C1.83693259,15.5990411 1.74388117,15.8221947 1.74499224,16.0548207 C1.74450379,16.2883194 1.83738799,16.5122959 2.00291711,16.6767443 L2.00291711,16.6767443 L7.32410782,22.0055755 C7.67164358,22.3378736 8.21863572,22.3378736 8.56617147,22.0055755 L8.56617147,22.0055755 L12.3704156,18.1992675 L5.80716124,11.6265891 Z M15.7545815,1 C16.2525499,1 16.7300148,1.19844361 17.0814394,1.55146766 L17.0814394,1.55146766 L19.5073838,3.97528209 L22.251485,1.22949828 C22.3949303,1.10657949 22.6087583,1.1148438 22.7423006,1.24846799 C22.8758429,1.38209217 22.8841022,1.59605128 22.7612587,1.7395846 L22.7612587,1.7395846 L20.0171576,4.48898605 L22.443102,6.91641812 C22.799466,7.26910213 23,7.74979014 23,8.25132487 C23,8.75285961 22.799466,9.23354761 22.443102,9.58623163 L22.443102,9.58623163 L20.2123901,11.8183115 C20.1445046,11.8867979 20.0520961,11.9253205 19.9556955,11.9253205 C19.8592949,11.9253205 19.7668864,11.8867979 19.6990009,11.8183115 C19.5588227,11.6772102 19.5588227,11.4493264 19.6990009,11.3082252 L19.6990009,11.3082252 L21.9297129,9.0761453 C22.146743,8.86021659 22.2687736,8.56661246 22.2687736,8.26036895 C22.2687736,7.95412545 22.146743,7.66052132 21.9297129,7.4445926 L21.9297129,7.4445926 L16.5680502,2.06155398 C16.1168874,1.61318787 15.3886602,1.61318787 14.9374974,2.06155398 L14.9374974,2.06155398 L11.0581555,5.97945104 L18.2889885,13.2328062 C18.3811141,13.3375039 18.4048721,13.4858741 18.3500488,13.6141311 C18.2952255,13.7423882 18.1715899,13.8276778 18.0322939,13.8333333 C17.9369303,13.8319742 17.8459663,13.7929657 17.7792147,13.7248043 L17.7792147,13.7248043 L10.2736101,6.21821485 C10.2051657,6.15028778 10.1666667,6.05782256 10.1666667,5.96136288 C10.1666667,5.86490319 10.2051657,5.77243797 10.2736101,5.7045109 L10.2736101,5.7045109 L14.4277236,1.55146766 C14.7791482,1.19844361 15.2566131,1 15.7545815,1 Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Yc},l))};$c.displayName="Apps",$c.defaultProps={height:24,title:null,width:24},$c.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var es=$c,ts=["title","width","height"],as={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},is=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ts);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M25.191 31.32a6.809 6.809 0 1 1 0-13.618 6.809 6.809 0 0 1 0 13.617zm3.405-6.3v-1.076H25.7V21.05h-1.076v2.894H21.73v1.076h2.895v2.895h1.076V25.02h2.895zM1.424.447l1.052 1.7A.998.998 0 0 0 2 3v2.377H0V3C0 1.921.57.975 1.424.447z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M10 0v2H4V0zm10 0v2h-6V0z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M24.552 1a2.998 2.998 0 0 1 1.424 2.553V5.93h-2V3.553a.998.998 0 0 0-.476-.852L24.552 1z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M26 14.36h-2V9h2z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M1.424 24.93A2.998 2.998 0 0 1 0 22.377V20h2v2.377c0 .351.181.67.476.852l-1.052 1.7z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M13 25.377H7v-2h6zM2 15.65H0v-6h2z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:as},l))};is.displayName="Blank",is.defaultProps={height:24,title:null,width:24},is.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ls=is,rs=["title","width","height"],hs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ns=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,rs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M23.129 12.431a1.262 1.262 0 1 1 0-2.524 1.262 1.262 0 0 1 0 2.524zm-9.445-1.822h6.392v1.111h-6.392v-1.111zm0 5.004h10.707v1.111H13.684v-1.11zm0 5.005h10.707v1.11H13.684v-1.11zM9.062 4.284v21.503a1.6 1.6 0 1 1-3.195 0v-8.84h1.577v-1.111H4.778v9.95a2.711 2.711 0 0 0 2.706 2.712h17.81a3.111 3.111 0 0 0 3.11-3.111V4.284H9.062zm18.222 21.094a2.013 2.013 0 0 1-2.008 2.009H9.666a2.693 2.693 0 0 0 .525-1.6V5.396h17.107l-.014 19.982z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:hs},l))};ns.displayName="Blog",ns.defaultProps={height:24,title:null,width:24},ns.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var cs=ns,ss=["title","width","height"],os={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ds=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ss);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",fillRule:"evenodd",d:"M5.442 21.815a2.755 2.755 0 0 1-2.752-2.751 2.755 2.755 0 0 1 2.752-2.752h15.754v2.5H5.823a.345.345 0 1 0 0 .69h15.373v2.313H5.442zM2.69 5.786c0-1.4 1.052-2.557 2.407-2.727v12.584a3.438 3.438 0 0 0-2.407 1.356V5.786zm10.64-2.752h4.823v7.779l-2.209-1.598a.346.346 0 0 0-.404 0l-2.21 1.598V3.034zm7.866 12.588H5.786V3.034h6.855v8.454a.344.344 0 0 0 .546.279l2.555-1.847 2.554 1.847a.345.345 0 0 0 .547-.28V3.035h2.353v12.588zm.345-13.277H5.44A3.445 3.445 0 0 0 2 5.786v13.278a3.445 3.445 0 0 0 3.44 3.441h16.1c.19 0 .344-.154.344-.345V2.69a.345.345 0 0 0-.344-.345zM8.983 5.128a.571.571 0 1 0 0 1.143.571.571 0 0 0 0-1.143"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:os},l))};ds.displayName="Book",ds.defaultProps={height:24,title:null,width:24},ds.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ps=ds,ms=["title","width","height"],us={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ws=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ms);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M7.83909 14.9965V6.3566C7.83909 6.0915 7.62419 5.8766 7.3591 5.8766C7.094 5.8766 6.8791 6.0915 6.8791 6.3566V14.9965C6.8791 15.2616 7.094 15.4765 7.3591 15.4765C7.62419 15.4765 7.83909 15.2616 7.83909 14.9965Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M7.35775 22.6791C6.82757 22.6791 6.39777 23.1089 6.39777 23.6391C6.39777 24.1693 6.82757 24.5991 7.35775 24.5991C7.88794 24.5991 8.31774 24.1693 8.31774 23.6391C8.31774 23.1089 7.88794 22.6791 7.35775 22.6791Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",fillRule:"evenodd",clipRule:"evenodd",d:"M4.47999 2.04018C4.2149 2.04018 4 2.25508 4 2.52017V29.4798C4 29.7449 4.2149 29.9598 4.47999 29.9598H10.2399C10.505 29.9598 10.7199 29.7449 10.7199 29.4798V2.52017C10.7199 2.25508 10.505 2.04018 10.2399 2.04018H4.47999ZM4.95999 3.00017V28.9998H9.75992V3.00017H4.95999Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.4801 6.3566V14.9965C16.4801 15.2616 16.2652 15.4765 16.0001 15.4765C15.735 15.4765 15.5201 15.2616 15.5201 14.9965V6.3566C15.5201 6.0915 15.735 5.8766 16.0001 5.8766C16.2652 5.8766 16.4801 6.0915 16.4801 6.3566Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.0005 22.6791C15.4703 22.6791 15.0405 23.1089 15.0405 23.6391C15.0405 24.1693 15.4703 24.5991 16.0005 24.5991C16.5307 24.5991 16.9605 24.1693 16.9605 23.6391C16.9605 23.1089 16.5307 22.6791 16.0005 22.6791Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",fillRule:"evenodd",clipRule:"evenodd",d:"M12.6391 2.52017C12.6391 2.25508 12.854 2.04018 13.1191 2.04018H18.8791C19.1442 2.04018 19.3591 2.25508 19.3591 2.52017V29.4798C19.3591 29.7449 19.1442 29.9598 18.8791 29.9598H13.1191C12.854 29.9598 12.6391 29.7449 12.6391 29.4798V2.52017ZM13.5991 28.9998V3.00017H18.3991V28.9998H13.5991Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M25.1192 14.9965V6.3566C25.1192 6.0915 24.9043 5.8766 24.6392 5.8766C24.3741 5.8766 24.1592 6.0915 24.1592 6.3566V14.9965C24.1592 15.2616 24.3741 15.4765 24.6392 15.4765C24.9043 15.4765 25.1192 15.2616 25.1192 14.9965Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M24.6397 22.6791C24.1095 22.6791 23.6797 23.1089 23.6797 23.6391C23.6797 24.1693 24.1095 24.5991 24.6397 24.5991C25.1698 24.5991 25.5996 24.1693 25.5996 23.6391C25.5996 23.1089 25.1698 22.6791 24.6397 22.6791Z",fill:"#12131A"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",fillRule:"evenodd",clipRule:"evenodd",d:"M21.2801 2.52017C21.2801 2.25508 21.495 2.04018 21.7601 2.04018H27.52C27.7851 2.04018 28 2.25508 28 2.52017V29.4798C28 29.7449 27.7851 29.9598 27.52 29.9598H21.7601C21.495 29.9598 21.2801 29.7449 21.2801 29.4798V2.52017ZM22.2401 28.9998V3.00017H27.04V28.9998H22.2401Z",fill:"#12131A"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:us},l))};ws.displayName="Bundle",ws.defaultProps={height:24,title:null,width:24},ws.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var gs=ws,vs=["title","width","height"],fs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Es=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,vs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fill:"#12131A",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M29.385 5.48c.856-1.432 2.882-1.92 4.348-1.04l.15.097.958.673c.975.636 2.344.67 3.363.106l.176-.106.958-.606c1.424-.91 3.398-.565 4.328.793l.096.15.59.942c.561 1.026 1.725 1.563 2.98 1.437l.19-.024 1.18-.202c1.712-.26 3.355.866 3.526 2.464l.012.162v1.144c.07 1.154.876 2.125 2.036 2.505l.176.053 1.18.27c1.71.455 2.663 2.105 2.058 3.613l-.51 1.165c-.49 1.024-.182 2.229.672 3.04l.139.124.958.74c1.351 1.04 1.4 2.954.145 4.055l-.145.119-.884.74c-.91.768-1.289 1.96-.882 3.001l.513 1.173c.713 1.497-.16 3.182-1.816 3.718l-.175.051-1.18.27c-1.193.32-2.052 1.251-2.195 2.386l-.016.172-.074 1.077c-.142 1.626-1.663 2.813-3.429 2.647l-.183-.022-1.18-.202c-1.26-.192-2.455.285-3.14 1.256l-.104.158-.59.942c-.855 1.431-2.881 1.92-4.347 1.038l-.15-.096-.958-.673c-.975-.636-2.344-.67-3.363-.106l-.176.106-.958.606c-1.424.91-3.398.565-4.328-.793l-.096-.15-.59-.942c-.561-1.026-1.725-1.563-2.98-1.437l-.19.024-1.18.202c-1.712.26-3.355-.866-3.526-2.464l-.086-1.239c-.07-1.154-.876-2.124-2.035-2.505l-.177-.053-1.18-.269c-1.71-.455-2.663-2.106-2.058-3.614l.51-1.165c.49-1.023.182-2.229-.671-3.04l-.14-.124-.884-.74c-1.351-1.039-1.4-2.954-.145-4.055l.145-.119.884-.74c.91-.768 1.289-1.96.882-3l-.513-1.174c-.713-1.496.16-3.182 1.816-3.718l.175-.051 1.18-.337c1.193-.32 2.052-1.251 2.195-2.386l.016-.172.074-1.077c.142-1.626 1.663-2.813 3.429-2.647l.183.022 1.18.202c1.26.192 2.455-.285 3.14-1.256l.104-.158.59-.942zm1.056 1.993c-1.063 1.562-2.979 2.393-5.03 2.161l-.238-.031-1.126-.194c-.606-.088-1.15.277-1.26.843l-.017.116-.073 1.065c-.115 1.89-1.464 3.507-3.393 4.112l-1.434.41c-.597.159-.928.72-.736 1.277l.046.111.418.958c.818 1.707.333 3.704-1.12 5.04l-.166.145-.948.792c-.435.335-.464.99-.035 1.41l.099.085.89.745c1.517 1.279 2.086 3.257 1.39 4.937l-.55 1.25c-.243.51.036 1.093.533 1.288l.102.033 1.26.29c2.004.538 3.42 2.107 3.626 3.964l.017.207.076 1.117c.024.55.535.956 1.045.937l.102-.01 1.22-.208c2.133-.324 4.19.54 5.213 2.215l.065.112.598.956c.283.473.886.626 1.38.38l.103-.06.935-.59c1.675-1.092 3.994-1.133 5.768-.086l.203.125.938.66c.432.295 1.087.182 1.443-.287l.071-.106.584-.931c1.035-1.681 3.019-2.586 5.15-2.345l.237.031 1.126.194c.606.088 1.15-.277 1.26-.843l.017-.116.073-1.065c.115-1.89 1.464-3.507 3.496-4.138l.228-.066 1.103-.25c.597-.16.928-.72.736-1.278l-.046-.111-.418-.957c-.818-1.708-.333-3.705 1.12-5.04l.166-.146.948-.791a.922.922 0 0 0 .084-1.37l-.088-.078-1.023-.793c-1.518-1.279-2.087-3.257-1.39-4.936l.085-.193.465-1.058c.243-.51-.037-1.092-.534-1.287l-.102-.034-1.26-.29c-2.004-.537-3.42-2.107-3.626-3.975l-.018-.208-.003-.098.002-1.074c-.024-.55-.535-.956-1.045-.937l-.102.01-1.22.208c-2.133.324-4.19-.54-5.213-2.215l-.072-.123-.591-.945c-.283-.473-.886-.626-1.38-.38l-.103.06-.935.59c-1.675 1.092-3.994 1.133-5.768.086l-.203-.125-.938-.66c-.432-.295-1.087-.182-1.443.287l-.071.106-.59.942-.113.173z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M36.5 12C43.985 12 50 17.856 50 25s-6.015 13-13.5 13S23 32.144 23 25c0-7.208 6.082-13 13.5-13zm0 2C30.161 14 25 18.92 25 25c0 6.063 5.144 11 11.5 11S48 31.063 48 25s-5.144-11-11.5-11zM20.983 47c.92.39 1.98.651 3.042.651.425 0 .849-.065 1.273-.13h.142l.07.13c1.203 2.084 3.68 3.386 6.368 3.386.707 0 1.485-.13 2.122-.326l-7.287 16.864c-.2.49-.9.577-1.218.151l-3.522-5.685a.494.494 0 0 0-.565-.196l-6.509 1.889c-.566.195-1.061-.326-.849-.782L20.983 47zm1.15 2.18l-5.29 12.17 3.92-1.137c1.04-.318 2.126.01 2.76.767l.102.13.068.103 2.163 3.494L31.03 52.73l-.052-.004c-2.577-.221-4.922-1.386-6.448-3.207l-.122-.15-.22.009-.163.001a9.402 9.402 0 0 1-1.798-.178l-.093-.02zM52.042 47l6.908 16.012c.212.519-.282 1.037-.846.843l-6.485-1.88a.493.493 0 0 0-.564.194L47.6 67.745c-.282.389-1.057.324-1.269-.13L39 50.76c.705.194 1.41.324 2.115.324 2.679 0 5.075-1.296 6.344-3.436l.07-.13h.142c.423.065.846.13 1.269.13 1.128 0 2.115-.259 3.102-.648zm-1.16 2.174l-.165.036a9.44 9.44 0 0 1-2.067.16l-.084-.006-.17.209c-1.475 1.75-3.648 2.887-6.081 3.17l-.34.033L47.2 64.788l2.136-3.447.069-.102c.582-.804 1.643-1.19 2.658-.951l.168.045 3.963 1.149-5.31-12.308z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:fs},l))};Es.displayName="Certificate",Es.defaultProps={height:24,title:null,width:24},Es.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var bs=Es,Cs=["title","width","height"],zs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ys=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Cs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.111 30.444c-7.883 0-14.333-6.45-14.333-14.333S8.228 1.778 16.11 1.778s14.333 6.45 14.333 14.333-6.45 14.333-14.333 14.333zm0-27.555C8.84 2.889 2.89 8.839 2.89 16.11c0 7.272 5.95 13.222 13.222 13.222 7.272 0 13.222-5.95 13.222-13.222 0-7.272-5.95-13.222-13.222-13.222z",fill:"var(--circle)"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M14.801 20.532a.43.43 0 0 1-.331-.142l-3.694-3.694a.458.458 0 0 1 0-.663c.19-.19.474-.19.663 0l3.362 3.362 7.057-7.056c.19-.19.474-.19.663 0 .19.19.19.473 0 .663l-7.388 7.388c-.047.095-.19.142-.332.142z",fill:"var(--checkmark)"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:zs},l))};ys.displayName="Checkmarkmulticolor",ys.defaultProps={height:24,title:null,width:24},ys.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ms=ys,Hs=["title","width","height"],As={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ls=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Hs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M15.892 29.785C8.252 29.785 2 23.533 2 15.892 2 8.252 8.252 2 15.892 2c7.641 0 13.893 6.252 13.893 13.892 0 7.641-6.252 13.893-13.893 13.893zm0-26.708c-7.048 0-12.815 5.767-12.815 12.815 0 7.049 5.767 12.816 12.815 12.816 7.049 0 12.816-5.767 12.816-12.816 0-7.048-5.767-12.815-12.816-12.815z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M14.623 20.177a.417.417 0 0 1-.321-.138l-3.58-3.58a.444.444 0 0 1 0-.643.444.444 0 0 1 .642 0l3.259 3.26 6.84-6.84a.444.444 0 0 1 .642 0 .444.444 0 0 1 0 .643l-7.16 7.16c-.047.092-.184.138-.322.138z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:As},l))};Ls.displayName="Checkmark",Ls.defaultProps={height:24,title:null,width:24},Ls.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Vs=Ls,Rs=["title","width","height"],Ss={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},xs=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Rs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M10.626 3.717v-1.47c0-.281.18-.47.451-.47h10.735c.27 0 .45.189.45.47v1.47h7.304c.273 0 .454.185.454.463v25.626c0 .231-.227.416-.454.416H2.676c-.272 0-.454-.185-.454-.462V4.18c0-.278.182-.463.454-.463h7.95zm0 .925H3.131v24.701h25.935v-24.7h-6.803v1.883c0 .235-.226.423-.451.423H11.077c-.27 0-.45-.188-.45-.47V4.642zM8.04 17.94a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm0-5.818a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm0 11.637a.646.646 0 1 1 0-1.293.646.646 0 0 1 0 1.293zm8.564 0h-3.552c-.292 0-.486-.13-.486-.324s.194-.323.486-.323h3.552c.292 0 .487.13.487.323 0 .194-.243.324-.487.324zm0-5.819h-3.552c-.292 0-.486-.129-.486-.323s.194-.323.486-.323h3.552c.292 0 .487.13.487.323 0 .194-.243.323-.487.323zm0-5.818h-3.552c-.292 0-.486-.13-.486-.323 0-.194.194-.323.486-.323h3.552c.292 0 .487.129.487.323s-.243.323-.487.323zM11.528 6.01h9.833V2.72h-9.833v3.29z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ss},l))};xs.displayName="Clipboard",xs.defaultProps={height:24,title:null,width:24},xs.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ps=xs,Bs=["title","width","height"],Fs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ns=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Bs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.102 6.603c6.447.008 11.671 5.233 11.679 11.68 0 6.45-5.229 11.679-11.68 11.679-6.45 0-11.679-5.229-11.679-11.68 0-6.45 5.23-11.679 11.68-11.679zm0 1.899c-5.398.008-9.771 4.383-9.777 9.78a9.781 9.781 0 1 0 9.777-9.78zm0 10.616a.95.95 0 0 1-.95-.95v-6.676a.95.95 0 1 1 1.899 0v6.677a.95.95 0 0 1-.95.949zm0-14.56z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Fs},l))};Ns.displayName="Clocksmall",Ns.defaultProps={height:24,title:null,width:24},Ns.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ts=Ns,ks=["title","width","height"],Zs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Os=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ks);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M24.778 21.862a1.267 1.267 0 1 0 0 2.534 1.267 1.267 0 0 0 0-2.534zm-10.716 6.125h10.894a4.582 4.582 0 0 0 4.577-4.596V14.44h-15.47v13.547zm1.111-12.445h13.25v7.85a3.471 3.471 0 0 1-3.467 3.461h-9.778l-.005-11.31zM2.591 27.987h9.542V3.91H2.591v24.076zM3.702 5.044h7.32v21.81h-7.32V5.043zm10.36-1.133v8.551h15.471v-8.55h-15.47zm14.36 7.44H15.173V5.022h13.25v6.33z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Zs},l))};Os.displayName="Design",Os.defaultProps={height:24,title:null,width:24},Os.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ds=Os,js=["title","width","height"],Ws={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Is=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,js);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M28.927 25.6v3.49c0 .973-.752 1.746-1.698 1.746H3.862c-.948 0-1.698-.77-1.698-1.745V25.6A.582.582 0 0 0 1 25.6v3.49C1 30.703 2.265 32 3.862 32h23.367c1.595 0 2.862-1.301 2.862-2.91V25.6a.582.582 0 0 0-1.164 0z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M22.35 19.363a.582.582 0 0 0-.823.015l-5.4 5.599V.582a.582.582 0 1 0-1.163 0v24.395l-5.4-5.6a.582.582 0 1 0-.837.809l6.4 6.637.004.002.007.009c.002 0 .002.002.003.004.02.017.043.025.063.04.028.02.055.042.086.058.01.004.018.014.028.018.003.002.007.002.01.003.036.014.073.016.11.023.034.007.067.02.103.02h.009c.035 0 .069-.013.103-.02.038-.007.074-.01.11-.023.003-.001.007-.001.01-.003.01-.004.017-.013.026-.017.032-.017.06-.039.089-.06.02-.014.043-.022.061-.04.002 0 .002-.002.003-.003l.008-.009.004-.002 6.4-6.637a.582.582 0 0 0-.015-.823"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ws},l))};Is.displayName="Digitaldownload",Is.defaultProps={height:24,title:null,width:24},Is.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var _s=Is,Us=["title","width","height"],Gs={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},qs=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Us);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.9230769230769231 0.9230769230769231)",d:"M3.76381 5.63246C3.86672 5.63264 3.96847 5.61076 4.06221 5.5683C4.15595 5.52584 4.23951 5.46378 4.30724 5.38631C4.64269 5.00372 5.00292 4.6436 5.38561 4.30827C5.45698 4.24579 5.51534 4.16988 5.55736 4.08485C5.59939 3.99982 5.62425 3.90735 5.63054 3.81272C5.63683 3.71808 5.62441 3.62313 5.59401 3.53329C5.5636 3.44345 5.51579 3.36048 5.45332 3.28912C5.39085 3.21775 5.31493 3.15939 5.22991 3.11737C5.14488 3.07534 5.05241 3.05048 4.95777 3.04419C4.86313 3.0379 4.76819 3.05032 4.67835 3.08073C4.58851 3.11113 4.50554 3.15894 4.43417 3.22141C4.00381 3.59878 3.59859 4.0039 3.22111 4.43416C3.12964 4.53852 3.07016 4.66702 3.04981 4.80429C3.02945 4.94157 3.04907 5.0818 3.10633 5.20821C3.16358 5.33462 3.25604 5.44186 3.37265 5.5171C3.48925 5.59234 3.62507 5.63239 3.76384 5.63246H3.76381Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.9230769230769231 0.9230769230769231)",d:"M7.60028 2.6928C7.71031 2.69278 7.81888 2.66757 7.91766 2.61909C8.37429 2.39512 8.84528 2.20168 9.32751 2.04005C9.50737 1.97786 9.65541 1.8472 9.73947 1.67646C9.82352 1.50572 9.83678 1.30871 9.77638 1.12824C9.71598 0.947778 9.58679 0.798447 9.41689 0.712707C9.247 0.626968 9.05012 0.61175 8.86907 0.670362C8.32609 0.8524 7.79573 1.07011 7.28145 1.32206C7.13484 1.39391 7.01691 1.51332 6.94688 1.66081C6.87685 1.80829 6.85887 1.97516 6.89585 2.13418C6.93283 2.2932 7.02261 2.435 7.15053 2.53645C7.27846 2.6379 7.43698 2.69301 7.60025 2.6928H7.60028Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.9230769230769231 0.9230769230769231)",d:"M1.12532 9.78394C1.21525 9.81423 1.31027 9.82648 1.40494 9.81998C1.49961 9.81348 1.59207 9.78836 1.67701 9.74607C1.76196 9.70378 1.83772 9.64514 1.89997 9.57351C1.96221 9.50189 2.00971 9.41868 2.03974 9.32867C2.2015 8.84624 2.39494 8.37502 2.6188 7.91808C2.70307 7.74608 2.71556 7.54765 2.65353 7.36645C2.59149 7.18524 2.46001 7.0361 2.28802 6.95183C2.11602 6.86756 1.91759 6.85507 1.73638 6.9171C1.55517 6.97914 1.40603 7.11061 1.32176 7.28261C1.06993 7.7967 0.852231 8.32682 0.670064 8.86952C0.609263 9.05115 0.623062 9.2495 0.708428 9.42096C0.793795 9.59242 0.943744 9.72298 1.12532 9.78394Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.9230769230769231 0.9230769230769231)",d:"M13 0C12.744 0 12.4894 0.00728729 12.2362 0.0218617C12.0486 0.0326819 11.8726 0.116178 11.7455 0.254629C11.6185 0.39308 11.5504 0.575586 11.5557 0.763412C11.5611 0.951238 11.6394 1.1296 11.774 1.26063C11.9087 1.39167 12.0892 1.46507 12.2771 1.46525C12.2912 1.46525 12.3053 1.4649 12.3194 1.46419C12.5447 1.45115 12.7716 1.44456 13 1.44444C15.2855 1.44444 17.5196 2.12217 19.4199 3.39191C21.3202 4.66165 22.8013 6.46638 23.6759 8.57788C24.5505 10.6894 24.7794 13.0128 24.3335 15.2544C23.8876 17.4959 22.7871 19.5549 21.171 21.171C19.5549 22.7871 17.4959 23.8876 15.2544 24.3335C13.0128 24.7794 10.6894 24.5505 8.57788 23.6759C6.46638 22.8013 4.66165 21.3202 3.39191 19.4199C2.12217 17.5196 1.44444 15.2855 1.44444 13C1.44444 12.7715 1.45103 12.5446 1.46419 12.3194C1.46966 12.2247 1.45642 12.1298 1.42523 12.0402C1.39403 11.9507 1.3455 11.8681 1.2824 11.7973C1.2193 11.7264 1.14286 11.6687 1.05746 11.6274C0.972051 11.5861 0.879349 11.5621 0.784644 11.5566C0.593997 11.5481 0.407552 11.6143 0.265059 11.7413C0.122566 11.8682 0.0352982 12.0458 0.0218617 12.2362C0.00740285 12.489 0.000115556 12.7436 0 13C0 15.5712 0.762436 18.0846 2.19089 20.2224C3.61935 22.3602 5.64967 24.0265 8.02511 25.0104C10.4006 25.9944 13.0144 26.2518 15.5362 25.7502C18.0579 25.2486 20.3743 24.0105 22.1924 22.1924C24.0105 20.3743 25.2486 18.0579 25.7502 15.5362C26.2518 13.0144 25.9944 10.4006 25.0104 8.02511C24.0265 5.64967 22.3602 3.61935 20.2224 2.19089C18.0846 0.762436 15.5712 0 13 0Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.9230769230769231 0.9230769230769231)",d:"M13.0001 3.61108C12.8085 3.61108 12.6248 3.68718 12.4894 3.82262C12.3539 3.95806 12.2778 4.14176 12.2778 4.33331V13C12.2779 13.1915 12.354 13.3752 12.4894 13.5106L16.8228 17.8439C16.9586 17.9773 17.1416 18.0517 17.332 18.0508C17.5224 18.0499 17.7048 17.9739 17.8394 17.8393C17.974 17.7047 18.05 17.5223 18.0509 17.3319C18.0518 17.1416 17.9774 16.9585 17.844 16.8227L13.7223 12.7009V4.33331C13.7223 4.14176 13.6462 3.95806 13.5107 3.82262C13.3753 3.68718 13.1916 3.61108 13.0001 3.61108Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Gs},l))};qs.displayName="Dripschedule",qs.defaultProps={height:24,title:null,width:24},qs.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ks=qs,Xs=["title","width","height"],Js={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Qs=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Xs);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",fillRule:"nonzero",d:"M16.907 49.667a.92.92 0 0 1 1.84 0v11.5c0 8.897 1.53 16.393 4.484 21.893 1.829 3.406 4.184 6.012 7.025 7.748a16.67 16.67 0 0 0 2.262 1.157.92.92 0 1 1-.71 1.697 18.51 18.51 0 0 1-2.512-1.284c-3.132-1.915-5.709-4.765-7.686-8.448-3.113-5.796-4.703-13.584-4.703-22.763v-11.5zm31.206 43.95a.92.92 0 1 1-.721-1.693 16.738 16.738 0 0 0 3.073-1.71c2.976-2.094 5.371-5.21 7.132-9.245a.92.92 0 1 1 1.686.735c-1.888 4.33-4.491 7.715-7.76 10.014a18.549 18.549 0 0 1-3.41 1.9zm18.265-52.253a.92.92 0 1 1-1.687-.735c1.879-4.308 4.464-7.68 7.708-9.978a18.555 18.555 0 0 1 3.415-1.915.92.92 0 1 1 .725 1.691 16.73 16.73 0 0 0-3.076 1.726c-2.954 2.093-5.334 5.196-7.085 9.211zm25.163-10.96a.92.92 0 0 1 .72-1.694c.876.373 1.719.81 2.526 1.312 3.122 1.938 5.687 4.813 7.651 8.518 3.065 5.782 4.63 13.52 4.63 22.627v10.58a.92.92 0 1 1-1.84 0v-10.58c0-8.828-1.507-16.277-4.416-21.765-1.817-3.43-4.163-6.059-6.996-7.817a16.667 16.667 0 0 0-2.275-1.181z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"39.907",cy:"94.287",r:"3.68",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"84.067",cy:"28.047",r:"3.68",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",d:"M75.404 59.105c.46.08.893.304 1.303.674.409.37.614.823.614 1.362v1.917c0 .52-.205.938-.614 1.258-.41.32-.844.539-1.303.659l-2.486.599c-.1.3-.204.584-.314.853-.11.27-.235.534-.375.794l1.318 2.216c.26.4.42.858.48 1.378.06.519-.1.968-.48 1.347L72.2 73.51a1.73 1.73 0 0 1-1.377.524c-.54-.03-1.008-.175-1.408-.434l-2.156-1.378c-.28.14-.559.27-.838.39-.28.12-.58.229-.899.329l-.539 2.486c-.08.459-.304.893-.674 1.302-.37.41-.823.614-1.362.614H61.03a1.52 1.52 0 0 1-1.258-.614 3.567 3.567 0 0 1-.659-1.302l-.599-2.456c-.32-.1-.639-.215-.958-.345a9.846 9.846 0 0 1-.928-.434L54.41 73.6c-.379.26-.843.404-1.392.434-.55.03-1.003-.145-1.363-.524l-1.377-1.348c-.36-.38-.51-.828-.45-1.347.06-.52.21-.979.45-1.378l1.407-2.336c-.12-.24-.234-.484-.344-.734a6.192 6.192 0 0 1-.285-.793l-2.485-.6a3.576 3.576 0 0 1-1.303-.658 1.52 1.52 0 0 1-.614-1.258v-1.917c0-.539.205-.993.614-1.362.41-.37.843-.594 1.303-.674l2.455-.54c.08-.279.18-.558.3-.838.12-.28.24-.549.36-.808l-1.408-2.336c-.24-.4-.39-.859-.45-1.378-.06-.519.09-.968.45-1.347l1.377-1.348c.36-.38.814-.554 1.363-.524.549.03 1.013.174 1.392.434l2.217 1.408a10.888 10.888 0 0 1 1.856-.78l.63-2.455c.1-.459.309-.893.628-1.303.32-.409.749-.613 1.288-.613h1.917c.539 0 .988.204 1.347.613.36.41.59.834.689 1.273l.54 2.516a13.356 13.356 0 0 1 1.736.719l2.156-1.378c.4-.26.869-.404 1.408-.434a1.73 1.73 0 0 1 1.377.524l1.348 1.348c.38.379.54.828.48 1.347-.06.52-.22.978-.48 1.378l-1.318 2.216c.14.28.275.564.405.853.13.29.234.594.314.914l2.456.539zm0 3.803l.03-1.707c-.02-.02-.07-.055-.15-.105a.8.8 0 0 0-.27-.104l-3.563-.809-.33-1.048c-.06-.24-.14-.48-.24-.719a8.4 8.4 0 0 0-.359-.749l-.479-.958 1.887-3.144a.97.97 0 0 0 .135-.24c.03-.08.045-.14.045-.18l-1.258-1.228a.712.712 0 0 0-.39.12l-3.084 1.977-.988-.51c-.24-.12-.48-.234-.72-.344a3.855 3.855 0 0 0-.748-.254l-1.048-.36-.779-3.623a.881.881 0 0 0-.09-.225l-.06-.105H61.18c-.04.04-.08.1-.12.18-.04.08-.07.18-.09.3l-.868 3.473-1.019.33a8.02 8.02 0 0 0-.778.284c-.26.11-.52.235-.779.375l-.988.509-3.205-2.037-.15-.075c-.06-.03-.12-.055-.18-.074l-1.257 1.257c0 .06.015.13.045.21.03.08.075.17.135.27l1.946 3.234-.479.928c-.12.26-.224.5-.314.719-.09.22-.165.44-.225.659l-.33 1.048-3.623.809a1.1 1.1 0 0 0-.195.09.407.407 0 0 1-.134.06v1.766c.04.04.1.075.18.105.08.03.179.055.299.075l3.504.898.33 1.019c.059.2.134.404.224.614.09.21.194.424.314.643l.45.929-1.947 3.264a.968.968 0 0 0-.135.24.61.61 0 0 0-.045.21l1.258 1.227c.06 0 .125-.015.195-.045s.134-.065.194-.104l3.145-2.007.988.51c.26.139.52.264.779.373.26.11.519.205.778.285l1.019.33.898 3.533c.02.1.045.185.075.255a.52.52 0 0 0 .105.165h1.737c.02-.02.055-.07.104-.15.05-.08.085-.16.105-.24l.779-3.564 1.048-.359a10.51 10.51 0 0 0 1.438-.599l.988-.509 3.144 2.006.15.075c.06.03.12.055.18.075l1.258-1.258a.61.61 0 0 0-.045-.21 1.685 1.685 0 0 0-.135-.269l-1.887-3.114.48-.959c.12-.22.224-.444.314-.674.09-.23.175-.464.254-.703l.33-.989 3.564-.898c.1-.02.184-.045.254-.075a.52.52 0 0 0 .165-.105zM61.987 56.26c1.597 0 2.96.559 4.088 1.677 1.128 1.118 1.692 2.476 1.692 4.073 0 1.597-.564 2.955-1.692 4.073-1.128 1.118-2.49 1.677-4.088 1.677-1.577 0-2.93-.56-4.058-1.677-1.128-1.118-1.692-2.476-1.692-4.073 0-1.597.564-2.955 1.692-4.073 1.128-1.118 2.481-1.677 4.058-1.677zm0 9.583a3.693 3.693 0 0 0 2.71-1.123 3.693 3.693 0 0 0 1.124-2.71 3.693 3.693 0 0 0-1.123-2.71 3.693 3.693 0 0 0-2.71-1.123 3.693 3.693 0 0 0-2.711 1.123 3.693 3.693 0 0 0-1.123 2.71c0 1.058.374 1.961 1.123 2.71a3.693 3.693 0 0 0 2.71 1.123z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"nonzero"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",d:"M106.147 111.844c-2.986 0-11.883-11.187-11.883-17.02 0-6.823 5.037-11.347 11.883-11.347 6.846 0 11.883 4.524 11.883 11.347 0 5.833-8.897 17.02-11.883 17.02zm0-2.3c-.154 0-.013-.07.185-.21.343-.24.784-.605 1.279-1.06 1.103-1.017 2.356-2.371 3.506-3.818 2.843-3.575 4.613-7.089 4.613-9.632 0-5.494-3.955-9.047-9.583-9.047s-9.583 3.553-9.583 9.047c0 2.543 1.77 6.057 4.613 9.632 1.15 1.447 2.403 2.8 3.506 3.817.495.456.936.82 1.279 1.062.198.139.339.209.185.209z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",d:"M106.147 101.11a5.75 5.75 0 1 1 0-11.5 5.75 5.75 0 0 1 0 11.5zm0-2.3a3.45 3.45 0 1 0 0-6.9 3.45 3.45 0 0 0 0 6.9z"})),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"nonzero"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",d:"M17.827 39.777c-8.257 0-14.95-6.693-14.95-14.95s6.693-14.95 14.95-14.95 14.95 6.693 14.95 14.95-6.693 14.95-14.95 14.95zm0-2.3c6.986 0 12.65-5.664 12.65-12.65 0-6.986-5.664-12.65-12.65-12.65-6.986 0-12.65 5.664-12.65 12.65 0 6.986 5.664 12.65 12.65 12.65z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.1935483870967742 0.1935483870967742)",d:"M16.6 31.701c-1.103-.157-1.977-.518-2.624-1.083-.704-.615-1.056-1.401-1.056-2.357v-.786c0-.092.03-.164.088-.216a.35.35 0 0 1 .242-.079h1.409a.35.35 0 0 1 .242.079.275.275 0 0 1 .088.216v.373c0 .668.26 1.218.78 1.65.521.433 1.244.649 2.168.649.865 0 1.53-.193 1.991-.58.462-.386.693-.88.693-1.483a1.34 1.34 0 0 0-.352-.923 3.265 3.265 0 0 0-.902-.688c-.367-.197-.91-.458-1.628-.786a21.71 21.71 0 0 1-1.804-.825c-1.012-.472-1.753-.963-2.223-1.474-.469-.51-.704-1.185-.704-2.023 0-1.022.33-1.844.99-2.466.618-.582 1.485-.949 2.602-1.101v-2.119c0-.367.314-.665.701-.665h1.052c.387 0 .7.298.7.665v2.118c1.034.152 1.857.497 2.47 1.033.734.642 1.1 1.48 1.1 2.515v.57a.275.275 0 0 1-.087.216.35.35 0 0 1-.242.079h-1.409a.384.384 0 0 1-.242-.07.224.224 0 0 1-.088-.186v-.236c0-.707-.245-1.28-.737-1.719-.491-.438-1.206-.658-2.145-.658-.821 0-1.456.17-1.903.51-.448.341-.671.82-.671 1.435 0 .38.113.7.34.963.228.262.525.478.892.648.367.17.91.393 1.628.668l1.122.432c1.262.511 2.186 1.081 2.773 1.71.586.628.88 1.388.88 2.279 0 1.074-.367 1.945-1.1 2.613-.632.575-1.492.941-2.58 1.099v2.277c0 .367-.314.665-.701.665H17.3c-.387 0-.7-.298-.7-.665v-2.274z"})))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Js},l))};Qs.displayName="Featureafterpurchase",Qs.defaultProps={height:24,title:null,width:24},Qs.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ys=Qs,$s=["title","width","height"],eo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},to=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,$s);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.087 6.449a.449.449 0 0 0-.084.014L.743 11.849a.449.449 0 0 0 0 .855l5.99 2.118v8.022c0 .588.367 1.092.883 1.487s1.204.723 2.047.996c1.687.545 3.969.87 6.494.87s4.808-.325 6.494-.87c.843-.273 1.532-.6 2.047-.996.516-.395.884-.899.884-1.487v-8.022l5.386-1.908v5.204a.449.449 0 1 0 .897 0v-5.835a.449.449 0 0 0-.294-.434L16.31 6.463a.449.449 0 0 0-.224-.014zm.07.925l13.9 4.91-13.9 4.894-13.899-4.895 13.9-4.909zM7.63 15.13l8.373 2.96c.1.036.209.036.308 0l8.373-2.96v7.714c0 .216-.142.473-.533.772-.39.299-1.001.604-1.78.855-1.56.504-3.766.828-6.214.828-2.447 0-4.654-.324-6.213-.828-.78-.251-1.391-.556-1.781-.855-.39-.3-.533-.556-.533-.772V15.13z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:eo},l))};to.displayName="Flagship",to.defaultProps={height:24,title:null,width:24},to.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ao=to,io=["title","width","height"],lo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ro=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,io);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M31 8.324h-7.397a3.069 3.069 0 0 0-3.419-5.017c-.823.412-2.216 2.087-3.255 3.442a1.355 1.355 0 0 0-1.839.024c-1.039-1.36-2.432-3.035-3.255-3.447A3.074 3.074 0 0 0 7.712 4.71a3.04 3.04 0 0 0 .704 3.648H1v6.56h1.676V28.03h26.648V14.884H31v-6.56zM20.61 4.15a2.087 2.087 0 0 1 1.619-.11 2.121 2.121 0 0 1 .249 3.907 9.226 9.226 0 0 1-2.753.378H17.21c.086-.176.133-.369.14-.565 1.167-1.55 2.604-3.284 3.26-3.61zm-7.358 9.777V9.311h.823c.958 0 1.7 0 1.915-.034.216-.033.958.034 1.916.034h.823v4.615h-5.477zm5.496.958v12.19h-5.496v-12.19h5.496zM9.503 7.946a2.126 2.126 0 0 1-.958-2.844 2.13 2.13 0 0 1 1.221-1.063 2.126 2.126 0 0 1 1.619.11c.656.326 2.087 2.06 3.255 3.606.002.197.048.392.134.57h-2.499a9.355 9.355 0 0 1-2.772-.379zm-7.545 5.98V9.282h10.336v4.64H1.958v.004zm1.675.958h8.661v12.19h-8.66v-12.19zm24.734 12.19h-8.661v-12.19h8.66v12.19zm1.675-13.148H19.706v-4.64h10.336v4.64z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:lo},l))};ro.displayName="Gift",ro.defaultProps={height:24,title:null,width:24},ro.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var ho=ro,no=["title","width","height"],co={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},so=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,no);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M3.148 17.842a.476.476 0 0 1-.368-.158A9.536 9.536 0 0 1 0 10.947C0 8.421.997 6 2.78 4.211a9.473 9.473 0 0 1 13.43 0l2.938 2.947a2.834 2.834 0 0 1 0 4 2.862 2.862 0 0 1-1.994.842 2.862 2.862 0 0 1-1.993-.842l-2.728-2.79a.51.51 0 0 1 0-.736c.21-.21.524-.21.734 0l2.728 2.736a1.801 1.801 0 0 0 2.518 0c.682-.684.682-1.79 0-2.526l-2.938-2.947a8.44 8.44 0 0 0-5.98-2.474 8.44 8.44 0 0 0-5.98 2.474c-1.574 1.579-2.466 3.79-2.466 6.052 0 2.264.892 4.421 2.466 6a.51.51 0 0 1 0 .737.476.476 0 0 1-.367.158z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M26.44 20.21a.476.476 0 0 1-.368-.157.51.51 0 0 1 0-.737l2.36-2.369a8.497 8.497 0 0 0 2.466-6 8.497 8.497 0 0 0-2.465-6 8.44 8.44 0 0 0-5.98-2.473 8.44 8.44 0 0 0-5.98 2.473.506.506 0 0 1-.735 0 .51.51 0 0 1 0-.736 9.473 9.473 0 0 1 13.43 0 9.536 9.536 0 0 1 2.78 6.736 9.536 9.536 0 0 1-2.78 6.737l-2.361 2.369c-.053.105-.21.158-.368.158zm-9.758 10.369c-.63 0-1.259-.263-1.679-.684l-2.728-2.737c-.472-.474-.682-1.053-.682-1.684 0-.632.263-1.263.682-1.685a2.4 2.4 0 0 1 3.41 0l2.728 2.737c.472.474.682 1.053.682 1.685 0 .631-.262 1.263-.682 1.684-.524.473-1.102.684-1.731.684zm-2.78-6.526c-.368 0-.682.158-.945.42-.262.264-.42.58-.42.948s.158.684.42.947l2.728 2.737a1.39 1.39 0 0 0 1.941 0c.263-.263.42-.579.42-.947 0-.369-.157-.684-.42-.947l-2.728-2.737a1.43 1.43 0 0 0-.996-.421zm8.078 1.21c-.63 0-1.206-.21-1.678-.684l-2.728-2.737a2.42 2.42 0 0 1 0-3.42 2.4 2.4 0 0 1 3.41 0l2.727 2.736c.473.474.682 1.053.682 1.684a2.423 2.423 0 0 1-2.413 2.421zm-2.728-6.526c-.367 0-.682.158-.944.42a1.402 1.402 0 0 0 0 1.948l2.728 2.737a1.39 1.39 0 0 0 1.941 0c.262-.263.42-.579.42-.947 0-.369-.158-.684-.42-.948l-2.728-2.736c-.315-.316-.682-.474-.997-.474z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M19.305 27.947c-.63 0-1.207-.21-1.679-.684l-2.728-2.737c-.472-.473-.682-1.052-.682-1.684 0-.631.263-1.263.682-1.684a2.292 2.292 0 0 1 1.679-.684c.63 0 1.26.263 1.679.684l2.728 2.737a2.42 2.42 0 0 1 0 3.42c-.42.37-1.05.632-1.68.632zm-2.728-6.526c-.367 0-.682.158-.944.421-.263.21-.42.58-.42.947 0 .369.157.685.42.948l2.728 2.737a1.39 1.39 0 0 0 1.94 0 1.402 1.402 0 0 0 0-1.948l-2.727-2.737c-.263-.263-.63-.368-.997-.368zm8.026 1.158c-.63 0-1.206-.21-1.678-.684l-2.728-2.737c-.472-.474-.682-1.053-.682-1.684 0-.632.262-1.263.682-1.685a2.4 2.4 0 0 1 3.41 0l2.727 2.737a2.42 2.42 0 0 1 0 3.421c-.472.421-1.101.632-1.73.632zm-2.728-6.474c-.367 0-.682.158-.944.421-.262.263-.42.58-.42.948s.158.684.42.947l2.728 2.737a1.39 1.39 0 0 0 1.941 0 1.402 1.402 0 0 0 0-1.947l-2.728-2.737c-.262-.263-.63-.369-.997-.369zM3.567 22.316c-.63 0-1.206-.21-1.678-.684a2.42 2.42 0 0 1 0-3.421L12.433 7.63c.21-.21.524-.21.734 0a.51.51 0 0 1 0 .737L2.623 18.948c-.262.263-.42.578-.42.947 0 .368.158.684.42.947a1.39 1.39 0 0 0 1.94 0l2.414-2.42a.505.505 0 0 1 .734 0 .51.51 0 0 1 0 .736l-2.465 2.474a2.292 2.292 0 0 1-1.679.684zm5.299 5.316c-.63 0-1.207-.21-1.68-.685a2.42 2.42 0 0 1 0-3.42L9.6 21.104c.21-.21.525-.21.734 0a.51.51 0 0 1 0 .737l-2.413 2.421a1.402 1.402 0 0 0 0 1.948 1.39 1.39 0 0 0 1.941 0l1.731-1.737c.21-.21.525-.21.735 0a.51.51 0 0 1 0 .737l-1.731 1.736c-.525.474-1.102.685-1.731.685z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M6.243 25c-.63 0-1.26-.263-1.68-.684a2.439 2.439 0 0 1-.681-1.684c0-.632.262-1.264.682-1.685l2.413-2.42a.505.505 0 0 1 .734 0 .51.51 0 0 1 0 .736l-2.465 2.369c-.262.263-.42.579-.42.947s.158.684.42.947a1.39 1.39 0 0 0 1.94 0l2.414-2.42a.505.505 0 0 1 .734 0 .51.51 0 0 1 0 .736l-2.413 2.421c-.472.474-1.049.737-1.678.737zm5.246 5.316c-.63 0-1.207-.21-1.68-.684a2.42 2.42 0 0 1 0-3.421l1.732-1.737c.21-.21.525-.21.734 0a.51.51 0 0 1 0 .737l-1.73 1.736c-.263.264-.42.58-.42.948s.157.684.42.947a1.39 1.39 0 0 0 1.94 0l1.102-1.105c.21-.21.524-.21.734 0a.51.51 0 0 1 0 .737l-1.101 1.105a2.465 2.465 0 0 1-1.731.737z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:co},l))};so.displayName="Handshake",so.defaultProps={height:24,title:null,width:24},so.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var oo=so,po=["title","width","height"],mo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},uo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,po);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M30.444 16.243a14.147 14.147 0 0 0-2.96-8.671c.029-.102.044-.206.045-.312 0-.697-.565-1.262-1.262-1.262a1.147 1.147 0 0 0-.178 0c-5.498-5.33-14.236-5.33-19.733 0a1.282 1.282 0 0 0-.276-.03 1.249 1.249 0 0 0-1.2 1.728 14.182 14.182 0 0 0 .04 17.187 1.258 1.258 0 0 0 1.147 1.777c.137-.002.274-.026.404-.07 5.456 5.163 13.992 5.174 19.462.026a1.253 1.253 0 0 0 1.614-1.231 1.231 1.231 0 0 0-.08-.445 14.147 14.147 0 0 0 2.977-8.697zM7.227 6.732c5.016-4.768 12.879-4.799 17.933-.072-.103.184-.158.39-.16.6 0 .168.033.334.098.49l-4.334 4.337a6.133 6.133 0 0 0-9.182.125L7.204 7.829c.091-.176.14-.37.143-.569a1.262 1.262 0 0 0-.12-.528zm14.049 9.51a5.049 5.049 0 1 1-10.098 0 5.049 5.049 0 0 1 10.098 0zM6.08 24.14a1.511 1.511 0 0 0-.284.036 13.067 13.067 0 0 1-.103-15.698c.125.042.255.065.387.067.075 0 .149-.008.222-.022l4.622 4.626a6.12 6.12 0 0 0 .152 6.476l-4.592 4.591a1.209 1.209 0 0 0-.404-.076zm10.151 5.227a13.044 13.044 0 0 1-8.96-3.555c.048-.13.074-.267.076-.405a1.258 1.258 0 0 0-.076-.409l4.502-4.498a6.142 6.142 0 0 0 8.8.125l4.471 4.471a1.169 1.169 0 0 0 .058.8 13.044 13.044 0 0 1-8.87 3.449v.022zm10.427-5.182a1.204 1.204 0 0 0-.378-.067 1.271 1.271 0 0 0-.502.107l-4.476-4.48a6.133 6.133 0 0 0 .156-6.769l4.498-4.498c.105.029.214.044.324.045.163-.001.324-.033.476-.094a13.076 13.076 0 0 1-.098 15.756z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:mo},l))};uo.displayName="Help",uo.defaultProps={height:24,title:null,width:24},uo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var wo=uo,go=["title","width","height"],vo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},fo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,go);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M20.954 23.0728L21.2133 21.8409C24.7042 19.976 27.0795 16.2964 27.0795 12.062C27.0795 5.94297 22.119 0.982483 16 0.982483C9.8809 0.982483 4.92041 5.94297 4.92041 12.062C4.92041 16.176 7.16257 19.7662 10.4915 21.6774L10.7853 23.0728C11.0496 24.3284 12.1573 25.2272 13.4405 25.2272H18.2988C19.5819 25.2272 20.6896 24.3284 20.954 23.0728ZM20.6699 20.8238C20.3693 20.9844 20.1551 21.2698 20.0848 21.6033L19.8255 22.8352C19.6735 23.5572 19.0366 24.074 18.2988 24.074H13.4405C12.7027 24.074 12.0657 23.5572 11.9137 22.8352L11.62 21.4398C11.5523 21.1183 11.3506 20.8409 11.0657 20.6773C8.08021 18.9633 6.07359 15.7463 6.07359 12.062C6.07359 6.57986 10.5178 2.13566 16 2.13566C21.4822 2.13566 25.9263 6.57986 25.9263 12.062C25.9263 15.8541 23.8004 19.1514 20.6699 20.8238Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M12.6196 26.5382C12.3012 26.5382 12.043 26.7964 12.043 27.1148C12.043 27.4333 12.3012 27.6914 12.6196 27.6914H19.2673C19.5858 27.6914 19.8439 27.4333 19.8439 27.1148C19.8439 26.7964 19.5858 26.5382 19.2673 26.5382H12.6196Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M12.043 29.489C12.043 29.1706 12.3012 28.9124 12.6196 28.9124H19.2673C19.5858 28.9124 19.8439 29.1706 19.8439 29.489C19.8439 29.8075 19.5858 30.0656 19.2673 30.0656H12.6196C12.3012 30.0656 12.043 29.8075 12.043 29.489Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16 30.9825C15.438 30.9825 14.9825 31.438 14.9825 32C14.9825 32.562 15.438 33.0175 16 33.0175C16.5619 33.0175 17.0175 32.562 17.0175 32C17.0175 31.438 16.5619 30.9825 16 30.9825Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:vo},l))};fo.displayName="Lightbulb",fo.defaultProps={height:24,title:null,width:24},fo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Eo=fo,bo=["title","width","height"],Co={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},zo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,bo);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M5.422 4.431v23.916h15.854v1.11H4.31V3.32h16.965v1.111H5.422zm16.25 4.316l7.64 7.644-7.64 7.64-.788-.787 6.303-6.297H15.48v-1.111h11.707l-6.303-6.303.787-.786zm-13.3 7.643a1.262 1.262 0 1 1 2.525 0 1.262 1.262 0 0 1-2.525 0z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Co},l))};zo.displayName="Logout",zo.defaultProps={height:24,title:null,width:24},zo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var yo=zo,Mo=["title","width","height"],Ho={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Ao=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Mo);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M31.489 6.893l-1.333-1.569a1.64 1.64 0 0 0-2.312-.173L26.164 6.6l-5.75 4.942h-8.89v1.111h7.587l-3.275 2.818-.494 2.969h-3.818v1.102h7.805l10.307-8.889 1.68-1.444a1.644 1.644 0 0 0 .173-2.316zM18.924 18.41h-2.44l.396-2.382 9.142-7.867 2.05 2.378-9.148 7.87zM30.591 8.36l-1.68 1.449-2.04-2.369 1.68-1.449a.529.529 0 0 1 .742.058l1.356 1.569a.529.529 0 0 1-.058.742zm-2.769 15.662l-.009-8.715h1.111v8.715a3.8 3.8 0 0 1-3.795 3.791H1.667V2.796h22.009v1.11H2.786V26.69h22.37a2.667 2.667 0 0 0 2.666-2.667zM7.924 10.818a1.262 1.262 0 1 1 0 2.524 1.262 1.262 0 0 1 0-2.524zm0 6.893a1.267 1.267 0 1 1-.008 2.533 1.267 1.267 0 0 1 .008-2.533z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ho},l))};Ao.displayName="Manage",Ao.defaultProps={height:24,title:null,width:24},Ao.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Lo=Ao,Vo=["title","width","height"],Ro={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},So=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Vo);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M12.987 12.689L8.893 16.96l-.804-.769 4.867-5.071 4.106 3.938 3.25-3.458.804.769-4.023 4.258-4.106-3.938zM23 10.8a1.262 1.262 0 1 1 0-2.524 1.262 1.262 0 0 1 0 2.524zm7.942-5.867v-1.11H1.316v1.11h2.506v17.36H1.316v1.111H13.4l-3.484 4.48.888.68 4-5.16h2.64l4 5.16.89-.68-3.485-4.48h12.089v-1.11H28.43V4.933h2.511zm-3.618 17.36H4.934V4.933h22.39v17.36z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ro},l))};So.displayName="Marketsell",So.defaultProps={height:24,title:null,width:24},So.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var xo=So,Po=["title","width","height"],Bo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Fo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Po);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M6.83082 25.8462C7.4086 25.8462 7.87698 25.3778 7.87698 24.8001C7.87698 24.2223 7.4086 23.7539 6.83082 23.7539C6.25305 23.7539 5.78467 24.2223 5.78467 24.8001C5.78467 25.3778 6.25305 25.8462 6.83082 25.8462Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M13.7844 25.8462C14.3622 25.8462 14.8306 25.3778 14.8306 24.8001C14.8306 24.2223 14.3622 23.7539 13.7844 23.7539C13.2067 23.7539 12.7383 24.2223 12.7383 24.8001C12.7383 25.3778 13.2067 25.8462 13.7844 25.8462Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M20.7385 25.8462C21.3163 25.8462 21.7847 25.3778 21.7847 24.8001C21.7847 24.2223 21.3163 23.7539 20.7385 23.7539C20.1608 23.7539 19.6924 24.2223 19.6924 24.8001C19.6924 25.3778 20.1608 25.8462 20.7385 25.8462Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M13.6614 39.5077C13.4767 39.5077 13.2306 39.3847 13.1691 39.2L10.4614 34.8924H1.35367C0.984435 34.8924 0.738281 34.6462 0.738281 34.277V16.4308C0.738281 16.0616 0.984435 15.8154 1.35367 15.8154H26.0306C26.3998 15.8154 26.646 16.0616 26.646 16.4308V34.277C26.646 34.6462 26.3998 34.8924 26.0306 34.8924H16.9229L14.2152 39.2616C14.0921 39.4462 13.9075 39.5077 13.6614 39.5077ZM1.96905 33.6616H10.8306C11.0152 33.6616 11.2614 33.7847 11.3229 33.9693L13.7229 37.7847L16.1229 33.9693C16.246 33.7847 16.4306 33.6616 16.6152 33.6616H25.4767V17.0462H1.96905V33.6616Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M19.323 12.7383C19.9008 12.7383 20.3692 12.2699 20.3692 11.6922C20.3692 11.1144 19.9008 10.646 19.323 10.646C18.7452 10.646 18.2769 11.1144 18.2769 11.6922C18.2769 12.2699 18.7452 12.7383 19.323 12.7383Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M26.2766 12.7383C26.8544 12.7383 27.3228 12.2699 27.3228 11.6922C27.3228 11.1144 26.8544 10.646 26.2766 10.646C25.6988 10.646 25.2305 11.1144 25.2305 11.6922C25.2305 12.2699 25.6988 12.7383 26.2766 12.7383Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M33.2922 12.7383C33.87 12.7383 34.3384 12.2699 34.3384 11.6922C34.3384 11.1144 33.87 10.646 33.2922 10.646C32.7145 10.646 32.2461 11.1144 32.2461 11.6922C32.2461 12.2699 32.7145 12.7383 33.2922 12.7383Z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.6 0.6)",d:"M38.5229 21.7844H29.7229C29.3537 21.7844 29.1075 21.5383 29.1075 21.1691C29.1075 20.7998 29.3537 20.5537 29.7229 20.5537H37.9691V3.93829H13.846V12.246C13.846 12.6152 13.5998 12.8614 13.2306 12.8614C12.8614 12.8614 12.6152 12.6152 12.6152 12.246V3.3229C12.6152 2.95367 12.8614 2.70752 13.2306 2.70752H38.5229C38.8922 2.70752 39.1383 2.95367 39.1383 3.3229V21.1691C39.1383 21.4768 38.8922 21.7844 38.5229 21.7844Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Bo},l))};Fo.displayName="Messages",Fo.defaultProps={height:24,title:null,width:24},Fo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var No=Fo,To=["title","width","height"],ko={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Zo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,To);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{transform:"translate(7 2)",fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M8.806 21.18c-3.567 0-6.503-2.935-6.503-6.503V6.774C2.303 3.206 5.24.271 8.806.271c3.568 0 6.504 2.935 6.504 6.503v7.903c0 3.568-2.936 6.504-6.504 6.504zm0-20.006c-3.07 0-5.6 2.53-5.6 5.6v7.903c0 3.071 2.53 5.6 5.6 5.6 3.071 0 5.6-2.529 5.6-5.6V6.774c0-3.07-2.529-5.6-5.6-5.6z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M8.806 27.684c-.27 0-.451-.18-.451-.452v-4.47c0-.272.18-.452.451-.452s.452.18.452.451v4.471c0 .226-.18.452-.452.452zM5.826 8.265H2.755c-.271 0-.452-.181-.452-.452s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.452zm0 2.709H2.755c-.271 0-.452-.18-.452-.451s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.451zm0 3.432H2.755c-.271 0-.452-.18-.452-.451s.18-.452.452-.452h3.07c.272 0 .452.18.452.452a.453.453 0 0 1-.451.451zm9.032-6.141h-3.07c-.272 0-.453-.181-.453-.452s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.452-.452.452zm0 2.709h-3.07c-.272 0-.453-.18-.453-.451s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.451-.452.451zm0 3.432h-3.07c-.272 0-.453-.18-.453-.451s.181-.452.452-.452h3.071c.271 0 .452.18.452.452 0 .27-.181.451-.452.451z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M8.806 23.168c-4.606 0-8.4-3.749-8.4-8.4v-2.123c0-.27.181-.451.452-.451s.452.18.452.451v2.123c0 4.11 3.342 7.497 7.496 7.497a7.478 7.478 0 0 0 7.497-7.497v-2.123c0-.27.18-.451.452-.451.27 0 .451.18.451.451v2.123c0 4.651-3.793 8.4-8.4 8.4zm7.723 4.516H1.716c-.27 0-.451-.18-.451-.452 0-.27.18-.451.451-.451h14.858c.271 0 .452.18.452.451s-.226.452-.497.452z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"8.897",cy:"5.148",r:"1"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:ko},l))};Zo.displayName="Microphone",Zo.defaultProps={height:24,title:null,width:24},Zo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Oo=Zo,Do=["title","width","height"],jo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Wo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Do);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M29.564 27.609H2.667c-1.599 0-2.41-.817-2.41-2.427V6.142c0-.933.904-.933 1.2-.933h29.345c.57 0 .94.366.94.933v18.916c0 2.08-1.84 2.55-2.178 2.55zM1.13 6.747v18.435c0 1.436.793 1.556 1.538 1.556H29.53c.223-.04 1.342-.311 1.342-1.68V6.836c-1.255 1.08-4.096 3.524-6.94 5.968-7.738 6.65-7.742 6.653-7.936 6.646-.208-.003-.21-.003-14.866-12.703zm.56-.667c4.791 4.15 12.769 11.056 14.316 12.37 1.557-1.315 9.61-8.24 14.409-12.37H1.69z",stroke:"#414C55",strokeWidth:".4"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:jo},l))};Wo.displayName="Minicourse",Wo.defaultProps={height:24,title:null,width:24},Wo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Io=Wo,_o=["title","width","height"],Uo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Go=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,_o);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{fillRule:"evenodd"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M29.097 29.594H2.452c-.271 0-.452-.181-.452-.452V2.452C2 2.18 2.18 2 2.452 2h13.232a.41.41 0 0 1 .316.135l13.413 13.413c.09.09.135.181.135.317v13.232c0 .316-.18.497-.451.497zM2.903 28.69H28.69v-12.6L15.503 2.903h-12.6V28.69z",fillRule:"nonzero"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle",{cx:"7.103",cy:"6.968",r:"1"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M15.4 2c.22 0 .4.18.4.4v13.52a.4.4 0 1 1-.8 0V2.4c0-.22.18-.4.4-.4z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M29.32 16.16a.4.4 0 0 1-.4.4H15.4a.4.4 0 1 1 0-.8h13.52c.22 0 .4.18.4.4z"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Uo},l))};Go.displayName="Page",Go.defaultProps={height:24,title:null,width:24},Go.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var qo=Go,Ko=["title","width","height"],Xo={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Jo=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ko);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(1 1)",d:"M8.89,13.7592 C9.743,13.6552 10.782,13.6422 11.991,14.3672 C12.243,14.5172 12.41,14.6452 12.556,14.7572 C12.828,14.9662 12.964,15.0712 13.591,15.1972 C13.983,15.2762 14.312,15.2912 14.63,15.3042 C15.113,15.3262 15.569,15.3462 16.116,15.5762 C16.654,15.8002 17.027,16.2922 17.09,16.8612 C17.119,17.1012 17.089,17.3342 17.011,17.5452 C17.134,17.5342 17.245,17.5212 17.343,17.5092 C17.781,17.4552 18.578,17.4052 19.328,17.3592 C19.978,17.3202 20.592,17.2832 20.885,17.2452 C21.76,17.1282 22.527,17.7102 22.669,18.2992 C22.825,18.9402 22.609,19.7622 21.767,20.0502 C21.164,20.2582 14.341,22.4302 13.847,22.5502 C13.514,22.6302 13.133,22.7012 12.676,22.7012 C12.326,22.7012 11.933,22.6592 11.484,22.5492 C11.085,22.4522 10.1235,22.18395 9.10225,21.893825 L8.54230071,21.7343034 C7.70255372,21.4944603 6.884,21.2581545 6.362,21.1072 C6.223,21.5322 5.842,21.8432 5.382,21.8432 L5.382,21.8432 L3.048,21.8432 C2.47,21.8432 2,21.3622 2,20.7712 L2,20.7712 L2,15.0662 C2,14.4742 2.47,13.9932 3.048,13.9932 L3.048,13.9932 L5.382,13.9932 C5.769,13.9932 6.094,14.2192 6.275,14.5402 C7.224,14.1182 8.082,13.8592 8.89,13.7592 Z M11.477,15.2242 C10.532,14.6582 9.734,14.6642 9.013,14.7512 C8.277,14.8432 7.484,15.0852 6.586,15.4942 C6.509,15.5282 6.46,15.5572 6.429,15.5792 L6.429,15.5792 L6.429,16.7082 L6.438,20.0872 C7.55,20.4102 10.906,21.3792 11.721,21.5792 C12.658,21.8052 13.279,21.6592 13.612,21.5782 C14.015,21.4802 20.701,19.3602 21.442,19.1052 C21.779,18.9902 21.722,18.6392 21.697,18.5352 C21.666,18.4522 21.398,18.1932 21.012,18.2372 C20.708,18.2762 20.067,18.3162 19.388,18.3572 C18.663,18.4022 17.891,18.4492 17.467,18.5012 C16.747,18.5912 15.355,18.6792 14.094,18.7162 C13.9254286,18.7240571 13.7956327,18.726302 13.727207,18.7269434 L13.676,18.7272 C13.402,18.7272 13.18,18.5062 13.177,18.2322 C13.174,17.9592 13.392,17.7332 13.666,17.7272 C13.809,17.7242 13.956,17.7202 14.104,17.7152 C14.778,17.6832 15.602,17.5792 15.894,17.4102 C16.108,17.2862 16.107,17.0642 16.096,16.9742 C16.073,16.7612 15.936,16.5842 15.73,16.4982 C15.346,16.3372 15.01,16.3232 14.586,16.3032 C14.247,16.2892 13.862,16.2712 13.394,16.1772 C12.597,16.0172 12.316,15.8342 11.947,15.5502 C11.825,15.4572 11.687,15.3502 11.477,15.2242 Z M3.048,14.9932 L3,20.7712 L5.382,20.8432 C5.4,20.8432 5.429,20.8142 5.429,20.7712 L5.429,20.7712 L5.429,15.4452 C5.426,15.4272 5.426,15.3992 5.429,15.3682 L5.429,15.3682 L5.429,15.0662 L3.048,14.9932 Z M12.6437,0.9998 C15.6757,0.9998 18.1437,3.4658 18.1437,6.4948 C18.1437,9.5248 15.6757,11.9908 12.6437,11.9908 C9.6117,11.9908 7.1437,9.5248 7.1437,6.4948 C7.1437,3.4658 9.6117,0.9998 12.6437,0.9998 Z M12.6437,1.9998 C10.1627,1.9998 8.1437,4.0168 8.1437,6.4948 C8.1437,8.9748 10.1627,10.9908 12.6437,10.9908 C15.1247,10.9908 17.1437,8.9748 17.1437,6.4948 C17.1437,4.0168 15.1247,1.9998 12.6437,1.9998 Z M12.7862,2.861 C13.0622,2.861 13.2862,3.085 13.2862,3.361 L13.2862,3.361 L13.2862,3.804 C13.9462,4.016 14.4282,4.629 14.4282,5.359 C14.4282,5.636 14.2042,5.859 13.9282,5.859 C13.6522,5.859 13.4282,5.636 13.4282,5.359 C13.4282,5.005 13.1402,4.718 12.7862,4.718 C12.4322,4.718 12.1432,5.005 12.1432,5.359 C12.1432,5.741 12.5602,5.928 12.9102,6.016 C13.8602,6.259 14.4282,6.866 14.4282,7.642 C14.4282,8.372 13.9462,8.985 13.2862,9.198 L13.2862,9.198 L13.2862,9.64 C13.2862,9.917 13.0622,10.14 12.7862,10.14 C12.5102,10.14 12.2862,9.917 12.2862,9.64 L12.2862,9.64 L12.2862,9.198 C11.6262,8.985 11.1432,8.372 11.1432,7.642 C11.1432,7.366 11.3672,7.142 11.6432,7.142 C11.9202,7.142 12.1432,7.366 12.1432,7.642 C12.1432,7.997 12.4322,8.284 12.7862,8.284 C13.1402,8.284 13.4282,7.997 13.4282,7.642 C13.4282,7.225 12.8932,7.044 12.6632,6.985 C11.6972,6.739 11.1432,6.146 11.1432,5.359 C11.1432,4.629 11.6262,4.016 12.2862,3.804 L12.2862,3.804 L12.2862,3.361 C12.2862,3.085 12.5102,2.861 12.7862,2.861 Z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Xo},l))};Jo.displayName="Payouts",Jo.defaultProps={height:24,title:null,width:24},Jo.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Qo=Jo,Yo=["title","width","height"],$o={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ed=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Yo);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M13 11l8 5.333-8 5.334V11zm3.111 19.444c-7.916 0-14.333-6.417-14.333-14.333S8.195 1.778 16.11 1.778 30.444 8.195 30.444 16.11s-6.417 14.333-14.333 14.333zm0-1.11c7.303 0 13.222-5.92 13.222-13.223 0-7.302-5.92-13.222-13.222-13.222S2.89 8.809 2.89 16.11c0 7.303 5.92 13.222 13.222 13.222z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:$o},l))};ed.displayName="Play",ed.defaultProps={height:24,title:null,width:24},ed.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var td=ed,ad=["title","width","height"],id={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},ld=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ad);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M18.474 19.452a.98.98 0 1 0-.007 1.96.98.98 0 0 0 .007-1.96zm-2.543-4.722a2.973 2.973 0 1 0 0-5.945 2.973 2.973 0 0 0 0 5.946zm0-5.081a2.113 2.113 0 1 1 0 4.225 2.113 2.113 0 0 1 0-4.225z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M19.083 16.527h-6.304a3.097 3.097 0 0 0-3.096 3.097v6.71h12.49V19.62a3.097 3.097 0 0 0-3.09-3.093zm2.233 8.946h-10.77v-5.85c0-1.233 1-2.234 2.233-2.236h6.304a2.237 2.237 0 0 1 2.25 2.233l-.017 5.853zm4.022-14.193a2.973 2.973 0 1 0 0-5.946 2.973 2.973 0 0 0 0 5.946zm0-5.083a2.113 2.113 0 1 1 0 4.226 2.113 2.113 0 0 1 0-4.226z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M28.831 13.048h-6.3a3.097 3.097 0 0 0-2.918 2.04l.809.293a2.24 2.24 0 0 1 2.102-1.473h6.307c1.234 0 2.235 1 2.237 2.234v5.849h-7.601v.86h8.46v-6.71a3.097 3.097 0 0 0-3.096-3.093zM5.726 11.28a2.973 2.973 0 1 1 0-5.946 2.973 2.973 0 0 1 0 5.946zm0-5.083a2.113 2.113 0 1 0 0 4.226 2.113 2.113 0 0 0 0-4.226zm-2.629 6.851h6.3a3.097 3.097 0 0 1 2.918 2.04l-.809.293a2.24 2.24 0 0 0-2.102-1.473H3.097c-1.234 0-2.235 1-2.237 2.234v5.849h7.601v.86H0v-6.71a3.097 3.097 0 0 1 3.097-3.093z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:id},l))};ld.displayName="Presell",ld.defaultProps={height:24,title:null,width:24},ld.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var rd=ld,hd=["title","width","height"],nd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},cd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,hd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M15.951 10.436a5.956 5.956 0 1 0 .009 11.91 5.956 5.956 0 0 0-.009-11.91zm0 10.8a4.844 4.844 0 1 1 .009-9.69 4.844 4.844 0 0 1-.009 9.69zm14.333-4.61a30.302 30.302 0 0 0-4.142-4.888c-3.39-3.227-6.915-4.93-10.19-4.93-3.276 0-6.8 1.703-10.188 4.93a30.476 30.476 0 0 0-4.146 4.889l-.21.324.228.307c.262.355 6.466 8.698 14.315 8.698 7.849 0 14.058-8.343 14.316-8.698l.226-.307-.209-.324zm-14.333 8.218c-6.467 0-12-6.435-13.178-7.933C3.93 15.267 9.44 7.938 15.951 7.938c6.511 0 12.022 7.329 13.182 8.973-1.195 1.498-6.715 7.933-13.182 7.933zm0-9.715a1.262 1.262 0 1 0 0 2.524 1.262 1.262 0 0 0 0-2.524z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:nd},l))};cd.displayName="Preview",cd.defaultProps={height:24,title:null,width:24},cd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var sd=cd,od=["title","width","height"],dd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},pd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,od);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M5.965 0a2.676 2.676 0 0 0-2.672 2.672v25.832a3.217 3.217 0 0 0 3.213 3.213h22.217V0H5.965zm22.073 4.664h-.847V.68h.847v3.983zM5.965.68H26.51v3.983H5.965a1.991 1.991 0 0 1 0-3.983zM3.974 28.504V4.453l.105.109a2.655 2.655 0 0 0 1.886.786h2.482v25.689H6.51a2.536 2.536 0 0 1-2.536-2.533zm5.154 2.533V5.348h18.927v25.689H9.128z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:dd},l))};pd.displayName="Resourcelibrary",pd.defaultProps={height:24,title:null,width:24},pd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var md=pd,ud=["title","width","height"],wd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},gd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,ud);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M34 60C19.088 60 7 47.912 7 33S19.088 6 34 6s27 12.088 27 27-12.088 27-27 27zm0-2.998c13.256 0 24.002-10.746 24.002-24.002C58.002 19.744 47.256 8.998 34 8.998 20.744 8.998 9.998 19.744 9.998 33c0 13.256 10.746 24.002 24.002 24.002z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M50.797 52.515c-.558-.562-.155-1.426.63-2.204.785-.779 1.652-1.175 2.21-.613L67.12 63.292a2 2 0 1 1-2.84 2.817L50.797 52.515zM28.979 26.5A1.49 1.49 0 0 1 27.5 25c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98zM23.5 35a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0-16a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm5.479 7.5A1.49 1.49 0 0 1 27.5 33c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98zm0 8A1.49 1.49 0 0 1 27.5 41c0-.826.66-1.5 1.479-1.5H45.02c.82 0 1.479.674 1.479 1.5s-.66 1.5-1.479 1.5H28.98z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:wd},l))};gd.displayName="Searchinitial",gd.defaultProps={height:24,title:null,width:24},gd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var vd=gd,fd=["title","width","height"],Ed={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},bd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,fd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M34 60C19.088 60 7 47.912 7 33S19.088 6 34 6s27 12.088 27 27-12.088 27-27 27zm0-2.998c13.256 0 24.002-10.746 24.002-24.002C58.002 19.744 47.256 8.998 34 8.998 20.744 8.998 9.998 19.744 9.998 33c0 13.256 10.746 24.002 24.002 24.002z"}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.3333333333333333 0.3333333333333333)",d:"M50.797 52.515c-.558-.562-.155-1.426.63-2.204.785-.779 1.652-1.175 2.21-.613L67.12 63.292a2 2 0 1 1-2.84 2.817L50.797 52.515zM38.531 25.94a1.5 1.5 0 0 1 2.121 2.122l-4.735 4.735 4.735 4.735a1.5 1.5 0 1 1-2.121 2.121l-4.735-4.735-4.735 4.735a1.5 1.5 0 1 1-2.122-2.121l4.735-4.735-4.735-4.735a1.5 1.5 0 0 1 2.122-2.122l4.735 4.735 4.735-4.735z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ed},l))};bd.displayName="Searchnoresult",bd.defaultProps={height:24,title:null,width:24},bd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Cd=bd,zd=["title","width","height"],yd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Md=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,zd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16.458 17.569a1.262 1.262 0 1 0-.01-2.525 1.262 1.262 0 0 0 .01 2.525zm-9.854 8.844l3.263-1.87a10.48 10.48 0 0 0 2.76 1.59v3.743h7.657V26.12a10.36 10.36 0 0 0 2.76-1.578l3.267 1.885 3.827-6.631-3.24-1.867c.086-.544.13-1.094.129-1.645a10.747 10.747 0 0 0-.12-1.577l3.23-1.867-3.826-6.631-3.218 1.858a10.556 10.556 0 0 0-2.809-1.627V2.72h-7.657v3.707a10.604 10.604 0 0 0-2.805 1.626L6.604 6.196l-3.83 6.63 3.235 1.867a10.187 10.187 0 0 0 .004 3.218l-3.24 1.871 3.831 6.631zm.57-8.32a9.364 9.364 0 0 1 0-3.586l.075-.387-2.947-1.698L7 7.716 9.947 9.43l.297-.262a9.471 9.471 0 0 1 3.112-1.809l.373-.129v-3.4h5.435v3.38l.374.129a9.471 9.471 0 0 1 3.11 1.809l.299.262 2.937-1.693 2.72 4.706-2.937 1.698.07.387a9.364 9.364 0 0 1 0 3.586l-.075.391 2.96 1.707-2.72 4.707-2.978-1.72-.297.258a9.333 9.333 0 0 1-3.08 1.777l-.374.134v3.444h-5.435v-3.458l-.516-.182a9.333 9.333 0 0 1-2.924-1.715l-.302-.258L7 24.898 4.284 20.19l2.956-1.707-.067-.39z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:yd},l))};Md.displayName="Settings",Md.defaultProps={height:24,title:null,width:24},Md.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Hd=Md,Ad=["title","width","height"],Ld={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Vd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Ad);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M26.511 11.716a4 4 0 0 1 3.996 3.995v8.667H19.582v-1.111h9.814V15.71a2.889 2.889 0 0 0-2.885-2.884h-8.138c-1.215 0-2.3.76-2.715 1.902l-1.045-.378a4 4 0 0 1 3.76-2.635h8.138zm-13.382 8.27a1.267 1.267 0 1 1 0 2.534 1.267 1.267 0 0 1 0-2.533zm-3.28-6.097a3.84 3.84 0 1 0 0-7.68 3.84 3.84 0 0 0 0 7.68zm0-6.565a2.729 2.729 0 1 1 0 5.458 2.729 2.729 0 0 1 0-5.458zm4.067 8.885H5.778a4 4 0 0 0-4 4v8.667H17.91v-8.672a4 4 0 0 0-3.995-3.995zm2.888 11.555H2.894V20.21a2.889 2.889 0 0 1 2.884-2.889h8.138a2.889 2.889 0 0 1 2.888 2.884v7.56zm5.192-18.333a3.84 3.84 0 1 0 0-7.68 3.84 3.84 0 0 0 0 7.68zm0-6.564a2.729 2.729 0 1 1 0 5.457 2.729 2.729 0 0 1 0-5.457z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Ld},l))};Vd.displayName="Students",Vd.defaultProps={height:24,title:null,width:24},Vd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Rd=Vd,Sd=["title","width","height"],xd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Pd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Sd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M27.858 26.653a42.884 42.884 0 0 1-1.262-10.733c0-6.391-4.103-11.031-9.752-11.031-5.493 0-9.75 5.929-9.75 11.031 0 4.813-1.263 10.711-1.276 10.769l-.142.671h6.075a5.12 5.12 0 0 0 10.182 0h6.13l-.205-.707zm-11.014 4.165a4 4 0 0 1-3.968-3.458h7.933a4 4 0 0 1-3.965 3.436v.022zm-9.8-4.61a59.556 59.556 0 0 0 1.16-10.328c0-5.587 4.645-9.92 8.64-9.92 5.085 0 8.64 4.08 8.64 9.92a45.89 45.89 0 0 0 1.12 10.329H7.044zm9.778-22.804a1.267 1.267 0 1 1 .01-2.533 1.267 1.267 0 0 1-.01 2.533z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:xd},l))};Pd.displayName="Updates",Pd.defaultProps={height:24,title:null,width:24},Pd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Bd=Pd,Fd=["title","width","height"],Nd={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Td=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Fd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M15.556 8.563l-6.323 6.323a.556.556 0 1 1-.785-.786l7.27-7.27a.556.556 0 0 1 .786 0l7.27 7.27a.556.556 0 1 1-.785.786l-6.322-6.323v12.7a.556.556 0 0 1-1.111 0v-12.7zm.555 16.881a.889.889 0 1 1 0-1.777.889.889 0 0 1 0 1.777zm0 5c-7.916 0-14.333-6.417-14.333-14.333S8.195 1.778 16.11 1.778 30.444 8.195 30.444 16.11s-6.417 14.333-14.333 14.333zm0-1.11c7.303 0 13.222-5.92 13.222-13.223 0-7.302-5.92-13.222-13.222-13.222S2.89 8.809 2.89 16.11c0 7.303 5.92 13.222 13.222 13.222z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Nd},l))};Td.displayName="Upgrade",Td.defaultProps={height:24,title:null,width:24},Td.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var kd=Td,Zd=["title","width","height"],Od={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},Dd=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Zd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("g",{clipPath:"url(#clip0_493_16202)"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.96 0.96)",fillRule:"evenodd",clipRule:"evenodd",d:"M12.7015 0.79536C8.7555 0.652356 5.44447 3.84312 5.30613 7.92213C5.30008 8.10052 5.3002 8.27766 5.30629 8.45332C7.67739 7.50763 10.3111 7.84548 12.3662 9.24667C14.7647 7.6472 17.9301 7.48224 20.548 9.09554C24.2271 11.3629 25.4315 16.284 23.2381 20.0871C21.2663 23.5061 17.2203 24.8573 13.7497 23.4486C13.5531 23.3688 13.4563 23.1394 13.5335 22.9361C13.6107 22.7329 13.8327 22.6328 14.0293 22.7126C17.157 23.9821 20.8041 22.7633 22.5811 19.6822C24.5477 16.2722 23.4839 11.8652 20.2085 9.80724C19.7078 12.3746 18.0507 14.4912 15.8396 15.5761C15.9617 18.4303 14.6003 21.2603 12.0596 22.8249C8.37979 25.091 3.61954 23.8445 1.4273 20.0406C-0.543501 16.621 0.232069 12.2995 3.08201 9.81443C3.24347 9.67365 3.48477 9.69482 3.62097 9.86172C3.75717 10.0286 3.73669 10.2781 3.57522 10.4188C1.00682 12.6584 0.308409 16.5542 2.08447 19.6359C4.0544 23.054 8.32484 24.1813 11.6375 22.1644C9.68242 20.4996 8.67875 17.9805 8.83551 15.4606C6.19406 14.0565 4.4307 11.1662 4.54166 7.89443C4.6948 3.37898 8.36009 -0.153184 12.7283 0.00511993C16.6553 0.147434 19.8129 3.22347 20.3001 7.124C20.3271 7.34056 20.1792 7.53878 19.9697 7.56674C19.7602 7.5947 19.5685 7.44181 19.5414 7.22525C19.1014 3.70232 16.2482 0.923893 12.7015 0.79536ZM12.3052 21.7033C14.1065 20.2999 15.0914 18.1233 15.082 15.8991C14.1747 16.2298 13.1934 16.394 12.1737 16.357C11.2619 16.324 10.3916 16.1327 9.58649 15.8097C9.53674 18.0568 10.5039 20.2704 12.3052 21.7033ZM15.76 14.7335C17.6981 13.6853 19.1219 11.7427 19.5005 9.4172C17.375 8.4023 14.9567 8.58261 13.0292 9.75325C13.6975 10.3236 14.2841 11.0204 14.7532 11.8343C15.2828 12.7532 15.614 13.7373 15.76 14.7335ZM12.3614 10.2143C13.0391 10.7543 13.6315 11.433 14.096 12.2389C14.6127 13.1356 14.92 14.1011 15.0327 15.0746C14.1567 15.4257 13.1989 15.6029 12.2005 15.5668C11.296 15.534 10.4367 15.3289 9.65099 14.9831C9.77584 14.0549 10.0785 13.1367 10.5718 12.2813C11.049 11.4539 11.6609 10.7609 12.3614 10.2143ZM11.6983 9.74629C9.82474 8.5819 7.4746 8.36108 5.3793 9.27553C5.70734 11.5581 7.05002 13.5139 8.93202 14.6158C9.08927 13.6743 9.41318 12.7461 9.9148 11.8764C10.3978 11.0389 11.0053 10.3255 11.6983 9.74629Z",fill:"#066869"})),react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath",{id:"clip0_493_16202"},react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect",{width:"24",height:"24",fill:"white",transform:"translate(0.333313)"}))),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Od},l))};Dd.displayName="Venn",Dd.defaultProps={height:24,title:null,width:24},Dd.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var jd=Dd,Wd=["title","width","height"],Id={position:"absolute",height:1,width:1,overflow:"hidden",clip:"rect(0, 0, 0, 0)",whiteSpace:"nowrap"},_d=function(a){var l=a.title,r=a.width,h=a.height,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Wd);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({"aria-hidden":"true",focusable:"false",height:h,preserveAspectRatio:"none",viewBox:"0 0 24 24",width:r},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("path",{transform:"scale(0.75 0.75)",d:"M16 .132c-6.623 0-12 5.377-12 12 0 5.023 3.094 9.326 7.477 11.113l-3.795 5.796a.334.334 0 0 0-.057.182c0 .445.362.766.818 1.011.456.245 1.073.444 1.818.614 1.49.338 3.505.545 5.739.545s4.248-.207 5.739-.545c.745-.17 1.362-.369 1.818-.614.456-.245.818-.566.818-1.011a.334.334 0 0 0-.057-.182l-3.795-5.796a12.067 12.067 0 0 0 7.102-8.102.367.367 0 0 0-.705-.204c-1.26 4.847-5.674 8.465-10.92 8.465A11.267 11.267 0 0 1 4.727 12.132C4.727 5.902 9.77.859 16 .859c6.23 0 11.273 5.043 11.273 11.273a.364.364 0 1 0 .727 0c0-6.623-5.377-12-12-12zm0 6.545a5.46 5.46 0 0 0-5.455 5.455A5.46 5.46 0 0 0 16 17.586a5.46 5.46 0 0 0 5.455-5.454A5.46 5.46 0 0 0 16 6.677zm0 .727a4.722 4.722 0 0 1 4.727 4.728A4.722 4.722 0 0 1 16 16.859a4.722 4.722 0 0 1-4.727-4.727A4.722 4.722 0 0 1 16 7.404zm-3.818 16.103a11.976 11.976 0 0 0 7.636 0l3.773 5.75c-.014.067-.085.2-.41.375-.353.19-.91.374-1.613.534-1.405.32-3.384.523-5.568.523-2.184 0-4.163-.204-5.568-.523-.703-.16-1.26-.344-1.614-.534-.324-.174-.395-.308-.409-.375l3.773-5.75z"})),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("span",{style:Id},l))};_d.displayName="Webinarreplay",_d.defaultProps={height:24,title:null,width:24},_d.propTypes={height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)};var Ud={"product-account":Jc,"product-apps":es,"product-blank":ls,"product-blog":cs,"product-book":ps,"product-bundle":gs,"product-certificate":bs,"product-checkmark-multicolor":Ms,"product-checkmark":Vs,"product-clipboard":Ps,"product-clock-small":Ts,"product-design":Ds,"product-digital-download":_s,"product-drip-schedule":Ks,"product-feature-afterpurchase":Ys,"product-flagship":ao,"product-gift":ho,"product-handshake":oo,"product-help":wo,"product-lightbulb":Eo,"product-logout":yo,"product-manage":Lo,"product-market-sell":xo,"product-messages":No,"product-microphone":Oo,"product-mini-course":Io,"product-page":qo,"product-payouts":Qo,"product-play":td,"product-pre-sell":rd,"product-preview":sd,"product-resource-library":md,"product-search-initial":vd,"product-search-no-result":Cd,"product-settings":Hd,"product-students":Rd,"product-updates":Bd,"product-upgrade":kd,"product-venn":jd,"product-webinar-replay":_d};(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.s)("",{insertAt:"top"});var Gd=["name","style","className","title","description"];function qd(e,t){var a=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);t&&(i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),a.push.apply(a,i)}return a}function Kd(e){for(var t=1;t<arguments.length;t++){var i=null!=arguments[t]?arguments[t]:{};t%2?qd(Object(i),!0).forEach((function(t){(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_4__._)(e,t,i[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(i)):qd(Object(i)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(i,t))}))}return e}var Xd=Kd(Kd({},Gc),Ud),Jd=Object.keys(Xd),Qd=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.b.bind({}),Yd=function(a){var l=a.name,r=a.style,h=a.className,n=a.title,c=a.description,s=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__._)(a,Gd),o=Qd("toga-icon","toga-icon-".concat(l),h),d=Xd[l]||null;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(d,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_1__.a)({className:o,description:c,style:r,title:n},s))};Yd.propTypes={className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.c,description:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),height:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number),name:prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(Jd).isRequired,style:prop_types__WEBPACK_IMPORTED_MODULE_2___default().shape({}),title:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),width:(prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)},Yd.defaultProps={className:null,style:{},title:null,description:"",height:24,width:24},Yd.displayName="Icon",Yd.filename=__filename,Yd.spreadAttributes=!0;var $d=Yd;
//# sourceMappingURL=Icon-343b84c4.js.map


/***/ }),

/***/ 65569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ u; }
/* harmony export */ });
/* unused harmony exports B, a, b */
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
/* harmony import */ var _Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79707);
/* harmony import */ var _Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42990);
var c=["className","isSmall","name","title"],f=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.s),u=function(e){var o=e.className,i=e.isSmall,r=e.name,n=e.title,p=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(e,c),u=f({"button--icon-only":!i,"button--icon-only-small":i},o);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.B,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({"aria-label":n,className:u},p),r&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.I,{name:r,title:n,"aria-hidden":!0}))};u.propTypes={className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c,isSmall:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),name:prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(_Icon_343b84c4_js__WEBPACK_IMPORTED_MODULE_4__.a).isRequired,title:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().string.isRequired)},u.defaultProps={className:null,isSmall:!1},u.displayName="IconButton",u.filename=__filename,u.spreadAttributes=!0;var d=(0,_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.w)({position:"left"})(_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.B);d.displayName="ButtonWithIconLeft";var b=(0,_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.w)({position:"right"})(_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.B);b.displayName="ButtonWithIconRight";var h=(0,_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.w)({position:"both"})(_Button_b37f2f11_js__WEBPACK_IMPORTED_MODULE_2__.B);h.displayName="ButtonWithBothIcon";
//# sourceMappingURL=IconButton-9b57b44f.js.map


/***/ }),

/***/ 28032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ E; }
});

// UNUSED EXPORTS: s

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/objectWithoutProperties-c7aad4d6.js
var objectWithoutProperties_c7aad4d6 = __webpack_require__(78776);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/getPrototypeOf-38c87d48.js
var getPrototypeOf_38c87d48 = __webpack_require__(23214);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/defineProperty-1e8516b1.js
var defineProperty_1e8516b1 = __webpack_require__(11841);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/isSymbol-e38f3509.js
var isSymbol_e38f3509 = __webpack_require__(96726);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/toString-363ab2b0.js
var n=Array.isArray;var i=function(r,t){for(var n=-1,i=null==r?0:r.length,a=Array(i);++n<i;)a[n]=t(r[n],n,r);return a},a=isSymbol_e38f3509.b?isSymbol_e38f3509.b.prototype:void 0,o=a?a.toString:void 0;var e=function r(a){if("string"==typeof a)return a;if(n(a))return i(a,r)+"";if((0,isSymbol_e38f3509.c)(a))return o?o.call(a):"";var e=a+"";return"0"==e&&1/a==-Infinity?"-0":e};var f=function(r){return null==r?"":e(r)};
//# sourceMappingURL=toString-363ab2b0.js.map

;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/uniqueId-bc45903f.js
var t=0;var uniqueId_bc45903f_a=function(a){var o=++t;return f(a)+o};
//# sourceMappingURL=uniqueId-bc45903f.js.map

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/prop-shapes-ac9385ac.js
var prop_shapes_ac9385ac = __webpack_require__(10518);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Label-86b7bb91.js
var Label_86b7bb91 = __webpack_require__(21976);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/Input-b1273534.js
var Input_b1273534_filename = "/index.js";
var h={"toga-form-group":"Input_toga-form-group__4","toga-form-error":"Input_toga-form-error__7","toga-form-text":"Input_toga-form-text__8","has-error":"Input_has-error__19","toga-form-control":"Input_toga-form-control__22","custom-select":"Input_custom-select__57","is-invalid":"Input_is-invalid__59","is-valid":"Input_is-valid__62","is-notice":"Input_is-notice__65","toga-control":"Input_toga-control__82","toga-control-label":"Input_toga-control-label__91","toga-control-label--empty":"Input_toga-control-label--empty__95","toga-control-input":"Input_toga-control-input__101",input__box:"Input_input__box__162","input__box__icon--left":"Input_input__box__icon--left__167","input__box__icon--right":"Input_input__box__icon--right__168","input__accessories-wrapper":"Input_input__accessories-wrapper__179","left-acessory__box":"Input_left-acessory__box__182","right-acessory__box":"Input_right-acessory__box__183",input__label:"Input_input__label__211",input__wrapper:"Input_input__wrapper__214","input__form-error":"Input_input__form-error__218","input__form-text":"Input_input__form-text__219","input__box__clear-button":"Input_input__box__clear-button__221","input__box--input":"Input_input__box--input__225","has-clear-button":"Input_has-clear-button__242","has-left-accessory":"Input_has-left-accessory__244","has-right-accessory":"Input_has-right-accessory__248","has-icon":"Input_has-icon__252","is-disabled":"Input_is-disabled__256","input--extra-small":"Input_input--extra-small__259","input--small":"Input_input--small__261","input--medium":"Input_input--medium__263","input--large":"Input_input--large__265","input--extra-large":"Input_input--extra-large__267","input__box-validation-message":"Input_input__box-validation-message__269","input__box-validation-message--error":"Input_input__box-validation-message--error__275","input__box-validation-message--success":"Input_input__box-validation-message--success__277",show:"Input_show__279",jumbo:"Input_jumbo__282"};function x(t){var o=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var r,_=(0,getPrototypeOf_38c87d48.a)(t);if(o){var a=(0,getPrototypeOf_38c87d48.a)(this).constructor;r=Reflect.construct(_,arguments,a)}else r=_.apply(this,arguments);return (0,getPrototypeOf_38c87d48.b)(this,r)}}(0,prop_shapes_ac9385ac.s)('.Input_toga-form-group__4{margin-bottom:1rem}.Input_toga-form-error__7,.Input_toga-form-text__8{display:inline-block;margin:8px 0 4px 4px;font-size:.875rem;line-height:1rem}.Input_toga-form-error__7{color:#d83232}.Input_toga-form-text__8{color:#6f7282}.Input_toga-form-text__8.Input_has-error__19{color:#d83232}.Input_toga-form-control__22{display:block;width:100%;height:40px;padding:8px 12px;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;border-radius:4px;border:1px solid #caccd6;background-clip:padding-box;background-color:#fff;color:#36394d;font-family:Source Sans Pro,sans-serif}.Input_toga-form-control__22:focus{border-color:#36394d;background-color:#fff;color:#36394d;box-shadow:none}.Input_toga-form-control__22::-ms-expand{border:0;background-color:transparent}.Input_toga-form-control__22::-moz-placeholder{color:#6f7282;opacity:1}.Input_toga-form-control__22:-ms-input-placeholder{color:#6f7282;opacity:1}.Input_toga-form-control__22::placeholder{color:#6f7282;opacity:1}.Input_toga-form-control__22[readonly]{opacity:1}.Input_toga-form-control__22:disabled,.Input_toga-form-control__22:disabled~[class*=toga-icon]{background-color:transparent;cursor:not-allowed;opacity:.45}.Input_toga-form-control__22.Input_custom-select__57{height:40px}.Input_toga-form-control__22.Input_is-invalid__59:focus{border-color:#d83232;box-shadow:none}.Input_toga-form-control__22.Input_is-valid__62:focus{border-color:#379a49;box-shadow:none}.Input_toga-form-control__22.Input_is-notice__65:focus{border-color:#ff7e40}.Input_toga-form-control__22[type=time]{max-width:130px}.Input_toga-form-control__22[type=time]::-webkit-clear-button{display:none;-webkit-appearance:none}.Input_toga-form-control__22[type=time]::-ms-clear{display:none}.Input_toga-form-control__22[type=time]::-webkit-inner-spin-button{cursor:pointer;-webkit-appearance:none}.Input_toga-form-control__22[type=time]:focus::-webkit-inner-spin-button,.Input_toga-form-control__22[type=time]:hover::-webkit-inner-spin-button{width:8px;background:#fff url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PHBhdGggZmlsbD0iIzYwNjQ2OSIgZD0iTTcuODU0IDE2Ljg1NEEuNS41IDAgMDE4LjIwNyAxNmg3LjU4NmEuNS41IDAgMDEuMzUzLjg1NGwtMy40MzkgMy40MzlhMSAxIDAgMDEtMS40MTQgMGwtMy40NC0zLjQ0em04LjI5Mi05LjcwOGEuNS41IDAgMDEtLjM1My44NTRIOC4yMDdhLjUuNSAwIDAxLS4zNTMtLjg1NGwzLjQzOS0zLjQzOWExIDEgMCAwMTEuNDE0IDBsMy40NCAzLjQ0eiIvPjwvc3ZnPg==") no-repeat 50%;background-size:24px 24px}.Input_toga-control__82{display:block;position:relative;min-height:1.5rem;padding-left:1.5rem}.Input_toga-control__82 [class*=icon-]{margin-left:4px;font-size:1.5rem;vertical-align:middle}.Input_toga-control__82 .Input_toga-control-label__91{color:#36394d;font-size:1rem;line-height:24px}.Input_toga-control__82 .Input_toga-control-label--empty__95{display:block}.Input_toga-control__82 .Input_toga-control-label--empty__95:after,.Input_toga-control__82 .Input_toga-control-label--empty__95:before{top:0;left:0}.Input_toga-control-input__101{position:absolute;left:0;width:1rem;height:1.25rem;opacity:0;z-index:-1}.Input_toga-control-input__101:checked~.Input_toga-control-label__91:before{border-color:#5668c7;background-color:#5668c7;color:#fff;box-shadow:none}.Input_toga-control-input__101:focus~.Input_toga-control-label__91:before{box-shadow:none}.Input_toga-control-input__101:focus:not(:checked)~.Input_toga-control-label__91:before{border-color:unset}.Input_toga-control-input__101:not(:disabled):active~.Input_toga-control-label__91:before{border-color:#dce0f3;background-color:#dce0f3;color:#fff;box-shadow:none}.Input_toga-control-input__101:hover~.Input_toga-control-label__91{cursor:pointer}.Input_toga-control-input__101:disabled~.Input_toga-control-label__91:focus,.Input_toga-control-input__101:disabled~.Input_toga-control-label__91:hover{cursor:default}.Input_toga-control-input__101~.Input_toga-control-label__91:before{border:unset}.Input_toga-control-input__101:disabled~.Input_toga-control-label__91,.Input_toga-control-input__101[disabled]~.Input_toga-control-label__91{color:#6c757d}.Input_toga-control-input__101:disabled~.Input_toga-control-label__91:before,.Input_toga-control-input__101[disabled]~.Input_toga-control-label__91:before{background-color:#e9ecef}.Input_toga-control-label__91{position:relative;margin-bottom:0;vertical-align:top}.Input_toga-control-label__91:before{transition:background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;display:block;position:absolute;top:.25rem;left:-1.5rem;width:1rem;height:1rem;border:1px solid #adb5bd;background-color:#fff;content:"";pointer-events:none}@media (prefers-reduced-motion:reduce){.Input_toga-control-label__91:before{transition:none}}.Input_toga-control-label__91:after{display:block;position:absolute;top:.25rem;left:-1.5rem;width:1rem;height:1rem;background:no-repeat 50%/50% 50%;content:""}.Input_input__box__162{display:flex;position:relative;flex-wrap:wrap;align-items:center}.Input_input__box__162 .Input_input__box__icon--left__167,.Input_input__box__162 .Input_input__box__icon--right__168{position:absolute;z-index:30;fill:#6f7282}.Input_input__box__162 .Input_input__box__icon--left__167{top:50%;left:12px;transform:translateY(-50%)}.Input_input__box__162 .Input_input__box__icon--right__168{right:4px;cursor:pointer}.Input_input__box__162 .Input_input__accessories-wrapper__179{display:flex;width:100%}.Input_input__box__162 .Input_left-acessory__box__182,.Input_input__box__162 .Input_right-acessory__box__183{display:flex;align-items:center;justify-content:center;height:40px;margin-bottom:0;padding:1px 12px;border:1px solid #caccd6;border-radius:4px;background-color:#f2f3f5;color:#12131a;font-size:1rem;font-weight:400;line-height:1.5;text-align:center}.Input_input__box__162 .Input_left-acessory__box__182.Input_has-error__19,.Input_input__box__162 .Input_right-acessory__box__183.Input_has-error__19{border-color:#d83232}.Input_input__box__162 .Input_left-acessory__box__182{margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0;z-index:20}.Input_input__box__162 .Input_right-acessory__box__183{margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0;z-index:20}.Input_input__box__162 .Input_input__label__211{flex-basis:100%;margin:0 0 8px 4px}.Input_input__box__162 .Input_input__wrapper__214{position:relative;flex-basis:0;flex-grow:1}.Input_input__box__162 .Input_input__form-error__218,.Input_input__box__162 .Input_input__form-text__219{width:100%}.Input_input__box__162 .Input_input__box__clear-button__221{top:50%;padding:0;transform:translateY(-50%)}.Input_input__box--input__225{position:relative;flex:1 1 auto;min-width:0;height:40px;margin:0;padding-left:12px;border:1px solid #caccd6;border-radius:4px;background-color:#fff;font-family:Source Sans Pro,sans-serif;font-size:1rem;z-index:21}.Input_input__box--input__225.Input_has-clear-button__242{padding-right:2.5rem}.Input_input__box--input__225.Input_has-left-accessory__244{flex:1;border-top-left-radius:0;border-bottom-left-radius:0}.Input_input__box--input__225.Input_has-right-accessory__248{flex:1;border-top-right-radius:0;border-bottom-right-radius:0}.Input_input__box--input__225.Input_has-icon__252{padding:0 40px}.Input_input__box--input__225.Input_has-error__19{border-color:#d83232}.Input_input__box--input__225.Input_is-disabled__256,.Input_input__box--input__225[aria-disabled=true]{cursor:not-allowed;opacity:.45}.Input_input__box--input__225.Input_input--extra-small__259{width:80px}.Input_input__box--input__225.Input_input--small__261{width:160px}.Input_input__box--input__225.Input_input--medium__263{width:200px}.Input_input__box--input__225.Input_input--large__265{width:320px}.Input_input__box--input__225.Input_input--extra-large__267{width:400px}.Input_input__box-validation-message__269{position:relative;top:-16px;left:4px;font-size:.875rem;opacity:0}.Input_input__box-validation-message--error__275{color:#d83232}.Input_input__box-validation-message--success__277{color:#379a49}.Input_input__box-validation-message__269.Input_show__279{opacity:1}.Input_jumbo__282{width:300px;max-width:none;height:80px;color:#139bde;font-size:2rem}',{insertAt:"top"});var y=prop_shapes_ac9385ac.b.bind(h),v=function(e){(0,getPrototypeOf_38c87d48._)(u,react.Component);var n=x(u);function u(t){var o;return (0,getPrototypeOf_38c87d48.c)(this,u),o=n.call(this,t),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"handleValueFieldChange",(function(t){var e=o.props,n=e.handleChange,r=e.validator,_=t.target.value,a=!0;r&&!r(_)&&(a=!1),a&&(o.setState({value:_}),n&&n(t))})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"sanitizeState",(function(t){var o={};return Object.keys(t).forEach((function(e){o[e]=t[e].trim?t[e].trim():t[e]})),o})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"handleBlur",(function(t){(0,o.props.handleBlur)(t,o.sanitizeState(o.state))})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"handleKeyDown",(function(t){(0,o.props.handleKeyDown)(t,o.sanitizeState(o.state))})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"handleKeyPress",(function(t){var e=o.props.onEnter;"Enter"===t.key&&null!==e&&e(t,o.sanitizeState(o.state))})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"resetInputValue",(function(){o.setState({value:""}),o.input&&o.input.select();var t=o.props,e=t.handleChange,n=t.name;e&&e({target:{value:"",name:n}})})),o.state={value:""},o.defaultId=uniqueId_bc45903f_a("input-"),o}return (0,getPrototypeOf_38c87d48.e)(u,[{key:"UNSAFE_componentWillMount",value:function(){var t=this.props.initValue;t&&this.setState({value:t.toString()})}},{key:"componentDidMount",value:function(){this.props.autoFocus&&this.input.select()}},{key:"UNSAFE_componentWillReceiveProps",value:function(t){this.setState({value:t.initValue})}},{key:"render",value:function(){var o=this,e=this.props,n=e.ariaLabel,r=e.className,_=e.id,a=e.disabled,i=e.isDisabled,p=e.name,u=e.type,s=e.placeholder,c=e.maxLength,d=e.extraClasses,b=e.extraProps,I=e.label,h=e.leftAccessory,x=e.rightAccessory,v=e.autoFocus,E=e.hasError,N=e.hasNoGroup,k=e.isRequired,z=e.icon,j=e.hasClearButton,A=e.wrapperClass,D=e.formText,M=e.errorText,S=this.state.value,C=_||this.defaultId,L=k||(null==b?void 0:b.required),P=!!I,B=I;"string"==typeof I&&(B=react.createElement(Label_86b7bb91.L,{className:y("input__label"),htmlFor:C},I,L&&" *"));var T=i||a||(null==b?void 0:b.disabled);return void 0!==b.disabled&&(b.disabled=null),react.createElement("div",{className:y("input__box",A,r,{"toga-form-group":!N})},B,react.createElement(w,{hasError:E||!!M,leftAccessory:h,rightAccessory:x},react.createElement("div",{className:y("input__wrapper")},z&&react.createElement(Icon_343b84c4.I,{className:y("input__box__icon--left",{"label-spacing":P}),name:z,"aria-hidden":!0}),react.createElement("input",(0,objectWithoutProperties_c7aad4d6.a)({"aria-describedby":"".concat(C,"--msg"),"aria-disabled":T?"true":"","aria-invalid":E||!!M,"aria-label":n,autoFocus:v,className:y("input__box--input","toga-form-control",d,{"has-clear-button":j,"has-left-accessory":!!h,"has-right-accessory":!!x,"has-icon":z,"has-error":E||!!M,"is-disabled":T}),id:C,maxLength:c,name:p,placeholder:s,readOnly:T,ref:function(t){return o.input=t,o.input},required:L,type:u,value:S,onBlur:this.handleBlur,onChange:this.handleValueFieldChange,onKeyDown:this.handleKeyDown,onKeyPress:this.handleKeyPress},b)),j&&S&&react.createElement(IconButton_9b57b44f.I,{appearance:"utility",className:y("input__box__clear-button","input__box__icon--right",{"label-spacing":P}),name:"circle-fill-x",title:"Clear input",isSmall:!0,onClick:this.resetInputValue}))),react.createElement("div",{"aria-live":"polite",className:y("input__form-error"),id:"".concat(C,"--error"),role:"alert"},M&&react.createElement("div",{className:y("toga-form-error")},M)),react.createElement("div",{"aria-live":E?"polite":"off",className:y("input__form-text"),id:"".concat(C,"--msg"),role:E?"alert":""},D&&react.createElement("span",{className:y("toga-form-text",{"has-error":E})},D)))}}]),u}(),w=function(t){var o=t.leftAccessory,e=t.rightAccessory,n=t.hasError,r=t.children;return react.createElement(react.Fragment,null,o||e?react.createElement("div",{className:y("input__accessories-wrapper")},o&&react.createElement("span",{className:y("left-acessory__box",{"has-error":n})},o),r,e&&react.createElement("span",{className:y("right-acessory__box",{"has-error":n})},e)):r)};w.propTypes={children:(prop_types_default()).node,hasError:(prop_types_default()).bool,leftAccessory:(prop_types_default()).element,rightAccessory:(prop_types_default()).element},w.defaultProps={children:null,leftAccessory:null,rightAccessory:null,hasError:!1},v.propTypes={ariaLabel:(prop_types_default()).string,autoFocus:(prop_types_default()).bool,className:prop_shapes_ac9385ac.c,errorText:(prop_types_default()).node,extraClasses:(prop_types_default()).string,extraProps:(prop_types_default()).object,formText:(prop_types_default()).string,handleBlur:(prop_types_default()).func,handleChange:(prop_types_default()).func,handleKeyDown:(prop_types_default()).func,hasClearButton:(prop_types_default()).bool,hasError:(prop_types_default()).bool,hasNoGroup:(prop_types_default()).bool,icon:prop_types_default().oneOf(Icon_343b84c4.a),id:(prop_types_default()).string,initValue:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).number]),isDisabled:(prop_types_default()).bool,isRequired:(prop_types_default()).bool,label:(prop_types_default()).any,leftAccessory:(prop_types_default()).element,maxLength:(prop_types_default()).number,name:(prop_types_default()).string,placeholder:(prop_types_default()).string,rightAccessory:(prop_types_default()).element,type:(prop_types_default()).string,validator:(prop_types_default()).func,wrapperClass:(prop_types_default()).string,onEnter:(prop_types_default()).func},v.defaultProps={ariaLabel:"",autoFocus:!1,className:null,handleBlur:function(){},handleKeyDown:function(){},validator:function(){return!0},handleChange:null,hasClearButton:!1,hasError:!1,name:"",type:"text",initValue:"",isDisabled:!1,placeholder:"",extraProps:{},extraClasses:"",maxLength:null,label:null,id:null,icon:null,leftAccessory:null,rightAccessory:null,onEnter:null,hasNoGroup:!1,isRequired:!1,wrapperClass:null,formText:null,errorText:null},v.displayName="Input",v.filename=Input_b1273534_filename;var E=v;
//# sourceMappingURL=Input-b1273534.js.map


/***/ }),

/***/ 21976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.s)(".Label_label__2{display:inline-block;font-size:.875rem;font-weight:600;line-height:1rem}",{insertAt:"top"});var i=["className","children","htmlFor"],m=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind({label:"Label_label__2"}),n=function(r){var s=r.className,t=r.children,o=r.htmlFor,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__._)(r,i);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("label",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__.a)({className:m("label",s),htmlFor:o},n),t)};n.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c,htmlFor:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)},n.defaultProps={className:null,htmlFor:null},n.displayName="Label",n.filename=__filename;var p=n;
//# sourceMappingURL=Label-86b7bb91.js.map


/***/ }),

/***/ 75826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ x; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23214);
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11841);
/* harmony import */ var _taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10518);
/* harmony import */ var _index_bd43cdd3_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11424);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55029);
var v;function h(e){var n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,a=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.a)(e);if(n){var i=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.a)(this).constructor;r=Reflect.construct(a,arguments,i)}else r=a.apply(this,arguments);return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.b)(this,r)}}(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.s)(".Loader_loader__2{position:fixed;top:0;left:0;width:100%;height:4px;background:#fccd56;z-index:9999}@media (prefers-reduced-motion:no-preference){.Loader_loader__2{-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-name:Loader_move__1;animation-name:Loader_move__1;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}}@media (prefers-reduced-motion:reduce){.Loader_loader__2{-webkit-animation-duration:8s;animation-duration:8s;-webkit-animation-name:Loader_move__1;animation-name:Loader_move__1;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}}@-webkit-keyframes Loader_move__1{0%{left:-100%}50%{left:0}to{left:100%}}@keyframes Loader_move__1{0%{left:-100%}50%{left:0}to{left:100%}}.Loader_sr-only__29{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}",{insertAt:"top"});var L=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.b.bind({loader:"Loader_loader__2",move:"Loader_move__1","sr-only":"Loader_sr-only__29"}),g="undefined"!=typeof document?document.querySelector("body"):null,k=styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(v||(v=(0,_taggedTemplateLiteral_2207d3b5_js__WEBPACK_IMPORTED_MODULE_5__._)(["\n  && {\n    ","\n  }\n"])),(function(e){return"\n        background-color: ".concat(null!=(t=e.theme)&&null!==(o=t.loader)&&void 0!==o&&o.color?t.loader.color:null!=t&&null!==(n=t.color)&&void 0!==n&&n.primary?t.color.primary:null,";\n    ");var t,o,n})),w=function(t){(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__._)(l,react__WEBPACK_IMPORTED_MODULE_0__.Component);var o=h(l);function l(){var e;return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.c)(this,l),e=o.call(this),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.d)(e),"componentDidMount",(function(){g.appendChild(e.el)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_6__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.d)(e),"componentWillUnmount",(function(){g.removeChild(e.el)})),e.el="undefined"!=typeof document?document.createElement("div"):null,e}return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.e)(l,[{key:"render",value:function(){var e=this.props,t=e.accessibilityLabel,o=e.className,n=t?(0,_index_bd43cdd3_js__WEBPACK_IMPORTED_MODULE_7__.n)():null;return react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(react__WEBPACK_IMPORTED_MODULE_0__.createElement(_themeContext_ac5c7f19_js__WEBPACK_IMPORTED_MODULE_8__.T.Consumer,null,(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement(k,{"aria-labelledby":n,className:L("loader",o),theme:e}),t&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",{className:L("sr-only"),id:n,role:"alert"},t))})),this.el)}}]),l}();w.displayName="Loader",w.propTypes={accessibilityLabel:(prop_types__WEBPACK_IMPORTED_MODULE_9___default().string),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_3__.c},w.defaultProps={accessibilityLabel:"Loading",className:null},w.filename=__filename;var x=w;
//# sourceMappingURL=Loader-fe940c7c.js.map


/***/ }),

/***/ 59675:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ Z; },
/* harmony export */   "a": function() { return /* binding */ z; },
/* harmony export */   "b": function() { return /* binding */ G; },
/* harmony export */   "c": function() { return /* binding */ B; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23214);
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11841);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10518);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _warning_3202c820_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34826);
/* harmony import */ var _IconButton_9b57b44f_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65569);
/* harmony import */ var _H2_6b37956c_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(95483);
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78776);
var C=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function e(t){var o=[].slice.call(t.querySelectorAll("*"),0).reduce((function(t,o){return t.concat(o.shadowRoot?e(o.shadowRoot):[o])}),[]);return o.filter(l)};
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */
var o=/input|select|textarea|button|object/;function n(e){var t=e.offsetWidth<=0&&e.offsetHeight<=0;if(t&&!e.innerHTML)return!0;try{var o=window.getComputedStyle(e);return t?"visible"!==o.getPropertyValue("overflow")||e.scrollWidth<=0&&e.scrollHeight<=0:"none"==o.getPropertyValue("display")}catch(e){return console.warn("Failed to inspect element style"),!1}}function a(e,t){var a=e.nodeName.toLowerCase();return(o.test(a)&&!e.disabled||"a"===a&&e.href||t)&&function(e){for(var t=e,o=e.getRootNode&&e.getRootNode();t&&t!==document.body;){if(o&&t===o&&(t=o.host.parentNode),n(t))return!1;t=t.parentNode}return!0}(e)}function l(e){var t=e.getAttribute("tabindex");null===t&&(t=void 0);var o=isNaN(t);return(o||t>=0)&&a(e,!o)}e.exports=t.default}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(C);var w=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.resetState=function(){a=[]},t.log=function(){ false&&(0)},t.handleBlur=s,t.handleFocus=i,t.markForFocusLater=function(){a.push(document.activeElement)},t.returnFocus=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=null;try{return void(0!==a.length&&(t=a.pop()).focus({preventScroll:e}))}catch(e){console.warn(["You tried to return focus to",t,"but it is not in the DOM anymore"].join(" "))}},t.popWithoutFocus=function(){a.length>0&&a.pop()},t.setupScopedFocus=function(e){l=e,window.addEventListener?(window.addEventListener("blur",s,!1),document.addEventListener("focus",i,!0)):(window.attachEvent("onBlur",s),document.attachEvent("onFocus",i))},t.teardownScopedFocus=function(){l=null,window.addEventListener?(window.removeEventListener("blur",s),document.removeEventListener("focus",i)):(window.detachEvent("onBlur",s),document.detachEvent("onFocus",i))};var o,n=(o=C)&&o.__esModule?o:{default:o};var a=[],l=null,r=!1;function s(){r=!0}function i(){if(r){if(r=!1,!l)return;setTimeout((function(){l.contains(document.activeElement)||((0,n.default)(l)[0]||l).focus()}),0)}}}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(w),w.resetState,w.log,w.handleBlur,w.handleFocus,w.markForFocusLater,w.returnFocus,w.popWithoutFocus,w.setupScopedFocus,w.teardownScopedFocus;var M=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t){var o=(0,n.default)(e);if(!o.length)return void t.preventDefault();var l=void 0,r=t.shiftKey,s=o[0],i=o[o.length-1],d=a();if(e===d){if(!r)return;l=i}i!==d||r||(l=s);s===d&&r&&(l=i);if(l)return t.preventDefault(),void l.focus();var u=/(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);if(null==u||"Chrome"==u[1]||null!=/\biPod\b|\biPad\b/g.exec(navigator.userAgent))return;var c=o.indexOf(d);c>-1&&(c+=r?-1:1);if(void 0===(l=o[c]))return t.preventDefault(),void(l=r?i:s).focus();t.preventDefault(),l.focus()};var o,n=(o=C)&&o.__esModule?o:{default:o};function a(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:document;return e.activeElement.shadowRoot?a(e.activeElement.shadowRoot):e.activeElement}e.exports=t.default}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(M);var N=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e){
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
var t,o;t=!("undefined"==typeof window||!window.document||!window.document.createElement),o={canUseDOM:t,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:t&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:t&&!!window.screen},e.exports?e.exports=o:window.ExecutionEnvironment=o})),E=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){var o;Object.defineProperty(t,"__esModule",{value:!0}),t.canUseDOM=t.SafeNodeList=t.SafeHTMLCollection=void 0;var n=((o=N)&&o.__esModule?o:{default:o}).default,a=n.canUseDOM?window.HTMLElement:{};t.SafeHTMLCollection=n.canUseDOM?window.HTMLCollection:{},t.SafeNodeList=n.canUseDOM?window.NodeList:{},t.canUseDOM=n.canUseDOM,t.default=a}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(E),E.canUseDOM,E.SafeNodeList,E.SafeHTMLCollection;var S=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.resetState=function(){a&&(a.removeAttribute?a.removeAttribute("aria-hidden"):null!=a.length?a.forEach((function(e){return e.removeAttribute("aria-hidden")})):document.querySelectorAll(a).forEach((function(e){return e.removeAttribute("aria-hidden")})));a=null},t.log=function(){if(false){ var e; }},t.assertNodeList=l,t.setElement=function(e){var t=e;if("string"==typeof t&&E.canUseDOM){var o=document.querySelectorAll(t);l(o,t),t=o}return a=t||a},t.validateElement=r,t.hide=function(e){var t=!0,o=!1,n=void 0;try{for(var a,l=r(e)[Symbol.iterator]();!(t=(a=l.next()).done);t=!0){a.value.setAttribute("aria-hidden","true")}}catch(e){o=!0,n=e}finally{try{!t&&l.return&&l.return()}finally{if(o)throw n}}},t.show=function(e){var t=!0,o=!1,n=void 0;try{for(var a,l=r(e)[Symbol.iterator]();!(t=(a=l.next()).done);t=!0){a.value.removeAttribute("aria-hidden")}}catch(e){o=!0,n=e}finally{try{!t&&l.return&&l.return()}finally{if(o)throw n}}},t.documentNotReadyOrSSRTesting=function(){a=null};var o,n=(o=_warning_3202c820_js__WEBPACK_IMPORTED_MODULE_3__.w)&&o.__esModule?o:{default:o};var a=null;function l(e,t){if(!e||!e.length)throw new Error("react-modal: No elements were found for selector "+t+".")}function r(e){var t=e||a;return t?Array.isArray(t)||t instanceof HTMLCollection||t instanceof NodeList?t:[t]:((0,n.default)(!1,["react-modal: App element is not defined.","Please use `Modal.setAppElement(el)` or set `appElement={el}`.","This is needed so screen readers don't see main content","when modal is opened. It is not recommended, but you can opt-out","by setting `ariaHideApp={false}`."].join(" ")),[])}}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(S),S.resetState,S.log,S.assertNodeList,S.setElement,S.validateElement,S.hide,S.show,S.documentNotReadyOrSSRTesting;var x=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.resetState=function(){var e=document.getElementsByTagName("html")[0];for(var t in o)a(e,o[t]);var l=document.body;for(var r in n)a(l,n[r]);o={},n={}},t.log=function(){if(false){ var l, a, e, t; }};var o={},n={};function a(e,t){e.classList.remove(t)}t.add=function(e,t){return a=e.classList,l="html"==e.nodeName.toLowerCase()?o:n,void t.split(" ").forEach((function(e){!function(e,t){e[t]||(e[t]=0),e[t]+=1}(l,e),a.add(e)}));var a,l},t.remove=function(e,t){return a=e.classList,l="html"==e.nodeName.toLowerCase()?o:n,void t.split(" ").forEach((function(e){!function(e,t){e[t]&&(e[t]-=1)}(l,e),0===l[e]&&a.remove(e)}));var a,l}}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(x),x.resetState,x.log,x.add,x.remove;var R=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.log=function(){console.log("portalOpenInstances ----------"),console.log(n.openInstances.length),n.openInstances.forEach((function(e){return console.log(e)})),console.log("end portalOpenInstances ----------")},t.resetState=function(){n=new o};var o=function e(){var t=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.register=function(e){-1===t.openInstances.indexOf(e)?(t.openInstances.push(e),t.emit("register")): false&&0},this.deregister=function(e){var o=t.openInstances.indexOf(e);-1!==o?(t.openInstances.splice(o,1),t.emit("deregister")): false&&0},this.subscribe=function(e){t.subscribers.push(e)},this.emit=function(e){t.subscribers.forEach((function(o){return o(e,t.openInstances.slice())}))},this.openInstances=[],this.subscribers=[]},n=new o;t.default=n}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(R),R.log,R.resetState;var T=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.resetState=function(){for(var e=[a,l],t=0;t<e.length;t++){var o=e[t];o&&(o.parentNode&&o.parentNode.removeChild(o))}a=l=null,r=[]},t.log=function(){console.log("bodyTrap ----------"),console.log(r.length);for(var e=[a,l],t=0;t<e.length;t++){var o=e[t]||{};console.log(o.nodeName,o.className,o.id)}console.log("edn bodyTrap ----------")};var o,n=(o=R)&&o.__esModule?o:{default:o};var a=void 0,l=void 0,r=[];function s(){0!==r.length?r[r.length-1].focusContent(): false&&0}n.default.subscribe((function(e,t){a||l||((a=document.createElement("div")).setAttribute("data-react-modal-body-trap",""),a.style.position="absolute",a.style.opacity="0",a.setAttribute("tabindex","0"),a.addEventListener("focus",s),(l=a.cloneNode()).addEventListener("focus",s)),(r=t).length>0?(document.body.firstChild!==a&&document.body.insertBefore(a,document.body.firstChild),document.body.lastChild!==l&&document.body.appendChild(l)):(a.parentElement&&a.parentElement.removeChild(a),l.parentElement&&l.parentElement.removeChild(l))}))}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(T),T.resetState,T.log;var A=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},a=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),l=h((prop_types__WEBPACK_IMPORTED_MODULE_4___default())),r=m(w),i=h(M),u=m(S),c=m(x),f=h(E),p=h(R);function m(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}function h(e){return e&&e.__esModule?e:{default:e}}var v={overlay:"ReactModal__Overlay",content:"ReactModal__Content"},_=0,y=function(e){function t(e){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,t);var o=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return o.setOverlayRef=function(e){o.overlay=e,o.props.overlayRef&&o.props.overlayRef(e)},o.setContentRef=function(e){o.content=e,o.props.contentRef&&o.props.contentRef(e)},o.afterClose=function(){var e=o.props,t=e.appElement,n=e.ariaHideApp,a=e.htmlOpenClassName,l=e.bodyOpenClassName;l&&c.remove(document.body,l),a&&c.remove(document.getElementsByTagName("html")[0],a),n&&_>0&&0===(_-=1)&&u.show(t),o.props.shouldFocusAfterRender&&(o.props.shouldReturnFocusAfterClose?(r.returnFocus(o.props.preventScroll),r.teardownScopedFocus()):r.popWithoutFocus()),o.props.onAfterClose&&o.props.onAfterClose(),p.default.deregister(o)},o.open=function(){o.beforeOpen(),o.state.afterOpen&&o.state.beforeClose?(clearTimeout(o.closeTimer),o.setState({beforeClose:!1})):(o.props.shouldFocusAfterRender&&(r.setupScopedFocus(o.node),r.markForFocusLater()),o.setState({isOpen:!0},(function(){o.openAnimationFrame=requestAnimationFrame((function(){o.setState({afterOpen:!0}),o.props.isOpen&&o.props.onAfterOpen&&o.props.onAfterOpen({overlayEl:o.overlay,contentEl:o.content})}))})))},o.close=function(){o.props.closeTimeoutMS>0?o.closeWithTimeout():o.closeWithoutTimeout()},o.focusContent=function(){return o.content&&!o.contentHasFocus()&&o.content.focus({preventScroll:!0})},o.closeWithTimeout=function(){var e=Date.now()+o.props.closeTimeoutMS;o.setState({beforeClose:!0,closesAt:e},(function(){o.closeTimer=setTimeout(o.closeWithoutTimeout,o.state.closesAt-Date.now())}))},o.closeWithoutTimeout=function(){o.setState({beforeClose:!1,isOpen:!1,afterOpen:!1,closesAt:null},o.afterClose)},o.handleKeyDown=function(e){9===e.keyCode&&(0,i.default)(o.content,e),o.props.shouldCloseOnEsc&&27===e.keyCode&&(e.stopPropagation(),o.requestClose(e))},o.handleOverlayOnClick=function(e){null===o.shouldClose&&(o.shouldClose=!0),o.shouldClose&&o.props.shouldCloseOnOverlayClick&&(o.ownerHandlesClose()?o.requestClose(e):o.focusContent()),o.shouldClose=null},o.handleContentOnMouseUp=function(){o.shouldClose=!1},o.handleOverlayOnMouseDown=function(e){o.props.shouldCloseOnOverlayClick||e.target!=o.overlay||e.preventDefault()},o.handleContentOnClick=function(){o.shouldClose=!1},o.handleContentOnMouseDown=function(){o.shouldClose=!1},o.requestClose=function(e){return o.ownerHandlesClose()&&o.props.onRequestClose(e)},o.ownerHandlesClose=function(){return o.props.onRequestClose},o.shouldBeClosed=function(){return!o.state.isOpen&&!o.state.beforeClose},o.contentHasFocus=function(){return document.activeElement===o.content||o.content.contains(document.activeElement)},o.buildClassName=function(e,t){var a="object"===(void 0===t?"undefined":n(t))?t:{base:v[e],afterOpen:v[e]+"--after-open",beforeClose:v[e]+"--before-close"},l=a.base;return o.state.afterOpen&&(l=l+" "+a.afterOpen),o.state.beforeClose&&(l=l+" "+a.beforeClose),"string"==typeof t&&t?l+" "+t:l},o.attributesFromObject=function(e,t){return Object.keys(t).reduce((function(o,n){return o[e+"-"+n]=t[n],o}),{})},o.state={afterOpen:!1,beforeClose:!1},o.shouldClose=null,o.moveFromContentToOverlay=null,o}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,react__WEBPACK_IMPORTED_MODULE_0__.Component),a(t,[{key:"componentDidMount",value:function(){this.props.isOpen&&this.open()}},{key:"componentDidUpdate",value:function(e,t){ false&&(0),this.props.isOpen&&!e.isOpen?this.open():!this.props.isOpen&&e.isOpen&&this.close(),this.props.shouldFocusAfterRender&&this.state.isOpen&&!t.isOpen&&this.focusContent()}},{key:"componentWillUnmount",value:function(){this.state.isOpen&&this.afterClose(),clearTimeout(this.closeTimer),cancelAnimationFrame(this.openAnimationFrame)}},{key:"beforeOpen",value:function(){var e=this.props,t=e.appElement,o=e.ariaHideApp,n=e.htmlOpenClassName,a=e.bodyOpenClassName;a&&c.add(document.body,a),n&&c.add(document.getElementsByTagName("html")[0],n),o&&(_+=1,u.hide(t)),p.default.register(this)}},{key:"render",value:function(){var e=this.props,t=e.id,n=e.className,a=e.overlayClassName,l=e.defaultStyles,r=e.children,s=n?{}:l.content,i=a?{}:l.overlay;if(this.shouldBeClosed())return null;var d={ref:this.setOverlayRef,className:this.buildClassName("overlay",a),style:o({},i,this.props.style.overlay),onClick:this.handleOverlayOnClick,onMouseDown:this.handleOverlayOnMouseDown},u=o({id:t,ref:this.setContentRef,style:o({},s,this.props.style.content),className:this.buildClassName("content",n),tabIndex:"-1",onKeyDown:this.handleKeyDown,onMouseDown:this.handleContentOnMouseDown,onMouseUp:this.handleContentOnMouseUp,onClick:this.handleContentOnClick,role:this.props.role,"aria-label":this.props.contentLabel},this.attributesFromObject("aria",o({modal:!0},this.props.aria)),this.attributesFromObject("data",this.props.data||{}),{"data-testid":this.props.testId}),c=this.props.contentElement(u,r);return this.props.overlayElement(d,c)}}]),t}();y.defaultProps={style:{overlay:{},content:{}},defaultStyles:{}},y.propTypes={isOpen:l.default.bool.isRequired,defaultStyles:l.default.shape({content:l.default.object,overlay:l.default.object}),style:l.default.shape({content:l.default.object,overlay:l.default.object}),className:l.default.oneOfType([l.default.string,l.default.object]),overlayClassName:l.default.oneOfType([l.default.string,l.default.object]),bodyOpenClassName:l.default.string,htmlOpenClassName:l.default.string,ariaHideApp:l.default.bool,appElement:l.default.oneOfType([l.default.instanceOf(f.default),l.default.instanceOf(E.SafeHTMLCollection),l.default.instanceOf(E.SafeNodeList),l.default.arrayOf(l.default.instanceOf(f.default))]),onAfterOpen:l.default.func,onAfterClose:l.default.func,onRequestClose:l.default.func,closeTimeoutMS:l.default.number,shouldFocusAfterRender:l.default.bool,shouldCloseOnOverlayClick:l.default.bool,shouldReturnFocusAfterClose:l.default.bool,preventScroll:l.default.bool,role:l.default.string,contentLabel:l.default.string,aria:l.default.object,data:l.default.object,children:l.default.node,shouldCloseOnEsc:l.default.bool,overlayRef:l.default.func,contentRef:l.default.func,id:l.default.string,overlayElement:l.default.func,contentElement:l.default.func,testId:l.default.string},t.default=y,e.exports=t.default}));function F(){var e=this.constructor.getDerivedStateFromProps(this.props,this.state);null!=e&&this.setState(e)}function P(e){this.setState(function(t){var o=this.constructor.getDerivedStateFromProps(e,t);return null!=o?o:null}.bind(this))}function j(e,t){try{var o=this.props,n=this.state;this.props=e,this.state=t,this.__reactInternalSnapshotFlag=!0,this.__reactInternalSnapshot=this.getSnapshotBeforeUpdate(o,n)}finally{this.props=o,this.state=n}}(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(A),F.__suppressDeprecationWarning=!0,P.__suppressDeprecationWarning=!0,j.__suppressDeprecationWarning=!0;var D=Object.freeze({__proto__:null,polyfill:function(e){var t=e.prototype;if(!t||!t.isReactComponent)throw new Error("Can only polyfill class components");if("function"!=typeof e.getDerivedStateFromProps&&"function"!=typeof t.getSnapshotBeforeUpdate)return e;var o=null,n=null,a=null;if("function"==typeof t.componentWillMount?o="componentWillMount":"function"==typeof t.UNSAFE_componentWillMount&&(o="UNSAFE_componentWillMount"),"function"==typeof t.componentWillReceiveProps?n="componentWillReceiveProps":"function"==typeof t.UNSAFE_componentWillReceiveProps&&(n="UNSAFE_componentWillReceiveProps"),"function"==typeof t.componentWillUpdate?a="componentWillUpdate":"function"==typeof t.UNSAFE_componentWillUpdate&&(a="UNSAFE_componentWillUpdate"),null!==o||null!==n||null!==a){var l=e.displayName||e.name,r="function"==typeof e.getDerivedStateFromProps?"getDerivedStateFromProps()":"getSnapshotBeforeUpdate()";throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n"+l+" uses "+r+" but also contains the following legacy lifecycles:"+(null!==o?"\n  "+o:"")+(null!==n?"\n  "+n:"")+(null!==a?"\n  "+a:"")+"\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks")}if("function"==typeof e.getDerivedStateFromProps&&(t.componentWillMount=F,t.componentWillReceiveProps=P),"function"==typeof t.getSnapshotBeforeUpdate){if("function"!=typeof t.componentDidUpdate)throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");t.componentWillUpdate=j;var s=t.componentDidUpdate;t.componentDidUpdate=function(e,t,o){var n=this.__reactInternalSnapshotFlag?this.__reactInternalSnapshot:o;s.call(this,e,t,n)}}return e}}),k=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.g)(D),U=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.bodyOpenClassName=t.portalClassName=void 0;var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n])}return e},n=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),a=f(react__WEBPACK_IMPORTED_MODULE_0__),l=f(react_dom__WEBPACK_IMPORTED_MODULE_1__),r=f((prop_types__WEBPACK_IMPORTED_MODULE_4___default())),i=f(A),u=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t.default=e,t}(S),c=f(E);function f(e){return e&&e.__esModule?e:{default:e}}function p(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function m(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}var h=t.portalClassName="ReactModalPortal",_=t.bodyOpenClassName="ReactModal__Body--open",y=E.canUseDOM&&void 0!==l.default.createPortal,b=function(e){return document.createElement(e)},O=function(){return y?l.default.createPortal:l.default.unstable_renderSubtreeIntoContainer};function g(e){return e()}var C=function(e){function t(){var e,n,r;p(this,t);for(var s=arguments.length,d=Array(s),u=0;u<s;u++)d[u]=arguments[u];return n=r=m(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(d))),r.removePortal=function(){!y&&l.default.unmountComponentAtNode(r.node);var e=g(r.props.parentSelector);e&&e.contains(r.node)?e.removeChild(r.node):console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.')},r.portalRef=function(e){r.portal=e},r.renderPortal=function(e){var n=O()(r,a.default.createElement(i.default,o({defaultStyles:t.defaultStyles},e)),r.node);r.portalRef(n)},m(r,n)}return function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}(t,react__WEBPACK_IMPORTED_MODULE_0__.Component),n(t,[{key:"componentDidMount",value:function(){E.canUseDOM&&(y||(this.node=b("div")),this.node.className=this.props.portalClassName,g(this.props.parentSelector).appendChild(this.node),!y&&this.renderPortal(this.props))}},{key:"getSnapshotBeforeUpdate",value:function(e){return{prevParent:g(e.parentSelector),nextParent:g(this.props.parentSelector)}}},{key:"componentDidUpdate",value:function(e,t,o){if(E.canUseDOM){var n=this.props,a=n.isOpen,l=n.portalClassName;e.portalClassName!==l&&(this.node.className=l);var r=o.prevParent,s=o.nextParent;s!==r&&(r.removeChild(this.node),s.appendChild(this.node)),(e.isOpen||a)&&!y&&this.renderPortal(this.props)}}},{key:"componentWillUnmount",value:function(){if(E.canUseDOM&&this.node&&this.portal){var e=this.portal.state,t=Date.now(),o=e.isOpen&&this.props.closeTimeoutMS&&(e.closesAt||t+this.props.closeTimeoutMS);o?(e.beforeClose||this.portal.closeWithTimeout(),setTimeout(this.removePortal,o-t)):this.removePortal()}}},{key:"render",value:function(){return E.canUseDOM&&y?(!this.node&&y&&(this.node=b("div")),O()(a.default.createElement(i.default,o({ref:this.portalRef,defaultStyles:t.defaultStyles},this.props)),this.node)):null}}],[{key:"setAppElement",value:function(e){u.setElement(e)}}]),t}();C.propTypes={isOpen:r.default.bool.isRequired,style:r.default.shape({content:r.default.object,overlay:r.default.object}),portalClassName:r.default.string,bodyOpenClassName:r.default.string,htmlOpenClassName:r.default.string,className:r.default.oneOfType([r.default.string,r.default.shape({base:r.default.string.isRequired,afterOpen:r.default.string.isRequired,beforeClose:r.default.string.isRequired})]),overlayClassName:r.default.oneOfType([r.default.string,r.default.shape({base:r.default.string.isRequired,afterOpen:r.default.string.isRequired,beforeClose:r.default.string.isRequired})]),appElement:r.default.oneOfType([r.default.instanceOf(c.default),r.default.instanceOf(E.SafeHTMLCollection),r.default.instanceOf(E.SafeNodeList),r.default.arrayOf(r.default.instanceOf(c.default))]),onAfterOpen:r.default.func,onRequestClose:r.default.func,closeTimeoutMS:r.default.number,ariaHideApp:r.default.bool,shouldFocusAfterRender:r.default.bool,shouldCloseOnOverlayClick:r.default.bool,shouldReturnFocusAfterClose:r.default.bool,preventScroll:r.default.bool,parentSelector:r.default.func,aria:r.default.object,data:r.default.object,role:r.default.string,contentLabel:r.default.string,shouldCloseOnEsc:r.default.bool,overlayRef:r.default.func,contentRef:r.default.func,id:r.default.string,overlayElement:r.default.func,contentElement:r.default.func},C.defaultProps={isOpen:!1,portalClassName:h,bodyOpenClassName:_,role:"dialog",ariaHideApp:!0,closeTimeoutMS:0,shouldFocusAfterRender:!0,shouldCloseOnEsc:!0,shouldCloseOnOverlayClick:!0,shouldReturnFocusAfterClose:!0,preventScroll:!1,parentSelector:function(){return document.body},overlayElement:function(e,t){return a.default.createElement("div",e,t)},contentElement:function(e,t){return a.default.createElement("div",e,t)}},C.defaultStyles={overlay:{position:"fixed",top:0,left:0,right:0,bottom:0,backgroundColor:"rgba(255, 255, 255, 0.75)"},content:{position:"absolute",top:"40px",left:"40px",right:"40px",bottom:"40px",border:"1px solid #ccc",background:"#fff",overflow:"auto",WebkitOverflowScrolling:"touch",borderRadius:"4px",outline:"none",padding:"20px"}},(0,k.polyfill)(C), false&&(0),t.default=C}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(U),U.bodyOpenClassName,U.portalClassName;var L=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)((0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){Object.defineProperty(t,"__esModule",{value:!0});var o,n=(o=U)&&o.__esModule?o:{default:o};t.default=n.default,e.exports=t.default}))),W={modal:"Modal_modal__2",modal__header:"Modal_modal__header__16","has-title":"Modal_has-title__23","modal__header__close-button":"Modal_modal__header__close-button__30",modal__body:"Modal_modal__body__36","no-padding":"Modal_no-padding__42","no-title":"Modal_no-title__44","allow-overflow":"Modal_allow-overflow__46",modal__footer:"Modal_modal__footer__51",overlay:"Modal_overlay__66","overlay--navigation-shown":"Modal_overlay--navigation-shown__74"};(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.s)(".Modal_modal__2{display:flex;position:absolute;top:50%;left:50%;flex-direction:column;width:560px;max-width:calc(100% - 24px);max-height:90vh!important;transform:translate3d(-50%,-50%,0);border-radius:4px;background-color:#fff;box-shadow:0 4px 12px 0 rgba(0,0,0,.25);overflow-y:auto}.Modal_modal__2 .Modal_modal__header__16{display:block}.Modal_modal__2 .Modal_modal__header__16>div{display:flex;align-items:center;justify-content:space-between;padding:16px 24px}.Modal_modal__2 .Modal_modal__header__16>div.Modal_has-title__23{border-bottom:1px solid #caccd6}.Modal_modal__2 .Modal_modal__header__16>div h3{margin:0}@media screen and (max-width:664px){.Modal_modal__2 .Modal_modal__header__16>div{padding:12px 16px}}.Modal_modal__2 .Modal_modal__header__close-button__30{margin-right:-8px;padding:8px;border:0;color:#36394d;font-size:1.5rem}.Modal_modal__2 .Modal_modal__body__36{flex-grow:1;padding:24px 24px 32px;background:#fbfbfb;font-size:1rem;overflow-y:auto}.Modal_modal__2 .Modal_modal__body__36.Modal_no-padding__42{padding:0}.Modal_modal__2 .Modal_modal__body__36.Modal_no-title__44{padding:24px}.Modal_modal__2 .Modal_modal__body__36.Modal_allow-overflow__46{overflow-y:visible;overflow-y:initial}@media screen and (max-width:664px){.Modal_modal__2 .Modal_modal__body__36{padding:24px 16px}}.Modal_modal__2 .Modal_modal__footer__51{display:flex;align-items:center;justify-content:flex-end;padding:16px 24px;border-top:1px solid #caccd6;text-align:right}.Modal_modal__2 .Modal_modal__footer__51 button:not(:first-child){margin-left:8px}@media screen and (max-width:664px){.Modal_modal__2 .Modal_modal__footer__51{padding:12px 16px}}.Modal_modal__2.Modal_allow-overflow__46{overflow-y:visible;overflow-y:initial}.Modal_overlay__66{position:fixed;top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.5);z-index:2703}.Modal_overlay--navigation-shown__74{top:56px;z-index:2699;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px)}@media (min-width:1265px){.Modal_overlay--navigation-shown__74{top:0}}",{insertAt:"top"});var H=["children","hasTitle"],q=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind(W),B=function(e){var t=e.children,o=e.hasTitle,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__._)(e,H);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__.a)({className:q("modal__header")},n),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:q({"has-title":o})},t))};B.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),hasTitle:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)},B.defaultProps={hasTitle:!1},B.displayName="ModalHeader",B.filename=__filename,B.spreadAttributes=!0;var I=["children","hasContentOverflow","hasTitle","isFullWidth"],V=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind(W),z=function(e){var t=e.children,o=e.hasContentOverflow,n=e.hasTitle,a=e.isFullWidth,l=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__._)(e,I);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__.a)({className:V("modal__body",{"no-padding":a,"no-title":!n,"allow-overflow":o})},l),t)};z.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),hasContentOverflow:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),hasTitle:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),isFullWidth:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool)},z.defaultProps={isFullWidth:!1,hasContentOverflow:!1,hasTitle:!1},z.displayName="ModalBody",z.filename=__filename,z.spreadAttributes=!0;var K=["children"],Y=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind(W),G=function(e){var t=e.children,o=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__._)(e,K);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_5__.a)({className:Y("modal__footer")},o),t)};function J(e){var n=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var a,l=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.a)(e);if(n){var r=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.a)(this).constructor;a=Reflect.construct(l,arguments,r)}else a=l.apply(this,arguments);return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.b)(this,a)}}G.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired)},G.displayName="ModalFooter",G.filename=__filename,G.spreadAttributes=!0;var Q=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind(W),X=function(t){(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__._)(d,react__WEBPACK_IMPORTED_MODULE_0__.Component);var o=J(d);function d(e){var t;return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.c)(this,d),t=o.call(this,e),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.d)(t),"UNSAFE_componentWillReceiveProps",(function(e){var o=e.isOpen;t.setState({isOpen:o})})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.d)(t),"findComponent",(function(e,t){return Array.isArray(e)&&e.find((function(e){return e.type.name===t.name}))})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.d)(t),"closeModal",(function(){var e=t.props,o=e.closeModal;e.isClosable&&(t.setState({isOpen:!1}),o())})),t.state={isOpen:e.isOpen},t}return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_6__.e)(d,[{key:"render",value:function(){var e=this.props,t=e.children,o=e.className,n=e.contentLabel,a=e.extraClassNames,l=e.footer,r=e.isFullWidth,i=e.isNavigationShown,d=e.hasContentOverflow,u=e.overlayClassName,c=e.style,f=e.title,p=this.state.isOpen,m=Q("overlay",{"overlay--navigation-shown":i},u);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(L,{aria:{labelledby:f&&"modalTitle"},ariaHideApp:!1,className:Q("modal",{"allow-overflow":d},a,o),contentLabel:n,isOpen:p,overlayClassName:m,style:c,onRequestClose:this.closeModal},this.findComponent(t,B),f&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(B,{hasTitle:!!f},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_H2_6b37956c_js__WEBPACK_IMPORTED_MODULE_8__.H,{className:Q("h4"),id:"modalTitle"},f),react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton_9b57b44f_js__WEBPACK_IMPORTED_MODULE_9__.I,{appearance:"utility",className:Q("modal__header__close-button"),name:"x-dismiss",title:"Close",onClick:this.closeModal})),this.findComponent(t,z)||react__WEBPACK_IMPORTED_MODULE_0__.createElement(z,{hasContentOverflow:d,hasTitle:!!f,isFullWidth:r},t),this.findComponent(t,G),l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement(G,null,l(this.closeModal)))}}]),d}();X.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,closeModal:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),contentLabel:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),extraClassNames:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,footer:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),hasContentOverflow:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),isClosable:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),isFullWidth:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),isNavigationShown:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),isOpen:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),overlayClassName:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,style:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().object),title:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node)},X.defaultProps={className:null,closeModal:function(){},contentLabel:"Modal",extraClassNames:null,footer:null,hasContentOverflow:!1,isClosable:!0,isFullWidth:!1,isOpen:!1,isNavigationShown:!1,overlayClassName:null,style:{},title:null},X.displayName="Modal",X.filename=__filename;var Z=X;
//# sourceMappingURL=Modal-06a02338.js.map


/***/ }),

/***/ 61783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ l; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
/* harmony import */ var _Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78618);
var i=["children","className"],t=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind(_Typography_module_f4624551_js__WEBPACK_IMPORTED_MODULE_2__.s),c=function(s){var o=s.children,p=s.className,m=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__._)(s,i),c=t("p",p);return react__WEBPACK_IMPORTED_MODULE_0__.createElement("p",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_3__.a)({className:c},m),o)};c.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c},c.defaultProps={className:null},c.displayName="P",c.filename=__filename;var l=c;
//# sourceMappingURL=P-3714214d.js.map


/***/ }),

/***/ 53325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ p; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23214);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
function s(t){var o=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var r,a=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.a)(t);if(o){var i=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.a)(this).constructor;r=Reflect.construct(a,arguments,i)}else r=a.apply(this,arguments);return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.b)(this,r)}}function f(t,e){var n="function"==typeof t?t():t;return((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(n)?react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(n):n)||e}var l=function(e){(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__._)(a,e);var n=s(a);function a(t){var e;return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.c)(this,a),(e=n.call(this,t)).state={mountNode:null},e}return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_2__.e)(a,[{key:"componentDidMount",value:function(){var t=this.props.container;this.setContainer(t)}},{key:"componentDidUpdate",value:function(t){var e=t.container,n=this.props.container;e!==n&&this.setContainer(n)}},{key:"setContainer",value:function(t){this.setState({mountNode:f(t,document.body)})}},{key:"render",value:function(){var t=this.props.children,e=this.state.mountNode;return e?react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(t,e):null}}]),a}(react__WEBPACK_IMPORTED_MODULE_0__.Component);l.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),container:prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),(prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)])},l.defaultProps={container:null},l.displayName="Portal",l.filename=__filename;var p=l;
//# sourceMappingURL=Portal-178fdc75.js.map


/***/ }),

/***/ 64828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ _; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78776);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10518);
(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.s)(".Surface_surface__2{border-radius:4px;background-color:#fff;box-shadow:0 2px 2px 0 rgba(0,0,0,.1),0 1px 3px 0 rgba(0,0,0,.06)}.Surface_surface--raised__6{border-radius:4px;background-color:#fff;box-shadow:0 4px 12px 0 rgba(0,0,0,.25)}.Surface_surface--form__10{border-radius:4px;background-color:#fbfbfb;box-shadow:0 2px 2px 0 rgba(0,0,0,.1),0 1px 3px 0 rgba(0,0,0,.06)}.Surface_surface--interactive__14{border:1px solid transparent}.Surface_surface--interactive__14:active,.Surface_surface--interactive__14:focus,.Surface_surface--interactive__14:hover{border:1px solid #caccd6}.Surface_surface--interactive__14:focus{outline-color:#caccd6}.Surface_surface__2.Surface_active__20{border:1px solid #36394d}",{insertAt:"top"});var t=["children","className","isInteractive","isRaised","tag","hasForm"],f=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.b.bind({surface:"Surface_surface__2","surface--raised":"Surface_surface--raised__6","surface--form":"Surface_surface--form__10","surface--interactive":"Surface_surface--interactive__14",active:"Surface_active__20"}),u=function(c){var s=c.children,i=c.className,o=c.isInteractive,u=c.isRaised,_=c.tag,d=c.hasForm,p=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__._)(c,t),n=f("surface",{"surface--interactive":o,"surface--raised":u,"surface--form":d},i);return o?react__WEBPACK_IMPORTED_MODULE_0__.createElement(_,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__.a)({className:n},p,{tabIndex:"0"}),s):react__WEBPACK_IMPORTED_MODULE_0__.createElement(_,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_2__.a)({className:n},p),s)};u.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().node.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_1__.c,hasForm:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),isInteractive:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),isRaised:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),tag:(prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)},u.defaultProps={className:null,hasForm:!1,isInteractive:!1,isRaised:!1,tag:"div"},u.displayName="Surface",u.filename=__filename,u.spreadAttributes=!0;var _=u;
//# sourceMappingURL=Surface-649a6d6c.js.map


/***/ }),

/***/ 20021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var __filename = "/index.js";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ tr; }
/* harmony export */ });
/* harmony import */ var _objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78776);
/* harmony import */ var _getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23214);
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11841);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10518);
/* harmony import */ var _warning_3202c820_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34826);
/* harmony import */ var _debounce_945d8015_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29908);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73935);
/* harmony import */ var _Portal_178fdc75_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53325);
var P=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(o,s){function c(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(s,"__esModule",{value:!0});var f=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.c),u=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.e),y=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.b),m=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.a),b=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__._),v=c(_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.f),g=c(_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__._),_=c(_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a),T=c(react__WEBPACK_IMPORTED_MODULE_0__),O=c((prop_types__WEBPACK_IMPORTED_MODULE_5___default())),E=c(_warning_3202c820_js__WEBPACK_IMPORTED_MODULE_6__.w);var P,x=(P=null,function(){if(null!==P)return P;var e,t,o,r=!1;try{window.addEventListener("test",null,(e={},t="passive",o={get:function(){r=!0}},Object.defineProperty(e,t,o)))}catch(e){}return P=r,r}()),A={capture:!1,passive:!1};function S(e){return _({},A,e)}function j(e,t,o){var r=[e,t];return r.push(x?o:o.capture),r}function N(e,t,o,r){e.addEventListener.apply(e,j(t,o,r))}function k(e,t,o,r){e.removeEventListener.apply(e,j(t,o,r))}function D(e,t){e.children,e.target;var o=g(e,["children","target"]);Object.keys(o).forEach((function(e){if("on"===e.substring(0,2)){var r=o[e],n=v(r),i="object"===n;if(i||"function"===n){var a="capture"===e.substr(-7).toLowerCase(),p=e.substring(2).toLowerCase();p=a?p.substring(0,p.length-7):p,i?t(p,r.handler,r.options):t(p,r,S({capture:a}))}}}))}var F=function(e){function t(){return f(this,t),y(this,m(t).apply(this,arguments))}return b(t,e),u(t,[{key:"componentDidMount",value:function(){this.applyListeners(N)}},{key:"componentDidUpdate",value:function(e){this.applyListeners(k,e),this.applyListeners(N)}},{key:"componentWillUnmount",value:function(){this.applyListeners(k)}},{key:"applyListeners",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.props,o=t.target;if(o){var r=o;"string"==typeof o&&(r=window[o]),D(t,e.bind(null,r))}}},{key:"render",value:function(){return this.props.children||null}}]),t}(T.PureComponent);F.propTypes= false?0:{},s.withOptions=function(e,t){return false&&0,{handler:e,options:S(t)}},s.default=F})),x=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(P);function A(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.g)(e,t)}P.withOptions;var S,j=Object.prototype.toString,N=function(e){var t=j.call(e),o="[object Arguments]"===t;return o||(o="[object Array]"!==t&&null!==e&&"object"==typeof e&&"number"==typeof e.length&&e.length>=0&&"[object Function]"===j.call(e.callee)),o};if(!Object.keys){var k=Object.prototype.hasOwnProperty,D=Object.prototype.toString,F=N,R=Object.prototype.propertyIsEnumerable,C=!R.call({toString:null},"toString"),I=R.call((function(){}),"prototype"),L=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"],M=function(e){var t=e.constructor;return t&&t.prototype===e},U={$applicationCache:!0,$console:!0,$external:!0,$frame:!0,$frameElement:!0,$frames:!0,$innerHeight:!0,$innerWidth:!0,$onmozfullscreenchange:!0,$onmozfullscreenerror:!0,$outerHeight:!0,$outerWidth:!0,$pageXOffset:!0,$pageYOffset:!0,$parent:!0,$scrollLeft:!0,$scrollTop:!0,$scrollX:!0,$scrollY:!0,$self:!0,$webkitIndexedDB:!0,$webkitStorageInfo:!0,$window:!0},B=function(){if("undefined"==typeof window)return!1;for(var e in window)try{if(!U["$"+e]&&k.call(window,e)&&null!==window[e]&&"object"==typeof window[e])try{M(window[e])}catch(e){return!0}}catch(e){return!0}return!1}();S=function(e){var t=null!==e&&"object"==typeof e,o="[object Function]"===D.call(e),r=F(e),n=t&&"[object String]"===D.call(e),i=[];if(!t&&!o&&!r)throw new TypeError("Object.keys called on a non-object");var a=I&&o;if(n&&e.length>0&&!k.call(e,0))for(var p=0;p<e.length;++p)i.push(String(p));if(r&&e.length>0)for(var l=0;l<e.length;++l)i.push(String(l));else for(var s in e)a&&"prototype"===s||!k.call(e,s)||i.push(String(s));if(C)for(var c=function(e){if("undefined"==typeof window||!B)return M(e);try{return M(e)}catch(e){return!1}}(e),f=0;f<L.length;++f)c&&"constructor"===L[f]||!k.call(e,L[f])||i.push(L[f]);return i}}var W=S,H=Array.prototype.slice,$=Object.keys,q=$?function(e){return $(e)}:W,V=Object.keys;q.shim=function(){if(Object.keys){var e=function(){var e=Object.keys(arguments);return e&&e.length===arguments.length}(1,2);e||(Object.keys=function(e){return N(e)?V(H.call(e)):V(e)})}else Object.keys=q;return Object.keys||q};var G=q,z=function(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var e={},t=Symbol("test"),o=Object(t);if("string"==typeof t)return!1;if("[object Symbol]"!==Object.prototype.toString.call(t))return!1;if("[object Symbol]"!==Object.prototype.toString.call(o))return!1;for(t in e[t]=42,e)return!1;if("function"==typeof Object.keys&&0!==Object.keys(e).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(e).length)return!1;var r=Object.getOwnPropertySymbols(e);if(1!==r.length||r[0]!==t)return!1;if(!Object.prototype.propertyIsEnumerable.call(e,t))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var n=Object.getOwnPropertyDescriptor(e,t);if(42!==n.value||!0!==n.enumerable)return!1}return!0},Y=function(){return z()&&!!Symbol.toStringTag},J="undefined"!=typeof Symbol&&Symbol,X="Function.prototype.bind called on incompatible ",K=Array.prototype.slice,Q=Object.prototype.toString,Z=Function.prototype.bind||function(e){var t=this;if("function"!=typeof t||"[object Function]"!==Q.call(t))throw new TypeError(X+t);for(var o,r=K.call(arguments,1),n=function(){if(this instanceof o){var n=t.apply(this,r.concat(K.call(arguments)));return Object(n)===n?n:this}return t.apply(e,r.concat(K.call(arguments)))},i=Math.max(0,t.length-r.length),a=[],p=0;p<i;p++)a.push("$"+p);if(o=Function("binder","return function ("+a.join(",")+"){ return binder.apply(this,arguments); }")(n),t.prototype){var l=function(){};l.prototype=t.prototype,o.prototype=new l,l.prototype=null}return o},ee=Z.call(Function.call,Object.prototype.hasOwnProperty),te=SyntaxError,oe=Function,re=TypeError,ne=function(e){try{return oe('"use strict"; return ('+e+").constructor;")()}catch(e){}},ie=Object.getOwnPropertyDescriptor;if(ie)try{ie({},"")}catch(e){ie=null}var ae=function(){throw new re},pe=ie?function(){try{return ae}catch(e){try{return ie(arguments,"callee").get}catch(e){return ae}}}():ae,le="function"==typeof J&&"function"==typeof Symbol&&"symbol"==typeof J("foo")&&"symbol"==typeof Symbol("bar")&&z(),se=Object.getPrototypeOf||function(e){return e.__proto__},ce={},fe="undefined"==typeof Uint8Array?undefined:se(Uint8Array),ue={"%AggregateError%":"undefined"==typeof AggregateError?undefined:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?undefined:ArrayBuffer,"%ArrayIteratorPrototype%":le?se([][Symbol.iterator]()):undefined,"%AsyncFromSyncIteratorPrototype%":undefined,"%AsyncFunction%":ce,"%AsyncGenerator%":ce,"%AsyncGeneratorFunction%":ce,"%AsyncIteratorPrototype%":ce,"%Atomics%":"undefined"==typeof Atomics?undefined:Atomics,"%BigInt%":"undefined"==typeof BigInt?undefined:BigInt,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?undefined:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":"undefined"==typeof Float32Array?undefined:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?undefined:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?undefined:FinalizationRegistry,"%Function%":oe,"%GeneratorFunction%":ce,"%Int8Array%":"undefined"==typeof Int8Array?undefined:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?undefined:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?undefined:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":le?se(se([][Symbol.iterator]())):undefined,"%JSON%":"object"==typeof JSON?JSON:undefined,"%Map%":"undefined"==typeof Map?undefined:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&le?se((new Map)[Symbol.iterator]()):undefined,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?undefined:Promise,"%Proxy%":"undefined"==typeof Proxy?undefined:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":"undefined"==typeof Reflect?undefined:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?undefined:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&le?se((new Set)[Symbol.iterator]()):undefined,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?undefined:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":le?se(""[Symbol.iterator]()):undefined,"%Symbol%":le?Symbol:undefined,"%SyntaxError%":te,"%ThrowTypeError%":pe,"%TypedArray%":fe,"%TypeError%":re,"%Uint8Array%":"undefined"==typeof Uint8Array?undefined:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?undefined:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?undefined:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?undefined:Uint32Array,"%URIError%":URIError,"%WeakMap%":"undefined"==typeof WeakMap?undefined:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?undefined:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?undefined:WeakSet},de=function e(t){var o;if("%AsyncFunction%"===t)o=ne("async function () {}");else if("%GeneratorFunction%"===t)o=ne("function* () {}");else if("%AsyncGeneratorFunction%"===t)o=ne("async function* () {}");else if("%AsyncGenerator%"===t){var r=e("%AsyncGeneratorFunction%");r&&(o=r.prototype)}else if("%AsyncIteratorPrototype%"===t){var n=e("%AsyncGenerator%");n&&(o=se(n.prototype))}return ue[t]=o,o},he={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},ye=Z.call(Function.call,Array.prototype.concat),me=Z.call(Function.apply,Array.prototype.splice),be=Z.call(Function.call,String.prototype.replace),ve=Z.call(Function.call,String.prototype.slice),ge=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,_e=/\\(\\)?/g,we=function(e){var t=ve(e,0,1),o=ve(e,-1);if("%"===t&&"%"!==o)throw new te("invalid intrinsic syntax, expected closing `%`");if("%"===o&&"%"!==t)throw new te("invalid intrinsic syntax, expected opening `%`");var r=[];return be(e,ge,(function(e,t,o,n){r[r.length]=o?be(n,_e,"$1"):t||e})),r},Te=function(e,t){var o,r=e;if(ee(he,r)&&(r="%"+(o=he[r])[0]+"%"),ee(ue,r)){var n=ue[r];if(n===ce&&(n=de(r)),void 0===n&&!t)throw new re("intrinsic "+e+" exists, but is not available. Please file an issue!");return{alias:o,name:r,value:n}}throw new te("intrinsic "+e+" does not exist!")},Oe=function(e,t){if("string"!=typeof e||0===e.length)throw new re("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof t)throw new re('"allowMissing" argument must be a boolean');var o=we(e),r=o.length>0?o[0]:"",n=Te("%"+r+"%",t),i=n.name,a=n.value,p=!1,l=n.alias;l&&(r=l[0],me(o,ye([0,1],l)));for(var s=1,c=!0;s<o.length;s+=1){var f=o[s],u=ve(f,0,1),d=ve(f,-1);if(('"'===u||"'"===u||"`"===u||'"'===d||"'"===d||"`"===d)&&u!==d)throw new te("property names with quotes must have matching quotes");if("constructor"!==f&&c||(p=!0),ee(ue,i="%"+(r+="."+f)+"%"))a=ue[i];else if(null!=a){if(!(f in a)){if(!t)throw new re("base intrinsic for "+e+" exists, but the property is not available.");return}if(ie&&s+1>=o.length){var h=ie(a,f);a=(c=!!h)&&"get"in h&&!("originalValue"in h.get)?h.get:a[f]}else c=ee(a,f),a=a[f];c&&!p&&(ue[i]=a)}}return a},Ee=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e){var t=Oe("%Function.prototype.apply%"),o=Oe("%Function.prototype.call%"),r=Oe("%Reflect.apply%",!0)||Z.call(o,t),n=Oe("%Object.getOwnPropertyDescriptor%",!0),i=Oe("%Object.defineProperty%",!0),a=Oe("%Math.max%");if(i)try{i({},"a",{value:1})}catch(e){i=null}e.exports=function(e){var t=r(Z,o,arguments);if(n&&i){var p=n(t,"length");p.configurable&&i(t,"length",{value:1+a(0,e.length-(arguments.length-1))})}return t};var p=function(){return r(Z,t,arguments)};i?i(e.exports,"apply",{value:p}):e.exports.apply=p}));Ee.apply;var Pe=Ee(Oe("String.prototype.indexOf")),xe=function(e,t){var o=Oe(e,!!t);return"function"==typeof o&&Pe(e,".prototype.")>-1?Ee(o):o},Ae=Y(),Se=xe("Object.prototype.toString"),je=function(e){return!(Ae&&e&&"object"==typeof e&&Symbol.toStringTag in e)&&"[object Arguments]"===Se(e)},Ne=function(e){return!!je(e)||null!==e&&"object"==typeof e&&"number"==typeof e.length&&e.length>=0&&"[object Array]"!==Se(e)&&"[object Function]"===Se(e.callee)},ke=function(){return je(arguments)}();je.isLegacyArguments=Ne;var De=ke?je:Ne,Fe="function"==typeof Symbol&&"symbol"==typeof Symbol("foo"),Re=Object.prototype.toString,Ce=Array.prototype.concat,Ie=Object.defineProperty,Le=Ie&&function(){var e={};try{for(var t in Ie(e,"x",{enumerable:!1,value:e}),e)return!1;return e.x===e}catch(e){return!1}}(),Me=function(e,t,o,r){var n;(!(t in e)||"function"==typeof(n=r)&&"[object Function]"===Re.call(n)&&r())&&(Le?Ie(e,t,{configurable:!0,enumerable:!1,value:o,writable:!0}):e[t]=o)},Ue=function(e,t){var o=arguments.length>2?arguments[2]:{},r=G(t);Fe&&(r=Ce.call(r,Object.getOwnPropertySymbols(t)));for(var n=0;n<r.length;n+=1)Me(e,r[n],t[r[n]],o[r[n]])};Ue.supportsDescriptors=!!Le;var Be=Ue,We=function(e){return e!=e},He=function(e,t){return 0===e&&0===t?1/e==1/t:e===t||!(!We(e)||!We(t))},$e=function(){return"function"==typeof Object.is?Object.is:He},qe=Ee($e(),Object);Be(qe,{getPolyfill:$e,implementation:He,shim:function(){var e=$e();return Be(Object,{is:e},{is:function(){return Object.is!==e}}),e}});var Ve,Ge,ze,Ye,Je=qe,Xe=Y();if(Xe){Ve=xe("Object.prototype.hasOwnProperty"),Ge=xe("RegExp.prototype.exec"),ze={};var Ke=function(){throw ze};Ye={toString:Ke,valueOf:Ke},"symbol"==typeof Symbol.toPrimitive&&(Ye[Symbol.toPrimitive]=Ke)}var Qe=xe("Object.prototype.toString"),Ze=Object.getOwnPropertyDescriptor,et=Xe?function(e){if(!e||"object"!=typeof e)return!1;var t=Ze(e,"lastIndex");if(!(t&&Ve(t,"value")))return!1;try{Ge(e,Ye)}catch(e){return e===ze}}:function(e){return!(!e||"object"!=typeof e&&"function"!=typeof e)&&"[object RegExp]"===Qe(e)},tt=Object,ot=TypeError,rt=function(){if(null!=this&&this!==tt(this))throw new ot("RegExp.prototype.flags getter called on non-object");var e="";return this.hasIndices&&(e+="d"),this.global&&(e+="g"),this.ignoreCase&&(e+="i"),this.multiline&&(e+="m"),this.dotAll&&(e+="s"),this.unicode&&(e+="u"),this.sticky&&(e+="y"),e},nt=Be.supportsDescriptors,it=Object.getOwnPropertyDescriptor,at=function(){if(nt&&"gim"===/a/gim.flags){var e=it(RegExp.prototype,"flags");if(e&&"function"==typeof e.get&&"boolean"==typeof/a/.dotAll)return e.get}return rt},pt=Be.supportsDescriptors,lt=Object.getOwnPropertyDescriptor,st=Object.defineProperty,ct=TypeError,ft=Object.getPrototypeOf,ut=/a/,dt=Ee(at());Be(dt,{getPolyfill:at,implementation:rt,shim:function(){if(!pt||!ft)throw new ct("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");var e=at(),t=ft(ut),o=lt(t,"flags");return o&&o.get===e||st(t,"flags",{configurable:!0,enumerable:!1,get:e}),e}});var ht=dt,yt=Date.prototype.getDay,mt=Object.prototype.toString,bt=Y(),vt=function(e){return"object"==typeof e&&null!==e&&(bt?function(e){try{return yt.call(e),!0}catch(e){return!1}}(e):"[object Date]"===mt.call(e))},gt=Date.prototype.getTime;function _t(e,t,o){var r=o||{};return!!(r.strict?Je(e,t):e===t)||(!e||!t||"object"!=typeof e&&"object"!=typeof t?r.strict?Je(e,t):e==t:function(e,t,o){var r,n;if(typeof e!=typeof t)return!1;if(wt(e)||wt(t))return!1;if(e.prototype!==t.prototype)return!1;if(De(e)!==De(t))return!1;var i=et(e),a=et(t);if(i!==a)return!1;if(i||a)return e.source===t.source&&ht(e)===ht(t);if(vt(e)&&vt(t))return gt.call(e)===gt.call(t);var p=Tt(e),l=Tt(t);if(p!==l)return!1;if(p||l){if(e.length!==t.length)return!1;for(r=0;r<e.length;r++)if(e[r]!==t[r])return!1;return!0}if(typeof e!=typeof t)return!1;try{var s=G(e),c=G(t)}catch(e){return!1}if(s.length!==c.length)return!1;for(s.sort(),c.sort(),r=s.length-1;r>=0;r--)if(s[r]!=c[r])return!1;for(r=s.length-1;r>=0;r--)if(!_t(e[n=s[r]],t[n],o))return!1;return!0}(e,t,r))}function wt(e){return null==e}function Tt(e){return!(!e||"object"!=typeof e||"number"!=typeof e.length)&&("function"==typeof e.copy&&"function"==typeof e.slice&&!(e.length>0&&"number"!=typeof e[0]))}var Ot=_t,Et="undefined"!=typeof window&&"undefined"!=typeof document&&"undefined"!=typeof navigator,Pt=function(){for(var e=["Edge","Trident","Firefox"],t=0;t<e.length;t+=1)if(Et&&navigator.userAgent.indexOf(e[t])>=0)return 1;return 0}();
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */var xt=Et&&window.Promise?function(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then((function(){t=!1,e()})))}}:function(e){var t=!1;return function(){t||(t=!0,setTimeout((function(){t=!1,e()}),Pt))}};function At(e){return e&&"[object Function]"==={}.toString.call(e)}function St(e,t){if(1!==e.nodeType)return[];var o=e.ownerDocument.defaultView.getComputedStyle(e,null);return t?o[t]:o}function jt(e){return"HTML"===e.nodeName?e:e.parentNode||e.host}function Nt(e){if(!e)return document.body;switch(e.nodeName){case"HTML":case"BODY":return e.ownerDocument.body;case"#document":return e.body}var t=St(e),o=t.overflow,r=t.overflowX,n=t.overflowY;return/(auto|scroll|overlay)/.test(o+n+r)?e:Nt(jt(e))}function kt(e){return e&&e.referenceNode?e.referenceNode:e}var Dt=Et&&!(!window.MSInputMethodContext||!document.documentMode),Ft=Et&&/MSIE 10/.test(navigator.userAgent);function Rt(e){return 11===e?Dt:10===e?Ft:Dt||Ft}function Ct(e){if(!e)return document.documentElement;for(var t=Rt(10)?document.body:null,o=e.offsetParent||null;o===t&&e.nextElementSibling;)o=(e=e.nextElementSibling).offsetParent;var r=o&&o.nodeName;return r&&"BODY"!==r&&"HTML"!==r?-1!==["TH","TD","TABLE"].indexOf(o.nodeName)&&"static"===St(o,"position")?Ct(o):o:e?e.ownerDocument.documentElement:document.documentElement}function It(e){return null!==e.parentNode?It(e.parentNode):e}function Lt(e,t){if(!(e&&e.nodeType&&t&&t.nodeType))return document.documentElement;var o=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,r=o?e:t,n=o?t:e,i=document.createRange();i.setStart(r,0),i.setEnd(n,0);var a,p,l=i.commonAncestorContainer;if(e!==l&&t!==l||r.contains(n))return"BODY"===(p=(a=l).nodeName)||"HTML"!==p&&Ct(a.firstElementChild)!==a?Ct(l):l;var s=It(e);return s.host?Lt(s.host,t):Lt(e,It(t).host)}function Mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",o="top"===t?"scrollTop":"scrollLeft",r=e.nodeName;if("BODY"===r||"HTML"===r){var n=e.ownerDocument.documentElement,i=e.ownerDocument.scrollingElement||n;return i[o]}return e[o]}function Ut(e,t){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=Mt(t,"top"),n=Mt(t,"left"),i=o?-1:1;return e.top+=r*i,e.bottom+=r*i,e.left+=n*i,e.right+=n*i,e}function Bt(e,t){var o="x"===t?"Left":"Top",r="Left"===o?"Right":"Bottom";return parseFloat(e["border"+o+"Width"])+parseFloat(e["border"+r+"Width"])}function Wt(e,t,o,r){return Math.max(t["offset"+e],t["scroll"+e],o["client"+e],o["offset"+e],o["scroll"+e],Rt(10)?parseInt(o["offset"+e])+parseInt(r["margin"+("Height"===e?"Top":"Left")])+parseInt(r["margin"+("Height"===e?"Bottom":"Right")]):0)}function Ht(e){var t=e.body,o=e.documentElement,r=Rt(10)&&getComputedStyle(o);return{height:Wt("Height",t,o,r),width:Wt("Width",t,o,r)}}var $t=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},qt=function(){function e(e,t){for(var o=0;o<t.length;o++){var r=t[o];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,o,r){return o&&e(t.prototype,o),r&&e(t,r),t}}(),Vt=function(e,t,o){return t in e?Object.defineProperty(e,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[t]=o,e},Gt=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var r in o)Object.prototype.hasOwnProperty.call(o,r)&&(e[r]=o[r])}return e};function zt(e){return Gt({},e,{right:e.left+e.width,bottom:e.top+e.height})}function Yt(e){var t={};try{if(Rt(10)){t=e.getBoundingClientRect();var o=Mt(e,"top"),r=Mt(e,"left");t.top+=o,t.left+=r,t.bottom+=o,t.right+=r}else t=e.getBoundingClientRect()}catch(e){}var n={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},i="HTML"===e.nodeName?Ht(e.ownerDocument):{},a=i.width||e.clientWidth||n.width,p=i.height||e.clientHeight||n.height,l=e.offsetWidth-a,s=e.offsetHeight-p;if(l||s){var c=St(e);l-=Bt(c,"x"),s-=Bt(c,"y"),n.width-=l,n.height-=s}return zt(n)}function Jt(e,t){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],r=Rt(10),n="HTML"===t.nodeName,i=Yt(e),a=Yt(t),p=Nt(e),l=St(t),s=parseFloat(l.borderTopWidth),c=parseFloat(l.borderLeftWidth);o&&n&&(a.top=Math.max(a.top,0),a.left=Math.max(a.left,0));var f=zt({top:i.top-a.top-s,left:i.left-a.left-c,width:i.width,height:i.height});if(f.marginTop=0,f.marginLeft=0,!r&&n){var u=parseFloat(l.marginTop),d=parseFloat(l.marginLeft);f.top-=s-u,f.bottom-=s-u,f.left-=c-d,f.right-=c-d,f.marginTop=u,f.marginLeft=d}return(r&&!o?t.contains(p):t===p&&"BODY"!==p.nodeName)&&(f=Ut(f,t)),f}function Xt(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=e.ownerDocument.documentElement,r=Jt(e,o),n=Math.max(o.clientWidth,window.innerWidth||0),i=Math.max(o.clientHeight,window.innerHeight||0),a=t?0:Mt(o),p=t?0:Mt(o,"left"),l={top:a-r.top+r.marginTop,left:p-r.left+r.marginLeft,width:n,height:i};return zt(l)}function Kt(e){var t=e.nodeName;if("BODY"===t||"HTML"===t)return!1;if("fixed"===St(e,"position"))return!0;var o=jt(e);return!!o&&Kt(o)}function Qt(e){if(!e||!e.parentElement||Rt())return document.documentElement;for(var t=e.parentElement;t&&"none"===St(t,"transform");)t=t.parentElement;return t||document.documentElement}function Zt(e,t,o,r){var n=arguments.length>4&&void 0!==arguments[4]&&arguments[4],i={top:0,left:0},a=n?Qt(e):Lt(e,kt(t));if("viewport"===r)i=Xt(a,n);else{var p=void 0;"scrollParent"===r?"BODY"===(p=Nt(jt(t))).nodeName&&(p=e.ownerDocument.documentElement):p="window"===r?e.ownerDocument.documentElement:r;var l=Jt(p,a,n);if("HTML"!==p.nodeName||Kt(a))i=l;else{var s=Ht(e.ownerDocument),c=s.height,f=s.width;i.top+=l.top-l.marginTop,i.bottom=c+l.top,i.left+=l.left-l.marginLeft,i.right=f+l.left}}var u="number"==typeof(o=o||0);return i.left+=u?o:o.left||0,i.top+=u?o:o.top||0,i.right-=u?o:o.right||0,i.bottom-=u?o:o.bottom||0,i}function eo(e){return e.width*e.height}function to(e,t,o,r,n){var i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf("auto"))return e;var a=Zt(o,r,i,n),p={top:{width:a.width,height:t.top-a.top},right:{width:a.right-t.right,height:a.height},bottom:{width:a.width,height:a.bottom-t.bottom},left:{width:t.left-a.left,height:a.height}},l=Object.keys(p).map((function(e){return Gt({key:e},p[e],{area:eo(p[e])})})).sort((function(e,t){return t.area-e.area})),s=l.filter((function(e){var t=e.width,r=e.height;return t>=o.clientWidth&&r>=o.clientHeight})),c=s.length>0?s[0].key:l[0].key,f=e.split("-")[1];return c+(f?"-"+f:"")}function oo(e,t,o){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,n=r?Qt(t):Lt(t,kt(o));return Jt(o,n,r)}function ro(e){var t=e.ownerDocument.defaultView.getComputedStyle(e),o=parseFloat(t.marginTop||0)+parseFloat(t.marginBottom||0),r=parseFloat(t.marginLeft||0)+parseFloat(t.marginRight||0);return{width:e.offsetWidth+r,height:e.offsetHeight+o}}function no(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,(function(e){return t[e]}))}function io(e,t,o){o=o.split("-")[0];var r=ro(e),n={width:r.width,height:r.height},i=-1!==["right","left"].indexOf(o),a=i?"top":"left",p=i?"left":"top",l=i?"height":"width",s=i?"width":"height";return n[a]=t[a]+t[l]/2-r[l]/2,n[p]=o===p?t[p]-r[s]:t[no(p)],n}function ao(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function po(e,t,o){return(void 0===o?e:e.slice(0,function(e,t,o){if(Array.prototype.findIndex)return e.findIndex((function(e){return e[t]===o}));var r=ao(e,(function(e){return e[t]===o}));return e.indexOf(r)}(e,"name",o))).forEach((function(e){e.function&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var o=e.function||e.fn;e.enabled&&At(o)&&(t.offsets.popper=zt(t.offsets.popper),t.offsets.reference=zt(t.offsets.reference),t=o(t,e))})),t}function lo(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=oo(this.state,this.popper,this.reference,this.options.positionFixed),e.placement=to(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.positionFixed=this.options.positionFixed,e.offsets.popper=io(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position=this.options.positionFixed?"fixed":"absolute",e=po(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e))}}function so(e,t){return e.some((function(e){var o=e.name;return e.enabled&&o===t}))}function co(e){for(var t=[!1,"ms","Webkit","Moz","O"],o=e.charAt(0).toUpperCase()+e.slice(1),r=0;r<t.length;r++){var n=t[r],i=n?""+n+o:e;if(void 0!==document.body.style[i])return i}return null}function fo(){return this.state.isDestroyed=!0,so(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.position="",this.popper.style.top="",this.popper.style.left="",this.popper.style.right="",this.popper.style.bottom="",this.popper.style.willChange="",this.popper.style[co("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function uo(e){var t=e.ownerDocument;return t?t.defaultView:window}function ho(e,t,o,r){var n="BODY"===e.nodeName,i=n?e.ownerDocument.defaultView:e;i.addEventListener(t,o,{passive:!0}),n||ho(Nt(i.parentNode),t,o,r),r.push(i)}function yo(e,t,o,r){o.updateBound=r,uo(e).addEventListener("resize",o.updateBound,{passive:!0});var n=Nt(e);return ho(n,"scroll",o.updateBound,o.scrollParents),o.scrollElement=n,o.eventsEnabled=!0,o}function mo(){this.state.eventsEnabled||(this.state=yo(this.reference,this.options,this.state,this.scheduleUpdate))}function bo(){var e,t;this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=(e=this.reference,t=this.state,uo(e).removeEventListener("resize",t.updateBound),t.scrollParents.forEach((function(e){e.removeEventListener("scroll",t.updateBound)})),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t))}function vo(e){return""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function go(e,t){Object.keys(t).forEach((function(o){var r="";-1!==["width","height","top","right","bottom","left"].indexOf(o)&&vo(t[o])&&(r="px"),e.style[o]=t[o]+r}))}var _o=Et&&/Firefox/i.test(navigator.userAgent);function wo(e,t,o){var r=ao(e,(function(e){return e.name===t})),n=!!r&&e.some((function(e){return e.name===o&&e.enabled&&e.order<r.order}));if(!n){var i="`"+t+"`",a="`"+o+"`";console.warn(a+" modifier is required by "+i+" modifier in order to work, be sure to include it before "+i+"!")}return n}var To=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],Oo=To.slice(3);function Eo(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=Oo.indexOf(e),r=Oo.slice(o+1).concat(Oo.slice(0,o));return t?r.reverse():r}var Po="flip",xo="clockwise",Ao="counterclockwise";function So(e,t,o,r){var n=[0,0],i=-1!==["right","left"].indexOf(r),a=e.split(/(\+|\-)/).map((function(e){return e.trim()})),p=a.indexOf(ao(a,(function(e){return-1!==e.search(/,|\s/)})));a[p]&&-1===a[p].indexOf(",")&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var l=/\s*,\s*|\s+/,s=-1!==p?[a.slice(0,p).concat([a[p].split(l)[0]]),[a[p].split(l)[1]].concat(a.slice(p+1))]:[a];return s=s.map((function(e,r){var n=(1===r?!i:i)?"height":"width",a=!1;return e.reduce((function(e,t){return""===e[e.length-1]&&-1!==["+","-"].indexOf(t)?(e[e.length-1]=t,a=!0,e):a?(e[e.length-1]+=t,a=!1,e):e.concat(t)}),[]).map((function(e){return function(e,t,o,r){var n=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),i=+n[1],a=n[2];if(!i)return e;if(0===a.indexOf("%")){return zt("%p"===a?o:r)[t]/100*i}if("vh"===a||"vw"===a)return("vh"===a?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0))/100*i;return i}(e,n,t,o)}))})),s.forEach((function(e,t){e.forEach((function(o,r){vo(o)&&(n[t]+=o*("-"===e[r-1]?-1:1))}))})),n}var jo={shift:{order:100,enabled:!0,fn:function(e){var t=e.placement,o=t.split("-")[0],r=t.split("-")[1];if(r){var n=e.offsets,i=n.reference,a=n.popper,p=-1!==["bottom","top"].indexOf(o),l=p?"left":"top",s=p?"width":"height",c={start:Vt({},l,i[l]),end:Vt({},l,i[l]+i[s]-a[s])};e.offsets.popper=Gt({},a,c[r])}return e}},offset:{order:200,enabled:!0,fn:function(e,t){var o=t.offset,r=e.placement,n=e.offsets,i=n.popper,a=n.reference,p=r.split("-")[0],l=void 0;return l=vo(+o)?[+o,0]:So(o,i,a,p),"left"===p?(i.top+=l[0],i.left-=l[1]):"right"===p?(i.top+=l[0],i.left+=l[1]):"top"===p?(i.left+=l[0],i.top-=l[1]):"bottom"===p&&(i.left+=l[0],i.top+=l[1]),e.popper=i,e},offset:0},preventOverflow:{order:300,enabled:!0,fn:function(e,t){var o=t.boundariesElement||Ct(e.instance.popper);e.instance.reference===o&&(o=Ct(o));var r=co("transform"),n=e.instance.popper.style,i=n.top,a=n.left,p=n[r];n.top="",n.left="",n[r]="";var l=Zt(e.instance.popper,e.instance.reference,t.padding,o,e.positionFixed);n.top=i,n.left=a,n[r]=p,t.boundaries=l;var s=t.priority,c=e.offsets.popper,f={primary:function(e){var o=c[e];return c[e]<l[e]&&!t.escapeWithReference&&(o=Math.max(c[e],l[e])),Vt({},e,o)},secondary:function(e){var o="right"===e?"left":"top",r=c[o];return c[e]>l[e]&&!t.escapeWithReference&&(r=Math.min(c[o],l[e]-("right"===e?c.width:c.height))),Vt({},o,r)}};return s.forEach((function(e){var t=-1!==["left","top"].indexOf(e)?"primary":"secondary";c=Gt({},c,f[t](e))})),e.offsets.popper=c,e},priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:function(e){var t=e.offsets,o=t.popper,r=t.reference,n=e.placement.split("-")[0],i=Math.floor,a=-1!==["top","bottom"].indexOf(n),p=a?"right":"bottom",l=a?"left":"top",s=a?"width":"height";return o[p]<i(r[l])&&(e.offsets.popper[l]=i(r[l])-o[s]),o[l]>i(r[p])&&(e.offsets.popper[l]=i(r[p])),e}},arrow:{order:500,enabled:!0,fn:function(e,t){var o;if(!wo(e.instance.modifiers,"arrow","keepTogether"))return e;var r=t.element;if("string"==typeof r){if(!(r=e.instance.popper.querySelector(r)))return e}else if(!e.instance.popper.contains(r))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var n=e.placement.split("-")[0],i=e.offsets,a=i.popper,p=i.reference,l=-1!==["left","right"].indexOf(n),s=l?"height":"width",c=l?"Top":"Left",f=c.toLowerCase(),u=l?"left":"top",d=l?"bottom":"right",h=ro(r)[s];p[d]-h<a[f]&&(e.offsets.popper[f]-=a[f]-(p[d]-h)),p[f]+h>a[d]&&(e.offsets.popper[f]+=p[f]+h-a[d]),e.offsets.popper=zt(e.offsets.popper);var y=p[f]+p[s]/2-h/2,m=St(e.instance.popper),b=parseFloat(m["margin"+c]),v=parseFloat(m["border"+c+"Width"]),g=y-e.offsets.popper[f]-b-v;return g=Math.max(Math.min(a[s]-h,g),0),e.arrowElement=r,e.offsets.arrow=(Vt(o={},f,Math.round(g)),Vt(o,u,""),o),e},element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:function(e,t){if(so(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var o=Zt(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement,e.positionFixed),r=e.placement.split("-")[0],n=no(r),i=e.placement.split("-")[1]||"",a=[];switch(t.behavior){case Po:a=[r,n];break;case xo:a=Eo(r);break;case Ao:a=Eo(r,!0);break;default:a=t.behavior}return a.forEach((function(p,l){if(r!==p||a.length===l+1)return e;r=e.placement.split("-")[0],n=no(r);var s=e.offsets.popper,c=e.offsets.reference,f=Math.floor,u="left"===r&&f(s.right)>f(c.left)||"right"===r&&f(s.left)<f(c.right)||"top"===r&&f(s.bottom)>f(c.top)||"bottom"===r&&f(s.top)<f(c.bottom),d=f(s.left)<f(o.left),h=f(s.right)>f(o.right),y=f(s.top)<f(o.top),m=f(s.bottom)>f(o.bottom),b="left"===r&&d||"right"===r&&h||"top"===r&&y||"bottom"===r&&m,v=-1!==["top","bottom"].indexOf(r),g=!!t.flipVariations&&(v&&"start"===i&&d||v&&"end"===i&&h||!v&&"start"===i&&y||!v&&"end"===i&&m),_=!!t.flipVariationsByContent&&(v&&"start"===i&&h||v&&"end"===i&&d||!v&&"start"===i&&m||!v&&"end"===i&&y),w=g||_;(u||b||w)&&(e.flipped=!0,(u||b)&&(r=a[l+1]),w&&(i=function(e){return"end"===e?"start":"start"===e?"end":e}(i)),e.placement=r+(i?"-"+i:""),e.offsets.popper=Gt({},e.offsets.popper,io(e.instance.popper,e.offsets.reference,e.placement)),e=po(e.instance.modifiers,e,"flip"))})),e},behavior:"flip",padding:5,boundariesElement:"viewport",flipVariations:!1,flipVariationsByContent:!1},inner:{order:700,enabled:!1,fn:function(e){var t=e.placement,o=t.split("-")[0],r=e.offsets,n=r.popper,i=r.reference,a=-1!==["left","right"].indexOf(o),p=-1===["top","left"].indexOf(o);return n[a?"left":"top"]=i[o]-(p?n[a?"width":"height"]:0),e.placement=no(t),e.offsets.popper=zt(n),e}},hide:{order:800,enabled:!0,fn:function(e){if(!wo(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,o=ao(e.instance.modifiers,(function(e){return"preventOverflow"===e.name})).boundaries;if(t.bottom<o.top||t.left>o.right||t.top>o.bottom||t.right<o.left){if(!0===e.hide)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]=""}else{if(!1===e.hide)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1}return e}},computeStyle:{order:850,enabled:!0,fn:function(e,t){var o=t.x,r=t.y,n=e.offsets.popper,i=ao(e.instance.modifiers,(function(e){return"applyStyle"===e.name})).gpuAcceleration;void 0!==i&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var a=void 0!==i?i:t.gpuAcceleration,p=Ct(e.instance.popper),l=Yt(p),s={position:n.position},c=function(e,t){var o=e.offsets,r=o.popper,n=o.reference,i=Math.round,a=Math.floor,p=function(e){return e},l=i(n.width),s=i(r.width),c=-1!==["left","right"].indexOf(e.placement),f=-1!==e.placement.indexOf("-"),u=t?c||f||l%2==s%2?i:a:p,d=t?i:p;return{left:u(l%2==1&&s%2==1&&!f&&t?r.left-1:r.left),top:d(r.top),bottom:d(r.bottom),right:u(r.right)}}(e,window.devicePixelRatio<2||!_o),f="bottom"===o?"top":"bottom",u="right"===r?"left":"right",d=co("transform"),h=void 0,y=void 0;if(y="bottom"===f?"HTML"===p.nodeName?-p.clientHeight+c.bottom:-l.height+c.bottom:c.top,h="right"===u?"HTML"===p.nodeName?-p.clientWidth+c.right:-l.width+c.right:c.left,a&&d)s[d]="translate3d("+h+"px, "+y+"px, 0)",s[f]=0,s[u]=0,s.willChange="transform";else{var m="bottom"===f?-1:1,b="right"===u?-1:1;s[f]=y*m,s[u]=h*b,s.willChange=f+", "+u}var v={"x-placement":e.placement};return e.attributes=Gt({},v,e.attributes),e.styles=Gt({},s,e.styles),e.arrowStyles=Gt({},e.offsets.arrow,e.arrowStyles),e},gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:function(e){var t,o;return go(e.instance.popper,e.styles),t=e.instance.popper,o=e.attributes,Object.keys(o).forEach((function(e){!1!==o[e]?t.setAttribute(e,o[e]):t.removeAttribute(e)})),e.arrowElement&&Object.keys(e.arrowStyles).length&&go(e.arrowElement,e.arrowStyles),e},onLoad:function(e,t,o,r,n){var i=oo(n,t,e,o.positionFixed),a=to(o.placement,i,t,e,o.modifiers.flip.boundariesElement,o.modifiers.flip.padding);return t.setAttribute("x-placement",a),go(t,{position:o.positionFixed?"fixed":"absolute"}),o},gpuAcceleration:void 0}},No={placement:"bottom",positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:jo},ko=function(){function e(t,o){var r=this,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};$t(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(r.update)},this.update=xt(this.update.bind(this)),this.options=Gt({},e.Defaults,n),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t&&t.jquery?t[0]:t,this.popper=o&&o.jquery?o[0]:o,this.options.modifiers={},Object.keys(Gt({},e.Defaults.modifiers,n.modifiers)).forEach((function(t){r.options.modifiers[t]=Gt({},e.Defaults.modifiers[t]||{},n.modifiers?n.modifiers[t]:{})})),this.modifiers=Object.keys(this.options.modifiers).map((function(e){return Gt({name:e},r.options.modifiers[e])})).sort((function(e,t){return e.order-t.order})),this.modifiers.forEach((function(e){e.enabled&&At(e.onLoad)&&e.onLoad(r.reference,r.popper,r.options,e,r.state)})),this.update();var i=this.options.eventsEnabled;i&&this.enableEventListeners(),this.state.eventsEnabled=i}return qt(e,[{key:"update",value:function(){return lo.call(this)}},{key:"destroy",value:function(){return fo.call(this)}},{key:"enableEventListeners",value:function(){return mo.call(this)}},{key:"disableEventListeners",value:function(){return bo.call(this)}}]),e}();ko.Utils=("undefined"!=typeof window?window:__webpack_require__.g).PopperUtils,ko.placements=To,ko.Defaults=No;var Do=ko,Fo="__global_unique_id__",Ro=function(){return _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.d[Fo]=(_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.d[Fo]||0)+1},Co=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){t.__esModule=!0,i(react__WEBPACK_IMPORTED_MODULE_0__);var o=i((prop_types__WEBPACK_IMPORTED_MODULE_5___default())),r=i(Ro),n=i(_warning_3202c820_js__WEBPACK_IMPORTED_MODULE_6__.w);function i(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function p(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function l(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}var s=1073741823;function c(e){var t=[];return{on:function(e){t.push(e)},off:function(e){t=t.filter((function(t){return t!==e}))},get:function(){return e},set:function(o,r){e=o,t.forEach((function(t){return t(e,r)}))}}}t.default=function(e,t){var i,f,u="__create-react-context-"+(0,r.default)()+"__",h=function(e){function o(){var t,r;a(this,o);for(var n=arguments.length,i=Array(n),l=0;l<n;l++)i[l]=arguments[l];return t=r=p(this,e.call.apply(e,[this].concat(i))),r.emitter=c(r.props.value),p(r,t)}return l(o,e),o.prototype.getChildContext=function(){var e;return(e={})[u]=this.emitter,e},o.prototype.componentWillReceiveProps=function(e){if(this.props.value!==e.value){var o=this.props.value,r=e.value,i=void 0;((a=o)===(p=r)?0!==a||1/a==1/p:a!=a&&p!=p)?i=0:(i="function"==typeof t?t(o,r):s, false&&0,0!==(i|=0)&&this.emitter.set(e.value,i))}var a,p},o.prototype.render=function(){return this.props.children},o}(react__WEBPACK_IMPORTED_MODULE_0__.Component);h.childContextTypes=((i={})[u]=o.default.object.isRequired,i);var y=function(t){function o(){var e,r;a(this,o);for(var n=arguments.length,i=Array(n),l=0;l<n;l++)i[l]=arguments[l];return e=r=p(this,t.call.apply(t,[this].concat(i))),r.state={value:r.getValue()},r.onUpdate=function(e,t){0!=((0|r.observedBits)&t)&&r.setState({value:r.getValue()})},p(r,e)}return l(o,t),o.prototype.componentWillReceiveProps=function(e){var t=e.observedBits;this.observedBits=null==t?s:t},o.prototype.componentDidMount=function(){this.context[u]&&this.context[u].on(this.onUpdate);var e=this.props.observedBits;this.observedBits=null==e?s:e},o.prototype.componentWillUnmount=function(){this.context[u]&&this.context[u].off(this.onUpdate)},o.prototype.getValue=function(){return this.context[u]?this.context[u].get():e},o.prototype.render=function(){return(e=this.props.children,Array.isArray(e)?e[0]:e)(this.state.value);var e},o}(react__WEBPACK_IMPORTED_MODULE_0__.Component);return y.contextTypes=((f={})[u]=o.default.object,f),{Provider:h,Consumer:y}},e.exports=t.default}));(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)(Co);var Io=(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.u)((0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.a)((function(e,t){t.__esModule=!0;var o=n(react__WEBPACK_IMPORTED_MODULE_0__),r=n(Co);function n(e){return e&&e.__esModule?e:{default:e}}t.default=o.default.createContext||r.default,e.exports=t.default}))),Lo=Io(),Mo=Io(),Uo=function(e){function t(){for(var t,o=arguments.length,r=new Array(o),n=0;n<o;n++)r[n]=arguments[n];return t=e.call.apply(e,[this].concat(r))||this,(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(t)),"referenceNode",void 0),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(t)),"setReferenceNode",(function(e){e&&t.referenceNode!==e&&(t.referenceNode=e,t.forceUpdate())})),t}A(t,e);var o=t.prototype;return o.componentWillUnmount=function(){this.referenceNode=null},o.render=function(){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Lo.Provider,{value:this.referenceNode},react__WEBPACK_IMPORTED_MODULE_0__.createElement(Mo.Provider,{value:this.setReferenceNode},this.props.children))},t}(react__WEBPACK_IMPORTED_MODULE_0__.Component),Bo=function(e){return Array.isArray(e)?e[0]:e},Wo=function(e){if("function"==typeof e){for(var t=arguments.length,o=new Array(t>1?t-1:0),r=1;r<t;r++)o[r-1]=arguments[r];return e.apply(void 0,o)}},Ho=function(e,t){if("function"==typeof e)return Wo(e,t);null!=e&&(e.current=t)},$o={position:"absolute",top:0,left:0,opacity:0,pointerEvents:"none"},qo={},Vo=function(e){function o(){for(var o,r=arguments.length,n=new Array(r),i=0;i<r;i++)n[i]=arguments[i];return o=e.call.apply(e,[this].concat(n))||this,(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"state",{data:void 0,placement:void 0}),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"popperInstance",void 0),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"popperNode",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"arrowNode",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"setPopperNode",(function(e){e&&o.popperNode!==e&&(Ho(o.props.innerRef,e),o.popperNode=e,o.updatePopperInstance())})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"setArrowNode",(function(e){o.arrowNode=e})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"updateStateModifier",{enabled:!0,order:900,fn:function(e){var t=e.placement;return o.setState({data:e,placement:t}),e}}),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"getOptions",(function(){return{placement:o.props.placement,eventsEnabled:o.props.eventsEnabled,positionFixed:o.props.positionFixed,modifiers:(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({},o.props.modifiers,{arrow:(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({},o.props.modifiers&&o.props.modifiers.arrow,{enabled:!!o.arrowNode,element:o.arrowNode}),applyStyle:{enabled:!1},updateStateModifier:o.updateStateModifier})}})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"getPopperStyle",(function(){return o.popperNode&&o.state.data?(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({position:o.state.data.offsets.popper.position},o.state.data.styles):$o})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"getPopperPlacement",(function(){return o.state.data?o.state.placement:void 0})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"getArrowStyle",(function(){return o.arrowNode&&o.state.data?o.state.data.arrowStyles:qo})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"getOutOfBoundariesState",(function(){return o.state.data?o.state.data.hide:void 0})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"destroyPopperInstance",(function(){o.popperInstance&&(o.popperInstance.destroy(),o.popperInstance=null)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"updatePopperInstance",(function(){o.destroyPopperInstance();var e=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)).popperNode,t=o.props.referenceElement;t&&e&&(o.popperInstance=new Do(t,e,o.getOptions()))})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(o)),"scheduleUpdate",(function(){o.popperInstance&&o.popperInstance.scheduleUpdate()})),o}A(o,e);var r=o.prototype;return r.componentDidUpdate=function(e,t){this.props.placement===e.placement&&this.props.referenceElement===e.referenceElement&&this.props.positionFixed===e.positionFixed&&Ot(this.props.modifiers,e.modifiers,{strict:!0})?this.props.eventsEnabled!==e.eventsEnabled&&this.popperInstance&&(this.props.eventsEnabled?this.popperInstance.enableEventListeners():this.popperInstance.disableEventListeners()):( false&&0,this.updatePopperInstance()),t.placement!==this.state.placement&&this.scheduleUpdate()},r.componentWillUnmount=function(){Ho(this.props.innerRef,null),this.destroyPopperInstance()},r.render=function(){return Bo(this.props.children)({ref:this.setPopperNode,style:this.getPopperStyle(),placement:this.getPopperPlacement(),outOfBoundaries:this.getOutOfBoundariesState(),scheduleUpdate:this.scheduleUpdate,arrowProps:{ref:this.setArrowNode,style:this.getArrowStyle()}})},o}(react__WEBPACK_IMPORTED_MODULE_0__.Component);function Go(e){var r=e.referenceElement,n=(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.b)(e,["referenceElement"]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Lo.Consumer,null,(function(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Vo,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({referenceElement:void 0!==r?r:e},n))}))}(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)(Vo,"defaultProps",{placement:"bottom",eventsEnabled:!0,referenceElement:void 0,positionFixed:!1}),Do.placements;var zo=function(e){function t(){for(var t,o=arguments.length,r=new Array(o),n=0;n<o;n++)r[n]=arguments[n];return t=e.call.apply(e,[this].concat(r))||this,(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(t)),"refHandler",(function(e){Ho(t.props.innerRef,e),Wo(t.props.setReferenceNode,e)})),t}A(t,e);var o=t.prototype;return o.componentWillUnmount=function(){Ho(this.props.innerRef,null)},o.render=function(){return (0,_warning_3202c820_js__WEBPACK_IMPORTED_MODULE_6__.w)(Boolean(this.props.setReferenceNode),"`Reference` should not be used outside of a `Manager` component."),Bo(this.props.children)({ref:this.refHandler})},t}(react__WEBPACK_IMPORTED_MODULE_0__.Component);function Yo(e){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Mo.Consumer,null,(function(o){return react__WEBPACK_IMPORTED_MODULE_0__.createElement(zo,(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({setReferenceNode:o},e))}))}function Jo(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var o,r=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.a)(e);if(t){var a=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.a)(this).constructor;o=Reflect.construct(r,arguments,a)}else o=r.apply(this,arguments);return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.b)(this,o)}}var Xo=function(e){(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__._)(o,e);var t=Jo(o);function o(){return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.c)(this,o),t.apply(this,arguments)}return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.e)(o,[{key:"componentDidMount",value:function(){(0,this.props.rootRef)(react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(this))}},{key:"componentWillUnmount",value:function(){(0,this.props.rootRef)(null)}},{key:"render",value:function(){return this.props.children}}]),o}(react__WEBPACK_IMPORTED_MODULE_0__.Component);Xo.propTypes={children:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().element.isRequired),rootRef:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired)},Xo.displayName="RootRef";var Ko=Xo;function Qo(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return!1}}();return function(){var o,r=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.a)(e);if(t){var a=(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.a)(this).constructor;o=Reflect.construct(r,arguments,a)}else o=r.apply(this,arguments);return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.b)(this,o)}}(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.s)('.Tooltip_tooltip-inner__2{border-radius:.25rem;max-width:200px;padding:.25rem .5rem;background-color:#36394d;color:#fff;text-align:center}.Tooltip_tooltip__2{font-family:Source Sans Pro,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-height:1.5;text-align:left;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-spacing:normal;line-break:auto;word-break:normal;font-size:.875rem;display:block;position:absolute;margin:0;background:transparent!important;opacity:0;z-index:2704;word-wrap:break-word}.Tooltip_tooltip__2.Tooltip_show__32{opacity:.9}.Tooltip_tooltip__2.Tooltip_show__32.Tooltip_is-opaque__34{opacity:1}.Tooltip_tooltip__2 .Tooltip_arrow__36{display:block;position:absolute;width:.8rem;height:.4rem}.Tooltip_tooltip__2 .Tooltip_arrow__36:before{position:absolute;border-style:solid;border-color:transparent;content:""}.Tooltip_tooltip__2 .Tooltip_tooltip-inner__2{max-width:240px}.Tooltip_bs-tooltip-auto__49[x-placement^=top],.Tooltip_bs-tooltip-top__49{padding:.4rem 0}.Tooltip_bs-tooltip-auto__49[x-placement^=top] .Tooltip_arrow__36,.Tooltip_bs-tooltip-top__49 .Tooltip_arrow__36{bottom:0}.Tooltip_bs-tooltip-auto__49[x-placement^=top] .Tooltip_arrow__36:before,.Tooltip_bs-tooltip-top__49 .Tooltip_arrow__36:before{top:0;border-width:.4rem .4rem 0;border-top-color:#36394d}.Tooltip_bs-tooltip-auto__49[x-placement^=right],.Tooltip_bs-tooltip-right__58{padding:0 .4rem}.Tooltip_bs-tooltip-auto__49[x-placement^=right] .Tooltip_arrow__36,.Tooltip_bs-tooltip-right__58 .Tooltip_arrow__36{left:0;width:.4rem;height:.8rem}.Tooltip_bs-tooltip-auto__49[x-placement^=right] .Tooltip_arrow__36:before,.Tooltip_bs-tooltip-right__58 .Tooltip_arrow__36:before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#36394d}.Tooltip_bs-tooltip-auto__49[x-placement^=bottom],.Tooltip_bs-tooltip-bottom__69{padding:.4rem 0}.Tooltip_bs-tooltip-auto__49[x-placement^=bottom] .Tooltip_arrow__36,.Tooltip_bs-tooltip-bottom__69 .Tooltip_arrow__36{top:0}.Tooltip_bs-tooltip-auto__49[x-placement^=bottom] .Tooltip_arrow__36:before,.Tooltip_bs-tooltip-bottom__69 .Tooltip_arrow__36:before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#36394d}.Tooltip_bs-tooltip-auto__49[x-placement^=left],.Tooltip_bs-tooltip-left__78{padding:0 .4rem}.Tooltip_bs-tooltip-auto__49[x-placement^=left] .Tooltip_arrow__36,.Tooltip_bs-tooltip-left__78 .Tooltip_arrow__36{right:0;width:.4rem;height:.8rem}.Tooltip_bs-tooltip-auto__49[x-placement^=left] .Tooltip_arrow__36:before,.Tooltip_bs-tooltip-left__78 .Tooltip_arrow__36:before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#36394d}.Tooltip_tooltip--dark__89 .Tooltip_tooltip-inner__2{background-color:#fff;color:#36394d}.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-auto__49[x-placement^=top] .Tooltip_arrow__36:before,.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-top__49 .Tooltip_arrow__36:before{border-top-color:#fff}.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-auto__49[x-placement^=right] .Tooltip_arrow__36:before,.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-right__58 .Tooltip_arrow__36:before{border-right-color:#fff}.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-auto__49[x-placement^=bottom] .Tooltip_arrow__36:before,.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-bottom__69 .Tooltip_arrow__36:before{border-bottom-color:#fff}.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-auto__49[x-placement^=left] .Tooltip_arrow__36:before,.Tooltip_tooltip--dark__89.Tooltip_bs-tooltip-left__78 .Tooltip_arrow__36:before{border-left-color:#fff}.Tooltip_container--block__105{display:block}.Tooltip_container--inline__108{display:inline-flex;max-width:100%}.Tooltip_container__105 [aria-disabled=true],.Tooltip_container__105 [disabled]{pointer-events:none}.Tooltip_container--disabled__116,.Tooltip_container__105 [aria-disabled=true]{cursor:not-allowed}.Tooltip_fade__119{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.Tooltip_fade__119{transition:none}}.Tooltip_fade__119:not(.Tooltip_show__32){opacity:0}',{insertAt:"top"});var Zo=_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.b.bind({"tooltip-inner":"Tooltip_tooltip-inner__2",tooltip:"Tooltip_tooltip__2",show:"Tooltip_show__32","is-opaque":"Tooltip_is-opaque__34",arrow:"Tooltip_arrow__36","bs-tooltip-top":"Tooltip_bs-tooltip-top__49","bs-tooltip-auto":"Tooltip_bs-tooltip-auto__49","bs-tooltip-right":"Tooltip_bs-tooltip-right__58","bs-tooltip-bottom":"Tooltip_bs-tooltip-bottom__69","bs-tooltip-left":"Tooltip_bs-tooltip-left__78","tooltip--dark":"Tooltip_tooltip--dark__89","container--block":"Tooltip_container--block__105","container--inline":"Tooltip_container--inline__108",container:"Tooltip_container__105","container--disabled":"Tooltip_container--disabled__116",fade:"Tooltip_fade__119"}),er=function(e){(0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__._)(n,e);var o=Qo(n);function n(e,t){var r;return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.c)(this,n),r=o.call(this,e,t),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"enterTimer",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"leaveTimer",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"touchTimer",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"closeTimer",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"isControlled",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"popper",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"children",null),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"ignoreNonTouchEvents",!1),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleResize",(0,_debounce_945d8015_js__WEBPACK_IMPORTED_MODULE_8__.d)((function(){r.popper&&r.popper._popper.scheduleUpdate()}),166)),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleEnter",(function(e){var t=r.props,o=t.children,n=t.enterDelay,i=o.props;"focus"===e.type&&i.onFocus&&i.onFocus(e),"mouseover"===e.type&&i.onMouseOver&&i.onMouseOver(e),r.ignoreNonTouchEvents&&"touchstart"!==e.type||(clearTimeout(r.enterTimer),clearTimeout(r.leaveTimer),n?(e.persist(),r.enterTimer=setTimeout((function(){r.handleOpen(e)}),n)):r.handleOpen(e))})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleOpen",(function(e){var t=r.props,o=t.onOpen,n=t.title;r.isControlled||""!==n&&r.setState({stateOpen:!0,stateShow:!0}),o&&o(e,!0)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleLeave",(function(e){var t=r.props,o=t.children,n=t.leaveDelay,i=o.props;"blur"===e.type&&i.onBlur&&i.onBlur(e),"mouseleave"===e.type&&i.onMouseLeave&&i.onMouseLeave(e),clearTimeout(r.enterTimer),clearTimeout(r.leaveTimer),n?(e.persist(),r.leaveTimer=setTimeout((function(){r.handleClose(e)}),n)):r.handleClose(e)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleClose",(function(e){var t=r.props.onClose;r.isControlled||r.setState({stateOpen:!1}),t&&t(e,!1),clearTimeout(r.closeTimer),r.closeTimer=setTimeout((function(){r.ignoreNonTouchEvents=!1}),200)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleTouchStart",(function(e){r.ignoreNonTouchEvents=!0;var t=r.props,o=t.children,n=t.enterTouchDelay,i=o.props;i.onTouchStart&&i.onTouchStart(e),clearTimeout(r.leaveTimer),clearTimeout(r.closeTimer),clearTimeout(r.touchTimer),e.persist(),r.touchTimer=setTimeout((function(){r.handleEnter(e)}),n)})),(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_7__._)((0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.d)(r),"handleTouchEnd",(function(e){var t=r.props,o=t.children,n=t.leaveTouchDelay,i=o.props;i.onTouchEnd&&i.onTouchEnd(e),clearTimeout(r.touchTimer),clearTimeout(r.leaveTimer),e.persist(),r.leaveTimer=setTimeout((function(){r.handleClose(e)}),n)})),r.isControlled=null!==e.isOpen,r.isControlled?r.state={}:r.state={stateOpen:!1,stateShow:!1},r}return (0,_getPrototypeOf_38c87d48_js__WEBPACK_IMPORTED_MODULE_3__.e)(n,[{key:"componentWillUnmount",value:function(){clearTimeout(this.enterTimer),clearTimeout(this.leaveTimer),clearTimeout(this.touchTimer),clearTimeout(this.closeTimer),this.handleResize.cancel()}},{key:"render",value:function(){var e=this.props,o=e.ariaLabel,r=e.arrowClassName,n=e.children,i=e.className,a=e.containerClassName,p=e.displayAs,l=e.displayElements,s=e.displayElementsClassName,c=e.innerClassName,f=e.isChildElementDisabled,u=e.isDark,h=e.isDisableFocusListener,y=e.isDisableHoverListener,m=e.hasTouchListener,b=e.isOpen,v=e.isOpaque,g=e.placement,_=e.title,w=e.role,T=this.state,O=T.stateShow,P=T.stateOpen,A=this.isControlled?b:P,S={};return m&&(S.onTouchStart=this.handleTouchStart,S.onTouchEnd=this.handleTouchEnd),y||(S.onMouseOver=this.handleEnter,S.onMouseLeave=this.handleLeave),h||(S.onFocus=this.handleEnter,S.onBlur=this.handleLeave),react__WEBPACK_IMPORTED_MODULE_0__.createElement(Uo,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement(x,{target:"window",onResize:this.handleResize}),react__WEBPACK_IMPORTED_MODULE_0__.createElement(Yo,null,(function(e){var o=e.ref;return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Ko,{rootRef:function(e){return o(e)}},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",(0,_objectWithoutProperties_c7aad4d6_js__WEBPACK_IMPORTED_MODULE_4__.a)({className:Zo("container",a,{"container--disabled":f,"container--block":"block"===p,"container--inline":"inline"===p})},S),react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(n)))})),react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Portal_178fdc75_js__WEBPACK_IMPORTED_MODULE_9__.P,null,react__WEBPACK_IMPORTED_MODULE_0__.createElement(Go,{eventsEnabled:O,modifiers:{offset:{offset:"0,4"},preventOverflow:{enabled:!0},hide:{enabled:!1}},placement:g,positionFixed:!1},(function(e){var t=e.ref,n=e.style,a=e.placement,p=e.arrowProps;return A&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{"aria-label":o||_,className:Zo("tooltip","fade","bs-tooltip-".concat(a),{show:O,"tooltip--dark":!0===u,"is-opaque":!0===v},i),ref:t,role:w,style:n,"x-placement":a},react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:Zo("arrow",r),ref:p.ref,style:p.style}),react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:Zo("tooltip-inner",c)},l&&react__WEBPACK_IMPORTED_MODULE_0__.createElement("div",{className:Zo(s)},l),_))}))))}}]),n}(react__WEBPACK_IMPORTED_MODULE_0__.Component);er.propTypes={ariaLabel:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),arrowClassName:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,children:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().element.isRequired),className:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,containerClassName:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,displayAs:prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(["block","inline"]),displayElements:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().element),displayElementsClassName:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),enterDelay:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),enterTouchDelay:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),hasTouchListener:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),innerClassName:_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_2__.c,isChildElementDisabled:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),isDark:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),isDisableFocusListener:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),isDisableHoverListener:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),isOpaque:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),isOpen:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),leaveDelay:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),leaveTouchDelay:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().number),placement:prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(["bottom","left","right","top"]),role:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),title:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),onClose:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),onOpen:(prop_types__WEBPACK_IMPORTED_MODULE_5___default().func)},er.defaultProps={ariaLabel:null,arrowClassName:null,className:null,displayElements:null,displayElementsClassName:"",containerClassName:null,displayAs:"inline",enterDelay:0,enterTouchDelay:1e3,innerClassName:null,isChildElementDisabled:!1,isDark:!1,isOpaque:!1,isDisableFocusListener:!1,isDisableHoverListener:!1,hasTouchListener:!0,isOpen:null,leaveDelay:0,leaveTouchDelay:1500,role:"tooltip",onClose:function(){},onOpen:function(){},placement:"top"},er.displayName="Tooltip",er.filename=__filename;var tr=er;
//# sourceMappingURL=Tooltip-00b73669.js.map


/***/ }),

/***/ 78618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ o; }
/* harmony export */ });
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10518);
var o={h1:"Typography_h1__2",h2:"Typography_h2__3",h3:"Typography_h3__4",h4:"Typography_h4__5",h5:"Typography_h5__6",h6:"Typography_h6__7",p:"Typography_p__57",caption:"Typography_caption__61",kpi:"Typography_kpi__66",blockquote:"Typography_blockquote__70","pre--bordered":"Typography_pre--bordered__77","code--example":"Typography_code--example__88"};(0,_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__.s)(".Typography_h1__2,.Typography_h2__3,.Typography_h3__4,.Typography_h4__5,.Typography_h5__6,.Typography_h6__7{margin:0}.Typography_h1__2{font-family:Barlow,sans-serif;font-size:1.875rem;font-weight:400;line-height:3rem}@media (min-width:1265px){.Typography_h1__2{font-size:2.5rem;line-height:3rem}}.Typography_h2__3{font-family:Barlow,sans-serif;font-size:1.625rem;font-weight:300;line-height:2.5rem}@media (min-width:1265px){.Typography_h2__3{font-size:2rem;line-height:2.5rem}}.Typography_h3__4{font-family:Barlow,sans-serif;font-size:1.5rem;font-weight:500;letter-spacing:.3px;line-height:2rem}.Typography_h4__5{font-size:1.25rem;line-height:1.625rem}.Typography_h4__5,.Typography_h5__6{font-family:Barlow,sans-serif;font-weight:600;letter-spacing:.01875em}.Typography_h5__6{font-size:1rem;line-height:1.5rem}.Typography_h6__7{font-size:.75rem;font-weight:600;line-height:1.5rem;text-transform:uppercase}.Typography_p__57{font-size:1rem;line-height:1.375rem}.Typography_caption__61{color:#6f7282;font-size:.875rem;line-height:1rem}.Typography_kpi__66{font-family:Barlow,sans-serif;font-weight:100}.Typography_blockquote__70{width:100%;margin:0;padding-left:8px;border-left:3px solid #36394d;overflow-x:auto}.Typography_pre--bordered__77{margin:0;padding:16px;border-left:4px solid #36394d;border-radius:0 4px 4px 0;background-color:#f2f3f5;font-family:Inconsolata,SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace;font-size:.875rem;line-height:1.375rem;white-space:normal}.Typography_code--example__88{color:#a62626;font-size:.875rem}",{insertAt:"top"});
//# sourceMappingURL=Typography.module-f4624551.js.map


/***/ }),

/***/ 29908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ d; }
});

;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/isObject-27c2f2cf.js
var isObject_27c2f2cf_n=function(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)};
//# sourceMappingURL=isObject-27c2f2cf.js.map

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/isSymbol-e38f3509.js
var isSymbol_e38f3509 = __webpack_require__(96726);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/debounce-945d8015.js
var i=function(){return isSymbol_e38f3509.a.Date.now()},e=/\s/;var o=function(t){for(var r=t.length;r--&&e.test(t.charAt(r)););return r},u=/^\s+/;var a=function(t){return t?t.slice(0,o(t)+1).replace(u,""):t},f=/^[-+]0x[0-9a-f]+$/i,c=/^0b[01]+$/i,v=/^0o[0-7]+$/i,s=parseInt;var m=function(r){if("number"==typeof r)return r;if((0,isSymbol_e38f3509.c)(r))return NaN;if(isObject_27c2f2cf_n(r)){var i="function"==typeof r.valueOf?r.valueOf():r;r=isObject_27c2f2cf_n(i)?i+"":i}if("string"!=typeof r)return 0===r?r:+r;r=a(r);var e=c.test(r);return e||v.test(r)?s(r.slice(2),e?2:8):f.test(r)?NaN:+r},l=Math.max,p=Math.min;var d=function(r,n,e){var o,u,a,f,c,v,s=0,d=!1,h=!1,y=!0;if("function"!=typeof r)throw new TypeError("Expected a function");function T(t){var n=o,i=u;return o=u=void 0,s=t,f=r.apply(i,n)}function x(t){return s=t,c=setTimeout(b,n),d?T(t):f}function g(t){var r=t-v;return void 0===v||r>=n||r<0||h&&t-s>=a}function b(){var t=i();if(g(t))return N(t);c=setTimeout(b,function(t){var r=n-(t-v);return h?p(r,a-(t-s)):r}(t))}function N(t){return c=void 0,y&&o?T(t):(o=u=void 0,f)}function j(){var t=i(),r=g(t);if(o=arguments,u=this,v=t,r){if(void 0===c)return x(v);if(h)return clearTimeout(c),c=setTimeout(b,n),T(v)}return void 0===c&&(c=setTimeout(b,n)),f}return n=m(n)||0,isObject_27c2f2cf_n(e)&&(d=!!e.leading,a=(h="maxWait"in e)?l(m(e.maxWait)||0,n):a,y="trailing"in e?!!e.trailing:y),j.cancel=function(){void 0!==c&&clearTimeout(c),s=0,o=v=u=c=void 0},j.flush=function(){return void 0===c?f:N(i())},j};
//# sourceMappingURL=debounce-945d8015.js.map


/***/ }),

/***/ 11841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ e; }
/* harmony export */ });
function e(e,r,n){return r in e?Object.defineProperty(e,r,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[r]=n,e}
//# sourceMappingURL=defineProperty-1e8516b1.js.map


/***/ }),

/***/ 23214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ i; },
/* harmony export */   "a": function() { return /* binding */ c; },
/* harmony export */   "b": function() { return /* binding */ f; },
/* harmony export */   "c": function() { return /* binding */ t; },
/* harmony export */   "d": function() { return /* binding */ r; },
/* harmony export */   "e": function() { return /* binding */ o; },
/* harmony export */   "f": function() { return /* binding */ u; },
/* harmony export */   "g": function() { return /* binding */ n; }
/* harmony export */ });
function t(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function e(t,e){for(var o=0;o<e.length;o++){var r=e[o];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function o(t,o,r){return o&&e(t.prototype,o),r&&e(t,r),Object.defineProperty(t,"prototype",{writable:!1}),t}function r(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function n(t,e){return n=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},n(t,e)}function i(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&n(t,e)}function u(t){return u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u(t)}function f(t,e){if(e&&("object"===u(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return r(t)}function c(t){return c=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},c(t)}
//# sourceMappingURL=getPrototypeOf-38c87d48.js.map


/***/ }),

/***/ 11424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ r; }
/* harmony export */ });
let r=(r=21)=>{let t="",e=r;for(;e--;)t+="useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64*Math.random()|0];return t};
//# sourceMappingURL=index-bd43cdd3.js.map


/***/ }),

/***/ 96726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ r; },
/* harmony export */   "b": function() { return /* binding */ n; },
/* harmony export */   "c": function() { return /* binding */ v; }
/* harmony export */ });
/* unused harmony exports _, d, i */
/* harmony import */ var _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10518);
var e="object"==typeof _prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__.d&&_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__.d&&_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__.d.Object===Object&&_prop_shapes_ac9385ac_js__WEBPACK_IMPORTED_MODULE_0__.d,o="object"==typeof self&&self&&self.Object===Object&&self,r=e||o||Function("return this")(),n=r.Symbol,a=Object.prototype,c=a.hasOwnProperty,l=a.toString,i=n?n.toStringTag:void 0;var b=function(t){var e=c.call(t,i),o=t[i];try{t[i]=void 0;var r=!0}catch(t){}var n=l.call(t);return r&&(e?t[i]=o:delete t[i]),n},s=Object.prototype.toString;var f=function(t){return s.call(t)},u=n?n.toStringTag:void 0;var j=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":u&&u in Object(t)?b(t):f(t)};var p=function(t){return null!=t&&"object"==typeof t};var v=function(t){return"symbol"==typeof t||p(t)&&"[object Symbol]"==j(t)};
//# sourceMappingURL=isSymbol-e38f3509.js.map


/***/ }),

/***/ 59453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ r; }
/* harmony export */ });
function r(r){if("undefined"!=typeof Symbol&&null!=r[Symbol.iterator]||null!=r["@@iterator"])return Array.from(r)}
//# sourceMappingURL=iterableToArray-12a62ea2.js.map


/***/ }),

/***/ 78776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ e; },
/* harmony export */   "a": function() { return /* binding */ r; },
/* harmony export */   "b": function() { return /* binding */ t; }
/* harmony export */ });
function r(){return r=Object.assign||function(r){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n])}return r},r.apply(this,arguments)}function t(r,t){if(null==r)return{};var e,n,o={},a=Object.keys(r);for(n=0;n<a.length;n++)e=a[n],t.indexOf(e)>=0||(o[e]=r[e]);return o}function e(r,e){if(null==r)return{};var n,o,a=t(r,e);if(Object.getOwnPropertySymbols){var l=Object.getOwnPropertySymbols(r);for(o=0;o<l.length;o++)n=l[o],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(r,n)&&(a[n]=r[n])}return a}
//# sourceMappingURL=objectWithoutProperties-c7aad4d6.js.map


/***/ }),

/***/ 10518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ o; },
/* harmony export */   "b": function() { return /* binding */ i; },
/* harmony export */   "c": function() { return /* binding */ f; },
/* harmony export */   "d": function() { return /* binding */ t; },
/* harmony export */   "e": function() { return /* binding */ r; },
/* harmony export */   "g": function() { return /* binding */ s; },
/* harmony export */   "s": function() { return /* binding */ a; },
/* harmony export */   "u": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof __webpack_require__.g?__webpack_require__.g:"undefined"!=typeof self?self:{};function r(){throw new Error("Dynamic requires are not currently supported by rollup-plugin-commonjs")}function n(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function o(e,t){return e(t={exports:{}},t.exports),t.exports}function s(e){return e&&e.default||e}var i=o((function(e){
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){var t={}.hasOwnProperty;function r(){for(var e=[],n=0;n<arguments.length;n++){var o=arguments[n];if(o){var s=typeof o;if("string"===s||"number"===s)e.push(this&&this[o]||o);else if(Array.isArray(o))e.push(r.apply(this,o));else if("object"===s)if(o.toString===Object.prototype.toString)for(var i in o)t.call(o,i)&&o[i]&&e.push(this&&this[i]||i);else e.push(o.toString())}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):window.classNames=r}()}));function a(e,t){void 0===t&&(t={});var r=t.insertAt;if(e&&"undefined"!=typeof document){var n=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css","top"===r&&n.firstChild?n.insertBefore(o,n.firstChild):n.appendChild(o),o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e))}}var f=prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string),(prop_types__WEBPACK_IMPORTED_MODULE_0___default().object)])),(prop_types__WEBPACK_IMPORTED_MODULE_0___default().object),(prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)]);
//# sourceMappingURL=prop-shapes-ac9385ac.js.map


/***/ }),

/***/ 70512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ e; },
/* harmony export */   "a": function() { return /* binding */ t; },
/* harmony export */   "b": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var _unsupportedIterableToArray_5baf4325_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50901);
function t(r){if(Array.isArray(r))return r}function n(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function e(e,a){return t(e)||function(r,t){var n=null==r?null:"undefined"!=typeof Symbol&&r[Symbol.iterator]||r["@@iterator"];if(null!=n){var e,a,o=[],l=!0,u=!1;try{for(n=n.call(r);!(l=(e=n.next()).done)&&(o.push(e.value),!t||o.length!==t);l=!0);}catch(r){u=!0,a=r}finally{try{l||null==n.return||n.return()}finally{if(u)throw a}}return o}}(e,a)||(0,_unsupportedIterableToArray_5baf4325_js__WEBPACK_IMPORTED_MODULE_0__._)(e,a)||n()}
//# sourceMappingURL=slicedToArray-82541484.js.map


/***/ }),

/***/ 75782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ e; }
/* harmony export */ });
function e(e,r){return r||(r=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))}
//# sourceMappingURL=taggedTemplateLiteral-2207d3b5.js.map


/***/ }),

/***/ 55029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ n; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var n=react__WEBPACK_IMPORTED_MODULE_0__.createContext({color:{primary:null,secondary:null,danger:null,info:null,success:null,warning:null,background:null,backgroundAlternate:null,text:null},button:{allCaps:null,borderRadius:null,fontWeight:null,fontFamily:null},spinner:{color:null},checkbox:{borderRadius:null,color:{unchecked:null,checked:null}},loader:{color:null}});
//# sourceMappingURL=themeContext-ac5c7f19.js.map


/***/ }),

/***/ 88707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ e; }
/* harmony export */ });
/* harmony import */ var _unsupportedIterableToArray_5baf4325_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50901);
/* harmony import */ var _iterableToArray_12a62ea2_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59453);
function e(e){return function(a){if(Array.isArray(a))return (0,_unsupportedIterableToArray_5baf4325_js__WEBPACK_IMPORTED_MODULE_0__.a)(a)}(e)||(0,_iterableToArray_12a62ea2_js__WEBPACK_IMPORTED_MODULE_1__._)(e)||(0,_unsupportedIterableToArray_5baf4325_js__WEBPACK_IMPORTED_MODULE_0__._)(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}
//# sourceMappingURL=toConsumableArray-28e9988c.js.map


/***/ }),

/***/ 81792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ n; },
/* harmony export */   "E": function() { return /* binding */ o; },
/* harmony export */   "M": function() { return /* binding */ r; },
/* harmony export */   "T": function() { return /* binding */ e; },
/* harmony export */   "t": function() { return /* binding */ d; }
/* harmony export */ });
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11841);
var e={ALERT:"alert",NOTICE:"notice",WARNING:"warning",INFO:"info"},n={SHOW:"SHOW_TOAST",MOUNTED:"CONTAINER_MOUNTED",CLEAR:"CLEAR_TOAST"},r=8,o={eventList:new Map,on:function(t,e){return this.eventList.has(t)||this.eventList.set(t,[]),this.eventList.get(t).push(e),this},off:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.eventList.delete(t)},emit:function(t){for(var e=this,n=arguments.length,r=new Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];return!!this.eventList.has(t)&&(this.eventList.get(t).forEach((function(t){return setTimeout((function(){return t.call.apply(t,[e].concat(r))}),0)})),!0)}};function i(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);e&&(r=r.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,r)}return n}function c(e){for(var n=1;n<arguments.length;n++){var r=null!=arguments[n]?arguments[n]:{};n%2?i(Object(r),!0).forEach((function(n){(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_0__._)(e,n,r[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):i(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}var u={type:e.NOTICE,autoClose:!0,closeButton:null,closeOnClick:null,updateId:null},s=null,a=[],l=0;function f(t,e){return l+=1,c(c(c({},u),t),{},{type:e,toastId:l})}function O(t,e){return null!==s?o.emit(n.SHOW,t,e):a.push({action:n.SHOW,content:t,options:e}),e.toastId}var p=Object.assign((function(t,n){return O(t,f(n,n&&n.type||e.NOTICE))}),{alert:function(t,n){return O(t,f(n,e.ALERT))},notice:function(t,n){return O(t,f(n,e.NOTICE))},warning:function(t,n){return O(t,f(n,e.WARNING))},info:function(t,n){return O(t,f(n,e.INFO))},dismiss:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return s&&o.emit(n.CLEAR,t)},update:function(t,e){setTimeout((function(){if(s&&void 0!==s.collection[t]){var n=s.collection[t],r=n.options,o=n.content,i=null!==r.updateId?r.updateId+1:1,u=c(c(c({},r),e),{},{toastId:t,updateId:i}),a=void 0!==u.render?u.render:o;delete u.render,O(a,u)}}),0)}});o.on(n.MOUNTED,(function(t){s=t,p.isActive=function(t){return s.isToastActive(t)},a.forEach((function(t){o.emit(t.action,t.content,t.options)})),a=[]}));var d=p;
//# sourceMappingURL=toaster-a57afb61.js.map


/***/ }),

/***/ 50901:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ t; },
/* harmony export */   "a": function() { return /* binding */ r; }
/* harmony export */ });
function r(r,t){(null==t||t>r.length)&&(t=r.length);for(var n=0,e=new Array(t);n<t;n++)e[n]=r[n];return e}function t(t,n){if(t){if("string"==typeof t)return r(t,n);var e=Object.prototype.toString.call(t).slice(8,-1);return"Object"===e&&t.constructor&&(e=t.constructor.name),"Map"===e||"Set"===e?Array.from(t):"Arguments"===e||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)?r(t,n):void 0}}
//# sourceMappingURL=unsupportedIterableToArray-5baf4325.js.map


/***/ }),

/***/ 33622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ j; },
/* harmony export */   "e": function() { return /* binding */ v; },
/* harmony export */   "f": function() { return /* binding */ m; },
/* harmony export */   "g": function() { return /* binding */ d; },
/* harmony export */   "h": function() { return /* binding */ w; },
/* harmony export */   "j": function() { return /* binding */ u; },
/* harmony export */   "k": function() { return /* binding */ O; }
/* harmony export */ });
/* unused harmony exports a, b, c, i, s */
/* harmony import */ var _defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11841);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6767);
/* harmony import */ var color__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(color__WEBPACK_IMPORTED_MODULE_0__);
class e{constructor(t,s,e){this.set(t,s,e)}set(t,s,e){this.r=this.clamp(t),this.g=this.clamp(s),this.b=this.clamp(e)}hueRotate(t=0){t=t/180*Math.PI;const s=Math.sin(t),e=Math.cos(t);this.multiply([.213+.787*e-.213*s,.715-.715*e-.715*s,.072-.072*e+.928*s,.213-.213*e+.143*s,.715+.285*e+.14*s,.072-.072*e-.283*s,.213-.213*e-.787*s,.715-.715*e+.715*s,.072+.928*e+.072*s])}grayscale(t=1){this.multiply([.2126+.7874*(1-t),.7152-.7152*(1-t),.0722-.0722*(1-t),.2126-.2126*(1-t),.7152+.2848*(1-t),.0722-.0722*(1-t),.2126-.2126*(1-t),.7152-.7152*(1-t),.0722+.9278*(1-t)])}sepia(t=1){this.multiply([.393+.607*(1-t),.769-.769*(1-t),.189-.189*(1-t),.349-.349*(1-t),.686+.314*(1-t),.168-.168*(1-t),.272-.272*(1-t),.534-.534*(1-t),.131+.869*(1-t)])}saturate(t=1){this.multiply([.213+.787*t,.715-.715*t,.072-.072*t,.213-.213*t,.715+.285*t,.072-.072*t,.213-.213*t,.715-.715*t,.072+.928*t])}multiply(t){const s=this.clamp(this.r*t[0]+this.g*t[1]+this.b*t[2]),e=this.clamp(this.r*t[3]+this.g*t[4]+this.b*t[5]),r=this.clamp(this.r*t[6]+this.g*t[7]+this.b*t[8]);this.r=s,this.g=e,this.b=r}brightness(t=1){this.linear(t)}contrast(t=1){this.linear(t,-.5*t+.5)}linear(t=1,s=0){this.r=this.clamp(this.r*t+255*s),this.g=this.clamp(this.g*t+255*s),this.b=this.clamp(this.b*t+255*s)}invert(t=1){this.r=this.clamp(255*(t+this.r/255*(1-2*t))),this.g=this.clamp(255*(t+this.g/255*(1-2*t))),this.b=this.clamp(255*(t+this.b/255*(1-2*t)))}hsl(){const t=this.r/255,s=this.g/255,e=this.b/255,r=Math.max(t,s,e),n=Math.min(t,s,e);let i,a,o=(r+n)/2;if(r===n)i=a=0;else{const h=r-n;switch(a=o>.5?h/(2-r-n):h/(r+n),r){case t:i=(s-e)/h+(s<e?6:0);break;case s:i=(e-t)/h+2;break;case e:i=(t-s)/h+4}i/=6}return{h:100*i,s:100*a,l:100*o}}clamp(t){return t>255?t=255:t<0&&(t=0),t}}class r{constructor(t,s){this.target=t,this.targetHSL=t.hsl(),this.reusedColor=new e(0,0,0),this.options=s||{}}solve(){const t=this.solveNarrow(this.solveWide());return{values:t.values,called:t.called,loss:t.loss,filter:this.css(t.values)}}solveWide(){const t=[60,180,18e3,600,1.2,1.2];let s={loss:1/0},e=0;for(;s.loss>this.options.acceptanceLossPercentage;){const r=[50,20,3750,50,100,100],n=this.spsa(5,t,15,r,1e3);if(n.loss<s.loss&&(s=n),e+=1,e>=this.options.maxChecks)break}return Object.assign({},s,{called:e})}solveNarrow(t){const s=t.loss,e=s+1,r=[.25*e,.25*e,e,.25*e,.2*e,.2*e];return this.spsa(s,r,2,t.values,500,t.called)}spsa(t,s,e,r,n,i){let a=null,o=1/0;const h=new Array(6),l=new Array(6),c=new Array(6);function u(t,s){let e=100;return 2===s?e=7500:4!==s&&5!==s||(e=200),3===s?t>e?t%=e:t<0&&(t=e+t%e):t<0?t=0:t>e&&(t=e),t}for(let i=0;i<n;i++){const n=e/Math.pow(i+1,.16666666666666666);for(let t=0;t<6;t++)h[t]=Math.random()>.5?1:-1,l[t]=r[t]+n*h[t],c[t]=r[t]-n*h[t];const f=this.loss(l)-this.loss(c);for(let e=0;e<6;e++){const a=f/(2*n)*h[e],o=s[e]/Math.pow(t+i+1,1);r[e]=u(r[e]-o*a,e)}const p=this.loss(r);p<o&&(a=r.slice(0),o=p)}return{values:a,loss:o,called:i}}loss(t){const s=this.reusedColor;s.set(255,255,255),s.invert(t[0]/100),s.sepia(t[1]/100),s.saturate(t[2]/100),s.hueRotate(3.6*t[3]),s.brightness(t[4]/100),s.contrast(t[5]/100);const e=s.hsl();return Math.abs(s.r-this.target.r)+Math.abs(s.g-this.target.g)+Math.abs(s.b-this.target.b)+Math.abs(e.h-this.targetHSL.h)+Math.abs(e.s-this.targetHSL.s)+Math.abs(e.l-this.targetHSL.l)}css(t){function s(s,e=1){return Math.round(t[s]*e)}return[`invert(${s(0)}%)`,`sepia(${s(1)}%)`,`saturate(${s(2)}%)`,`hue-rotate(${s(3,3.6)}deg)`,`brightness(${s(4)}%)`,`contrast(${s(5)}%);`].join(" ")}}const n=t=>!isNaN(parseFloat(t))&&isFinite(t);let i={};var a=(t,s={})=>{let a,o,h;if(i[t])return i[t];try{if([a,o,h]=function(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,((t,s,e,r)=>s+s+e+e+r+r));const s=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);return s?[parseInt(s[1],16),parseInt(s[2],16),parseInt(s[3],16)]:null}(t),!n(a)||!n(o)||!n(h))throw new Error(`hextToRgb returned an invalid value for '${t}'`)}catch(t){throw new Error("Color value should be in HEX format")}const l=new e(a,o,h),c=Object.assign({},{acceptanceLossPercentage:5,maxChecks:15},s),u=new r(l,c);return i[t]=Object.assign({},u.solve(),{hex:t,rgb:[a,o,h]}),i[t]};function o(t,s){var e=Object.keys(t);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(t);s&&(r=r.filter((function(s){return Object.getOwnPropertyDescriptor(t,s).enumerable}))),e.push.apply(e,r)}return e}function h(s){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?o(Object(r),!0).forEach((function(e){(0,_defineProperty_1e8516b1_js__WEBPACK_IMPORTED_MODULE_1__._)(s,e,r[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(s,Object.getOwnPropertyDescriptors(r)):o(Object(r)).forEach((function(t){Object.defineProperty(s,t,Object.getOwnPropertyDescriptor(r,t))}))}return s}var l=color__WEBPACK_IMPORTED_MODULE_0___default()("white"),c=color__WEBPACK_IMPORTED_MODULE_0___default()("black"),u=function(t){if(!t)return!1;try{return color__WEBPACK_IMPORTED_MODULE_0___default()(t),!0}catch(t){return!1}},f=function(t){return color__WEBPACK_IMPORTED_MODULE_0___default()(t).hsl().object()},p=function(t,e){return color__WEBPACK_IMPORTED_MODULE_0___default().hsl(h(h({},f(t)),{},{l:e}))},b=function(t){return p(t,95)},g=function(t){return p(t,15)},v=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"AA",n="AAA"===r?7:4.5,i="string"==typeof t?color__WEBPACK_IMPORTED_MODULE_0___default()(t):t,a="string"==typeof e?color__WEBPACK_IMPORTED_MODULE_0___default()(e):e;return i.contrast(a)>=n},m=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:10;return u(t)?color__WEBPACK_IMPORTED_MODULE_0___default()(t).hsl().object().l>e:null},d=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:65;return u(t)?color__WEBPACK_IMPORTED_MODULE_0___default()(t).hsl().object().l<e:null},y=function(t){return u?d(t)?s(t).lighten(.5).mix(l,.2).hex():s(t).darken(.2).hex():null},w=function(t){return u(t)?color__WEBPACK_IMPORTED_MODULE_0___default()(t).mix(color__WEBPACK_IMPORTED_MODULE_0___default()("white"),.95):null},j=function(t,e){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"AA";if(!u(t))return null;var n=color__WEBPACK_IMPORTED_MODULE_0___default()(e||t),i=b(t),a=g(t),o=[color__WEBPACK_IMPORTED_MODULE_0___default()(t),i,a,l,c],h=o.find((function(t){return v(n,t,r)}));if(h)return h;var f=o.reduce((function(t,s){return!t||n.contrast(t)<n.contrast(s)?s:t}));return f},O=function(t){return"brightness(0) invert(1) ".concat(a(color__WEBPACK_IMPORTED_MODULE_0___default()(t).hex()).filter)};
//# sourceMappingURL=utils-9c93357c.js.map


/***/ }),

/***/ 34826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ o; }
/* harmony export */ });
var r=function(){};if(false){ var n; }var o=r;
//# sourceMappingURL=warning-3202c820.js.map


/***/ }),

/***/ 77424:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
    RBTree: __webpack_require__(62448),
    BinTree: __webpack_require__(69675)
};


/***/ }),

/***/ 69675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var TreeBase = __webpack_require__(5301);

function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
}

Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};

Node.prototype.set_child = function(dir, val) {
    if(dir) {
        this.right = val;
    }
    else {
        this.left = val;
    }
};

function BinTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}

BinTree.prototype = new TreeBase();

// returns true if inserted, false if duplicate
BinTree.prototype.insert = function(data) {
    if(this._root === null) {
        // empty tree
        this._root = new Node(data);
        this.size++;
        return true;
    }

    var dir = 0;

    // setup
    var p = null; // parent
    var node = this._root;

    // search down
    while(true) {
        if(node === null) {
            // insert new node at the bottom
            node = new Node(data);
            p.set_child(dir, node);
            ret = true;
            this.size++;
            return true;
        }

        // stop if found
        if(this._comparator(node.data, data) === 0) {
            return false;
        }

        dir = this._comparator(node.data, data) < 0;

        // update helpers
        p = node;
        node = node.get_child(dir);
    }
};

// returns true if removed, false if not found
BinTree.prototype.remove = function(data) {
    if(this._root === null) {
        return false;
    }

    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var found = null; // found item
    var dir = 1;

    while(node.get_child(dir) !== null) {
        p = node;
        node = node.get_child(dir);
        var cmp = this._comparator(data, node.data);
        dir = cmp > 0;

        if(cmp === 0) {
            found = node;
        }
    }

    if(found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));

        this._root = head.right;
        this.size--;
        return true;
    }
    else {
        return false;
    }
};

module.exports = BinTree;



/***/ }),

/***/ 62448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


var TreeBase = __webpack_require__(5301);

function Node(data) {
    this.data = data;
    this.left = null;
    this.right = null;
    this.red = true;
}

Node.prototype.get_child = function(dir) {
    return dir ? this.right : this.left;
};

Node.prototype.set_child = function(dir, val) {
    if(dir) {
        this.right = val;
    }
    else {
        this.left = val;
    }
};

function RBTree(comparator) {
    this._root = null;
    this._comparator = comparator;
    this.size = 0;
}

RBTree.prototype = new TreeBase();

// returns true if inserted, false if duplicate
RBTree.prototype.insert = function(data) {
    var ret = false;

    if(this._root === null) {
        // empty tree
        this._root = new Node(data);
        ret = true;
        this.size++;
    }
    else {
        var head = new Node(undefined); // fake tree root

        var dir = 0;
        var last = 0;

        // setup
        var gp = null; // grandparent
        var ggp = head; // grand-grand-parent
        var p = null; // parent
        var node = this._root;
        ggp.right = this._root;

        // search down
        while(true) {
            if(node === null) {
                // insert new node at the bottom
                node = new Node(data);
                p.set_child(dir, node);
                ret = true;
                this.size++;
            }
            else if(is_red(node.left) && is_red(node.right)) {
                // color flip
                node.red = true;
                node.left.red = false;
                node.right.red = false;
            }

            // fix red violation
            if(is_red(node) && is_red(p)) {
                var dir2 = ggp.right === gp;

                if(node === p.get_child(last)) {
                    ggp.set_child(dir2, single_rotate(gp, !last));
                }
                else {
                    ggp.set_child(dir2, double_rotate(gp, !last));
                }
            }

            var cmp = this._comparator(node.data, data);

            // stop if found
            if(cmp === 0) {
                break;
            }

            last = dir;
            dir = cmp < 0;

            // update helpers
            if(gp !== null) {
                ggp = gp;
            }
            gp = p;
            p = node;
            node = node.get_child(dir);
        }

        // update root
        this._root = head.right;
    }

    // make root black
    this._root.red = false;

    return ret;
};

// returns true if removed, false if not found
RBTree.prototype.remove = function(data) {
    if(this._root === null) {
        return false;
    }

    var head = new Node(undefined); // fake tree root
    var node = head;
    node.right = this._root;
    var p = null; // parent
    var gp = null; // grand parent
    var found = null; // found item
    var dir = 1;

    while(node.get_child(dir) !== null) {
        var last = dir;

        // update helpers
        gp = p;
        p = node;
        node = node.get_child(dir);

        var cmp = this._comparator(data, node.data);

        dir = cmp > 0;

        // save found node
        if(cmp === 0) {
            found = node;
        }

        // push the red node down
        if(!is_red(node) && !is_red(node.get_child(dir))) {
            if(is_red(node.get_child(!dir))) {
                var sr = single_rotate(node, dir);
                p.set_child(last, sr);
                p = sr;
            }
            else if(!is_red(node.get_child(!dir))) {
                var sibling = p.get_child(!last);
                if(sibling !== null) {
                    if(!is_red(sibling.get_child(!last)) && !is_red(sibling.get_child(last))) {
                        // color flip
                        p.red = false;
                        sibling.red = true;
                        node.red = true;
                    }
                    else {
                        var dir2 = gp.right === p;

                        if(is_red(sibling.get_child(last))) {
                            gp.set_child(dir2, double_rotate(p, last));
                        }
                        else if(is_red(sibling.get_child(!last))) {
                            gp.set_child(dir2, single_rotate(p, last));
                        }

                        // ensure correct coloring
                        var gpc = gp.get_child(dir2);
                        gpc.red = true;
                        node.red = true;
                        gpc.left.red = false;
                        gpc.right.red = false;
                    }
                }
            }
        }
    }

    // replace and remove if found
    if(found !== null) {
        found.data = node.data;
        p.set_child(p.right === node, node.get_child(node.left === null));
        this.size--;
    }

    // update root and make it black
    this._root = head.right;
    if(this._root !== null) {
        this._root.red = false;
    }

    return found !== null;
};

function is_red(node) {
    return node !== null && node.red;
}

function single_rotate(root, dir) {
    var save = root.get_child(!dir);

    root.set_child(!dir, save.get_child(dir));
    save.set_child(dir, root);

    root.red = true;
    save.red = false;

    return save;
}

function double_rotate(root, dir) {
    root.set_child(!dir, single_rotate(root.get_child(!dir), !dir));
    return single_rotate(root, dir);
}

module.exports = RBTree;


/***/ }),

/***/ 5301:
/***/ (function(module) {


function TreeBase() {}

// removes all nodes from the tree
TreeBase.prototype.clear = function() {
    this._root = null;
    this.size = 0;
};

// returns node data if found, null otherwise
TreeBase.prototype.find = function(data) {
    var res = this._root;

    while(res !== null) {
        var c = this._comparator(data, res.data);
        if(c === 0) {
            return res.data;
        }
        else {
            res = res.get_child(c > 0);
        }
    }

    return null;
};

// returns iterator to node if found, null otherwise
TreeBase.prototype.findIter = function(data) {
    var res = this._root;
    var iter = this.iterator();

    while(res !== null) {
        var c = this._comparator(data, res.data);
        if(c === 0) {
            iter._cursor = res;
            return iter;
        }
        else {
            iter._ancestors.push(res);
            res = res.get_child(c > 0);
        }
    }

    return null;
};

// Returns an iterator to the tree node at or immediately after the item
TreeBase.prototype.lowerBound = function(item) {
    var cur = this._root;
    var iter = this.iterator();
    var cmp = this._comparator;

    while(cur !== null) {
        var c = cmp(item, cur.data);
        if(c === 0) {
            iter._cursor = cur;
            return iter;
        }
        iter._ancestors.push(cur);
        cur = cur.get_child(c > 0);
    }

    for(var i=iter._ancestors.length - 1; i >= 0; --i) {
        cur = iter._ancestors[i];
        if(cmp(item, cur.data) < 0) {
            iter._cursor = cur;
            iter._ancestors.length = i;
            return iter;
        }
    }

    iter._ancestors.length = 0;
    return iter;
};

// Returns an iterator to the tree node immediately after the item
TreeBase.prototype.upperBound = function(item) {
    var iter = this.lowerBound(item);
    var cmp = this._comparator;

    while(iter.data() !== null && cmp(iter.data(), item) === 0) {
        iter.next();
    }

    return iter;
};

// returns null if tree is empty
TreeBase.prototype.min = function() {
    var res = this._root;
    if(res === null) {
        return null;
    }

    while(res.left !== null) {
        res = res.left;
    }

    return res.data;
};

// returns null if tree is empty
TreeBase.prototype.max = function() {
    var res = this._root;
    if(res === null) {
        return null;
    }

    while(res.right !== null) {
        res = res.right;
    }

    return res.data;
};

// returns a null iterator
// call next() or prev() to point to an element
TreeBase.prototype.iterator = function() {
    return new Iterator(this);
};

// calls cb on each node's data, in order
TreeBase.prototype.each = function(cb) {
    var it=this.iterator(), data;
    while((data = it.next()) !== null) {
        if(cb(data) === false) {
            return;
        }
    }
};

// calls cb on each node's data, in reverse order
TreeBase.prototype.reach = function(cb) {
    var it=this.iterator(), data;
    while((data = it.prev()) !== null) {
        if(cb(data) === false) {
            return;
        }
    }
};


function Iterator(tree) {
    this._tree = tree;
    this._ancestors = [];
    this._cursor = null;
}

Iterator.prototype.data = function() {
    return this._cursor !== null ? this._cursor.data : null;
};

// if null-iterator, returns first node
// otherwise, returns next node
Iterator.prototype.next = function() {
    if(this._cursor === null) {
        var root = this._tree._root;
        if(root !== null) {
            this._minNode(root);
        }
    }
    else {
        if(this._cursor.right === null) {
            // no greater node in subtree, go up to parent
            // if coming from a right child, continue up the stack
            var save;
            do {
                save = this._cursor;
                if(this._ancestors.length) {
                    this._cursor = this._ancestors.pop();
                }
                else {
                    this._cursor = null;
                    break;
                }
            } while(this._cursor.right === save);
        }
        else {
            // get the next node from the subtree
            this._ancestors.push(this._cursor);
            this._minNode(this._cursor.right);
        }
    }
    return this._cursor !== null ? this._cursor.data : null;
};

// if null-iterator, returns last node
// otherwise, returns previous node
Iterator.prototype.prev = function() {
    if(this._cursor === null) {
        var root = this._tree._root;
        if(root !== null) {
            this._maxNode(root);
        }
    }
    else {
        if(this._cursor.left === null) {
            var save;
            do {
                save = this._cursor;
                if(this._ancestors.length) {
                    this._cursor = this._ancestors.pop();
                }
                else {
                    this._cursor = null;
                    break;
                }
            } while(this._cursor.left === save);
        }
        else {
            this._ancestors.push(this._cursor);
            this._maxNode(this._cursor.left);
        }
    }
    return this._cursor !== null ? this._cursor.data : null;
};

Iterator.prototype._minNode = function(start) {
    while(start.left !== null) {
        this._ancestors.push(start);
        start = start.left;
    }
    this._cursor = start;
};

Iterator.prototype._maxNode = function(start) {
    while(start.right !== null) {
        this._ancestors.push(start);
        start = start.right;
    }
    this._cursor = start;
};

module.exports = TreeBase;



/***/ }),

/***/ 47166:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 48168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* MIT license */
var cssKeywords = __webpack_require__(39092);

// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in cssKeywords) {
	if (cssKeywords.hasOwnProperty(key)) {
		reverseKeywords[cssKeywords[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in cssKeywords) {
		if (cssKeywords.hasOwnProperty(keyword)) {
			var value = cssKeywords[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return cssKeywords[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};


/***/ }),

/***/ 12085:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var conversions = __webpack_require__(48168);
var route = __webpack_require__(85468);

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

module.exports = convert;


/***/ }),

/***/ 39092:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 85468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var conversions = __webpack_require__(48168);

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

module.exports = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};



/***/ }),

/***/ 8874:
/***/ (function(module) {

"use strict";


module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};


/***/ }),

/***/ 19818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(8874);
var swizzle = __webpack_require__(86851);
var hasOwnProperty = Object.hasOwnProperty;

var reverseNames = Object.create(null);

// create a list of reverse color names
for (var name in colorNames) {
	if (hasOwnProperty.call(colorNames, name)) {
		reverseNames[colorNames[name]] = name;
	}
}

var cs = module.exports = {
	to: {},
	get: {}
};

cs.get = function (string) {
	var prefix = string.substring(0, 3).toLowerCase();
	var val;
	var model;
	switch (prefix) {
		case 'hsl':
			val = cs.get.hsl(string);
			model = 'hsl';
			break;
		case 'hwb':
			val = cs.get.hwb(string);
			model = 'hwb';
			break;
		default:
			val = cs.get.rgb(string);
			model = 'rgb';
			break;
	}

	if (!val) {
		return null;
	}

	return {model: model, value: val};
};

cs.get.rgb = function (string) {
	if (!string) {
		return null;
	}

	var abbr = /^#([a-f0-9]{3,4})$/i;
	var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
	var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
	var keyword = /^(\w+)$/;

	var rgb = [0, 0, 0, 1];
	var match;
	var i;
	var hexAlpha;

	if (match = string.match(hex)) {
		hexAlpha = match[2];
		match = match[1];

		for (i = 0; i < 3; i++) {
			// https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
			var i2 = i * 2;
			rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha, 16) / 255;
		}
	} else if (match = string.match(abbr)) {
		match = match[1];
		hexAlpha = match[3];

		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i] + match[i], 16);
		}

		if (hexAlpha) {
			rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
		}
	} else if (match = string.match(rgba)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = parseInt(match[i + 1], 0);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(per)) {
		for (i = 0; i < 3; i++) {
			rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
		}

		if (match[4]) {
			if (match[5]) {
				rgb[3] = parseFloat(match[4]) * 0.01;
			} else {
				rgb[3] = parseFloat(match[4]);
			}
		}
	} else if (match = string.match(keyword)) {
		if (match[1] === 'transparent') {
			return [0, 0, 0, 0];
		}

		if (!hasOwnProperty.call(colorNames, match[1])) {
			return null;
		}

		rgb = colorNames[match[1]];
		rgb[3] = 1;

		return rgb;
	} else {
		return null;
	}

	for (i = 0; i < 3; i++) {
		rgb[i] = clamp(rgb[i], 0, 255);
	}
	rgb[3] = clamp(rgb[3], 0, 1);

	return rgb;
};

cs.get.hsl = function (string) {
	if (!string) {
		return null;
	}

	var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hsl);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var s = clamp(parseFloat(match[2]), 0, 100);
		var l = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);

		return [h, s, l, a];
	}

	return null;
};

cs.get.hwb = function (string) {
	if (!string) {
		return null;
	}

	var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
	var match = string.match(hwb);

	if (match) {
		var alpha = parseFloat(match[4]);
		var h = ((parseFloat(match[1]) % 360) + 360) % 360;
		var w = clamp(parseFloat(match[2]), 0, 100);
		var b = clamp(parseFloat(match[3]), 0, 100);
		var a = clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
		return [h, w, b, a];
	}

	return null;
};

cs.to.hex = function () {
	var rgba = swizzle(arguments);

	return (
		'#' +
		hexDouble(rgba[0]) +
		hexDouble(rgba[1]) +
		hexDouble(rgba[2]) +
		(rgba[3] < 1
			? (hexDouble(Math.round(rgba[3] * 255)))
			: '')
	);
};

cs.to.rgb = function () {
	var rgba = swizzle(arguments);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')'
		: 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};

cs.to.rgb.percent = function () {
	var rgba = swizzle(arguments);

	var r = Math.round(rgba[0] / 255 * 100);
	var g = Math.round(rgba[1] / 255 * 100);
	var b = Math.round(rgba[2] / 255 * 100);

	return rgba.length < 4 || rgba[3] === 1
		? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)'
		: 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};

cs.to.hsl = function () {
	var hsla = swizzle(arguments);
	return hsla.length < 4 || hsla[3] === 1
		? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)'
		: 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
cs.to.hwb = function () {
	var hwba = swizzle(arguments);

	var a = '';
	if (hwba.length >= 4 && hwba[3] !== 1) {
		a = ', ' + hwba[3];
	}

	return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};

cs.to.keyword = function (rgb) {
	return reverseNames[rgb.slice(0, 3)];
};

// helpers
function clamp(num, min, max) {
	return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
	var str = Math.round(num).toString(16).toUpperCase();
	return (str.length < 2) ? '0' + str : str;
}


/***/ }),

/***/ 6767:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var colorString = __webpack_require__(19818);
var convert = __webpack_require__(12085);

var _slice = [].slice;

var skippedModels = [
	// to be honest, I don't really feel like keyword belongs in color convert, but eh.
	'keyword',

	// gray conflicts with some method names, and has its own method defined.
	'gray',

	// shouldn't really be in color-convert either...
	'hex'
];

var hashedModelKeys = {};
Object.keys(convert).forEach(function (model) {
	hashedModelKeys[_slice.call(convert[model].labels).sort().join('')] = model;
});

var limiters = {};

function Color(obj, model) {
	if (!(this instanceof Color)) {
		return new Color(obj, model);
	}

	if (model && model in skippedModels) {
		model = null;
	}

	if (model && !(model in convert)) {
		throw new Error('Unknown model: ' + model);
	}

	var i;
	var channels;

	if (obj == null) { // eslint-disable-line no-eq-null,eqeqeq
		this.model = 'rgb';
		this.color = [0, 0, 0];
		this.valpha = 1;
	} else if (obj instanceof Color) {
		this.model = obj.model;
		this.color = obj.color.slice();
		this.valpha = obj.valpha;
	} else if (typeof obj === 'string') {
		var result = colorString.get(obj);
		if (result === null) {
			throw new Error('Unable to parse color from string: ' + obj);
		}

		this.model = result.model;
		channels = convert[this.model].channels;
		this.color = result.value.slice(0, channels);
		this.valpha = typeof result.value[channels] === 'number' ? result.value[channels] : 1;
	} else if (obj.length) {
		this.model = model || 'rgb';
		channels = convert[this.model].channels;
		var newArr = _slice.call(obj, 0, channels);
		this.color = zeroArray(newArr, channels);
		this.valpha = typeof obj[channels] === 'number' ? obj[channels] : 1;
	} else if (typeof obj === 'number') {
		// this is always RGB - can be converted later on.
		obj &= 0xFFFFFF;
		this.model = 'rgb';
		this.color = [
			(obj >> 16) & 0xFF,
			(obj >> 8) & 0xFF,
			obj & 0xFF
		];
		this.valpha = 1;
	} else {
		this.valpha = 1;

		var keys = Object.keys(obj);
		if ('alpha' in obj) {
			keys.splice(keys.indexOf('alpha'), 1);
			this.valpha = typeof obj.alpha === 'number' ? obj.alpha : 0;
		}

		var hashedKeys = keys.sort().join('');
		if (!(hashedKeys in hashedModelKeys)) {
			throw new Error('Unable to parse color from object: ' + JSON.stringify(obj));
		}

		this.model = hashedModelKeys[hashedKeys];

		var labels = convert[this.model].labels;
		var color = [];
		for (i = 0; i < labels.length; i++) {
			color.push(obj[labels[i]]);
		}

		this.color = zeroArray(color);
	}

	// perform limitations (clamping, etc.)
	if (limiters[this.model]) {
		channels = convert[this.model].channels;
		for (i = 0; i < channels; i++) {
			var limit = limiters[this.model][i];
			if (limit) {
				this.color[i] = limit(this.color[i]);
			}
		}
	}

	this.valpha = Math.max(0, Math.min(1, this.valpha));

	if (Object.freeze) {
		Object.freeze(this);
	}
}

Color.prototype = {
	toString: function () {
		return this.string();
	},

	toJSON: function () {
		return this[this.model]();
	},

	string: function (places) {
		var self = this.model in colorString.to ? this : this.rgb();
		self = self.round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to[self.model](args);
	},

	percentString: function (places) {
		var self = this.rgb().round(typeof places === 'number' ? places : 1);
		var args = self.valpha === 1 ? self.color : self.color.concat(this.valpha);
		return colorString.to.rgb.percent(args);
	},

	array: function () {
		return this.valpha === 1 ? this.color.slice() : this.color.concat(this.valpha);
	},

	object: function () {
		var result = {};
		var channels = convert[this.model].channels;
		var labels = convert[this.model].labels;

		for (var i = 0; i < channels; i++) {
			result[labels[i]] = this.color[i];
		}

		if (this.valpha !== 1) {
			result.alpha = this.valpha;
		}

		return result;
	},

	unitArray: function () {
		var rgb = this.rgb().color;
		rgb[0] /= 255;
		rgb[1] /= 255;
		rgb[2] /= 255;

		if (this.valpha !== 1) {
			rgb.push(this.valpha);
		}

		return rgb;
	},

	unitObject: function () {
		var rgb = this.rgb().object();
		rgb.r /= 255;
		rgb.g /= 255;
		rgb.b /= 255;

		if (this.valpha !== 1) {
			rgb.alpha = this.valpha;
		}

		return rgb;
	},

	round: function (places) {
		places = Math.max(places || 0, 0);
		return new Color(this.color.map(roundToPlace(places)).concat(this.valpha), this.model);
	},

	alpha: function (val) {
		if (arguments.length) {
			return new Color(this.color.concat(Math.max(0, Math.min(1, val))), this.model);
		}

		return this.valpha;
	},

	// rgb
	red: getset('rgb', 0, maxfn(255)),
	green: getset('rgb', 1, maxfn(255)),
	blue: getset('rgb', 2, maxfn(255)),

	hue: getset(['hsl', 'hsv', 'hsl', 'hwb', 'hcg'], 0, function (val) { return ((val % 360) + 360) % 360; }), // eslint-disable-line brace-style

	saturationl: getset('hsl', 1, maxfn(100)),
	lightness: getset('hsl', 2, maxfn(100)),

	saturationv: getset('hsv', 1, maxfn(100)),
	value: getset('hsv', 2, maxfn(100)),

	chroma: getset('hcg', 1, maxfn(100)),
	gray: getset('hcg', 2, maxfn(100)),

	white: getset('hwb', 1, maxfn(100)),
	wblack: getset('hwb', 2, maxfn(100)),

	cyan: getset('cmyk', 0, maxfn(100)),
	magenta: getset('cmyk', 1, maxfn(100)),
	yellow: getset('cmyk', 2, maxfn(100)),
	black: getset('cmyk', 3, maxfn(100)),

	x: getset('xyz', 0, maxfn(100)),
	y: getset('xyz', 1, maxfn(100)),
	z: getset('xyz', 2, maxfn(100)),

	l: getset('lab', 0, maxfn(100)),
	a: getset('lab', 1),
	b: getset('lab', 2),

	keyword: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return convert[this.model].keyword(this.color);
	},

	hex: function (val) {
		if (arguments.length) {
			return new Color(val);
		}

		return colorString.to.hex(this.rgb().round().color);
	},

	rgbNumber: function () {
		var rgb = this.rgb().color;
		return ((rgb[0] & 0xFF) << 16) | ((rgb[1] & 0xFF) << 8) | (rgb[2] & 0xFF);
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.rgb().color;

		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}

		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();

		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}

		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	isDark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.rgb().color;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	isLight: function () {
		return !this.isDark();
	},

	negate: function () {
		var rgb = this.rgb();
		for (var i = 0; i < 3; i++) {
			rgb.color[i] = 255 - rgb.color[i];
		}
		return rgb;
	},

	lighten: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] += hsl.color[2] * ratio;
		return hsl;
	},

	darken: function (ratio) {
		var hsl = this.hsl();
		hsl.color[2] -= hsl.color[2] * ratio;
		return hsl;
	},

	saturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] += hsl.color[1] * ratio;
		return hsl;
	},

	desaturate: function (ratio) {
		var hsl = this.hsl();
		hsl.color[1] -= hsl.color[1] * ratio;
		return hsl;
	},

	whiten: function (ratio) {
		var hwb = this.hwb();
		hwb.color[1] += hwb.color[1] * ratio;
		return hwb;
	},

	blacken: function (ratio) {
		var hwb = this.hwb();
		hwb.color[2] += hwb.color[2] * ratio;
		return hwb;
	},

	grayscale: function () {
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var rgb = this.rgb().color;
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		return Color.rgb(val, val, val);
	},

	fade: function (ratio) {
		return this.alpha(this.valpha - (this.valpha * ratio));
	},

	opaquer: function (ratio) {
		return this.alpha(this.valpha + (this.valpha * ratio));
	},

	rotate: function (degrees) {
		var hsl = this.hsl();
		var hue = hsl.color[0];
		hue = (hue + degrees) % 360;
		hue = hue < 0 ? 360 + hue : hue;
		hsl.color[0] = hue;
		return hsl;
	},

	mix: function (mixinColor, weight) {
		// ported from sass implementation in C
		// https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		if (!mixinColor || !mixinColor.rgb) {
			throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
		}
		var color1 = mixinColor.rgb();
		var color2 = this.rgb();
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return Color.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue(),
				color1.alpha() * p + color2.alpha() * (1 - p));
	}
};

// model conversion methods and static constructors
Object.keys(convert).forEach(function (model) {
	if (skippedModels.indexOf(model) !== -1) {
		return;
	}

	var channels = convert[model].channels;

	// conversion methods
	Color.prototype[model] = function () {
		if (this.model === model) {
			return new Color(this);
		}

		if (arguments.length) {
			return new Color(arguments, model);
		}

		var newAlpha = typeof arguments[channels] === 'number' ? channels : this.valpha;
		return new Color(assertArray(convert[this.model][model].raw(this.color)).concat(newAlpha), model);
	};

	// 'static' construction methods
	Color[model] = function (color) {
		if (typeof color === 'number') {
			color = zeroArray(_slice.call(arguments), channels);
		}
		return new Color(color, model);
	};
});

function roundTo(num, places) {
	return Number(num.toFixed(places));
}

function roundToPlace(places) {
	return function (num) {
		return roundTo(num, places);
	};
}

function getset(model, channel, modifier) {
	model = Array.isArray(model) ? model : [model];

	model.forEach(function (m) {
		(limiters[m] || (limiters[m] = []))[channel] = modifier;
	});

	model = model[0];

	return function (val) {
		var result;

		if (arguments.length) {
			if (modifier) {
				val = modifier(val);
			}

			result = this[model]();
			result.color[channel] = val;
			return result;
		}

		result = this[model]().color[channel];
		if (modifier) {
			result = modifier(result);
		}

		return result;
	};
}

function maxfn(max) {
	return function (v) {
		return Math.max(0, Math.min(max, v));
	};
}

function assertArray(val) {
	return Array.isArray(val) ? val : [val];
}

function zeroArray(arr, length) {
	for (var i = 0; i < length; i++) {
		if (typeof arr[i] !== 'number') {
			arr[i] = 0;
		}
	}

	return arr;
}

module.exports = Color;


/***/ }),

/***/ 54098:
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 44020:
/***/ (function(module) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ 79180:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(59829)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code])?$/;

    return {
        /**
         * Given an Error object, extract the most information from it.
         *
         * @param {Error} error object
         * @return {Array} of StackFrames
         */
        parse: function ErrorStackParser$$parse(error) {
            if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
                return this.parseOpera(error);
            } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
                return this.parseV8OrIE(error);
            } else if (error.stack) {
                return this.parseFFOrSafari(error);
            } else {
                throw new Error('Cannot parse given Error object');
            }
        },

        // Separate line and column numbers from a string of the form: (URI:Line:Column)
        extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
            // Fail-fast but return locations like "(native)"
            if (urlLike.indexOf(':') === -1) {
                return [urlLike];
            }

            var regExp = /(.+?)(?::(\d+))?(?::(\d+))?$/;
            var parts = regExp.exec(urlLike.replace(/[()]/g, ''));
            return [parts[1], parts[2] || undefined, parts[3] || undefined];
        },

        parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(CHROME_IE_STACK_REGEXP);
            }, this);

            return filtered.map(function(line) {
                if (line.indexOf('(eval ') > -1) {
                    // Throw away eval information until we implement stacktrace.js/stackframe#8
                    line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^()]*)|(,.*$)/g, '');
                }
                var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(').replace(/^.*?\s+/, '');

                // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
                // case it has spaces in it, as the string is split on \s+ later on
                var location = sanitizedLine.match(/ (\(.+\)$)/);

                // remove the parenthesized location from the line, if it was matched
                sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;

                // if a location was matched, pass it to extractLocation() otherwise pass all sanitizedLine
                // because this line doesn't have function name
                var locationParts = this.extractLocation(location ? location[1] : sanitizedLine);
                var functionName = location && sanitizedLine || undefined;
                var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];

                return new StackFrame({
                    functionName: functionName,
                    fileName: fileName,
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        },

        parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !line.match(SAFARI_NATIVE_CODE_REGEXP);
            }, this);

            return filtered.map(function(line) {
                // Throw away eval information until we implement stacktrace.js/stackframe#8
                if (line.indexOf(' > eval') > -1) {
                    line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ':$1');
                }

                if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
                    // Safari eval frames only have function names and nothing else
                    return new StackFrame({
                        functionName: line
                    });
                } else {
                    var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
                    var matches = line.match(functionNameRegex);
                    var functionName = matches && matches[1] ? matches[1] : undefined;
                    var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));

                    return new StackFrame({
                        functionName: functionName,
                        fileName: locationParts[0],
                        lineNumber: locationParts[1],
                        columnNumber: locationParts[2],
                        source: line
                    });
                }
            }, this);
        },

        parseOpera: function ErrorStackParser$$parseOpera(e) {
            if (!e.stacktrace || (e.message.indexOf('\n') > -1 &&
                e.message.split('\n').length > e.stacktrace.split('\n').length)) {
                return this.parseOpera9(e);
            } else if (!e.stack) {
                return this.parseOpera10(e);
            } else {
                return this.parseOpera11(e);
            }
        },

        parseOpera9: function ErrorStackParser$$parseOpera9(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
            var lines = e.message.split('\n');
            var result = [];

            for (var i = 2, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(new StackFrame({
                        fileName: match[2],
                        lineNumber: match[1],
                        source: lines[i]
                    }));
                }
            }

            return result;
        },

        parseOpera10: function ErrorStackParser$$parseOpera10(e) {
            var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
            var lines = e.stacktrace.split('\n');
            var result = [];

            for (var i = 0, len = lines.length; i < len; i += 2) {
                var match = lineRE.exec(lines[i]);
                if (match) {
                    result.push(
                        new StackFrame({
                            functionName: match[3] || undefined,
                            fileName: match[2],
                            lineNumber: match[1],
                            source: lines[i]
                        })
                    );
                }
            }

            return result;
        },

        // Opera 10.65+ Error.stack very similar to FF/Safari
        parseOpera11: function ErrorStackParser$$parseOpera11(error) {
            var filtered = error.stack.split('\n').filter(function(line) {
                return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
            }, this);

            return filtered.map(function(line) {
                var tokens = line.split('@');
                var locationParts = this.extractLocation(tokens.pop());
                var functionCall = (tokens.shift() || '');
                var functionName = functionCall
                    .replace(/<anonymous function(: (\w+))?>/, '$2')
                    .replace(/\([^)]*\)/g, '') || undefined;
                var argsRaw;
                if (functionCall.match(/\(([^)]*)\)/)) {
                    argsRaw = functionCall.replace(/^[^(]+\(([^)]*)\)$/, '$1');
                }
                var args = (argsRaw === undefined || argsRaw === '[arguments not available]') ?
                    undefined : argsRaw.split(',');

                return new StackFrame({
                    functionName: functionName,
                    args: args,
                    fileName: locationParts[0],
                    lineNumber: locationParts[1],
                    columnNumber: locationParts[2],
                    source: line
                });
            }, this);
        }
    };
}));


/***/ }),

/***/ 92806:
/***/ (function(module) {

"use strict";

module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ 75063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ps": function() { return /* binding */ gql; }
});

// UNUSED EXPORTS: default, disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, resetCaches

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/polyfills/symbols.mjs
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, getLocation(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs
function GraphQLError_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { GraphQLError_typeof = function _typeof(obj) { return typeof obj; }; } else { GraphQLError_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return GraphQLError_typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (GraphQLError_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return getLocation(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return getLocation(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && isObjectLike(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + printLocation(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + printSourceLocation(error.source, location);
    }
  }

  return output;
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs + 2 modules
var ast = __webpack_require__(29749);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs
function instanceOf_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { instanceOf_typeof = function _typeof(obj) { return typeof obj; }; } else { instanceOf_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return instanceOf_typeof(obj); }


/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
/* harmony default export */ var instanceOf = ( true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
0);

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs
function source_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function source_createClass(Constructor, protoProps, staticProps) { if (protoProps) source_defineProperties(Constructor.prototype, protoProps); if (staticProps) source_defineProperties(Constructor, staticProps); return Constructor; }






/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || devAssert(0, "Body must be a string. Received: ".concat((0,inspect/* default */.Z)(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || devAssert(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || devAssert(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  source_createClass(Source, [{
    key: SYMBOL_TO_STRING_TAG,
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs




/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === tokenKind_TokenKind.BANG || kind === tokenKind_TokenKind.DOLLAR || kind === tokenKind_TokenKind.AMP || kind === tokenKind_TokenKind.PAREN_L || kind === tokenKind_TokenKind.PAREN_R || kind === tokenKind_TokenKind.SPREAD || kind === tokenKind_TokenKind.COLON || kind === tokenKind_TokenKind.EQUALS || kind === tokenKind_TokenKind.AT || kind === tokenKind_TokenKind.BRACKET_L || kind === tokenKind_TokenKind.BRACKET_R || kind === tokenKind_TokenKind.BRACE_L || kind === tokenKind_TokenKind.PIPE || kind === tokenKind_TokenKind.BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? tokenKind_TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new ast/* Token */.WU(tokenKind_TokenKind.BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new ast/* Token */.WU(tokenKind_TokenKind.DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new ast/* Token */.WU(tokenKind_TokenKind.AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new ast/* Token */.WU(tokenKind_TokenKind.PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new ast/* Token */.WU(tokenKind_TokenKind.SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new ast/* Token */.WU(tokenKind_TokenKind.COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new ast/* Token */.WU(tokenKind_TokenKind.EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new ast/* Token */.WU(tokenKind_TokenKind.AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new ast/* Token */.WU(tokenKind_TokenKind.PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new ast/* Token */.WU(tokenKind_TokenKind.BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw syntaxError(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new ast/* Token */.WU(tokenKind_TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new ast/* Token */.WU(tokenKind_TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw syntaxError(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new ast/* Token */.WU(isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw syntaxError(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw syntaxError(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw syntaxError(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new ast/* Token */.WU(tokenKind_TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0,blockString/* dedentBlockStringValue */.W7)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw syntaxError(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw syntaxError(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new ast/* Token */.WU(tokenKind_TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(tokenKind_TokenKind.NAME);
    return {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(tokenKind_TokenKind.SOF, this.parseDefinition, tokenKind_TokenKind.EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(tokenKind_TokenKind.NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseVariableDefinition, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(tokenKind_TokenKind.BRACE_L, this.parseSelection, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(tokenKind_TokenKind.COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.FLOAT:
        this._lexer.advance();

        return {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: kinds/* Kind.NULL */.h.NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case tokenKind_TokenKind.DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);
    return {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseNamedType();
    return {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(tokenKind_TokenKind.AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(tokenKind_TokenKind.AMP) || this.peek(tokenKind_TokenKind.NAME));

      return types;
    }

    return this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(tokenKind_TokenKind.BRACE_L) && this._lexer.lookahead().kind === tokenKind_TokenKind.BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseFieldDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, this.parseInputValueDef, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS) ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseEnumValueDefinition, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseInputValueDef, tokenKind_TokenKind.BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(tokenKind_TokenKind.BRACE_L, this.parseOperationTypeDefinition, tokenKind_TokenKind.BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (DirectiveLocation[name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new ast/* Location */.Ye(startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw syntaxError(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw syntaxError(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? "\"".concat(kind, "\"") : kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = ((/* unused pure expression or super */ null && (gql)));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 68203:
/***/ (function(module, exports, __webpack_require__) {

// Save global object in a variable
var __global__ =
(typeof globalThis !== 'undefined' && globalThis) ||
(typeof self !== 'undefined' && self) ||
(typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g);
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = (function () {
function F() {
this.fetch = false;
this.DOMException = __global__.DOMException
}
F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
return new F();
})();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis) {

var irrelevant = (function (exports) {

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  return exports;

})({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports["default"] = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),

/***/ 62402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Linkify; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var linkifyjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51854);



function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Given a string, converts to an array of valid React components
 * (which may include strings)
 * @param {string} str
 * @param {any} opts
 * @returns {React.ReactNodeArray}
 */

function stringToElements(str, opts) {
  var tokens = (0,linkifyjs__WEBPACK_IMPORTED_MODULE_1__/* .tokenize */ .wS)(str);
  var elements = [];
  var linkId = 0;

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (token.t === 'nl' && opts.nl2br) {
      elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement('br', {
        key: "linkified-".concat(++linkId)
      }));
      continue;
    } else if (!token.isLink || !opts.check(token)) {
      // Regular text
      elements.push(token.toString());
      continue;
    }

    var _opts$resolve = opts.resolve(token),
        formatted = _opts$resolve.formatted,
        formattedHref = _opts$resolve.formattedHref,
        tagName = _opts$resolve.tagName,
        className = _opts$resolve.className,
        target = _opts$resolve.target,
        rel = _opts$resolve.rel,
        attributes = _opts$resolve.attributes;

    var props = {
      key: "linkified-".concat(++linkId),
      href: formattedHref
    };

    if (className) {
      props.className = className;
    }

    if (target) {
      props.target = target;
    }

    if (rel) {
      props.rel = rel;
    } // Build up additional attributes
    // Support for events via attributes hash


    if (attributes) {
      for (var attr in attributes) {
        props[attr] = attributes[attr];
      }
    }

    elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(tagName, props, formatted));
  }

  return elements;
} // Recursively linkify the contents of the given React Element instance

/**
 * @template P
 * @template {string | React.JSXElementConstructor<P>} T
 * @param {React.ReactElement<P, T>} element
 * @param {Object} opts
 * @param {number} elementId
 * @returns {React.ReactElement<P, T>}
 */


function linkifyReactElement(element, opts) {
  var elementId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  if (react__WEBPACK_IMPORTED_MODULE_0__.Children.count(element.props.children) === 0) {
    // No need to clone if the element had no children
    return element;
  }

  var children = [];
  react__WEBPACK_IMPORTED_MODULE_0__.Children.forEach(element.props.children, function (child) {
    if (typeof child === 'string') {
      // ensure that we always generate unique element IDs for keys
      elementId = elementId + 1;
      children.push.apply(children, _toConsumableArray(stringToElements(child, opts)));
    } else if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(child)) {
      if (typeof child.type === 'string' && opts.ignoreTags.indexOf(child.type.toUpperCase()) >= 0) {
        // Don't linkify this element
        children.push(child);
      } else {
        children.push(linkifyReactElement(child, opts, ++elementId));
      }
    } else {
      // Unknown element type, just push
      children.push(child);
    }
  }); // Set a default unique key, copy over remaining props

  var newProps = {
    key: "linkified-element-".concat(elementId)
  };

  for (var prop in element.props) {
    newProps[prop] = element.props[prop];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(element, newProps, children);
}
/**
 * @template P
 * @template {string | React.JSXElementConstructor<P>} T
 * @param {P & { tagName?: T, options?: any, children?: React.ReactNode}} props
 * @returns {React.ReactElement<P, T>}
 */


var Linkify = function Linkify(props) {
  // Copy over all non-linkify-specific props
  var newProps = {
    key: 'linkified-element-wrapper'
  };

  for (var prop in props) {
    if (prop !== 'options' && prop !== 'tagName' && prop !== 'children') {
      newProps[prop] = props[prop];
    }
  }

  var opts = new linkifyjs__WEBPACK_IMPORTED_MODULE_1__/* .Options */ .Ei(props.options);
  var tagName = props.tagName || react__WEBPACK_IMPORTED_MODULE_0__.Fragment || 'span';
  var children = props.children;
  var element = react__WEBPACK_IMPORTED_MODULE_0__.createElement(tagName, newProps, children);
  return linkifyReactElement(element, opts, 0);
};




/***/ }),

/***/ 51854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ Options; },
/* harmony export */   "sE": function() { return /* binding */ find; },
/* harmony export */   "wS": function() { return /* binding */ tokenize; }
/* harmony export */ });
/* unused harmony exports init, options, registerCustomProtocol, registerPlugin, reset, test */
/**
 * Finite State Machine generation utilities
 */

/**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 * @param {string|class} token to emit
 */
function State(token) {
  this.j = {}; // IMPLEMENTATION 1
  // this.j = []; // IMPLEMENTATION 2

  this.jr = [];
  this.jd = null;
  this.t = token;
}
/**
 * Take the transition from this state to the next one on the given input.
 * If this state does not exist deterministically, will create it.
 *
 * @param {string} input character or token to transition on
 * @param {string|class} [token] token or multi-token to emit when reaching
 * this state
 */

State.prototype = {
  /**
   * @param {State} state
   */
  accepts: function accepts() {
    return !!this.t;
  },

  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * @param {string} input character or token to transition on
   * @param {Token|State} tokenOrState transition to a matching state
   * @returns State taken after the given input
   */
  tt: function tt(input, tokenOrState) {
    if (tokenOrState && tokenOrState.j) {
      // State, default a basic transition
      this.j[input] = tokenOrState;
      return tokenOrState;
    } // See if there's a direct state transition (not regex or default)


    var token = tokenOrState;
    var nextState = this.j[input];

    if (nextState) {
      if (token) {
        nextState.t = token;
      } // overrwites previous token


      return nextState;
    } // Create a new state for this input


    nextState = makeState(); // Take the transition using the usual default mechanisms

    var templateState = takeT(this, input);

    if (templateState) {
      // Some default state transition, make a prime state based on this one
      Object.assign(nextState.j, templateState.j);
      nextState.jr.append(templateState.jr);
      nextState.jr = templateState.jd;
      nextState.t = token || templateState.t;
    } else {
      nextState.t = token;
    }

    this.j[input] = nextState;
    return nextState;
  }
};
/**
 * Utility function to create state without using new keyword (reduced file size
 * when minified)
 */

var makeState = function makeState() {
  return new State();
};
/**
 * Similar to previous except it is an accepting state that emits a token
 * @param {Token} token
 */

var makeAcceptingState = function makeAcceptingState(token) {
  return new State(token);
};
/**
 * Create a transition from startState to nextState via the given character
 * @param {State} startState transition from thie starting state
 * @param {Token} input via this input character or other concrete token type
 * @param {State} nextState to this next state
 */

var makeT = function makeT(startState, input, nextState) {
  // IMPLEMENTATION 1: Add to object (fast)
  if (!startState.j[input]) {
    startState.j[input] = nextState;
  } // IMPLEMENTATION 2: Add to array (slower)
  // startState.j.push([input, nextState]);

};
/**
 *
 * @param {State} startState stransition from this starting state
 * @param {RegExp} regex Regular expression to match on input
 * @param {State} nextState transition to this next state if there's are regex match
 */

var makeRegexT = function makeRegexT(startState, regex, nextState) {
  startState.jr.push([regex, nextState]);
};
/**
 * Follow the transition from the given character to the next state
 * @param {State} state
 * @param {Token} input character or other concrete token type to transition
 * @returns {?State} the next state, if any
 */

var takeT = function takeT(state, input) {
  // IMPLEMENTATION 1: Object key lookup (faster)
  var nextState = state.j[input];

  if (nextState) {
    return nextState;
  } // IMPLEMENTATION 2: List lookup (slower)
  // Loop through all the state transitions and see if there's a match
  // for (let i = 0; i < state.j.length; i++) {
  //	const val = state.j[i][0];
  //	const nextState = state.j[i][1];
  // 	if (input === val) { return nextState; }
  // }


  for (var i = 0; i < state.jr.length; i++) {
    var regex = state.jr[i][0];
    var _nextState = state.jr[i][1];

    if (regex.test(input)) {
      return _nextState;
    }
  } // Nowhere left to jump! Return default, if any


  return state.jd;
};
/**
 * Similar to makeT, but takes a list of characters that all transition to the
 * same nextState startState
 * @param {State} startState
 * @param {Array} chars
 * @param {State} nextState
 */

var makeMultiT = function makeMultiT(startState, chars, nextState) {
  for (var i = 0; i < chars.length; i++) {
    makeT(startState, chars[i], nextState);
  }
};
/**
 * Set up a list of multiple transitions at once. transitions is a list of
 * tuples, where the first element is the transitions character and the second
 * is the state to transition to
 * @param {State} startState
 * @param {Array} transitions
 */

var makeBatchT = function makeBatchT(startState, transitions) {
  for (var i = 0; i < transitions.length; i++) {
    var input = transitions[i][0];
    var nextState = transitions[i][1];
    makeT(startState, input, nextState);
  }
};
/**
 * For state machines that transition on characters only; given a non-empty
 * target string, generates states (if required) for each consecutive substring
 * of characters starting from the beginning of the string. The final state will
 * have a special value, as specified in options. All other "in between"
 * substrings will have a default end state.
 *
 * This turns the state machine into a Trie-like data structure (rather than a
 * intelligently-designed DFA).
 * @param {State} state
 * @param {string} str
 * @param {Token} endStateFactory
 * @param {Token} defaultStateFactory
 */

var makeChainT = function makeChainT(state, str, endState, defaultStateFactory) {
  var i = 0,
      len = str.length,
      nextState; // Find the next state without a jump to the next character

  while (i < len && (nextState = state.j[str[i]])) {
    state = nextState;
    i++;
  }

  if (i >= len) {
    return [];
  } // no new tokens were added


  while (i < len - 1) {
    nextState = defaultStateFactory();
    makeT(state, str[i], nextState);
    state = nextState;
    i++;
  }

  makeT(state, str[len - 1], endState);
};

/******************************************************************************
	Text Tokens
	Tokens composed of strings
******************************************************************************/
// A valid web domain token
var DOMAIN = 'DOMAIN';
var LOCALHOST = 'LOCALHOST'; // special case of domain
// Valid top-level domain (see tlds.js)

var TLD = 'TLD'; // Any sequence of digits 0-9

var NUM = 'NUM'; // A web URL protocol. Supported types include
// - `http:`
// - `https:`
// - `ftp:`
// - `ftps:`
// - user-defined custom protocols

var PROTOCOL = 'PROTOCOL'; // Start of the email URI protocol

var MAILTO = 'MAILTO'; // mailto:
// Any number of consecutive whitespace characters that are not newline

var WS = 'WS'; // New line (unix style)

var NL = 'NL'; // \n
// Opening/closing bracket classes

var OPENBRACE = 'OPENBRACE'; // {

var OPENBRACKET = 'OPENBRACKET'; // [

var OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <

var OPENPAREN = 'OPENPAREN'; // (

var CLOSEBRACE = 'CLOSEBRACE'; // }

var CLOSEBRACKET = 'CLOSEBRACKET'; // ]

var CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >

var CLOSEPAREN = 'CLOSEPAREN'; // )
// Various symbols

var AMPERSAND = 'AMPERSAND'; // &

var APOSTROPHE = 'APOSTROPHE'; // '

var ASTERISK = 'ASTERISK'; // *

var AT = 'AT'; // @

var BACKSLASH = 'BACKSLASH'; // \

var BACKTICK = 'BACKTICK'; // `

var CARET = 'CARET'; // ^

var COLON = 'COLON'; // :

var COMMA = 'COMMA'; // ,

var DOLLAR = 'DOLLAR'; // $

var DOT = 'DOT'; // .

var EQUALS = 'EQUALS'; // =

var EXCLAMATION = 'EXCLAMATION'; // !

var HYPHEN = 'HYPHEN'; // -

var PERCENT = 'PERCENT'; // %

var PIPE = 'PIPE'; // |

var PLUS = 'PLUS'; // +

var POUND = 'POUND'; // #

var QUERY = 'QUERY'; // ?

var QUOTE = 'QUOTE'; // "

var SEMI = 'SEMI'; // ;

var SLASH = 'SLASH'; // /

var TILDE = 'TILDE'; // ~

var UNDERSCORE = 'UNDERSCORE'; // _
// Default token - anything that is not one of the above

var SYM = 'SYM';

var text = /*#__PURE__*/Object.freeze({
	__proto__: null,
	DOMAIN: DOMAIN,
	LOCALHOST: LOCALHOST,
	TLD: TLD,
	NUM: NUM,
	PROTOCOL: PROTOCOL,
	MAILTO: MAILTO,
	WS: WS,
	NL: NL,
	OPENBRACE: OPENBRACE,
	OPENBRACKET: OPENBRACKET,
	OPENANGLEBRACKET: OPENANGLEBRACKET,
	OPENPAREN: OPENPAREN,
	CLOSEBRACE: CLOSEBRACE,
	CLOSEBRACKET: CLOSEBRACKET,
	CLOSEANGLEBRACKET: CLOSEANGLEBRACKET,
	CLOSEPAREN: CLOSEPAREN,
	AMPERSAND: AMPERSAND,
	APOSTROPHE: APOSTROPHE,
	ASTERISK: ASTERISK,
	AT: AT,
	BACKSLASH: BACKSLASH,
	BACKTICK: BACKTICK,
	CARET: CARET,
	COLON: COLON,
	COMMA: COMMA,
	DOLLAR: DOLLAR,
	DOT: DOT,
	EQUALS: EQUALS,
	EXCLAMATION: EXCLAMATION,
	HYPHEN: HYPHEN,
	PERCENT: PERCENT,
	PIPE: PIPE,
	PLUS: PLUS,
	POUND: POUND,
	QUERY: QUERY,
	QUOTE: QUOTE,
	SEMI: SEMI,
	SLASH: SLASH,
	TILDE: TILDE,
	UNDERSCORE: UNDERSCORE,
	SYM: SYM
});

// NOTE: punycode versions of IDNs are not included here because these will not
// be as commonly used without the http prefix anyway and linkify will already
// force-encode those.
// To be updated with the values in this list
// http://data.iana.org/TLD/tlds-alpha-by-domain.txt
// Version 2021022800, Last Updated Sun Feb 28 07:07:01 2021 UTC
var tlds = 'aaa \
aarp \
abarth \
abb \
abbott \
abbvie \
abc \
able \
abogado \
abudhabi \
ac \
academy \
accenture \
accountant \
accountants \
aco \
actor \
ad \
adac \
ads \
adult \
ae \
aeg \
aero \
aetna \
af \
afamilycompany \
afl \
africa \
ag \
agakhan \
agency \
ai \
aig \
airbus \
airforce \
airtel \
akdn \
al \
alfaromeo \
alibaba \
alipay \
allfinanz \
allstate \
ally \
alsace \
alstom \
am \
amazon \
americanexpress \
americanfamily \
amex \
amfam \
amica \
amsterdam \
analytics \
android \
anquan \
anz \
ao \
aol \
apartments \
app \
apple \
aq \
aquarelle \
ar \
arab \
aramco \
archi \
army \
arpa \
art \
arte \
as \
asda \
asia \
associates \
at \
athleta \
attorney \
au \
auction \
audi \
audible \
audio \
auspost \
author \
auto \
autos \
avianca \
aw \
aws \
ax \
axa \
az \
azure \
ba \
baby \
baidu \
banamex \
bananarepublic \
band \
bank \
bar \
barcelona \
barclaycard \
barclays \
barefoot \
bargains \
baseball \
basketball \
bauhaus \
bayern \
bb \
bbc \
bbt \
bbva \
bcg \
bcn \
bd \
be \
beats \
beauty \
beer \
bentley \
berlin \
best \
bestbuy \
bet \
bf \
bg \
bh \
bharti \
bi \
bible \
bid \
bike \
bing \
bingo \
bio \
biz \
bj \
black \
blackfriday \
blockbuster \
blog \
bloomberg \
blue \
bm \
bms \
bmw \
bn \
bnpparibas \
bo \
boats \
boehringer \
bofa \
bom \
bond \
boo \
book \
booking \
bosch \
bostik \
boston \
bot \
boutique \
box \
br \
bradesco \
bridgestone \
broadway \
broker \
brother \
brussels \
bs \
bt \
budapest \
bugatti \
build \
builders \
business \
buy \
buzz \
bv \
bw \
by \
bz \
bzh \
ca \
cab \
cafe \
cal \
call \
calvinklein \
cam \
camera \
camp \
cancerresearch \
canon \
capetown \
capital \
capitalone \
car \
caravan \
cards \
care \
career \
careers \
cars \
casa \
case \
cash \
casino \
cat \
catering \
catholic \
cba \
cbn \
cbre \
cbs \
cc \
cd \
center \
ceo \
cern \
cf \
cfa \
cfd \
cg \
ch \
chanel \
channel \
charity \
chase \
chat \
cheap \
chintai \
christmas \
chrome \
church \
ci \
cipriani \
circle \
cisco \
citadel \
citi \
citic \
city \
cityeats \
ck \
cl \
claims \
cleaning \
click \
clinic \
clinique \
clothing \
cloud \
club \
clubmed \
cm \
cn \
co \
coach \
codes \
coffee \
college \
cologne \
com \
comcast \
commbank \
community \
company \
compare \
computer \
comsec \
condos \
construction \
consulting \
contact \
contractors \
cooking \
cookingchannel \
cool \
coop \
corsica \
country \
coupon \
coupons \
courses \
cpa \
cr \
credit \
creditcard \
creditunion \
cricket \
crown \
crs \
cruise \
cruises \
csc \
cu \
cuisinella \
cv \
cw \
cx \
cy \
cymru \
cyou \
cz \
dabur \
dad \
dance \
data \
date \
dating \
datsun \
day \
dclk \
dds \
de \
deal \
dealer \
deals \
degree \
delivery \
dell \
deloitte \
delta \
democrat \
dental \
dentist \
desi \
design \
dev \
dhl \
diamonds \
diet \
digital \
direct \
directory \
discount \
discover \
dish \
diy \
dj \
dk \
dm \
dnp \
do \
docs \
doctor \
dog \
domains \
dot \
download \
drive \
dtv \
dubai \
duck \
dunlop \
dupont \
durban \
dvag \
dvr \
dz \
earth \
eat \
ec \
eco \
edeka \
edu \
education \
ee \
eg \
email \
emerck \
energy \
engineer \
engineering \
enterprises \
epson \
equipment \
er \
ericsson \
erni \
es \
esq \
estate \
et \
etisalat \
eu \
eurovision \
eus \
events \
exchange \
expert \
exposed \
express \
extraspace \
fage \
fail \
fairwinds \
faith \
family \
fan \
fans \
farm \
farmers \
fashion \
fast \
fedex \
feedback \
ferrari \
ferrero \
fi \
fiat \
fidelity \
fido \
film \
final \
finance \
financial \
fire \
firestone \
firmdale \
fish \
fishing \
fit \
fitness \
fj \
fk \
flickr \
flights \
flir \
florist \
flowers \
fly \
fm \
fo \
foo \
food \
foodnetwork \
football \
ford \
forex \
forsale \
forum \
foundation \
fox \
fr \
free \
fresenius \
frl \
frogans \
frontdoor \
frontier \
ftr \
fujitsu \
fujixerox \
fun \
fund \
furniture \
futbol \
fyi \
ga \
gal \
gallery \
gallo \
gallup \
game \
games \
gap \
garden \
gay \
gb \
gbiz \
gd \
gdn \
ge \
gea \
gent \
genting \
george \
gf \
gg \
ggee \
gh \
gi \
gift \
gifts \
gives \
giving \
gl \
glade \
glass \
gle \
global \
globo \
gm \
gmail \
gmbh \
gmo \
gmx \
gn \
godaddy \
gold \
goldpoint \
golf \
goo \
goodyear \
goog \
google \
gop \
got \
gov \
gp \
gq \
gr \
grainger \
graphics \
gratis \
green \
gripe \
grocery \
group \
gs \
gt \
gu \
guardian \
gucci \
guge \
guide \
guitars \
guru \
gw \
gy \
hair \
hamburg \
hangout \
haus \
hbo \
hdfc \
hdfcbank \
health \
healthcare \
help \
helsinki \
here \
hermes \
hgtv \
hiphop \
hisamitsu \
hitachi \
hiv \
hk \
hkt \
hm \
hn \
hockey \
holdings \
holiday \
homedepot \
homegoods \
homes \
homesense \
honda \
horse \
hospital \
host \
hosting \
hot \
hoteles \
hotels \
hotmail \
house \
how \
hr \
hsbc \
ht \
hu \
hughes \
hyatt \
hyundai \
ibm \
icbc \
ice \
icu \
id \
ie \
ieee \
ifm \
ikano \
il \
im \
imamat \
imdb \
immo \
immobilien \
in \
inc \
industries \
infiniti \
info \
ing \
ink \
institute \
insurance \
insure \
int \
international \
intuit \
investments \
io \
ipiranga \
iq \
ir \
irish \
is \
ismaili \
ist \
istanbul \
it \
itau \
itv \
iveco \
jaguar \
java \
jcb \
je \
jeep \
jetzt \
jewelry \
jio \
jll \
jm \
jmp \
jnj \
jo \
jobs \
joburg \
jot \
joy \
jp \
jpmorgan \
jprs \
juegos \
juniper \
kaufen \
kddi \
ke \
kerryhotels \
kerrylogistics \
kerryproperties \
kfh \
kg \
kh \
ki \
kia \
kim \
kinder \
kindle \
kitchen \
kiwi \
km \
kn \
koeln \
komatsu \
kosher \
kp \
kpmg \
kpn \
kr \
krd \
kred \
kuokgroup \
kw \
ky \
kyoto \
kz \
la \
lacaixa \
lamborghini \
lamer \
lancaster \
lancia \
land \
landrover \
lanxess \
lasalle \
lat \
latino \
latrobe \
law \
lawyer \
lb \
lc \
lds \
lease \
leclerc \
lefrak \
legal \
lego \
lexus \
lgbt \
li \
lidl \
life \
lifeinsurance \
lifestyle \
lighting \
like \
lilly \
limited \
limo \
lincoln \
linde \
link \
lipsy \
live \
living \
lixil \
lk \
llc \
llp \
loan \
loans \
locker \
locus \
loft \
lol \
london \
lotte \
lotto \
love \
lpl \
lplfinancial \
lr \
ls \
lt \
ltd \
ltda \
lu \
lundbeck \
luxe \
luxury \
lv \
ly \
ma \
macys \
madrid \
maif \
maison \
makeup \
man \
management \
mango \
map \
market \
marketing \
markets \
marriott \
marshalls \
maserati \
mattel \
mba \
mc \
mckinsey \
md \
me \
med \
media \
meet \
melbourne \
meme \
memorial \
men \
menu \
merckmsd \
mg \
mh \
miami \
microsoft \
mil \
mini \
mint \
mit \
mitsubishi \
mk \
ml \
mlb \
mls \
mm \
mma \
mn \
mo \
mobi \
mobile \
moda \
moe \
moi \
mom \
monash \
money \
monster \
mormon \
mortgage \
moscow \
moto \
motorcycles \
mov \
movie \
mp \
mq \
mr \
ms \
msd \
mt \
mtn \
mtr \
mu \
museum \
mutual \
mv \
mw \
mx \
my \
mz \
na \
nab \
nagoya \
name \
nationwide \
natura \
navy \
nba \
nc \
ne \
nec \
net \
netbank \
netflix \
network \
neustar \
new \
news \
next \
nextdirect \
nexus \
nf \
nfl \
ng \
ngo \
nhk \
ni \
nico \
nike \
nikon \
ninja \
nissan \
nissay \
nl \
no \
nokia \
northwesternmutual \
norton \
now \
nowruz \
nowtv \
np \
nr \
nra \
nrw \
ntt \
nu \
nyc \
nz \
obi \
observer \
off \
office \
okinawa \
olayan \
olayangroup \
oldnavy \
ollo \
om \
omega \
one \
ong \
onl \
online \
onyourside \
ooo \
open \
oracle \
orange \
org \
organic \
origins \
osaka \
otsuka \
ott \
ovh \
pa \
page \
panasonic \
paris \
pars \
partners \
parts \
party \
passagens \
pay \
pccw \
pe \
pet \
pf \
pfizer \
pg \
ph \
pharmacy \
phd \
philips \
phone \
photo \
photography \
photos \
physio \
pics \
pictet \
pictures \
pid \
pin \
ping \
pink \
pioneer \
pizza \
pk \
pl \
place \
play \
playstation \
plumbing \
plus \
pm \
pn \
pnc \
pohl \
poker \
politie \
porn \
post \
pr \
pramerica \
praxi \
press \
prime \
pro \
prod \
productions \
prof \
progressive \
promo \
properties \
property \
protection \
pru \
prudential \
ps \
pt \
pub \
pw \
pwc \
py \
qa \
qpon \
quebec \
quest \
qvc \
racing \
radio \
raid \
re \
read \
realestate \
realtor \
realty \
recipes \
red \
redstone \
redumbrella \
rehab \
reise \
reisen \
reit \
reliance \
ren \
rent \
rentals \
repair \
report \
republican \
rest \
restaurant \
review \
reviews \
rexroth \
rich \
richardli \
ricoh \
ril \
rio \
rip \
rmit \
ro \
rocher \
rocks \
rodeo \
rogers \
room \
rs \
rsvp \
ru \
rugby \
ruhr \
run \
rw \
rwe \
ryukyu \
sa \
saarland \
safe \
safety \
sakura \
sale \
salon \
samsclub \
samsung \
sandvik \
sandvikcoromant \
sanofi \
sap \
sarl \
sas \
save \
saxo \
sb \
sbi \
sbs \
sc \
sca \
scb \
schaeffler \
schmidt \
scholarships \
school \
schule \
schwarz \
science \
scjohnson \
scot \
sd \
se \
search \
seat \
secure \
security \
seek \
select \
sener \
services \
ses \
seven \
sew \
sex \
sexy \
sfr \
sg \
sh \
shangrila \
sharp \
shaw \
shell \
shia \
shiksha \
shoes \
shop \
shopping \
shouji \
show \
showtime \
si \
silk \
sina \
singles \
site \
sj \
sk \
ski \
skin \
sky \
skype \
sl \
sling \
sm \
smart \
smile \
sn \
sncf \
so \
soccer \
social \
softbank \
software \
sohu \
solar \
solutions \
song \
sony \
soy \
spa \
space \
sport \
spot \
spreadbetting \
sr \
srl \
ss \
st \
stada \
staples \
star \
statebank \
statefarm \
stc \
stcgroup \
stockholm \
storage \
store \
stream \
studio \
study \
style \
su \
sucks \
supplies \
supply \
support \
surf \
surgery \
suzuki \
sv \
swatch \
swiftcover \
swiss \
sx \
sy \
sydney \
systems \
sz \
tab \
taipei \
talk \
taobao \
target \
tatamotors \
tatar \
tattoo \
tax \
taxi \
tc \
tci \
td \
tdk \
team \
tech \
technology \
tel \
temasek \
tennis \
teva \
tf \
tg \
th \
thd \
theater \
theatre \
tiaa \
tickets \
tienda \
tiffany \
tips \
tires \
tirol \
tj \
tjmaxx \
tjx \
tk \
tkmaxx \
tl \
tm \
tmall \
tn \
to \
today \
tokyo \
tools \
top \
toray \
toshiba \
total \
tours \
town \
toyota \
toys \
tr \
trade \
trading \
training \
travel \
travelchannel \
travelers \
travelersinsurance \
trust \
trv \
tt \
tube \
tui \
tunes \
tushu \
tv \
tvs \
tw \
tz \
ua \
ubank \
ubs \
ug \
uk \
unicom \
university \
uno \
uol \
ups \
us \
uy \
uz \
va \
vacations \
vana \
vanguard \
vc \
ve \
vegas \
ventures \
verisign \
versicherung \
vet \
vg \
vi \
viajes \
video \
vig \
viking \
villas \
vin \
vip \
virgin \
visa \
vision \
viva \
vivo \
vlaanderen \
vn \
vodka \
volkswagen \
volvo \
vote \
voting \
voto \
voyage \
vu \
vuelos \
wales \
walmart \
walter \
wang \
wanggou \
watch \
watches \
weather \
weatherchannel \
webcam \
weber \
website \
wed \
wedding \
weibo \
weir \
wf \
whoswho \
wien \
wiki \
williamhill \
win \
windows \
wine \
winners \
wme \
wolterskluwer \
woodside \
work \
works \
world \
wow \
ws \
wtc \
wtf \
xbox \
xerox \
xfinity \
xihuan \
xin \
xxx \
xyz \
yachts \
yahoo \
yamaxun \
yandex \
ye \
yodobashi \
yoga \
yokohama \
you \
youtube \
yt \
yun \
za \
zappos \
zara \
zero \
zip \
zm \
zone \
zuerich \
zw \
vermögensberater-ctb \
vermögensberatung-pwb \
ελ \
ευ \
бг \
бел \
дети \
ею \
католик \
ком \
қаз \
мкд \
мон \
москва \
онлайн \
орг \
рус \
рф \
сайт \
срб \
укр \
გე \
հայ \
ישראל \
קום \
ابوظبي \
اتصالات \
ارامكو \
الاردن \
البحرين \
الجزائر \
السعودية \
العليان \
المغرب \
امارات \
ایران \
بارت \
بازار \
بھارت \
بيتك \
پاکستان \
ڀارت \
تونس \
سودان \
سورية \
شبكة \
عراق \
عرب \
عمان \
فلسطين \
قطر \
كاثوليك \
كوم \
مصر \
مليسيا \
موريتانيا \
موقع \
همراه \
कॉम \
नेट \
भारत \
भारतम् \
भारोत \
संगठन \
বাংলা \
ভারত \
ভাৰত \
ਭਾਰਤ \
ભારત \
ଭାରତ \
இந்தியா \
இலங்கை \
சிங்கப்பூர் \
భారత్ \
ಭಾರತ \
ഭാരതം \
ලංකා \
คอม \
ไทย \
ລາວ \
닷넷 \
닷컴 \
삼성 \
한국 \
アマゾン \
グーグル \
クラウド \
コム \
ストア \
セール \
ファッション \
ポイント \
みんな \
世界 \
中信 \
中国 \
中國 \
中文网 \
亚马逊 \
企业 \
佛山 \
信息 \
健康 \
八卦 \
公司 \
公益 \
台湾 \
台灣 \
商城 \
商店 \
商标 \
嘉里 \
嘉里大酒店 \
在线 \
大众汽车 \
大拿 \
天主教 \
娱乐 \
家電 \
广东 \
微博 \
慈善 \
我爱你 \
手机 \
招聘 \
政务 \
政府 \
新加坡 \
新闻 \
时尚 \
書籍 \
机构 \
淡马锡 \
游戏 \
澳門 \
点看 \
移动 \
组织机构 \
网址 \
网店 \
网站 \
网络 \
联通 \
诺基亚 \
谷歌 \
购物 \
通販 \
集团 \
電訊盈科 \
飞利浦 \
食品 \
餐厅 \
香格里拉 \
香港'.split(' ');

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.

	@module linkify
	@submodule scanner
	@main scanner
*/

var LETTER = /(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/; // Any Unicode character with letter data type

var EMOJI = /(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDD-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE74\uDE78-\uDE7C\uDE80-\uDE86\uDE90-\uDEAC\uDEB0-\uDEBA\uDEC0-\uDEC5\uDED0-\uDED9\uDEE0-\uDEE7\uDEF0-\uDEF6])/; // Any Unicode emoji character

var EMOJI_VARIATION = /\uFE0F/; // Variation selector, follows heart and others

var DIGIT = /\d/;
var SPACE = /\s/;
/**
 * Initialize the scanner character-based state machine for the given start state
 * @return {State} scanner starting state
 */

function init$2() {
  var customProtocols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Frequently used states
  var S_START = makeState();
  var S_NUM = makeAcceptingState(NUM);
  var S_DOMAIN = makeAcceptingState(DOMAIN);
  var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters

  var S_WS = makeAcceptingState(WS);
  var DOMAIN_REGEX_TRANSITIONS = [[DIGIT, S_DOMAIN], [LETTER, S_DOMAIN], [EMOJI, S_DOMAIN], [EMOJI_VARIATION, S_DOMAIN]]; // Create a state which emits a domain token

  var makeDomainState = function makeDomainState() {
    var state = makeAcceptingState(DOMAIN);
    state.j = {
      '-': S_DOMAIN_HYPHEN
    };
    state.jr = [].concat(DOMAIN_REGEX_TRANSITIONS);
    return state;
  }; // Create a state which does not emit a domain state but the usual alphanumeric
  // transitions are domains


  var makeNearDomainState = function makeNearDomainState(token) {
    var state = makeDomainState();
    state.t = token;
    return state;
  }; // States for special URL symbols that accept immediately after start


  makeBatchT(S_START, [["'", makeAcceptingState(APOSTROPHE)], ['{', makeAcceptingState(OPENBRACE)], ['[', makeAcceptingState(OPENBRACKET)], ['<', makeAcceptingState(OPENANGLEBRACKET)], ['(', makeAcceptingState(OPENPAREN)], ['}', makeAcceptingState(CLOSEBRACE)], [']', makeAcceptingState(CLOSEBRACKET)], ['>', makeAcceptingState(CLOSEANGLEBRACKET)], [')', makeAcceptingState(CLOSEPAREN)], ['&', makeAcceptingState(AMPERSAND)], ['*', makeAcceptingState(ASTERISK)], ['@', makeAcceptingState(AT)], ['`', makeAcceptingState(BACKTICK)], ['^', makeAcceptingState(CARET)], [':', makeAcceptingState(COLON)], [',', makeAcceptingState(COMMA)], ['$', makeAcceptingState(DOLLAR)], ['.', makeAcceptingState(DOT)], ['=', makeAcceptingState(EQUALS)], ['!', makeAcceptingState(EXCLAMATION)], ['-', makeAcceptingState(HYPHEN)], ['%', makeAcceptingState(PERCENT)], ['|', makeAcceptingState(PIPE)], ['+', makeAcceptingState(PLUS)], ['#', makeAcceptingState(POUND)], ['?', makeAcceptingState(QUERY)], ['"', makeAcceptingState(QUOTE)], ['/', makeAcceptingState(SLASH)], [';', makeAcceptingState(SEMI)], ['~', makeAcceptingState(TILDE)], ['_', makeAcceptingState(UNDERSCORE)], ['\\', makeAcceptingState(BACKSLASH)]]); // Whitespace jumps
  // Tokens of only non-newline whitespace are arbitrarily long

  makeT(S_START, '\n', makeAcceptingState(NL));
  makeRegexT(S_START, SPACE, S_WS); // If any whitespace except newline, more whitespace!

  makeT(S_WS, '\n', makeState()); // non-accepting state

  makeRegexT(S_WS, SPACE, S_WS); // Generates states for top-level domains
  // Note that this is most accurate when tlds are in alphabetical order

  for (var i = 0; i < tlds.length; i++) {
    makeChainT(S_START, tlds[i], makeNearDomainState(TLD), makeDomainState);
  } // Collect the states generated by different protocls


  var S_PROTOCOL_FILE = makeDomainState();
  var S_PROTOCOL_FTP = makeDomainState();
  var S_PROTOCOL_HTTP = makeDomainState();
  var S_MAILTO = makeDomainState();
  makeChainT(S_START, 'file', S_PROTOCOL_FILE, makeDomainState);
  makeChainT(S_START, 'ftp', S_PROTOCOL_FTP, makeDomainState);
  makeChainT(S_START, 'http', S_PROTOCOL_HTTP, makeDomainState);
  makeChainT(S_START, 'mailto', S_MAILTO, makeDomainState); // Protocol states

  var S_PROTOCOL_SECURE = makeDomainState();
  var S_FULL_PROTOCOL = makeAcceptingState(PROTOCOL); // Full protocol ends with COLON

  var S_FULL_MAILTO = makeAcceptingState(MAILTO); // Mailto ends with COLON
  // Secure protocols (end with 's')

  makeT(S_PROTOCOL_FTP, 's', S_PROTOCOL_SECURE);
  makeT(S_PROTOCOL_FTP, ':', S_FULL_PROTOCOL);
  makeT(S_PROTOCOL_HTTP, 's', S_PROTOCOL_SECURE);
  makeT(S_PROTOCOL_HTTP, ':', S_FULL_PROTOCOL); // Become protocol tokens after a COLON

  makeT(S_PROTOCOL_FILE, ':', S_FULL_PROTOCOL);
  makeT(S_PROTOCOL_SECURE, ':', S_FULL_PROTOCOL);
  makeT(S_MAILTO, ':', S_FULL_MAILTO); // Register custom protocols

  var S_CUSTOM_PROTOCOL = makeDomainState();

  for (var _i = 0; _i < customProtocols.length; _i++) {
    makeChainT(S_START, customProtocols[_i], S_CUSTOM_PROTOCOL, makeDomainState);
  }

  makeT(S_CUSTOM_PROTOCOL, ':', S_FULL_PROTOCOL); // Localhost

  makeChainT(S_START, 'localhost', makeNearDomainState(LOCALHOST), makeDomainState); // Everything else
  // DOMAINs make more DOMAINs
  // Number and character transitions

  makeRegexT(S_START, DIGIT, S_NUM);
  makeRegexT(S_START, LETTER, S_DOMAIN);
  makeRegexT(S_START, EMOJI, S_DOMAIN);
  makeRegexT(S_START, EMOJI_VARIATION, S_DOMAIN);
  makeRegexT(S_NUM, DIGIT, S_NUM);
  makeRegexT(S_NUM, LETTER, S_DOMAIN); // number becomes DOMAIN

  makeRegexT(S_NUM, EMOJI, S_DOMAIN); // number becomes DOMAIN

  makeRegexT(S_NUM, EMOJI_VARIATION, S_DOMAIN); // number becomes DOMAIN

  makeT(S_NUM, '-', S_DOMAIN_HYPHEN); // Default domain transitions

  makeT(S_DOMAIN, '-', S_DOMAIN_HYPHEN);
  makeT(S_DOMAIN_HYPHEN, '-', S_DOMAIN_HYPHEN);
  makeRegexT(S_DOMAIN, DIGIT, S_DOMAIN);
  makeRegexT(S_DOMAIN, LETTER, S_DOMAIN);
  makeRegexT(S_DOMAIN, EMOJI, S_DOMAIN);
  makeRegexT(S_DOMAIN, EMOJI_VARIATION, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, DIGIT, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, LETTER, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, EMOJI, S_DOMAIN);
  makeRegexT(S_DOMAIN_HYPHEN, EMOJI_VARIATION, S_DOMAIN); // Set default transition for start state (some symbol)

  S_START.jd = makeAcceptingState(SYM);
  return S_START;
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State} start scanner starting state
	@param {string} str input string to scan
	@return {{t: string, v: string, s: number, l: number}[]} list of tokens, each with a type and value
*/

function run$1(start, str) {
  // State machine is not case sensitive, so input is tokenized in lowercased
  // form (still returns the regular case though) Uses selective `toLowerCase`
  // is used because lowercasing the entire string causes the length and
  // character position to vary in some non-English strings with V8-based
  // runtimes.
  var iterable = stringToArray(str.replace(/[A-Z]/g, function (c) {
    return c.toLowerCase();
  }));
  var charCount = iterable.length; // <= len if there are emojis, etc

  var tokens = []; // return value
  // cursor through the string itself, accounting for characters that have
  // width with length 2 such as emojis

  var cursor = 0; // Cursor through the array-representation of the string

  var charCursor = 0; // Tokenize the string

  while (charCursor < charCount) {
    var state = start;
    var nextState = null;
    var tokenLength = 0;
    var latestAccepting = null;
    var sinceAccepts = -1;
    var charsSinceAccepts = -1;

    while (charCursor < charCount && (nextState = takeT(state, iterable[charCursor]))) {
      state = nextState; // Keep track of the latest accepting state

      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }

      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    } // Roll back to the latest accepting state


    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts; // No more jumps, just make a new token from the last accepting one
    // TODO: If possible, don't output v, instead output range where values ocur

    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.substr(cursor - tokenLength, tokenLength),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor // end index (excluding)

    });
  }

  return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */

function stringToArray(str) {
  var result = [];
  var len = str.length;
  var index = 0;

  while (index < len) {
    var first = str.charCodeAt(index);
    var second = void 0;
    var char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
    : str.slice(index, index + 2); // two-index characters

    result.push(char);
    index += char.length;
  }

  return result;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * @property {string} defaultProtocol
 * @property {{[string]: (event) => void}]} [events]
 */
var defaults = {
  defaultProtocol: 'http',
  events: null,
  format: noop,
  formatHref: noop,
  nl2br: false,
  tagName: 'a',
  target: null,
  rel: null,
  validate: true,
  truncate: 0,
  className: null,
  attributes: null,
  ignoreTags: []
};
/**
 * @class Options
 * @param {Object} [opts] Set option properties besides the defaults
 */

function Options(opts) {
  opts = opts || {};
  this.defaultProtocol = 'defaultProtocol' in opts ? opts.defaultProtocol : defaults.defaultProtocol;
  this.events = 'events' in opts ? opts.events : defaults.events;
  this.format = 'format' in opts ? opts.format : defaults.format;
  this.formatHref = 'formatHref' in opts ? opts.formatHref : defaults.formatHref;
  this.nl2br = 'nl2br' in opts ? opts.nl2br : defaults.nl2br;
  this.tagName = 'tagName' in opts ? opts.tagName : defaults.tagName;
  this.target = 'target' in opts ? opts.target : defaults.target;
  this.rel = 'rel' in opts ? opts.rel : defaults.rel;
  this.validate = 'validate' in opts ? opts.validate : defaults.validate;
  this.truncate = 'truncate' in opts ? opts.truncate : defaults.truncate;
  this.className = 'className' in opts ? opts.className : defaults.className;
  this.attributes = opts.attributes || defaults.attributes;
  this.ignoreTags = []; // Make all tags names upper case

  var ignoredTags = 'ignoreTags' in opts ? opts.ignoreTags : defaults.ignoreTags;

  for (var i = 0; i < ignoredTags.length; i++) {
    this.ignoreTags.push(ignoredTags[i].toUpperCase());
  }
}
Options.prototype = {
  /**
   * Given the token, return all options for how it should be displayed
   */
  resolve: function resolve(token) {
    var href = token.toHref(this.defaultProtocol);
    return {
      formatted: this.get('format', token.toString(), token),
      formattedHref: this.get('formatHref', href, token),
      tagName: this.get('tagName', href, token),
      className: this.get('className', href, token),
      target: this.get('target', href, token),
      rel: this.get('rel', href, token),
      events: this.getObject('events', href, token),
      attributes: this.getObject('attributes', href, token),
      truncate: this.get('truncate', href, token)
    };
  },

  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options. By default,
   */
  check: function check(token) {
    return this.get('validate', token.toString(), token);
  },
  // Private methods

  /**
   * Resolve an option's value based on the value of the option and the given
   * params.
   * @param {string} key Name of option to use
   * @param operator will be passed to the target option if it's method
   * @param {MultiToken} token The token from linkify.tokenize
   */
  get: function get(key, operator, token) {
    var option = this[key];

    if (!option) {
      return option;
    }

    var optionValue;

    switch (_typeof(option)) {
      case 'function':
        return option(operator, token.t);

      case 'object':
        optionValue = token.t in option ? option[token.t] : defaults[key];
        return typeof optionValue === 'function' ? optionValue(operator, token.t) : optionValue;
    }

    return option;
  },
  getObject: function getObject(key, operator, token) {
    var option = this[key];
    return typeof option === 'function' ? option(operator, token.t) : option;
  }
};

function noop(val) {
  return val;
}

var options = /*#__PURE__*/Object.freeze({
	__proto__: null,
	defaults: defaults,
	Options: Options
});

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

function inherits(parent, child) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var extended = Object.create(parent.prototype);

  for (var p in props) {
    extended[p] = props[p];
  }

  extended.constructor = child;
  child.prototype = extended;
  return child;
}
/**
	Abstract class used for manufacturing tokens of text tokens. That is rather
	than the value for a token being a small string of text, it's value an array
	of text tokens.

	Used for grouping together URLs, emails, hashtags, and other potential
	creations.

	@class MultiToken
	@param {string} value
	@param {{t: string, v: string, s: number, e: number}[]} tokens
	@abstract
*/


function MultiToken() {}
MultiToken.prototype = {
  /**
  	String representing the type for this token
  	@property t
  	@default 'token'
  */
  t: 'token',

  /**
  	Is this multitoken a link?
  	@property isLink
  	@default false
  */
  isLink: false,

  /**
  	Return the string this token represents.
  	@method toString
  	@return {string}
  */
  toString: function toString() {
    return this.v;
  },

  /**
  	What should the value for this token be in the `href` HTML attribute?
  	Returns the `.toString` value by default.
  		@method toHref
  	@return {string}
  */
  toHref: function toHref() {
    return this.toString();
  },

  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex: function startIndex() {
    return this.tk[0].s;
  },

  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex: function endIndex() {
    return this.tk[this.tk.length - 1].e;
  },

  /**
  	Returns a hash of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject: function toObject() {
    var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.defaultProtocol;
    return {
      type: this.t,
      value: this.v,
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  }
}; // Base token
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {(value: string, tokens: {t: string, v: string, s: number, e: number}) => MultiToken} new token class
 */

function createTokenClass(type, props) {
  function Token(value, tokens) {
    this.t = type;
    this.v = value;
    this.tk = tokens;
  }

  inherits(MultiToken, Token, props);
  return Token;
}
/**
	Represents an arbitrarily mailto email address with the prefix included
	@class MailtoEmail
	@extends MultiToken
*/

var MailtoEmail = createTokenClass('email', {
  isLink: true
});
/**
	Represents a list of tokens making up a valid email address
	@class Email
	@extends MultiToken
*/

var Email = createTokenClass('email', {
  isLink: true,
  toHref: function toHref() {
    return 'mailto:' + this.toString();
  }
});
/**
	Represents some plain text
	@class Text
	@extends MultiToken
*/

var Text = createTokenClass('text');
/**
	Multi-linebreak token - represents a line break
	@class Nl
	@extends MultiToken
*/

var Nl = createTokenClass('nl');
/**
	Represents a list of text tokens making up a valid URL
	@class Url
	@extends MultiToken
*/

var Url = createTokenClass('url', {
  isLink: true,

  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@method href
  	@param {string} protocol
  	@return {string}
  */
  toHref: function toHref() {
    var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults.defaultProtocol;
    var tokens = this.tk;
    var hasProtocol = false;
    var hasSlashSlash = false;
    var result = [];
    var i = 0; // Make the first part of the domain lowercase
    // Lowercase protocol

    while (tokens[i].t === PROTOCOL) {
      hasProtocol = true;
      result.push(tokens[i].v);
      i++;
    } // Skip slash-slash


    while (tokens[i].t === SLASH) {
      hasSlashSlash = true;
      result.push(tokens[i].v);
      i++;
    } // Continue pushing characters


    for (; i < tokens.length; i++) {
      result.push(tokens[i].v);
    }

    result = result.join('');

    if (!(hasProtocol || hasSlashSlash)) {
      result = "".concat(protocol, "://").concat(result);
    }

    return result;
  },
  hasProtocol: function hasProtocol() {
    return this.tk[0].t === PROTOCOL;
  }
});

var multi = /*#__PURE__*/Object.freeze({
	__proto__: null,
	MultiToken: MultiToken,
	Base: MultiToken,
	createTokenClass: createTokenClass,
	MailtoEmail: MailtoEmail,
	Email: Email,
	Text: Text,
	Nl: Nl,
	Url: Url
});

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/
/**
 * Generate the parser multi token-based state machine
 * @returns {State} the starting state
 */

function init$1() {
  // The universal starting state.
  var S_START = makeState(); // Intermediate states for URLs. Note that domains that begin with a protocol
  // are treated slighly differently from those that don't.

  var S_PROTOCOL = makeState(); // e.g., 'http:'

  var S_MAILTO = makeState(); // 'mailto:'

  var S_PROTOCOL_SLASH = makeState(); // e.g., 'http:/''

  var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g.,'http://'

  var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)

  var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT

  var S_TLD = makeAcceptingState(Url); // (A) Simplest possible URL with no query string

  var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)

  var S_TLD_PORT = makeAcceptingState(Url); // TLD followed by a port number

  var S_URL = makeAcceptingState(Url); // Long URL with optional port and maybe query string

  var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)

  var S_URL_OPENBRACE = makeState(); // URL followed by {

  var S_URL_OPENBRACKET = makeState(); // URL followed by [

  var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <

  var S_URL_OPENPAREN = makeState(); // URL followed by (

  var S_URL_OPENBRACE_Q = makeAcceptingState(Url); // URL followed by { and some symbols that the URL can end it

  var S_URL_OPENBRACKET_Q = makeAcceptingState(Url); // URL followed by [ and some symbols that the URL can end it

  var S_URL_OPENANGLEBRACKET_Q = makeAcceptingState(Url); // URL followed by < and some symbols that the URL can end it

  var S_URL_OPENPAREN_Q = makeAcceptingState(Url); // URL followed by ( and some symbols that the URL can end it

  var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it

  var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it

  var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it

  var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it

  var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)

  var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT

  var S_EMAIL = makeAcceptingState(Email); // (C) Possible email address (could have more tlds)

  var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)

  var S_EMAIL_PORT = makeAcceptingState(Email); // (C) Email address with a port

  var S_MAILTO_EMAIL = makeAcceptingState(MailtoEmail); // Email that begins with the mailto prefix (D)

  var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars

  var S_LOCALPART = makeState(); // Local part of the email address

  var S_LOCALPART_AT = makeState(); // Local part of the email address plus @

  var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)

  var S_NL = makeAcceptingState(Nl); // single new line
  // Make path from start to protocol (with '//')

  makeT(S_START, NL, S_NL);
  makeT(S_START, PROTOCOL, S_PROTOCOL);
  makeT(S_START, MAILTO, S_MAILTO);
  makeT(S_PROTOCOL, SLASH, S_PROTOCOL_SLASH);
  makeT(S_PROTOCOL_SLASH, SLASH, S_PROTOCOL_SLASH_SLASH); // The very first potential domain name

  makeT(S_START, TLD, S_DOMAIN);
  makeT(S_START, DOMAIN, S_DOMAIN);
  makeT(S_START, LOCALHOST, S_TLD);
  makeT(S_START, NUM, S_DOMAIN); // Force URL for protocol followed by anything sane

  makeT(S_PROTOCOL_SLASH_SLASH, TLD, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, DOMAIN, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, NUM, S_URL);
  makeT(S_PROTOCOL_SLASH_SLASH, LOCALHOST, S_URL); // Account for dots and hyphens
  // hyphens are usually parts of domain names

  makeT(S_DOMAIN, DOT, S_DOMAIN_DOT);
  makeT(S_EMAIL_DOMAIN, DOT, S_EMAIL_DOMAIN_DOT); // Hyphen can jump back to a domain name
  // After the first domain and a dot, we can find either a URL or another domain

  makeT(S_DOMAIN_DOT, TLD, S_TLD);
  makeT(S_DOMAIN_DOT, DOMAIN, S_DOMAIN);
  makeT(S_DOMAIN_DOT, NUM, S_DOMAIN);
  makeT(S_DOMAIN_DOT, LOCALHOST, S_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, TLD, S_EMAIL);
  makeT(S_EMAIL_DOMAIN_DOT, DOMAIN, S_EMAIL_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, NUM, S_EMAIL_DOMAIN);
  makeT(S_EMAIL_DOMAIN_DOT, LOCALHOST, S_EMAIL_DOMAIN); // S_TLD accepts! But the URL could be longer, try to find a match greedily
  // The `run` function should be able to "rollback" to the accepting state

  makeT(S_TLD, DOT, S_DOMAIN_DOT);
  makeT(S_EMAIL, DOT, S_EMAIL_DOMAIN_DOT); // Become real URLs after `SLASH` or `COLON NUM SLASH`
  // Here PSS and non-PSS converge

  makeT(S_TLD, COLON, S_TLD_COLON);
  makeT(S_TLD, SLASH, S_URL);
  makeT(S_TLD_COLON, NUM, S_TLD_PORT);
  makeT(S_TLD_PORT, SLASH, S_URL);
  makeT(S_EMAIL, COLON, S_EMAIL_COLON);
  makeT(S_EMAIL_COLON, NUM, S_EMAIL_PORT); // Types of characters the URL can definitely end in

  var qsAccepting = [AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, DOMAIN, EQUALS, HYPHEN, LOCALHOST, NUM, PERCENT, PIPE, PLUS, POUND, PROTOCOL, SLASH, SYM, TILDE, TLD, UNDERSCORE]; // Types of tokens that can follow a URL and be part of the query string
  // but cannot be the very last characters
  // Characters that cannot appear in the URL at all should be excluded

  var qsNonAccepting = [APOSTROPHE, CLOSEANGLEBRACKET, CLOSEBRACE, CLOSEBRACKET, CLOSEPAREN, COLON, COMMA, DOT, EXCLAMATION, OPENANGLEBRACKET, OPENBRACE, OPENBRACKET, OPENPAREN, QUERY, QUOTE, SEMI]; // These states are responsible primarily for determining whether or not to
  // include the final round bracket.
  // URL, followed by an opening bracket

  makeT(S_URL, OPENBRACE, S_URL_OPENBRACE);
  makeT(S_URL, OPENBRACKET, S_URL_OPENBRACKET);
  makeT(S_URL, OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET);
  makeT(S_URL, OPENPAREN, S_URL_OPENPAREN); // URL with extra symbols at the end, followed by an opening bracket

  makeT(S_URL_NON_ACCEPTING, OPENBRACE, S_URL_OPENBRACE);
  makeT(S_URL_NON_ACCEPTING, OPENBRACKET, S_URL_OPENBRACKET);
  makeT(S_URL_NON_ACCEPTING, OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET);
  makeT(S_URL_NON_ACCEPTING, OPENPAREN, S_URL_OPENPAREN); // Closing bracket component. This character WILL be included in the URL

  makeT(S_URL_OPENBRACE, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN, CLOSEPAREN, S_URL);
  makeT(S_URL_OPENBRACE_Q, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET_Q, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET_Q, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN_Q, CLOSEPAREN, S_URL);
  makeT(S_URL_OPENBRACE_SYMS, CLOSEBRACE, S_URL);
  makeT(S_URL_OPENBRACKET_SYMS, CLOSEBRACKET, S_URL);
  makeT(S_URL_OPENANGLEBRACKET_SYMS, CLOSEANGLEBRACKET, S_URL);
  makeT(S_URL_OPENPAREN_SYMS, CLOSEPAREN, S_URL); // URL that beings with an opening bracket, followed by a symbols.
  // Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
  // has a single opening bracket for some reason).

  makeMultiT(S_URL_OPENBRACE, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE, qsNonAccepting, S_URL_OPENBRACE_SYMS);
  makeMultiT(S_URL_OPENBRACKET, qsNonAccepting, S_URL_OPENBRACKET_SYMS);
  makeMultiT(S_URL_OPENANGLEBRACKET, qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
  makeMultiT(S_URL_OPENPAREN, qsNonAccepting, S_URL_OPENPAREN_SYMS); // URL that begins with an opening bracket, followed by some symbols

  makeMultiT(S_URL_OPENBRACE_Q, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_Q, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_Q, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_Q, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_Q, qsNonAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_Q, qsNonAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_Q, qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_Q, qsNonAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_SYMS, qsAccepting, S_URL_OPENBRACE_Q);
  makeMultiT(S_URL_OPENBRACKET_SYMS, qsAccepting, S_URL_OPENBRACKET_Q);
  makeMultiT(S_URL_OPENANGLEBRACKET_SYMS, qsAccepting, S_URL_OPENANGLEBRACKET_Q);
  makeMultiT(S_URL_OPENPAREN_SYMS, qsAccepting, S_URL_OPENPAREN_Q);
  makeMultiT(S_URL_OPENBRACE_SYMS, qsNonAccepting, S_URL_OPENBRACE_SYMS);
  makeMultiT(S_URL_OPENBRACKET_SYMS, qsNonAccepting, S_URL_OPENBRACKET_SYMS);
  makeMultiT(S_URL_OPENANGLEBRACKET_SYMS, qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
  makeMultiT(S_URL_OPENPAREN_SYMS, qsNonAccepting, S_URL_OPENPAREN_SYMS); // Account for the query string

  makeMultiT(S_URL, qsAccepting, S_URL);
  makeMultiT(S_URL_NON_ACCEPTING, qsAccepting, S_URL);
  makeMultiT(S_URL, qsNonAccepting, S_URL_NON_ACCEPTING);
  makeMultiT(S_URL_NON_ACCEPTING, qsNonAccepting, S_URL_NON_ACCEPTING); // Email address-specific state definitions
  // Note: We are not allowing '/' in email addresses since this would interfere
  // with real URLs
  // For addresses with the mailto prefix
  // 'mailto:' followed by anything sane is a valid email

  makeT(S_MAILTO, TLD, S_MAILTO_EMAIL);
  makeT(S_MAILTO, DOMAIN, S_MAILTO_EMAIL);
  makeT(S_MAILTO, NUM, S_MAILTO_EMAIL);
  makeT(S_MAILTO, LOCALHOST, S_MAILTO_EMAIL); // Greedily get more potential valid email values

  makeMultiT(S_MAILTO_EMAIL, qsAccepting, S_MAILTO_EMAIL);
  makeMultiT(S_MAILTO_EMAIL, qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
  makeMultiT(S_MAILTO_EMAIL_NON_ACCEPTING, qsAccepting, S_MAILTO_EMAIL);
  makeMultiT(S_MAILTO_EMAIL_NON_ACCEPTING, qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING); // For addresses without the mailto prefix
  // Tokens allowed in the localpart of the email

  var localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, CLOSEBRACE, DOLLAR, DOMAIN, EQUALS, HYPHEN, NUM, OPENBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, TLD, UNDERSCORE]; // Some of the tokens in `localpartAccepting` are already accounted for here and
  // will not be overwritten (don't worry)

  makeMultiT(S_DOMAIN, localpartAccepting, S_LOCALPART);
  makeT(S_DOMAIN, AT, S_LOCALPART_AT);
  makeMultiT(S_TLD, localpartAccepting, S_LOCALPART);
  makeT(S_TLD, AT, S_LOCALPART_AT);
  makeMultiT(S_DOMAIN_DOT, localpartAccepting, S_LOCALPART); // Now in localpart of address
  // TODO: IP addresses and what if the email starts with numbers?

  makeMultiT(S_LOCALPART, localpartAccepting, S_LOCALPART);
  makeT(S_LOCALPART, AT, S_LOCALPART_AT); // close to an email address now

  makeT(S_LOCALPART, DOT, S_LOCALPART_DOT);
  makeMultiT(S_LOCALPART_DOT, localpartAccepting, S_LOCALPART);
  makeT(S_LOCALPART_AT, TLD, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, DOMAIN, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, NUM, S_EMAIL_DOMAIN);
  makeT(S_LOCALPART_AT, LOCALHOST, S_EMAIL); // States following `@` defined above

  return S_START;
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {{t: string, v: string, s: number, e: number}[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */

function run(start, input, tokens) {
  var len = tokens.length;
  var cursor = 0;
  var multis = [];
  var textTokens = [];

  while (cursor < len) {
    var state = start;
    var secondState = null;
    var nextState = null;
    var multiLength = 0;
    var latestAccepting = null;
    var sinceAccepts = -1;

    while (cursor < len && !(secondState = takeT(state, tokens[cursor].t))) {
      // Starting tokens with nowhere to jump to.
      // Consider these to be just plain text
      textTokens.push(tokens[cursor++]);
    }

    while (cursor < len && (nextState = secondState || takeT(state, tokens[cursor].t))) {
      // Get the next state
      secondState = null;
      state = nextState; // Keep track of the latest accepting state

      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }

      cursor++;
      multiLength++;
    }

    if (sinceAccepts < 0) {
      // No accepting state was found, part of a regular text token
      // Add all the tokens we looked at to the text tokens array
      for (var i = cursor - multiLength; i < cursor; i++) {
        textTokens.push(tokens[i]);
      }
    } else {
      // Accepting state!
      // First close off the textTokens (if available)
      if (textTokens.length > 0) {
        multis.push(parserCreateMultiToken(Text, input, textTokens));
        textTokens = [];
      } // Roll back to the latest accepting state


      cursor -= sinceAccepts;
      multiLength -= sinceAccepts; // Create a new multitoken

      var Multi = latestAccepting.t;
      var subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(parserCreateMultiToken(Multi, input, subtokens));
    }
  } // Finally close off the textTokens (if available)


  if (textTokens.length > 0) {
    multis.push(parserCreateMultiToken(Text, input, textTokens));
  }

  return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {Class<MultiToken>} Multi class to instantiate
 * @param {string} input original input string
 * @param {{t: string, v: string, s: number, e: number}[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */

function parserCreateMultiToken(Multi, input, tokens) {
  var startIdx = tokens[0].s;
  var endIdx = tokens[tokens.length - 1].e;
  var value = input.substr(startIdx, endIdx - startIdx);
  return new Multi(value, tokens);
}

var warn = typeof console !== 'undefined' && console && console.warn || function () {}; // Side-effect initialization state


var INIT = {
  scanner: null,
  parser: null,
  pluginQueue: [],
  customProtocols: [],
  initialized: false
};
/**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */

function reset() {
  INIT.scanner = null;
  INIT.parser = null;
  INIT.pluginQueue = [];
  INIT.customProtocols = [];
  INIT.initialized = false;
}
/**
 * Register a linkify extension plugin
 * @param {string} name of plugin to register
 * @param {Function} plugin function that accepts mutable linkify state
 */

function registerPlugin(name, plugin) {
  for (var i = 0; i < INIT.pluginQueue.length; i++) {
    if (name === INIT.pluginQueue[i][0]) {
      warn("linkifyjs: plugin \"".concat(name, "\" already registered - will be overwritten"));
      INIT.pluginQueue[i] = [name, plugin];
      return;
    }
  }

  INIT.pluginQueue.push([name, plugin]);

  if (INIT.initialized) {
    warn("linkifyjs: already initialized - will not register plugin \"".concat(name, "\" until you manually call linkify.init(). To avoid this warning, please register all plugins before invoking linkify the first time."));
  }
}
/**
 * Detect URLs with the following additional protocol. Anything following
 * "protocol:" will be considered a link.
 * @param {string} protocol
 */

function registerCustomProtocol(protocol) {
  if (INIT.initialized) {
    warn("linkifyjs: already initialized - will not register custom protocol \"".concat(protocol, "\" until you manually call linkify.init(). To avoid this warning, please register all custom protocols before invoking linkify the first time."));
  }

  if (!/^[a-z-]+$/.test(protocol)) {
    throw Error('linkifyjs: protocols containing characters other than a-z or - (hyphen) are not supported');
  }

  INIT.customProtocols.push(protocol);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */

function init() {
  // Initialize state machines
  INIT.scanner = {
    start: init$2(INIT.customProtocols),
    tokens: text
  };
  INIT.parser = {
    start: init$1(),
    tokens: multi
  };
  var utils = {
    createTokenClass: createTokenClass
  }; // Initialize plugins

  for (var i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser,
      utils: utils
    });
  }

  INIT.initialized = true;
}
/**
	Parse a string into tokens that represent linkable and non-linkable sub-components
	@param {string} str
	@return {MultiToken[]} tokens
*/

function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }

  return run(INIT.parser.start, str, run$1(INIT.scanner.start, str));
}
/**
	Find a list of linkable items in the given string.
	@param {string} str string to find links in
	@param {string} [type] (optional) only find links of a specific type, e.g.,
	'url' or 'email'
*/

function find(str) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tokens = tokenize(str);
  var filtered = [];

  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (token.isLink && (!type || token.t === type)) {
      filtered.push(token.toObject());
    }
  }

  return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */

function test(str) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var tokens = tokenize(str);
  return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}




/***/ }),

/***/ 99490:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o) {
  var i = 0;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  i = o[Symbol.iterator]();
  return i.next.bind(i);
}

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
var LuxonError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LuxonError, _Error);

  function LuxonError() {
    return _Error.apply(this, arguments) || this;
  }

  return LuxonError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * @private
 */


var InvalidDateTimeError = /*#__PURE__*/function (_LuxonError) {
  _inheritsLoose(InvalidDateTimeError, _LuxonError);

  function InvalidDateTimeError(reason) {
    return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
  }

  return InvalidDateTimeError;
}(LuxonError);
/**
 * @private
 */

var InvalidIntervalError = /*#__PURE__*/function (_LuxonError2) {
  _inheritsLoose(InvalidIntervalError, _LuxonError2);

  function InvalidIntervalError(reason) {
    return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
  }

  return InvalidIntervalError;
}(LuxonError);
/**
 * @private
 */

var InvalidDurationError = /*#__PURE__*/function (_LuxonError3) {
  _inheritsLoose(InvalidDurationError, _LuxonError3);

  function InvalidDurationError(reason) {
    return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
  }

  return InvalidDurationError;
}(LuxonError);
/**
 * @private
 */

var ConflictingSpecificationError = /*#__PURE__*/function (_LuxonError4) {
  _inheritsLoose(ConflictingSpecificationError, _LuxonError4);

  function ConflictingSpecificationError() {
    return _LuxonError4.apply(this, arguments) || this;
  }

  return ConflictingSpecificationError;
}(LuxonError);
/**
 * @private
 */

var InvalidUnitError = /*#__PURE__*/function (_LuxonError5) {
  _inheritsLoose(InvalidUnitError, _LuxonError5);

  function InvalidUnitError(unit) {
    return _LuxonError5.call(this, "Invalid unit " + unit) || this;
  }

  return InvalidUnitError;
}(LuxonError);
/**
 * @private
 */

var InvalidArgumentError = /*#__PURE__*/function (_LuxonError6) {
  _inheritsLoose(InvalidArgumentError, _LuxonError6);

  function InvalidArgumentError() {
    return _LuxonError6.apply(this, arguments) || this;
  }

  return InvalidArgumentError;
}(LuxonError);
/**
 * @private
 */

var ZoneIsAbstractError = /*#__PURE__*/function (_LuxonError7) {
  _inheritsLoose(ZoneIsAbstractError, _LuxonError7);

  function ZoneIsAbstractError() {
    return _LuxonError7.call(this, "Zone is an abstract class") || this;
  }

  return ZoneIsAbstractError;
}(LuxonError);

/**
 * @private
 */
var n = "numeric",
    s = "short",
    l = "long";
var DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
var DATE_MED = {
  year: n,
  month: s,
  day: n
};
var DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
var DATE_FULL = {
  year: n,
  month: l,
  day: n
};
var DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
var TIME_SIMPLE = {
  hour: n,
  minute: n
};
var TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
var TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
var TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */

var TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */

var TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: s
};
/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */

var TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hour12: false,
  timeZoneName: l
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */

var DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
var DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
var DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
var DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
var DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
var DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
var DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/
/**
 * @private
 */
// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES

function hasIntl() {
  try {
    return typeof Intl !== "undefined" && Intl.DateTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasFormatToParts() {
  return !isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}
function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
} // OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }

  return arr.reduce(function (best, next) {
    var pair = [by(next), next];

    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce(function (a, k) {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x

function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n) {
  if (n === void 0) {
    n = 2;
  }

  var minus = input < 0 ? "-" : "";
  var target = minus ? input * -1 : input;
  var result;

  if (target.toString().length < n) {
    result = ("0".repeat(n) + target).slice(-n);
  } else {
    result = target.toString();
  }

  return "" + minus + result;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    var f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero) {
  if (towardZero === void 0) {
    towardZero = false;
  }

  var factor = Math.pow(10, digits),
      rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
} // DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  var modMonth = floorMod(month - 1, 12) + 1,
      modYear = year + (month - modMonth) / 12;

  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)

function objToLocalTS(obj) {
  var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that

  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }

  return +d;
}
function weeksInWeekYear(weekYear) {
  var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7,
      last = weekYear - 1,
      p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
  return p1 === 4 || p2 === 3 ? 53 : 52;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone) {
  if (timeZone === void 0) {
    timeZone = null;
  }

  var date = new Date(ts),
      intlOpts = {
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }

  var modified = Object.assign({
    timeZoneName: offsetFormat
  }, intlOpts),
      intl = hasIntl();

  if (intl && hasFormatToParts()) {
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function (m) {
      return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
  } else if (intl) {
    // this probably doesn't work for all locales
    var without = new Intl.DateTimeFormat(locale, intlOpts).format(date),
        included = new Intl.DateTimeFormat(locale, modified).format(date),
        diffed = included.substring(without.length),
        trimmed = diffed.replace(/^[, \u200e]+/, "");
    return trimmed;
  } else {
    return null;
  }
} // signedOffset('-5', '30') -> -330

function signedOffset(offHourStr, offMinuteStr) {
  var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0

  if (Number.isNaN(offHour)) {
    offHour = 0;
  }

  var offMin = parseInt(offMinuteStr, 10) || 0,
      offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
} // COERCION

function asNumber(value) {
  var numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError("Invalid unit value " + value);
  return numericValue;
}
function normalizeObject(obj, normalizer, nonUnitKeys) {
  var normalized = {};

  for (var u in obj) {
    if (hasOwnProperty(obj, u)) {
      if (nonUnitKeys.indexOf(u) >= 0) continue;
      var v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }

  return normalized;
}
function formatOffset(offset, format) {
  var hours = Math.trunc(Math.abs(offset / 60)),
      minutes = Math.trunc(Math.abs(offset % 60)),
      sign = offset >= 0 ? "+" : "-";

  switch (format) {
    case "short":
      return "" + sign + padStart(hours, 2) + ":" + padStart(minutes, 2);

    case "narrow":
      return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");

    case "techie":
      return "" + sign + padStart(hours, 2) + padStart(minutes, 2);

    default:
      throw new RangeError("Value format " + format + " is out of range for property format");
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}
var ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;

function stringify(obj) {
  return JSON.stringify(obj, Object.keys(obj).sort());
}
/**
 * @private
 */


var monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [].concat(monthsNarrow);

    case "short":
      return [].concat(monthsShort);

    case "long":
      return [].concat(monthsLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

    default:
      return null;
  }
}
var weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
var weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
var weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [].concat(weekdaysNarrow);

    case "short":
      return [].concat(weekdaysShort);

    case "long":
      return [].concat(weekdaysLong);

    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];

    default:
      return null;
  }
}
var meridiems = ["AM", "PM"];
var erasLong = ["Before Christ", "Anno Domini"];
var erasShort = ["BC", "AD"];
var erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [].concat(erasNarrow);

    case "short":
      return [].concat(erasShort);

    case "long":
      return [].concat(erasLong);

    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric, narrow) {
  if (numeric === void 0) {
    numeric = "always";
  }

  if (narrow === void 0) {
    narrow = false;
  }

  var units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  var lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;

  if (numeric === "auto" && lastable) {
    var isDay = unit === "days";

    switch (count) {
      case 1:
        return isDay ? "tomorrow" : "next " + units[unit][0];

      case -1:
        return isDay ? "yesterday" : "last " + units[unit][0];

      case 0:
        return isDay ? "today" : "this " + units[unit][0];

    }
  }

  var isInPast = Object.is(count, -0) || count < 0,
      fmtValue = Math.abs(count),
      singular = fmtValue === 1,
      lilUnits = units[unit],
      fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function formatString(knownFormat) {
  // these all have the offsets removed because we don't have access to them
  // without all the intl stuff this is backfilling
  var filtered = pick(knownFormat, ["weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hour12"]),
      key = stringify(filtered),
      dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";

  switch (key) {
    case stringify(DATE_SHORT):
      return "M/d/yyyy";

    case stringify(DATE_MED):
      return "LLL d, yyyy";

    case stringify(DATE_MED_WITH_WEEKDAY):
      return "EEE, LLL d, yyyy";

    case stringify(DATE_FULL):
      return "LLLL d, yyyy";

    case stringify(DATE_HUGE):
      return "EEEE, LLLL d, yyyy";

    case stringify(TIME_SIMPLE):
      return "h:mm a";

    case stringify(TIME_WITH_SECONDS):
      return "h:mm:ss a";

    case stringify(TIME_WITH_SHORT_OFFSET):
      return "h:mm a";

    case stringify(TIME_WITH_LONG_OFFSET):
      return "h:mm a";

    case stringify(TIME_24_SIMPLE):
      return "HH:mm";

    case stringify(TIME_24_WITH_SECONDS):
      return "HH:mm:ss";

    case stringify(TIME_24_WITH_SHORT_OFFSET):
      return "HH:mm";

    case stringify(TIME_24_WITH_LONG_OFFSET):
      return "HH:mm";

    case stringify(DATETIME_SHORT):
      return "M/d/yyyy, h:mm a";

    case stringify(DATETIME_MED):
      return "LLL d, yyyy, h:mm a";

    case stringify(DATETIME_FULL):
      return "LLLL d, yyyy, h:mm a";

    case stringify(DATETIME_HUGE):
      return dateTimeHuge;

    case stringify(DATETIME_SHORT_WITH_SECONDS):
      return "M/d/yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_SECONDS):
      return "LLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_MED_WITH_WEEKDAY):
      return "EEE, d LLL yyyy, h:mm a";

    case stringify(DATETIME_FULL_WITH_SECONDS):
      return "LLLL d, yyyy, h:mm:ss a";

    case stringify(DATETIME_HUGE_WITH_SECONDS):
      return "EEEE, LLLL d, yyyy, h:mm:ss a";

    default:
      return dateTimeHuge;
  }
}

function stringifyTokens(splits, tokenToString) {
  var s = "";

  for (var _iterator = _createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;) {
    var token = _step.value;

    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }

  return s;
}

var _macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */

var Formatter = /*#__PURE__*/function () {
  Formatter.create = function create(locale, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new Formatter(locale, opts);
  };

  Formatter.parseFormat = function parseFormat(fmt) {
    var current = null,
        currentFull = "",
        bracketed = false;
    var splits = [];

    for (var i = 0; i < fmt.length; i++) {
      var c = fmt.charAt(i);

      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed,
            val: currentFull
          });
        }

        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: false,
            val: currentFull
          });
        }

        currentFull = c;
        current = c;
      }
    }

    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed,
        val: currentFull
      });
    }

    return splits;
  };

  Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
    return _macroTokenToFormatOpts[token];
  };

  function Formatter(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }

  var _proto = Formatter.prototype;

  _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }

    var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTime = function formatDateTime(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.format();
  };

  _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.formatToParts();
  };

  _proto.resolvedOptions = function resolvedOptions(dt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
    return df.resolvedOptions();
  };

  _proto.num = function num(n, p) {
    if (p === void 0) {
      p = 0;
    }

    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }

    var opts = Object.assign({}, this.opts);

    if (p > 0) {
      opts.padTo = p;
    }

    return this.loc.numberFormatter(opts).format(n);
  };

  _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
    var _this = this;

    var knownEnglish = this.loc.listingMode() === "en",
        useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && hasFormatToParts(),
        string = function string(opts, extract) {
      return _this.loc.extract(dt, opts, extract);
    },
        formatOffset = function formatOffset(opts) {
      if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
        return "Z";
      }

      return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
    },
        meridiem = function meridiem() {
      return knownEnglish ? meridiemForDateTime(dt) : string({
        hour: "numeric",
        hour12: true
      }, "dayperiod");
    },
        month = function month(length, standalone) {
      return knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
        month: length
      } : {
        month: length,
        day: "numeric"
      }, "month");
    },
        weekday = function weekday(length, standalone) {
      return knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
        weekday: length
      } : {
        weekday: length,
        month: "long",
        day: "numeric"
      }, "weekday");
    },
        maybeMacro = function maybeMacro(token) {
      var formatOpts = Formatter.macroTokenToFormatOpts(token);

      if (formatOpts) {
        return _this.formatWithSystemDefault(dt, formatOpts);
      } else {
        return token;
      }
    },
        era = function era(length) {
      return knownEnglish ? eraForDateTime(dt, length) : string({
        era: length
      }, "era");
    },
        tokenToString = function tokenToString(token) {
      // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
      switch (token) {
        // ms
        case "S":
          return _this.num(dt.millisecond);

        case "u": // falls through

        case "SSS":
          return _this.num(dt.millisecond, 3);
        // seconds

        case "s":
          return _this.num(dt.second);

        case "ss":
          return _this.num(dt.second, 2);
        // minutes

        case "m":
          return _this.num(dt.minute);

        case "mm":
          return _this.num(dt.minute, 2);
        // hours

        case "h":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);

        case "hh":
          return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);

        case "H":
          return _this.num(dt.hour);

        case "HH":
          return _this.num(dt.hour, 2);
        // offset

        case "Z":
          // like +6
          return formatOffset({
            format: "narrow",
            allowZ: _this.opts.allowZ
          });

        case "ZZ":
          // like +06:00
          return formatOffset({
            format: "short",
            allowZ: _this.opts.allowZ
          });

        case "ZZZ":
          // like +0600
          return formatOffset({
            format: "techie",
            allowZ: _this.opts.allowZ
          });

        case "ZZZZ":
          // like EST
          return dt.zone.offsetName(dt.ts, {
            format: "short",
            locale: _this.loc.locale
          });

        case "ZZZZZ":
          // like Eastern Standard Time
          return dt.zone.offsetName(dt.ts, {
            format: "long",
            locale: _this.loc.locale
          });
        // zone

        case "z":
          // like America/New_York
          return dt.zoneName;
        // meridiems

        case "a":
          return meridiem();
        // dates

        case "d":
          return useDateTimeFormatter ? string({
            day: "numeric"
          }, "day") : _this.num(dt.day);

        case "dd":
          return useDateTimeFormatter ? string({
            day: "2-digit"
          }, "day") : _this.num(dt.day, 2);
        // weekdays - standalone

        case "c":
          // like 1
          return _this.num(dt.weekday);

        case "ccc":
          // like 'Tues'
          return weekday("short", true);

        case "cccc":
          // like 'Tuesday'
          return weekday("long", true);

        case "ccccc":
          // like 'T'
          return weekday("narrow", true);
        // weekdays - format

        case "E":
          // like 1
          return _this.num(dt.weekday);

        case "EEE":
          // like 'Tues'
          return weekday("short", false);

        case "EEEE":
          // like 'Tuesday'
          return weekday("long", false);

        case "EEEEE":
          // like 'T'
          return weekday("narrow", false);
        // months - standalone

        case "L":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric",
            day: "numeric"
          }, "month") : _this.num(dt.month);

        case "LL":
          // like 01, doesn't seem to work
          return useDateTimeFormatter ? string({
            month: "2-digit",
            day: "numeric"
          }, "month") : _this.num(dt.month, 2);

        case "LLL":
          // like Jan
          return month("short", true);

        case "LLLL":
          // like January
          return month("long", true);

        case "LLLLL":
          // like J
          return month("narrow", true);
        // months - format

        case "M":
          // like 1
          return useDateTimeFormatter ? string({
            month: "numeric"
          }, "month") : _this.num(dt.month);

        case "MM":
          // like 01
          return useDateTimeFormatter ? string({
            month: "2-digit"
          }, "month") : _this.num(dt.month, 2);

        case "MMM":
          // like Jan
          return month("short", false);

        case "MMMM":
          // like January
          return month("long", false);

        case "MMMMM":
          // like J
          return month("narrow", false);
        // years

        case "y":
          // like 2014
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year);

        case "yy":
          // like 14
          return useDateTimeFormatter ? string({
            year: "2-digit"
          }, "year") : _this.num(dt.year.toString().slice(-2), 2);

        case "yyyy":
          // like 0012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 4);

        case "yyyyyy":
          // like 000012
          return useDateTimeFormatter ? string({
            year: "numeric"
          }, "year") : _this.num(dt.year, 6);
        // eras

        case "G":
          // like AD
          return era("short");

        case "GG":
          // like Anno Domini
          return era("long");

        case "GGGGG":
          return era("narrow");

        case "kk":
          return _this.num(dt.weekYear.toString().slice(-2), 2);

        case "kkkk":
          return _this.num(dt.weekYear, 4);

        case "W":
          return _this.num(dt.weekNumber);

        case "WW":
          return _this.num(dt.weekNumber, 2);

        case "o":
          return _this.num(dt.ordinal);

        case "ooo":
          return _this.num(dt.ordinal, 3);

        case "q":
          // like 1
          return _this.num(dt.quarter);

        case "qq":
          // like 01
          return _this.num(dt.quarter, 2);

        case "X":
          return _this.num(Math.floor(dt.ts / 1000));

        case "x":
          return _this.num(dt.ts);

        default:
          return maybeMacro(token);
      }
    };

    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  };

  _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
    var _this2 = this;

    var tokenToField = function tokenToField(token) {
      switch (token[0]) {
        case "S":
          return "millisecond";

        case "s":
          return "second";

        case "m":
          return "minute";

        case "h":
          return "hour";

        case "d":
          return "day";

        case "M":
          return "month";

        case "y":
          return "year";

        default:
          return null;
      }
    },
        tokenToString = function tokenToString(lildur) {
      return function (token) {
        var mapped = tokenToField(token);

        if (mapped) {
          return _this2.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      };
    },
        tokens = Formatter.parseFormat(fmt),
        realTokens = tokens.reduce(function (found, _ref) {
      var literal = _ref.literal,
          val = _ref.val;
      return literal ? found : found.concat(val);
    }, []),
        collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function (t) {
      return t;
    }));

    return stringifyTokens(tokens, tokenToString(collapsed));
  };

  return Formatter;
}();

var Invalid = /*#__PURE__*/function () {
  function Invalid(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }

  var _proto = Invalid.prototype;

  _proto.toMessage = function toMessage() {
    if (this.explanation) {
      return this.reason + ": " + this.explanation;
    } else {
      return this.reason;
    }
  };

  return Invalid;
}();

/**
 * @interface
 */

var Zone = /*#__PURE__*/function () {
  function Zone() {}

  var _proto = Zone.prototype;

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  _proto.offsetName = function offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  ;

  _proto.formatOffset = function formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  ;

  _proto.offset = function offset(ts) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(otherZone) {
    throw new ZoneIsAbstractError();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  ;

  _createClass(Zone, [{
    key: "type",

    /**
     * The type of zone
     * @abstract
     * @type {string}
     */
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * The name of this zone.
     * @abstract
     * @type {string}
     */

  }, {
    key: "name",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
    /**
     * Returns whether the offset is known to be fixed for the whole year.
     * @abstract
     * @type {boolean}
     */

  }, {
    key: "universal",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }, {
    key: "isValid",
    get: function get() {
      throw new ZoneIsAbstractError();
    }
  }]);

  return Zone;
}();

var singleton = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */

var LocalZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(LocalZone, _Zone);

  function LocalZone() {
    return _Zone.apply(this, arguments) || this;
  }

  var _proto = LocalZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "local";
  }
  /** @override **/
  ;

  _createClass(LocalZone, [{
    key: "type",

    /** @override **/
    get: function get() {
      return "local";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      if (hasIntl()) {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
      } else return "local";
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }], [{
    key: "instance",

    /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */
    get: function get() {
      if (singleton === null) {
        singleton = new LocalZone();
      }

      return singleton;
    }
  }]);

  return LocalZone;
}(Zone);

var matchingRegex = RegExp("^" + ianaRegex.source + "$");
var dtfCache = {};

function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }

  return dtfCache[zone];
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, ""),
      parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted),
      fMonth = parsed[1],
      fDay = parsed[2],
      fYear = parsed[3],
      fHour = parsed[4],
      fMinute = parsed[5],
      fSecond = parsed[6];
  return [fYear, fMonth, fDay, fHour, fMinute, fSecond];
}

function partsOffset(dtf, date) {
  var formatted = dtf.formatToParts(date),
      filled = [];

  for (var i = 0; i < formatted.length; i++) {
    var _formatted$i = formatted[i],
        type = _formatted$i.type,
        value = _formatted$i.value,
        pos = typeToPos[type];

    if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }

  return filled;
}

var ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */

var IANAZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(IANAZone, _Zone);

  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  IANAZone.create = function create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }

    return ianaZoneCache[name];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  ;

  IANAZone.resetCache = function resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Fantasia/Castle") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidSpecifier = function isValidSpecifier(s) {
    return !!(s && s.match(matchingRegex));
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  ;

  IANAZone.isValidZone = function isValidZone(zone) {
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  } // Etc/GMT+8 -> -480

  /** @ignore */
  ;

  IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
    if (specifier) {
      var match = specifier.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);

      if (match) {
        return -60 * parseInt(match[1]);
      }
    }

    return null;
  };

  function IANAZone(name) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.zoneName = name;
    /** @private **/

    _this.valid = IANAZone.isValidZone(name);
    return _this;
  }
  /** @override **/


  var _proto = IANAZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName(ts, _ref) {
    var format = _ref.format,
        locale = _ref.locale;
    return parseZoneInfo(ts, format, locale, this.name);
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.offset(ts), format);
  }
  /** @override **/
  ;

  _proto.offset = function offset(ts) {
    var date = new Date(ts);
    if (isNaN(date)) return NaN;

    var dtf = makeDTF(this.name),
        _ref2 = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date),
        year = _ref2[0],
        month = _ref2[1],
        day = _ref2[2],
        hour = _ref2[3],
        minute = _ref2[4],
        second = _ref2[5],
        adjustedHour = hour === 24 ? 0 : hour;

    var asUTC = objToLocalTS({
      year: year,
      month: month,
      day: day,
      hour: adjustedHour,
      minute: minute,
      second: second,
      millisecond: 0
    });
    var asTS = +date;
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }
  /** @override **/
  ;

  _createClass(IANAZone, [{
    key: "type",
    get: function get() {
      return "iana";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.valid;
    }
  }]);

  return IANAZone;
}(Zone);

var singleton$1 = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */

var FixedOffsetZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(FixedOffsetZone, _Zone);

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  FixedOffsetZone.instance = function instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  ;

  FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
    if (s) {
      var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);

      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }

    return null;
  };

  _createClass(FixedOffsetZone, null, [{
    key: "utcInstance",

    /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */
    get: function get() {
      if (singleton$1 === null) {
        singleton$1 = new FixedOffsetZone(0);
      }

      return singleton$1;
    }
  }]);

  function FixedOffsetZone(offset) {
    var _this;

    _this = _Zone.call(this) || this;
    /** @private **/

    _this.fixed = offset;
    return _this;
  }
  /** @override **/


  var _proto = FixedOffsetZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return this.name;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset$1(ts, format) {
    return formatOffset(this.fixed, format);
  }
  /** @override **/
  ;

  /** @override **/
  _proto.offset = function offset() {
    return this.fixed;
  }
  /** @override **/
  ;

  _proto.equals = function equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }
  /** @override **/
  ;

  _createClass(FixedOffsetZone, [{
    key: "type",
    get: function get() {
      return "fixed";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.fixed === 0 ? "UTC" : "UTC" + formatOffset(this.fixed, "narrow");
    }
  }, {
    key: "universal",
    get: function get() {
      return true;
    }
  }, {
    key: "isValid",
    get: function get() {
      return true;
    }
  }]);

  return FixedOffsetZone;
}(Zone);

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */

var InvalidZone = /*#__PURE__*/function (_Zone) {
  _inheritsLoose(InvalidZone, _Zone);

  function InvalidZone(zoneName) {
    var _this;

    _this = _Zone.call(this) || this;
    /**  @private */

    _this.zoneName = zoneName;
    return _this;
  }
  /** @override **/


  var _proto = InvalidZone.prototype;

  /** @override **/
  _proto.offsetName = function offsetName() {
    return null;
  }
  /** @override **/
  ;

  _proto.formatOffset = function formatOffset() {
    return "";
  }
  /** @override **/
  ;

  _proto.offset = function offset() {
    return NaN;
  }
  /** @override **/
  ;

  _proto.equals = function equals() {
    return false;
  }
  /** @override **/
  ;

  _createClass(InvalidZone, [{
    key: "type",
    get: function get() {
      return "invalid";
    }
    /** @override **/

  }, {
    key: "name",
    get: function get() {
      return this.zoneName;
    }
    /** @override **/

  }, {
    key: "universal",
    get: function get() {
      return false;
    }
  }, {
    key: "isValid",
    get: function get() {
      return false;
    }
  }]);

  return InvalidZone;
}(Zone);

/**
 * @private
 */
function normalizeZone(input, defaultZone) {
  var offset;

  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    var lowered = input.toLowerCase();
    if (lowered === "local") return defaultZone;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else if ((offset = IANAZone.parseGMTOffset(input)) != null) {
      // handle Etc/GMT-4, which V8 chokes on
      return FixedOffsetZone.instance(offset);
    } else if (IANAZone.isValidSpecifier(lowered)) return IANAZone.create(input);else return FixedOffsetZone.parseSpecifier(lowered) || new InvalidZone(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && input.offset && typeof input.offset === "number") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

var now = function now() {
  return Date.now();
},
    defaultZone = null,
    // not setting this directly to LocalZone.instance bc loading order issues
defaultLocale = null,
    defaultNumberingSystem = null,
    defaultOutputCalendar = null,
    throwOnInvalid = false;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */


var Settings = /*#__PURE__*/function () {
  function Settings() {}

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  Settings.resetCaches = function resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
  };

  _createClass(Settings, null, [{
    key: "now",

    /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */
    get: function get() {
      return now;
    }
    /**
     * Set the callback for returning the current timestamp.
     * The function should return a number, which will be interpreted as an Epoch millisecond count
     * @type {function}
     * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
     * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
     */
    ,
    set: function set(n) {
      now = n;
    }
    /**
     * Get the default time zone to create DateTimes in.
     * @type {string}
     */

  }, {
    key: "defaultZoneName",
    get: function get() {
      return Settings.defaultZone.name;
    }
    /**
     * Set the default time zone to create DateTimes in. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(z) {
      if (!z) {
        defaultZone = null;
      } else {
        defaultZone = normalizeZone(z);
      }
    }
    /**
     * Get the default time zone object to create DateTimes in. Does not affect existing instances.
     * @type {Zone}
     */

  }, {
    key: "defaultZone",
    get: function get() {
      return defaultZone || LocalZone.instance;
    }
    /**
     * Get the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultLocale",
    get: function get() {
      return defaultLocale;
    }
    /**
     * Set the default locale to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(locale) {
      defaultLocale = locale;
    }
    /**
     * Get the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultNumberingSystem",
    get: function get() {
      return defaultNumberingSystem;
    }
    /**
     * Set the default numbering system to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(numberingSystem) {
      defaultNumberingSystem = numberingSystem;
    }
    /**
     * Get the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */

  }, {
    key: "defaultOutputCalendar",
    get: function get() {
      return defaultOutputCalendar;
    }
    /**
     * Set the default output calendar to create DateTimes with. Does not affect existing instances.
     * @type {string}
     */
    ,
    set: function set(outputCalendar) {
      defaultOutputCalendar = outputCalendar;
    }
    /**
     * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */

  }, {
    key: "throwOnInvalid",
    get: function get() {
      return throwOnInvalid;
    }
    /**
     * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
     * @type {boolean}
     */
    ,
    set: function set(t) {
      throwOnInvalid = t;
    }
  }]);

  return Settings;
}();

var intlDTCache = {};

function getCachedDTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var dtf = intlDTCache[key];

  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }

  return dtf;
}

var intlNumCache = {};

function getCachedINF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var key = JSON.stringify([locString, opts]);
  var inf = intlNumCache[key];

  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }

  return inf;
}

var intlRelCache = {};

function getCachedRTF(locString, opts) {
  if (opts === void 0) {
    opts = {};
  }

  var _opts = opts,
      base = _opts.base,
      cacheKeyOpts = _objectWithoutPropertiesLoose(_opts, ["base"]); // exclude `base` from the options


  var key = JSON.stringify([locString, cacheKeyOpts]);
  var inf = intlRelCache[key];

  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }

  return inf;
}

var sysLocaleCache = null;

function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else if (hasIntl()) {
    var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb

    sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
    return sysLocaleCache;
  } else {
    sysLocaleCache = "en-US";
    return sysLocaleCache;
  }
}

function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:
  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u
  var uIndex = localeStr.indexOf("-u-");

  if (uIndex === -1) {
    return [localeStr];
  } else {
    var options;
    var smaller = localeStr.substring(0, uIndex);

    try {
      options = getCachedDTF(localeStr).resolvedOptions();
    } catch (e) {
      options = getCachedDTF(smaller).resolvedOptions();
    }

    var _options = options,
        numberingSystem = _options.numberingSystem,
        calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it

    return [smaller, numberingSystem, calendar];
  }
}

function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (hasIntl()) {
    if (outputCalendar || numberingSystem) {
      localeStr += "-u";

      if (outputCalendar) {
        localeStr += "-ca-" + outputCalendar;
      }

      if (numberingSystem) {
        localeStr += "-nu-" + numberingSystem;
      }

      return localeStr;
    } else {
      return localeStr;
    }
  } else {
    return [];
  }
}

function mapMonths(f) {
  var ms = [];

  for (var i = 1; i <= 12; i++) {
    var dt = DateTime.utc(2016, i, 1);
    ms.push(f(dt));
  }

  return ms;
}

function mapWeekdays(f) {
  var ms = [];

  for (var i = 1; i <= 7; i++) {
    var dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }

  return ms;
}

function listStuff(loc, length, defaultOK, englishFn, intlFn) {
  var mode = loc.listingMode(defaultOK);

  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}

function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}
/**
 * @private
 */


var PolyNumberFormatter = /*#__PURE__*/function () {
  function PolyNumberFormatter(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;

    if (!forceSimple && hasIntl()) {
      var intlOpts = {
        useGrouping: false
      };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }

  var _proto = PolyNumberFormatter.prototype;

  _proto.format = function format(i) {
    if (this.inf) {
      var fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      var _fixed = this.floor ? Math.floor(i) : roundTo(i, 3);

      return padStart(_fixed, this.padTo);
    }
  };

  return PolyNumberFormatter;
}();
/**
 * @private
 */


var PolyDateFormatter = /*#__PURE__*/function () {
  function PolyDateFormatter(dt, intl, opts) {
    this.opts = opts;
    this.hasIntl = hasIntl();
    var z;

    if (dt.zone.universal && this.hasIntl) {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      var gmtOffset = -1 * (dt.offset / 60);
      var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
      var isOffsetZoneSupported = IANAZone.isValidZone(offsetZ);

      if (dt.offset !== 0 && isOffsetZoneSupported) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
        // So we have to make do. Two cases:
        // 1. The format options tell us to show the zone. We can't do that, so the best
        // we can do is format the date in UTC.
        // 2. The format options don't tell us to show the zone. Then we can adjust them
        // the time and tell the formatter to show it to us in UTC, so that the time is right
        // and the bad zone doesn't show up.
        z = "UTC";

        if (opts.timeZoneName) {
          this.dt = dt;
        } else {
          this.dt = dt.offset === 0 ? dt : DateTime.fromMillis(dt.ts + dt.offset * 60 * 1000);
        }
      }
    } else if (dt.zone.type === "local") {
      this.dt = dt;
    } else {
      this.dt = dt;
      z = dt.zone.name;
    }

    if (this.hasIntl) {
      var intlOpts = Object.assign({}, this.opts);

      if (z) {
        intlOpts.timeZone = z;
      }

      this.dtf = getCachedDTF(intl, intlOpts);
    }
  }

  var _proto2 = PolyDateFormatter.prototype;

  _proto2.format = function format() {
    if (this.hasIntl) {
      return this.dtf.format(this.dt.toJSDate());
    } else {
      var tokenFormat = formatString(this.opts),
          loc = Locale.create("en-US");
      return Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
    }
  };

  _proto2.formatToParts = function formatToParts() {
    if (this.hasIntl && hasFormatToParts()) {
      return this.dtf.formatToParts(this.dt.toJSDate());
    } else {
      // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
      // and IMO it's too weird to have an uncanny valley like that
      return [];
    }
  };

  _proto2.resolvedOptions = function resolvedOptions() {
    if (this.hasIntl) {
      return this.dtf.resolvedOptions();
    } else {
      return {
        locale: "en-US",
        numberingSystem: "latn",
        outputCalendar: "gregory"
      };
    }
  };

  return PolyDateFormatter;
}();
/**
 * @private
 */


var PolyRelFormatter = /*#__PURE__*/function () {
  function PolyRelFormatter(intl, isEnglish, opts) {
    this.opts = Object.assign({
      style: "long"
    }, opts);

    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }

  var _proto3 = PolyRelFormatter.prototype;

  _proto3.format = function format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  };

  _proto3.formatToParts = function formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  };

  return PolyRelFormatter;
}();
/**
 * @private
 */


var Locale = /*#__PURE__*/function () {
  Locale.fromOpts = function fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
  };

  Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
    if (defaultToEN === void 0) {
      defaultToEN = false;
    }

    var specifiedLocale = locale || Settings.defaultLocale,
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
    localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale()),
        numberingSystemR = numberingSystem || Settings.defaultNumberingSystem,
        outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
  };

  Locale.resetCache = function resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  };

  Locale.fromObject = function fromObject(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        outputCalendar = _ref.outputCalendar;

    return Locale.create(locale, numberingSystem, outputCalendar);
  };

  function Locale(locale, numbering, outputCalendar, specifiedLocale) {
    var _parseLocaleString = parseLocaleString(locale),
        parsedLocale = _parseLocaleString[0],
        parsedNumberingSystem = _parseLocaleString[1],
        parsedOutputCalendar = _parseLocaleString[2];

    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }

  var _proto4 = Locale.prototype;

  _proto4.listingMode = function listingMode(defaultOK) {
    if (defaultOK === void 0) {
      defaultOK = true;
    }

    var intl = hasIntl(),
        hasFTP = intl && hasFormatToParts(),
        isActuallyEn = this.isEnglish(),
        hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");

    if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) {
      return "error";
    } else if (!hasFTP || isActuallyEn && hasNoWeirdness) {
      return "en";
    } else {
      return "intl";
    }
  };

  _proto4.clone = function clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    }
  };

  _proto4.redefaultToEN = function redefaultToEN(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(Object.assign({}, alts, {
      defaultToEN: true
    }));
  };

  _proto4.redefaultToSystem = function redefaultToSystem(alts) {
    if (alts === void 0) {
      alts = {};
    }

    return this.clone(Object.assign({}, alts, {
      defaultToEN: false
    }));
  };

  _proto4.months = function months$1(length, format, defaultOK) {
    var _this = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, months, function () {
      var intl = format ? {
        month: length,
        day: "numeric"
      } : {
        month: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this.monthsCache[formatStr][length]) {
        _this.monthsCache[formatStr][length] = mapMonths(function (dt) {
          return _this.extract(dt, intl, "month");
        });
      }

      return _this.monthsCache[formatStr][length];
    });
  };

  _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
    var _this2 = this;

    if (format === void 0) {
      format = false;
    }

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, weekdays, function () {
      var intl = format ? {
        weekday: length,
        year: "numeric",
        month: "long",
        day: "numeric"
      } : {
        weekday: length
      },
          formatStr = format ? "format" : "standalone";

      if (!_this2.weekdaysCache[formatStr][length]) {
        _this2.weekdaysCache[formatStr][length] = mapWeekdays(function (dt) {
          return _this2.extract(dt, intl, "weekday");
        });
      }

      return _this2.weekdaysCache[formatStr][length];
    });
  };

  _proto4.meridiems = function meridiems$1(defaultOK) {
    var _this3 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, undefined, defaultOK, function () {
      return meridiems;
    }, function () {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!_this3.meridiemCache) {
        var intl = {
          hour: "numeric",
          hour12: true
        };
        _this3.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(function (dt) {
          return _this3.extract(dt, intl, "dayperiod");
        });
      }

      return _this3.meridiemCache;
    });
  };

  _proto4.eras = function eras$1(length, defaultOK) {
    var _this4 = this;

    if (defaultOK === void 0) {
      defaultOK = true;
    }

    return listStuff(this, length, defaultOK, eras, function () {
      var intl = {
        era: length
      }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.

      if (!_this4.eraCache[length]) {
        _this4.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(function (dt) {
          return _this4.extract(dt, intl, "era");
        });
      }

      return _this4.eraCache[length];
    });
  };

  _proto4.extract = function extract(dt, intlOpts, field) {
    var df = this.dtFormatter(dt, intlOpts),
        results = df.formatToParts(),
        matching = results.find(function (m) {
      return m.type.toLowerCase() === field;
    });
    return matching ? matching.value : null;
  };

  _proto4.numberFormatter = function numberFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  };

  _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
    if (intlOpts === void 0) {
      intlOpts = {};
    }

    return new PolyDateFormatter(dt, this.intl, intlOpts);
  };

  _proto4.relFormatter = function relFormatter(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  };

  _proto4.isEnglish = function isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  };

  _proto4.equals = function equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  };

  _createClass(Locale, [{
    key: "fastNumbers",
    get: function get() {
      if (this.fastNumbersCached == null) {
        this.fastNumbersCached = supportsFastNumbers(this);
      }

      return this.fastNumbersCached;
    }
  }]);

  return Locale;
}();

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

function combineRegexes() {
  for (var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++) {
    regexes[_key] = arguments[_key];
  }

  var full = regexes.reduce(function (f, r) {
    return f + r.source;
  }, "");
  return RegExp("^" + full + "$");
}

function combineExtractors() {
  for (var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extractors[_key2] = arguments[_key2];
  }

  return function (m) {
    return extractors.reduce(function (_ref, ex) {
      var mergedVals = _ref[0],
          mergedZone = _ref[1],
          cursor = _ref[2];

      var _ex = ex(m, cursor),
          val = _ex[0],
          zone = _ex[1],
          next = _ex[2];

      return [Object.assign(mergedVals, val), mergedZone || zone, next];
    }, [{}, null, 1]).slice(0, 2);
  };
}

function parse(s) {
  if (s == null) {
    return [null, null];
  }

  for (var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    patterns[_key3 - 1] = arguments[_key3];
  }

  for (var _i = 0, _patterns = patterns; _i < _patterns.length; _i++) {
    var _patterns$_i = _patterns[_i],
        regex = _patterns$_i[0],
        extractor = _patterns$_i[1];
    var m = regex.exec(s);

    if (m) {
      return extractor(m);
    }
  }

  return [null, null];
}

function simpleParse() {
  for (var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    keys[_key4] = arguments[_key4];
  }

  return function (match, cursor) {
    var ret = {};
    var i;

    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }

    return [ret, null, cursor + i];
  };
} // ISO and SQL parsing


var offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/,
    isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/,
    isoTimeRegex = RegExp("" + isoTimeBaseRegex.source + offsetRegex.source + "?"),
    isoTimeExtensionRegex = RegExp("(?:T" + isoTimeRegex.source + ")?"),
    isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/,
    isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/,
    isoOrdinalRegex = /(\d{4})-?(\d{3})/,
    extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay"),
    extractISOOrdinalData = simpleParse("year", "ordinal"),
    sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/,
    // dumbed-down version of the ISO one
sqlTimeRegex = RegExp(isoTimeBaseRegex.source + " ?(?:" + offsetRegex.source + "|(" + ianaRegex.source + "))?"),
    sqlTimeExtensionRegex = RegExp("(?: " + sqlTimeRegex.source + ")?");

function int(match, pos, fallback) {
  var m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}

function extractISOYmd(match, cursor) {
  var item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}

function extractISOTime(match, cursor) {
  var item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}

function extractISOOffset(match, cursor) {
  var local = !match[cursor] && !match[cursor + 1],
      fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
      zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}

function extractIANAZone(match, cursor) {
  var zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
} // ISO time parsing


var isoTimeOnly = RegExp("^T?" + isoTimeBaseRegex.source + "$"); // ISO duration parsing

var isoDuration = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;

function extractISODuration(match) {
  var s = match[0],
      yearStr = match[1],
      monthStr = match[2],
      weekStr = match[3],
      dayStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      millisecondsStr = match[8];
  var hasNegativePrefix = s[0] === "-";
  var negativeSeconds = secondStr && secondStr[0] === "-";

  var maybeNegate = function maybeNegate(num, force) {
    if (force === void 0) {
      force = false;
    }

    return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  };

  return [{
    years: maybeNegate(parseInteger(yearStr)),
    months: maybeNegate(parseInteger(monthStr)),
    weeks: maybeNegate(parseInteger(weekStr)),
    days: maybeNegate(parseInteger(dayStr)),
    hours: maybeNegate(parseInteger(hourStr)),
    minutes: maybeNegate(parseInteger(minuteStr)),
    seconds: maybeNegate(parseInteger(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that


var obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};

function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  var result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);

  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }

  return result;
} // RFC 2822/5322


var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;

function extractRFC2822(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      obsOffset = match[8],
      milOffset = match[9],
      offHourStr = match[10],
      offMinuteStr = match[11],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  var offset;

  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }

  return [result, new FixedOffsetZone(offset)];
}

function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date


var rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
    rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
    ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;

function extractRFC1123Or850(match) {
  var weekdayStr = match[1],
      dayStr = match[2],
      monthStr = match[3],
      yearStr = match[4],
      hourStr = match[5],
      minuteStr = match[6],
      secondStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

function extractASCII(match) {
  var weekdayStr = match[1],
      monthStr = match[2],
      dayStr = match[3],
      hourStr = match[4],
      minuteStr = match[5],
      secondStr = match[6],
      yearStr = match[7],
      result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}

var isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
var isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
var isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
var isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
var extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset);
var extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset);
var extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset);
var extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset);
/**
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
var extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
var sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
var sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
var extractISOYmdTimeOffsetAndIANAZone = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
var extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeOffsetAndIANAZone], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

var INVALID = "Invalid Duration"; // unit conversion constants

var lowOrderMatrix = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1000
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1000
  },
  hours: {
    minutes: 60,
    seconds: 60 * 60,
    milliseconds: 60 * 60 * 1000
  },
  minutes: {
    seconds: 60,
    milliseconds: 60 * 1000
  },
  seconds: {
    milliseconds: 1000
  }
},
    casualMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1000
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix),
    daysInYearAccurate = 146097.0 / 400,
    daysInMonthAccurate = 146097.0 / 4800,
    accurateMatrix = Object.assign({
  years: {
    quarters: 4,
    months: 12,
    weeks: daysInYearAccurate / 7,
    days: daysInYearAccurate,
    hours: daysInYearAccurate * 24,
    minutes: daysInYearAccurate * 24 * 60,
    seconds: daysInYearAccurate * 24 * 60 * 60,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
  },
  quarters: {
    months: 3,
    weeks: daysInYearAccurate / 28,
    days: daysInYearAccurate / 4,
    hours: daysInYearAccurate * 24 / 4,
    minutes: daysInYearAccurate * 24 * 60 / 4,
    seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
    milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
  },
  months: {
    weeks: daysInMonthAccurate / 7,
    days: daysInMonthAccurate,
    hours: daysInMonthAccurate * 24,
    minutes: daysInMonthAccurate * 24 * 60,
    seconds: daysInMonthAccurate * 24 * 60 * 60,
    milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
  }
}, lowOrderMatrix); // units ordered by size

var orderedUnits = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
var reverseUnits = orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"

function clone(dur, alts, clear) {
  if (clear === void 0) {
    clear = false;
  }

  // deep merge for vals
  var conf = {
    values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
  };
  return new Duration(conf);
}

function antiTrunc(n) {
  return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters


function convert(matrix, fromMap, fromUnit, toMap, toUnit) {
  var conv = matrix[toUnit][fromUnit],
      raw = fromMap[fromUnit] / conv,
      sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]),
      // ok, so this is wild, but see the matrix in the tests
  added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? antiTrunc(raw) : Math.trunc(raw);
  toMap[toUnit] += added;
  fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters


function normalizeValues(matrix, vals) {
  reverseUnits.reduce(function (previous, current) {
    if (!isUndefined(vals[current])) {
      if (previous) {
        convert(matrix, vals, previous, vals, current);
      }

      return current;
    } else {
      return previous;
    }
  }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */


var Duration = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Duration(config) {
    var accurate = config.conversionAccuracy === "longterm" || false;
    /**
     * @access private
     */

    this.values = config.values;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.matrix = accurate ? accurateMatrix : casualMatrix;
    /**
     * @access private
     */

    this.isLuxonDuration = true;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */


  Duration.fromMillis = function fromMillis(count, opts) {
    return Duration.fromObject(Object.assign({
      milliseconds: count
    }, opts));
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {string} [obj.locale='en-US'] - the locale to use
   * @param {string} obj.numberingSystem - the numbering system to use
   * @param {string} [obj.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  Duration.fromObject = function fromObject(obj) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
    }

    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit, ["locale", "numberingSystem", "conversionAccuracy", "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
      ]),
      loc: Locale.fromObject(obj),
      conversionAccuracy: obj.conversionAccuracy
    });
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  ;

  Duration.fromISO = function fromISO(text, opts) {
    var _parseISODuration = parseISODuration(text),
        parsed = _parseISODuration[0];

    if (parsed) {
      var obj = Object.assign(parsed, opts);
      return Duration.fromObject(obj);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  ;

  Duration.fromISOTime = function fromISOTime(text, opts) {
    var _parseISOTimeOnly = parseISOTimeOnly(text),
        parsed = _parseISOTimeOnly[0];

    if (parsed) {
      var obj = Object.assign(parsed, opts);
      return Duration.fromObject(obj);
    } else {
      return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    }
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  ;

  Duration.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid: invalid
      });
    }
  }
  /**
   * @private
   */
  ;

  Duration.normalizeUnit = function normalizeUnit(unit) {
    var normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Duration.isDuration = function isDuration(o) {
    return o && o.isLuxonDuration || false;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  ;

  var _proto = Duration.prototype;

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    var fmtOpts = Object.assign({}, opts, {
      floor: opts.round !== false && opts.floor !== false
    });
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID;
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return {};
    var base = Object.assign({}, this.values);

    if (opts.includeConfig) {
      base.conversionAccuracy = this.conversionAccuracy;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }

    return base;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    var s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return null;
    var millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = Object.assign({
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended"
    }, opts);
    var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
    var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";

    if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
      fmt += opts.format === "basic" ? "ss" : ":ss";

      if (!opts.suppressMilliseconds || value.milliseconds !== 0) {
        fmt += ".SSS";
      }
    }

    var str = value.toFormat(fmt);

    if (opts.includePrefix) {
      str = "T" + str;
    }

    return str;
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.toISO();
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.as("milliseconds");
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration),
        result = {};

    for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits), _step; !(_step = _iterator()).done;) {
      var k = _step.value;

      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }

    return clone(this, {
      values: result
    }, true);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration);
    return this.plus(dur.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnit((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  ;

  _proto.mapUnits = function mapUnits(fn) {
    if (!this.isValid) return this;
    var result = {};

    for (var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++) {
      var k = _Object$keys[_i];
      result[k] = asNumber(fn(this.values[k], k));
    }

    return clone(this, {
      values: result
    }, true);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  ;

  _proto.get = function get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var mixed = Object.assign(this.values, normalizeObject(values, Duration.normalizeUnit, []));
    return clone(this, {
      values: mixed
    });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        locale = _ref.locale,
        numberingSystem = _ref.numberingSystem,
        conversionAccuracy = _ref.conversionAccuracy;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem
    }),
        opts = {
      loc: loc
    };

    if (conversionAccuracy) {
      opts.conversionAccuracy = conversionAccuracy;
    }

    return clone(this, opts);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  ;

  _proto.as = function as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */
  ;

  _proto.normalize = function normalize() {
    if (!this.isValid) return this;
    var vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone(this, {
      values: vals
    }, true);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  ;

  _proto.shiftTo = function shiftTo() {
    for (var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++) {
      units[_key] = arguments[_key];
    }

    if (!this.isValid) return this;

    if (units.length === 0) {
      return this;
    }

    units = units.map(function (u) {
      return Duration.normalizeUnit(u);
    });
    var built = {},
        accumulated = {},
        vals = this.toObject();
    var lastUnit;

    for (var _iterator2 = _createForOfIteratorHelperLoose(orderedUnits), _step2; !(_step2 = _iterator2()).done;) {
      var k = _step2.value;

      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        var own = 0; // anything we haven't boiled down yet should get boiled to this unit

        for (var ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        } // plus anything that's already in this unit


        if (isNumber(vals[k])) {
          own += vals[k];
        }

        var i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
        // plus anything further down the chain that should be rolled up in to this

        for (var down in vals) {
          if (orderedUnits.indexOf(down) > orderedUnits.indexOf(k)) {
            convert(this.matrix, vals, down, built, k);
          }
        } // otherwise, keep it in the wings to boil it later

      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    } // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty


    for (var key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }

    return clone(this, {
      values: built
    }, true).normalize();
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  ;

  _proto.negate = function negate() {
    if (!this.isValid) return this;
    var negated = {};

    for (var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++) {
      var k = _Object$keys2[_i2];
      negated[k] = -this.values[k];
    }

    return clone(this, {
      values: negated
    }, true);
  }
  /**
   * Get the years.
   * @type {number}
   */
  ;

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    if (!this.loc.equals(other.loc)) {
      return false;
    }

    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }

    for (var _iterator3 = _createForOfIteratorHelperLoose(orderedUnits), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;

      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }

    return true;
  };

  _createClass(Duration, [{
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
  }, {
    key: "years",
    get: function get() {
      return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
     * Get the quarters.
     * @type {number}
     */

  }, {
    key: "quarters",
    get: function get() {
      return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
     * Get the months.
     * @type {number}
     */

  }, {
    key: "months",
    get: function get() {
      return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
     * Get the weeks
     * @type {number}
     */

  }, {
    key: "weeks",
    get: function get() {
      return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
     * Get the days.
     * @type {number}
     */

  }, {
    key: "days",
    get: function get() {
      return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
     * Get the hours.
     * @type {number}
     */

  }, {
    key: "hours",
    get: function get() {
      return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
     * Get the minutes.
     * @type {number}
     */

  }, {
    key: "minutes",
    get: function get() {
      return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
     * Get the seconds.
     * @return {number}
     */

  }, {
    key: "seconds",
    get: function get() {
      return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
     * Get the milliseconds.
     * @return {number}
     */

  }, {
    key: "milliseconds",
    get: function get() {
      return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
     * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
     * on invalid DateTimes or Intervals.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this Duration became invalid, or null if the Duration is valid
     * @return {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Duration;
}();
function friendlyDuration(durationish) {
  if (isNumber(durationish)) {
    return Duration.fromMillis(durationish);
  } else if (Duration.isDuration(durationish)) {
    return durationish;
  } else if (typeof durationish === "object") {
    return Duration.fromObject(durationish);
  } else {
    throw new InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
  }
}

var INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end

function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
  } else {
    return null;
  }
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}.
 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
 */


var Interval = /*#__PURE__*/function () {
  /**
   * @private
   */
  function Interval(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */

    this.e = config.end;
    /**
     * @access private
     */

    this.invalid = config.invalid || null;
    /**
     * @access private
     */

    this.isLuxonInterval = true;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */


  Interval.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid: invalid
      });
    }
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  ;

  Interval.fromDateTimes = function fromDateTimes(start, end) {
    var builtStart = friendlyDateTime(start),
        builtEnd = friendlyDateTime(end);
    var validateError = validateStartEnd(builtStart, builtEnd);

    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.after = function after(start, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  ;

  Interval.before = function before(end, duration) {
    var dur = friendlyDuration(duration),
        dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime.fromISO} and optionally {@link Duration.fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  ;

  Interval.fromISO = function fromISO(text, opts) {
    var _split = (text || "").split("/", 2),
        s = _split[0],
        e = _split[1];

    if (s && e) {
      var start, startIsValid;

      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }

      var end, endIsValid;

      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }

      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }

      if (startIsValid) {
        var dur = Duration.fromISO(e, opts);

        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        var _dur = Duration.fromISO(s, opts);

        if (_dur.isValid) {
          return Interval.before(end, _dur);
        }
      }
    }

    return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  Interval.isInterval = function isInterval(o) {
    return o && o.isLuxonInterval || false;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  ;

  var _proto = Interval.prototype;

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  _proto.length = function length(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    return this.isValid ? this.toDuration.apply(this, [unit]).get(unit) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */
  ;

  _proto.count = function count(unit) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (!this.isValid) return NaN;
    var start = this.start.startOf(unit),
        end = this.end.startOf(unit);
    return Math.floor(end.diff(start, unit).get(unit)) + 1;
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  ;

  _proto.isEmpty = function isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isAfter = function isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.isBefore = function isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  ;

  _proto.contains = function contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  ;

  _proto.set = function set(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        start = _ref.start,
        end = _ref.end;

    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...[DateTime]} dateTimes - the unit of time to count.
   * @return {[Interval]}
   */
  ;

  _proto.splitAt = function splitAt() {
    var _this = this;

    if (!this.isValid) return [];

    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    var sorted = dateTimes.map(friendlyDateTime).filter(function (d) {
      return _this.contains(d);
    }).sort(),
        results = [];
    var s = this.s,
        i = 0;

    while (s < this.e) {
      var added = sorted[i] || this.e,
          next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }

    return results;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {[Interval]}
   */
  ;

  _proto.splitBy = function splitBy(duration) {
    var dur = friendlyDuration(duration);

    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }

    var s = this.s,
        idx = 1,
        next;
    var results = [];

    while (s < this.e) {
      var added = this.start.plus(dur.mapUnits(function (x) {
        return x * idx;
      }));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }

    return results;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {[Interval]}
   */
  ;

  _proto.divideEqually = function divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.overlaps = function overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsStart = function abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.abutsEnd = function abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.engulfs = function engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }

    return this.s.equals(other.s) && this.e.equals(other.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.intersection = function intersection(other) {
    if (!this.isValid) return this;
    var s = this.s > other.s ? this.s : other.s,
        e = this.e < other.e ? this.e : other.e;

    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  ;

  _proto.union = function union(other) {
    if (!this.isValid) return this;
    var s = this.s < other.s ? this.s : other.s,
        e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  ;

  Interval.merge = function merge(intervals) {
    var _intervals$sort$reduc = intervals.sort(function (a, b) {
      return a.s - b.s;
    }).reduce(function (_ref2, item) {
      var sofar = _ref2[0],
          current = _ref2[1];

      if (!current) {
        return [sofar, item];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [sofar, current.union(item)];
      } else {
        return [sofar.concat([current]), item];
      }
    }, [[], null]),
        found = _intervals$sort$reduc[0],
        final = _intervals$sort$reduc[1];

    if (final) {
      found.push(final);
    }

    return found;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {[Interval]} intervals
   * @return {[Interval]}
   */
  ;

  Interval.xor = function xor(intervals) {
    var _Array$prototype;

    var start = null,
        currentCount = 0;

    var results = [],
        ends = intervals.map(function (i) {
      return [{
        time: i.s,
        type: "s"
      }, {
        time: i.e,
        type: "e"
      }];
    }),
        flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends),
        arr = flattened.sort(function (a, b) {
      return a.time - b.time;
    });

    for (var _iterator = _createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;) {
      var i = _step.value;
      currentCount += i.type === "s" ? 1 : -1;

      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }

        start = null;
      }
    }

    return Interval.merge(results);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {[Interval]}
   */
  ;

  _proto.difference = function difference() {
    var _this2 = this;

    for (var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      intervals[_key2] = arguments[_key2];
    }

    return Interval.xor([this].concat(intervals)).map(function (i) {
      return _this2.intersection(i);
    }).filter(function (i) {
      return i && !i.isEmpty();
    });
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    if (!this.isValid) return INVALID$1;
    return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISO(opts) + "/" + this.e.toISO(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate() {
    if (!this.isValid) return INVALID$1;
    return this.s.toISODate() + "/" + this.e.toISODate();
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime.toISO}
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime.toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(dateFormat, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        _ref3$separator = _ref3.separator,
        separator = _ref3$separator === void 0 ? " – " : _ref3$separator;

    if (!this.isValid) return INVALID$1;
    return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  ;

  _proto.toDuration = function toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }

    return this.e.diff(this.s, unit, opts);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  ;

  _proto.mapEndpoints = function mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  };

  _createClass(Interval, [{
    key: "start",
    get: function get() {
      return this.isValid ? this.s : null;
    }
    /**
     * Returns the end of the Interval
     * @type {DateTime}
     */

  }, {
    key: "end",
    get: function get() {
      return this.isValid ? this.e : null;
    }
    /**
     * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
     * @type {boolean}
     */

  }, {
    key: "isValid",
    get: function get() {
      return this.invalidReason === null;
    }
    /**
     * Returns an error code if this Interval is invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
  }]);

  return Interval;
}();

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */

var Info = /*#__PURE__*/function () {
  function Info() {}

  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  Info.hasDST = function hasDST(zone) {
    if (zone === void 0) {
      zone = Settings.defaultZone;
    }

    var proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.universal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  ;

  Info.isValidIANAZone = function isValidIANAZone(zone) {
    return IANAZone.isValidSpecifier(zone) && IANAZone.isValidZone(zone);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone.isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  ;

  Info.normalizeZone = function normalizeZone$1(input) {
    return normalizeZone(input, Settings.defaultZone);
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {[string]}
   */
  ;

  Info.months = function months(length, _temp) {
    if (length === void 0) {
      length = "long";
    }

    var _ref = _temp === void 0 ? {} : _temp,
        _ref$locale = _ref.locale,
        locale = _ref$locale === void 0 ? null : _ref$locale,
        _ref$numberingSystem = _ref.numberingSystem,
        numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem,
        _ref$locObj = _ref.locObj,
        locObj = _ref$locObj === void 0 ? null : _ref$locObj,
        _ref$outputCalendar = _ref.outputCalendar,
        outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {[string]}
   */
  ;

  Info.monthsFormat = function monthsFormat(length, _temp2) {
    if (length === void 0) {
      length = "long";
    }

    var _ref2 = _temp2 === void 0 ? {} : _temp2,
        _ref2$locale = _ref2.locale,
        locale = _ref2$locale === void 0 ? null : _ref2$locale,
        _ref2$numberingSystem = _ref2.numberingSystem,
        numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem,
        _ref2$locObj = _ref2.locObj,
        locObj = _ref2$locObj === void 0 ? null : _ref2$locObj,
        _ref2$outputCalendar = _ref2.outputCalendar,
        outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;

    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {[string]}
   */
  ;

  Info.weekdays = function weekdays(length, _temp3) {
    if (length === void 0) {
      length = "long";
    }

    var _ref3 = _temp3 === void 0 ? {} : _temp3,
        _ref3$locale = _ref3.locale,
        locale = _ref3$locale === void 0 ? null : _ref3$locale,
        _ref3$numberingSystem = _ref3.numberingSystem,
        numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem,
        _ref3$locObj = _ref3.locObj,
        locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link weekdays}
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {[string]}
   */
  ;

  Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
    if (length === void 0) {
      length = "long";
    }

    var _ref4 = _temp4 === void 0 ? {} : _temp4,
        _ref4$locale = _ref4.locale,
        locale = _ref4$locale === void 0 ? null : _ref4$locale,
        _ref4$numberingSystem = _ref4.numberingSystem,
        numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem,
        _ref4$locObj = _ref4.locObj,
        locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;

    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {[string]}
   */
  ;

  Info.meridiems = function meridiems(_temp5) {
    var _ref5 = _temp5 === void 0 ? {} : _temp5,
        _ref5$locale = _ref5.locale,
        locale = _ref5$locale === void 0 ? null : _ref5$locale;

    return Locale.create(locale).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {[string]}
   */
  ;

  Info.eras = function eras(length, _temp6) {
    if (length === void 0) {
      length = "short";
    }

    var _ref6 = _temp6 === void 0 ? {} : _temp6,
        _ref6$locale = _ref6.locale,
        locale = _ref6$locale === void 0 ? null : _ref6$locale;

    return Locale.create(locale, null, "gregory").eras(length);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, timezone support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `zones`: whether this environment supports IANA timezones
   * * `intlTokens`: whether this environment supports internationalized token-based formatting/parsing
   * * `intl`: whether this environment supports general internationalization
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { intl: true, intlTokens: false, zones: true, relative: false }
   * @return {Object}
   */
  ;

  Info.features = function features() {
    var intl = false,
        intlTokens = false,
        zones = false,
        relative = false;

    if (hasIntl()) {
      intl = true;
      intlTokens = hasFormatToParts();
      relative = hasRelative();

      try {
        zones = new Intl.DateTimeFormat("en", {
          timeZone: "America/New_York"
        }).resolvedOptions().timeZone === "America/New_York";
      } catch (e) {
        zones = false;
      }
    }

    return {
      intl: intl,
      intlTokens: intlTokens,
      zones: zones,
      relative: relative
    };
  };

  return Info;
}();

function dayDiff(earlier, later) {
  var utcDayStart = function utcDayStart(dt) {
    return dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf();
  },
      ms = utcDayStart(later) - utcDayStart(earlier);

  return Math.floor(Duration.fromMillis(ms).as("days"));
}

function highOrderDiffs(cursor, later, units) {
  var differs = [["years", function (a, b) {
    return b.year - a.year;
  }], ["quarters", function (a, b) {
    return b.quarter - a.quarter;
  }], ["months", function (a, b) {
    return b.month - a.month + (b.year - a.year) * 12;
  }], ["weeks", function (a, b) {
    var days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  var results = {};
  var lowestOrder, highWater;

  for (var _i = 0, _differs = differs; _i < _differs.length; _i++) {
    var _differs$_i = _differs[_i],
        unit = _differs$_i[0],
        differ = _differs$_i[1];

    if (units.indexOf(unit) >= 0) {
      var _cursor$plus;

      lowestOrder = unit;
      var delta = differ(cursor, later);
      highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));

      if (highWater > later) {
        var _cursor$plus2;

        cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
        delta -= 1;
      } else {
        cursor = highWater;
      }

      results[unit] = delta;
    }
  }

  return [cursor, results, highWater, lowestOrder];
}

function _diff (earlier, later, units, opts) {
  var _highOrderDiffs = highOrderDiffs(earlier, later, units),
      cursor = _highOrderDiffs[0],
      results = _highOrderDiffs[1],
      highWater = _highOrderDiffs[2],
      lowestOrder = _highOrderDiffs[3];

  var remainingMillis = later - cursor;
  var lowerOrderUnits = units.filter(function (u) {
    return ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0;
  });

  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      var _cursor$plus3;

      highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
    }

    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }

  var duration = Duration.fromObject(Object.assign(results, opts));

  if (lowerOrderUnits.length > 0) {
    var _Duration$fromMillis;

    return (_Duration$fromMillis = Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

var numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
var numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}; // eslint-disable-next-line

var hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  var value = parseInt(str, 10);

  if (isNaN(value)) {
    value = "";

    for (var i = 0; i < str.length; i++) {
      var code = str.charCodeAt(i);

      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (var key in numberingSystemsUTF16) {
          var _numberingSystemsUTF = numberingSystemsUTF16[key],
              min = _numberingSystemsUTF[0],
              max = _numberingSystemsUTF[1];

          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }

    return parseInt(value, 10);
  } else {
    return value;
  }
}
function digitRegex(_ref, append) {
  var numberingSystem = _ref.numberingSystem;

  if (append === void 0) {
    append = "";
  }

  return new RegExp("" + numberingSystems[numberingSystem || "latn"] + append);
}

var MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";

function intUnit(regex, post) {
  if (post === void 0) {
    post = function post(i) {
      return i;
    };
  }

  return {
    regex: regex,
    deser: function deser(_ref) {
      var s = _ref[0];
      return post(parseDigits(s));
    }
  };
}

var NBSP = String.fromCharCode(160);
var spaceOrNBSP = "( |" + NBSP + ")";
var spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");

function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}

function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}

function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: function deser(_ref2) {
        var s = _ref2[0];
        return strings.findIndex(function (i) {
          return stripInsensitivities(s) === stripInsensitivities(i);
        }) + startIndex;
      }
    };
  }
}

function offset(regex, groups) {
  return {
    regex: regex,
    deser: function deser(_ref3) {
      var h = _ref3[1],
          m = _ref3[2];
      return signedOffset(h, m);
    },
    groups: groups
  };
}

function simple(regex) {
  return {
    regex: regex,
    deser: function deser(_ref4) {
      var s = _ref4[0];
      return s;
    }
  };
}

function escapeToken(value) {
  // eslint-disable-next-line no-useless-escape
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

function unitForToken(token, loc) {
  var one = digitRegex(loc),
      two = digitRegex(loc, "{2}"),
      three = digitRegex(loc, "{3}"),
      four = digitRegex(loc, "{4}"),
      six = digitRegex(loc, "{6}"),
      oneOrTwo = digitRegex(loc, "{1,2}"),
      oneToThree = digitRegex(loc, "{1,3}"),
      oneToSix = digitRegex(loc, "{1,6}"),
      oneToNine = digitRegex(loc, "{1,9}"),
      twoToFour = digitRegex(loc, "{2,4}"),
      fourToSix = digitRegex(loc, "{4,6}"),
      literal = function literal(t) {
    return {
      regex: RegExp(escapeToken(t.val)),
      deser: function deser(_ref5) {
        var s = _ref5[0];
        return s;
      },
      literal: true
    };
  },
      unitate = function unitate(t) {
    if (token.literal) {
      return literal(t);
    }

    switch (t.val) {
      // era
      case "G":
        return oneOf(loc.eras("short", false), 0);

      case "GG":
        return oneOf(loc.eras("long", false), 0);
      // years

      case "y":
        return intUnit(oneToSix);

      case "yy":
        return intUnit(twoToFour, untruncateYear);

      case "yyyy":
        return intUnit(four);

      case "yyyyy":
        return intUnit(fourToSix);

      case "yyyyyy":
        return intUnit(six);
      // months

      case "M":
        return intUnit(oneOrTwo);

      case "MM":
        return intUnit(two);

      case "MMM":
        return oneOf(loc.months("short", true, false), 1);

      case "MMMM":
        return oneOf(loc.months("long", true, false), 1);

      case "L":
        return intUnit(oneOrTwo);

      case "LL":
        return intUnit(two);

      case "LLL":
        return oneOf(loc.months("short", false, false), 1);

      case "LLLL":
        return oneOf(loc.months("long", false, false), 1);
      // dates

      case "d":
        return intUnit(oneOrTwo);

      case "dd":
        return intUnit(two);
      // ordinals

      case "o":
        return intUnit(oneToThree);

      case "ooo":
        return intUnit(three);
      // time

      case "HH":
        return intUnit(two);

      case "H":
        return intUnit(oneOrTwo);

      case "hh":
        return intUnit(two);

      case "h":
        return intUnit(oneOrTwo);

      case "mm":
        return intUnit(two);

      case "m":
        return intUnit(oneOrTwo);

      case "q":
        return intUnit(oneOrTwo);

      case "qq":
        return intUnit(two);

      case "s":
        return intUnit(oneOrTwo);

      case "ss":
        return intUnit(two);

      case "S":
        return intUnit(oneToThree);

      case "SSS":
        return intUnit(three);

      case "u":
        return simple(oneToNine);
      // meridiem

      case "a":
        return oneOf(loc.meridiems(), 0);
      // weekYear (k)

      case "kkkk":
        return intUnit(four);

      case "kk":
        return intUnit(twoToFour, untruncateYear);
      // weekNumber (W)

      case "W":
        return intUnit(oneOrTwo);

      case "WW":
        return intUnit(two);
      // weekdays

      case "E":
      case "c":
        return intUnit(one);

      case "EEE":
        return oneOf(loc.weekdays("short", false, false), 1);

      case "EEEE":
        return oneOf(loc.weekdays("long", false, false), 1);

      case "ccc":
        return oneOf(loc.weekdays("short", true, false), 1);

      case "cccc":
        return oneOf(loc.weekdays("long", true, false), 1);
      // offset/zone

      case "Z":
      case "ZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);

      case "ZZZ":
        return offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are

      case "z":
        return simple(/[a-z_+-/]{1,256}?/i);

      default:
        return literal(t);
    }
  };

  var unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}

var partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour: {
    numeric: "h",
    "2-digit": "hh"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  }
};

function tokenForPart(part, locale, formatOpts) {
  var type = part.type,
      value = part.value;

  if (type === "literal") {
    return {
      literal: true,
      val: value
    };
  }

  var style = formatOpts[type];
  var val = partTypeStyleToTokenVal[type];

  if (typeof val === "object") {
    val = val[style];
  }

  if (val) {
    return {
      literal: false,
      val: val
    };
  }

  return undefined;
}

function buildRegex(units) {
  var re = units.map(function (u) {
    return u.regex;
  }).reduce(function (f, r) {
    return f + "(" + r.source + ")";
  }, "");
  return ["^" + re + "$", units];
}

function match(input, regex, handlers) {
  var matches = input.match(regex);

  if (matches) {
    var all = {};
    var matchIndex = 1;

    for (var i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        var h = handlers[i],
            groups = h.groups ? h.groups + 1 : 1;

        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }

        matchIndex += groups;
      }
    }

    return [matches, all];
  } else {
    return [matches, {}];
  }
}

function dateTimeFromMatches(matches) {
  var toField = function toField(token) {
    switch (token) {
      case "S":
        return "millisecond";

      case "s":
        return "second";

      case "m":
        return "minute";

      case "h":
      case "H":
        return "hour";

      case "d":
        return "day";

      case "o":
        return "ordinal";

      case "L":
      case "M":
        return "month";

      case "y":
        return "year";

      case "E":
      case "c":
        return "weekday";

      case "W":
        return "weekNumber";

      case "k":
        return "weekYear";

      case "q":
        return "quarter";

      default:
        return null;
    }
  };

  var zone;

  if (!isUndefined(matches.Z)) {
    zone = new FixedOffsetZone(matches.Z);
  } else if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  } else {
    zone = null;
  }

  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }

  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }

  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }

  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }

  var vals = Object.keys(matches).reduce(function (r, k) {
    var f = toField(k);

    if (f) {
      r[f] = matches[k];
    }

    return r;
  }, {});
  return [vals, zone];
}

var dummyDateTimeCache = null;

function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }

  return dummyDateTimeCache;
}

function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }

  var formatOpts = Formatter.macroTokenToFormatOpts(token.val);

  if (!formatOpts) {
    return token;
  }

  var formatter = Formatter.create(locale, formatOpts);
  var parts = formatter.formatDateTimeParts(getDummyDateTime());
  var tokens = parts.map(function (p) {
    return tokenForPart(p, locale, formatOpts);
  });

  if (tokens.includes(undefined)) {
    return token;
  }

  return tokens;
}

function expandMacroTokens(tokens, locale) {
  var _Array$prototype;

  return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function (t) {
    return maybeExpandMacroToken(t, locale);
  }));
}
/**
 * @private
 */


function explainFromTokens(locale, input, format) {
  var tokens = expandMacroTokens(Formatter.parseFormat(format), locale),
      units = tokens.map(function (t) {
    return unitForToken(t, locale);
  }),
      disqualifyingUnit = units.find(function (t) {
    return t.invalidReason;
  });

  if (disqualifyingUnit) {
    return {
      input: input,
      tokens: tokens,
      invalidReason: disqualifyingUnit.invalidReason
    };
  } else {
    var _buildRegex = buildRegex(units),
        regexString = _buildRegex[0],
        handlers = _buildRegex[1],
        regex = RegExp(regexString, "i"),
        _match = match(input, regex, handlers),
        rawMatches = _match[0],
        matches = _match[1],
        _ref6 = matches ? dateTimeFromMatches(matches) : [null, null],
        result = _ref6[0],
        zone = _ref6[1];

    if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
      throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
    }

    return {
      input: input,
      tokens: tokens,
      regex: regex,
      rawMatches: rawMatches,
      matches: matches,
      result: result,
      zone: zone
    };
  }
}
function parseFromTokens(locale, input, format) {
  var _explainFromTokens = explainFromTokens(locale, input, format),
      result = _explainFromTokens.result,
      zone = _explainFromTokens.zone,
      invalidReason = _explainFromTokens.invalidReason;

  return [result, zone, invalidReason];
}

var nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
    leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];

function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}

function dayOfWeek(year, month, day) {
  var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
  return js === 0 ? 7 : js;
}

function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}

function uncomputeOrdinal(year, ordinal) {
  var table = isLeapYear(year) ? leapLadder : nonLeapLadder,
      month0 = table.findIndex(function (i) {
    return i < ordinal;
  }),
      day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day: day
  };
}
/**
 * @private
 */


function gregorianToWeek(gregObj) {
  var year = gregObj.year,
      month = gregObj.month,
      day = gregObj.day,
      ordinal = computeOrdinal(year, month, day),
      weekday = dayOfWeek(year, month, day);
  var weekNumber = Math.floor((ordinal - weekday + 10) / 7),
      weekYear;

  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear);
  } else if (weekNumber > weeksInWeekYear(year)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }

  return Object.assign({
    weekYear: weekYear,
    weekNumber: weekNumber,
    weekday: weekday
  }, timeObject(gregObj));
}
function weekToGregorian(weekData) {
  var weekYear = weekData.weekYear,
      weekNumber = weekData.weekNumber,
      weekday = weekData.weekday,
      weekdayOfJan4 = dayOfWeek(weekYear, 1, 4),
      yearInDays = daysInYear(weekYear);
  var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3,
      year;

  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }

  var _uncomputeOrdinal = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal.month,
      day = _uncomputeOrdinal.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(weekData));
}
function gregorianToOrdinal(gregData) {
  var year = gregData.year,
      month = gregData.month,
      day = gregData.day,
      ordinal = computeOrdinal(year, month, day);
  return Object.assign({
    year: year,
    ordinal: ordinal
  }, timeObject(gregData));
}
function ordinalToGregorian(ordinalData) {
  var year = ordinalData.year,
      ordinal = ordinalData.ordinal,
      _uncomputeOrdinal2 = uncomputeOrdinal(year, ordinal),
      month = _uncomputeOrdinal2.month,
      day = _uncomputeOrdinal2.day;

  return Object.assign({
    year: year,
    month: month,
    day: day
  }, timeObject(ordinalData));
}
function hasInvalidWeekData(obj) {
  var validYear = isInteger(obj.weekYear),
      validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear)),
      validWeekday = integerBetween(obj.weekday, 1, 7);

  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.week);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  var validYear = isInteger(obj.year),
      validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  var validYear = isInteger(obj.year),
      validMonth = integerBetween(obj.month, 1, 12),
      validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));

  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  var hour = obj.hour,
      minute = obj.minute,
      second = obj.second,
      millisecond = obj.millisecond;
  var validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
      validMinute = integerBetween(minute, 0, 59),
      validSecond = integerBetween(second, 0, 59),
      validMillisecond = integerBetween(millisecond, 0, 999);

  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

var INVALID$2 = "Invalid DateTime";
var MAX_DATE = 8.64e15;

function unsupportedZone(zone) {
  return new Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache


function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }

  return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties


function clone$1(inst, alts) {
  var current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime(Object.assign({}, current, alts, {
    old: current
  }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)


function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - o * 60 * 1000; // Test whether the zone matches the offset for this ts

  var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done

  if (o === o2) {
    return [utcGuess, o];
  } // If not, change the ts by the difference in the offset


  utcGuess -= (o2 - o) * 60 * 1000; // If that gives us the local time we want, we're done

  var o3 = tz.offset(utcGuess);

  if (o2 === o3) {
    return [utcGuess, o2];
  } // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time


  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
} // convert an epoch timestamp into a calendar object with the given offset


function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  var d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
} // convert a calendar object to a epoch timestamp


function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs


function adjustTime(inst, dur) {
  var oPre = inst.o,
      year = inst.c.year + Math.trunc(dur.years),
      month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
      c = Object.assign({}, inst.c, {
    year: year,
    month: month,
    day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
  }),
      millisToAdd = Duration.fromObject({
    years: dur.years - Math.trunc(dur.years),
    quarters: dur.quarters - Math.trunc(dur.quarters),
    months: dur.months - Math.trunc(dur.months),
    weeks: dur.weeks - Math.trunc(dur.weeks),
    days: dur.days - Math.trunc(dur.days),
    hours: dur.hours,
    minutes: dur.minutes,
    seconds: dur.seconds,
    milliseconds: dur.milliseconds
  }).as("milliseconds"),
      localTS = objToLocalTS(c);

  var _fixOffset = fixOffset(localTS, oPre, inst.zone),
      ts = _fixOffset[0],
      o = _fixOffset[1];

  if (millisToAdd !== 0) {
    ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same

    o = inst.zone.offset(ts);
  }

  return {
    ts: ts,
    o: o
  };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options


function parseDataToDateTime(parsed, parsedZone, opts, format, text) {
  var setZone = opts.setZone,
      zone = opts.zone;

  if (parsed && Object.keys(parsed).length !== 0) {
    var interpretationZone = parsedZone || zone,
        inst = DateTime.fromObject(Object.assign(parsed, opts, {
      zone: interpretationZone,
      // setZone is a valid option in the calling methods, but not in fromObject
      setZone: undefined
    }));
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
  }
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details


function toTechFormat(dt, format, allowZ) {
  if (allowZ === void 0) {
    allowZ = true;
  }

  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ: allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling


function toTechTimeFormat(dt, _ref) {
  var _ref$suppressSeconds = _ref.suppressSeconds,
      suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds,
      _ref$suppressMillisec = _ref.suppressMilliseconds,
      suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec,
      includeOffset = _ref.includeOffset,
      _ref$includePrefix = _ref.includePrefix,
      includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix,
      _ref$includeZone = _ref.includeZone,
      includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone,
      _ref$spaceZone = _ref.spaceZone,
      spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "extended" : _ref$format;
  var fmt = format === "basic" ? "HHmm" : "HH:mm";

  if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
    fmt += format === "basic" ? "ss" : ":ss";

    if (!suppressMilliseconds || dt.millisecond !== 0) {
      fmt += ".SSS";
    }
  }

  if ((includeZone || includeOffset) && spaceZone) {
    fmt += " ";
  }

  if (includeZone) {
    fmt += "z";
  } else if (includeOffset) {
    fmt += format === "basic" ? "ZZZ" : "ZZ";
  }

  var str = toTechFormat(dt, fmt);

  if (includePrefix) {
    str = "T" + str;
  }

  return str;
} // defaults for unspecified units in the supported calendars


var defaultUnitValues = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultWeekUnitValues = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
},
    defaultOrdinalUnitValues = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}; // Units in the supported calendars, sorted by bigness

var orderedUnits$1 = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
    orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
    orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"]; // standardize case and plurality in units

function normalizeUnit(unit) {
  var normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.


function quickDT(obj, zone) {
  // assume we have the higher-order units
  for (var _iterator = _createForOfIteratorHelperLoose(orderedUnits$1), _step; !(_step = _iterator()).done;) {
    var u = _step.value;

    if (isUndefined(obj[u])) {
      obj[u] = defaultUnitValues[u];
    }
  }

  var invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);

  if (invalid) {
    return DateTime.invalid(invalid);
  }

  var tsNow = Settings.now(),
      offsetProvis = zone.offset(tsNow),
      _objToTS = objToTS(obj, offsetProvis, zone),
      ts = _objToTS[0],
      o = _objToTS[1];

  return new DateTime({
    ts: ts,
    zone: zone,
    o: o
  });
}

function diffRelative(start, end, opts) {
  var round = isUndefined(opts.round) ? true : opts.round,
      format = function format(c, unit) {
    c = roundTo(c, round || opts.calendary ? 0 : 2, true);
    var formatter = end.loc.clone(opts).relFormatter(opts);
    return formatter.format(c, unit);
  },
      differ = function differ(unit) {
    if (opts.calendary) {
      if (!end.hasSame(start, unit)) {
        return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
      } else return 0;
    } else {
      return end.diff(start, unit).get(unit);
    }
  };

  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }

  for (var _iterator2 = _createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;) {
    var unit = _step2.value;
    var count = differ(unit);

    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }

  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */


var DateTime = /*#__PURE__*/function () {
  /**
   * @access private
   */
  function DateTime(config) {
    var zone = config.zone || Settings.defaultZone;
    var invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */

    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    var c = null,
        o = null;

    if (!invalid) {
      var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);

      if (unchanged) {
        var _ref2 = [config.old.c, config.old.o];
        c = _ref2[0];
        o = _ref2[1];
      } else {
        var ot = zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }
    /**
     * @access private
     */


    this._zone = zone;
    /**
     * @access private
     */

    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */

    this.invalid = invalid;
    /**
     * @access private
     */

    this.weekData = null;
    /**
     * @access private
     */

    this.c = c;
    /**
     * @access private
     */

    this.o = o;
    /**
     * @access private
     */

    this.isLuxonDateTime = true;
  } // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */


  DateTime.now = function now() {
    return new DateTime({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                            //~> now
   * @example DateTime.local(2017)                        //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                     //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12)                 //~> 2017-03-12T00:00:00
   * @example DateTime.local(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  ;

  DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return DateTime.now();
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, Settings.defaultZone);
    }
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.utc()                            //~> now
   * @example DateTime.utc(2017)                        //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                     //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                 //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)              //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)          //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)      //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765) //~> 2017-03-12T05:45:10.765Z
   * @return {DateTime}
   */
  ;

  DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
    if (isUndefined(year)) {
      return new DateTime({
        ts: Settings.now(),
        zone: FixedOffsetZone.utcInstance
      });
    } else {
      return quickDT({
        year: year,
        month: month,
        day: day,
        hour: hour,
        minute: minute,
        second: second,
        millisecond: millisecond
      }, FixedOffsetZone.utcInstance);
    }
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  ;

  DateTime.fromJSDate = function fromJSDate(date, options) {
    if (options === void 0) {
      options = {};
    }

    var ts = isDate(date) ? date.valueOf() : NaN;

    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }

    var zoneToUse = normalizeZone(options.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromMillis = function fromMillis(milliseconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromSeconds = function fromSeconds(seconds, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {string|Zone} [obj.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [obj.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} obj.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} obj.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6, zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */
  ;

  DateTime.fromObject = function fromObject(obj) {
    var zoneToUse = normalizeZone(obj.zone, Settings.defaultZone);

    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }

    var tsNow = Settings.now(),
        offsetProvis = zoneToUse.offset(tsNow),
        normalized = normalizeObject(obj, normalizeUnit, ["zone", "locale", "outputCalendar", "numberingSystem"]),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber,
        loc = Locale.fromObject(obj); // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff

    var units,
        defaultValues,
        objNow = tsToObj(tsNow, offsetProvis);

    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits$1;
      defaultValues = defaultUnitValues;
    } // set default values for missing stuff


    var foundFirst = false;

    for (var _iterator3 = _createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;) {
      var u = _step3.value;
      var v = normalized[u];

      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    } // make sure the values we have are in range


    var higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
        invalid = higherOrderInvalid || hasInvalidTimeData(normalized);

    if (invalid) {
      return DateTime.invalid(invalid);
    } // compute the actual time


    var gregorian = useWeekData ? weekToGregorian(normalized) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
        _objToTS2 = objToTS(gregorian, offsetProvis, zoneToUse),
        tsFinal = _objToTS2[0],
        offsetFinal = _objToTS2[1],
        inst = new DateTime({
      ts: tsFinal,
      zone: zoneToUse,
      o: offsetFinal,
      loc: loc
    }); // gregorian data + weekday serves only to validate


    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
    }

    return inst;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  ;

  DateTime.fromISO = function fromISO(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseISODate = parseISODate(text),
        vals = _parseISODate[0],
        parsedZone = _parseISODate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  ;

  DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseRFC2822Date = parseRFC2822Date(text),
        vals = _parseRFC2822Date[0],
        parsedZone = _parseRFC2822Date[1];

    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  ;

  DateTime.fromHTTP = function fromHTTP(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseHTTPDate = parseHTTPDate(text),
        vals = _parseHTTPDate[0],
        parsedZone = _parseHTTPDate[1];

    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/parsing.html#table-of-tokens
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  ;

  DateTime.fromFormat = function fromFormat(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }

    var _opts = opts,
        _opts$locale = _opts.locale,
        locale = _opts$locale === void 0 ? null : _opts$locale,
        _opts$numberingSystem = _opts.numberingSystem,
        numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    }),
        _parseFromTokens = parseFromTokens(localeToUse, text, fmt),
        vals = _parseFromTokens[0],
        parsedZone = _parseFromTokens[1],
        invalid = _parseFromTokens[2];

    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
    }
  }
  /**
   * @deprecated use fromFormat instead
   */
  ;

  DateTime.fromString = function fromString(text, fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return DateTime.fromFormat(text, fmt, opts);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  ;

  DateTime.fromSQL = function fromSQL(text, opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _parseSQL = parseSQL(text),
        vals = _parseSQL[0],
        parsedZone = _parseSQL[1];

    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  ;

  DateTime.invalid = function invalid(reason, explanation) {
    if (explanation === void 0) {
      explanation = null;
    }

    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }

    var invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);

    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid: invalid
      });
    }
  }
  /**
   * Check if an object is a DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  ;

  DateTime.isDateTime = function isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  } // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  ;

  var _proto = DateTime.prototype;

  _proto.get = function get(unit) {
    return this[unit];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  ;

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
    if (opts === void 0) {
      opts = {};
    }

    var _Formatter$create$res = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this),
        locale = _Formatter$create$res.locale,
        numberingSystem = _Formatter$create$res.numberingSystem,
        calendar = _Formatter$create$res.calendar;

    return {
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: calendar
    };
  } // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  ;

  _proto.toUTC = function toUTC(offset, opts) {
    if (offset === void 0) {
      offset = 0;
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  ;

  _proto.toLocal = function toLocal() {
    return this.setZone(Settings.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link plus}. You may wish to use {@link toLocal} and {@link toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  ;

  _proto.setZone = function setZone(zone, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp,
        _ref3$keepLocalTime = _ref3.keepLocalTime,
        keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime,
        _ref3$keepCalendarTim = _ref3.keepCalendarTime,
        keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;

    zone = normalizeZone(zone, Settings.defaultZone);

    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      var newTS = this.ts;

      if (keepLocalTime || keepCalendarTime) {
        var offsetGuess = zone.offset(this.ts);
        var asObj = this.toObject();

        var _objToTS3 = objToTS(asObj, offsetGuess, zone);

        newTS = _objToTS3[0];
      }

      return clone$1(this, {
        ts: newTS,
        zone: zone
      });
    }
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  ;

  _proto.reconfigure = function reconfigure(_temp2) {
    var _ref4 = _temp2 === void 0 ? {} : _temp2,
        locale = _ref4.locale,
        numberingSystem = _ref4.numberingSystem,
        outputCalendar = _ref4.outputCalendar;

    var loc = this.loc.clone({
      locale: locale,
      numberingSystem: numberingSystem,
      outputCalendar: outputCalendar
    });
    return clone$1(this, {
      loc: loc
    });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  ;

  _proto.setLocale = function setLocale(locale) {
    return this.reconfigure({
      locale: locale
    });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link reconfigure} and {@link setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  ;

  _proto.set = function set(values) {
    if (!this.isValid) return this;
    var normalized = normalizeObject(values, normalizeUnit, []),
        settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
        containsOrdinal = !isUndefined(normalized.ordinal),
        containsGregorYear = !isUndefined(normalized.year),
        containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
        containsGregor = containsGregorYear || containsGregorMD,
        definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }

    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }

    var mixed;

    if (settingWeekStuff) {
      mixed = weekToGregorian(Object.assign(gregorianToWeek(this.c), normalized));
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian(Object.assign(gregorianToOrdinal(this.c), normalized));
    } else {
      mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month

      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }

    var _objToTS4 = objToTS(mixed, this.o, this.zone),
        ts = _objToTS4[0],
        o = _objToTS4[1];

    return clone$1(this, {
      ts: ts,
      o: o
    });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  ;

  _proto.plus = function plus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration);
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
  */
  ;

  _proto.minus = function minus(duration) {
    if (!this.isValid) return this;
    var dur = friendlyDuration(duration).negate();
    return clone$1(this, adjustTime(this, dur));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  ;

  _proto.startOf = function startOf(unit) {
    if (!this.isValid) return this;
    var o = {},
        normalizedUnit = Duration.normalizeUnit(unit);

    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through

      case "quarters":
      case "months":
        o.day = 1;
      // falls through

      case "weeks":
      case "days":
        o.hour = 0;
      // falls through

      case "hours":
        o.minute = 0;
      // falls through

      case "minutes":
        o.second = 0;
      // falls through

      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      o.weekday = 1;
    }

    if (normalizedUnit === "quarters") {
      var q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }

    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  ;

  _proto.endOf = function endOf(unit) {
    var _this$plus;

    return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
  } // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @see https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  ;

  _proto.toFormat = function toFormat(fmt, opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID$2;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param opts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hour12: false }); //=> '11:32'
   * @return {string}
   */
  ;

  _proto.toLocaleString = function toLocaleString(opts) {
    if (opts === void 0) {
      opts = DATE_SHORT;
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : INVALID$2;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  ;

  _proto.toLocaleParts = function toLocaleParts(opts) {
    if (opts === void 0) {
      opts = {};
    }

    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  ;

  _proto.toISO = function toISO(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toISODate(opts) + "T" + this.toISOTime(opts);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  ;

  _proto.toISODate = function toISODate(_temp3) {
    var _ref5 = _temp3 === void 0 ? {} : _temp3,
        _ref5$format = _ref5.format,
        format = _ref5$format === void 0 ? "extended" : _ref5$format;

    var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";

    if (this.year > 9999) {
      fmt = "+" + fmt;
    }

    return toTechFormat(this, fmt);
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  ;

  _proto.toISOWeekDate = function toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  ;

  _proto.toISOTime = function toISOTime(_temp4) {
    var _ref6 = _temp4 === void 0 ? {} : _temp4,
        _ref6$suppressMillise = _ref6.suppressMilliseconds,
        suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise,
        _ref6$suppressSeconds = _ref6.suppressSeconds,
        suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds,
        _ref6$includeOffset = _ref6.includeOffset,
        includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset,
        _ref6$includePrefix = _ref6.includePrefix,
        includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix,
        _ref6$format = _ref6.format,
        format = _ref6$format === void 0 ? "extended" : _ref6$format;

    return toTechTimeFormat(this, {
      suppressSeconds: suppressSeconds,
      suppressMilliseconds: suppressMilliseconds,
      includeOffset: includeOffset,
      includePrefix: includePrefix,
      format: format
    });
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime, always in UTC
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  ;

  _proto.toRFC2822 = function toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  ;

  _proto.toHTTP = function toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  ;

  _proto.toSQLDate = function toSQLDate() {
    return toTechFormat(this, "yyyy-MM-dd");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQLTime = function toSQLTime(_temp5) {
    var _ref7 = _temp5 === void 0 ? {} : _temp5,
        _ref7$includeOffset = _ref7.includeOffset,
        includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset,
        _ref7$includeZone = _ref7.includeZone,
        includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;

    return toTechTimeFormat(this, {
      includeOffset: includeOffset,
      includeZone: includeZone,
      spaceZone: true
    });
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  ;

  _proto.toSQL = function toSQL(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) {
      return null;
    }

    return this.toSQLDate() + " " + this.toSQLTime(opts);
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  ;

  _proto.toString = function toString() {
    return this.isValid ? this.toISO() : INVALID$2;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link toMillis}
   * @return {number}
   */
  ;

  _proto.valueOf = function valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toMillis = function toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  ;

  _proto.toSeconds = function toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toBSON = function toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  ;

  _proto.toObject = function toObject(opts) {
    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid) return {};
    var base = Object.assign({}, this.c);

    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }

    return base;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  ;

  _proto.toJSDate = function toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  } // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  ;

  _proto.diff = function diff(otherDateTime, unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
    }

    var durOpts = Object.assign({
      locale: this.locale,
      numberingSystem: this.numberingSystem
    }, opts);

    var units = maybeArray(unit).map(Duration.normalizeUnit),
        otherIsLater = otherDateTime.valueOf() > this.valueOf(),
        earlier = otherIsLater ? this : otherDateTime,
        later = otherIsLater ? otherDateTime : this,
        diffed = _diff(earlier, later, units, durOpts);

    return otherIsLater ? diffed.negate() : diffed;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  ;

  _proto.diffNow = function diffNow(unit, opts) {
    if (unit === void 0) {
      unit = "milliseconds";
    }

    if (opts === void 0) {
      opts = {};
    }

    return this.diff(DateTime.now(), unit, opts);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  ;

  _proto.until = function until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  ;

  _proto.hasSame = function hasSame(otherDateTime, unit) {
    if (!this.isValid) return false;
    var inputMs = otherDateTime.valueOf();
    var otherZoneDateTime = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
  }
  /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  ;

  _proto.equals = function equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  ;

  _proto.toRelative = function toRelative(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    var base = options.base || DateTime.fromObject({
      zone: this.zone
    }),
        padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    var units = ["years", "months", "days", "hours", "minutes", "seconds"];
    var unit = options.unit;

    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }

    return diffRelative(base, this.plus(padding), Object.assign(options, {
      numeric: "always",
      units: units,
      unit: unit
    }));
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  ;

  _proto.toRelativeCalendar = function toRelativeCalendar(options) {
    if (options === void 0) {
      options = {};
    }

    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({
      zone: this.zone
    }), this, Object.assign(options, {
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    }));
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  ;

  DateTime.min = function min() {
    for (var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++) {
      dateTimes[_key] = arguments[_key];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  ;

  DateTime.max = function max() {
    for (var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      dateTimes[_key2] = arguments[_key2];
    }

    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }

    return bestBy(dateTimes, function (i) {
      return i.valueOf();
    }, Math.max);
  } // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  ;

  DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$locale = _options.locale,
        locale = _options$locale === void 0 ? null : _options$locale,
        _options$numberingSys = _options.numberingSystem,
        numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys,
        localeToUse = Locale.fromOpts({
      locale: locale,
      numberingSystem: numberingSystem,
      defaultToEN: true
    });
    return explainFromTokens(localeToUse, text, fmt);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  ;

  DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
    if (options === void 0) {
      options = {};
    }

    return DateTime.fromFormatExplain(text, fmt, options);
  } // FORMAT PRESETS

  /**
   * {@link toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  ;

  _createClass(DateTime, [{
    key: "isValid",
    get: function get() {
      return this.invalid === null;
    }
    /**
     * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidReason",
    get: function get() {
      return this.invalid ? this.invalid.reason : null;
    }
    /**
     * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
     * @type {string}
     */

  }, {
    key: "invalidExplanation",
    get: function get() {
      return this.invalid ? this.invalid.explanation : null;
    }
    /**
     * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "locale",
    get: function get() {
      return this.isValid ? this.loc.locale : null;
    }
    /**
     * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "numberingSystem",
    get: function get() {
      return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
     * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
     *
     * @type {string}
     */

  }, {
    key: "outputCalendar",
    get: function get() {
      return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
     * Get the time zone associated with this DateTime.
     * @type {Zone}
     */

  }, {
    key: "zone",
    get: function get() {
      return this._zone;
    }
    /**
     * Get the name of the time zone.
     * @type {string}
     */

  }, {
    key: "zoneName",
    get: function get() {
      return this.isValid ? this.zone.name : null;
    }
    /**
     * Get the year
     * @example DateTime.local(2017, 5, 25).year //=> 2017
     * @type {number}
     */

  }, {
    key: "year",
    get: function get() {
      return this.isValid ? this.c.year : NaN;
    }
    /**
     * Get the quarter
     * @example DateTime.local(2017, 5, 25).quarter //=> 2
     * @type {number}
     */

  }, {
    key: "quarter",
    get: function get() {
      return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
     * Get the month (1-12).
     * @example DateTime.local(2017, 5, 25).month //=> 5
     * @type {number}
     */

  }, {
    key: "month",
    get: function get() {
      return this.isValid ? this.c.month : NaN;
    }
    /**
     * Get the day of the month (1-30ish).
     * @example DateTime.local(2017, 5, 25).day //=> 25
     * @type {number}
     */

  }, {
    key: "day",
    get: function get() {
      return this.isValid ? this.c.day : NaN;
    }
    /**
     * Get the hour of the day (0-23).
     * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
     * @type {number}
     */

  }, {
    key: "hour",
    get: function get() {
      return this.isValid ? this.c.hour : NaN;
    }
    /**
     * Get the minute of the hour (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
     * @type {number}
     */

  }, {
    key: "minute",
    get: function get() {
      return this.isValid ? this.c.minute : NaN;
    }
    /**
     * Get the second of the minute (0-59).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
     * @type {number}
     */

  }, {
    key: "second",
    get: function get() {
      return this.isValid ? this.c.second : NaN;
    }
    /**
     * Get the millisecond of the second (0-999).
     * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
     * @type {number}
     */

  }, {
    key: "millisecond",
    get: function get() {
      return this.isValid ? this.c.millisecond : NaN;
    }
    /**
     * Get the week year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
     * @type {number}
     */

  }, {
    key: "weekYear",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
     * Get the week number of the week year (1-52ish).
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
     * @type {number}
     */

  }, {
    key: "weekNumber",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
     * Get the day of the week.
     * 1 is Monday and 7 is Sunday
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2014, 11, 31).weekday //=> 4
     * @type {number}
     */

  }, {
    key: "weekday",
    get: function get() {
      return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
     * Get the ordinal (meaning the day of the year)
     * @example DateTime.local(2017, 5, 25).ordinal //=> 145
     * @type {number|DateTime}
     */

  }, {
    key: "ordinal",
    get: function get() {
      return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
    }
    /**
     * Get the human readable short month name, such as 'Oct'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
     * @type {string}
     */

  }, {
    key: "monthShort",
    get: function get() {
      return this.isValid ? Info.months("short", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable long month name, such as 'October'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).monthLong //=> October
     * @type {string}
     */

  }, {
    key: "monthLong",
    get: function get() {
      return this.isValid ? Info.months("long", {
        locObj: this.loc
      })[this.month - 1] : null;
    }
    /**
     * Get the human readable short weekday, such as 'Mon'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
     * @type {string}
     */

  }, {
    key: "weekdayShort",
    get: function get() {
      return this.isValid ? Info.weekdays("short", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the human readable long weekday, such as 'Monday'.
     * Defaults to the system's locale if no locale has been specified
     * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
     * @type {string}
     */

  }, {
    key: "weekdayLong",
    get: function get() {
      return this.isValid ? Info.weekdays("long", {
        locObj: this.loc
      })[this.weekday - 1] : null;
    }
    /**
     * Get the UTC offset of this DateTime in minutes
     * @example DateTime.now().offset //=> -240
     * @example DateTime.utc().offset //=> 0
     * @type {number}
     */

  }, {
    key: "offset",
    get: function get() {
      return this.isValid ? +this.o : NaN;
    }
    /**
     * Get the short human name for the zone's current offset, for example "EST" or "EDT".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameShort",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "short",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
     * Defaults to the system's locale if no locale has been specified
     * @type {string}
     */

  }, {
    key: "offsetNameLong",
    get: function get() {
      if (this.isValid) {
        return this.zone.offsetName(this.ts, {
          format: "long",
          locale: this.locale
        });
      } else {
        return null;
      }
    }
    /**
     * Get whether this zone's offset ever changes, as in a DST.
     * @type {boolean}
     */

  }, {
    key: "isOffsetFixed",
    get: function get() {
      return this.isValid ? this.zone.universal : null;
    }
    /**
     * Get whether the DateTime is in a DST.
     * @type {boolean}
     */

  }, {
    key: "isInDST",
    get: function get() {
      if (this.isOffsetFixed) {
        return false;
      } else {
        return this.offset > this.set({
          month: 1
        }).offset || this.offset > this.set({
          month: 5
        }).offset;
      }
    }
    /**
     * Returns true if this DateTime is in a leap year, false otherwise
     * @example DateTime.local(2016).isInLeapYear //=> true
     * @example DateTime.local(2013).isInLeapYear //=> false
     * @type {boolean}
     */

  }, {
    key: "isInLeapYear",
    get: function get() {
      return isLeapYear(this.year);
    }
    /**
     * Returns the number of days in this DateTime's month
     * @example DateTime.local(2016, 2).daysInMonth //=> 29
     * @example DateTime.local(2016, 3).daysInMonth //=> 31
     * @type {number}
     */

  }, {
    key: "daysInMonth",
    get: function get() {
      return daysInMonth(this.year, this.month);
    }
    /**
     * Returns the number of days in this DateTime's year
     * @example DateTime.local(2016).daysInYear //=> 366
     * @example DateTime.local(2013).daysInYear //=> 365
     * @type {number}
     */

  }, {
    key: "daysInYear",
    get: function get() {
      return this.isValid ? daysInYear(this.year) : NaN;
    }
    /**
     * Returns the number of weeks in this DateTime's year
     * @see https://en.wikipedia.org/wiki/ISO_week_date
     * @example DateTime.local(2004).weeksInWeekYear //=> 53
     * @example DateTime.local(2013).weeksInWeekYear //=> 52
     * @type {number}
     */

  }, {
    key: "weeksInWeekYear",
    get: function get() {
      return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
    }
  }], [{
    key: "DATE_SHORT",
    get: function get() {
      return DATE_SHORT;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED",
    get: function get() {
      return DATE_MED;
    }
    /**
     * {@link toLocaleString} format like 'Fri, Oct 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_MED_WITH_WEEKDAY",
    get: function get() {
      return DATE_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_FULL",
    get: function get() {
      return DATE_FULL;
    }
    /**
     * {@link toLocaleString} format like 'Tuesday, October 14, 1983'
     * @type {Object}
     */

  }, {
    key: "DATE_HUGE",
    get: function get() {
      return DATE_HUGE;
    }
    /**
     * {@link toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_SIMPLE",
    get: function get() {
      return TIME_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SECONDS",
    get: function get() {
      return TIME_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "TIME_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_SIMPLE",
    get: function get() {
      return TIME_24_SIMPLE;
    }
    /**
     * {@link toLocaleString} format like '09:30:23', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SECONDS",
    get: function get() {
      return TIME_24_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 EDT', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_SHORT_OFFSET",
    get: function get() {
      return TIME_24_WITH_SHORT_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
     * @type {Object}
     */

  }, {
    key: "TIME_24_WITH_LONG_OFFSET",
    get: function get() {
      return TIME_24_WITH_LONG_OFFSET;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT",
    get: function get() {
      return DATETIME_SHORT;
    }
    /**
     * {@link toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_SHORT_WITH_SECONDS",
    get: function get() {
      return DATETIME_SHORT_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED",
    get: function get() {
      return DATETIME_MED;
    }
    /**
     * {@link toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_SECONDS",
    get: function get() {
      return DATETIME_MED_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_MED_WITH_WEEKDAY",
    get: function get() {
      return DATETIME_MED_WITH_WEEKDAY;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL",
    get: function get() {
      return DATETIME_FULL;
    }
    /**
     * {@link toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_FULL_WITH_SECONDS",
    get: function get() {
      return DATETIME_FULL_WITH_SECONDS;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE",
    get: function get() {
      return DATETIME_HUGE;
    }
    /**
     * {@link toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
     * @type {Object}
     */

  }, {
    key: "DATETIME_HUGE_WITH_SECONDS",
    get: function get() {
      return DATETIME_HUGE_WITH_SECONDS;
    }
  }]);

  return DateTime;
}();
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
  }
}

var VERSION = "1.28.1";

exports.ou = DateTime;
__webpack_unused_export__ = Duration;
__webpack_unused_export__ = FixedOffsetZone;
__webpack_unused_export__ = IANAZone;
__webpack_unused_export__ = Info;
__webpack_unused_export__ = Interval;
__webpack_unused_export__ = InvalidZone;
__webpack_unused_export__ = LocalZone;
__webpack_unused_export__ = Settings;
__webpack_unused_export__ = VERSION;
__webpack_unused_export__ = Zone;
//# sourceMappingURL=luxon.js.map


/***/ }),

/***/ 30845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["default"] = (memoizeOne);


/***/ }),

/***/ 4067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jc": function() { return /* reexport */ appWithTranslation; },
  "ag": function() { return /* reexport */ globalI18n; },
  "Zh": function() { return /* reexport */ es/* withTranslation */.Zh; }
});

// UNUSED EXPORTS: I18nContext, Trans, Translation, useTranslation

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/defaultConfig.js
var DEFAULT_LOCALE = 'en';
var LOCALES = ['en'];
var DEFAULT_NAMESPACE = 'common';
var LOCALE_PATH = './public/locales';
var LOCALE_STRUCTURE = '{{lng}}/{{ns}}';
var LOCALE_EXTENSION = 'json';
var defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES
  },
  get initImmediate() {
    return  true && typeof window !== 'undefined';
  },
  interpolation: {
    escapeValue: false
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: []
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/utils.js


var getFallbackForLng = function getFallbackForLng(lng, fallbackLng) {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng];
  }
  if (Array.isArray(fallbackLng)) {
    return fallbackLng;
  }
  if (_typeof(fallbackLng) === 'object') {
    var fallbackList = fallbackLng[lng];
    var fallbackDefault = fallbackLng["default"];
    return [].concat(_toConsumableArray(fallbackList !== null && fallbackList !== void 0 ? fallbackList : []), _toConsumableArray(fallbackDefault !== null && fallbackDefault !== void 0 ? fallbackDefault : []));
  }
  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng(lng));
  }
  return [];
};
var unique = function unique(list) {
  return Array.from(new Set(list));
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/config/createConfig.js





var _excluded = ["i18n"],
  _excluded2 = ["i18n"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var deepMergeObjects = ['backend', 'detection'];
var createConfig = function createConfig(userConfig) {
  var _userConfig$interpola, _userConfig$interpola2, _userConfig$use;
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.lng) !== 'string') {
    throw new Error('config.lng was not passed into createConfig');
  }

  //
  // Initial merge of default and user-provided config
  //
  var userI18n = userConfig.i18n,
    userConfigStripped = (0,objectWithoutProperties/* default */.Z)(userConfig, _excluded);
  var defaultI18n = defaultConfig.i18n,
    defaultConfigStripped = (0,objectWithoutProperties/* default */.Z)(defaultConfig, _excluded2);
  var combinedConfig = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultConfigStripped), userConfigStripped), defaultI18n), userI18n);
  var defaultNS = combinedConfig.defaultNS,
    lng = combinedConfig.lng,
    localeExtension = combinedConfig.localeExtension,
    localePath = combinedConfig.localePath,
    nonExplicitSupportedLngs = combinedConfig.nonExplicitSupportedLngs;
  var locales = combinedConfig.locales.filter(function (l) {
    return l !== 'default';
  });

  /**
   * Skips translation file resolution while in cimode
   * https://github.com/i18next/next-i18next/pull/851#discussion_r503113620
   */
  if (lng === 'cimode') {
    return combinedConfig;
  }
  if (typeof combinedConfig.fallbackLng === 'undefined') {
    combinedConfig.fallbackLng = combinedConfig.defaultLocale;
    if (combinedConfig.fallbackLng === 'default') {
      var _locales = (0,slicedToArray/* default */.Z)(locales, 1);
      combinedConfig.fallbackLng = _locales[0];
    }
  }
  var userPrefix = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$interpola = userConfig.interpolation) === null || _userConfig$interpola === void 0 ? void 0 : _userConfig$interpola.prefix;
  var userSuffix = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$interpola2 = userConfig.interpolation) === null || _userConfig$interpola2 === void 0 ? void 0 : _userConfig$interpola2.suffix;
  var prefix = userPrefix !== null && userPrefix !== void 0 ? userPrefix : '{{';
  var suffix = userSuffix !== null && userSuffix !== void 0 ? userSuffix : '}}';
  if (typeof (userConfig === null || userConfig === void 0 ? void 0 : userConfig.localeStructure) !== 'string' && (userPrefix || userSuffix)) {
    combinedConfig.localeStructure = "".concat(prefix, "lng").concat(suffix, "/").concat(prefix, "ns").concat(suffix);
  }
  var fallbackLng = combinedConfig.fallbackLng,
    localeStructure = combinedConfig.localeStructure;
  if (nonExplicitSupportedLngs) {
    var createFallbackObject = function createFallbackObject(acc, l) {
      var _l$split = l.split('-'),
        _l$split2 = (0,slicedToArray/* default */.Z)(_l$split, 1),
        locale = _l$split2[0];
      acc[l] = [locale];
      return acc;
    };
    if (typeof fallbackLng === 'string') {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": [fallbackLng]
      });
    } else if (Array.isArray(fallbackLng)) {
      combinedConfig.fallbackLng = combinedConfig.locales.filter(function (l) {
        return l.includes('-');
      }).reduce(createFallbackObject, {
        "default": fallbackLng
      });
    } else if ((0,esm_typeof/* default */.Z)(fallbackLng) === 'object') {
      combinedConfig.fallbackLng = Object.entries(combinedConfig.fallbackLng).reduce(function (acc, _ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          l = _ref2[0],
          f = _ref2[1];
        acc[l] = l.includes('-') ? unique([l.split('-')[0]].concat((0,toConsumableArray/* default */.Z)(f))) : f;
        return acc;
      }, fallbackLng);
    } else if (typeof fallbackLng === 'function') {
      throw new Error('If nonExplicitSupportedLngs is true, no functions are allowed for fallbackLng');
    }
  }
  var hasCustomBackend = userConfig === null || userConfig === void 0 ? void 0 : (_userConfig$use = userConfig.use) === null || _userConfig$use === void 0 ? void 0 : _userConfig$use.some(function (b) {
    return b.type === 'backend';
  });
  if (false) { var getNamespaces, _defaultFallbackNSExists, _fallback, _defaultNSExists, _defaultNSPath, defaultFallbackNSExists, fallback, defaultNSExists, defaultNSPath, defaultFile, defaultLocaleStructure, path, fs; } else {
    //
    // Set client side backend, if there is no custom backend
    //
    if (!hasCustomBackend) {
      if (typeof localePath === 'string') {
        combinedConfig.backend = {
          addPath: "".concat(localePath, "/").concat(localeStructure, ".missing.").concat(localeExtension),
          loadPath: "".concat(localePath, "/").concat(localeStructure, ".").concat(localeExtension)
        };
      } else if (typeof localePath === 'function') {
        combinedConfig.backend = {
          addPath: function addPath(locale, namespace) {
            return localePath(locale, namespace, true);
          },
          loadPath: function loadPath(locale, namespace) {
            return localePath(locale, namespace, false);
          }
        };
      }
    }
    if (typeof combinedConfig.ns !== 'string' && !Array.isArray(combinedConfig.ns)) {
      combinedConfig.ns = [defaultNS];
    }
  }

  //
  // Deep merge with overwrite - goes last
  //
  deepMergeObjects.forEach(function (obj) {
    if (userConfig[obj]) {
      combinedConfig[obj] = _objectSpread(_objectSpread({}, combinedConfig[obj]), userConfig[obj]);
    }
  });
  return combinedConfig;
};
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(89611);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,setPrototypeOf/* default */.Z)(subClass, superClass);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && ((0,esm_typeof/* default */.Z)(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return (0,assertThisInitialized/* default */.Z)(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(arr) {
  return (0,arrayWithHoles/* default */.Z)(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || (0,nonIterableRest/* default */.Z)();
}
;// CONCATENATED MODULE: ./node_modules/i18next/dist/esm/i18next.js










function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,classCallCheck/* default */.Z)(this, Logger);
    this.init(concreteLogger, options);
  }
  (0,createClass/* default */.Z)(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    (0,classCallCheck/* default */.Z)(this, EventEmitter);
    this.observers = {};
  }
  (0,createClass/* default */.Z)(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
    obj = _getLastOfPath.obj,
    k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
    obj = _getLastOfPath2.obj,
    k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
    obj = _getLastOfPath3.obj,
    k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function i18next_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);
  var _super = _createSuper$3(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    (0,classCallCheck/* default */.Z)(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  (0,createClass/* default */.Z)(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);
  var _super = _createSuper$2(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,classCallCheck/* default */.Z)(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, (0,assertThisInitialized/* default */.Z)(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  (0,createClass/* default */.Z)(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if ((0,esm_typeof/* default */.Z)(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if ((0,esm_typeof/* default */.Z)(options) === 'object') options = _objectSpread$4({}, options);
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _this$extractFromKey.key,
        namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: "".concat(namespace).concat(nsSeparator).concat(key),
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace
            };
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    (0,classCallCheck/* default */.Z)(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  (0,createClass/* default */.Z)(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0,classCallCheck/* default */.Z)(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  (0,createClass/* default */.Z)(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function deepFindWithDefaults(data, defaultData, key) {
  var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,classCallCheck/* default */.Z)(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  (0,createClass/* default */.Z)(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : i18next_escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
          _opt$split2 = _toArray(_opt$split),
          key = _opt$split2[0],
          rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0,classCallCheck/* default */.Z)(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val, opt.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  (0,createClass/* default */.Z)(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
          formatName = _parseFormatStr.formatName,
          formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);
  var _super = _createSuper$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    (0,classCallCheck/* default */.Z)(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  (0,createClass/* default */.Z)(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (n) {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(function (data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
          isUpdate: isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if ((0,esm_typeof/* default */.Z)(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if ((0,esm_typeof/* default */.Z)(args[2]) === 'object' || (0,esm_typeof/* default */.Z)(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function i18next_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function i18next_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? i18next_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : i18next_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function noop() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    (0,classCallCheck/* default */.Z)(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call((0,assertThisInitialized/* default */.Z)(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions((0,assertThisInitialized/* default */.Z)(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return _possibleConstructorReturn(_this, (0,assertThisInitialized/* default */.Z)(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  (0,createClass/* default */.Z)(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get();
      this.options = i18next_objectSpread(i18next_objectSpread(i18next_objectSpread({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = i18next_objectSpread(i18next_objectSpread({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if ((0,esm_typeof/* default */.Z)(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = i18next_objectSpread({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function (k) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = options.lng || this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var mergedOptions = i18next_objectSpread(i18next_objectSpread(i18next_objectSpread({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = i18next_objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
(0,defineProperty/* default */.Z)(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var i18next_instance = I18n.createInstance();
i18next_instance.createInstance = I18n.createInstance;

var createInstance = i18next_instance.createInstance;
var dir = i18next_instance.dir;
var init = i18next_instance.init;
var loadResources = i18next_instance.loadResources;
var reloadResources = i18next_instance.reloadResources;
var use = i18next_instance.use;
var changeLanguage = i18next_instance.changeLanguage;
var getFixedT = i18next_instance.getFixedT;
var t = i18next_instance.t;
var exists = i18next_instance.exists;
var setDefaultNamespace = i18next_instance.setDefaultNamespace;
var hasLoadedNamespace = i18next_instance.hasLoadedNamespace;
var loadNamespaces = i18next_instance.loadNamespaces;
var loadLanguages = i18next_instance.loadLanguages;



;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/createClient/browser.js

/* harmony default export */ var browser = (function (config) {
  if (config.ns === undefined) config.ns = [];
  var instance = i18next_instance.createInstance(config);
  var initPromise;
  if (!instance.isInitialized) {
    var _config$use;
    config === null || config === void 0 ? void 0 : (_config$use = config.use) === null || _config$use === void 0 ? void 0 : _config$use.forEach(function (x) {
      return instance.use(x);
    });
    if (typeof config.onPreInitI18next === 'function') {
      config.onPreInitI18next(instance);
    }
    initPromise = instance.init(config);
  } else {
    initPromise = Promise.resolve(i18next_instance.t);
  }
  return {
    i18n: instance,
    initPromise: initPromise
  };
});
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/appWithTranslation.js


var __jsx = react.createElement;
function appWithTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function appWithTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? appWithTranslation_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : appWithTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var globalI18n = null;
var appWithTranslation = function appWithTranslation(WrappedComponent) {
  var configOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var AppWithTranslation = function AppWithTranslation(props) {
    var _nextI18Next$initialL, _props$router;
    var _ref = props.pageProps || {},
      _nextI18Next = _ref._nextI18Next; // pageProps may be undefined on strange setups, i.e. https://github.com/i18next/next-i18next/issues/2109
    var locale = (_nextI18Next$initialL = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.initialLocale) !== null && _nextI18Next$initialL !== void 0 ? _nextI18Next$initialL : props === null || props === void 0 ? void 0 : (_props$router = props.router) === null || _props$router === void 0 ? void 0 : _props$router.locale;
    var ns = _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.ns;

    // Memoize the instance and only re-initialize when either:
    // 1. The route changes (non-shallowly)
    // 2. Router locale changes
    // 3. UserConfig override changes
    var i18n = (0,react.useMemo)(function () {
      var _userConfig$i18n;
      if (!_nextI18Next && !configOverride) return null;
      var userConfig = configOverride !== null && configOverride !== void 0 ? configOverride : _nextI18Next === null || _nextI18Next === void 0 ? void 0 : _nextI18Next.userConfig;
      if (!userConfig) {
        throw new Error('appWithTranslation was called without a next-i18next config');
      }
      if (!(userConfig !== null && userConfig !== void 0 && userConfig.i18n)) {
        throw new Error('appWithTranslation was called without config.i18n');
      }
      if (!(userConfig !== null && userConfig !== void 0 && (_userConfig$i18n = userConfig.i18n) !== null && _userConfig$i18n !== void 0 && _userConfig$i18n.defaultLocale)) {
        throw new Error('config.i18n does not include a defaultLocale property');
      }
      var _ref2 = _nextI18Next || {},
        initialI18nStore = _ref2.initialI18nStore;
      var resources = configOverride !== null && configOverride !== void 0 && configOverride.resources ? configOverride.resources : initialI18nStore;
      if (!locale) locale = userConfig.i18n.defaultLocale;
      var instance = browser(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, createConfig(appWithTranslation_objectSpread(appWithTranslation_objectSpread({}, userConfig), {}, {
        lng: locale
      }))), {}, {
        lng: locale,
        ns: ns,
        resources: resources
      })).i18n;
      globalI18n = instance;
      return instance;
    }, [_nextI18Next, locale, configOverride, ns]);
    return i18n !== null ? __jsx(es/* I18nextProvider */.a3, {
      i18n: i18n
    }, __jsx(WrappedComponent, props)) : __jsx(WrappedComponent, (0,esm_extends/* default */.Z)({
      key: locale
    }, props));
  };
  return hoist_non_react_statics_cjs_default()(AppWithTranslation, WrappedComponent);
};
;// CONCATENATED MODULE: ./node_modules/next-i18next/dist/esm/index.js



/***/ }),

/***/ 7544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(46029)


/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(83934);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CommunityActions_CommunityActions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/CommunityActionsList/CommunityActionsList.module.scss
var CommunityActionsList_module = __webpack_require__(5792);
var CommunityActionsList_module_default = /*#__PURE__*/__webpack_require__.n(CommunityActionsList_module);
;// CONCATENATED MODULE: ./components/CommunityActionsList/components/CommonActions.tsx













var cx = bind_default().bind((CommunityActionsList_module_default()));
var CommonActions = function(param) {
    var handleMobileNavClick = param.handleMobileNavClick;
    var ref;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref1 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref1.community, currentUser = ref1.currentUser, communityUsers = ref1.communityUsers, featureFlags = ref1.featureFlags, trackEvent = ref1.trackEvent;
    var siteFeatures = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().siteFeatures;
    var isSearchEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_SEARCH */.R.COMMUNITIES_SEARCH];
    var communityEventsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEvents) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var router = (0,next_router.useRouter)();
    var handleClick = function(event) {
        event.preventDefault();
        if (handleMobileNavClick) handleMobileNavClick();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("common-actions__wrapper"),
        children: [
            isSearchEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: cx("common-actions__button", {
                    "is-active": router.pathname === routerHelpers/* pathnames.search */.$O.search
                }),
                "data-qa": "main-search_button",
                href: "/communities/".concat(community.id, "/search/"),
                type: "button",
                onClick: function(event) {
                    handleClick(event);
                    trackEvent(trackingEvents/* default.GO_TO_SEARCH */.ZP.GO_TO_SEARCH, {});
                    (0,routerHelpers/* goToSearch */.I6)(router, community.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "magnifying-glass",
                        "aria-hidden": true
                    }),
                    t("pages-search_title", "Search")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: cx("common-actions__button", {
                    "is-active": router.pathname === routerHelpers/* pathnames.home */.$O.home
                }),
                "data-qa": "main-home_button",
                href: "/communities/".concat(community.id, "/"),
                type: "button",
                onClick: function(event) {
                    handleClick(event);
                    (0,routerHelpers/* goToHome */.rC)(router, community.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "view-grid",
                        "aria-hidden": true
                    }),
                    t("pages-home_title", "Home")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: cx("common-actions__button", {
                    "is-active": router.pathname === routerHelpers/* pathnames.following */.$O.following
                }),
                "data-qa": "main-following__button",
                href: "/communities/".concat(community.id, "/following/"),
                type: "button",
                onClick: function(event) {
                    handleClick(event);
                    (0,routerHelpers/* goToFollowing */.Ey)(router, community.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "star-fill",
                        "aria-hidden": true
                    }),
                    t("pages-following_title", "Following")
                ]
            }),
            (0,userHelpers/* canViewMemberList */.e$)(currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: cx("common-actions__button", {
                    "is-active": router.pathname === routerHelpers/* pathnames.members */.$O.members
                }),
                "data-qa": "main-members_button",
                href: "/communities/".concat(community.id, "/members/"),
                type: "button",
                onClick: function(event) {
                    handleClick(event);
                    (0,routerHelpers/* goToMembers */.Ff)(router, community.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "people",
                        "aria-hidden": true
                    }),
                    t("pages-members_title", "Members"),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: cx("common-actions__members-count"),
                        children: [
                            "\xa0 ",
                            "(".concat(communityUsers.totalCount, ")")
                        ]
                    })
                ]
            }),
            communityEventsEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: cx("common-actions__button", {
                    "is-active": router.pathname === routerHelpers/* pathnames.events.events */.$O.events.events
                }),
                "data-qa": "main-event__button",
                href: "/communities/".concat(community.id, "/events/"),
                type: "button",
                onClick: function(event) {
                    handleClick(event);
                    (0,routerHelpers/* goToEvents */.MW)(router, community.id);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "system-calendar",
                        "aria-hidden": true
                    }),
                    t("pages-events_title", "Events")
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CommonActions = (CommonActions);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(94578);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}



;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var Context_ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (Context_ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function Subscription_createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = Subscription_createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || Context_ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect_useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? Context_ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = Subscription_createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators_bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators_bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js

var selectorFactory_excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, selectorFactory_excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, (0,esm_extends/* default */.Z)({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/createConnect());
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = useContext(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function useStore_createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function () {
    return useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/(/* unused pure expression or super */ null && (useStore_createStoreHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useDefaultStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/(/* unused pure expression or super */ null && (createDispatchHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = useReducer(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = useMemo(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = useRef();
  var latestSelector = useRef();
  var latestStoreState = useRef();
  var latestSelectedState = useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useDefaultReduxContext : function () {
    return useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    useDebugValue(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/(/* unused pure expression or super */ null && (createSelectorHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);

;// CONCATENATED MODULE: ./node_modules/use-memo-one/dist/use-memo-one.esm.js


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = (0,react.useState)(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = (0,react.useRef)(true);
  var committed = (0,react.useRef)(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  (0,react.useEffect)(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var use_memo_one_esm_useMemo = useMemoOne;
var useCallback = useCallbackOne;



;// CONCATENATED MODULE: ./node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}



;// CONCATENATED MODULE: ./node_modules/css-box-model/dist/css-box-model.esm.js


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? 0 : invariant(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};



// EXTERNAL MODULE: ./node_modules/memoize-one/dist/memoize-one.esm.js
var memoize_one_esm = __webpack_require__(30845);
;// CONCATENATED MODULE: ./node_modules/raf-schd/dist/raf-schd.esm.js
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ var raf_schd_esm = (rafSchd);

;// CONCATENATED MODULE: ./node_modules/react-beautiful-dnd/dist/react-beautiful-dnd.esm.js











var react_beautiful_dnd_esm_isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log(type, message) {
  var _console;

  if (react_beautiful_dnd_esm_isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var react_beautiful_dnd_esm_warning = log.bind(null, 'warn');
var error = log.bind(null, 'error');

function noop() {}

function getOptions(shared, fromBinding) {
  return (0,esm_extends/* default */.Z)({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = "production" === 'production';
var react_beautiful_dnd_esm_prefix = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function react_beautiful_dnd_esm_invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix);
  } else {
    throw new RbdInvariant(react_beautiful_dnd_esm_prefix + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  (0,inheritsLoose/* default */.Z)(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
         false ? 0 : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (false) {}
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (false) {}

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(react.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var react_beautiful_dnd_esm_noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var react_beautiful_dnd_esm_scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return (0,esm_extends/* default */.Z)({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = react_beautiful_dnd_esm_scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = (0,esm_extends/* default */.Z)({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = (0,esm_extends/* default */.Z)({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = (0,memoize_one_esm["default"])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = (0,memoize_one_esm["default"])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = (0,memoize_one_esm["default"])(function (droppables) {
  return values(droppables);
});
var toDraggableList = (0,memoize_one_esm["default"])(function (draggables) {
  return values(draggables);
});

var getDraggablesInsideDroppable = (0,memoize_one_esm["default"])(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = (0,memoize_one_esm["default"])(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return (0,esm_extends/* default */.Z)({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible((0,esm_extends/* default */.Z)({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = (0,esm_extends/* default */.Z)({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = (0,memoize_one_esm["default"])(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return (0,esm_extends/* default */.Z)({}, frame, {
    scroll: (0,esm_extends/* default */.Z)({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return (0,esm_extends/* default */.Z)({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return (0,esm_extends/* default */.Z)({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return (0,esm_extends/* default */.Z)({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = (0,esm_extends/* default */.Z)({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return (0,esm_extends/* default */.Z)({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start = function start(key) {
  if (false) {}
};
var finish = function finish(key) {
  if (false) {}
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = (0,esm_extends/* default */.Z)({}, draggable, {
    placeholder: (0,esm_extends/* default */.Z)({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = (0,esm_extends/* default */.Z)({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = (0,esm_extends/* default */.Z)({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = (0,esm_extends/* default */.Z)({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = (0,esm_extends/* default */.Z)({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return (0,esm_extends/* default */.Z)({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result = (0,esm_extends/* default */.Z)({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var updated = (0,esm_extends/* default */.Z)({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _updated = (0,esm_extends/* default */.Z)({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = (0,esm_extends/* default */.Z)({}, state.viewport, {
      scroll: (0,esm_extends/* default */.Z)({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return (0,esm_extends/* default */.Z)({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var newState = (0,esm_extends/* default */.Z)({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
   false ? 0 : void 0;
}

function validateDimensions(critical, dimensions) {
  if (false) { var insideDestination; }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        dispatch(flush());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = (0,esm_extends/* default */.Z)({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var react_beautiful_dnd_esm_getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(react_beautiful_dnd_esm_getWindowScroll());
  }

  var scheduled = raf_schd_esm(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop;

  function isActive() {
    return unbind !== noop;
  }

  function start() {
    !!isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? 0 : void 0;
      return;
    }

    if (isExpired) {
       false ? 0 : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = (0,esm_extends/* default */.Z)({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = (0,esm_extends/* default */.Z)({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var react_beautiful_dnd_esm_focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? 0 : compose;
var react_beautiful_dnd_esm_createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, react_beautiful_dnd_esm_focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = react_beautiful_dnd_esm_getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
     false ? 0 : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = (0,memoize_one_esm["default"])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? 0 : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = raf_schd_esm(scrollWindow);
  var scheduleDroppableScroll = raf_schd_esm(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start();
    !!dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var react_beautiful_dnd_esm_useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = use_memo_one_esm_useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = (0,react.useRef)(null);
  var dynamicRef = (0,react.useRef)(null);
  var setDynamicStyle = useCallback((0,memoize_one_esm["default"])(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    el.textContent = proposed;
  }, []);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = use_memo_one_esm_useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));

  if (!possible.length) {
     false ? 0 : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
     false ? 0 : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = (0,react.useRef)({});
  var recordRef = (0,react.useRef)(null);
  var restoreFocusFrameRef = (0,react.useRef)(null);
  var isMountedRef = (0,react.useRef)(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = use_memo_one_esm_useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = use_memo_one_esm_useMemo(createRegistry, []);
  (0,react.useEffect)(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = react.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = use_memo_one_esm_useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = (0,react.useRef)(null);
  (0,react.useEffect)(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    (0,esm_extends/* default */.Z)(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? 0 : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults = {
  separator: '::'
};
function react_beautiful_dnd_esm_reset() {
  count = 0;
}
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults;
  }

  return use_memo_one_esm_useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = use_memo_one_esm_useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  (0,react.useEffect)(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = react.createContext(null);

var peerDependencies = {
	react: "^16.8.5 || ^17.0.0 || ^18.0.0",
	"react-dom": "^16.8.5 || ^17.0.0 || ^18.0.0"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? 0 : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? 0 : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? 0 : void 0;
  }

  if (doctype.publicId !== '') {
     false ? 0 : void 0;
  }
});

function useDev(useHook) {
  if (false) {}
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    (0,react.useEffect)(function () {
      try {
        fn();
      } catch (e) {
        error("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, react.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = (0,react.useRef)(current);
  (0,react.useEffect)(function () {
    ref.current = current;
  });
  return ref;
}

function create() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var react_beautiful_dnd_esm_escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = (0,react.useRef)(idle$1);
  var unbindEventsRef = (0,react.useRef)(noop);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = (0,react.useRef)(noop$1);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === react_beautiful_dnd_esm_escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = (0,react.useRef)(idle$2);
  var unbindEventsRef = (0,react.useRef)(noop);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = use_memo_one_esm_useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
     false ? 0 : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
     false ? 0 : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
     false ? 0 : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
       false ? 0 : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
     false ? 0 : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
     false ? 0 : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return (0,esm_extends/* default */.Z)({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = raf_schd_esm(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return (0,esm_extends/* default */.Z)({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = (0,react.useState)(function () {
    return create();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = use_memo_one_esm_useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = (0,react.useRef)(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = use_memo_one_esm_useMemo(function () {
    return bindActionCreators({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = use_memo_one_esm_useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = use_memo_one_esm_useMemo(function () {
    return createAutoScroller((0,esm_extends/* default */.Z)({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = use_memo_one_esm_useMemo(function () {
    return react_beautiful_dnd_esm_createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (false) {}

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = use_memo_one_esm_useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = use_memo_one_esm_useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  (0,react.useEffect)(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return react.createElement(AppContext.Provider, {
    value: appContext
  }, react.createElement(components_Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function reset$1() {
  count$1 = 0;
}
function useInstanceCount() {
  return use_memo_one_esm_useMemo(function () {
    return "" + count$1++;
  }, []);
}

function resetServerContext() {
  reset$1();
  react_beautiful_dnd_esm_reset();
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return react.createElement(ErrorBoundary, null, function (setCallbacks) {
    return react.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1('scroll');
var isAuto = isEqual$1('auto');
var isVisible$1 = isEqual$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? 0 : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? 0 : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = (0,react.useContext)(Context);
  !result ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = (0,react.useRef)(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = use_memo_one_esm_useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = (0,react.useRef)(descriptor);
  var memoizedUpdateScroll = use_memo_one_esm_useMemo(function () {
    return (0,memoize_one_esm["default"])(function (x, y) {
      !whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = use_memo_one_esm_useMemo(function () {
    return raf_schd_esm(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {}
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = use_memo_one_esm_useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = use_memo_one_esm_useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
         false ? 0 : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2() {}

var empty = {
  width: 0,
  height: 0,
  margin: react_beautiful_dnd_esm_noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = (0,react.useRef)(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = (0,react.useState)(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  (0,react.useEffect)(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2;
    }

    if (animateOpenTimerRef.current) {
      return noop$2;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return react.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = react.memo(Placeholder);

var DroppableContext = react.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !(typeof props.droppableId === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.isCombineEnabled) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

   false ? 0 : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  (0,inheritsLoose/* default */.Z)(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(react.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = use_memo_one_esm_useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = use_memo_one_esm_useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = (0,react.useRef)(entry);
  var isFirstPublishRef = (0,react.useRef)(true);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  react_beautiful_dnd_esm_useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !(typeof id === 'string') ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    !isInteger(props.index) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = (0,react.useRef)(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = (0,react.useRef)(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = use_memo_one_esm_useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = use_memo_one_esm_useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = use_memo_one_esm_useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = use_memo_one_esm_useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = use_memo_one_esm_useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = (0,memoize_one_esm["default"])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = (0,memoize_one_esm["default"])(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = (0,memoize_one_esm["default"])(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = (0,memoize_one_esm["default"])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = (0,memoize_one_esm["default"])(getSecondarySnapshot);
  var getMemoizedProps = (0,memoize_one_esm["default"])(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var react_beautiful_dnd_esm_mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, react_beautiful_dnd_esm_mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return react.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return react.createElement(PrivateDraggable, (0,esm_extends/* default */.Z)({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = (0,react.useContext)(AppContext);
  !appContext ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = (0,react.useRef)(null);
  var placeholderRef = (0,react.useRef)(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = react.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return react.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = use_memo_one_esm_useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = use_memo_one_esm_useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = react.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return react_dom.createPortal(node, getContainerForClone());
  }

  return react.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = (0,esm_extends/* default */.Z)({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = (0,memoize_one_esm["default"])(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = (0,memoize_one_esm["default"])(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ?  false ? 0 : react_beautiful_dnd_esm_invariant(false) : void 0;
  return document.body;
}

var defaultProps = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;



// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Tooltip-00b73669.js
var Tooltip_00b73669 = __webpack_require__(20021);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./koba/components/Section/SectionToggle/index.ts + 1 modules
var SectionToggle = __webpack_require__(72019);
// EXTERNAL MODULE: ./schema/Section/queries.ts
var queries = __webpack_require__(47653);
// EXTERNAL MODULE: ./schema/Space/queries.ts
var Space_queries = __webpack_require__(73820);
// EXTERNAL MODULE: ./schema/Space/mutations.ts
var mutations = __webpack_require__(59252);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./helpers/spaceHelpers.ts
var spaceHelpers = __webpack_require__(68556);
;// CONCATENATED MODULE: ./components/CommunityActionsList/components/SpacePanel.tsx














var SpacePanel_cx = bind_default().bind((CommunityActionsList_module_default()));
var SpacePanel = function(param) {
    var handleClick = param.handleClick, isDragDisabled = param.isDragDisabled, index = param.index, space = param.space;
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var _query = router.query, communityId = _query.communityId, activeRoute = _query.spaceId;
    var featureFlags = (0,CommunityContext/* useCommunityContext */.v1)().featureFlags;
    var isExclusiveSpacesEnabled = featureFlags[constants_featureFlags/* features.EXCLUSIVE_SPACES */.R.EXCLUSIVE_SPACES];
    var ariaLabel = isDragDisabled ? t("Go to {{space}}", {
        space: space.name
    }) : t("Go to {{space}} or press space bar to reorder the Space", {
        space: space.name
    });
    var handleSpacePanelClick = function(event) {
        return handleClick(event, space.id, space.name);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PublicDraggable, {
        draggableId: space.id,
        index: index,
        isDragDisabled: isDragDisabled,
        children: function(provided, snapshot) {
            // eslint-disable-next-line jsx-a11y/no-redundant-roles
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, provided.draggableProps, provided.dragHandleProps), {
                "aria-label": ariaLabel,
                className: SpacePanel_cx("space__button", {
                    "space__button--dragging": snapshot.isDragging,
                    "is-active": activeRoute === space.id
                }),
                "data-qa": "space-button",
                href: "/communities/".concat(communityId, "/spaces/").concat(space.id),
                ref: provided.innerRef,
                role: "link" // overwrite the role that comes from provided.dragHandleProps
                ,
                title: space.name,
                onClick: handleSpacePanelClick,
                onKeyPress: handleSpacePanelClick,
                children: [
                    !isDragDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: SpacePanel_cx("space__drag", {
                            space__dragging: snapshot.isDragging
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "handle-drag"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: SpacePanel_cx("space__title"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: (0,spaceHelpers/* getIconNameByStoredValue */.i)(space === null || space === void 0 ? void 0 : space.iconName)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: space.name
                            })
                        ]
                    }),
                    isExclusiveSpacesEnabled && space.isExclusive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
                        className: SpacePanel_cx("space__tooltip"),
                        title: t("common-Exclusive_Space", "Exclusive Space"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            className: SpacePanel_cx("space__access-indicator"),
                            name: "lock"
                        })
                    })
                ]
            }));
        }
    }, space.id);
};
/* harmony default export */ var components_SpacePanel = (SpacePanel);

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/objectWithoutProperties-c7aad4d6.js
var objectWithoutProperties_c7aad4d6 = __webpack_require__(78776);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/defineProperty-1e8516b1.js
var defineProperty_1e8516b1 = __webpack_require__(11841);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/prop-shapes-ac9385ac.js
var prop_shapes_ac9385ac = __webpack_require__(10518);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/Skeleton-5884f47b.js
var Skeleton_5884f47b_filename = "/index.js";
var s={CIRCLE:"circular",RECTANGLE:"rectangular",TEXT:"text"};(0,prop_shapes_ac9385ac.s)('@-webkit-keyframes Skeleton_pulse__1{0%{opacity:1}50%{opacity:.4}to{opacity:1}}@keyframes Skeleton_pulse__1{0%{opacity:1}50%{opacity:.4}to{opacity:1}}.Skeleton_skeleton__10{display:block;height:1rem;background-color:rgba(0,0,0,.1);-webkit-animation:Skeleton_pulse__1 1.5s ease-in-out .5s infinite;animation:Skeleton_pulse__1 1.5s ease-in-out .5s infinite}@media (prefers-reduced-motion:reduce){.Skeleton_skeleton__10{-webkit-animation:none;animation:none}}.Skeleton_skeleton--text__19{height:auto;margin-top:0;margin-bottom:0;transform:scaleY(.7);transform-origin:center;border-radius:4px}.Skeleton_skeleton--text__19:empty:before{content:"\\A0"}.Skeleton_skeleton--circular__29{border-radius:50%}.Skeleton_skeleton--no-animation__32{-webkit-animation:none;animation:none}.Skeleton_skeleton--has-children__35>*{visibility:hidden}.Skeleton_skeleton--fit-content__38{max-width:-webkit-fit-content;max-width:-moz-fit-content;max-width:fit-content}.Skeleton_skeleton--auto-height__41{height:auto}',{insertAt:"top"});var c=["noAnimation","className","component","height","style","variant","width","children"];function _(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,o)}return n}function k(e){for(var t=1;t<arguments.length;t++){var o=null!=arguments[t]?arguments[t]:{};t%2?_(Object(o),!0).forEach((function(t){(0,defineProperty_1e8516b1._)(e,t,o[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(o)):_(Object(o)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(o,t))}))}return e}var p=prop_shapes_ac9385ac.b.bind({skeleton:"Skeleton_skeleton__10",pulse:"Skeleton_pulse__1","skeleton--text":"Skeleton_skeleton--text__19","skeleton--circular":"Skeleton_skeleton--circular__29","skeleton--no-animation":"Skeleton_skeleton--no-animation__32","skeleton--has-children":"Skeleton_skeleton--has-children__35","skeleton--fit-content":"Skeleton_skeleton--fit-content__38","skeleton--auto-height":"Skeleton_skeleton--auto-height__41"}),m=function(n){var i=n.noAnimation,a=n.className,r=n.component,l=void 0===r?"span":r,s=n.height,_=n.style,m=n.variant,h=n.width,u=n.children,f=(0,objectWithoutProperties_c7aad4d6._)(n,c),d=!!u;return react.createElement(l,(0,objectWithoutProperties_c7aad4d6.a)({className:p("skeleton","skeleton--".concat(m),{"skeleton--no-animation":i,"skeleton--has-children":d,"skeleton--fit-content":d&&!h,"skeleton--auto-height":d&&!s},a)},f,{style:k({width:h,height:s},_)}),u)};m.propTypes={children:(prop_types_default()).node,className:prop_shapes_ac9385ac.c,component:(prop_types_default()).elementType,height:prop_types_default().oneOfType([(prop_types_default()).number,(prop_types_default()).string]),noAnimation:(prop_types_default()).bool,style:(prop_types_default()).object,variant:prop_types_default().oneOf([s.CIRCLE,s.RECTANGLE,s.TEXT]),width:prop_types_default().oneOfType([(prop_types_default()).number,(prop_types_default()).string])},m.defaultProps={children:null,height:null,width:null,style:null,component:"span",className:null,noAnimation:!1,variant:s.RECTANGLE},m.displayName="Skeleton",m.filename=Skeleton_5884f47b_filename;var h=m;
//# sourceMappingURL=Skeleton-5884f47b.js.map

// EXTERNAL MODULE: ./components/CommunityActionsList/components/SkeletonSpacesList.module.scss
var SkeletonSpacesList_module = __webpack_require__(80390);
var SkeletonSpacesList_module_default = /*#__PURE__*/__webpack_require__.n(SkeletonSpacesList_module);
;// CONCATENATED MODULE: ./components/CommunityActionsList/components/SkeletonSpacesList.tsx





var SkeletonSpacesList_cx = bind_default().bind((SkeletonSpacesList_module_default()));
var SkeletonSpacesList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: SkeletonSpacesList_cx("spaces-list-skeleton__content"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(h, {
                height: "12px",
                width: "40%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(h, {
                height: "8px",
                width: "80%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(h, {
                height: "8px",
                width: "80%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(h, {
                height: "8px",
                width: "80%"
            })
        ]
    });
};
/* harmony default export */ var components_SkeletonSpacesList = (SkeletonSpacesList);

;// CONCATENATED MODULE: ./components/CommunityActionsList/components/SpacesList.tsx






























var SpacesList_cx = bind_default().bind((CommunityActionsList_module_default()));
var SpacesList = function(param) {
    var handleMobileNavClick = param.handleMobileNavClick;
    var ref, ref1, ref2;
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var t = (0,es/* useTranslation */.$G)().t;
    var ref3 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref3.community, currentUser = ref3.currentUser, featureFlags = ref3.featureFlags, trackEvent = ref3.trackEvent;
    var router = (0,next_router.useRouter)();
    var isCoursesToCommunitiesEnabled = !!featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var ref4 = (0,react.useState)([]), spaceList = ref4[0], setSpaceList = ref4[1];
    var isDragEnabled = (0,userHelpers/* canAccess */.WL)([
        constants/* USER_ROLES.SITE_OWNER_SITE_ADMIN */.pR.SITE_OWNER_SITE_ADMIN,
        constants/* USER_ROLES.SITE_ADMIN */.pR.SITE_ADMIN,
        constants/* USER_ROLES.PARTNER */.pR.PARTNER, 
    ], currentUser);
    var handleClick = function(event, filter, name) {
        event.preventDefault();
        if (handleMobileNavClick) handleMobileNavClick();
        var _obj;
        trackEvent(trackingEvents/* default.SPACE_CLICKED */.ZP.SPACE_CLICKED, (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.COMMUNITY_ID */.Ku.COMMUNITY_ID, (0,rawId/* rawId */.b)(community.id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.SPACE_ID */.Ku.SPACE_ID, (0,rawId/* rawId */.b)(filter)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.SPACE_NAME */.Ku.SPACE_NAME, name), _obj));
        (0,routerHelpers/* goToSpaces */.ZY)(router, filter, community.id);
    };
    var ref5 = (0,useQuery/* useQuery */.a)(queries/* SECTION_QUERY */.z, {
        variables: {
            communityId: community.id,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        },
        notifyOnNetworkStatusChange: true,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), loading = ref5.loading, data = ref5.data, error = ref5.error;
    (0,react.useEffect)(function() {
        if (data) {
            var ref, ref1, ref2;
            var spaces = [];
            data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : (ref1 = ref.communitySections) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(section) {
                var ref, ref1, ref2;
                section === null || section === void 0 ? void 0 : (ref = section.node) === null || ref === void 0 ? void 0 : (ref1 = ref.communitySpaces) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.forEach(function(space) {
                    var ref, ref1;
                    // Performance Improvement
                    // Since the SectionList query fetches all of the data required for the CommunitySpace query,
                    // we can preload the apollo cache with that data. Any subsequent CommunitySpace query will
                    // come from the cache instead of the server.
                    client.writeQuery({
                        query: Space_queries/* SPACE_QUERY */.y,
                        data: {
                            community: {
                                __typename: "Community",
                                id: community.id,
                                communitySpace: space.node
                            }
                        },
                        variables: {
                            spaceId: space.node.id,
                            communityId: community.id,
                            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
                        }
                    });
                    spaces.push({
                        id: space.node.id,
                        name: space.node.name,
                        iconName: (ref = space.node) === null || ref === void 0 ? void 0 : ref.iconName,
                        isExclusive: (ref1 = space.node) === null || ref1 === void 0 ? void 0 : ref1.isExclusive
                    });
                });
            });
            setSpaceList(spaces);
        }
    }, [
        data
    ]);
    var spaceGroups = [];
    if (data === null || data === void 0 ? void 0 : data.community) {
        var ref6, ref7;
        spaceGroups = (ref6 = data.community) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.communitySections) === null || ref7 === void 0 ? void 0 : ref7.edges;
    }
    var hasError = !!((error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.length) || (data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.userErrors) === null || ref2 === void 0 ? void 0 : ref2.length));
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(mutations/* REORDER_SPACE_MUTATION */.td, {
        onError: toastHelpers/* genericToastAlert */.d9
    }), 2), reorderSpaceMutation = ref8[0], ref9 = ref8[1], reorderLoading = ref9.loading;
    var onDragStart = function(start, provided) {
        provided.announce(t("components-communityActionsList-space_drag_start_sr_message", "You have lifted the Space in position {{position}}. Use the arrows up and down to move the Space to a new position. Once you moved it to the desired position press the space bar to release the Space to its new position.", {
            position: start.source.index + 1
        }));
    };
    var onDragUpdate = function(update, provided) {
        var message = update.destination ? t("components-communityActionsList-space_drag_update_sr_message", "You have moved the Space to position {{position}}. If this is the final position press the space bar to release it to this position.", {
            position: update.destination.index + 1
        }) : t("You are currently not over a droppable area");
        provided.announce(message);
    };
    var onDragEnd = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(result, provided) {
            var _spaces, ref, destination, source, draggableId, message, originalSpaces, spaces, ref1, reorderSpaceData, errors;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        ;
                        destination = result.destination, source = result.source, draggableId = result.draggableId;
                        message = destination ? t("You have moved the Space from position {{from}} to {{to}}", {
                            from: source.index + 1,
                            to: destination.index + 1
                        }) : t("The Space has been returned to its starting position of {{position}}", {
                            position: source.index + 1
                        });
                        provided.announce(message);
                        if (!(!destination || destination.droppableId === source.droppableId && destination.index === source.index)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        originalSpaces = (0,_to_consumable_array/* default */.Z)(spaceList);
                        spaces = (0,_to_consumable_array/* default */.Z)(spaceList);
                        (_spaces = spaces).splice.apply(_spaces, [
                            destination.index,
                            0
                        ].concat((0,_to_consumable_array/* default */.Z)(spaces.splice(source.index, 1))));
                        setSpaceList((0,_to_consumable_array/* default */.Z)(spaces));
                        _ctx.next = 13;
                        return reorderSpaceMutation({
                            variables: {
                                input: {
                                    id: draggableId,
                                    position: destination.index
                                }
                            },
                            refetchQueries: [
                                {
                                    query: queries/* SECTION_QUERY */.z,
                                    variables: {
                                        communityId: community.id,
                                        isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
                                    }
                                }, 
                            ]
                        });
                    case 13:
                        ref1 = _ctx.sent;
                        reorderSpaceData = ref1.data;
                        errors = ref1.errors;
                        if ((errors === null || errors === void 0 ? void 0 : errors.length) || (reorderSpaceData === null || reorderSpaceData === void 0 ? void 0 : (ref = reorderSpaceData.reorderCommunitySpace) === null || ref === void 0 ? void 0 : ref.userErrors)) {
                            (0,toastHelpers/* genericToastAlert */.d9)();
                            setSpaceList((0,_to_consumable_array/* default */.Z)(originalSpaces));
                        }
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onDragEnd(result, provided) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreateSpaceClick = function() {
        if (handleMobileNavClick) handleMobileNavClick();
        trackEvent(trackingEvents/* default.GO_TO_NEW_SPACE */.ZP.GO_TO_NEW_SPACE, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "SpacesList"));
        (0,routerHelpers/* goToNewSpace */.uq)(router, community.id);
    };
    var AddSpaceButton = (0,userHelpers/* canAccess */.WL)([
        constants/* USER_ROLES.SITE_OWNER_SITE_ADMIN */.pR.SITE_OWNER_SITE_ADMIN,
        constants/* USER_ROLES.SITE_ADMIN */.pR.SITE_ADMIN,
        constants/* USER_ROLES.PARTNER */.pR.PARTNER, 
    ], currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_00b73669.T, {
        role: "presentation",
        title: t("Create Space"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
            appearance: "utility",
            "aria-label": t("Add new Space"),
            className: SpacesList_cx("add-space__button"),
            "data-qa": "main-create-space__button",
            name: "plus",
            title: t("Add new Space"),
            onClick: handleCreateSpaceClick
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (hasError || loading) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SkeletonSpacesList, {}),
            !hasError && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: SpacesList_cx("spaces-list__wrapper"),
                "data-qa": isDragEnabled ? "spaces-list__wrapper--draggable" : "spaces-list__wrapper",
                children: spaceGroups === null || spaceGroups === void 0 ? void 0 : spaceGroups.map(function(param) {
                    var spaceGroup = param.node;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionToggle/* SectionToggle */.K, {
                        caretType: "fill",
                        rightAccessory: AddSpaceButton,
                        t: t,
                        title: t("SPACES"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DragDropContext, {
                            onDragEnd: onDragEnd,
                            onDragStart: onDragStart,
                            onDragUpdate: onDragUpdate,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedDroppable, {
                                droppableId: spaceGroup.id,
                                children: function(provided) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        ref: provided.innerRef
                                    }, provided.droppableProps), {
                                        children: [
                                            spaceList.map(function(space, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpacePanel, {
                                                    handleClick: handleClick,
                                                    index: index,
                                                    isDragDisabled: !isDragEnabled || reorderLoading,
                                                    space: space
                                                }, space.id);
                                            }),
                                            provided.placeholder
                                        ]
                                    }));
                                }
                            })
                        })
                    }, spaceGroup.id);
                })
            })
        ]
    });
};
/* harmony default export */ var components_SpacesList = (SpacesList);

;// CONCATENATED MODULE: ./components/CommunityActionsList/CommunityActionsList.tsx














var CommunityActionsList_cx = bind_default().bind((CommunityActionsList_module_default()));
var CommunityActionsList = function(param) {
    var handleMobileNavClick = param.handleMobileNavClick;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var router = (0,next_router.useRouter)();
    var handleCreateSpaceClick = function(e) {
        e.preventDefault();
        if (handleMobileNavClick) handleMobileNavClick();
        trackEvent(trackingEvents/* default.GO_TO_NEW_SPACE */.ZP.GO_TO_NEW_SPACE, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "CommunityActionsList"));
        (0,routerHelpers/* goToNewSpace */.uq)(router, community.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: CommunityActionsList_cx("community-actions-list__wrapper"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            className: CommunityActionsList_cx("community-actions-list"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CommonActions, {
                    handleMobileNavClick: handleMobileNavClick
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpacesList, {
                    handleMobileNavClick: handleMobileNavClick
                }),
                (0,userHelpers/* isAdmin */.GJ)(currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                    appearance: "knockout",
                    className: CommunityActionsList_cx("community-actions-list__create-space"),
                    "data-qa": "community-actions-list__create-space",
                    href: "/communities/".concat(community.id, "/spaces/new"),
                    type: "button",
                    onClick: handleCreateSpaceClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                            name: "plus",
                            "aria-hidden": true
                        }),
                        t("common-CREATE_SPACE", "CREATE SPACE")
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var CommunityActionsList_CommunityActionsList = (CommunityActionsList);

;// CONCATENATED MODULE: ./components/CommunityActionsList/index.ts


// EXTERNAL MODULE: ./components/CommunityActions/CommunityActions.module.scss
var CommunityActions_module = __webpack_require__(19150);
var CommunityActions_module_default = /*#__PURE__*/__webpack_require__.n(CommunityActions_module);
;// CONCATENATED MODULE: ./components/CommunityActions/CommunityActions.tsx





var CommunityActions_cx = bind_default().bind((CommunityActions_module_default()));
var CommunityActions = function(param) {
    var handleMobileNavClick = param.handleMobileNavClick, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: CommunityActions_cx("community-actions__wrapper", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityActionsList_CommunityActionsList, {
            handleMobileNavClick: handleMobileNavClick
        })
    });
};
/* harmony default export */ var CommunityActions_CommunityActions = (CommunityActions);

;// CONCATENATED MODULE: ./components/CommunityActions/index.ts



/***/ }),

/***/ 9973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gR": function() { return /* binding */ CommunityProvider; },
  "v1": function() { return /* binding */ useCommunityContext; }
});

// UNUSED EXPORTS: CommunityContext, getTenantGA, initializeGoogleAnalytics

// NAMESPACE OBJECT: ./node_modules/react-ga/dist/esm/core.js
var core_namespaceObject = {};
__webpack_require__.r(core_namespaceObject);
__webpack_require__.d(core_namespaceObject, {
  "addTrackers": function() { return addTrackers; },
  "default": function() { return core; },
  "event": function() { return core_event; },
  "exception": function() { return exception; },
  "ga": function() { return ga; },
  "initialize": function() { return initialize; },
  "modalview": function() { return modalview; },
  "outboundLink": function() { return outboundLink; },
  "pageview": function() { return pageview; },
  "plugin": function() { return core_plugin; },
  "send": function() { return send; },
  "set": function() { return set; },
  "testModeAPI": function() { return core_testModeAPI; },
  "timing": function() { return timing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./utils/queries.ts
var queries = __webpack_require__(57917);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/FacebookPixelScript/FacebookPixelScript.tsx




/* eslint-disable react/no-danger */ var FacebookPixelScript = function(param) {
    var id = param.id;
    var scriptSrc = "!function(f,b,e,v,n,t,s)\n    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n    n.callMethod.apply(n,arguments):n.queue.push(arguments)};\n    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';\n    n.queue=[];t=b.createElement(e);t.async=!0;\n    t.src=v;s=b.getElementsByTagName(e)[0];\n    s.parentNode.insertBefore(t,s)}(window, document,'script',\n    'https://connect.facebook.net/en_US/fbevents.js');\n    fbq('init', '".concat(id, "');\n    fbq('track', 'PageView');");
    var noscriptSrc = '<img alt="" height="1" width="1" style="display:none"\n    src="https://www.facebook.com/tr?id='.concat(id, '\n    &ev=PageView&noscript=1" />');
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: scriptSrc
                },
                type: "text/javascript"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                dangerouslySetInnerHTML: {
                    __html: noscriptSrc
                }
            })
        ]
    });
};
FacebookPixelScript.propTypes = {
    id: (prop_types_default()).number.isRequired
};
/* harmony default export */ var FacebookPixelScript_FacebookPixelScript = (FacebookPixelScript);

;// CONCATENATED MODULE: ./components/FacebookPixelScript/index.ts


;// CONCATENATED MODULE: ./components/FontProvider.tsx




var FONTS = [
    "Source Sans Pro",
    "Droid Serif",
    "Lato",
    "Montserrat",
    "Open Sans",
    "Raleway", 
];
var FontProvider = function(param) {
    var font = param.font;
    var fontFamily = FONTS[0];
    if (FONTS.includes(font)) {
        fontFamily = font;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "https://fonts.googleapis.com/css?family=".concat(encodeURI(fontFamily), ":300,400,600,700"),
                rel: "stylesheet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                children: "body, input, button, textarea, .emoji-mart { font-family: ".concat(fontFamily, "; }")
            })
        ]
    });
};
FontProvider.propTypes = {
    font: prop_types_default().oneOf(FONTS).isRequired
};
/* harmony default export */ var components_FontProvider = (FontProvider);

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/themeContext-ac5c7f19.js
var themeContext_ac5c7f19 = __webpack_require__(55029);
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/console/warn.js
function warn(s) {
  console.warn('[react-ga]', s);
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/components/OutboundLink.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _excluded = ["to", "target"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink = /*#__PURE__*/function (_Component) {
  _inherits(OutboundLink, _Component);

  var _super = _createSuper(OutboundLink);

  function OutboundLink() {
    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          target = _this$props2.target,
          oldProps = _objectWithoutProperties(_this$props2, _excluded);

      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
        target: target,
        href: href,
        onClick: this.handleClick
      });

      if (target === NEWTAB) {
        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return /*#__PURE__*/react.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(react.Component);

_defineProperty(OutboundLink, "trackLink", function () {
  warn('ga tracking not enabled');
});


OutboundLink.propTypes = {
  eventLabel: (prop_types_default()).string.isRequired,
  target: (prop_types_default()).string,
  to: (prop_types_default()).string,
  onClick: (prop_types_default()).func,
  trackerNames: prop_types_default().arrayOf((prop_types_default()).string)
};
OutboundLink.defaultProps = {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
};
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/mightBeEmail.js
// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/redactEmail.js


var redacted = 'REDACTED (Potential Email Address)';
function redactEmail(string) {
  if (mightBeEmail(string)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  return string;
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/trim.js
// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s && s.toString().replace(/^\s+|\s+$/g, '');
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/toTitleCase.js
/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */

var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test

function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/format.js


function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || '';

  if (titleCase) {
    _str = toTitleCase(s);
  }

  if (redactingEmail) {
    _str = redactEmail(_str);
  }

  return _str;
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/removeLeadingSlash.js
function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/loadGA.js
var isLoaded = false;
/* harmony default export */ function loadGA(options) {
  if (isLoaded) return;
  isLoaded = true;
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  }

  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */

  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    a.onerror = onerror;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/console/log.js
function log(s) {
  console.info('[react-ga]', s);
}
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/utils/testModeAPI.js
var gaCalls = [];
/* harmony default export */ var testModeAPI = ({
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
});
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/core.js
var core_excluded = ["category", "action", "label", "value", "nonInteraction", "transport"];

function core_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = core_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function core_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function core_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function core_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? core_ownKeys(Object(source), !0).forEach(function (key) { core_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : core_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function core_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function core_typeof(obj) { "@babel/helpers - typeof"; return core_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, core_typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * React Google Analytics Module
 *
 * @package react-ga
 * @author  Adam Lofting <adam@mozillafoundation.org>
 *          Atul Varma <atul@mozillafoundation.org>
 */

/**
 * Utilities
 */








var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;
var _redactEmail = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return testModeAPI.ga.apply(testModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase, _redactEmail);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.redactEmail === false) {
      _redactEmail = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function addTrackers(configsOrTrackingId, options) {
  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (core_typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
  addTrackers(configsOrTrackingId, options);
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      log("called ga('arguments');");
      log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (core_typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log("called ga('set', fieldsObject);");
    log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log("called ga('send', fieldObject);");
    log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', core_objectSpread({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log("called ga('send', 'pageview', path);");
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log("called ga('send', 'pageview', path);");
      log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
 */

function core_event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = core_objectWithoutProperties(_ref2, core_excluded);

  var trackerNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var core_plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (core_typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
      args[_key3 - 2] = arguments[_key3];
    }

    if (args.length === 1) {
      payload = args[0];
    } else {
      actionType = args[0];
      payload = args[1];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var core_testModeAPI = testModeAPI;
/* harmony default export */ var core = ({
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: core_event,
  exception: exception,
  plugin: core_plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI
});
;// CONCATENATED MODULE: ./node_modules/react-ga/dist/esm/index.js
function esm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function esm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? esm_ownKeys(Object(source), !0).forEach(function (key) { esm_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : esm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function esm_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var esm_initialize = initialize;

var esm_addTrackers = addTrackers;

var esm_ga = ga;

var esm_set = set;

var esm_send = send;

var esm_pageview = pageview;

var esm_modalview = modalview;

var esm_timing = timing;

var esm_event = core_event;

var esm_exception = exception;

var esm_plugin = core_plugin;

var esm_outboundLink = outboundLink;

var esm_testModeAPI = core_testModeAPI;

OutboundLink.origTrackLink = OutboundLink.trackLink;
OutboundLink.trackLink = outboundLink;
var esm_OutboundLink = OutboundLink;
/* harmony default export */ var esm = (esm_objectSpread(esm_objectSpread({}, core_namespaceObject), {}, {
  OutboundLink: esm_OutboundLink
}));
// EXTERNAL MODULE: ./node_modules/react-ga4/dist/index.js
var dist = __webpack_require__(49089);
;// CONCATENATED MODULE: ./utils/featureFlags.ts
var initializeFeatureFlags = function(features) {
    var flags = {};
    for(var i = 0; i < (features === null || features === void 0 ? void 0 : features.length); i += 1){
        var currentFeature = features[i];
        if (currentFeature.length) {
            var key = currentFeature[0].toLowerCase();
            var isEnabled = typeof currentFeature[1] === "boolean" ? currentFeature[1] : false;
            /**
       * Lab Experiments - Overrides feature toggle
       * More details see past history of this file
       */ // switch (key) {
            //   case featureNames.COMMUNITIES_REPLIES_TO_COMMENTS:
            //     isEnabled = labFeatures?.reply_to_comments ? labFeatures.reply_to_comments?.isEnabled : isEnabled;
            //     break;
            // }
            flags[key] = isEnabled;
        } else {
            // eslint-disable-next-line no-console
            console.warn("Feature missing key or enabled value", currentFeature);
        }
    }
    return flags;
};

// EXTERNAL MODULE: ./utils/colors.ts
var colors = __webpack_require__(82083);
// EXTERNAL MODULE: ./components/PageSkeleton/index.ts + 1 modules
var PageSkeleton = __webpack_require__(62185);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/CommunityContext.tsx















// Right now the toga definitions are created automatically
// and they don't cover context providers
// @ts-ignore









var THINKIFIC_TRACKER_NAME = "thinkificGA";
var TENANT_TRACKER_NAME = "tenantGA";
var CommunityContext = /*#__PURE__*/ react.createContext({});
var useCommunityContext = function() {
    return (0,react.useContext)(CommunityContext);
};
// initializes thinkific's and tenant's GA (if provided)
var initializeGoogleAnalytics = function(tenantGAKey) {
    var tenantGA = getTenantGA(tenantGAKey);
    esm.initialize([
        {
            trackingId: "UA-30557184-1" || 0,
            gaOptions: {
                name: THINKIFIC_TRACKER_NAME
            }
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(tenantGA)));
    esm.pageview("communities", [
        THINKIFIC_TRACKER_NAME, 
    ].concat((0,_to_consumable_array/* default */.Z)(tenantGAKey ? [
        TENANT_TRACKER_NAME
    ] : [])));
};
var initializeGoogleAnalytics4 = function(tenantGAMeasurementId) {
    dist/* default.initialize */.ZP.initialize(tenantGAMeasurementId);
    dist/* default.send */.ZP.send("pageview");
};
var getTenantGA = function(tenantGAKey) {
    return tenantGAKey ? [
        {
            trackingId: tenantGAKey,
            gaOptions: {
                name: TENANT_TRACKER_NAME
            }
        }, 
    ] : [];
};
var CommunityProvider = function(param) {
    var children = param.children, communityId = param.communityId;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(), thinkificAnalytics = ref3[0], setThinkificAnalytics = ref3[1];
    var ref4 = (0,useQuery/* useQuery */.a)(queries/* MAIN_QUERY */.s9, {
        variables: {
            communityId: communityId
        }
    }), loading = ref4.loading, data = ref4.data;
    var ref5 = data || {}, site = ref5.site, community = ref5.community, currentUser = ref5.me;
    var mentionableUsers = data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : ref.mentionableUsers;
    var communityUsers = data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : ref1.communityUsers;
    var ref6 = site || {}, filestackSecurity = ref6.filestackPolicy;
    var featureFlags = site && site.featureFlags ? initializeFeatureFlags(site.featureFlags) : {};
    (0,react.useEffect)(function() {
        if (site && "production" === "production") {
            initializeGoogleAnalytics(site.googleAnalyticsKey);
        }
    }, [
        site && site.googleAnalyticsKey
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((site === null || site === void 0 ? void 0 : (ref = site.integrations) === null || ref === void 0 ? void 0 : ref.gaMeasurementId) && "production" === "production") {
            initializeGoogleAnalytics4(site.integrations.gaMeasurementId);
        }
    }, [
        site === null || site === void 0 ? void 0 : (ref2 = site.integrations) === null || ref2 === void 0 ? void 0 : ref2.gaMeasurementId
    ]);
    (0,react.useEffect)(function() {
        var loadAnalytics = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var getThinkificAnalytics, analytics;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return Promise.all(/* import() */[__webpack_require__.e(4955), __webpack_require__.e(6451)]).then(__webpack_require__.bind(__webpack_require__, 26451));
                        case 2:
                            getThinkificAnalytics = _ctx.sent.default;
                            analytics = getThinkificAnalytics("e9f85a260e22673665c335ea07907e45", site.trackingKey);
                            setThinkificAnalytics(analytics);
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadAnalytics() {
                return _ref.apply(this, arguments);
            };
        }();
        if (site && !thinkificAnalytics && featureFlags[constants_featureFlags/* features.STUDENT_EVENT_TRACKING */.R.STUDENT_EVENT_TRACKING]) {
            if (true) {
                loadAnalytics();
            } else {}
        }
    }, [
        site
    ]);
    (0,react.useEffect)(function() {
        if (currentUser && currentUser.locale) {
            document.getElementsByTagName("html")[0].setAttribute("lang", currentUser.locale);
        }
    }, [
        currentUser
    ]);
    if (loading || !data) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSkeleton/* default */.Z, {});
    }
    var trackEvent = function(event, eventProperties) {
        var ref;
        if (!thinkificAnalytics) {
            return null;
        }
        var SITE_ADMIN = constants/* EVENT_USER_ROLES.SITE_ADMIN */.YV.SITE_ADMIN, COMMUNITY_MODERATOR = constants/* EVENT_USER_ROLES.COMMUNITY_MODERATOR */.YV.COMMUNITY_MODERATOR, STUDENT = constants/* EVENT_USER_ROLES.STUDENT */.YV.STUDENT;
        var userRole;
        if ((0,userHelpers/* isSiteAdmin */.$1)(currentUser.roles)) {
            userRole = SITE_ADMIN;
        } else if ((0,userHelpers/* isModerator */.vJ)(currentUser.permissions)) {
            userRole = COMMUNITY_MODERATOR;
        } else {
            userRole = currentUser.roles.join(", ");
        }
        var _obj;
        var baseProperties = (_obj = {}, (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.COMMUNITY_ID */.Ku.COMMUNITY_ID, (0,rawId/* rawId */.b)(communityId)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.COMMUNITY_ID_ENCODED */.Ku.COMMUNITY_ID_ENCODED, communityId), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.COMMUNITY_NAME */.Ku.COMMUNITY_NAME, community.name), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.TENANT_ID */.Ku.TENANT_ID, (0,rawId/* rawId */.b)(site.id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.TENANT_ID_ENCODED */.Ku.TENANT_ID_ENCODED, site.id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.USER_ID */.Ku.USER_ID, (0,rawId/* rawId */.b)(currentUser.id)), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.USER_ID_ENCODED */.Ku.USER_ID_ENCODED, currentUser.id), (0,_define_property/* default */.Z)(_obj, trackingEvents/* TrackingProperty.USER_ROLE */.Ku.USER_ROLE, userRole || STUDENT), _obj);
        var spaceId = (0,rawId/* rawId */.b)(router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.spaceId);
        if (spaceId) {
            baseProperties[trackingEvents/* TrackingProperty.SPACE_ID */.Ku.SPACE_ID] = spaceId;
        }
        return thinkificAnalytics.track(event, (0,_object_spread/* default */.Z)({}, baseProperties, eventProperties));
    };
    var facebookPixelCode = site.integrations.facebookPixelCode || "";
    // Extract the Facebook Pixel ID from the script
    var matchResult = facebookPixelCode.match(/fbq\('init', '([0-9]+)'\)/) || "";
    var facebookPixelId = matchResult.length === 2 ? Number(matchResult[1]) : null;
    var theme = {
        color: {
        },
        button: {
            allCaps: false
        },
        loader: {
            color: (0,colors/* isTextDark */.aS)(community === null || community === void 0 ? void 0 : community.primaryColor) ? "black" : "white"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityContext.Provider, {
        value: {
            site: site,
            community: community,
            communityUsers: communityUsers,
            mentionableUsers: mentionableUsers,
            currentUser: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentUser), {
                isModerator: (0,userHelpers/* isModerator */.vJ)(currentUser.permissions),
                isSiteAdmin: (0,userHelpers/* isSiteAdmin */.$1)(currentUser.roles)
            }),
            trackEvent: trackEvent,
            filestackSecurity: filestackSecurity,
            featureFlags: featureFlags
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(themeContext_ac5c7f19.T.Provider, {
            value: theme,
            children: [
                facebookPixelId && /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookPixelScript_FacebookPixelScript, {
                    id: facebookPixelId
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FontProvider, {
                    font: community.font
                }),
                children
            ]
        })
    });
};



/***/ }),

/***/ 83622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20021);
/* harmony import */ var components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82957);
/* harmony import */ var _CommunityUsersAvatars_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84945);
/* harmony import */ var _CommunityUsersAvatars_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_CommunityUsersAvatars_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_CommunityUsersAvatars_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var CommunityUsersAvatars = function(param) {
    var className = param.className, _text = param.text, text = _text === void 0 ? "" : _text, tooltipTitle = param.tooltipTitle, totalUsers = param.totalUsers, users = param.users;
    if (!users) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("community-users__wrapper", "mb-4", className),
        children: [
            users === null || users === void 0 ? void 0 : users.map(function(user, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: cx("community-users__avatar-container"),
                    style: {
                        zIndex: Math.abs(index - users.length)
                    },
                    "aria-hidden": true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__.T, {
                        enterTouchDelay: 0,
                        title: user.fullName,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_UserAvatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            avatarUrl: user.profile.avatarUrl,
                            className: cx("community-users__avatar"),
                            size: "xs",
                            srcSet: "".concat(user.profile.avatarUrl, "?width=40 1x, ").concat(user.profile.avatarUrl, "?width=40&dpr=2 2x, ").concat(user.profile.avatarUrl, "?width=40&dpr=3 3x"),
                            userId: user.id,
                            username: user.fullName || ""
                        })
                    })
                }, user.id);
            }),
            totalUsers > (users === null || users === void 0 ? void 0 : users.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__.T, {
                enterTouchDelay: 0,
                title: tooltipTitle,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: cx("community-users__total"),
                    "data-qa": "community-users__total",
                    "aria-hidden": true,
                    children: [
                        "+",
                        totalUsers - (users === null || users === void 0 ? void 0 : users.length),
                        " ",
                        text
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "sr-only",
                children: tooltipTitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityUsersAvatars);


/***/ }),

/***/ 72549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var koba_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99438);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);
/* harmony import */ var components_SpaceDetails__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19024);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9973);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89131);
/* harmony import */ var utils_rawId__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93593);









var CourseCard = function(param) {
    var className = param.className, percentageCompleted = param.percentageCompleted, courseURL = param.courseURL, dataQA = param.dataQA, description = param.description, imageUrl = param.imageUrl, name = param.name, productId = param.productId;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_5__/* .useCommunityContext */ .v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var courseLinkText = t("RESUME COURSE");
    if (percentageCompleted === 0) {
        courseLinkText = t("START COURSE");
    } else if (percentageCompleted === 1) {
        courseLinkText = t("REPLAY COURSE");
    } else if (percentageCompleted === null) {
        courseLinkText = t("PREVIEW COURSE");
    }
    var onClick = function() {
        var _obj;
        trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* ["default"].GO_TO_COURSE_FROM_COMMUNITY */ .ZP.GO_TO_COURSE_FROM_COMMUNITY, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* .TrackingProperty.PRODUCT_ID */ .Ku.PRODUCT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_8__/* .rawId */ .b)(productId || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* .TrackingProperty.PRODUCT_TYPE */ .Ku.PRODUCT_TYPE, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* .ProductTypes.COURSE */ .V7.COURSE), _obj));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SpaceDetails__WEBPACK_IMPORTED_MODULE_4__/* .SpaceDetailsCard */ .a, {
        className: className,
        dataQA: dataQA,
        description: description,
        footerAccessory: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
            appearance: "default",
            color: community.primaryColor,
            dataQA: "course-card__access-course",
            href: courseURL,
            rel: "noopener",
            onClick: courseURL ? onClick : undefined,
            children: courseLinkText
        }),
        imageUrl: imageUrl,
        name: name,
        renderDescriptionAsHTML: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCard);


/***/ }),

/***/ 58664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64828);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42990);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1798);
/* harmony import */ var pubsub_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pubsub_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var constants_eventNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81340);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89131);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9973);
/* harmony import */ var _CourseCardPlaceholder_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9484);
/* harmony import */ var _CourseCardPlaceholder_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_CourseCardPlaceholder_module_scss__WEBPACK_IMPORTED_MODULE_8__);











var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_CourseCardPlaceholder_module_scss__WEBPACK_IMPORTED_MODULE_8___default()));
var CourseCardPlaceholder = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var trackEvent = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__/* .useCommunityContext */ .v1)().trackEvent;
    var handleClick = function() {
        pubsub_js__WEBPACK_IMPORTED_MODULE_4___default().publish(constants_eventNames__WEBPACK_IMPORTED_MODULE_5__/* .eventNames.OPEN_SELECT_COURSE_MODAL */ .S.OPEN_SELECT_COURSE_MODAL);
        trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* ["default"].CLICK_ADD_COURSE_TO_SPACE */ .ZP.CLICK_ADD_COURSE_TO_SPACE, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_6__/* .TrackingProperty.COMPONENT */ .Ku.COMPONENT, "CourseCardPlaceholder"));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "aria-label": t("Add a course"),
        "data-qa": "course-card__placeholder",
        role: "button",
        tabIndex: 0,
        onClick: handleClick,
        onKeyPress: function(e) {
            if (e.key === "Enter" || e.key === " ") {
                handleClick();
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_10__.S, {
            className: cx("course-card__add"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: cx("course-card__add__icon"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_11__.I, {
                        height: 48,
                        name: "plus",
                        width: 48
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: cx("course-card__add__title"),
                    children: t("Link a course")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: cx("course-card__add__subtitle"),
                    children: t("components-courseCardPlaceholder-course_card_placeholder_description", "Select a course that students in your community have access to, creating a more holistic, dynamic learning experience.")
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCardPlaceholder);


/***/ }),

/***/ 80948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseCard_CourseDetails; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./schema/Product/queries.ts + 1 modules
var queries = __webpack_require__(5867);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
;// CONCATENATED MODULE: ./constants/relatableTypes.ts
var RELATABLE_TYPES = {
    COMMUNITY_SPACE: "CommunitySpace"
};

// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/Opacity/Opacity.tsx
var Opacity = __webpack_require__(21349);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/SpaceDetails/index.ts + 2 modules
var SpaceDetails = __webpack_require__(19024);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./components/SpaceDetails/components/SpaceDetailsSkeleton/SpaceDetailsSkeleton.tsx
var SpaceDetailsSkeleton = __webpack_require__(43650);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/CourseCard/CourseCard.tsx
var CourseCard = __webpack_require__(72549);
// EXTERNAL MODULE: ./components/CourseCard/CourseCardPlaceholder/CourseCardPlaceholder.tsx
var CourseCardPlaceholder = __webpack_require__(58664);
// EXTERNAL MODULE: ./components/CourseCard/CourseDetails.module.scss
var CourseDetails_module = __webpack_require__(62670);
var CourseDetails_module_default = /*#__PURE__*/__webpack_require__.n(CourseDetails_module);
;// CONCATENATED MODULE: ./components/CourseCard/CourseDetails.tsx























var cx = bind_default().bind((CourseDetails_module_default()));
var CourseDetails = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,react.useState)(), courseInfo = ref7[0], setCourseInfo = ref7[1];
    var ref8 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref8.currentUser, community = ref8.community, trackEvent = ref8.trackEvent;
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var _query = router.query, spaceId = _query.spaceId, communityId = _query.communityId;
    var isEditSpacePage = router.pathname === routerHelpers/* pathnames.spaces.edit */.$O.spaces.edit;
    var isNewSpacePage = router.pathname === routerHelpers/* pathnames.spaces.new */.$O.spaces["new"];
    var isSpacePage = router.pathname === routerHelpers/* pathnames.spaces.space */.$O.spaces.space;
    var isAdmin = (0,userHelpers/* isSiteAdmin */.$1)(currentUser.roles);
    var ref9 = (0,useQuery/* useQuery */.a)(queries/* PRODUCT_QUERY */.Pj, {
        variables: {
            communityId: communityId,
            relatableType: RELATABLE_TYPES.COMMUNITY_SPACE,
            relatableId: spaceId,
            isModerator: isAdmin
        },
        fetchPolicy: "cache-and-network",
        skip: isNewSpacePage,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), data = ref9.data, loading = ref9.loading;
    var productRelation = data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : (ref1 = ref.communityProductRelations) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2[0];
    var courseProduct = productRelation === null || productRelation === void 0 ? void 0 : (ref3 = productRelation.node) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.product) === null || ref4 === void 0 ? void 0 : ref4.productable;
    var slug = productRelation === null || productRelation === void 0 ? void 0 : (ref5 = productRelation.node) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.product) === null || ref6 === void 0 ? void 0 : ref6.slug;
    (0,react.useEffect)(function() {
        if ((courseProduct === null || courseProduct === void 0 ? void 0 : courseProduct.__typename) === "Course") {
            setCourseInfo(courseProduct);
        } else {
            setCourseInfo(undefined);
        }
    }, [
        courseProduct,
        router.asPath
    ]);
    (0,react.useEffect)(function() {
        var tokenShow = pubsub_default().subscribe(eventNames/* eventNames.SHOW_COURSE_CARD_PREVIEW */.S.SHOW_COURSE_CARD_PREVIEW, function(msg, info) {
            setCourseInfo(info);
        });
        var tokenHide = pubsub_default().subscribe(eventNames/* eventNames.HIDE_COURSE_CARD_PREVIEW */.S.HIDE_COURSE_CARD_PREVIEW, function() {
            setCourseInfo(undefined);
        });
        return function() {
            pubsub_default().unsubscribe(tokenShow);
            pubsub_default().unsubscribe(tokenHide);
        };
    }, []);
    var previewCourseUrl = "".concat(routerHelpers/* routes.coursesPreview */._j.coursesPreview, "/").concat(slug, "?preview_type=student");
    // if the percentage completed is null, we know that the current_user must be an admin + has not enrolled in the course.
    var goToCourseUrl = (courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.percentageCompleted) === null ? previewCourseUrl : courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.resumeCourseUrl;
    var content;
    if (courseInfo) {
        var ref10, ref11;
        var productId = (productRelation === null || productRelation === void 0 ? void 0 : (ref10 = productRelation.node) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.product) === null || ref11 === void 0 ? void 0 : ref11.id) || "";
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(Opacity/* default */.Z, {
            value: isEditSpacePage || isNewSpacePage ? 0.7 : 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseCard/* default */.Z, {
                className: cx("course-card__container", {
                    "is-not-clickable": isEditSpacePage || isNewSpacePage
                }),
                courseURL: goToCourseUrl || "",
                dataQA: "course-card",
                description: courseInfo.description || "",
                imageUrl: courseInfo.cardImageUrl || "",
                name: courseInfo.name || "",
                percentageCompleted: courseInfo.percentageCompleted,
                productId: productId
            })
        });
    } else if (isEditSpacePage || isNewSpacePage) {
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseCardPlaceholder/* default */.Z, {});
    } else if (isSpacePage && isAdmin) {
        if (loading || courseInfo !== courseProduct) {
            // If courseInfo !== courseProduct, then we need to wait for state to update as well
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetailsSkeleton/* default */.Z, {
                hideImageSkeleton: true
            });
        }
        content = /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetails/* SpaceDetailsCard */.a, {
            description: t("components-courseCard-link_course_description", "Select a course that students in your community have access to, creating a more holistic, dynamic learning experience."),
            footerAccessory: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                appearance: "secondary",
                "data-qa": "link-a-course-cta",
                onClick: function() {
                    trackEvent(trackingEvents/* default.CLICK_ADD_COURSE_TO_SPACE */.ZP.CLICK_ADD_COURSE_TO_SPACE, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "CourseDetails"));
                    (0,routerHelpers/* goToEditSpace */.Z4)(router, spaceId, community.id, {
                        openCourseModal: true
                    });
                },
                children: t("LINK A COURSE")
            }),
            icon: "link",
            inheritPrimaryColor: false,
            name: t("Link a Course"),
            showImage: false
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        "data-qa-loading": loading,
        children: content
    });
};
/* harmony default export */ var CourseCard_CourseDetails = (CourseDetails);


/***/ }),

/***/ 45022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42990);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9973);
/* harmony import */ var helpers_eventHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7856);
/* harmony import */ var koba_components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99438);
/* harmony import */ var _EditEventButton_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18384);
/* harmony import */ var _EditEventButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_EditEventButton_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_EditEventButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
var EditEventButton = function(param) {
    var eventId = param.eventId, parentComponent = param.parentComponent, callback = param.callback, _hasIcon = param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, title = param.title, className = param.className;
    var ref = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_4__/* .useCommunityContext */ .v1)(), community = ref.community, trackEvent = ref.trackEvent;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var handleEditClick = function(e) {
        (0,helpers_eventHelpers__WEBPACK_IMPORTED_MODULE_5__/* .handleEditEvent */ .K)(e, router, trackEvent, community.id, eventId, parentComponent);
        callback === null || callback === void 0 ? void 0 : callback();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(koba_components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        appearance: "ghost",
        className: cx("edit-event-button", className),
        dataQA: "event-panel__edit-button",
        href: "/communities/".concat(community === null || community === void 0 ? void 0 : community.id, "/events/").concat(eventId, "/edit/"),
        onClick: handleEditClick,
        children: [
            hasIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_8__.I, {
                name: "pencil"
            }),
            title
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EditEventButton);


/***/ }),

/***/ 56613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79707);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52945);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99490);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67421);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var linkify_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62402);
/* harmony import */ var helpers_interactions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56427);
/* harmony import */ var utils_textHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51661);
/* harmony import */ var helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17981);
/* harmony import */ var utils_rawId__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(93593);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9973);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89131);
/* harmony import */ var components_Events_components_TimezoneTip__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71890);
/* harmony import */ var _EventContent_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71476);
/* harmony import */ var _EventContent_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_EventContent_module_scss__WEBPACK_IMPORTED_MODULE_10__);


















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_EventContent_module_scss__WEBPACK_IMPORTED_MODULE_10___default()));
var EventContent = function(param) {
    var event = param.event, parentComponent = param.parentComponent;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_7__/* .useCommunityContext */ .v1)(), currentUser = ref.currentUser, trackEvent = ref.trackEvent;
    var profile = currentUser.profile, locale = currentUser.locale;
    var userTimezone = (profile === null || profile === void 0 ? void 0 : profile.timezone) || undefined;
    var isOnlineMeeting = !!(event === null || event === void 0 ? void 0 : event.meetingUrl);
    var startTime = luxon__WEBPACK_IMPORTED_MODULE_11__/* .DateTime.fromISO */ .ou.fromISO((event === null || event === void 0 ? void 0 : event.startTime) || "", {
        zone: userTimezone,
        locale: locale
    });
    var endTime = luxon__WEBPACK_IMPORTED_MODULE_11__/* .DateTime.fromISO */ .ou.fromISO((event === null || event === void 0 ? void 0 : event.endTime) || "", {
        zone: userTimezone,
        locale: locale
    });
    var handleJoinMeeting = function(e, mixpanelEvent) {
        e.preventDefault();
        var _obj;
        trackEvent(mixpanelEvent, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* .TrackingProperty.LIVE_EVENT_ID */ .Ku.LIVE_EVENT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_13__/* .rawId */ .b)((event === null || event === void 0 ? void 0 : event.id) || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* .TrackingProperty.LIVE_EVENT_ID_ENCODED */ .Ku.LIVE_EVENT_ID_ENCODED, event === null || event === void 0 ? void 0 : event.id), _obj));
        window.open((event === null || event === void 0 ? void 0 : event.meetingUrl) || "", "_blank");
    };
    var renderFormattedUserLocalTime = function() {
        var date = (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_6__/* .localeEventsDate */ .U0)((event === null || event === void 0 ? void 0 : event.startTime) || "", locale, userTimezone, {
            month: "long",
            day: "numeric",
            weekday: "long"
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: cx("event-content__date"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: date
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    "data-qa": "event-content__time",
                    children: [
                        startTime.toFormat("h:mm a"),
                        " - ",
                        endTime.toFormat(helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_6__/* .TIMEZONE_FORMAT */ .km)
                    ]
                })
            ]
        });
    };
    var renderEventLocation = function() {
        if (event === null || event === void 0 ? void 0 : event.meetingUrl) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx("event-content__meeting"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_14__.B, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                        appearance: "accessible-link",
                        "aria-label": t("components-events-eventPanel-access_meeting", "Click to join the meeting. The meeting will be opened in a new window."),
                        className: cx("event-content__meeting-url"),
                        "data-qa": "event-content__meeting-url",
                        href: event.meetingUrl,
                        target: "_blank"
                    }, (0,helpers_interactions__WEBPACK_IMPORTED_MODULE_17__/* .a11yOnClick */ .Z)(function(e) {
                        return handleJoinMeeting(e, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* ["default"].CLICK_LIVE_EVENT_MEETING_LINK */ .ZP.CLICK_LIVE_EVENT_MEETING_LINK);
                    })), {
                        children: event.meetingUrl
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_14__.B, {
                        appearance: "accessible-link",
                        className: cx("event-content__meeting-button"),
                        "data-qa": "event-content__copy-link",
                        type: "button",
                        onClick: handleCopyLink,
                        children: t("common-copy_link", "copy link")
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            "data-qa": "event-content__location",
            children: event === null || event === void 0 ? void 0 : event.location
        });
    };
    var handleCopyLink = function() {
        (0,utils_textHelpers__WEBPACK_IMPORTED_MODULE_5__/* .copyToClipboard */ .vQ)((event === null || event === void 0 ? void 0 : event.meetingUrl) || "", t("components-events-eventPanel-copy_to_clipboard_success", "You have successfully copied the link to join the event to your clipboard."));
        var _obj;
        trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* ["default"].CLICK_COPY_LIVE_EVENT_LINK */ .ZP.CLICK_COPY_LIVE_EVENT_LINK, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* .TrackingProperty.LIVE_EVENT_ID */ .Ku.LIVE_EVENT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_13__/* .rawId */ .b)((event === null || event === void 0 ? void 0 : event.id) || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* .TrackingProperty.LIVE_EVENT_ID_ENCODED */ .Ku.LIVE_EVENT_ID_ENCODED, event === null || event === void 0 ? void 0 : event.id), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_8__/* .TrackingProperty.COMPONENT */ .Ku.COMPONENT, parentComponent), _obj));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("event-content__wrapper"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("components-events-eventPanel-DATE_AND_TIME", "DATE AND TIME")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: renderFormattedUserLocalTime()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_18__.C, {
                className: cx("d-inline-block"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Events_components_TimezoneTip__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: isOnlineMeeting ? t("components-events-eventPanel-EVENT_LINK", "EVENT LINK") : t("components-events-eventPanel-EVENT_LOCATION", "EVENT LOCATION")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: renderEventLocation()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                children: t("components-events-eventPanel-ABOUT", "ABOUT")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(linkify_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                options: {
                    target: {
                        url: "_blank",
                        email: "_blank"
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: cx("event-content__about-wrapper"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("pre", {
                        className: cx("event-content__about"),
                        "data-qa": "event-content__about",
                        children: event === null || event === void 0 ? void 0 : event.description
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventContent);


/***/ }),

/***/ 75196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var koba_components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99438);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42990);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67421);
/* harmony import */ var components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65699);
/* harmony import */ var _EventInterestedButton_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84660);
/* harmony import */ var _EventInterestedButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_EventInterestedButton_module_scss__WEBPACK_IMPORTED_MODULE_7__);










var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_3___default().bind((_EventInterestedButton_module_scss__WEBPACK_IMPORTED_MODULE_7___default()));
var EventInterestedButton = function(param) {
    var eventId = param.eventId, isInterested = param.isInterested, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var ref = (0,components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(eventId), addInterest = ref.addInterest, removeInterest = ref.removeInterest, loading = ref.loading;
    var handleInterestButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isInterested) {
                            removeInterest();
                        } else {
                            addInterest();
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleInterestButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(koba_components_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        appearance: "default",
        className: cx("event-panel__interested-button", {
            interested: isInterested,
            "not-yet-interested": !isInterested
        }),
        dataQA: "event-panel__interested-button",
        isDisabled: loading || isDisabled,
        onClick: handleInterestButton,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
            className: cx("event-panel__interested-button-container"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: cx("event-panel__interested-button-icon-container"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_9__.I, {
                        className: cx("event-panel__interested-button-icon"),
                        name: isInterested ? "checkmark" : "plus"
                    })
                }),
                t("components-eventPanel-interested", "interested")
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventInterestedButton);


/***/ }),

/***/ 71890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67421);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4154);




var TimezoneTip = function(param) {
    var onClick = param.onClick;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            t("components-events-timezone_tip_text", "You can edit your preferred timezone in your Profile."),
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: utils_routerHelpers__WEBPACK_IMPORTED_MODULE_3__/* .routes.myAccount */ ._j.myAccount,
                onClick: onClick,
                children: t("components-events-timezone_tip_edit", "Edit")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TimezoneTip);


/***/ }),

/***/ 65699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50319);
/* harmony import */ var utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55049);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89131);
/* harmony import */ var schema_Event_mutations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14130);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9973);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67421);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59830);
/* harmony import */ var utils_rawId__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93593);










 // get from generated?

var useEventInterest = function(id) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)().t;
    var trackEvent = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_4__/* .useCommunityContext */ .v1)().trackEvent;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)(schema_Event_mutations__WEBPACK_IMPORTED_MODULE_3__/* .CREATE_ATTENDANCE_MUTATION */ .eS, {
        onError: utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .genericToastAlert */ .d9,
        update: function(cache, result) {
            var ref, ref1;
            var updatedEvent = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createAttendance) === null || ref1 === void 0 ? void 0 : ref1.liveEvent;
            if (updatedEvent) {
                cache.evict({
                    id: cache.identify({
                        id: updatedEvent.id,
                        __typename: updatedEvent.__typename
                    }),
                    fieldName: "interestedUsers"
                });
                cache.gc();
            }
        }
    }), 2), createAttendanceMutation = ref[0], ref1 = ref[1], createLoading = ref1.loading;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)(schema_Event_mutations__WEBPACK_IMPORTED_MODULE_3__/* .DELETE_ATTENDANCE_MUTATION */ .uw, {
        onError: utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .genericToastAlert */ .d9,
        update: function(cache, result) {
            var ref, ref1;
            var updatedEvent = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.deleteAttendance) === null || ref1 === void 0 ? void 0 : ref1.liveEvent;
            if (updatedEvent) {
                cache.evict({
                    id: cache.identify({
                        id: updatedEvent.id,
                        __typename: updatedEvent.__typename
                    }),
                    fieldName: "interestedUsers"
                });
                cache.gc();
            }
        }
    }), 2), deleteAttendanceMutation = ref2[0], ref3 = ref2[1], deleteLoading = ref3.loading;
    var handleResponse = function(trackingEvent, userErrors, requestErrors) {
        var alreadyAttendingFailure = userErrors === null || userErrors === void 0 ? void 0 : userErrors.find(function(error) {
            return error.code === utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .USER_ERRORS_API_CODES.event_attendance_already_attending */ .f5.event_attendance_already_attending;
        });
        var notAttendingFailure = userErrors === null || userErrors === void 0 ? void 0 : userErrors.find(function(error) {
            return error.code === utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .USER_ERRORS_API_CODES.event_attendance_not_attending */ .f5.event_attendance_not_attending;
        });
        if (!(userErrors === null || userErrors === void 0 ? void 0 : userErrors.length) && !(requestErrors === null || requestErrors === void 0 ? void 0 : requestErrors.length)) {
            var _obj;
            trackEvent(trackingEvent, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .TrackingProperty.LIVE_EVENT_ID */ .Ku.LIVE_EVENT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_10__/* .rawId */ .b)(id || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* .TrackingProperty.LIVE_EVENT_ID_ENCODED */ .Ku.LIVE_EVENT_ID_ENCODED, id), _obj));
        } else if (alreadyAttendingFailure) {
            (0,utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .failureToastMessage */ .MO)(t("pages-events-user_already_attending", "You are already attending that event."));
        } else if (notAttendingFailure) {
            (0,utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .failureToastMessage */ .MO)(t("pages-events-user_not_attending", "You are not attending that event."));
        } else {
            (0,utils_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .genericToastAlert */ .d9)();
        }
    };
    var handleCreateAttendance = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, data, errors, userErrors;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return createAttendanceMutation({
                            variables: {
                                input: {
                                    eventId: id || ""
                                }
                            },
                            refetchQueries: [
                                "LiveEvent"
                            ]
                        });
                    case 3:
                        ref1 = _ctx.sent;
                        data = ref1.data;
                        errors = ref1.errors;
                        userErrors = data === null || data === void 0 ? void 0 : (ref = data.createAttendance) === null || ref === void 0 ? void 0 : ref.userErrors;
                        handleResponse(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* ["default"].CREATE_ATTENDANCE */ .ZP.CREATE_ATTENDANCE, userErrors, errors);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCreateAttendance() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRemoveAttendance = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1, data, errors, userErrors;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return deleteAttendanceMutation({
                            variables: {
                                input: {
                                    eventId: id || ""
                                }
                            },
                            refetchQueries: [
                                "LiveEvent"
                            ]
                        });
                    case 3:
                        ref1 = _ctx.sent;
                        data = ref1.data;
                        errors = ref1.errors;
                        userErrors = data === null || data === void 0 ? void 0 : (ref = data.deleteAttendance) === null || ref === void 0 ? void 0 : ref.userErrors;
                        handleResponse(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DELETE_ATTENDANCE */ .ZP.DELETE_ATTENDANCE, userErrors, errors);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRemoveAttendance() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        addInterest: handleCreateAttendance,
        removeInterest: handleRemoveAttendance,
        loading: createLoading || deleteLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useEventInterest);


/***/ }),

/***/ 82513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image_Image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/Image/Image.module.scss
var Image_module = __webpack_require__(1922);
var Image_module_default = /*#__PURE__*/__webpack_require__.n(Image_module);
;// CONCATENATED MODULE: ./components/Image/Image.tsx




var cx = bind_default().bind((Image_module_default()));
var placeholderSrc = function(width, height) {
    return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '.concat(width, " ").concat(height, '"%3E%3C/svg%3E');
};
/* This is image is responsive. The height and width are used to maintain the aspect ratio */ var ResponsiveImage = function(param) {
    var imgSrc = param.src, alt = param.alt, width = param.width, height = param.height, className = param.className;
    var placeholder = placeholderSrc(width, height);
    var ref = (0,react.useState)(placeholder), src = ref[0], setSrc = ref[1];
    var ref1 = (0,react.useState)(""), srcSet = ref1[0], setSrcSet = ref1[1];
    var image = new Image();
    image.onload = function() {
        var source = imgSrc.includes("?") ? "".concat(imgSrc, "&") : "".concat(imgSrc, "?");
        setSrcSet("".concat(source, "width=").concat(width, " 1x, ").concat(source, "width=").concat(width, "&dpr=2 2x, ").concat(source, "width=").concat(width, "&dpr=3 3x"));
        setSrc(imgSrc);
    };
    image.src = imgSrc;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        alt: alt,
        className: cx("img", className),
        src: src,
        srcSet: srcSet
    });
};
/* harmony default export */ var Image_Image = (ResponsiveImage);

;// CONCATENATED MODULE: ./components/Image/index.ts



/***/ }),

/***/ 73314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SiteLayout_SiteLayout; },
  "G": function() { return /* reexport */ getLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./koba/components/Button/index.ts
var Button = __webpack_require__(99438);
// EXTERNAL MODULE: ./koba/components/Typography/index.ts + 6 modules
var Typography = __webpack_require__(63579);
// EXTERNAL MODULE: ./koba/components/Dropdown/index.ts + 9 modules
var Dropdown = __webpack_require__(46744);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./components/UserAvatar/index.ts + 2 modules
var UserAvatar = __webpack_require__(82957);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
// EXTERNAL MODULE: ./components/CurrentUserDropdown/CurrentUserDropdown.module.scss
var CurrentUserDropdown_module = __webpack_require__(71107);
var CurrentUserDropdown_module_default = /*#__PURE__*/__webpack_require__.n(CurrentUserDropdown_module);
;// CONCATENATED MODULE: ./components/CurrentUserDropdown/CurrentUserDropdown.tsx














var cx = bind_default().bind((CurrentUserDropdown_module_default()));
var CurrentUserDropdown = function(param) {
    var _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _isTextDark = param.isTextDark, isTextDark = _isTextDark === void 0 ? false : _isTextDark;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), trackEvent = ref.trackEvent, currentUser = ref.currentUser, community = ref.community;
    var id = currentUser.id, avatarUrl = currentUser.avatarUrl, fullName = currentUser.fullName;
    var goTo = function(route, event) {
        if (event) trackEvent(event, {});
        window.location.href = route;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
        children: function(param) {
            var open = param.open, toggleMenu = param.toggleMenu;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.ZP, {
                        appearance: "knockout",
                        ariaLabel: t("Menu options for {{fullName}}", {
                            fullName: fullName
                        }),
                        className: cx("current-user", {
                            "current-user--dark-text": isTextDark
                        }),
                        dataQA: "menu-options-homepage__btn",
                        onClick: toggleMenu,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                                className: cx("current-user__name"),
                                children: fullName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                                avatarUrl: avatarUrl || "",
                                className: cx("current-user__avatar-container"),
                                size: "xs",
                                srcSet: "".concat(avatarUrl, "?width=32 1x, ").concat(avatarUrl, "?width=32&dpr=2 2x, ").concat(avatarUrl, "?width=32&dpr=3 3x"),
                                userId: id,
                                username: fullName || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                name: open ? "caret-fill-up" : "caret-fill-down"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Menu */.v2, {
                        dataQA: "menu-options__dropdown",
                        open: open,
                        position: isMobile ? "absolute" : "right",
                        children: (0,userHelpers/* isAdmin */.GJ)(currentUser) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("components-currentUserDropdown-community_settings_button", "Community Settings"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo((0,routerHelpers/* getSettingsUrl */.ro)(community.id));
                                        },
                                        children: t("components-currentUserDropdown-community_settings_button", "Community Settings")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("components-currentUserDropdown-admin_dashboard_button", "Admin Dashboard"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo(routerHelpers/* routes.admin */._j.admin);
                                        },
                                        children: t("components-currentUserDropdown-admin_dashboard_button", "Admin Dashboard")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("components-currentUserDropdown-my_profile_button", "My Profile"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo(routerHelpers/* routes.myAccount */._j.myAccount, trackingEvents/* default.MY_ACCOUNT */.ZP.MY_ACCOUNT);
                                        },
                                        children: t("components-currentUserDropdown-my_profile_button", "My Profile")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("common-log_out", "Log Out"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo(routerHelpers/* routes.signOut */._j.signOut);
                                        },
                                        children: t("common-log_out", "Log Out")
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("components-currentUserDropdown-my_profile_button", "My Profile"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo(routerHelpers/* routes.myAccount */._j.myAccount, trackingEvents/* default.MY_ACCOUNT */.ZP.MY_ACCOUNT);
                                        },
                                        children: t("components-currentUserDropdown-my_profile_button", "My Profile")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Item */.ck, {
                                    title: t("common-log_out", "Log Out"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: cx("current-user__button"),
                                        type: "button",
                                        onClick: function() {
                                            return goTo(routerHelpers/* routes.signOut */._j.signOut);
                                        },
                                        children: t("common-log_out", "Log Out")
                                    })
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var CurrentUserDropdown_CurrentUserDropdown = (CurrentUserDropdown);

;// CONCATENATED MODULE: ./components/CurrentUserDropdown/index.ts


// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 12 modules
var ApolloClient = __webpack_require__(20874);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72198);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 8 modules
var inMemoryCache = __webpack_require__(76118);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js + 14 modules
var createHttpLink = __webpack_require__(75465);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/from.js

var from = ApolloLink/* ApolloLink.from */.i.from;
//# sourceMappingURL=from.js.map
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(63200);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/policies/pagination.js
var pagination = __webpack_require__(97091);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./utils/colors.ts
var colors = __webpack_require__(82083);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./components/NotificationPane/NotificationPane.module.scss
var NotificationPane_module = __webpack_require__(14730);
var NotificationPane_module_default = /*#__PURE__*/__webpack_require__.n(NotificationPane_module);
;// CONCATENATED MODULE: ./components/NotificationPane/NotificationPane.tsx












var NotificationPane_cx = bind_default().bind((NotificationPane_module_default()));
var deps = {
    ApolloClient: ApolloClient/* ApolloClient */.f,
    ApolloLink: ApolloLink/* ApolloLink */.i,
    HttpLink: HttpLink/* HttpLink */.u,
    InMemoryCache: inMemoryCache/* InMemoryCache */.h,
    createHttpLink: createHttpLink/* createHttpLink */.L,
    from: from,
    gql: lib/* gql */.Ps,
    onError: error/* onError */.q,
    relayStylePagination: pagination/* relayStylePagination */.ZB
};
function NotificationPane(param) {
    var className = param.className, dataQA = param.dataQA;
    var isSetupSuccessful = useSetup();
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), primaryColor = ref.community.primaryColor, _currentUser = ref.currentUser, userId = _currentUser.id, roles = _currentUser.roles, locale = _currentUser.locale, _site = ref.site, tenantId = _site.id, trackingKey = _site.trackingKey;
    var isAdmin = (0,userHelpers/* isSiteAdmin */.$1)(roles);
    var hostRef = (0,react.useRef)(null);
    var paneRef = (0,react.useRef)(null);
    var currentUser = {
        isAdmin: isAdmin,
        locale: locale || "en",
        userId: (0,rawId/* rawId */.b)(userId),
        tenantId: (0,rawId/* rawId */.b)(tenantId),
        trackingKey: trackingKey || null
    };
    (0,react.useEffect)(function() {
        var cleanup = function() {
            if (paneRef.current !== null) paneRef.current.destroy();
        };
        if (!isSetupSuccessful) return cleanup;
        if (hostRef.current === null) return cleanup;
        var NotificationPaneConstructor = grabNotificationPane();
        if (!NotificationPaneConstructor) return cleanup;
        var initializeNotificationPane = function() {
            if (!hostRef.current) return;
            paneRef.current = new NotificationPaneConstructor({
                wrapper: hostRef.current,
                currentUser: currentUser,
                deps: deps
            });
        };
        var analyticsPromise = Promise.resolve(null);
        if (trackingKey) {
            analyticsPromise = __webpack_require__.e(/* import() */ 4955).then(__webpack_require__.t.bind(__webpack_require__, 64955, 23)).then(function(param) {
                var ThinkificAnalytics = param.default;
                deps.analytics = ThinkificAnalytics;
            });
        }
        analyticsPromise.then(initializeNotificationPane);
        return cleanup;
    }, [
        isSetupSuccessful,
        isAdmin
    ]);
    if (!isSetupSuccessful) return null;
    var conditionalClassNames = {
        "notification-pane--dark": (0,colors/* isTextDark */.aS)(primaryColor)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: NotificationPane_cx(className, "notification-pane", conditionalClassNames),
        "data-qa": dataQA,
        ref: hostRef
    });
}
function useIsNotificationPaneEnabled() {
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), _featureFlags = ref.featureFlags, featureFlags = _featureFlags === void 0 ? {} : _featureFlags;
    var isEnabled = featureFlags[constants_featureFlags/* features.NOTIFICATION_PANE */.R.NOTIFICATION_PANE];
    return isEnabled && !!grabNotificationPaneJs();
}
function useSetup() {
    var ref = (0,react.useState)(!!grabNotificationPane()), isFinished = ref[0], setIsFinished = ref[1];
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    (0,react.useEffect)(function() {
        if (grabNotificationPane()) {
            setIsFinished(true);
            return;
        }
        NotificationPane.loadScript(grabNotificationPaneJs()).then(function() {
            return setIsFinished(true);
        }).catch(function(e) {
            var data = {
                errorMsg: "".concat((e === null || e === void 0 ? void 0 : e.msg) || e)
            };
            // @ts-ignore I think we should log an error here instead of a mixpanel event?
            trackEvent("Notification Pane script fails to load", data);
        });
    }, [
        trackEvent
    ]);
    return isFinished;
}
var scriptLoadingPromise = null;
NotificationPane.loadScript = function loadScript(src) {
    if (scriptLoadingPromise !== null) return scriptLoadingPromise;
    scriptLoadingPromise = new Promise(function(resolve, reject) {
        var script = document.createElement("script");
        script.onload = resolve;
        script.onerror = reject;
        script.src = src;
        document.body.append(script);
    });
    return scriptLoadingPromise;
};
function grabNotificationPane() {
    var ref;
    return (ref = window.Thinkific) === null || ref === void 0 ? void 0 : ref.NotificationPane;
}
function grabNotificationPaneJs() {
    return "https://notification-pane.thinkific.com/NotificationPane.js" || 0;
}

;// CONCATENATED MODULE: ./components/NotificationPane/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./helpers/interactions/index.ts
var interactions = __webpack_require__(56427);
// EXTERNAL MODULE: ./components/VisibilityCloak/VisibilityCloak.tsx
var VisibilityCloak = __webpack_require__(37510);
;// CONCATENATED MODULE: ./types/communityStatuses.ts
var CommunityStatuses;
(function(CommunityStatuses) {
    CommunityStatuses["PUBLISHED"] = "Published";
    CommunityStatuses["PRE_ORDER"] = "Pre-order";
    CommunityStatuses["DRAFT"] = "Draft";
})(CommunityStatuses || (CommunityStatuses = {}));

// EXTERNAL MODULE: ./components/CommunityStatusBadge/CommunityStatusBadge.module.scss
var CommunityStatusBadge_module = __webpack_require__(10073);
var CommunityStatusBadge_module_default = /*#__PURE__*/__webpack_require__.n(CommunityStatusBadge_module);
;// CONCATENATED MODULE: ./components/CommunityStatusBadge/CommunityStatusBadge.tsx
















var CommunityStatusBadge_cx = bind_default().bind((CommunityStatusBadge_module_default()));
var CommunityStatusBadge = function() {
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, featureFlags = ref.featureFlags, trackEvent = ref.trackEvent;
    var t = (0,es/* useTranslation */.$G)().t;
    var isCommunitiesAsAProductEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_AS_A_PRODUCT */.R.COMMUNITIES_AS_A_PRODUCT];
    var communityStatusLabel = function() {
        switch(community.status){
            case CommunityStatuses.PRE_ORDER:
                return t("components-communityStatusBadge-Pre-order", "Pre-order");
            case CommunityStatuses.PUBLISHED:
                return t("components-communityStatusBadge-live", "Live");
            default:
                return t("components-communityStatusBadge-draft", "Draft");
        }
    };
    var handleOnClick = function() {
        trackEvent(trackingEvents/* default.GO_TO_PUBLISH_COMMUNITY */.ZP.GO_TO_PUBLISH_COMMUNITY, (0,_define_property/* default */.Z)({}, trackingEvents/* TrackingProperty.COMPONENT */.Ku.COMPONENT, "CommunityStatusBadge"));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VisibilityCloak/* default */.Z, {
        hide: !isCommunitiesAsAProductEnabled,
        admins: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "aria-label": t("components-communityStatusBadge-go_to_publish_community", "Go to Community Builder to update its status"),
            className: CommunityStatusBadge_cx("community-status-badge__link", {
                "is-live": community.status !== "Draft"
            }),
            href: routerHelpers/* routes.publishCommunity */._j.publishCommunity(community.id),
            target: "__blank"
        }, (0,interactions/* a11yOnClick */.Z)(handleOnClick)), {
            children: [
                communityStatusLabel(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                    height: 16,
                    name: "arrow-up-right",
                    width: 16,
                    "aria-hidden": true
                })
            ]
        }))
    });
};
/* harmony default export */ var CommunityStatusBadge_CommunityStatusBadge = (CommunityStatusBadge);

// EXTERNAL MODULE: ./components/TopBar/TopBar.module.scss
var TopBar_module = __webpack_require__(18926);
var TopBar_module_default = /*#__PURE__*/__webpack_require__.n(TopBar_module);
;// CONCATENATED MODULE: ./components/TopBar/TopBar.tsx













var TopBar_cx = bind_default().bind((TopBar_module_default()));
var TopBar = function(param) {
    var _isDashboardLinkVisible = param.isDashboardLinkVisible, isDashboardLinkVisible = _isDashboardLinkVisible === void 0 ? false : _isDashboardLinkVisible, t = param.t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, currentUser = ref.currentUser, trackEvent = ref.trackEvent;
    var isNotificationPaneEnabled = useIsNotificationPaneEnabled();
    var color = community.primaryColor;
    var goToDashboard = function() {
        trackEvent(trackingEvents/* default.GO_TO_DASHBOARD */.ZP.GO_TO_DASHBOARD, {});
        window.location.href = "/enrollments";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
            className: TopBar_cx("top-bar", (0,colors/* isTextDark */.aS)(color) ? "top-bar--dark-text" : ""),
            style: {
                backgroundColor: color
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: TopBar_cx("top-bar__container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* ButtonWithIconLeft */.ej, {
                        appearance: "knockout",
                        "aria-label": t("components-topBar-student_dashboard_button", "My Dashboard"),
                        className: TopBar_cx("top-bar__link", "top-bar__link-dashboard", isDashboardLinkVisible ? "top-bar__link-visible" : ""),
                        onClick: goToDashboard,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                name: "caret-stroke-left"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                                className: TopBar_cx("top-bar-dashboard__title"),
                                children: t("components-topBar-student_dashboard_button", "My Dashboard")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: TopBar_cx("top-bar__link-container"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "aria-label": community.name,
                                className: TopBar_cx("top-bar__link", "top-bar__link-title"),
                                href: "/communities/".concat(community.id),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H1, {
                                    className: TopBar_cx("top-bar__title"),
                                    children: community.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityStatusBadge_CommunityStatusBadge, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: TopBar_cx("top-bar__right-container"),
                        children: [
                            currentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: TopBar_cx("top-bar__dropdown"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrentUserDropdown_CurrentUserDropdown, {
                                    isTextDark: (0,colors/* isTextDark */.aS)(color)
                                })
                            }),
                            isNotificationPaneEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationPane, {
                                className: TopBar_cx("top-bar__button-hover")
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TopBar_TopBar = (TopBar);

;// CONCATENATED MODULE: ./components/TopBar/index.ts


// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./components/CommunityActions/index.ts + 36 modules
var CommunityActions = __webpack_require__(98);
// EXTERNAL MODULE: ./components/MobileMenuUserSection/MobileMenuUserSection.module.scss
var MobileMenuUserSection_module = __webpack_require__(87835);
var MobileMenuUserSection_module_default = /*#__PURE__*/__webpack_require__.n(MobileMenuUserSection_module);
;// CONCATENATED MODULE: ./components/MobileMenuUserSection/MobileMenuUserSection.tsx












var MobileMenuUserSection_cx = bind_default().bind((MobileMenuUserSection_module_default()));
var MobileMenuUserSection = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), trackEvent = ref.trackEvent, _currentUser = ref.currentUser, fullName = _currentUser.fullName, avatarUrl = _currentUser.avatarUrl, currentUser = ref.currentUser, id = ref.community.id;
    var handleNavigation = function(event, path) {
        trackEvent(event, {});
        window.location.assign(path);
    };
    var goTo = function(route, event) {
        if (event) trackEvent(event, {});
        window.location.href = route;
    };
    var goToMyAccount = function(event) {
        event.preventDefault();
        handleNavigation(trackingEvents/* default.MY_ACCOUNT */.ZP.MY_ACCOUNT, "/account");
    };
    var goToMyDashboard = function(event) {
        event.preventDefault();
        handleNavigation(trackingEvents/* default.GO_TO_DASHBOARD */.ZP.GO_TO_DASHBOARD, "/enrollments");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: MobileMenuUserSection_cx("mobile-menu-user-section__wrapper"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: MobileMenuUserSection_cx("mobile-menu-user-section__separator")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: MobileMenuUserSection_cx("mobile-menu-user-section__info"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: MobileMenuUserSection_cx("mobile-menu-user-section__avatar-container"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                            avatarUrl: avatarUrl,
                            className: MobileMenuUserSection_cx("mobile-menu-user-section__avatar"),
                            size: "xs",
                            srcSet: "".concat(avatarUrl, "?width=32 1x, ").concat(avatarUrl, "?width=32&dpr=2 2x, ").concat(avatarUrl, "?width=32&dpr=3 3x"),
                            userId: id,
                            username: fullName || ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Caption */.Y, {
                        className: MobileMenuUserSection_cx("current-user__name"),
                        children: fullName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: MobileMenuUserSection_cx("mobile-menu-user-section__actions"),
                children: [
                    (0,userHelpers/* isAdmin */.GJ)(currentUser) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                        appearance: "knockout",
                        className: MobileMenuUserSection_cx("mobile-menu-user-section__button"),
                        onClick: function() {
                            return goTo((0,routerHelpers/* getSettingsUrl */.ro)(id));
                        },
                        children: t("components-mobileMenuUserSections-community_settings_button", "Community Settings")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                        appearance: "knockout",
                        className: MobileMenuUserSection_cx("mobile-menu-user-section__button"),
                        href: "/enrollments",
                        onClick: goToMyDashboard,
                        children: t("components-mobileMenuUserSections-dashboard_button", "My Dashboard")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                        appearance: "knockout",
                        className: MobileMenuUserSection_cx("mobile-menu-user-section__button"),
                        href: "/account",
                        onClick: goToMyAccount,
                        children: t("components-mobileMenuUserSections-my_profile_button", "My Profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                        appearance: "knockout",
                        className: MobileMenuUserSection_cx("mobile-menu-user-section__button"),
                        href: "/logout",
                        onClick: function() {
                            return goTo(routerHelpers/* routes.signOut */._j.signOut);
                        },
                        children: t("common-log_out", "Log Out")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MobileMenuUserSection_MobileMenuUserSection = (MobileMenuUserSection);

;// CONCATENATED MODULE: ./components/MobileMenuUserSection/index.ts


// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./koba/components/MobileMenu/MobileMenu.module.scss
var MobileMenu_module = __webpack_require__(54862);
var MobileMenu_module_default = /*#__PURE__*/__webpack_require__.n(MobileMenu_module);
// EXTERNAL MODULE: ./hooks/useFocusTrap.ts
var useFocusTrap = __webpack_require__(188);
;// CONCATENATED MODULE: ./hooks/useEscape.tsx

var useEscape = function(onEscape) {
    (0,react.useEffect)(function() {
        var handleEsc = function(event) {
            if (event.keyCode === 27) onEscape();
        };
        window.addEventListener("keydown", handleEsc);
        return function() {
            window.removeEventListener("keydown", handleEsc);
        };
    }, []);
};
/* harmony default export */ var hooks_useEscape = (useEscape);

// EXTERNAL MODULE: ./koba/components/MobileMenu/components/MenuTab.module.scss
var MenuTab_module = __webpack_require__(39599);
var MenuTab_module_default = /*#__PURE__*/__webpack_require__.n(MenuTab_module);
;// CONCATENATED MODULE: ./koba/components/MobileMenu/components/MenuTab.tsx










var MenuTab_cx = bind_default().bind((MenuTab_module_default()));
var MenuTab = function(param) {
    var buttonClassName = param.buttonClassName, children = param.children, iconName = param.iconName, isOpen = param.isOpen, hasOverlay = param.hasOverlay, _hasHeader = param.hasHeader, hasHeader = _hasHeader === void 0 ? true : _hasHeader, hasOpenButton = param.hasOpenButton, menuTitle = param.menuTitle, _slideTo = param.slideTo, slideTo = _slideTo === void 0 ? "right" : _slideTo, _size = param.size, size = _size === void 0 ? "medium" : _size, _showCommunityStatus = param.showCommunityStatus, showCommunityStatus = _showCommunityStatus === void 0 ? false : _showCommunityStatus, _title = param.title, title = _title === void 0 ? "" : _title, onClose = param.onClose, onOpen = param.onOpen, wrapperClassName = param.wrapperClassName;
    var menuRef = (0,react.useRef)(null);
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    (0,useFocusTrap/* default */.Z)(menuRef);
    hooks_useEscape(onClose);
    (0,react.useEffect)(function() {
        document.body.classList.toggle(MenuTab_cx("hide-scroll"), isOpen);
        return function() {
            return document.body.classList.remove(MenuTab_cx("hide-scroll"));
        };
    }, [
        isOpen
    ]);
    (0,react.useEffect)(function() {
        // If doesn't has overlay it should close when route changes
        if (!hasOverlay && isOpen) {
            onClose();
        }
    }, [
        router.asPath,
        hasOverlay
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            hasOpenButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
                appearance: "utility",
                "aria-label": title,
                name: iconName,
                title: title,
                onClick: onOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: MenuTab_cx("menu-tab__container", size, {
                    "is-menu-open": isOpen,
                    "slide-to-left": slideTo === "left",
                    "no-header": !hasHeader
                }),
                "data-qa": "menu-tab__container",
                ref: menuRef,
                children: [
                    hasHeader && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: MenuTab_cx("menu-tab__header"),
                        "data-qa": "menu-tab__header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        title: menuTitle,
                                        children: menuTitle
                                    }),
                                    showCommunityStatus && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityStatusBadge_CommunityStatusBadge, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
                                appearance: "utility",
                                "aria-label": t("Close the menu"),
                                className: MenuTab_cx("menu-tab__button", buttonClassName),
                                name: "x-dismiss",
                                title: t("Close the menu"),
                                onClick: onClose
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: MenuTab_cx("menu-tab__content", {
                            "is-menu-open": isOpen
                        }, wrapperClassName),
                        children: children
                    })
                ]
            }),
            hasOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "aria-hidden": "true",
                className: MenuTab_cx("menu-tab__overlay", {
                    "is-menu-open": isOpen
                }),
                "data-qa": "menu-tab__overlay",
                role: "button",
                tabIndex: -1,
                onClick: onClose
            })
        ]
    });
};
/* harmony default export */ var components_MenuTab = (MenuTab);

;// CONCATENATED MODULE: ./koba/components/MobileMenu/MobileMenu.tsx

/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 








var MobileMenu_cx = bind_default().bind((MobileMenu_module_default()));
var MobileMenu = function(param) {
    var buttonClassName = param.buttonClassName, children = param.children, className = param.className, headerTitle = param.headerTitle, isOpen = param.isOpen, menuTitle = param.menuTitle, onClose = param.onClose, onOpen = param.onOpen, rightAccessory = param.rightAccessory, isPostView = param.isPostView, _isEventPage = param.isEventPage, isEventPage = _isEventPage === void 0 ? false : _isEventPage, goToPostListPage = param.goToPostListPage;
    var t = (0,es/* useTranslation */.$G)().t;
    var isNotificationPaneEnabled = useIsNotificationPaneEnabled();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: MobileMenu_cx("mobile-menu__wrapper", className),
                children: [
                    isPostView || isEventPage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* ButtonWithIconOnly */.Au, {
                        appearance: "knockout",
                        ariaLabel: t("common-return_to_previous_page", "Return to the previous page"),
                        className: MobileMenu_cx("mobile-menu__back-button"),
                        onClick: goToPostListPage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            name: "arrow-left"
                        })
                    }) : !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
                        appearance: "utility",
                        "aria-label": t("Click to open the menu"),
                        className: MobileMenu_cx("mobile-menu__button", buttonClassName),
                        name: "menu",
                        title: t("Click to open the menu"),
                        onClick: onOpen
                    }),
                    !isOpen && headerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: MobileMenu_cx("mobile-menu__header-title"),
                        children: headerTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: MobileMenu_cx("mobile-menu__actions", {
                            "is-menu-open": isOpen
                        }),
                        children: [
                            rightAccessory,
                            isNotificationPaneEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationPane, {
                                className: MobileMenu_cx("mobile-menu__button-hover")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuTab, {
                isOpen: isOpen,
                menuTitle: menuTitle,
                hasOverlay: true,
                showCommunityStatus: true,
                onClose: onClose,
                children: children
            })
        ]
    });
};
/* harmony default export */ var MobileMenu_MobileMenu = (MobileMenu);

;// CONCATENATED MODULE: ./koba/components/MobileMenu/index.ts


// EXTERNAL MODULE: ./schema/Space/queries.ts
var queries = __webpack_require__(73820);
// EXTERNAL MODULE: ./components/SpaceDetails/index.ts + 2 modules
var SpaceDetails = __webpack_require__(19024);
// EXTERNAL MODULE: ./hooks/useWindowSize.js
var useWindowSize = __webpack_require__(90698);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./components/CourseCard/CourseDetails.tsx + 1 modules
var CourseDetails = __webpack_require__(80948);
// EXTERNAL MODULE: ./components/MobileNav/MobileNav.module.scss
var MobileNav_module = __webpack_require__(2146);
var MobileNav_module_default = /*#__PURE__*/__webpack_require__.n(MobileNav_module);
;// CONCATENATED MODULE: ./components/MobileNav/MobileNav.tsx






















var MobileNav_cx = bind_default().bind((MobileNav_module_default()));
var MobileNav = function(param) {
    var community = param.community, isPostView = param.isPostView;
    var ref, ref1;
    var ref2 = (0,react.useState)(false), isMenuOpen = ref2[0], setIsMenuOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isRightAccessoryOpen = ref3[0], setIsRightAccessoryOpen = ref3[1];
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var ref4 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref4.currentUser, featureFlags = ref4.featureFlags;
    var spaceId = (ref = router.query) === null || ref === void 0 ? void 0 : ref.spaceId;
    var spaceDetailTabPages = [
        routerHelpers/* pathnames.spaces.space */.$O.spaces.space
    ];
    var showSpaceDetailsTab = spaceDetailTabPages.includes(router.pathname);
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    (0,react.useEffect)(function() {
        if (width > constants/* SCREEN_LG */.k4) {
            handleCloseMenu();
            handleCloseRightAccessory();
        }
    }, [
        width
    ]);
    var _obj;
    var headerTitleByPath = (_obj = {}, (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.home */.$O.home, t("pages-home_title", "Home")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.following */.$O.following, t("pages-following_title", "Following")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.spaces.new */.$O.spaces["new"], t("pages-new_space_title", "Create Space")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.spaces.edit */.$O.spaces.edit, t("pages-edit_space_title", "Space Settings")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.events.new */.$O.events["new"], t("pages-new_event_title", "Create Event")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.events.events */.$O.events.events, t("pages-events_title", "Events")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.events.event */.$O.events.event, t("pages-event_title", "Event")), (0,_define_property/* default */.Z)(_obj, routerHelpers/* pathnames.events.edit */.$O.events.edit, t("pages-edit_event_title", "Edit Event")), _obj);
    var handleCloseMenu = function() {
        setIsMenuOpen(false);
    };
    var handleOpenMenu = function() {
        setIsMenuOpen(true);
    };
    var handleCloseRightAccessory = function() {
        setIsRightAccessoryOpen(false);
    };
    var handleOpenRightAccessory = function() {
        setIsRightAccessoryOpen(true);
    };
    var ref5 = (0,useQuery/* useQuery */.a)(queries/* SPACE_QUERY */.y, {
        variables: {
            communityId: community.id,
            spaceId: spaceId,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        },
        notifyOnNetworkStatusChange: true,
        skip: !spaceId
    }), loading = ref5.loading, data = ref5.data;
    var space = data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : ref1.communitySpace;
    var headerTitle = [
        routerHelpers/* pathnames.events.events */.$O.events.events,
        routerHelpers/* pathnames.events.event */.$O.events.event
    ].includes(router.pathname) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: MobileNav_cx("mobile-nav__title"),
        children: headerTitleByPath[router.pathname]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        children: headerTitleByPath[router.pathname]
    });
    if (showSpaceDetailsTab && (space === null || space === void 0 ? void 0 : space.name)) {
        headerTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: space === null || space === void 0 ? void 0 : space.name
        });
    } else if (isPostView) {
        headerTitle = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: community === null || community === void 0 ? void 0 : community.name
        });
    }
    var goToEditSpacePage = function(event) {
        event.preventDefault();
        handleCloseRightAccessory();
        (0,routerHelpers/* goToEditSpace */.Z4)(router, spaceId, community.id);
    };
    var spaceDetailsFooter = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: MobileNav_cx("mobile-nav__separator")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                appearance: "knockout",
                className: MobileNav_cx("mobile-nav__button"),
                href: "/communities/".concat(community.id, "/spaces/").concat(spaceId, "/edit/"),
                type: "button",
                onClick: goToEditSpacePage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                        name: "cog",
                        title: t("pages-edit_space_title", "Space Settings")
                    }),
                    t("pages-edit_space_title", "Space Settings")
                ]
            })
        ]
    });
    var canManageSpace = (0,userHelpers/* canAccess */.WL)([
        constants/* USER_ROLES.SITE_OWNER_SITE_ADMIN */.pR.SITE_OWNER_SITE_ADMIN,
        constants/* USER_ROLES.SITE_ADMIN */.pR.SITE_ADMIN,
        constants/* USER_ROLES.PARTNER */.pR.PARTNER, 
    ], currentUser);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenu_MobileMenu, {
            goToPostListPage: (0,routerHelpers/* goToPostListPage */.x9)(router, community.id),
            headerTitle: loading ? "" : headerTitle,
            isEventPage: routerHelpers/* pathnames.events.event */.$O.events.event === router.pathname,
            isOpen: isMenuOpen,
            isPostView: isPostView,
            menuTitle: community === null || community === void 0 ? void 0 : community.name,
            rightAccessory: showSpaceDetailsTab && /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MenuTab, {
                iconName: "circle-outline-info",
                isOpen: isRightAccessoryOpen,
                menuTitle: t("Details"),
                size: "small",
                slideTo: "left",
                title: t("Click to see this Space's information"),
                hasOpenButton: true,
                hasOverlay: true,
                onClose: handleCloseRightAccessory,
                onOpen: handleOpenRightAccessory,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetails/* SpaceDetailsCard */.a, {
                        description: space === null || space === void 0 ? void 0 : space.description,
                        icon: space === null || space === void 0 ? void 0 : space.iconName,
                        imageAltText: space === null || space === void 0 ? void 0 : space.imageAltText,
                        imageUrl: space === null || space === void 0 ? void 0 : space.imageUrl,
                        name: space === null || space === void 0 ? void 0 : space.name
                    }),
                    isCoursesToCommunitiesEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(CourseDetails/* default */.Z, {}),
                    canManageSpace && spaceDetailsFooter
                ]
            }),
            onClose: handleCloseMenu,
            onOpen: handleOpenMenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityActions/* default */.Z, {
                    handleMobileNavClick: handleCloseMenu
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuUserSection_MobileMenuUserSection, {})
            ]
        })
    });
};
/* harmony default export */ var MobileNav_MobileNav = (MobileNav);

;// CONCATENATED MODULE: ./components/MobileNav/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(99490);
// EXTERNAL MODULE: ./helpers/dateHelpers/index.ts
var dateHelpers = __webpack_require__(17981);
// EXTERNAL MODULE: ./schema/User/queries.ts
var User_queries = __webpack_require__(72175);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./components/ModeratorBadge/index.ts + 1 modules
var ModeratorBadge = __webpack_require__(45475);
// EXTERNAL MODULE: ./koba/components/SkeletonPost/index.ts
var SkeletonPost = __webpack_require__(13925);
// EXTERNAL MODULE: ./components/Profile/components/ProfilePanelSkeleton/ProfilePanelSkeleton.module.scss
var ProfilePanelSkeleton_module = __webpack_require__(20513);
var ProfilePanelSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePanelSkeleton_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfilePanelSkeleton/ProfilePanelSkeleton.tsx





var ProfilePanelSkeleton_cx = bind_default().bind((ProfilePanelSkeleton_module_default()));
var ProfilePanel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProfilePanelSkeleton_cx("skeleton-profile-panel"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProfilePanelSkeleton_cx("skeleton-profile-panel__avatar")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "40px",
                width: "100%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "20px",
                width: "70%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "20px",
                width: "90%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "20px",
                width: "75%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                height: "20px",
                width: "30%"
            })
        ]
    });
};
/* harmony default export */ var ProfilePanelSkeleton = (ProfilePanel);

// EXTERNAL MODULE: ./schema/Post/queries.ts
var Post_queries = __webpack_require__(95313);
// EXTERNAL MODULE: ./components/Profile/components/ProfilePostSkeleton/ProfilePostSkeleton.module.scss
var ProfilePostSkeleton_module = __webpack_require__(8446);
var ProfilePostSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePostSkeleton_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfilePostSkeleton/ProfilePostSkeleton.tsx





var ProfilePostSkeleton_cx = bind_default().bind((ProfilePostSkeleton_module_default()));
var ProfilePostSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProfilePostSkeleton_cx("profile-post-skeleton"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProfilePostSkeleton_cx("profile-post-skeleton__avatar")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: ProfilePostSkeleton_cx("profile-post-skeleton__body"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        width: "80px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        width: "160px"
                    })
                ]
            })
        ]
    });
};
var ProfilePostSkeletonContainer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProfilePostSkeleton_cx("profile-post-skeleton__container"),
        "data-qa": "profile-post-skeleton__container",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostSkeleton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostSkeleton, {})
        ]
    });
};
/* harmony default export */ var ProfilePostSkeleton_ProfilePostSkeleton = ({
    ProfilePostSkeleton: ProfilePostSkeleton,
    ProfilePostSkeletonContainer: ProfilePostSkeletonContainer
});

// EXTERNAL MODULE: ./components/Profile/components/ProfilePostEmptyState/ProfilePostEmptyState.module.scss
var ProfilePostEmptyState_module = __webpack_require__(76337);
var ProfilePostEmptyState_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePostEmptyState_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfilePostEmptyState/ProfilePostEmptyState.tsx







var ProfilePostEmptyState_cx = bind_default().bind((ProfilePostEmptyState_module_default()));
var ProfilePostEmptyState = function(param) {
    var userName = param.userName;
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: ProfilePostEmptyState_cx("profile-empty-state"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                className: ProfilePostEmptyState_cx("profile-empty-state__icon"),
                height: 32,
                name: "content-discussions",
                width: 32
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                className: ProfilePostEmptyState_cx("profile-empty-state__title"),
                "data-qa": ProfilePostEmptyState_cx("profile-empty-state__title"),
                children: t("No activity to show")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography.P, {
                className: ProfilePostEmptyState_cx("profile-empty-state__subtitle"),
                "data-qa": "profile-empty-state__subtitle",
                children: [
                    t("components-profile-profile_empty_state_no_recent_posts", "{{userName}} hasn\u2019t posted in the last while.", {
                        userName: userName
                    }),
                    " ",
                    t("components-profile-profile_empty_state_suggestion", "Invite them to a conversation by mentioning their name.")
                ]
            })
        ]
    });
};
/* harmony default export */ var ProfilePostEmptyState_ProfilePostEmptyState = (ProfilePostEmptyState);

// EXTERNAL MODULE: ./components/Profile/components/ProfilePost/ProfilePost.module.scss
var ProfilePost_module = __webpack_require__(80991);
var ProfilePost_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePost_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfilePost/ProfilePost.tsx











var ProfilePost_cx = bind_default().bind((ProfilePost_module_default()));
var ProfilePost = function(param) {
    var author = param.author, createdAt = param.createdAt, title = param.title, id = param.id, onPostClick = param.onPostClick;
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref.community, trackEvent = ref.trackEvent, currentUser = ref.currentUser;
    var postRef = (0,react.useRef)(null);
    var time = (0,dateHelpers/* relativeFormattedDateTime */.f6)(createdAt, currentUser === null || currentUser === void 0 ? void 0 : currentUser.locale, t);
    var handlePostClick = function() {
        (0,routerHelpers/* goToPostPage */.YY)(router, community.id, id);
        trackEvent(trackingEvents/* default.PAST_ACTIVITY_CLICKED */.ZP.PAST_ACTIVITY_CLICKED, {});
        onPostClick();
    };
    var postedText = t("{{name}} posted {{time}}", {
        name: author.firstName,
        time: time
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: ProfilePost_cx("profile-post"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            className: ProfilePost_cx("profile-post__label"),
            "data-qa": "profile-post__label",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    title: postedText,
                    children: postedText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ProfilePost_cx("profile-post__details"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                            avatarUrl: author === null || author === void 0 ? void 0 : author.avatarUrl,
                            className: ProfilePost_cx("profile-post__avatar"),
                            size: "sm",
                            srcSet: "".concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=40 1x, ").concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=40&dpr=2 2x, ").concat(author === null || author === void 0 ? void 0 : author.avatarUrl, "?width=40&dpr=3 3x"),
                            userId: author.id,
                            username: author.fullName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "aria-label": t("Read full post: {{title}}", {
                                title: title
                            }),
                            className: ProfilePost_cx("profile-post__title"),
                            "data-qa": "profile-post__title",
                            ref: postRef,
                            role: "button",
                            tabIndex: 0,
                            onClick: handlePostClick,
                            onKeyPress: function(e) {
                                if (e.key === "Enter" || e.key === " ") {
                                    handlePostClick();
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: title
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ProfilePost_ProfilePost = (ProfilePost);

// EXTERNAL MODULE: ./components/Profile/components/ProfilePastActivity/ProfilePastActivity.module.scss
var ProfilePastActivity_module = __webpack_require__(85011);
var ProfilePastActivity_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePastActivity_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfilePastActivity/ProfilePastActivity.tsx













var ProfilePastActivity_cx = bind_default().bind((ProfilePastActivity_module_default()));
var ProfilePastActivity = function(param) {
    var onClose = param.onClose, userId = param.userId, user = param.user;
    var ref, ref1;
    var t = (0,es/* useTranslation */.$G)().t;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var ref2 = (0,useQuery/* useQuery */.a)(Post_queries/* POST_LIST_QUERY */.c, {
        fetchPolicy: "cache-and-network",
        skip: !userId,
        notifyOnNetworkStatusChange: true,
        variables: {
            communityId: community.id,
            numOfPosts: constants/* POSTS_ON_PROFILE_VIEW */.yW,
            postOrderField: constants/* POST_ORDER_FIELDS.CREATED_AT */.Jq.CREATED_AT,
            filter: {
                userId: userId
            },
            numberOfReactions: constants/* NUMBER_OF_REACTIONS */.ed
        }
    }), isPostQueryLoading = ref2.loading, postListData = ref2.data;
    var posts = (postListData === null || postListData === void 0 ? void 0 : (ref = postListData.community) === null || ref === void 0 ? void 0 : (ref1 = ref.posts) === null || ref1 === void 0 ? void 0 : ref1.edges) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: ProfilePastActivity_cx("past-activity"),
        children: isPostQueryLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostSkeletonContainer, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: posts.length !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                        className: ProfilePastActivity_cx("past-activity__title"),
                        "data-qa": "past-activity__title",
                        children: t("Past activity")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: posts.map(function(param) {
                            var node = param.node;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePost_ProfilePost, {
                                author: node.user,
                                createdAt: node.createdAt,
                                id: node.id,
                                title: node.title,
                                onPostClick: onClose
                            }, node.id);
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePostEmptyState_ProfilePostEmptyState, {
                userName: (user === null || user === void 0 ? void 0 : user.firstName) || ""
            })
        })
    });
};
/* harmony default export */ var ProfilePastActivity_ProfilePastActivity = (ProfilePastActivity);

// EXTERNAL MODULE: ./components/Profile/ProfilePanel.module.scss
var ProfilePanel_module = __webpack_require__(80868);
var ProfilePanel_module_default = /*#__PURE__*/__webpack_require__.n(ProfilePanel_module);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/CardList-7847c099.js + 1 modules
var CardList_7847c099 = __webpack_require__(80579);
// EXTERNAL MODULE: ./koba/components/CircularSpinner/index.ts + 1 modules
var CircularSpinner = __webpack_require__(71939);
// EXTERNAL MODULE: ./components/Profile/components/ProfileCompletedCourses/ProfileCompletedCourses.module.scss
var ProfileCompletedCourses_module = __webpack_require__(1804);
var ProfileCompletedCourses_module_default = /*#__PURE__*/__webpack_require__.n(ProfileCompletedCourses_module);
;// CONCATENATED MODULE: ./components/Profile/components/ProfileCompletedCourses/ProfileCompletedCourses.tsx

/* eslint-disable camelcase */ 










var ProfileCompletedCourses_cx = bind_default().bind((ProfileCompletedCourses_module_default()));
var ProfileCompletedCourses = function(param) {
    var enrollments = param.enrollments, isLoadingMore = param.isLoadingMore, onLoadMoreCourses = param.onLoadMoreCourses;
    var ref, ref1, ref2;
    var t = (0,es/* useTranslation */.$G)().t;
    var currentUser = (0,CommunityContext/* useCommunityContext */.v1)().currentUser;
    var handleNavigation = function(e, resumeCourseUrl, landingPageUrl) {
        if (e.type === "click" || e.key === "Enter" || e.key === " ") {
            window.location.assign((0,userHelpers/* isSiteAdmin */.$1)(currentUser.roles) ? landingPageUrl : resumeCourseUrl);
        }
    };
    if (!(enrollments === null || enrollments === void 0 ? void 0 : (ref = enrollments.edges) === null || ref === void 0 ? void 0 : ref.length)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: ProfileCompletedCourses_cx("completed-courses__section"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                className: ProfileCompletedCourses_cx("completed-courses__section-title"),
                "data-qa": "completed-courses__section-title",
                children: t("COMPLETED COURSES")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardList_7847c099.b, {
                variation: "list",
                children: enrollments === null || enrollments === void 0 ? void 0 : (ref1 = enrollments.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(enrollment) {
                    var ref, ref1, ref2, ref3, ref4, ref5;
                    var time = (0,dateHelpers/* relativeFormattedDateTime */.f6)(enrollment === null || enrollment === void 0 ? void 0 : (ref = enrollment.node) === null || ref === void 0 ? void 0 : ref.completedAt, currentUser === null || currentUser === void 0 ? void 0 : currentUser.locale, t);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ProfileCompletedCourses_cx("completed-courses__section-card"),
                        "data-qa": "profile-course__card",
                        role: "link",
                        tabIndex: 0,
                        onClick: function(event) {
                            var ref, ref1, ref2, ref3;
                            return handleNavigation(event, enrollment === null || enrollment === void 0 ? void 0 : (ref = enrollment.node) === null || ref === void 0 ? void 0 : (ref1 = ref.course) === null || ref1 === void 0 ? void 0 : ref1.resumeCourseUrl, enrollment === null || enrollment === void 0 ? void 0 : (ref2 = enrollment.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.course) === null || ref3 === void 0 ? void 0 : ref3.landingPageUrl);
                        },
                        onKeyPress: function(event) {
                            var ref, ref1, ref2, ref3;
                            return handleNavigation(event, enrollment === null || enrollment === void 0 ? void 0 : (ref = enrollment.node) === null || ref === void 0 ? void 0 : (ref1 = ref.course) === null || ref1 === void 0 ? void 0 : ref1.resumeCourseUrl, enrollment === null || enrollment === void 0 ? void 0 : (ref2 = enrollment.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.course) === null || ref3 === void 0 ? void 0 : ref3.landingPageUrl);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardList_7847c099.a, {
                            caption: t("Completed {{dateTime}}", {
                                dateTime: time
                            }),
                            image: (enrollment === null || enrollment === void 0 ? void 0 : (ref1 = enrollment.node) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.course) === null || ref2 === void 0 ? void 0 : ref2.cardImageUrl) || "",
                            name: enrollment === null || enrollment === void 0 ? void 0 : (ref3 = enrollment.node) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.course) === null || ref4 === void 0 ? void 0 : ref4.name
                        })
                    }, enrollment === null || enrollment === void 0 ? void 0 : (ref5 = enrollment.node) === null || ref5 === void 0 ? void 0 : ref5.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProfileCompletedCourses_cx("completed-courses__section-button"),
                children: isLoadingMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularSpinner/* default */.Z, {
                    variation: "medium"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (enrollments === null || enrollments === void 0 ? void 0 : (ref2 = enrollments.pageInfo) === null || ref2 === void 0 ? void 0 : ref2.hasNextPage) && // @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        appearance: "ghost",
                        className: ProfileCompletedCourses_cx("load-more"),
                        "data-qa": "completed-course__button",
                        onClick: onLoadMoreCourses,
                        children: t("See More")
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProfileCompletedCourses_ProfileCompletedCourses = (ProfileCompletedCourses);

;// CONCATENATED MODULE: ./components/Profile/ProfilePanel.tsx

























var ProfilePanel_cx = bind_default().bind((ProfilePanel_module_default()));
var ProfilePanel_ProfilePanel = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, userId = param.userId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var ref15 = (0,react.useState)(false), isLoadingMore = ref15[0], setIsLoadingMore = ref15[1];
    var t = (0,es/* useTranslation */.$G)().t;
    var ref16 = (0,CommunityContext/* useCommunityContext */.v1)(), trackEvent = ref16.trackEvent, currentUser = ref16.currentUser, community = ref16.community;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var ref17 = (0,useQuery/* useQuery */.a)(User_queries/* USER_QUERY */.Qt, {
        variables: {
            communityId: community.id,
            userId: userId,
            numOfCourses: constants/* COURSES_ON_PROFILE_VIEW */.xc
        },
        fetchPolicy: "cache-and-network",
        skip: !userId,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), data = ref17.data, isUserQueryLoading = ref17.loading, fetchMore = ref17.fetchMore, previousData = ref17.previousData;
    var user = data === null || data === void 0 ? void 0 : (ref = data.community) === null || ref === void 0 ? void 0 : (ref1 = ref.communityUser) === null || ref1 === void 0 ? void 0 : ref1.user;
    var hasRoles = user === null || user === void 0 ? void 0 : (ref2 = user.roles) === null || ref2 === void 0 ? void 0 : ref2.length;
    var canModerate = data === null || data === void 0 ? void 0 : (ref3 = data.community) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.communityUser) === null || ref4 === void 0 ? void 0 : ref4.canModerate;
    var userHasModeratorBadge = hasRoles ? (0,userHelpers/* hasModeratorBadge */.x)(user) : false;
    var roles = userHasModeratorBadge ? t("Moderator") : user === null || user === void 0 ? void 0 : (ref5 = user.roles) === null || ref5 === void 0 ? void 0 : ref5.join(", ");
    var renderModeratorBadge = function() {
        // The flag related condition needs to be deleted along with the flag removal.
        if (userHasModeratorBadge || canModerate) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ProfilePanel_cx("profile-panel__moderator-badge__container"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeratorBadge/* default */.Z, {
                    children: t("common-Moderator", "Moderator")
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: ProfilePanel_cx("profile-panel__roles"),
            children: t("common-Member", "Member")
        });
    };
    var isDifferentUser = (user === null || user === void 0 ? void 0 : user.id) !== (previousData === null || previousData === void 0 ? void 0 : (ref6 = previousData.community) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.communityUser) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.user) === null || ref8 === void 0 ? void 0 : ref8.id);
    var handleEditProfile = function(event) {
        event.preventDefault();
        trackEvent(trackingEvents/* default.EDIT_PROFILE_FROM_PROFILE_PANEL_CLICKED */.ZP.EDIT_PROFILE_FROM_PROFILE_PANEL_CLICKED, {});
        window.location.href = "/account";
    };
    var formatUserLocalTime = function() {
        var ref;
        var localTime = luxon/* DateTime.now */.ou.now().setZone((user === null || user === void 0 ? void 0 : (ref = user.profile) === null || ref === void 0 ? void 0 : ref.timezone) || "").toFormat(dateHelpers/* TIMEZONE_FORMAT */.km, {
            locale: currentUser.locale
        });
        return localTime;
    };
    var onLoadMoreCourses = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setIsLoadingMore(true);
                        _ctx.next = 4;
                        return fetchMore({
                            variables: {
                                endCursor: user === null || user === void 0 ? void 0 : (ref = user.enrollments) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.endCursor
                            }
                        });
                    case 4:
                        setIsLoadingMore(false);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onLoadMoreCourses() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderSubtitle = function() {
        if (!(user === null || user === void 0 ? void 0 : user.profile)) return null;
        var ref = user === null || user === void 0 ? void 0 : user.profile, headline = ref.headline, company = ref.company;
        if (!headline && !company) return null;
        var subtitle = "";
        if (headline) {
            subtitle += headline;
        }
        if (company) {
            if (subtitle.trim()) {
                subtitle += ", ".concat(company);
            } else {
                subtitle += company;
            }
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H3, {
            className: ProfilePanel_cx("profile-panel__subtitle"),
            title: subtitle,
            children: subtitle
        });
    };
    var closeButton = !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: ProfilePanel_cx("profile-panel__close"),
        "data-qa": "profile-panel__close",
        name: "x-dismiss",
        title: t("Close profile panel"),
        onClick: onClose
    });
    var hasNoProfile = !isUserQueryLoading && userId && !(data === null || data === void 0 ? void 0 : (ref9 = data.community) === null || ref9 === void 0 ? void 0 : ref9.communityUser);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuTab, {
        hasHeader: isMobile,
        hasOverlay: isMobile,
        isOpen: isOpen,
        menuTitle: t("Profile"),
        size: isMobile ? "medium" : "large",
        slideTo: "left",
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            "aria-label": "".concat(user === null || user === void 0 ? void 0 : user.fullName, " profile."),
            className: ProfilePanel_cx("profile-panel"),
            "data-qa": "profile-panel__wrapper",
            role: "dialog",
            children: [
                isUserQueryLoading && isDifferentUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ProfilePanel_cx("profile-panel__skeleton"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePanelSkeleton, {}),
                        closeButton
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: ProfilePanel_cx("profile-panel__content"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ProfilePanel_cx("profile-panel__header"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar/* default */.Z, {
                                    avatarUrl: (user === null || user === void 0 ? void 0 : (ref10 = user.profile) === null || ref10 === void 0 ? void 0 : ref10.avatarUrl) || "",
                                    className: ProfilePanel_cx("profile-panel__avatar"),
                                    size: "lg",
                                    srcSet: "".concat(user === null || user === void 0 ? void 0 : (ref11 = user.profile) === null || ref11 === void 0 ? void 0 : ref11.avatarUrl, "?width=148 1x, ").concat(user === null || user === void 0 ? void 0 : (ref12 = user.profile) === null || ref12 === void 0 ? void 0 : ref12.avatarUrl, "?width=148&dpr=2 2x, ").concat(user === null || user === void 0 ? void 0 : (ref13 = user.profile) === null || ref13 === void 0 ? void 0 : ref13.avatarUrl, "?width=148&dpr=3 3x"),
                                    userId: (user === null || user === void 0 ? void 0 : user.id) || "",
                                    username: (user === null || user === void 0 ? void 0 : user.fullName) || ""
                                }),
                                closeButton
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: ProfilePanel_cx("profile-panel__info"),
                            children: [
                                (user === null || user === void 0 ? void 0 : user.fullName) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                                    className: ProfilePanel_cx("profile-panel__title"),
                                    title: user === null || user === void 0 ? void 0 : user.fullName,
                                    children: user === null || user === void 0 ? void 0 : user.fullName
                                }),
                                (user === null || user === void 0 ? void 0 : user.profile) && renderSubtitle(),
                                (user === null || user === void 0 ? void 0 : (ref14 = user.profile) === null || ref14 === void 0 ? void 0 : ref14.timezone) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography.P, {
                                    className: ProfilePanel_cx("profile-panel__label"),
                                    children: [
                                        t("Local time"),
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: formatUserLocalTime()
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: ProfilePanel_cx("profile-panel__label"),
                                    children: [
                                        t("Community Role"),
                                        renderModeratorBadge()
                                    ]
                                }),
                                currentUser.id === userId && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: ProfilePanel_cx("profile-panel__link"),
                                    href: "/account",
                                    onClick: handleEditProfile,
                                    children: t("Edit Profile")
                                })
                            ]
                        }),
                        !(roles === null || roles === void 0 ? void 0 : roles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileCompletedCourses_ProfileCompletedCourses, {
                            enrollments: user === null || user === void 0 ? void 0 : user.enrollments,
                            isLoadingMore: isLoadingMore,
                            onLoadMoreCourses: onLoadMoreCourses
                        })
                    ]
                }),
                hasNoProfile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: ProfilePanel_cx("profile-panel__no-info"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                            className: ProfilePanel_cx("profile-panel__no-info__title"),
                            "data-qa": "profile-panel__no-info__title",
                            children: t("components-profile-no_profile_information", "No profile information.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.P, {
                            className: ProfilePanel_cx("profile-panel__no-info__text"),
                            children: t("components-profile-no_info_text", "This person may no longer be part of the community.")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePastActivity_ProfilePastActivity, {
                    user: user,
                    userId: userId,
                    onClose: onClose
                })
            ]
        })
    });
};
/* harmony default export */ var Profile_ProfilePanel = (ProfilePanel_ProfilePanel);

// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Badge-95ef19f1.js
var Badge_95ef19f1 = __webpack_require__(36160);
// EXTERNAL MODULE: ./schema/Event/queries.ts + 1 modules
var Event_queries = __webpack_require__(20143);
// EXTERNAL MODULE: ./helpers/eventHelpers.ts
var eventHelpers = __webpack_require__(7856);
// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EventInterestedButton/EventInterestedButton.tsx
var EventInterestedButton = __webpack_require__(75196);
// EXTERNAL MODULE: ./components/CommunityUsers/components/CommunityUsersAvatars.tsx
var CommunityUsersAvatars = __webpack_require__(83622);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Loader-fe940c7c.js
var Loader_fe940c7c = __webpack_require__(75826);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EventInterestedUsers/EventInterestedUsers.module.scss
var EventInterestedUsers_module = __webpack_require__(1196);
var EventInterestedUsers_module_default = /*#__PURE__*/__webpack_require__.n(EventInterestedUsers_module);
;// CONCATENATED MODULE: ./components/Events/components/EventPanel/components/EventInterestedUsers/EventInterestedUsers.tsx













var EventInterestedUsers_cx = bind_default().bind((EventInterestedUsers_module_default()));
var EventInterestedUsers = function(param) {
    var eventId = param.eventId;
    var ref, ref1, ref2;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref3 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref3.currentUser, community = ref3.community;
    var router = (0,next_router.useRouter)();
    var handleGoToEventPage = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (eventId && (community === null || community === void 0 ? void 0 : community.id)) {
            (0,routerHelpers/* goToEvent */.s6)(router, eventId, community.id);
        }
    };
    var ref4 = (0,useQuery/* useQuery */.a)(Event_queries/* LIVE_EVENT_QUERY */.U7, {
        variables: {
            eventId: eventId
        },
        notifyOnNetworkStatusChange: true,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), data = ref4.data, loading = ref4.loading;
    var liveEvent = data === null || data === void 0 ? void 0 : (ref = data.site) === null || ref === void 0 ? void 0 : ref.liveEvent;
    var totalUsers = (liveEvent === null || liveEvent === void 0 ? void 0 : (ref1 = liveEvent.interestedUsers) === null || ref1 === void 0 ? void 0 : ref1.totalCount) || 0;
    var interestedUsersEdges = liveEvent === null || liveEvent === void 0 ? void 0 : (ref2 = liveEvent.interestedUsers) === null || ref2 === void 0 ? void 0 : ref2.edges;
    var interestedUsers = [];
    interestedUsers = (interestedUsersEdges === null || interestedUsersEdges === void 0 ? void 0 : interestedUsersEdges.map(function(edge) {
        var ref, ref1, ref2, ref3;
        return {
            id: (edge === null || edge === void 0 ? void 0 : (ref = edge.node) === null || ref === void 0 ? void 0 : ref.id) || "",
            fullName: (edge === null || edge === void 0 ? void 0 : (ref1 = edge.node) === null || ref1 === void 0 ? void 0 : ref1.fullName) || "",
            profile: {
                avatarUrl: (edge === null || edge === void 0 ? void 0 : (ref2 = edge.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.profile) === null || ref3 === void 0 ? void 0 : ref3.avatarUrl) || ""
            }
        };
    }).filter(function(user) {
        return user.id !== currentUser.id;
    })) || [];
    // Makes sure the first UserAvatar shown is the current user logged
    if (liveEvent === null || liveEvent === void 0 ? void 0 : liveEvent.isInterested) {
        interestedUsers === null || interestedUsers === void 0 ? void 0 : interestedUsers.unshift({
            id: currentUser.id,
            fullName: currentUser.fullName,
            profile: {
                avatarUrl: currentUser.avatarUrl
            }
        });
    }
    // // if interestedUsers length is bigger than 4 it means that the currentUser
    // // wasn't returned by the USERS_QUERY and we need to display it + 3 users
    if (interestedUsers.length > 4) interestedUsers = interestedUsers.slice(0, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader_fe940c7c.L, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: EventInterestedUsers_cx("event-interested-users__container"),
            "data-qa": "event-interested-users",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityUsersAvatars/* default */.Z, {
                    className: EventInterestedUsers_cx("event-interested-users"),
                    text: t("components-events-eventPanel-interested", "interested"),
                    tooltipTitle: t("components-eventInterestedUsers-total_member_count_title", "{{userCount}} interested members", {
                        userCount: totalUsers
                    }),
                    totalUsers: totalUsers,
                    users: interestedUsers
                }),
                totalUsers > interestedUsers.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_b37f2f11.B, {
                    appearance: "accessible-link",
                    className: EventInterestedUsers_cx("event-panel__view-all"),
                    "data-qa": "event-panel__view-all",
                    href: "/communities/".concat(community === null || community === void 0 ? void 0 : community.id, "/events/").concat(eventId, "/"),
                    type: "button",
                    onClick: handleGoToEventPage,
                    children: t("common-view-all", "view all")
                })
            ]
        })
    });
};
/* harmony default export */ var EventInterestedUsers_EventInterestedUsers = (EventInterestedUsers);

// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EventContent/EventContent.tsx
var EventContent = __webpack_require__(56613);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/EventPanel.module.scss
var EventPanel_module = __webpack_require__(41018);
var EventPanel_module_default = /*#__PURE__*/__webpack_require__.n(EventPanel_module);
// EXTERNAL MODULE: ./components/Events/components/EventPanel/components/EditEventButton/EditEventButton.tsx
var EditEventButton = __webpack_require__(45022);
;// CONCATENATED MODULE: ./components/Events/components/EventPanel/EventPanel.tsx































var EventPanel_cx = bind_default().bind((EventPanel_module_default()));
var EventPanel = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose, eventId = param.eventId;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var t = (0,es/* useTranslation */.$G)().t;
    var ref2 = (0,CommunityContext/* useCommunityContext */.v1)(), currentUser = ref2.currentUser, community = ref2.community, trackEvent = ref2.trackEvent, featureFlags = ref2.featureFlags;
    var siteFeatures = (0,SiteFeaturesContext/* useSiteFeaturesContext */.Er)().siteFeatures;
    var eventNotificationsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEventNotifications) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var rsvpEnabled = featureFlags[constants_featureFlags/* features.COMMUNITIES_EVENTS_RSVP */.R.COMMUNITIES_EVENTS_RSVP];
    var ref3 = (0,useQuery/* useQuery */.a)(Event_queries/* LIVE_EVENT_QUERY */.U7, {
        variables: {
            eventId: eventId || ""
        },
        skip: !eventId,
        notifyOnNetworkStatusChange: true,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), eventData = ref3.data, liveEventLoading = ref3.loading;
    var event = eventData === null || eventData === void 0 ? void 0 : (ref1 = eventData.site) === null || ref1 === void 0 ? void 0 : ref1.liveEvent;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var hasEventEditPermission = (0,userHelpers/* canEditEvent */.F5)(currentUser);
    var profile = currentUser.profile, locale = currentUser.locale;
    var userTimezone = (profile === null || profile === void 0 ? void 0 : profile.timezone) || undefined;
    var endTime = luxon/* DateTime.fromISO */.ou.fromISO((event === null || event === void 0 ? void 0 : event.endTime) || "", {
        zone: userTimezone,
        locale: locale
    });
    var isPastEvent = luxon/* DateTime.now */.ou.now() > endTime;
    var canJoinEvent = (event === null || event === void 0 ? void 0 : event.meetingUrl) && ((0,dateHelpers/* isEventLive */.MF)(event === null || event === void 0 ? void 0 : event.startTime, event === null || event === void 0 ? void 0 : event.endTime) || (0,dateHelpers/* isEventStartingSoon */.HE)(event === null || event === void 0 ? void 0 : event.startTime, 15));
    var showEventInterestedButton = !!event && !hasEventEditPermission && rsvpEnabled && !isPastEvent && !canJoinEvent && eventNotificationsEnabled;
    var showInterestedUsers = rsvpEnabled && event && !isPastEvent && eventNotificationsEnabled;
    var closeButton = !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: EventPanel_cx("event-panel__close"),
        "data-qa": "event-panel__close",
        name: "x-dismiss",
        title: t("components-events-eventPanel-close_panel", "Close event panel"),
        onClick: onClose
    });
    var handleTitleClick = function(e) {
        e.preventDefault();
        (0,routerHelpers/* goToEvent */.s6)(router, (event === null || event === void 0 ? void 0 : event.id) || "", community.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MenuTab, {
        hasHeader: isMobile,
        hasOverlay: isMobile,
        isOpen: isOpen,
        menuTitle: t("components-events-eventPanel-title", "Event"),
        size: isMobile ? "medium" : "large",
        slideTo: "left",
        wrapperClassName: EventPanel_cx("event-panel"),
        onClose: onClose,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
            "aria-label": "",
            className: EventPanel_cx("event-panel__wrapper"),
            "data-qa": "event-panel__wrapper",
            role: "dialog",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: EventPanel_cx("event-panel__header"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: (event === null || event === void 0 ? void 0 : event.imageAltText) || "",
                            src: (event === null || event === void 0 ? void 0 : event.imageUrl) || constants/* EVENT_IMAGE_PLACEHOLDER */.dm
                        }),
                        closeButton
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: EventPanel_cx("event-panel__content"),
                    children: [
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: EventPanel_cx("event-panel__title"),
                            "data-qa": "event-panel__title",
                            href: "/communities/".concat(community === null || community === void 0 ? void 0 : community.id, "/events/").concat(event === null || event === void 0 ? void 0 : event.id, "/")
                        }, (0,interactions/* a11yOnClick */.Z)(handleTitleClick)), {
                            children: event === null || event === void 0 ? void 0 : event.title
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography.H2, {
                            "data-qa": "event-panel__title",
                            children: event === null || event === void 0 ? void 0 : event.title
                        }),
                        showInterestedUsers && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInterestedUsers_EventInterestedUsers, {
                            eventId: event.id
                        }),
                        isPastEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_95ef19f1.B, {
                            type: "secondary",
                            children: t("components-events-eventPanel-past_event", "Past event")
                        }),
                        event && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContent/* default */.Z, {
                            event: event,
                            parentComponent: "EventPanel"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: EventPanel_cx("event-panel__footer"),
                    "data-qa": "event-panel__footer",
                    children: [
                        hasEventEditPermission && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditEventButton/* default */.Z, {
                            callback: onClose,
                            eventId: (event === null || event === void 0 ? void 0 : event.id) || "",
                            parentComponent: "EventPanel",
                            title: t("common-EDIT", "EDIT")
                        }),
                        showEventInterestedButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInterestedButton/* default */.Z, {
                            eventId: event === null || event === void 0 ? void 0 : event.id,
                            isDisabled: liveEventLoading,
                            isInterested: (event === null || event === void 0 ? void 0 : event.isInterested) || false
                        }),
                        canJoinEvent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            appearance: "default",
                            ariaLabel: t("components-events-eventPanel-access_meeting", "Click to join the meeting. The meeting will be opened in a new window."),
                            color: community.primaryColor,
                            dataQA: "event-panel__join-button",
                            href: (event === null || event === void 0 ? void 0 : event.meetingUrl) || "",
                            isDisabled: isPastEvent,
                            target: "_blank"
                        }, (0,interactions/* a11yOnClick */.Z)(function(e) {
                            return (0,eventHelpers/* handleJoinMeeting */.x)(e, trackingEvents/* default.CLICK_JOIN_LIVE_EVENT */.ZP.CLICK_JOIN_LIVE_EVENT, trackEvent, event.id, event.meetingUrl, "EventPanel");
                        })), {
                            children: t("common-JOIN", "JOIN")
                        }))
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var EventPanel_EventPanel = (EventPanel);

;// CONCATENATED MODULE: ./hooks/Events/useEventPanel.ts


var useEventPanel = function(onOpenCallback) {
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react.useState)(), eventId = ref1[0], setEventId = ref1[1];
    var ref2 = (0,react.useState)(), lastFocusedElementRef = ref2[0], setLastFocusedElementRef = ref2[1];
    (0,react.useEffect)(function() {
        var token = PubSub.subscribe(eventNames/* eventNames.OPEN_EVENT_PANEL */.S.OPEN_EVENT_PANEL, function(msg, info) {
            handleOpenEventPanel(info);
        });
        return function() {
            PubSub.unsubscribe(token);
        };
    }, []);
    var handleCloseEventPanel = function() {
        var ref;
        lastFocusedElementRef === null || lastFocusedElementRef === void 0 ? void 0 : (ref = lastFocusedElementRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        setEventId(null);
        setIsOpen(false);
    };
    var handleOpenEventPanel = function(info) {
        setLastFocusedElementRef(info.lastElementRef);
        setEventId(info.eventId);
        setIsOpen(true);
        onOpenCallback === null || onOpenCallback === void 0 ? void 0 : onOpenCallback();
    };
    return {
        isOpen: isOpen,
        eventId: eventId,
        handleCloseEventPanel: handleCloseEventPanel
    };
};
/* harmony default export */ var Events_useEventPanel = (useEventPanel);

// EXTERNAL MODULE: ./helpers/styleHelpers.js
var styleHelpers = __webpack_require__(89804);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/H2-6b37956c.js
var H2_6b37956c = __webpack_require__(95483);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Input-b1273534.js + 2 modules
var Input_b1273534 = __webpack_require__(28032);
// EXTERNAL MODULE: ./components/ModeratorPanel/ModeratorPanel.module.scss
var ModeratorPanel_module = __webpack_require__(59587);
var ModeratorPanel_module_default = /*#__PURE__*/__webpack_require__.n(ModeratorPanel_module);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Surface-649a6d6c.js
var Surface_649a6d6c = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/H6-b9b7adb2.js
var H6_b9b7adb2 = __webpack_require__(92320);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/P-3714214d.js
var P_3714214d = __webpack_require__(61783);
// EXTERNAL MODULE: ./components/ModeratorPanel/components/ModeratorAccessList/ModeratorAccessList.module.scss
var ModeratorAccessList_module = __webpack_require__(92280);
var ModeratorAccessList_module_default = /*#__PURE__*/__webpack_require__.n(ModeratorAccessList_module);
;// CONCATENATED MODULE: ./components/ModeratorPanel/components/ModeratorAccessList/ModeratorAccessList.tsx






var ModeratorAccessList_cx = bind_default().bind((ModeratorAccessList_module_default()));
var ModeratorAccessList = function() {
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Surface_649a6d6c.S, {
        className: ModeratorAccessList_cx("moderator-access-list"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(H6_b9b7adb2.b, {
                children: t("components-moderatorPanel-permissions_title", "Community Moderator Permissions")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(P_3714214d.P, {
                children: t("components-moderatorPanel-permissions_description", "Permissions below only apply to the community the moderator is assigned to.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                className: ModeratorAccessList_cx("moderator-access-list__allowed"),
                                name: "checkmark"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("components-moderatorPanel-permissions_first_item", "Can create, edit, delete, and pin any post in the community")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                className: ModeratorAccessList_cx("moderator-access-list__allowed"),
                                name: "checkmark"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("components-moderatorPanel-permissions_second_item", "Can create, edit and reorder Spaces")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                className: ModeratorAccessList_cx("moderator-access-list__banned"),
                                name: "x-dismiss"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("components-moderatorPanel-permissions_third_item", "Cannot delete Spaces")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                className: ModeratorAccessList_cx("moderator-access-list__banned"),
                                name: "x-dismiss"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("components-moderatorPanel-permissions_forth_item", "Cannot create, edit or delete events")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                className: ModeratorAccessList_cx("moderator-access-list__banned"),
                                name: "x-dismiss"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("components-moderatorPanel-permissions_fifth_item", "Cannot add or revoke other users' access to the community")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModeratorAccessList_ModeratorAccessList = (ModeratorAccessList);

;// CONCATENATED MODULE: ./components/ModeratorPanel/ModeratorPanel.tsx












var ModeratorPanel_cx = bind_default().bind((ModeratorPanel_module_default()));
var ModeratorPanel = function(param) {
    var isOpen = param.isOpen, onClose = param.onClose;
    var community = (0,CommunityContext/* useCommunityContext */.v1)().community;
    var width = (0,useWindowSize/* useWindowSize */.i)().width;
    var t = (0,es/* useTranslation */.$G)().t;
    var isMobile = width < constants/* SCREEN_LG */.k4;
    var closeButton = !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: ModeratorPanel_cx("moderator-panel__close"),
        "data-qa": "moderator-panel__close",
        name: "x-dismiss",
        title: t("components-moderatorPanel-close_panel", "Close moderator panel"),
        onClick: onClose
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_MenuTab, {
        hasHeader: isMobile,
        hasOverlay: isMobile,
        isOpen: isOpen,
        menuTitle: t("common-Moderator", "Moderator"),
        size: isMobile ? "medium" : "large",
        slideTo: "left",
        wrapperClassName: ModeratorPanel_cx("moderator-panel"),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                "aria-label": ModeratorPanel_cx("Moderator Panel", "Moderator Panel"),
                className: ModeratorPanel_cx("moderator-panel__wrapper"),
                "data-qa": "moderator-panel__wrapper",
                role: "dialog",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: ModeratorPanel_cx("moderator-panel__header"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(H2_6b37956c.H, {
                                children: t("components-moderatorPanel-new_moderator", "New Moderator")
                            }),
                            closeButton
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ModeratorPanel_cx("moderator-panel__search"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_b1273534.I, {
                            ariaLabel: ModeratorPanel_cx("components-moderatorPanel-search_input", "Moderator panel members search input"),
                            extraClasses: ModeratorPanel_cx("moderator-panel__members-search"),
                            extraProps: {
                                "data-qa": "moderator-panel__members-search",
                                id: "moderator-panel__members-search"
                            },
                            label: t("common-Member", "Member"),
                            type: "text"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeratorAccessList_ModeratorAccessList, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: ModeratorPanel_cx("moderator-panel__footer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                    appearance: "default",
                    "aria-label": t("components-moderatorPanel-assign_moderator_button", "Moderator Panel assign moderator button"),
                    className: ModeratorPanel_cx("moderator-panel__assign-button"),
                    color: community.primaryColor,
                    "data-qa": "members__add-moderator-button",
                    children: t("Assign Moderator", "Assign Moderator")
                })
            })
        ]
    });
};
/* harmony default export */ var ModeratorPanel_ModeratorPanel = (ModeratorPanel);

;// CONCATENATED MODULE: ./components/ModeratorPanel/index.ts


;// CONCATENATED MODULE: ./components/Layouts/SiteLayout/SiteLayout.tsx















var SiteLayout = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isProfilePanelOpen = ref[0], setIsProfilePanelOpen = ref[1];
    var ref1 = (0,react.useState)(false), isModeratorPanelOpen = ref1[0], setIsModeratorPanelOpen = ref1[1];
    var ref2 = (0,react.useState)(), lastFocusedElementRef = ref2[0], setLastFocusedElementRef = ref2[1];
    var ref3 = (0,react.useState)(""), selectedUserId = ref3[0], setSelectedUserId = ref3[1];
    var ref4 = (0,CommunityContext/* useCommunityContext */.v1)(), community = ref4.community, site = ref4.site;
    var ref5 = Events_useEventPanel(function() {
        return setIsProfilePanelOpen(false);
    }), eventId = ref5.eventId, handleCloseEventPanel = ref5.handleCloseEventPanel, isEventPanelOpen = ref5.isOpen;
    var t = (0,es/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    var isPostPage = router.pathname === "/[communityId]/post/[postId]";
    var isEventPage = router.pathname === "/[communityId]/events/[eventId]";
    var isSearchPage = router.pathname === "/[communityId]/search";
    (0,react.useEffect)(function() {
        (0,styleHelpers/* setGlobalCSSVariables */.S)(community.primaryColor);
    }, [
        community
    ]);
    (0,react.useEffect)(function() {
        var profileToken = pubsub_default().subscribe(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, function(msg, info) {
            handleOpenProfilePanel(info);
        });
        var moderatorToken = pubsub_default().subscribe(eventNames/* eventNames.OPEN_MODERATOR_PANEL */.S.OPEN_MODERATOR_PANEL, function(msg, info) {
            handleOpenModeratorPanel(info);
        });
        return function() {
            pubsub_default().unsubscribe(profileToken);
            pubsub_default().unsubscribe(moderatorToken);
        };
    }, []);
    var handleCloseProfilePanel = function() {
        var ref;
        lastFocusedElementRef === null || lastFocusedElementRef === void 0 ? void 0 : (ref = lastFocusedElementRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        setSelectedUserId("");
        setIsProfilePanelOpen(false);
    };
    var handleOpenProfilePanel = function(info) {
        handleCloseEventPanel();
        setLastFocusedElementRef(info.lastElementRef);
        setSelectedUserId(info.userId);
        setIsProfilePanelOpen(true);
    };
    var handleOpenModeratorPanel = function(info) {
        setLastFocusedElementRef(info.lastElementRef);
        setIsModeratorPanelOpen(true);
    };
    var handleCloseModeratorPanel = function() {
        var ref;
        lastFocusedElementRef === null || lastFocusedElementRef === void 0 ? void 0 : (ref = lastFocusedElementRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        setIsModeratorPanelOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: community.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: community.name,
                        name: "description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: site.favicon,
                        rel: "shortcut icon",
                        type: "image/x-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBar_TopBar, {
                isDashboardLinkVisible: !isPostPage && !isEventPage && !isSearchPage,
                t: t
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav_MobileNav, {
                community: community,
                isPostView: isPostPage
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Profile_ProfilePanel, {
                isOpen: isProfilePanelOpen,
                userId: selectedUserId,
                onClose: handleCloseProfilePanel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPanel_EventPanel, {
                eventId: eventId,
                isOpen: isEventPanelOpen,
                onClose: handleCloseEventPanel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModeratorPanel_ModeratorPanel, {
                isOpen: isModeratorPanelOpen,
                onClose: handleCloseModeratorPanel
            })
        ]
    });
};
var getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLayout, {
        children: page
    });
};
/* harmony default export */ var SiteLayout_SiteLayout = (SiteLayout);

;// CONCATENATED MODULE: ./components/Layouts/SiteLayout/index.ts




/***/ }),

/***/ 45475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ModeratorBadge_ModeratorBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Badge-95ef19f1.js
var Badge_95ef19f1 = __webpack_require__(36160);
// EXTERNAL MODULE: ./components/ModeratorBadge/ModeratorBadge.module.scss
var ModeratorBadge_module = __webpack_require__(79178);
var ModeratorBadge_module_default = /*#__PURE__*/__webpack_require__.n(ModeratorBadge_module);
;// CONCATENATED MODULE: ./components/ModeratorBadge/ModeratorBadge.tsx





var cx = bind_default().bind((ModeratorBadge_module_default()));
var ModeratorBadge = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_95ef19f1.B, {
        className: cx("moderator-badge", className),
        children: children
    });
};
/* harmony default export */ var ModeratorBadge_ModeratorBadge = (ModeratorBadge);

;// CONCATENATED MODULE: ./components/ModeratorBadge/index.ts



/***/ }),

/***/ 21349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  opacity: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledOpacity = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject(), function(props) {
    return props.value;
});
var Opacity = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledOpacity, {
        value: value,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Opacity);


/***/ }),

/***/ 62185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageSkeleton_PageSkeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/SkeletonPost/index.ts
var SkeletonPost = __webpack_require__(13925);
// EXTERNAL MODULE: ./components/PageSkeleton/PageSkeleton.module.scss
var PageSkeleton_module = __webpack_require__(11579);
var PageSkeleton_module_default = /*#__PURE__*/__webpack_require__.n(PageSkeleton_module);
;// CONCATENATED MODULE: ./components/PageSkeleton/PageSkeleton.tsx





var cx = bind_default().bind((PageSkeleton_module_default()));
var PageSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("page-skeleton__wrapper"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("page-skeleton__navbar"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        height: "24px",
                        width: "160px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        height: "24px",
                        width: "160px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                        height: "24px",
                        width: "160px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("page-skeleton__main"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("page-skeleton__aside"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cx("page-skeleton__aside-first-block"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "40px",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "40px",
                                        width: "100%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cx("page-skeleton__aside-second-block"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "16px",
                                        width: "70px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "40px",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "40px",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "40px",
                                        width: "100%"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: cx("page-skeleton__content"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: cx("page-skeleton__content-first-element"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                        height: "160px",
                                        width: "100%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: cx("page-skeleton__content-first-element-body"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                height: "8px",
                                                width: "209px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                height: "8px",
                                                width: "100%"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                height: "8px",
                                                width: "100%"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                height: "16px",
                                width: "70px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx("page-skeleton__content-empty-block")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: cx("page-skeleton__content-empty-block")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("page-skeleton__info"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cx("page-skeleton__info-community"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                    height: "16px",
                                    width: "60%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: cx("page-skeleton__info-community-container"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: cx("page-skeleton__info-community-post"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: cx("page-skeleton__info-community-container-avatar")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: cx("page-skeleton__info-community-container-body"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                            width: "60px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                            width: "120px"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: cx("page-skeleton__info-community-post"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: cx("page-skeleton__info-community-container-avatar")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: cx("page-skeleton__info-community-container-body"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                            width: "60px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonPost/* SkeletonLine */.AU, {
                                                            width: "120px"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSkeleton_PageSkeleton = (PageSkeleton);

;// CONCATENATED MODULE: ./components/PageSkeleton/index.ts



/***/ }),

/***/ 40670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cm": function() { return /* reexport */ SiteFeaturesProvider; },
  "Er": function() { return /* reexport */ useSiteFeaturesContext; }
});

// UNUSED EXPORTS: SiteFeaturesContext

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(75063);
;// CONCATENATED MODULE: ./schema/SiteFeatures/queries.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SiteFeatures($communityId: ID!) {\n    site {\n      id\n      features {\n        communities {\n          maxCommunitySpaces\n        }\n        communityEvents {\n          isEnabled\n        }\n        communityEventNotifications {\n          isEnabled\n        }\n      }\n    }\n    community(id: $communityId) {\n      id\n      communitySections {\n        edges {\n          node {\n            id\n            communitySpaces {\n              totalCount\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SITE_FEATURES_QUERY = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
;// CONCATENATED MODULE: ./components/SiteFeaturesContext/SiteFeaturesContext.tsx





var SiteFeaturesContext = /*#__PURE__*/ (0,react.createContext)({});
var useSiteFeaturesContext = function() {
    return (0,react.useContext)(SiteFeaturesContext);
};
var SiteFeaturesProvider = function(param) {
    var children = param.children;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,CommunityContext/* useCommunityContext */.v1)(), id = ref7.community.id;
    var data = (0,useQuery/* useQuery */.a)(SITE_FEATURES_QUERY, {
        variables: {
            communityId: id
        }
    }).data;
    var siteFeatures = data === null || data === void 0 ? void 0 : (ref = data.site) === null || ref === void 0 ? void 0 : ref.features;
    var maxSpacesAllowed = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref1 = siteFeatures.communities) === null || ref1 === void 0 ? void 0 : ref1.maxCommunitySpaces;
    var communitySectionsEdges = data === null || data === void 0 ? void 0 : (ref2 = data.community) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.communitySections) === null || ref3 === void 0 ? void 0 : ref3.edges;
    var communitySpacesTotalCount = communitySectionsEdges && ((ref4 = communitySectionsEdges[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.node) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.communitySpaces) === null || ref6 === void 0 ? void 0 : ref6.totalCount);
    var exceededPlanSpaces = maxSpacesAllowed && communitySpacesTotalCount ? maxSpacesAllowed - communitySpacesTotalCount <= 0 : false;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteFeaturesContext.Provider, {
        value: {
            siteFeatures: siteFeatures,
            communitySpacesTotalCount: communitySpacesTotalCount,
            exceededPlanSpaces: exceededPlanSpaces
        },
        children: children
    });
};


;// CONCATENATED MODULE: ./components/SiteFeaturesContext/index.ts



/***/ }),

/***/ 43650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13925);
/* harmony import */ var _SpaceDetailsSkeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76259);
/* harmony import */ var _SpaceDetailsSkeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_SpaceDetailsSkeleton_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_SpaceDetailsSkeleton_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var SpaceDetailsSkeleton = function(param) {
    var hideImageSkeleton = param.hideImageSkeleton;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("space-details-skeleton__container"),
        "data-qa": "space-details-skeleton",
        children: [
            !hideImageSkeleton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonLine */ .AU, {
                height: "147px",
                width: "100%"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx("space-details-skeleton__body"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonLine */ .AU, {
                        height: "16px",
                        width: "40%"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: cx("space-details-skeleton__description"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonLine */ .AU, {
                                height: "16px",
                                width: "60%"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonLine */ .AU, {
                                height: "16px",
                                width: "70%"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(koba_components_SkeletonPost__WEBPACK_IMPORTED_MODULE_3__/* .SkeletonLine */ .AU, {
                                height: "16px",
                                width: "80%"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SpaceDetailsSkeleton);


/***/ }),

/***/ 19024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ SpaceDetails_SpaceDetails; },
  "a": function() { return /* reexport */ SpaceDetailsCard_SpaceDetailsCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Surface-649a6d6c.js
var Surface_649a6d6c = __webpack_require__(64828);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Badge-95ef19f1.js
var Badge_95ef19f1 = __webpack_require__(36160);
// EXTERNAL MODULE: ./components/Image/index.ts + 1 modules
var Image = __webpack_require__(82513);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./helpers/spaceHelpers.ts
var spaceHelpers = __webpack_require__(68556);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./components/SpaceDetails/components/SpaceDetailsCard/SpaceDetailsCard.module.scss
var SpaceDetailsCard_module = __webpack_require__(21540);
var SpaceDetailsCard_module_default = /*#__PURE__*/__webpack_require__.n(SpaceDetailsCard_module);
;// CONCATENATED MODULE: ./components/SpaceDetails/components/SpaceDetailsCard/SpaceDetailsCard.tsx









var cx = bind_default().bind((SpaceDetailsCard_module_default()));
var SpaceDetailsCard = function(param) {
    var name = param.name, description = param.description, icon = param.icon, imageUrl = param.imageUrl, imageAltText = param.imageAltText, isExclusiveMember = param.isExclusiveMember, className = param.className, footerAccessory = param.footerAccessory, dataQA = param.dataQA, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage, _inheritPrimaryColor = param.inheritPrimaryColor, inheritPrimaryColor = _inheritPrimaryColor === void 0 ? true : _inheritPrimaryColor, _renderDescriptionAsHTML = param.renderDescriptionAsHTML, renderDescriptionAsHTML = _renderDescriptionAsHTML === void 0 ? false : _renderDescriptionAsHTML;
    var t = (0,es/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("space-details__container", className),
        "data-qa": dataQA,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Surface_649a6d6c.S, {
            className: cx("space-details__wrapper"),
            children: [
                showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("space-details__image"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: imageAltText || "",
                        height: 294,
                        src: imageUrl || constants/* SPACE_IMAGE_PLACEHOLDER */.zq,
                        width: 524
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: cx("space-details__body", "p-2"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cx("space-details__header"),
                            children: [
                                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_343b84c4.I, {
                                    className: cx({
                                        "space-details__icon--inherit": inheritPrimaryColor
                                    }),
                                    "data-qa": "space-card-icon__image",
                                    name: (0,spaceHelpers/* getIconNameByStoredValue */.i)(icon)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: cx("space-details__title", "h3"),
                                    "data-qa": "space-card-name__text",
                                    title: name,
                                    children: name
                                })
                            ]
                        }),
                        !isExclusiveMember && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: cx("space-details__description", "mt-2"),
                            "data-qa": "space-card-description__text",
                            title: description,
                            children: renderDescriptionAsHTML ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                dangerouslySetInnerHTML: {
                                    __html: description !== null && description !== void 0 ? description : ""
                                }
                            }) : description
                        }),
                        isExclusiveMember && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_95ef19f1.B, {
                                className: cx("space-details__badge"),
                                icon: "lock",
                                type: "secondary",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("common-Exclusive", "Exclusive")
                                })
                            })
                        })
                    ]
                }),
                !isExclusiveMember && footerAccessory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("space-details__footer"),
                    children: footerAccessory
                })
            ]
        })
    });
};
/* harmony default export */ var SpaceDetailsCard_SpaceDetailsCard = (SpaceDetailsCard);

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(37887);
// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./schema/Space/queries.ts
var queries = __webpack_require__(73820);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./components/Opacity/Opacity.tsx
var Opacity = __webpack_require__(21349);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./constants/featureFlags.ts
var constants_featureFlags = __webpack_require__(46139);
// EXTERNAL MODULE: ./components/SpaceDetails/components/SpaceDetailsSkeleton/SpaceDetailsSkeleton.tsx
var SpaceDetailsSkeleton = __webpack_require__(43650);
;// CONCATENATED MODULE: ./components/SpaceDetails/SpaceDetails.tsx
















var SpaceDetails = function(param) {
    var communityId = param.communityId, spaceId = param.spaceId, footerAccessory = param.footerAccessory, className = param.className;
    var ref, ref1, ref2, ref3;
    var t = (0,es/* useTranslation */.$G)().t;
    var featureFlags = (0,CommunityContext/* useCommunityContext */.v1)().featureFlags;
    var router = (0,next_router.useRouter)();
    var isCoursesToCommunitiesEnabled = featureFlags[constants_featureFlags/* features.COURSES_TO_COMMUNITIES */.R.COURSES_TO_COMMUNITIES];
    var ref4 = (0,react.useState)(""), description = ref4[0], setDescription = ref4[1];
    var ref5 = (0,react.useState)(""), imageUrl = ref5[0], setImageUrl = ref5[1];
    var ref6 = (0,useQuery/* useQuery */.a)(queries/* SPACE_QUERY */.y, {
        variables: {
            communityId: communityId,
            spaceId: spaceId,
            isCoursesToCommunitiesEnabled: isCoursesToCommunitiesEnabled
        },
        notifyOnNetworkStatusChange: true,
        skip: !spaceId,
        onError: function() {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    }), data = ref6.data, error = ref6.error, loading = ref6.loading;
    var hasError = !!((error === null || error === void 0 ? void 0 : (ref = error.graphQLErrors) === null || ref === void 0 ? void 0 : ref.length) || (data === null || data === void 0 ? void 0 : (ref1 = data.community) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.userErrors) === null || ref2 === void 0 ? void 0 : ref2.length));
    var space = data === null || data === void 0 ? void 0 : (ref3 = data.community) === null || ref3 === void 0 ? void 0 : ref3.communitySpace;
    var defaultDescription = t("components-spaceDetails-guideline_convo_starters_placeholder", "eg. Guidelines, conversation starters, etc.");
    var isSpacePage = router.pathname === routerHelpers/* pathnames.spaces.space */.$O.spaces.space;
    var opacityValue = !isSpacePage ? 0.6 : 1;
    (0,react.useEffect)(function() {
        setDescription((space === null || space === void 0 ? void 0 : space.description) || defaultDescription);
        setImageUrl(space === null || space === void 0 ? void 0 : space.imageUrl);
    }, [
        space
    ]);
    (0,react.useEffect)(function() {
        var tokenDescription = pubsub_default().subscribe(eventNames/* eventNames.SPACE_DESCRIPTION_CHANGE */.S.SPACE_DESCRIPTION_CHANGE, function(msg, value) {
            return setDescription(value !== "" ? value : defaultDescription);
        });
        var tokenImage = pubsub_default().subscribe(eventNames/* eventNames.SPACE_IMAGE_CHANGE */.S.SPACE_IMAGE_CHANGE, function(msg, value) {
            return setImageUrl(value || constants/* SPACE_IMAGE_PLACEHOLDER */.zq);
        });
        return function() {
            pubsub_default().unsubscribe(tokenDescription);
            pubsub_default().unsubscribe(tokenImage);
        };
    }, []);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetailsSkeleton/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !hasError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Opacity/* default */.Z, {
            value: opacityValue,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpaceDetailsCard_SpaceDetailsCard, {
                className: className,
                description: description,
                footerAccessory: footerAccessory,
                imageAltText: space === null || space === void 0 ? void 0 : space.imageAltText,
                imageUrl: imageUrl,
                name: t("Details")
            })
        })
    });
};
/* harmony default export */ var SpaceDetails_SpaceDetails = (SpaceDetails);

;// CONCATENATED MODULE: ./components/SpaceDetails/index.ts





/***/ }),

/***/ 82957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UserAvatar_UserAvatar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/slicedToArray-82541484.js
var slicedToArray_82541484 = __webpack_require__(70512);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/prop-shapes-ac9385ac.js
var prop_shapes_ac9385ac = __webpack_require__(10518);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/iterableToArray-12a62ea2.js
var iterableToArray_12a62ea2 = __webpack_require__(59453);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/unsupportedIterableToArray-5baf4325.js
var unsupportedIterableToArray_5baf4325 = __webpack_require__(50901);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/utils-9c93357c.js
var utils_9c93357c = __webpack_require__(33622);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/defineProperty-1e8516b1.js
var defineProperty_1e8516b1 = __webpack_require__(11841);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/Avatar-1153873e.js
var Avatar_1153873e_filename = "/index.js";
var p=function(a){return (0,react.useMemo)((function(){var e=a;return{block:e,element:function(a){return"".concat(e,"__").concat(a)},modifier:function(a){return"".concat(e,"--").concat(a)}}}),[a])},h={VIDEO:{width:16,height:9},SQUARE:{width:1,height:1},LANDSCAPE:{width:4,height:3},PORTRAIT:{width:3,height:4}},f={LEFT:"left",CENTER:"center",RIGHT:"right"},A={TOP:"top",CENTER:"center",BOTTOM:"bottom"};(0,prop_shapes_ac9385ac.s)(".ConstrainedImage_constrained-image__2{position:relative;overflow:hidden}.ConstrainedImage_constrained-image__image-wrapper__5{height:0}.ConstrainedImage_constrained-image__image-wrapper--aspect-16x9__7{padding-bottom:56.25%}.ConstrainedImage_constrained-image__image-wrapper--aspect-1x1__9{padding-bottom:100%}.ConstrainedImage_constrained-image__image-wrapper--aspect-4x3__11{padding-bottom:75%}.ConstrainedImage_constrained-image__image-wrapper--aspect-3x4__13{padding-bottom:133.33333%}.ConstrainedImage_constrained-image__image__5{display:block;position:absolute;top:50%;left:50%;width:auto;max-width:none;height:100%}.ConstrainedImage_constrained-image__image--narrow__23{width:100%;height:auto}.ConstrainedImage_constrained-image__image--anchor-x-left__26{left:0}.ConstrainedImage_constrained-image__image--anchor-x-center__28{transform:translateX(-50%)}.ConstrainedImage_constrained-image__image--anchor-x-right__30{right:0;left:auto}.ConstrainedImage_constrained-image__image--anchor-y-top__33{top:0}.ConstrainedImage_constrained-image__image--anchor-y-center__35{transform:translateY(-50%)}.ConstrainedImage_constrained-image__image--anchor-y-center__35.ConstrainedImage_constrained-image__image--anchor-x-center__28{transform:translate(-50%,-50%)}.ConstrainedImage_constrained-image__image--anchor-y-bottom__39{top:auto;bottom:0}",{insertAt:"top"});var u=prop_shapes_ac9385ac.b.bind({"constrained-image":"ConstrainedImage_constrained-image__2","constrained-image__image-wrapper":"ConstrainedImage_constrained-image__image-wrapper__5","constrained-image__image-wrapper--aspect-16x9":"ConstrainedImage_constrained-image__image-wrapper--aspect-16x9__7","constrained-image__image-wrapper--aspect-1x1":"ConstrainedImage_constrained-image__image-wrapper--aspect-1x1__9","constrained-image__image-wrapper--aspect-4x3":"ConstrainedImage_constrained-image__image-wrapper--aspect-4x3__11","constrained-image__image-wrapper--aspect-3x4":"ConstrainedImage_constrained-image__image-wrapper--aspect-3x4__13","constrained-image__image":"ConstrainedImage_constrained-image__image__5","constrained-image__image--narrow":"ConstrainedImage_constrained-image__image--narrow__23","constrained-image__image--anchor-x-left":"ConstrainedImage_constrained-image__image--anchor-x-left__26","constrained-image__image--anchor-x-center":"ConstrainedImage_constrained-image__image--anchor-x-center__28","constrained-image__image--anchor-x-right":"ConstrainedImage_constrained-image__image--anchor-x-right__30","constrained-image__image--anchor-y-top":"ConstrainedImage_constrained-image__image--anchor-y-top__33","constrained-image__image--anchor-y-center":"ConstrainedImage_constrained-image__image--anchor-y-center__35","constrained-image__image--anchor-y-bottom":"ConstrainedImage_constrained-image__image--anchor-y-bottom__39"}),x=function(e){var t,n=e.anchorX,o=e.anchorY,s=e.aspectRatio,m=e.alt,c=e.className,g=e.src,d=e.srcSet,v=e.onError,h=p("constrained-image"),f=(0,react.useState)(null),A=(0,slicedToArray_82541484._)(f,2),x=A[0],w=A[1],C=s.width/s.height,b="".concat(s.width,"x").concat(s.height);return (0,react.useEffect)((function(){var a=new Image;a.onload=function(){w(a.width/a.height)},a.src=g}),[g]),react.createElement("div",{className:u(h.block,c)},react.createElement("div",{className:u(h.element("image-wrapper"),h.element("image-wrapper--aspect-".concat(b)))},react.createElement("img",{alt:m,className:u(h.element("image"),h.element("image--anchor-x-".concat(n)),h.element("image--anchor-y-".concat(o)),(t={},(0,defineProperty_1e8516b1._)(t,h.element("image--wide"),x>C),(0,defineProperty_1e8516b1._)(t,h.element("image--narrow"),x<C),t)),src:g,srcSet:d,onError:v})))};x.defaultProps={alt:"",anchorX:f.CENTER,anchorY:A.CENTER,aspectRatio:h.VIDEO,className:null,srcSet:null,onError:null},x.propTypes={alt:(prop_types_default()).string,anchorX:prop_types_default().oneOf(Object.values(f)),anchorY:prop_types_default().oneOf(Object.values(A)),aspectRatio:prop_types_default().oneOf(Object.values(h)),className:prop_shapes_ac9385ac.c,src:(prop_types_default()).string.isRequired,srcSet:(prop_types_default()).string,onError:(prop_types_default()).func},x.filename=Avatar_1153873e_filename;var w=x;var C=function(r){if(!r||""===r.trim())return null;var n,_,i=r.trim().split(" ");if(i.length>1){var o=(0,slicedToArray_82541484.a)(_=i)||(0,iterableToArray_12a62ea2._)(_)||(0,unsupportedIterableToArray_5baf4325._)(_)||(0,slicedToArray_82541484.b)(),s=o[0],m=o.slice(1).pop();n=s[0]+m[0]}else{var c=i[0].split(""),v=(0,slicedToArray_82541484._)(c,2);n=v[0]+v[1]}return n.toUpperCase()},b="xs",I="sm",E="md",y="lg",N="https://cdn.thinkific.com/82/20201203/47f33f6acab9eb172db511bf8013848b.svg";(0,prop_shapes_ac9385ac.s)(".Avatar_avatar__2{position:relative;width:40px;height:40px;border-radius:50%;background-color:#6f7282;color:#fff;overflow:hidden}.Avatar_avatar__2,.Avatar_avatar__initials__13{display:flex;align-items:center;justify-content:center}.Avatar_avatar__initials__13{font-family:Source Sans Pro,sans-serif;font-size:1rem;font-weight:700}.Avatar_avatar__2.Avatar_avatar--xs__20,.Avatar_avatar__2.Avatar_avatar--xs__20 img,.Avatar_avatar__2.Avatar_avatar--xs__20>div{width:32px;height:32px}.Avatar_avatar__2.Avatar_avatar--xs__20 .Avatar_avatar__initials__13{font-size:.75rem}.Avatar_avatar__2.Avatar_avatar--sm__29,.Avatar_avatar__2.Avatar_avatar--sm__29 img,.Avatar_avatar__2.Avatar_avatar--sm__29>div{width:40px;height:40px}.Avatar_avatar__2.Avatar_avatar--sm__29 .Avatar_avatar__initials__13{font-size:1rem}.Avatar_avatar__2.Avatar_avatar--md__38,.Avatar_avatar__2.Avatar_avatar--md__38 img,.Avatar_avatar__2.Avatar_avatar--md__38>div{width:64px;height:64px}.Avatar_avatar__2.Avatar_avatar--md__38 .Avatar_avatar__initials__13{font-size:1.5rem}.Avatar_avatar__2.Avatar_avatar--lg__47,.Avatar_avatar__2.Avatar_avatar--lg__47 img,.Avatar_avatar__2.Avatar_avatar--lg__47>div{width:128px;height:128px}.Avatar_avatar__2.Avatar_avatar--lg__47 .Avatar_avatar__initials__13{font-size:3rem}",{insertAt:"top"});var T=prop_shapes_ac9385ac.b.bind({avatar:"Avatar_avatar__2",avatar__initials:"Avatar_avatar__initials__13","avatar--xs":"Avatar_avatar--xs__20","avatar--sm":"Avatar_avatar--sm__29","avatar--md":"Avatar_avatar--md__38","avatar--lg":"Avatar_avatar--lg__47"}),R=function(e){var t=e.alt,n=e.backgroundColor,o=e.className,s=e.size,m=e.name,c=e.src,g=e.srcSet,d=(0,react.useState)(void 0),l=(0,slicedToArray_82541484._)(d,2),p=l[0],f=l[1],A=C(m);(0,react.useEffect)((function(){f(c)}),[c]);var u=(0,utils_9c93357c.e)("white",n||"black","AA");return react.createElement("div",{className:T("avatar","avatar--".concat(s),o)},p&&react.createElement(w,{alt:t,aspectRatio:h.SQUARE,src:p,srcSet:g,onError:function(){f(A?null:N)}}),A&&!p&&react.createElement("div",{className:T("avatar__initials"),style:{backgroundColor:n,color:u?"white":"black"}},A),!p&&!A&&react.createElement("img",{alt:t,src:N}))};R.propTypes={alt:(prop_types_default()).string,backgroundColor:(prop_types_default()).string,className:prop_shapes_ac9385ac.c,name:(prop_types_default()).string,size:prop_types_default().oneOf([b,I,E,y]),src:(prop_types_default()).string,srcSet:(prop_types_default()).string},R.defaultProps={alt:"",backgroundColor:null,className:null,name:null,size:"md",src:null,srcSet:null},R.displayName="Avatar",R.filename=Avatar_1153873e_filename;var O=R;
//# sourceMappingURL=Avatar-1153873e.js.map

// EXTERNAL MODULE: ./node_modules/pubsub-js/src/pubsub.js
var pubsub = __webpack_require__(1798);
var pubsub_default = /*#__PURE__*/__webpack_require__.n(pubsub);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./utils/rawId.ts
var rawId = __webpack_require__(93593);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./constants/eventNames.ts
var eventNames = __webpack_require__(81340);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./constants/trackingEvents.ts
var trackingEvents = __webpack_require__(89131);
// EXTERNAL MODULE: ./components/UserAvatar/UserAvatar.module.scss
var UserAvatar_module = __webpack_require__(36701);
var UserAvatar_module_default = /*#__PURE__*/__webpack_require__.n(UserAvatar_module);
;// CONCATENATED MODULE: ./components/UserAvatar/UserAvatar.tsx














var cx = bind_default().bind((UserAvatar_module_default()));
var UserAvatar = function(param) {
    var avatarUrl = param.avatarUrl, className = param.className, username = param.username, userId = param.userId, size = param.size, srcSet = param.srcSet, _shouldOpenProfile = param.shouldOpenProfile, shouldOpenProfile = _shouldOpenProfile === void 0 ? false : _shouldOpenProfile, alt = param.alt;
    var handleUserDetailAction = function handleUserDetailAction(event) {
        event.preventDefault();
        event.stopPropagation();
        pubsub_default().publish(eventNames/* eventNames.OPEN_PROFILE_PANEL */.S.OPEN_PROFILE_PANEL, {
            userId: userId,
            lastElementRef: userAvatarRef
        });
        trackEvent(trackingEvents/* default.PROFILE_PANEL_TAB_OPENED */.ZP.PROFILE_PANEL_TAB_OPENED);
    };
    var trackEvent = (0,CommunityContext/* useCommunityContext */.v1)().trackEvent;
    var userAvatarRef = (0,react.useRef)(null);
    var t = (0,es/* useTranslation */.$G)().t;
    var USER_DEFAULT_AVATAR_URL = "/assets/tenant/defaults/avatar.png";
    var lastDigitOfUserId = ((0,rawId/* rawId */.b)(userId) || 0) % constants/* USER_AVATAR_COLORS.length */.qv.length;
    var isDefaultAvatar = avatarUrl === USER_DEFAULT_AVATAR_URL;
    var extraProps = shouldOpenProfile ? {
        className: cx("user-avatar__container"),
        "aria-label": t("Open profile tab"),
        "aria-hidden": false,
        ref: userAvatarRef,
        role: "button",
        tabIndex: 0,
        onClick: handleUserDetailAction,
        onKeyDown: function(event) {
            if (event.key === "Enter" || event.key === " ") {
                handleUserDetailAction(event);
            }
        }
    } : {
        className: cx("user-avatar__container")
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "data-qa": "user-avatar__container",
        "aria-hidden": true
    }, extraProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(O, {
            alt: alt || "",
            backgroundColor: constants/* USER_AVATAR_COLORS */.qv[lastDigitOfUserId],
            className: className,
            name: username,
            size: size,
            src: isDefaultAvatar ? "" : avatarUrl || "",
            srcSet: isDefaultAvatar ? "" : srcSet
        })
    }));
};
/* harmony default export */ var UserAvatar_UserAvatar = (UserAvatar);

;// CONCATENATED MODULE: ./components/UserAvatar/index.ts



/***/ }),

/***/ 37510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_userHelpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73652);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);
/* harmony import */ var hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90698);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59830);






// https://getbootstrap.com/docs/4.0/utilities/display/
var VisibilityCloak = function(param) {
    var admins = param.admins, moderators = param.moderators, hide = param.hide, hideXS = param.hideXS, hideSM = param.hideSM, hideMD = param.hideMD, children = param.children;
    var currentUser = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)().currentUser;
    var width = (0,hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .i)().width;
    if (admins && !(0,utils_userHelpers__WEBPACK_IMPORTED_MODULE_2__/* .isAdmin */ .GJ)(currentUser)) return null;
    if (moderators && !currentUser.isModerator) return null;
    if (hide) return null;
    if (hideXS && width < utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINT_SM */ .Fg) return null; // Hide on x-small screens
    if (hideSM && width < utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINT_MD */ .GI) return null; // Hide on small screens
    if (hideMD && width < utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .BREAKPOINT_LG */ .Qq) return null; // Hide on medium screens
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VisibilityCloak);


/***/ }),

/***/ 81340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ eventNames; }
/* harmony export */ });
var eventNames = {
    SPACE_DESCRIPTION_CHANGE: "SPACE_DESCRIPTION_CHANGE",
    SPACE_IMAGE_CHANGE: "SPACE_IMAGE_CHANGE",
    OPEN_PROFILE_PANEL: "OPEN_PROFILE_PANEL",
    SHOW_COURSE_CARD_PREVIEW: "SHOW_COURSE_CARD_PREVIEW",
    HIDE_COURSE_CARD_PREVIEW: "HIDE_COURSE_CARD_PREVIEW",
    OPEN_SELECT_COURSE_MODAL: "OPEN_SELECT_COURSE_MODAL",
    // Live events
    OPEN_EVENT_PANEL: "OPEN_EVENT_PANEL",
    // Posts
    OPEN_POST_MODAL: "OPEN_POST_MODAL",
    // Moderator
    OPEN_MODERATOR_PANEL: "OPEN_MODERATOR_PANEL"
};


/***/ }),

/***/ 46139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ features; }
/* harmony export */ });
var features = {
    STUDENT_EVENT_TRACKING: "feature.communities-student-event-tracking",
    COURSES_TO_COMMUNITIES: "feature.courses-to-communities-link",
    NOTIFICATION_PANE: "feature.notification-pane",
    COMMUNITIES_AS_A_PRODUCT: "feature.communities-as-a-product",
    DEV_COMMUNITIES_DEBUGGING: "dev-communities-debugging",
    COMMUNITIES_EVENTS_RSVP: "feature.communities-events-rsvp",
    COMMUNITIES_EVENT_EMAILS: "feature.live-event-emails",
    EXCLUSIVE_SPACES: "feature.community-exclusive-spaces",
    COMMENTS_IN_FEED: "feature.communities-comments-in-feed",
    COMMUNITIES_MODERATOR_ROLE: "feature.communities-moderator-role",
    LIVE_EVENT_REMINDERS: "events.live-event-reminders",
    COMMUNITIES_SEARCH: "feature.communities-post-search"
};


/***/ }),

/***/ 89131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ku": function() { return /* binding */ TrackingProperty; },
/* harmony export */   "V7": function() { return /* binding */ ProductTypes; }
/* harmony export */ });
var // If we upgrade eslint, we shouldn't need the no-shadow. It's a bug
/* eslint-disable no-shadow */ TrackingEvent;
(function(TrackingEvent) {
    TrackingEvent[// Courses to Communities
    "CLICK_ADD_COURSE_TO_SPACE"] = "Communities Click Add Course to Space";
    TrackingEvent["ADD_COURSE_TO_SPACE"] = "Communities Add Course to Space";
    TrackingEvent["CLICK_CHANGE_COURSE_IN_SPACE"] = "Communities Click Change Course in Space";
    TrackingEvent["CHANGE_COURSE_ON_SPACE"] = "Communities Change Course on Space";
    TrackingEvent["CLICK_UNLINK_COURSE_FROM_SPACE"] = "Communities Click Unlink Course from Space";
    TrackingEvent["REMOVE_COURSE_FROM_SPACE"] = "Communities Remove Course from Space";
    TrackingEvent["CLICK_EDIT_COURSE_ENROLLMENTS"] = "Communities Click Edit Course Enrollments";
    TrackingEvent["CLICK_SET_COMMUNITY_ACCESS"] = "Communities Click Set Community Access";
    TrackingEvent["CLICK_EXPAND_LINKED_COURSES"] = "Communities Expand Linked Courses";
    TrackingEvent["GO_TO_COURSE_FROM_COMMUNITY"] = "Communities Go From Community To Course";
    TrackingEvent["GO_TO_COMMUNITY_FROM_COURSE"] = "Communities Go From Course to Community";
    TrackingEvent[// Live Events
    "CLICK_COPY_LIVE_EVENT_LINK"] = "Communities Click Live Event Copy Link";
    TrackingEvent["CLICK_CREATE_LIVE_EVENT"] = "Communities Click Create Live Event";
    TrackingEvent["CLICK_EDIT_LIVE_EVENT"] = "Communities Click Edit Live Event";
    TrackingEvent["CLICK_JOIN_LIVE_EVENT"] = "Communities Click Join Live Event";
    TrackingEvent["CLICK_LIVE_EVENT_MEETING_LINK"] = "Communities Click Live Event Link";
    TrackingEvent["CLICK_SEE_ALL_EVENTS"] = "Communities Click See All Live Events";
    TrackingEvent["DELETE_LIVE_EVENT"] = "Communities Delete Live Event";
    TrackingEvent["OPEN_LIVE_EVENT_DETAILS_TAB"] = "Communities View Live Event Details";
    TrackingEvent["PUBLISH_LIVE_EVENT"] = "Communities Publish Live Event";
    TrackingEvent["UPDATE_LIVE_EVENT"] = "Communities Publish Edited Live Event";
    TrackingEvent["CREATE_ATTENDANCE"] = "Communities Student Click Interested";
    TrackingEvent["DELETE_ATTENDANCE"] = "Communities Student Click Not Interested";
    TrackingEvent[// Spaces pricing & packaging
    "CLICK_UPGRADE_SUBSCRIPTION_LINK"] = "Communities Click Upgrade Subscription Link";
    TrackingEvent[// Search
    "SEARCH_SUBMITTED"] = "Communities Search Submitted";
    TrackingEvent[// Other
    "DELETE_POST"] = "Communities Delete Post";
    TrackingEvent["EDIT_POST"] = "Communities Edit Post";
    TrackingEvent["FOLLOW_COMMENT"] = "Communities Follow Comment";
    TrackingEvent["FOLLOW"] = "Communities Follow";
    TrackingEvent["GO_TO_DASHBOARD"] = "Communities Go To Dashboard";
    TrackingEvent["GO_TO_SEARCH"] = "Communities Go To Search";
    TrackingEvent["GO_TO_PROFILE"] = "Communities Go To Profile";
    TrackingEvent["GO_TO_CUSTOMIZE_COMMUNITY"] = "Communities Go To Customize Community";
    TrackingEvent["GO_TO_SET_ACCESS"] = "Communities Go To Set Community Access";
    TrackingEvent["GO_TO_PUBLISH_COMMUNITY"] = "Communities Go To Publish Community";
    TrackingEvent["MY_ACCOUNT"] = "Communities My Account";
    TrackingEvent["NOTIFICATIONS_SAVED"] = "Communities Notifications Saved";
    TrackingEvent["PAGE_VIEW"] = "Communities Page View";
    TrackingEvent["PIN"] = "Communities Pin Post";
    TrackingEvent["POST_CREATED"] = "Communities Post Created";
    TrackingEvent["POST_REACTED"] = "Communities Post Reacted";
    TrackingEvent["UNFOLLOW_COMMENT"] = "Communities Unfollow Comment";
    TrackingEvent["UNFOLLOW"] = "Communities Unfollow";
    TrackingEvent["UNPIN"] = "Communities Unpin Post";
    TrackingEvent["POST_MODAL_OPENED"] = "Communities Post Modal Opened";
    TrackingEvent["SPACE_CREATED"] = "Communities Space Created";
    TrackingEvent["GO_TO_NEW_SPACE"] = "Communities Go To New Space";
    TrackingEvent["SPACE_EDITED"] = "Communities Space Edited";
    TrackingEvent["SPACE_DELETED"] = "Communities Space Deleted";
    TrackingEvent["SPACE_CLICKED"] = "Communities Space Clicked";
    TrackingEvent["EDIT_PROFILE_FROM_MENU_CLICKED"] = "Communities Edit Profile Header Clicked";
    TrackingEvent["EDIT_PROFILE_FROM_PROFILE_PANEL_CLICKED"] = "Communities Profile Panel Edit Profile Clicked";
    TrackingEvent["PROFILE_PANEL_TAB_OPENED"] = "Communities Profile Panel Opened";
    TrackingEvent["PAST_ACTIVITY_CLICKED"] = "Communities Profile Panel Past Activities Clicked";
    TrackingEvent["TRENDING_POST_CLICKED"] = "Communities Trending Post Clicked";
})(TrackingEvent || (TrackingEvent = {}));
var TrackingProperty;
(function(TrackingProperty) {
    TrackingProperty["ATTACHMENT"] = "Attachment";
    TrackingProperty["COMPONENT"] = "Component";
    TrackingProperty["COMMENT_ID_ENCODED"] = "Comment Id (Base64 Encoded)";
    TrackingProperty["COMMENT_ID"] = "Comment Id";
    TrackingProperty["COMMUNITY_ID_ENCODED"] = "Community Id (Base64 Encoded)";
    TrackingProperty["COMMUNITY_ID"] = "Community Id";
    TrackingProperty["COURSE_SLUG"] = "Course Slug";
    TrackingProperty["COMMUNITY_NAME"] = "Community Name";
    TrackingProperty["INTERACTION_TYPE"] = "Type of interaction (added/removed reaction)";
    TrackingProperty["NOTIFICATIONS_SETTINGS"] = "Notifications Settings";
    TrackingProperty["PINNED_POST"] = "Pinned Post";
    TrackingProperty["PAGE_TYPE"] = "Page Type";
    TrackingProperty["POST_ID_ENCODED"] = "Post Id (Base64 Encoded)";
    TrackingProperty["POST_ID"] = "Post Id";
    TrackingProperty["POST_TYPE"] = "Post Type";
    TrackingProperty["PRODUCT_ID"] = "Product Id";
    TrackingProperty["PRODUCT_TYPE"] = "Product Type";
    TrackingProperty["REACTION_TIMESTAMP"] = "Reaction Timestamp";
    TrackingProperty["TENANT_ID_ENCODED"] = "Tenant Id (Base64 Encoded)";
    TrackingProperty["TENANT_ID"] = "Tenant Id";
    TrackingProperty["USER_ID_ENCODED"] = "User Id (Base64 Encoded)";
    TrackingProperty["USER_ID"] = "User Id";
    TrackingProperty["USER_ROLE"] = "User Role";
    TrackingProperty["VISITOR_ID"] = "Visitor ID";
    TrackingProperty["SPACE_ID"] = "Space ID";
    TrackingProperty["SPACE_NAME"] = "Space Name";
    TrackingProperty["POST_REASSIGNED"] = "Post Reassigned";
    TrackingProperty["WAS_OPENED_FROM_MENTION"] = "Was Opened from Mention";
    TrackingProperty["HAS_MENTION"] = "Has mention";
    TrackingProperty["WINDOW_WIDTH"] = "Window Width";
    TrackingProperty["EVENT_TYPE"] = "Event Type";
    TrackingProperty["LIVE_EVENT_ID"] = "Live Event ID";
    TrackingProperty["LIVE_EVENT_ID_ENCODED"] = "Live Event ID (Base64 Encoded)";
    TrackingProperty["SENT_EMAILS"] = "Sent Emails";
})(TrackingProperty || (TrackingProperty = {}));
var ProductTypes;
(function(ProductTypes) {
    ProductTypes["COURSE"] = "Course";
})(ProductTypes || (ProductTypes = {}));
/* harmony default export */ __webpack_exports__["ZP"] = (TrackingEvent);


/***/ }),

/***/ 17981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HE": function() { return /* binding */ isEventStartingSoon; },
/* harmony export */   "In": function() { return /* binding */ getRoundedDateTime; },
/* harmony export */   "MF": function() { return /* binding */ isEventLive; },
/* harmony export */   "S": function() { return /* binding */ DEFAULT_EVENT_STEP_MINUTES; },
/* harmony export */   "U0": function() { return /* binding */ localeEventsDate; },
/* harmony export */   "VQ": function() { return /* binding */ checkIfPastDateTime; },
/* harmony export */   "Zx": function() { return /* binding */ getUTCDateTime; },
/* harmony export */   "co": function() { return /* binding */ formatTimeOptionText; },
/* harmony export */   "f6": function() { return /* binding */ relativeFormattedDateTime; },
/* harmony export */   "ji": function() { return /* binding */ EVENT_DATE_ISO_OPTIONS; },
/* harmony export */   "km": function() { return /* binding */ TIMEZONE_FORMAT; },
/* harmony export */   "m2": function() { return /* binding */ getRoundedISOTime; },
/* harmony export */   "tv": function() { return /* binding */ getISOFromUTC; }
/* harmony export */ });
/* unused harmony export ONE_MINUTE */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99490);


var ONE_MINUTE = 60 * 1000;
var DEFAULT_EVENT_STEP_MINUTES = 30;
var EVENT_DATE_ISO_OPTIONS = {
    includeOffset: false,
    suppressMilliseconds: true
};
var TIMEZONE_FORMAT = "hh:mm a, (ZZZZ - ZZZZZ)";
var fromISO = function(date, zone) {
    // It's a bit silly that empty string for zone just returns an error
    // This helper will just ensure that we default to local time if timezone is empty string
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        zone: zone || undefined
    });
};
var relativeFormatDateTime = function(date, locale) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        locale: locale
    }).toRelative();
};
var createdLessThanAMinuteAgo = function(date) {
    return new Date().valueOf() - luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date).valueOf() < ONE_MINUTE;
};
var relativeFormattedDateTime = function(time, locale, t) {
    return createdLessThanAMinuteAgo(time) ? t("a few seconds ago") : relativeFormatDateTime(time, locale);
};
var localeEventsDate = function(date, locale, zone, options) {
    var dateTime = fromISO(date, zone);
    if (dateTime.isValid) {
        // Avoid showing year if its the current one
        var isCurrentYear = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now().year === dateTime.year; // ToDo: Add some tests for this line around Dec 31st
        var opts = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, options || {
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            timeZoneName: "short"
        });
        if (!isCurrentYear) opts.year = "numeric";
        return dateTime.setLocale(locale || "").toLocaleString(opts);
    }
    return "";
};
var isEventLive = function(startTime, endTime) {
    var start = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(startTime);
    var end = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(endTime);
    var now = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now();
    return now >= start && now <= end;
};
var isEventStartingSoon = function(startTime) {
    var rangeInMins = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15;
    var start = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(startTime);
    var now = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now();
    var diff = start.diff(now, [
        "minutes"
    ]).toObject();
    if (!diff.minutes) return false;
    return diff.minutes <= rangeInMins && diff.minutes > 0;
};
var checkIfPastDateTime = function(date, timezone) {
    if (!timezone) return false;
    if (luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.now */ .ou.now() > luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        zone: timezone
    })) return true;
    return false;
};
var getRoundedDateTime = function(date) {
    var step = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_EVENT_STEP_MINUTES;
    var remainder = step - date.minute % step;
    var roundedStartDate = date.plus({
        minutes: remainder
    }).startOf("minute");
    return roundedStartDate;
};
var getRoundedISOTime = function(date) {
    var step = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_EVENT_STEP_MINUTES;
    var dateTime = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        setZone: true
    });
    var roundedStartDate = getRoundedDateTime(dateTime, step);
    return roundedStartDate.toISO(EVENT_DATE_ISO_OPTIONS);
};
var formatTimeOptionText = function(currentDate, t, startDate, withDuration) {
    var text = currentDate.toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.TIME_SIMPLE */ .ou.TIME_SIMPLE);
    if (withDuration && startDate) {
        var diff = currentDate.diff(startDate).as("hours");
        var rounded = Math.round(diff * 10) / 10;
        return "".concat(text, " (").concat(rounded, " ").concat(t("helpers-date-hours_abbreviation", "hrs"), ")");
    }
    return text;
};
var getUTCDateTime = function(date, zone) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        zone: zone
    }).toUTC().toISO(EVENT_DATE_ISO_OPTIONS);
};
var getISOFromUTC = function(date, zone) {
    return luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromISO */ .ou.fromISO(date, {
        zone: zone
    }).toISO(EVENT_DATE_ISO_OPTIONS);
};


/***/ }),

/***/ 7856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ handleEditEvent; },
/* harmony export */   "x": function() { return /* binding */ handleJoinMeeting; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89131);
/* harmony import */ var utils_rawId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93593);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4154);




var handleJoinMeeting = function(e, mixpanelEvent, trackEvent, liveEventId, liveEventUrl, parentComponent) {
    e.preventDefault();
    var _obj;
    trackEvent(mixpanelEvent, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.LIVE_EVENT_ID */ .Ku.LIVE_EVENT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_3__/* .rawId */ .b)(liveEventId || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.LIVE_EVENT_ID_ENCODED */ .Ku.LIVE_EVENT_ID_ENCODED, liveEventId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.COMPONENT */ .Ku.COMPONENT, parentComponent), _obj));
    window.open(liveEventUrl || "", "_blank");
};
var handleEditEvent = function(e, router, trackEvent, communityId, liveEventId, parentComponent) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    var _obj;
    trackEvent(constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLICK_EDIT_LIVE_EVENT */ .ZP.CLICK_EDIT_LIVE_EVENT, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.LIVE_EVENT_ID */ .Ku.LIVE_EVENT_ID, (0,utils_rawId__WEBPACK_IMPORTED_MODULE_3__/* .rawId */ .b)(liveEventId || "")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.LIVE_EVENT_ID_ENCODED */ .Ku.LIVE_EVENT_ID_ENCODED, liveEventId), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, constants_trackingEvents__WEBPACK_IMPORTED_MODULE_0__/* .TrackingProperty.COMPONENT */ .Ku.COMPONENT, parentComponent), _obj));
    (0,utils_routerHelpers__WEBPACK_IMPORTED_MODULE_1__/* .goToEditEvent */ .zf)(router, liveEventId, communityId);
};


/***/ }),

/***/ 56427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ a11yOnClick; }
/* harmony export */ });
var a11yOnClick = function(onClick, tabIndex) {
    return {
        role: "button",
        tabIndex: tabIndex || 0,
        onKeyPress: function(e) {
            if (e.type === "click" || e.key === "Enter" || e.key === " ") {
                onClick(e);
            }
        },
        onClick: onClick
    };
};


/***/ }),

/***/ 68556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ getIconNameByStoredValue; }
/* harmony export */ });
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59830);

// fetch the toga appropriate icon based on value coming from API
var getIconNameByStoredValue = function(icon) {
    return Object.keys(_utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SPACE_ICONS */ .YL).find(function(key) {
        return _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SPACE_ICONS */ .YL[key] === icon;
    }) || icon || _utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_SPACE_ICON */ .ng;
};


/***/ }),

/***/ 89804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ setGlobalCSSVariables; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/* harmony import */ var _utils_colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82083);


var setGlobalCSSVariables = function(primaryColor) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_utils_colors__WEBPACK_IMPORTED_MODULE_1__/* .hexToRGB */ .$W)(primaryColor), 3), r = ref[0], g = ref[1], b = ref[2];
    var textColor = (0,_utils_colors__WEBPACK_IMPORTED_MODULE_1__/* .isTextDark */ .aS)(primaryColor) ? getComputedStyle(document.documentElement).getPropertyValue("--dark-text") : getComputedStyle(document.documentElement).getPropertyValue("--light-text");
    document.documentElement.style.setProperty("--primary-color", "".concat(+r, ", ").concat(+g, ", ").concat(+b));
    document.documentElement.style.setProperty("--main-text-color", textColor);
};


/***/ }),

/***/ 188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useClickOutside(elementRef) {
    var ref = elementRef.current;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (ref) {
            ref === null || ref === void 0 ? void 0 : ref.addEventListener("transitionend", handleTransitionEnded, true);
            ref === null || ref === void 0 ? void 0 : ref.addEventListener("keydown", handleTabNavigation, true);
        }
        return function() {
            ref === null || ref === void 0 ? void 0 : ref.removeEventListener("transitionend", handleTransitionEnded, true);
            ref === null || ref === void 0 ? void 0 : ref.removeEventListener("keydown", handleTabNavigation, true);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref
    ]);
    var getFocusableElements = function() {
        var focusableElements = ref === null || ref === void 0 ? void 0 : ref.querySelectorAll('select, input, textarea, button, a, svg[role="img"], div[role="button"], div[role="link"]');
        if (focusableElements) {
            var elements = Array.from(focusableElements);
            var firstElement = focusableElements[0];
            var lastElement = focusableElements[focusableElements.length - 1];
            return {
                elements: elements,
                firstElement: firstElement,
                lastElement: lastElement
            };
        }
        return {};
    };
    var handleTabNavigation = function(event) {
        var ref = getFocusableElements(), lastElement = ref.lastElement, firstElement = ref.firstElement;
        if (event.key === "Tab") {
            if (event.shiftKey) {
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement === null || lastElement === void 0 ? void 0 : lastElement.focus();
                }
            } else if (document.activeElement === lastElement) {
                event.preventDefault();
                firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
            }
        }
    };
    var handleTransitionEnded = function(event) {
        var firstElement = getFocusableElements().firstElement;
        if (event.propertyName === "visibility") firstElement === null || firstElement === void 0 ? void 0 : firstElement.focus();
    };
};


/***/ }),

/***/ 90698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* eslint-disable import/prefer-default-export */ var useWindowSize = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    }), windowSize = ref[0], setWindowSize = ref[1];
    var changeWindowSize = function() {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("resize", changeWindowSize);
        // We should look into debouncing/throttling this to improve resize performance.
        // This triggers a lot of re-renders when the window is resized
        return function() {
            window.removeEventListener("resize", changeWindowSize);
        };
    }, []);
    return windowSize;
};


/***/ }),

/***/ 78472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Au": function() { return /* binding */ ButtonWithIconOnly; },
/* harmony export */   "H1": function() { return /* binding */ withIcon; },
/* harmony export */   "Xs": function() { return /* binding */ ButtonWithIconRight; },
/* harmony export */   "ej": function() { return /* binding */ ButtonWithIconLeft; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82083);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88826);
/* harmony import */ var _Button_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Button_module_scss__WEBPACK_IMPORTED_MODULE_5__);








// This could be simplified...
var withIcon = function(param) {
    var position = param.position;
    return function(WrappedComponent) {
        return function MyFunc(props) {
            var className = props.className;
            var classes = cx(className, {
                "button--icon-left": position === "left",
                "button--icon-right": position === "right",
                "button--icon-both": position === "both",
                "button--icon-only": position === "none"
            });
            var newProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                className: classes
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, newProps));
        };
    };
};
var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_Button_module_scss__WEBPACK_IMPORTED_MODULE_5___default()));
var Button = function(_param, ref) {
    var _appearance = _param.appearance, appearance = _appearance === void 0 ? "default" : _appearance, ariaLabel = _param.ariaLabel, children = _param.children, _color = _param.color, color = _color === void 0 ? null : _color, _className = _param.className, className = _className === void 0 ? null : _className, _dataQA = _param.dataQA, dataQA = _dataQA === void 0 ? null : _dataQA, _hasDanger = _param.hasDanger, hasDanger = _hasDanger === void 0 ? false : _hasDanger, _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _isBlockStyle = _param.isBlockStyle, isBlockStyle = _isBlockStyle === void 0 ? false : _isBlockStyle, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, href = _param.href, onClick = _param.onClick, _size = _param.size, size = _size === void 0 ? null : _size, _type = _param.type, type = _type === void 0 ? "button" : _type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "appearance",
        "ariaLabel",
        "children",
        "color",
        "className",
        "dataQA",
        "hasDanger",
        "isActive",
        "isBlockStyle",
        "isDisabled",
        "href",
        "onClick",
        "size",
        "type"
    ]);
    var Element = href ? "a" : "button";
    var role = Element === "a" ? "button" : undefined;
    var baseClasses = cx(className, "button", {
        "button--x-small": size === "x-small",
        "button--small": size === "small",
        active: isActive === true,
        "button--dark-text": color && (0,utils_colors__WEBPACK_IMPORTED_MODULE_7__/* .isTextDark */ .aS)(color)
    });
    var appearanceClasses = cx({
        "button--default": appearance === "default",
        "button--default-danger": appearance === "default" && hasDanger,
        "button--ghost": appearance === "ghost",
        "button--ghost-danger": appearance === "ghost" && hasDanger,
        "button--knockout": appearance === "knockout",
        "button--knockout-danger": appearance === "knockout" && hasDanger,
        "button--link": appearance === "link",
        "button--block": isBlockStyle
    });
    if (href) {
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            "aria-label": ariaLabel,
            className: "".concat(baseClasses, " ").concat(appearanceClasses),
            "data-qa": dataQA,
            href: href,
            ref: ref,
            role: role,
            style: color ? {
                backgroundColor: color
            } : {},
            onClick: onClick
        }, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            })
        })));
    }
    return(// eslint-disable-next-line react/button-has-type
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        "aria-label": ariaLabel,
        className: "".concat(baseClasses, " ").concat(appearanceClasses),
        "data-qa": dataQA,
        disabled: isDisabled,
        ref: ref,
        role: role,
        style: color ? {
            backgroundColor: color
        } : {},
        type: type === "submit" ? "submit" : "button",
        onClick: onClick
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: children
        })
    })));
};
var ButtonWithIconLeft = withIcon({
    position: "left"
})(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Button));
var ButtonWithIconOnly = withIcon({
    position: "none"
})(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Button));
var ButtonWithIconRight = withIcon({
    position: "right"
})(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Button));
/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(Button));


/***/ }),

/***/ 99438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Au": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Au; },
/* harmony export */   "H1": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.H1; },
/* harmony export */   "Xs": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.Xs; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.ZP; },
/* harmony export */   "ej": function() { return /* reexport safe */ _Button__WEBPACK_IMPORTED_MODULE_0__.ej; }
/* harmony export */ });
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78472);



/***/ }),

/***/ 71939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CircularSpinner_CircularSpinner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/CircularSpinner/CircularSpinner.module.scss
var CircularSpinner_module = __webpack_require__(19115);
var CircularSpinner_module_default = /*#__PURE__*/__webpack_require__.n(CircularSpinner_module);
;// CONCATENATED MODULE: ./koba/components/CircularSpinner/CircularSpinner.tsx




var cx = bind_default().bind((CircularSpinner_module_default()));
var CircularSpinner = function(param) {
    var className = param.className, color = param.color, _variation = param.variation, variation = _variation === void 0 ? "default" : _variation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx([
            "spinner",
            "spinner--".concat(variation),
            className
        ]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("circle"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("circle-inner"),
                    style: {
                        borderLeftColor: color,
                        borderTopColor: color
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx([
                    "circle",
                    "circle-2"
                ]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: cx("circle-inner"),
                    style: {
                        borderLeftColor: color,
                        borderTopColor: color
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CircularSpinner_CircularSpinner = (CircularSpinner);

;// CONCATENATED MODULE: ./koba/components/CircularSpinner/index.ts



/***/ }),

/***/ 43989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nh": function() { return /* binding */ DROPDOWN_DIMENSIONS_PROP_TYPE; },
/* harmony export */   "yW": function() { return /* binding */ DROPDOWN_DIMENSIONS_DEFAULT_PROP; }
/* harmony export */ });
/* unused harmony exports DIMENSIONS_PROP_TYPE, DIMENSIONS_DEFAULT_PROP */
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

var DIMENSIONS_PROP_TYPE = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    maxWidth: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
    ]),
    minWidth: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
    ]),
    width: prop_types__WEBPACK_IMPORTED_MODULE_0___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string)
    ])
});
var DIMENSIONS_DEFAULT_PROP = {
    maxWidth: null,
    minWidth: null,
    width: null
};
var DROPDOWN_DIMENSIONS_PROP_TYPE = prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape({
    menu: DIMENSIONS_PROP_TYPE,
    toggle: DIMENSIONS_PROP_TYPE
});
var DROPDOWN_DIMENSIONS_DEFAULT_PROP = {
    menu: DIMENSIONS_DEFAULT_PROP,
    toggle: DIMENSIONS_DEFAULT_PROP
};


/***/ }),

/***/ 46744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lt": function() { return /* reexport */ Dropdown_Dropdown; },
  "ck": function() { return /* reexport */ Item_Item; },
  "v2": function() { return /* reexport */ Menu_Menu; }
});

// UNUSED EXPORTS: ItemHeader

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Dropdown/Dropdown.module.scss
var Dropdown_module = __webpack_require__(70639);
var Dropdown_module_default = /*#__PURE__*/__webpack_require__.n(Dropdown_module);
;// CONCATENATED MODULE: ./koba/components/Dropdown/Dropdown.tsx









var cx = bind_default().bind((Dropdown_module_default())) // eslint-disable-line
;
var Dropdown = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Dropdown, Component);
    var _super = (0,_create_super/* default */.Z)(Dropdown);
    function Dropdown() {
        (0,_class_call_check/* default */.Z)(this, Dropdown);
        var _this;
        _this = _super.apply(this, arguments);
        // eslint-disable-next-line react/state-in-constructor
        _this.state = {
            open: false
        };
        _this.handleClickOutside = function(event) {
            var domNode = react_dom.findDOMNode((0,_assert_this_initialized/* default */.Z)(_this)); // eslint-disable-line react/no-find-dom-node
            var open = _this.state.open;
            // Closes any dropdown instances as we use other things in the page
            if (!domNode || !domNode.contains(event.target)) {
                if (open) {
                    _this.toggleMenu();
                }
            }
            // Close the dropdown when a dropdown item is clicked on
            if ((domNode === null || domNode === void 0 ? void 0 : domNode.contains(event.target)) && event.target.parentNode !== domNode) {
                if (open) {
                    _this.toggleMenu();
                }
            }
        };
        _this.toggleMenu = function(e) {
            if (e) {
                e.stopPropagation();
            }
            _this.setState(function(prevState) {
                return {
                    open: !prevState.open
                };
            });
        };
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.componentDidMount = function componentDidMount() {
        // Starting on React 17, event listeners are not longer attached to
        // the document, they are attached to the root element of the app
        var rootElement = document.getElementById("__next");
        if (rootElement) {
            rootElement.addEventListener("click", this.handleClickOutside);
        }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        var rootElement = document.getElementById("__next");
        if (rootElement) {
            rootElement.removeEventListener("click", this.handleClickOutside);
        }
    };
    _proto.render = function render() {
        var _props = this.props, children = _props.children, className = _props.className;
        var open = this.state.open;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: cx("dropdown", className),
            children: children({
                open: open,
                toggleMenu: this.toggleMenu
            })
        });
    };
    return Dropdown;
}(react.Component);
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./koba/components/Dropdown/Header/Header.tsx




var Header_cx = bind_default().bind((Dropdown_module_default()));
var Header = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: Header_cx("dropdown__header"),
        children: content
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./koba/components/Dropdown/Header/index.ts


// EXTERNAL MODULE: ./koba/components/Dropdown/constants.ts
var constants = __webpack_require__(43989);
;// CONCATENATED MODULE: ./koba/components/Dropdown/Menu/Menu.js







var Menu_cx = bind_default().bind((Dropdown_module_default()));
var Menu = function(props) {
    var children = props.children, className = props.className, dataQA = props.dataQA, dimensions = props.dimensions, headerContent = props.headerContent, open = props.open, position = props.position, width = props.width;
    var localClassName = Menu_cx("dropdown__menu", className, {
        "is-visible": open,
        "is-hidden": !open,
        "dropdown__menu-right": position === "right"
    });
    if (width) {
        console.warn("'width' will be removed from Dropdown/Menu component"); // eslint-disable-line no-console
    }
    var style = width;
    if (dimensions.menu) {
        style = dimensions.menu;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: localClassName,
        "data-qa": dataQA,
        style: style,
        children: [
            headerContent && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                content: headerContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: Menu_cx("dropdown__list"),
                children: children
            })
        ]
    });
};
Menu.propTypes = {
    /** HTML Node that will appear in the dropdown when clicked */ children: (prop_types_default()).node,
    /** Override classes if provided * */ className: prop_types_default().oneOfType([
        (prop_types_default()).array,
        (prop_types_default()).string
    ]),
    /** data-qa element */ dataQA: (prop_types_default()).string,
    /** Object with maxWidth, minWidth and width * */ dimensions: constants/* DROPDOWN_DIMENSIONS_PROP_TYPE */.Nh,
    /** String that first appear in the hidden menu */ headerContent: (prop_types_default()).string,
    /** Flag to control if the dropdown menu is open or closed */ open: (prop_types_default()).bool,
    /** Menu position - use right to right-align the menu */ position: (prop_types_default()).string,
    /** Menu width */ width: (prop_types_default()).number
};
Menu.defaultProps = {
    children: null,
    className: null,
    dataQA: null,
    dimensions: constants/* DROPDOWN_DIMENSIONS_DEFAULT_PROP */.yW,
    headerContent: "",
    open: false,
    position: null,
    width: null
};
/* harmony default export */ var Menu_Menu = (Menu);

;// CONCATENATED MODULE: ./koba/components/Dropdown/Menu/index.js


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./koba/components/Dropdown/Item/Item.tsx







var Item_cx = bind_default().bind((Dropdown_module_default())); // eslint-disable-line
var Item = function(_param) {
    var children = _param.children, multipleActions = _param.multipleActions, tmp = _param.className, propClasses = tmp === void 0 ? "" : tmp, attrs = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "multipleActions",
        "className"
    ]);
    var className = Item_cx("dropdown__list-item", {
        "dropdown__list-item--actions": multipleActions
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: "".concat(className, " ").concat(propClasses)
    }, attrs), {
        children: children
    }));
};
/* harmony default export */ var Item_Item = (Item);

;// CONCATENATED MODULE: ./koba/components/Dropdown/Item/index.ts


;// CONCATENATED MODULE: ./koba/components/Dropdown/ItemHeader/ItemHeader.js








var ItemHeader_cx = bind_default().bind((Dropdown_module_default())) // eslint-disable-line
;
/**
 * React component which allows selection of a single item from a dropdown list
 * Substitute for the native select element.
 */ var ItemHeader = function(props) {
    var children = props.children, attrs = (0,_object_without_properties/* default */.Z)(props, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: ItemHeader_cx("dropdown__list-item-header")
    }, attrs), {
        children: children
    }));
};
ItemHeader.propTypes = {
    /** HTML Node that will appear in the component */ children: (prop_types_default()).node
};
ItemHeader.defaultProps = {
    children: null
};
/* harmony default export */ var ItemHeader_ItemHeader = ((/* unused pure expression or super */ null && (ItemHeader)));

;// CONCATENATED MODULE: ./koba/components/Dropdown/ItemHeader/index.js


;// CONCATENATED MODULE: ./koba/components/Dropdown/index.ts







/***/ }),

/***/ 8236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Icon_Icon; }
});

// UNUSED EXPORTS: availableIcons

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Icon/Icon.module.scss
var Icon_module = __webpack_require__(49236);
var Icon_module_default = /*#__PURE__*/__webpack_require__.n(Icon_module);
;// CONCATENATED MODULE: ./koba/components/Icon/constants.js
// eslint-disable-next-line import/prefer-default-export
var availableIcons = [
    "arrow-down",
    "arrow-grow",
    "arrow-left",
    "arrow-redo",
    "arrow-right",
    "arrow-shrink",
    "arrow-undo",
    "arrow-up-right",
    "arrow-up",
    "beta",
    "bookmark-fill",
    "bookmark-outline-add",
    "bookmark-outline",
    "bullet",
    "caret-fill-down",
    "caret-fill-left",
    "caret-fill-right",
    "caret-fill-up",
    "caret-stroke-down",
    "caret-stroke-left",
    "caret-stroke-right",
    "caret-stroke-up",
    "certificate",
    "checkbox-empty",
    "checkbox-indeterminate",
    "checkbox-selected",
    "checkmark",
    "circle-fill-check",
    "circle-fill-dash",
    "circle-fill-info",
    "circle-fill-x",
    "circle-outline-info",
    "circle-outline-play",
    "circle-outline-price",
    "circle-slash",
    "cog",
    "column-select",
    "connection",
    "content-assignment",
    "content-audio",
    "content-discussions",
    "content-download",
    "content-exam",
    "content-live",
    "content-multimedia",
    "content-pdf",
    "content-presentation",
    "content-quiz",
    "content-survey",
    "content-text",
    "content-video",
    "data-download",
    "data-export",
    "data-import",
    "discussions",
    "document",
    "download",
    "ellipsis-v",
    "enrollment-add",
    "enrollment-remove",
    "envelope",
    "eye-slash",
    "eye",
    "filter",
    "flag",
    "folder",
    "graph-bar",
    "handle-drag",
    "header",
    "heart-fill",
    "heart-outline",
    "icon-communities",
    "image",
    "integration",
    "key",
    "link",
    "location",
    "lock",
    "magnifying-glass",
    "menu",
    "message",
    "new-window",
    "page-duplicate",
    "page-new",
    "page",
    "pencil",
    "people",
    "pin",
    "plane",
    "play",
    "plus",
    "product-account",
    "product-blank",
    "product-blog",
    "product-checkmark-multicolor",
    "product-checkmark",
    "product-clipboard",
    "product-clock-small",
    "product-design",
    "product-digital-download",
    "product-feature-afterpurchase",
    "product-flagship",
    "product-gift",
    "product-handshake",
    "product-help",
    "product-logout",
    "product-manage",
    "product-market-sell",
    "product-microphone",
    "product-mini-course",
    "product-page",
    "product-play",
    "product-pre-sell",
    "product-preview",
    "product-resource-library",
    "product-search-initial",
    "product-search-no-result",
    "product-settings",
    "product-students",
    "product-updates",
    "product-upgrade",
    "product-webinar-replay",
    "radio-empty",
    "radio-selected",
    "record",
    "refresh",
    "reply",
    "shield",
    "social-facebook",
    "social-google",
    "social-linkedIn",
    "social-twitter",
    "speaker",
    "star-fill",
    "star-outline",
    "smiley-face",
    "stop-sign",
    "trash-can",
    "trophy",
    "upgrade",
    "user-login",
    "user-logout",
    "view-device-desktop",
    "view-device-phone",
    "view-grid",
    "view-list",
    "view-menu",
    "warning",
    "webhook",
    "window-maximize",
    "window-minimize",
    "x-dismiss", 
];

;// CONCATENATED MODULE: ./koba/components/Icon/Icon.js






var cx = bind_default().bind((Icon_module_default()));
var Icon = function(param) {
    var ariaLabel = param.ariaLabel, className = param.className, name = param.name, color = param.color;
    var classes = cx("toga-icon", "toga-icon-".concat(name), "icon", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        "aria-hidden": !ariaLabel,
        "aria-label": ariaLabel,
        className: classes,
        "data-qa": "toga-icon-".concat(name),
        style: {
            color: color
        }
    });
};
Icon.propTypes = {
    ariaLabel: (prop_types_default()).string,
    className: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().arrayOf((prop_types_default()).string),
        (prop_types_default()).object, 
    ]),
    color: (prop_types_default()).string,
    name: prop_types_default().oneOf(availableIcons).isRequired
};
Icon.defaultProps = {
    ariaLabel: null,
    className: null,
    color: null
};
/* harmony default export */ var Icon_Icon = (Icon);

;// CONCATENATED MODULE: ./koba/components/Icon/index.js




/***/ }),

/***/ 72019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K": function() { return /* reexport */ SectionToggle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./koba/components/Icon/index.js + 2 modules
var Icon = __webpack_require__(8236);
// EXTERNAL MODULE: ./koba/components/Section/Section.module.scss
var Section_module = __webpack_require__(64844);
var Section_module_default = /*#__PURE__*/__webpack_require__.n(Section_module);
;// CONCATENATED MODULE: ./koba/components/Section/SectionToggle/SectionToggle.tsx






var cx = bind_default().bind((Section_module_default()));
var SectionToggle = function(param) {
    var caretType = param.caretType, caption = param.caption, children = param.children, title = param.title, toggleClassName = param.toggleClassName, toggleTitleClassName = param.toggleTitleClassName, toggleContentClassName = param.toggleContentClassName, rightAccessory = param.rightAccessory, _startClosed = param.startClosed, startClosed = _startClosed === void 0 ? false : _startClosed, t = param.t, onExpand = param.onExpand;
    var ref = (0,react.useState)(startClosed), isCollapsed = ref[0], setIsCollapsed = ref[1];
    var toggleSection = function(event) {
        event.preventDefault();
        if (isCollapsed) {
            onExpand === null || onExpand === void 0 ? void 0 : onExpand();
        }
        setIsCollapsed(!isCollapsed);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: cx("section--toggle-item", toggleClassName),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: cx("section--toggle-item__wrapper"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button_b37f2f11.B, {
                        appearance: "knockout",
                        "aria-label": isCollapsed ? t("components-section-click_to_expand_aria_label", "Section {{title}} collapsed. Click to expand {{title}} section", {
                            title: title
                        }) : t("components-section-click_to_collapse_aria_label", "Section {{title}} expanded. Click to collapse {{title}} section", {
                            title: title
                        }),
                        className: cx("section--toggle-item__toggleable", {
                            "has-right-accessory": rightAccessory
                        }),
                        type: "button",
                        onClick: toggleSection,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("section--toggle-item__toggleable__title", toggleTitleClassName),
                                children: title
                            }),
                            caption && !rightAccessory && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: cx("caption", "font-italic", "section--toggle-item__caption"),
                                children: caption
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                className: cx("section--toggle-item__icon"),
                                name: isCollapsed ? "caret-".concat(caretType, "-up") : "caret-".concat(caretType, "-down")
                            })
                        ]
                    }),
                    rightAccessory && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: cx("section--toggle-item__actions"),
                        children: rightAccessory
                    })
                ]
            }),
            !isCollapsed && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cx("section--toggle-item__toggle-content", toggleContentClassName),
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./koba/components/Section/SectionToggle/index.ts



/***/ }),

/***/ 99900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* binding */ SkeletonLine; },
/* harmony export */   "VJ": function() { return /* binding */ SkeletonPost; },
/* harmony export */   "zX": function() { return /* binding */ SkeletonPostContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _SkeletonPost_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4940);
/* harmony import */ var _SkeletonPost_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_SkeletonPost_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_SkeletonPost_module_scss__WEBPACK_IMPORTED_MODULE_3___default()));
var SkeletonLine = function(param) {
    var _width = param.width, width = _width === void 0 ? "100%" : _width, _height = param.height, height = _height === void 0 ? "6px" : _height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: cx("skeleton-line"),
        style: {
            width: width,
            height: height
        }
    });
};
SkeletonLine.displayName = "SkeletonLine";
var SkeletonPost = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("skeleton-post"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx("skeleton-post__details"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: cx("skeleton-post__avatar")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: cx("skeleton-comment__name"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonLine, {
                                width: "80px"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonLine, {
                                width: "160px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx("skeleton-post__body"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonLine, {
                        width: "70%"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonLine, {
                        width: "100%"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonLine, {
                        width: "30%"
                    })
                ]
            })
        ]
    });
};
SkeletonPost.displayName = "SkeletonPost";
var SkeletonPostContainer = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("skeleton-post__container"),
        "data-qa": "skeleton-post__container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonPost, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonPost, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkeletonPost, {})
        ]
    });
};
SkeletonPostContainer.displayName = "SkeletonPostContainer";
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    SkeletonLine: SkeletonLine,
    SkeletonPost: SkeletonPost,
    SkeletonPostContainer: SkeletonPostContainer
});


/***/ }),

/***/ 13925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AU": function() { return /* reexport safe */ _SkeletonPost__WEBPACK_IMPORTED_MODULE_0__.AU; }
/* harmony export */ });
/* harmony import */ var _SkeletonPost__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99900);



/***/ }),

/***/ 63579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ Typography_Caption; },
  "H1": function() { return /* reexport */ Typography_H1; },
  "H2": function() { return /* reexport */ Typography_H2; },
  "H3": function() { return /* reexport */ Typography_H3; },
  "H4": function() { return /* reexport */ Typography_H4; },
  "P": function() { return /* reexport */ Typography_P; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./koba/components/Typography/Typography.module.scss
var Typography_module = __webpack_require__(10706);
var Typography_module_default = /*#__PURE__*/__webpack_require__.n(Typography_module);
;// CONCATENATED MODULE: ./koba/components/Typography/H1.tsx







var cx = bind_default().bind((Typography_module_default()));
var H1 = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = cx("h1", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_H1 = (H1);

;// CONCATENATED MODULE: ./koba/components/Typography/H2.tsx







var H2_cx = bind_default().bind((Typography_module_default()));
var H2 = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = H2_cx("h2", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_H2 = (H2);

;// CONCATENATED MODULE: ./koba/components/Typography/H3.tsx







var H3_cx = bind_default().bind((Typography_module_default()));
var H3 = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = H3_cx("h3", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_H3 = (H3);

;// CONCATENATED MODULE: ./koba/components/Typography/H4.tsx







var H4_cx = bind_default().bind((Typography_module_default()));
var H4 = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = H4_cx("h4", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_H4 = (H4);

;// CONCATENATED MODULE: ./koba/components/Typography/P.tsx







var P_cx = bind_default().bind((Typography_module_default()));
var P = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = P_cx("p", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_P = (P);

;// CONCATENATED MODULE: ./koba/components/Typography/Caption.tsx







var Caption_cx = bind_default().bind((Typography_module_default()));
var Caption = function(_param) {
    var children = _param.children, className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className"
    ]);
    var classes = Caption_cx("caption", className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("small", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: classes
    }, props), {
        children: children
    }));
};
/* harmony default export */ var Typography_Caption = (Caption);

;// CONCATENATED MODULE: ./koba/components/Typography/index.ts









/***/ }),

/***/ 46029:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

var _class_call_check = (__webpack_require__(79658)/* ["default"] */ .Z);
var _create_class = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _create_super = (__webpack_require__(37735)/* ["default"] */ .Z);
var _runtimeJs = _interop_require_default(__webpack_require__(34051));
__webpack_unused_export__ = ({
    value: true
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.AppInitialProps;
    }
});
__webpack_unused_export__ = ({
    enumerable: true,
    get: function get() {
        return _utils.NextWebVitalsMetric;
    }
});
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _utils = __webpack_require__(63794);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function appGetInitialProps(_) {
    return _appGetInitialProps.apply(this, arguments);
}
function _appGetInitialProps() {
    _appGetInitialProps = /**
 * `App` component is used for initialize of pages. It allows for overwriting and full control of the `page` initialization.
 * This allows for keeping state between navigation, custom error handling, injecting additional data.
 */ _asyncToGenerator(_runtimeJs.default.mark(function _callee(param) {
        var Component, ctx, pageProps;
        return _runtimeJs.default.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Component = param.Component, ctx = param.ctx;
                    _ctx.next = 3;
                    return (0, _utils).loadGetInitialProps(Component, ctx);
                case 3:
                    pageProps = _ctx.sent;
                    return _ctx.abrupt("return", {
                        pageProps: pageProps
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _appGetInitialProps.apply(this, arguments);
}
var _Component;
var App = /*#__PURE__*/ function(_superClass) {
    _inherits(App, _superClass);
    var _super = _create_super(App);
    function App() {
        _class_call_check(this, App);
        return _super.apply(this, arguments);
    }
    _create_class(App, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Component = _props.Component, pageProps = _props.pageProps;
                return /*#__PURE__*/ _react.default.createElement(Component, Object.assign({}, pageProps));
            }
        }
    ]);
    return App;
}(_Component = _react.default.Component);
App.origGetInitialProps = appGetInitialProps;
App.getInitialProps = appGetInitialProps;
exports["default"] = App; //# sourceMappingURL=_app.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _object_spread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _object_spread({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _object_spread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var _class_call_check = (__webpack_require__(79658)/* ["default"] */ .Z);
var _create_class = (__webpack_require__(7222)/* ["default"] */ .Z);
var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _object_spread_props = (__webpack_require__(49961)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var useSyncExternalStore = ( false ? 0 : __webpack_require__(61688)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _object_spread_props(_object_spread({}, props), {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _class_call_check(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _create_class(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _object_spread(_object_spread_props(_object_spread({}, this._state), {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }), partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 83934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/app.js
var app = __webpack_require__(7544);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var context_ApolloContext = __webpack_require__(85317);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js




var ApolloProvider = function (_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0,context_ApolloContext/* getApolloContext */.K)();
    var parentContext = react.useContext(ApolloContext);
    var context = react.useMemo(function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, parentContext), { client: client || parentContext.client });
    }, [parentContext, client]);
    (0,globals/* invariant */.kG)(context.client, 46);
    return (react.createElement(ApolloContext.Provider, { value: context }, children));
};
//# sourceMappingURL=ApolloProvider.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js + 14 modules
var createHttpLink = __webpack_require__(75465);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 12 modules
var ApolloClient = __webpack_require__(20874);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 8 modules
var inMemoryCache = __webpack_require__(76118);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(63200);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/policies/pagination.js
var pagination = __webpack_require__(97091);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/objectWithoutProperties-c7aad4d6.js
var objectWithoutProperties_c7aad4d6 = __webpack_require__(78776);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toConsumableArray-28e9988c.js
var toConsumableArray_28e9988c = __webpack_require__(88707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/getPrototypeOf-38c87d48.js
var getPrototypeOf_38c87d48 = __webpack_require__(23214);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/defineProperty-1e8516b1.js
var defineProperty_1e8516b1 = __webpack_require__(11841);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/prop-shapes-ac9385ac.js
var prop_shapes_ac9385ac = __webpack_require__(10518);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/toaster-a57afb61.js
var toaster_a57afb61 = __webpack_require__(81792);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Icon-343b84c4.js
var Icon_343b84c4 = __webpack_require__(42990);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Button-b37f2f11.js
var Button_b37f2f11 = __webpack_require__(79707);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Portal-178fdc75.js
var Portal_178fdc75 = __webpack_require__(53325);
;// CONCATENATED MODULE: ./node_modules/@thinkific/toga-react/dist/es/ToastContainer-91c4ec78.js
var ToastContainer_91c4ec78_filename = "/index.js";
var E={toast:"Toast_toast__3",slide:"Toast_slide__1",toast__container:"Toast_toast__container__29","toast--notice":"Toast_toast--notice__44",toast__button:"Toast_toast__button__46",focused:"Toast_focused__49",hovered:"Toast_hovered__49",pressed:"Toast_pressed__55","toast--info":"Toast_toast--info__65","toast--alert":"Toast_toast--alert__86","toast--warning":"Toast_toast--warning__107",toast__icon:"Toast_toast__icon__128","toga-icon":"Toast_toga-icon__137",toast__dismiss:"Toast_toast__dismiss__139",toast__message:"Toast_toast__message__156","toast__message--emphasis":"Toast_toast__message--emphasis__159","toast--primary":"Toast_toast--primary__172","toast--secondary":"Toast_toast--secondary__175","toast--success":"Toast_toast--success__178","toast--danger":"Toast_toast--danger__187","toast--light":"Toast_toast--light__190","toast--dark":"Toast_toast--dark__193","toast--upsell":"Toast_toast--upsell__196"};(0,prop_shapes_ac9385ac.s)(".Toast_toast__3{display:flex;align-items:center;width:484px;max-width:calc(100% - 16px);min-height:48px;margin-bottom:10px;border-radius:4px;color:#fff;font-weight:600;box-shadow:0 4px 12px 0 rgba(0,0,0,.25);opacity:1;-webkit-animation-name:Toast_slide__1;animation-name:Toast_slide__1;-webkit-animation-duration:.3s;animation-duration:.3s}@media (prefers-reduced-motion:reduce){.Toast_toast__3{-webkit-animation:none;animation:none}}@-webkit-keyframes Toast_slide__1{0%{margin-bottom:-200px;opacity:0}}@keyframes Toast_slide__1{0%{margin-bottom:-200px;opacity:0}}@media (max-width:664px){.Toast_toast__3{width:100%;min-width:304px}}.Toast_toast__container__29{display:flex;position:fixed;bottom:16px;left:16px;flex-direction:column-reverse;z-index:2704}@media (max-width:952px){.Toast_toast__container__29{left:12px}}@media (max-width:344px){.Toast_toast__container__29{left:8px}}.Toast_toast__3:first-child{margin-bottom:0}.Toast_toast--notice__44{background:#379a49}.Toast_toast--notice__44 .Toast_toast__button__46{border-color:#379a49;color:#379a49}.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover{border-color:#379a49;background-color:#216e2f;color:#fff}.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49 svg,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49 svg,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus svg,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active{border-color:#216e2f;background:#216e2f;color:#fff}.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55 svg,.Toast_toast--notice__44 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Toast_toast--notice__44 .Toast_toast__button__46:disabled,.Toast_toast--notice__44 .Toast_toast__button__46[aria-disabled=true]{color:rgba(55,154,73,.45)}.Toast_toast--notice__44 .Toast_toast__button__46:disabled svg,.Toast_toast--notice__44 .Toast_toast__button__46[aria-disabled=true] svg{fill:rgba(55,154,73,.45)}.Toast_toast--info__65{background:#36394d!important}.Toast_toast--info__65 .Toast_toast__button__46{border-color:#36394d;color:#36394d}.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover{border-color:#12131a;background-color:#12131a;color:#fff}.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49 svg,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49 svg,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus svg,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active{border-color:#12131a;background:#12131a;color:#fff}.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55 svg,.Toast_toast--info__65 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Toast_toast--info__65 .Toast_toast__button__46:disabled,.Toast_toast--info__65 .Toast_toast__button__46[aria-disabled=true]{color:rgba(54,57,77,.45)}.Toast_toast--info__65 .Toast_toast__button__46:disabled svg,.Toast_toast--info__65 .Toast_toast__button__46[aria-disabled=true] svg{fill:rgba(54,57,77,.45)}.Toast_toast--alert__86{background:#d83232}.Toast_toast--alert__86 .Toast_toast__button__46{border-color:#d83232;color:#d83232}.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover{border-color:#a62626;background-color:#a62626;color:#fff}.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49 svg,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49 svg,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus svg,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active{border-color:#731a1a;background:#731a1a;color:#fff}.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55 svg,.Toast_toast--alert__86 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Toast_toast--alert__86 .Toast_toast__button__46:disabled,.Toast_toast--alert__86 .Toast_toast__button__46[aria-disabled=true]{color:rgba(216,50,50,.45)}.Toast_toast--alert__86 .Toast_toast__button__46:disabled svg,.Toast_toast--alert__86 .Toast_toast__button__46[aria-disabled=true] svg{fill:rgba(216,50,50,.45)}.Toast_toast--warning__107 .Toast_toast__button__46{border-color:#ff7e40;color:#ff7e40}.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover{border-color:#af4d1e;background-color:#af4d1e;color:#fff}.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_focused__49 svg,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_hovered__49 svg,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):focus svg,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active{border-color:#af4d1e;background:#af4d1e;color:#fff}.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]).Toast_pressed__55 svg,.Toast_toast--warning__107 .Toast_toast__button__46:not([disabled]):not([aria-disabled=true]):active svg{fill:#fff}.Toast_toast--warning__107 .Toast_toast__button__46:disabled,.Toast_toast--warning__107 .Toast_toast__button__46[aria-disabled=true]{color:rgba(255,126,64,.45)}.Toast_toast--warning__107 .Toast_toast__button__46:disabled svg,.Toast_toast--warning__107 .Toast_toast__button__46[aria-disabled=true] svg{fill:rgba(255,126,64,.45)}.Toast_toast__3 .Toast_toast__icon__128{display:flex;align-self:stretch;padding:12px 8px;border-radius:4px 0 0 4px;background:hsla(0,0%,100%,.15);color:#fff}.Toast_toast__3 .Toast_toast__icon__128 svg{fill:#fff}.Toast_toast__3 .Toast_toast__icon__128 .Toast_toga-icon__137{font-size:24px}.Toast_toast__3 .Toast_toast__dismiss__139{align-items:flex-start;align-self:flex-start;width:24px;height:24px;margin:12px 12px 0 0;padding:0;border:0;color:#fff}.Toast_toast__3 .Toast_toast__dismiss__139 svg{fill:#fff}.Toast_toast__3 .Toast_toast__dismiss__139:not([disabled]):not([aria-disabled=true]):focus,.Toast_toast__3 .Toast_toast__dismiss__139:not([disabled]):not([aria-disabled=true]):hover{color:#fff}.Toast_toast__3 .Toast_toast__dismiss__139:not([disabled]):not([aria-disabled=true]):focus svg,.Toast_toast__3 .Toast_toast__dismiss__139:not([disabled]):not([aria-disabled=true]):hover svg{fill:#fff}.Toast_toast__3 .Toast_toast__dismiss__139 .Toast_toga-icon__137{font-size:24px}.Toast_toast__3 .Toast_toast__message__156{flex-grow:1;padding:12px 16px}.Toast_toast__3 .Toast_toast__message--emphasis__159{font-style:italic;font-weight:400}.Toast_toast__3 .Toast_toast__message__156:focus{outline:0}.Toast_toast__3 .Toast_toast__button__46{display:block;flex-shrink:0;margin:12px 0 4px;background-color:#fff;font-size:.875rem;text-transform:uppercase}.Toast_toast--primary__172{background:#5668c7}.Toast_toast--secondary__175{background:#6f7282}.Toast_toast--success__178{background:#379a49}.Toast_toast--info__65{background:#139bde}.Toast_toast--warning__107{background:#ff7e40}.Toast_toast--danger__187{background:#d83232}.Toast_toast--light__190{background:#eceffb}.Toast_toast--dark__193{background:#100d59}.Toast_toast--upsell__196{background:#00a999}",{insertAt:"top"});var N=["actionTitle","autoClose","children","className","closeToast","closeOnClick","onActionClick","type","updateId","isDocumentHidden","onClose","onOpen"];function R(t){var o=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var a,s=(0,getPrototypeOf_38c87d48.a)(t);if(o){var n=(0,getPrototypeOf_38c87d48.a)(this).constructor;a=Reflect.construct(s,arguments,n)}else a=s.apply(this,arguments);return (0,getPrototypeOf_38c87d48.b)(this,a)}}var I=prop_shapes_ac9385ac.b.bind(E),A=function(a){(0,getPrototypeOf_38c87d48._)(_,a);var e=R(_);function _(t){var o;return (0,getPrototypeOf_38c87d48.c)(this,_),o=e.call(this,t),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"closeToastTimer",null),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"onAnimationEnd",(function(){var t=o.props,a=t.autoClose,s=t.closeToast;clearTimeout(o.closeToastTimer),a&&(o.closeToastTimer=setTimeout((function(){return s()}),a))})),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"toastIcon",(function(t){switch(t){case toaster_a57afb61.T.NOTICE:return"circle-fill-check";case toaster_a57afb61.T.ALERT:return"stop-sign";case toaster_a57afb61.T.INFO:return"circle-fill-info";case toaster_a57afb61.T.WARNING:default:return"warning"}})),o.state={isRunning:!0},o.toastMessage=react.createRef(),o}return (0,getPrototypeOf_38c87d48.e)(_,[{key:"componentDidMount",value:function(){var t=this.props,o=t.onOpen,a=t.onActionClick;o(),"function"==typeof a&&this.toastMessage&&this.toastMessage.current&&this.toastMessage.current.focus()}},{key:"UNSAFE_componentWillReceiveProps",value:function(t){var o=t.isDocumentHidden;this.props.isDocumentHidden!==o&&this.setState({isRunning:!o})}},{key:"componentWillUnmount",value:function(){(0,this.props.onClose)(),clearTimeout(this.closeToastTimer)}},{key:"render",value:function(){var a=this.props,s=a.actionTitle,e=a.autoClose,_=a.children,n=a.className,i=a.closeToast,r=a.closeOnClick,d=a.onActionClick,l=a.type;a.updateId,a.isDocumentHidden,a.onClose,a.onOpen;var u=(0,objectWithoutProperties_c7aad4d6._)(a,N),f=this.state.isRunning,b=this.onAnimationEnd,T={animationPlayState:f?"running":"paused"},p={},m=[I("toast__button"),{"button--secondary-success":l===toaster_a57afb61.T.NOTICE,"button--secondary-warning":l===toaster_a57afb61.T.WARNING,"button--secondary-info":l===toaster_a57afb61.T.INFO,"button--secondary-alert":l===toaster_a57afb61.T.ALERT}],g=I("toast",n,{"toast--notice":l===toaster_a57afb61.T.NOTICE,"toast--alert":l===toaster_a57afb61.T.ALERT,"toast--warning":l===toaster_a57afb61.T.WARNING,"toast--info":l===toaster_a57afb61.T.INFO});return r&&(u.onClick=function(){return i()},u.onKeyPress=function(){return i()}),d||(p.role="alert"),react.createElement("div",(0,objectWithoutProperties_c7aad4d6.a)({className:g,style:T,onAnimationEnd:b},p,u),react.createElement("div",{className:I("toast__icon")},react.createElement(Icon_343b84c4.I,{name:this.toastIcon(l),title:l})),react.createElement("div",{className:I("toast__message"),ref:this.toastMessage,tabIndex:-1},_,s&&react.createElement(Button_b37f2f11.B,{appearance:"secondary",className:m,hasDanger:"alert"===l,size:"x-small",onClick:d},s)),!e&&react.createElement(Button_b37f2f11.B,{appearance:"utility","aria-label":"close",className:I("toast__dismiss"),isDark:!0,onClick:i},react.createElement(Icon_343b84c4.I,{name:"x-dismiss",title:"Close alert"})))}}]),_}(react.Component);A.propTypes={actionTitle:(prop_types_default()).string,autoClose:prop_types_default().oneOfType([(prop_types_default()).number,(prop_types_default()).bool]).isRequired,children:(prop_types_default()).node.isRequired,className:prop_shapes_ac9385ac.c,closeOnClick:(prop_types_default()).bool.isRequired,closeToast:(prop_types_default()).func.isRequired,isDocumentHidden:(prop_types_default()).bool,type:prop_types_default().oneOf([toaster_a57afb61.T.NOTICE,toaster_a57afb61.T.ALERT,toaster_a57afb61.T.INFO,toaster_a57afb61.T.WARNING]),updateId:(prop_types_default()).number,onActionClick:(prop_types_default()).func,onClose:(prop_types_default()).func,onOpen:(prop_types_default()).func},A.defaultProps={actionTitle:null,className:null,isDocumentHidden:!1,type:toaster_a57afb61.T.NOTICE,updateId:null,onActionClick:null,onClose:function(){},onOpen:function(){}},A.displayName="Toast",A.filename=ToastContainer_91c4ec78_filename,A.spreadAttributes=!0;var D=A;function j(t,o){var a=Object.keys(t);if(Object.getOwnPropertySymbols){var s=Object.getOwnPropertySymbols(t);o&&(s=s.filter((function(o){return Object.getOwnPropertyDescriptor(t,o).enumerable}))),a.push.apply(a,s)}return a}function P(t){for(var o=1;o<arguments.length;o++){var a=null!=arguments[o]?arguments[o]:{};o%2?j(Object(a),!0).forEach((function(o){(0,defineProperty_1e8516b1._)(t,o,a[o])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(a)):j(Object(a)).forEach((function(o){Object.defineProperty(t,o,Object.getOwnPropertyDescriptor(a,o))}))}return t}function H(t){var o=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var a,s=(0,getPrototypeOf_38c87d48.a)(t);if(o){var n=(0,getPrototypeOf_38c87d48.a)(this).constructor;a=Reflect.construct(s,arguments,n)}else a=s.apply(this,arguments);return (0,getPrototypeOf_38c87d48.b)(this,a)}}var S=prop_shapes_ac9385ac.b.bind(E),M=function(t){(0,getPrototypeOf_38c87d48._)(_,react.Component);var e=H(_);function _(t){var o;return (0,getPrototypeOf_38c87d48.c)(this,_),o=e.call(this,t),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"collection",{}),(0,defineProperty_1e8516b1._)((0,getPrototypeOf_38c87d48.d)(o),"isDocumentHidden",(function(){return o.setState({isDocumentHidden:document.hidden})})),o.state={toast:[],isDocumentHidden:!1},o}return (0,getPrototypeOf_38c87d48.e)(_,[{key:"componentDidMount",value:function(){var t=this,o=this.props.pauseOnVisibilityChange,a=toaster_a57afb61.A.SHOW,s=toaster_a57afb61.A.CLEAR,e=toaster_a57afb61.A.MOUNTED;toaster_a57afb61.E.on(a,(function(o,a){t.show(o,a)})).on(s,(function(o){return null!==o?t.removeToast(o):t.clear()})).emit(e,this),o&&document.addEventListener("visibilitychange",this.isDocumentHidden),window.Thinkific&&(window.Thinkific.toaster=toaster_a57afb61.t)}},{key:"componentWillUnmount",value:function(){var t=this.props.pauseOnVisibilityChange;toaster_a57afb61.E.off(toaster_a57afb61.A.SHOW),toaster_a57afb61.E.off(toaster_a57afb61.A.CLEAR),t&&document.removeEventListener("visibilitychange",this.isDocumentHidden)}},{key:"getAutoCloseDelay",value:function(t){var o=this.props.autoClose;return!1===t||"number"==typeof t&&!isNaN(t)&&t>0?t:o}},{key:"removeToast",value:function(t){var o=this.state.toast;this.setState({toast:o.filter((function(o){return o!==parseInt(t,10)}))})}},{key:"show",value:function(t,o){var s=this;if(!_.canBeRendered(t))throw new Error("The element you provided cannot be rendered. You provided an element of type ".concat((0,getPrototypeOf_38c87d48.f)(t)));var e=o.toastId,n=function(){return s.removeToast(e)},i=this.state.toast,r=this.props.closeOnClick,c={actionTitle:o.actionTitle,autoClose:this.getAutoCloseDelay(!1!==o.autoClose?parseInt(o.autoClose,10):o.autoClose),closeToast:n,closeOnClick:null!==o.closeOnClick?o.closeOnClick:r,id:e,onActionClick:o.onActionClick,type:o.type,updateId:o.updateId};"function"==typeof o.onOpen&&(c.onOpen=o.onOpen),"function"==typeof o.onClose&&(c.onClose=o.onClose),(0,react.isValidElement)(t)&&"string"!=typeof t.type&&"number"!=typeof t.type?t=(0,react.cloneElement)(t,{closeToast:n}):"function"==typeof t&&(t=t({closeToast:n})),this.collection=P(P({},this.collection),{},(0,defineProperty_1e8516b1._)({},e,{options:c,content:t})),this.setState({toast:null!==c.updateId?(0,toConsumableArray_28e9988c._)(i):[].concat((0,toConsumableArray_28e9988c._)(i),[e])})}},{key:"makeToast",value:function(t,a){var s=this.state.isDocumentHidden,e=react.isValidElement(t);return react.createElement(D,(0,objectWithoutProperties_c7aad4d6.a)({},a,{isDocumentHidden:s,key:"toast-".concat(a.id)}),e&&t,!e&&react.createElement("span",{dangerouslySetInnerHTML:{__html:t}}))}},{key:"clear",value:function(){this.setState({toast:[]})}},{key:"renderToast",value:function(){var t=this,o=[],a=this.state.toast,s=this.collection;return Object.keys(s).forEach((function(s){var e=t.collection[s];-1!==a.indexOf(parseInt(s,10))?(o.length>=toaster_a57afb61.M&&o.shift(),o.push(t.makeToast(e.content,e.options))):delete t.collection[s]})),o}},{key:"render",value:function(){return react.createElement(Portal_178fdc75.P,null,react.createElement("div",{"aria-atomic":"true","aria-live":"polite",className:S("toast__container")},this.renderToast()))}}],[{key:"canBeRendered",value:function(t){return (0,react.isValidElement)(t)||"string"==typeof t||"number"==typeof t||"function"==typeof t}}]),_}();M.propTypes={autoClose:prop_types_default().oneOfType([(prop_types_default()).number,(prop_types_default()).bool]),closeOnClick:(prop_types_default()).bool,pauseOnVisibilityChange:(prop_types_default()).bool},M.defaultProps={autoClose:3e3,closeOnClick:!0,pauseOnVisibilityChange:!0},M.displayName="ToastContainer",M.filename=ToastContainer_91c4ec78_filename;var W=M;
//# sourceMappingURL=ToastContainer-91c4ec78.js.map

// EXTERNAL MODULE: ./components/Layouts/SiteLayout/index.ts + 31 modules
var SiteLayout = __webpack_require__(73314);
;// CONCATENATED MODULE: ./node_modules/promise-polyfill/src/finally.js
/**
 * @this {Promise}
 */
function finallyConstructor(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      // @ts-ignore
      return constructor.resolve(callback()).then(function() {
        // @ts-ignore
        return constructor.reject(reason);
      });
    }
  );
}

/* harmony default export */ var src_finally = (finallyConstructor);

;// CONCATENATED MODULE: ./node_modules/promise-polyfill/src/allSettled.js
function allSettled(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(
        new TypeError(
          typeof arr +
            ' ' +
            arr +
            ' is not iterable(cannot read property Symbol(Symbol.iterator))'
        )
      );
    }
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        var then = val.then;
        if (typeof then === 'function') {
          then.call(
            val,
            function(val) {
              res(i, val);
            },
            function(e) {
              args[i] = { status: 'rejected', reason: e };
              if (--remaining === 0) {
                resolve(args);
              }
            }
          );
          return;
        }
      }
      args[i] = { status: 'fulfilled', value: val };
      if (--remaining === 0) {
        resolve(args);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
}

/* harmony default export */ var src_allSettled = (allSettled);

;// CONCATENATED MODULE: ./node_modules/promise-polyfill/src/any.js
/**
 * @constructor
 */
function AggregateError(errors, message) {
  (this.name = 'AggregateError'), (this.errors = errors);
  this.message = message || '';
}
AggregateError.prototype = Error.prototype;

function any(arr) {
  var P = this;
  return new P(function(resolve, reject) {
    if (!(arr && typeof arr.length !== 'undefined')) {
      return reject(new TypeError('Promise.any accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return reject();

    var rejectionReasons = [];
    for (var i = 0; i < args.length; i++) {
      try {
        P.resolve(args[i])
          .then(resolve)
          .catch(function(error) {
            rejectionReasons.push(error);
            if (rejectionReasons.length === args.length) {
              reject(
                new AggregateError(
                  rejectionReasons,
                  'All promises were rejected'
                )
              );
            }
          });
      } catch (ex) {
        reject(ex);
      }
    }
  });
}

/* harmony default export */ var src_any = (any);

;// CONCATENATED MODULE: ./node_modules/promise-polyfill/src/index.js




// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function isArray(x) {
  return Boolean(x && typeof x.length !== 'undefined');
}

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

/**
 * @constructor
 * @param {Function} fn
 */
function src_Promise(fn) {
  if (!(this instanceof src_Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  /** @type {!number} */
  this._state = 0;
  /** @type {!boolean} */
  this._handled = false;
  /** @type {Promise|undefined} */
  this._value = undefined;
  /** @type {!Array<!Function>} */
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  src_Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof src_Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    src_Promise._immediateFn(function() {
      if (!self._handled) {
        src_Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

/**
 * @constructor
 */
function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

src_Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

src_Promise.prototype.then = function(onFulfilled, onRejected) {
  // @ts-ignore
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

src_Promise.prototype['finally'] = src_finally;

src_Promise.all = function(arr) {
  return new src_Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.all accepts an array'));
    }

    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

src_Promise.any = src_any;

src_Promise.allSettled = src_allSettled;

src_Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === src_Promise) {
    return value;
  }

  return new src_Promise(function(resolve) {
    resolve(value);
  });
};

src_Promise.reject = function(value) {
  return new src_Promise(function(resolve, reject) {
    reject(value);
  });
};

src_Promise.race = function(arr) {
  return new src_Promise(function(resolve, reject) {
    if (!isArray(arr)) {
      return reject(new TypeError('Promise.race accepts an array'));
    }

    for (var i = 0, len = arr.length; i < len; i++) {
      src_Promise.resolve(arr[i]).then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
src_Promise._immediateFn =
  // @ts-ignore
  (typeof setImmediate === 'function' &&
    function(fn) {
      // @ts-ignore
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

src_Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

/* harmony default export */ var src = (src_Promise);

;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/jsonify_notice.js
var FILTERED = '[Filtered]';
var MAX_OBJ_LENGTH = 128;
// jsonifyNotice serializes notice to JSON and truncates params,
// environment and session keys.
function jsonifyNotice(notice, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.maxLength, maxLength = _c === void 0 ? 64000 : _c, _d = _b.keysBlocklist, keysBlocklist = _d === void 0 ? [] : _d;
    if (notice.errors) {
        for (var i = 0; i < notice.errors.length; i++) {
            var t = new Truncator({ keysBlocklist: keysBlocklist });
            notice.errors[i] = t.truncate(notice.errors[i]);
        }
    }
    var s = '';
    var keys = ['params', 'environment', 'session'];
    for (var level = 0; level < 8; level++) {
        var opts = { level: level, keysBlocklist: keysBlocklist };
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var obj = notice[key];
            if (obj) {
                notice[key] = truncate(obj, opts);
            }
        }
        s = JSON.stringify(notice);
        if (s.length < maxLength) {
            return s;
        }
    }
    var params = {
        json: s.slice(0, Math.floor(maxLength / 2)) + '...',
    };
    keys.push('errors');
    for (var _e = 0, keys_2 = keys; _e < keys_2.length; _e++) {
        var key = keys_2[_e];
        var obj = notice[key];
        if (!obj) {
            continue;
        }
        s = JSON.stringify(obj);
        params[key] = s.length;
    }
    var err = new Error("airbrake: notice exceeds max length and can't be truncated");
    err.params = params;
    throw err;
}
function scale(num, level) {
    return num >> level || 1;
}
var Truncator = /** @class */ (function () {
    function Truncator(opts) {
        this.maxStringLength = 1024;
        this.maxObjectLength = MAX_OBJ_LENGTH;
        this.maxArrayLength = MAX_OBJ_LENGTH;
        this.maxDepth = 8;
        this.keys = [];
        this.keysBlocklist = [];
        this.seen = [];
        var level = opts.level || 0;
        this.keysBlocklist = opts.keysBlocklist || [];
        this.maxStringLength = scale(this.maxStringLength, level);
        this.maxObjectLength = scale(this.maxObjectLength, level);
        this.maxArrayLength = scale(this.maxArrayLength, level);
        this.maxDepth = scale(this.maxDepth, level);
    }
    Truncator.prototype.truncate = function (value, key, depth) {
        if (key === void 0) { key = ''; }
        if (depth === void 0) { depth = 0; }
        if (value === null || value === undefined) {
            return value;
        }
        switch (typeof value) {
            case 'boolean':
            case 'number':
            case 'function':
                return value;
            case 'string':
                return this.truncateString(value);
            case 'object':
                break;
            default:
                return this.truncateString(String(value));
        }
        if (value instanceof String) {
            return this.truncateString(value.toString());
        }
        if (value instanceof Boolean ||
            value instanceof Number ||
            value instanceof Date ||
            value instanceof RegExp) {
            return value;
        }
        if (value instanceof Error) {
            return this.truncateString(value.toString());
        }
        if (this.seen.indexOf(value) >= 0) {
            return "[Circular ".concat(this.getPath(value), "]");
        }
        var type = objectType(value);
        depth++;
        if (depth > this.maxDepth) {
            return "[Truncated ".concat(type, "]");
        }
        this.keys.push(key);
        this.seen.push(value);
        switch (type) {
            case 'Array':
                return this.truncateArray(value, depth);
            case 'Object':
                return this.truncateObject(value, depth);
            default:
                var saved = this.maxDepth;
                this.maxDepth = 0;
                var obj = this.truncateObject(value, depth);
                obj.__type = type;
                this.maxDepth = saved;
                return obj;
        }
    };
    Truncator.prototype.getPath = function (value) {
        var index = this.seen.indexOf(value);
        var path = [this.keys[index]];
        for (var i = index; i >= 0; i--) {
            var sub = this.seen[i];
            if (sub && getAttr(sub, path[0]) === value) {
                value = sub;
                path.unshift(this.keys[i]);
            }
        }
        return '~' + path.join('.');
    };
    Truncator.prototype.truncateString = function (s) {
        if (s.length > this.maxStringLength) {
            return s.slice(0, this.maxStringLength) + '...';
        }
        return s;
    };
    Truncator.prototype.truncateArray = function (arr, depth) {
        if (depth === void 0) { depth = 0; }
        var length = 0;
        var dst = [];
        for (var i = 0; i < arr.length; i++) {
            var el = arr[i];
            dst.push(this.truncate(el, i.toString(), depth));
            length++;
            if (length >= this.maxArrayLength) {
                break;
            }
        }
        return dst;
    };
    Truncator.prototype.truncateObject = function (obj, depth) {
        if (depth === void 0) { depth = 0; }
        var length = 0;
        var dst = {};
        for (var key in obj) {
            if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                continue;
            }
            if (isBlocklisted(key, this.keysBlocklist)) {
                dst[key] = FILTERED;
                continue;
            }
            var value = getAttr(obj, key);
            if (value === undefined || typeof value === 'function') {
                continue;
            }
            dst[key] = this.truncate(value, key, depth);
            length++;
            if (length >= this.maxObjectLength) {
                break;
            }
        }
        return dst;
    };
    return Truncator;
}());
function truncate(value, opts) {
    if (opts === void 0) { opts = {}; }
    var t = new Truncator(opts);
    return t.truncate(value);
}
function getAttr(obj, attr) {
    // Ignore browser specific exception trying to read an attribute (#79).
    try {
        return obj[attr];
    }
    catch (_) {
        return;
    }
}
function objectType(obj) {
    var s = Object.prototype.toString.apply(obj);
    return s.slice('[object '.length, -1);
}
function isBlocklisted(key, keysBlocklist) {
    for (var _i = 0, keysBlocklist_1 = keysBlocklist; _i < keysBlocklist_1.length; _i++) {
        var v = keysBlocklist_1[_i];
        if (v === key) {
            return true;
        }
        if (v instanceof RegExp) {
            if (key.match(v)) {
                return true;
            }
        }
    }
    return false;
}
//# sourceMappingURL=jsonify_notice.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/metrics.js
var Span = /** @class */ (function () {
    function Span(metric, name, startTime) {
        this._dur = 0;
        this._level = 0;
        this._metric = metric;
        this.name = name;
        this.startTime = startTime || new Date();
    }
    Span.prototype.end = function (endTime) {
        this.endTime = endTime ? endTime : new Date();
        this._dur += this.endTime.getTime() - this.startTime.getTime();
        this._metric._incGroup(this.name, this._dur);
        this._metric = null;
    };
    Span.prototype._pause = function () {
        if (this._paused()) {
            return;
        }
        var now = new Date();
        this._dur += now.getTime() - this.startTime.getTime();
        this.startTime = null;
    };
    Span.prototype._resume = function () {
        if (!this._paused()) {
            return;
        }
        this.startTime = new Date();
    };
    Span.prototype._paused = function () {
        return this.startTime == null;
    };
    return Span;
}());

var BaseMetric = /** @class */ (function () {
    function BaseMetric() {
        this._spans = {};
        this._groups = {};
        this.startTime = new Date();
    }
    BaseMetric.prototype.end = function (endTime) {
        if (!this.endTime) {
            this.endTime = endTime || new Date();
        }
    };
    BaseMetric.prototype.isRecording = function () {
        return true;
    };
    BaseMetric.prototype.startSpan = function (name, startTime) {
        var span = this._spans[name];
        if (span) {
            span._level++;
        }
        else {
            span = new Span(this, name, startTime);
            this._spans[name] = span;
        }
    };
    BaseMetric.prototype.endSpan = function (name, endTime) {
        var span = this._spans[name];
        if (!span) {
            console.error('airbrake: span=%s does not exist', name);
            return;
        }
        if (span._level > 0) {
            span._level--;
        }
        else {
            span.end(endTime);
            delete this._spans[span.name];
        }
    };
    BaseMetric.prototype._incGroup = function (name, ms) {
        this._groups[name] = (this._groups[name] || 0) + ms;
    };
    BaseMetric.prototype._duration = function () {
        if (!this.endTime) {
            this.endTime = new Date();
        }
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return BaseMetric;
}());

var NoopMetric = /** @class */ (function () {
    function NoopMetric() {
    }
    NoopMetric.prototype.isRecording = function () {
        return false;
    };
    NoopMetric.prototype.startSpan = function (_name, _startTime) { };
    NoopMetric.prototype.endSpan = function (_name, _startTime) { };
    NoopMetric.prototype._incGroup = function (_name, _ms) { };
    return NoopMetric;
}());

//# sourceMappingURL=metrics.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/scope.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Scope = /** @class */ (function () {
    function Scope() {
        this._noopMetric = new NoopMetric();
        this._context = {};
        this._historyMaxLen = 20;
        this._history = [];
    }
    Scope.prototype.clone = function () {
        var clone = new Scope();
        clone._context = __assign({}, this._context);
        clone._history = this._history.slice();
        return clone;
    };
    Scope.prototype.setContext = function (context) {
        this._context = __assign(__assign({}, this._context), context);
    };
    Scope.prototype.context = function () {
        var ctx = __assign({}, this._context);
        if (this._history.length > 0) {
            ctx.history = this._history.slice();
        }
        return ctx;
    };
    Scope.prototype.pushHistory = function (state) {
        if (this._isDupState(state)) {
            if (this._lastRecord.num) {
                this._lastRecord.num++;
            }
            else {
                this._lastRecord.num = 2;
            }
            return;
        }
        if (!state.date) {
            state.date = new Date();
        }
        this._history.push(state);
        this._lastRecord = state;
        if (this._history.length > this._historyMaxLen) {
            this._history = this._history.slice(-this._historyMaxLen);
        }
    };
    Scope.prototype._isDupState = function (state) {
        if (!this._lastRecord) {
            return false;
        }
        for (var key in state) {
            if (!state.hasOwnProperty(key) || key === 'date') {
                continue;
            }
            if (state[key] !== this._lastRecord[key]) {
                return false;
            }
        }
        return true;
    };
    Scope.prototype.routeMetric = function () {
        return this._routeMetric || this._noopMetric;
    };
    Scope.prototype.setRouteMetric = function (metric) {
        this._routeMetric = metric;
    };
    Scope.prototype.queueMetric = function () {
        return this._queueMetric || this._noopMetric;
    };
    Scope.prototype.setQueueMetric = function (metric) {
        this._queueMetric = metric;
    };
    return Scope;
}());

//# sourceMappingURL=scope.js.map
// EXTERNAL MODULE: ./node_modules/error-stack-parser/error-stack-parser.js
var error_stack_parser = __webpack_require__(79180);
var error_stack_parser_default = /*#__PURE__*/__webpack_require__.n(error_stack_parser);
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/processor/esp.js

var hasConsole = typeof console === 'object' && console.warn;
function parse(err) {
    try {
        return error_stack_parser_default().parse(err);
    }
    catch (parseErr) {
        if (hasConsole && err.stack) {
            console.warn('ErrorStackParser:', parseErr.toString(), err.stack);
        }
    }
    if (err.fileName) {
        return [err];
    }
    return [];
}
function espProcessor(err) {
    var backtrace = [];
    if (err.noStack) {
        backtrace.push({
            function: err.functionName || '',
            file: err.fileName || '',
            line: err.lineNumber || 0,
            column: err.columnNumber || 0,
        });
    }
    else {
        var frames_2 = parse(err);
        if (frames_2.length === 0) {
            try {
                throw new Error('fake');
            }
            catch (fakeErr) {
                frames_2 = parse(fakeErr);
                frames_2.shift();
                frames_2.shift();
            }
        }
        for (var _i = 0, frames_1 = frames_2; _i < frames_1.length; _i++) {
            var frame = frames_1[_i];
            backtrace.push({
                function: frame.functionName || '',
                file: frame.fileName || '',
                line: frame.lineNumber || 0,
                column: frame.columnNumber || 0,
            });
        }
    }
    var type = err.name ? err.name : '';
    var msg = err.message ? String(err.message) : String(err);
    return {
        type: type,
        message: msg,
        backtrace: backtrace,
    };
}
//# sourceMappingURL=esp.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/filter/angular_message.js
var re = new RegExp([
    '^',
    '\\[(\\$.+)\\]',
    '\\s',
    '([\\s\\S]+)',
    '$',
].join(''));
function angularMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== '' && err.type !== 'Error') {
        return notice;
    }
    var m = err.message.match(re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}
//# sourceMappingURL=angular_message.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/filter/debounce.js
function makeDebounceFilter() {
    var lastNoticeJSON;
    var timeout;
    return function (notice) {
        var s = JSON.stringify(notice.errors);
        if (s === lastNoticeJSON) {
            return null;
        }
        if (timeout) {
            clearTimeout(timeout);
        }
        lastNoticeJSON = s;
        timeout = setTimeout(function () {
            lastNoticeJSON = '';
        }, 1000);
        return notice;
    };
}
//# sourceMappingURL=debounce.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/filter/ignore_noise.js
var IGNORED_MESSAGES = [
    'Script error',
    'Script error.',
    'InvalidAccessError',
];
function ignoreNoiseFilter(notice) {
    var err = notice.errors[0];
    if (err.type === '' && IGNORED_MESSAGES.indexOf(err.message) !== -1) {
        return null;
    }
    if (err.backtrace && err.backtrace.length > 0) {
        var frame = err.backtrace[0];
        if (frame.file === '<anonymous>') {
            return null;
        }
    }
    return notice;
}
//# sourceMappingURL=ignore_noise.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/filter/uncaught_message.js
var uncaught_message_re = new RegExp([
    '^',
    'Uncaught\\s',
    '(.+?)',
    ':\\s',
    '(.+)',
    '$',
].join(''));
function uncaughtMessageFilter(notice) {
    var err = notice.errors[0];
    if (err.type !== '' && err.type !== 'Error') {
        return notice;
    }
    var m = err.message.match(uncaught_message_re);
    if (m !== null) {
        err.type = m[1];
        err.message = m[2];
    }
    return notice;
}
//# sourceMappingURL=uncaught_message.js.map
// EXTERNAL MODULE: ./node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(54098);
var browser_ponyfill_default = /*#__PURE__*/__webpack_require__.n(browser_ponyfill);
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/http_req/api.js
var errors = {
    unauthorized: new Error('airbrake: unauthorized: project id or key are wrong'),
    ipRateLimited: new Error('airbrake: IP is rate limited'),
};
//# sourceMappingURL=api.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/http_req/fetch.js



var rateLimitReset = 0;
function request(req) {
    var utime = Date.now() / 1000;
    if (utime < rateLimitReset) {
        return src.reject(errors.ipRateLimited);
    }
    var opt = {
        method: req.method,
        body: req.body,
        headers: req.headers,
    };
    return browser_ponyfill_default()(req.url, opt).then(function (resp) {
        if (resp.status === 401) {
            throw errors.unauthorized;
        }
        if (resp.status === 429) {
            var s = resp.headers.get('X-RateLimit-Delay');
            if (!s) {
                throw errors.ipRateLimited;
            }
            var n = parseInt(s, 10);
            if (n > 0) {
                rateLimitReset = Date.now() / 1000 + n;
            }
            throw errors.ipRateLimited;
        }
        if (resp.status === 204) {
            return { json: null };
        }
        if (resp.status === 404) {
            throw new Error('404 Not Found');
        }
        if (resp.status >= 200 && resp.status < 300) {
            return resp.json().then(function (json) {
                return { json: json };
            });
        }
        if (resp.status >= 400 && resp.status < 500) {
            return resp.json().then(function (json) {
                var err = new Error(json.message);
                throw err;
            });
        }
        return resp.text().then(function (body) {
            var err = new Error("airbrake: fetch: unexpected response: code=".concat(resp.status, " body='").concat(body, "'"));
            throw err;
        });
    });
}
//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/http_req/node.js


function makeRequester(api) {
    return function (req) {
        return node_request(req, api);
    };
}
var node_rateLimitReset = 0;
function node_request(req, api) {
    var utime = Date.now() / 1000;
    if (utime < node_rateLimitReset) {
        return src.reject(errors.ipRateLimited);
    }
    return new src(function (resolve, reject) {
        api({
            url: req.url,
            method: req.method,
            body: req.body,
            headers: {
                'content-type': 'application/json',
            },
            timeout: req.timeout,
        }, function (error, resp, body) {
            if (error) {
                reject(error);
                return;
            }
            if (!resp.statusCode) {
                error = new Error("airbrake: request: response statusCode is ".concat(resp.statusCode));
                reject(error);
                return;
            }
            if (resp.statusCode === 401) {
                reject(errors.unauthorized);
                return;
            }
            if (resp.statusCode === 429) {
                reject(errors.ipRateLimited);
                var h = resp.headers['x-ratelimit-delay'];
                if (!h) {
                    return;
                }
                var s = void 0;
                if (typeof h === 'string') {
                    s = h;
                }
                else if (h instanceof Array) {
                    s = h[0];
                }
                else {
                    return;
                }
                var n = parseInt(s, 10);
                if (n > 0) {
                    node_rateLimitReset = Date.now() / 1000 + n;
                }
                return;
            }
            if (resp.statusCode === 204) {
                resolve({ json: null });
                return;
            }
            if (resp.statusCode >= 200 && resp.statusCode < 300) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                }
                catch (err) {
                    reject(err);
                    return;
                }
                resolve(json);
                return;
            }
            if (resp.statusCode >= 400 && resp.statusCode < 500) {
                var json = void 0;
                try {
                    json = JSON.parse(body);
                }
                catch (err) {
                    reject(err);
                    return;
                }
                error = new Error(json.message);
                reject(error);
                return;
            }
            body = body.trim();
            error = new Error("airbrake: node: unexpected response: code=".concat(resp.statusCode, " body='").concat(body, "'"));
            reject(error);
        });
    });
}
//# sourceMappingURL=node.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/http_req/index.js


function http_req_makeRequester(opts) {
    if (opts.request) {
        return makeRequester(opts.request);
    }
    return request;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/tdshared.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var tdigest;
var hasTdigest = false;
try {
    tdigest = __webpack_require__(14378);
    hasTdigest = true;
}
catch (err) { }
var TDigestStat = /** @class */ (function () {
    function TDigestStat() {
        this.count = 0;
        this.sum = 0;
        this.sumsq = 0;
        this._td = new tdigest.Digest();
    }
    TDigestStat.prototype.add = function (ms) {
        if (ms === 0) {
            ms = 0.00001;
        }
        this.count += 1;
        this.sum += ms;
        this.sumsq += ms * ms;
        if (this._td) {
            this._td.push(ms);
        }
    };
    TDigestStat.prototype.toJSON = function () {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td),
        };
    };
    return TDigestStat;
}());

var TDigestStatGroups = /** @class */ (function (_super) {
    __extends(TDigestStatGroups, _super);
    function TDigestStatGroups() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.groups = {};
        return _this;
    }
    TDigestStatGroups.prototype.addGroups = function (totalMs, groups) {
        this.add(totalMs);
        for (var name_1 in groups) {
            if (groups.hasOwnProperty(name_1)) {
                this.addGroup(name_1, groups[name_1]);
            }
        }
    };
    TDigestStatGroups.prototype.addGroup = function (name, ms) {
        var stat = this.groups[name];
        if (!stat) {
            stat = new TDigestStat();
            this.groups[name] = stat;
        }
        stat.add(ms);
    };
    TDigestStatGroups.prototype.toJSON = function () {
        return {
            count: this.count,
            sum: this.sum,
            sumsq: this.sumsq,
            tdigestCentroids: tdigestCentroids(this._td),
            groups: this.groups,
        };
    };
    return TDigestStatGroups;
}(TDigestStat));

function tdigestCentroids(td) {
    var means = [];
    var counts = [];
    td.centroids.each(function (c) {
        means.push(c.mean);
        counts.push(c.n);
    });
    return {
        mean: means,
        count: counts,
    };
}
//# sourceMappingURL=tdshared.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/queries.js
var queries_assign = (undefined && undefined.__assign) || function () {
    queries_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return queries_assign.apply(this, arguments);
};


var FLUSH_INTERVAL = 15000; // 15 seconds
var QueryInfo = /** @class */ (function () {
    function QueryInfo(query) {
        if (query === void 0) { query = ''; }
        this.method = '';
        this.route = '';
        this.query = '';
        this.func = '';
        this.file = '';
        this.line = 0;
        this.startTime = new Date();
        this.query = query;
    }
    QueryInfo.prototype._duration = function () {
        if (!this.endTime) {
            this.endTime = new Date();
        }
        return this.endTime.getTime() - this.startTime.getTime();
    };
    return QueryInfo;
}());

var QueriesStats = /** @class */ (function () {
    function QueriesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/queries-stats?key=").concat(opt.projectKey);
        this._requester = http_req_makeRequester(opt);
    }
    QueriesStats.prototype.start = function (query) {
        if (query === void 0) { query = ''; }
        return new QueryInfo(query);
    };
    QueriesStats.prototype.notify = function (q) {
        var _this = this;
        if (!hasTdigest) {
            return;
        }
        if (!this._opt.performanceStats) {
            return;
        }
        if (!this._opt.queryStats) {
            return;
        }
        var ms = q._duration();
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            method: q.method,
            route: q.route,
            query: q.query,
            func: q.func,
            file: q.file,
            line: q.line,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new TDigestStat();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, FLUSH_INTERVAL);
    };
    QueriesStats.prototype._flush = function () {
        var queries = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = queries_assign(queries_assign({}, key), this._m[keyStr].toJSON());
            queries.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queries: queries,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report queries stats', err);
            }
        });
    };
    return QueriesStats;
}());

//# sourceMappingURL=queries.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/queues.js
var queues_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var queues_assign = (undefined && undefined.__assign) || function () {
    queues_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return queues_assign.apply(this, arguments);
};



var queues_FLUSH_INTERVAL = 15000; // 15 seconds
var QueueMetric = /** @class */ (function (_super) {
    queues_extends(QueueMetric, _super);
    function QueueMetric(queue) {
        var _this = _super.call(this) || this;
        _this.queue = queue;
        _this.startTime = new Date();
        return _this;
    }
    return QueueMetric;
}(BaseMetric));

var QueuesStats = /** @class */ (function () {
    function QueuesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/queues-stats?key=").concat(opt.projectKey);
        this._requester = http_req_makeRequester(opt);
    }
    QueuesStats.prototype.notify = function (q) {
        var _this = this;
        if (!hasTdigest) {
            return;
        }
        if (!this._opt.performanceStats) {
            return;
        }
        if (!this._opt.queueStats) {
            return;
        }
        var ms = q._duration();
        if (ms === 0) {
            ms = 0.00001;
        }
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(q.startTime.getTime() / minute) * minute);
        var key = {
            queue: q.queue,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new TDigestStatGroups();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, q._groups);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, queues_FLUSH_INTERVAL);
    };
    QueuesStats.prototype._flush = function () {
        var queues = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = queues_assign(queues_assign({}, key), this._m[keyStr].toJSON());
            queues.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            queues: queues,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report queues breakdowns', err);
            }
        });
    };
    return QueuesStats;
}());

//# sourceMappingURL=queues.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/routes.js
var routes_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var routes_assign = (undefined && undefined.__assign) || function () {
    routes_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return routes_assign.apply(this, arguments);
};



var routes_FLUSH_INTERVAL = 15000; // 15 seconds
var RouteMetric = /** @class */ (function (_super) {
    routes_extends(RouteMetric, _super);
    function RouteMetric(method, route, statusCode, contentType) {
        if (method === void 0) { method = ''; }
        if (route === void 0) { route = ''; }
        if (statusCode === void 0) { statusCode = 0; }
        if (contentType === void 0) { contentType = ''; }
        var _this = _super.call(this) || this;
        _this.method = method;
        _this.route = route;
        _this.statusCode = statusCode;
        _this.contentType = contentType;
        _this.startTime = new Date();
        return _this;
    }
    return RouteMetric;
}(BaseMetric));

var RoutesStats = /** @class */ (function () {
    function RoutesStats(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/routes-stats?key=").concat(opt.projectKey);
        this._requester = http_req_makeRequester(opt);
    }
    RoutesStats.prototype.notify = function (req) {
        var _this = this;
        if (!hasTdigest) {
            return;
        }
        if (!this._opt.performanceStats) {
            return;
        }
        var ms = req._duration();
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            statusCode: req.statusCode,
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new TDigestStat();
            this._m[keyStr] = stat;
        }
        stat.add(ms);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, routes_FLUSH_INTERVAL);
    };
    RoutesStats.prototype._flush = function () {
        var routes = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = routes_assign(routes_assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report routes stats', err);
            }
        });
    };
    return RoutesStats;
}());

var RoutesBreakdowns = /** @class */ (function () {
    function RoutesBreakdowns(opt) {
        this._m = {};
        this._opt = opt;
        this._url = "".concat(opt.host, "/api/v5/projects/").concat(opt.projectId, "/routes-breakdowns?key=").concat(opt.projectKey);
        this._requester = http_req_makeRequester(opt);
    }
    RoutesBreakdowns.prototype.notify = function (req) {
        var _this = this;
        if (!hasTdigest) {
            return;
        }
        if (!this._opt.performanceStats) {
            return;
        }
        if (req.statusCode < 200 ||
            (req.statusCode >= 300 && req.statusCode < 400) ||
            req.statusCode === 404 ||
            Object.keys(req._groups).length === 0) {
            return;
        }
        var ms = req._duration();
        if (ms === 0) {
            ms = 0.00001;
        }
        var minute = 60 * 1000;
        var startTime = new Date(Math.floor(req.startTime.getTime() / minute) * minute);
        var key = {
            method: req.method,
            route: req.route,
            responseType: this._responseType(req),
            time: startTime,
        };
        var keyStr = JSON.stringify(key);
        var stat = this._m[keyStr];
        if (!stat) {
            stat = new TDigestStatGroups();
            this._m[keyStr] = stat;
        }
        stat.addGroups(ms, req._groups);
        if (this._timer) {
            return;
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, routes_FLUSH_INTERVAL);
    };
    RoutesBreakdowns.prototype._flush = function () {
        var routes = [];
        for (var keyStr in this._m) {
            if (!this._m.hasOwnProperty(keyStr)) {
                continue;
            }
            var key = JSON.parse(keyStr);
            var v = routes_assign(routes_assign({}, key), this._m[keyStr].toJSON());
            routes.push(v);
        }
        this._m = {};
        this._timer = null;
        var outJSON = JSON.stringify({
            environment: this._opt.environment,
            routes: routes,
        });
        var req = {
            method: 'POST',
            url: this._url,
            body: outJSON,
        };
        this._requester(req)
            .then(function (_resp) {
            // nothing
        })
            .catch(function (err) {
            if (console.error) {
                console.error('can not report routes breakdowns', err);
            }
        });
    };
    RoutesBreakdowns.prototype._responseType = function (req) {
        if (req.statusCode >= 500) {
            return '5xx';
        }
        if (req.statusCode >= 400) {
            return '4xx';
        }
        if (!req.contentType) {
            return '';
        }
        var s = req.contentType.split(';')[0].split('/');
        return s[s.length - 1];
    };
    return RoutesBreakdowns;
}());

//# sourceMappingURL=routes.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/version.js
var NOTIFIER_NAME = 'airbrake-js/browser';
var NOTIFIER_VERSION = '2.1.8';
var NOTIFIER_URL = 'https://github.com/airbrake/airbrake-js/tree/master/packages/browser';
//# sourceMappingURL=version.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/remote_settings.js
var remote_settings_assign = (undefined && undefined.__assign) || function () {
    remote_settings_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return remote_settings_assign.apply(this, arguments);
};


// API version to poll.
var API_VER = '2020-06-18';
// How frequently we should poll the config API.
var DEFAULT_INTERVAL = 600000; // 10 minutes
var NOTIFIER_INFO = {
    notifier_name: NOTIFIER_NAME,
    notifier_version: NOTIFIER_VERSION,
    os: typeof window !== 'undefined' &&
        window.navigator &&
        window.navigator.userAgent
        ? window.navigator.userAgent
        : undefined,
    language: 'JavaScript',
};
// Remote config settings.
var ERROR_SETTING = 'errors';
var APM_SETTING = 'apm';
var RemoteSettings = /** @class */ (function () {
    function RemoteSettings(opt) {
        this._opt = opt;
        this._requester = http_req_makeRequester(opt);
        this._data = new SettingsData(opt.projectId, {
            project_id: null,
            poll_sec: 0,
            updated_at: 0,
            config_route: '',
            settings: [],
        });
        this._origErrorNotifications = opt.errorNotifications;
        this._origPerformanceStats = opt.performanceStats;
    }
    RemoteSettings.prototype.poll = function () {
        var _this = this;
        // First request is immediate. When it's done, we cancel it since we want to
        // change interval time to the default value.
        var pollerId = setInterval(function () {
            _this._doRequest();
            clearInterval(pollerId);
        }, 0);
        // Second fetch is what always runs in background.
        return setInterval(this._doRequest.bind(this), DEFAULT_INTERVAL);
    };
    RemoteSettings.prototype._doRequest = function () {
        var _this = this;
        this._requester(this._requestParams(this._opt))
            .then(function (resp) {
            _this._data.merge(resp.json);
            _this._opt.host = _this._data.errorHost();
            _this._opt.apmHost = _this._data.apmHost();
            _this._processErrorNotifications(_this._data);
            _this._processPerformanceStats(_this._data);
        })
            .catch(function (_) {
            return;
        });
    };
    RemoteSettings.prototype._requestParams = function (opt) {
        return {
            method: 'GET',
            url: this._pollUrl(opt),
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache,no-store',
            },
        };
    };
    RemoteSettings.prototype._pollUrl = function (opt) {
        var url = this._data.configRoute(opt.remoteConfigHost);
        var queryParams = '?';
        for (var _i = 0, _a = this._entries(NOTIFIER_INFO); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            queryParams += "&".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
        }
        return url + queryParams;
    };
    RemoteSettings.prototype._processErrorNotifications = function (data) {
        if (!this._origErrorNotifications) {
            return;
        }
        this._opt.errorNotifications = data.errorNotifications();
    };
    RemoteSettings.prototype._processPerformanceStats = function (data) {
        if (!this._origPerformanceStats) {
            return;
        }
        this._opt.performanceStats = data.performanceStats();
    };
    // Polyfill from:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries#polyfill
    RemoteSettings.prototype._entries = function (obj) {
        var ownProps = Object.keys(obj);
        var i = ownProps.length;
        var resArray = new Array(i);
        while (i--)
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        return resArray;
    };
    return RemoteSettings;
}());

var SettingsData = /** @class */ (function () {
    function SettingsData(projectId, data) {
        this._projectId = projectId;
        this._data = data;
    }
    SettingsData.prototype.merge = function (other) {
        this._data = remote_settings_assign(remote_settings_assign({}, this._data), other);
    };
    SettingsData.prototype.configRoute = function (remoteConfigHost) {
        var host = remoteConfigHost.replace(/\/$/, '');
        var configRoute = this._data.config_route;
        if (configRoute === null ||
            configRoute === undefined ||
            configRoute === '') {
            return "".concat(host, "/").concat(API_VER, "/config/").concat(this._projectId, "/config.json");
        }
        else {
            return "".concat(host, "/").concat(configRoute);
        }
    };
    SettingsData.prototype.errorNotifications = function () {
        var s = this._findSetting(ERROR_SETTING);
        if (s === null) {
            return true;
        }
        return s.enabled;
    };
    SettingsData.prototype.performanceStats = function () {
        var s = this._findSetting(APM_SETTING);
        if (s === null) {
            return true;
        }
        return s.enabled;
    };
    SettingsData.prototype.errorHost = function () {
        var s = this._findSetting(ERROR_SETTING);
        if (s === null) {
            return null;
        }
        return s.endpoint;
    };
    SettingsData.prototype.apmHost = function () {
        var s = this._findSetting(APM_SETTING);
        if (s === null) {
            return null;
        }
        return s.endpoint;
    };
    SettingsData.prototype._findSetting = function (name) {
        var settings = this._data.settings;
        if (settings === null || settings === undefined) {
            return null;
        }
        var setting = settings.find(function (s) {
            return s.name === name;
        });
        if (setting === undefined) {
            return null;
        }
        return setting;
    };
    return SettingsData;
}());

//# sourceMappingURL=remote_settings.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/base_notifier.js
var base_notifier_assign = (undefined && undefined.__assign) || function () {
    base_notifier_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return base_notifier_assign.apply(this, arguments);
};














var BaseNotifier = /** @class */ (function () {
    function BaseNotifier(opt) {
        var _this = this;
        this._filters = [];
        this._performanceFilters = [];
        this._scope = new Scope();
        this._onClose = [];
        if (!opt.projectId || !opt.projectKey) {
            throw new Error('airbrake: projectId and projectKey are required');
        }
        this._opt = opt;
        this._opt.host = this._opt.host || 'https://api.airbrake.io';
        this._opt.remoteConfigHost =
            this._opt.remoteConfigHost || 'https://notifier-configs.airbrake.io';
        this._opt.apmHost = this._opt.apmHost || 'https://api.airbrake.io';
        this._opt.timeout = this._opt.timeout || 10000;
        this._opt.keysBlocklist = this._opt.keysBlocklist || [/password/, /secret/];
        this._url = "".concat(this._opt.host, "/api/v3/projects/").concat(this._opt.projectId, "/notices?key=").concat(this._opt.projectKey);
        this._opt.errorNotifications = this._opt.errorNotifications !== false;
        this._opt.performanceStats = this._opt.performanceStats !== false;
        this._opt.queryStats = this._opt.queryStats !== false;
        this._opt.queueStats = this._opt.queueStats !== false;
        this._opt.remoteConfig = this._opt.remoteConfig !== false;
        this._processor = this._opt.processor || espProcessor;
        this._requester = http_req_makeRequester(this._opt);
        this.addFilter(ignoreNoiseFilter);
        this.addFilter(makeDebounceFilter());
        this.addFilter(uncaughtMessageFilter);
        this.addFilter(angularMessageFilter);
        this.addFilter(function (notice) {
            notice.context.notifier = {
                name: NOTIFIER_NAME,
                version: NOTIFIER_VERSION,
                url: NOTIFIER_URL,
            };
            if (_this._opt.environment) {
                notice.context.environment = _this._opt.environment;
            }
            return notice;
        });
        this.routes = new Routes(this);
        this.queues = new Queues(this);
        this.queries = new QueriesStats(this._opt);
        if (this._opt.remoteConfig) {
            var pollerId_1 = new RemoteSettings(this._opt).poll();
            this._onClose.push(function () { return clearInterval(pollerId_1); });
        }
    }
    BaseNotifier.prototype.close = function () {
        for (var _i = 0, _a = this._onClose; _i < _a.length; _i++) {
            var fn = _a[_i];
            fn();
        }
    };
    BaseNotifier.prototype.scope = function () {
        return this._scope;
    };
    BaseNotifier.prototype.setActiveScope = function (scope) {
        this._scope = scope;
    };
    BaseNotifier.prototype.addFilter = function (filter) {
        this._filters.push(filter);
    };
    BaseNotifier.prototype.addPerformanceFilter = function (performanceFilter) {
        this._performanceFilters.push(performanceFilter);
    };
    BaseNotifier.prototype.notify = function (err) {
        var notice = {
            errors: [],
            context: base_notifier_assign(base_notifier_assign({ severity: 'error' }, this.scope().context()), err.context),
            params: err.params || {},
            environment: err.environment || {},
            session: err.session || {},
        };
        if (typeof err !== 'object' || err.error === undefined) {
            err = { error: err };
        }
        if (!this._opt.errorNotifications) {
            notice.error = new Error("airbrake: not sending this error, errorNotifications is disabled err=".concat(JSON.stringify(err.error)));
            return src.resolve(notice);
        }
        if (!err.error) {
            notice.error = new Error("airbrake: got err=".concat(JSON.stringify(err.error), ", wanted an Error"));
            return src.resolve(notice);
        }
        var error = this._processor(err.error);
        notice.errors.push(error);
        for (var _i = 0, _a = this._filters; _i < _a.length; _i++) {
            var filter = _a[_i];
            var r = filter(notice);
            if (r === null) {
                notice.error = new Error('airbrake: error is filtered');
                return src.resolve(notice);
            }
            notice = r;
        }
        if (!notice.context) {
            notice.context = {};
        }
        notice.context.language = 'JavaScript';
        return this._sendNotice(notice);
    };
    BaseNotifier.prototype._sendNotice = function (notice) {
        var body = jsonifyNotice(notice, {
            keysBlocklist: this._opt.keysBlocklist,
        });
        if (this._opt.reporter) {
            if (typeof this._opt.reporter === 'function') {
                return this._opt.reporter(notice);
            }
            else {
                console.warn('airbrake: options.reporter must be a function');
            }
        }
        var req = {
            method: 'POST',
            url: this._url,
            body: body,
        };
        return this._requester(req)
            .then(function (resp) {
            notice.id = resp.json.id;
            notice.url = resp.json.url;
            return notice;
        })
            .catch(function (err) {
            notice.error = err;
            return notice;
        });
    };
    BaseNotifier.prototype.wrap = function (fn, props) {
        if (props === void 0) { props = []; }
        if (fn._airbrake) {
            return fn;
        }
        // tslint:disable-next-line:no-this-assignment
        var client = this;
        var airbrakeWrapper = function () {
            var fnArgs = Array.prototype.slice.call(arguments);
            var wrappedArgs = client._wrapArguments(fnArgs);
            try {
                return fn.apply(this, wrappedArgs);
            }
            catch (err) {
                client.notify({ error: err, params: { arguments: fnArgs } });
                client._ignoreNextWindowError();
                throw err;
            }
        };
        for (var prop in fn) {
            if (fn.hasOwnProperty(prop)) {
                airbrakeWrapper[prop] = fn[prop];
            }
        }
        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
            var prop = props_1[_i];
            if (fn.hasOwnProperty(prop)) {
                airbrakeWrapper[prop] = fn[prop];
            }
        }
        airbrakeWrapper._airbrake = true;
        airbrakeWrapper.inner = fn;
        return airbrakeWrapper;
    };
    BaseNotifier.prototype._wrapArguments = function (args) {
        for (var i = 0; i < args.length; i++) {
            var arg = args[i];
            if (typeof arg === 'function') {
                args[i] = this.wrap(arg);
            }
        }
        return args;
    };
    BaseNotifier.prototype._ignoreNextWindowError = function () { };
    BaseNotifier.prototype.call = function (fn) {
        var _args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _args[_i - 1] = arguments[_i];
        }
        var wrapper = this.wrap(fn);
        return wrapper.apply(this, Array.prototype.slice.call(arguments, 1));
    };
    return BaseNotifier;
}());

var Routes = /** @class */ (function () {
    function Routes(notifier) {
        this._notifier = notifier;
        this._routes = new RoutesStats(notifier._opt);
        this._breakdowns = new RoutesBreakdowns(notifier._opt);
        this._opt = notifier._opt;
    }
    Routes.prototype.start = function (method, route, statusCode, contentType) {
        if (method === void 0) { method = ''; }
        if (route === void 0) { route = ''; }
        if (statusCode === void 0) { statusCode = 0; }
        if (contentType === void 0) { contentType = ''; }
        var metric = new RouteMetric(method, route, statusCode, contentType);
        if (!this._opt.performanceStats) {
            return metric;
        }
        var scope = this._notifier.scope().clone();
        scope.setContext({ httpMethod: method, route: route });
        scope.setRouteMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Routes.prototype.notify = function (req) {
        if (!this._opt.performanceStats) {
            return;
        }
        req.end();
        for (var _i = 0, _a = this._notifier._performanceFilters; _i < _a.length; _i++) {
            var performanceFilter = _a[_i];
            if (performanceFilter(req) === null) {
                return;
            }
        }
        this._routes.notify(req);
        this._breakdowns.notify(req);
    };
    return Routes;
}());
var Queues = /** @class */ (function () {
    function Queues(notifier) {
        this._notifier = notifier;
        this._queues = new QueuesStats(notifier._opt);
        this._opt = notifier._opt;
    }
    Queues.prototype.start = function (queue) {
        var metric = new QueueMetric(queue);
        if (!this._opt.performanceStats) {
            return metric;
        }
        var scope = this._notifier.scope().clone();
        scope.setContext({ queue: queue });
        scope.setQueueMetric(metric);
        this._notifier.setActiveScope(scope);
        return metric;
    };
    Queues.prototype.notify = function (q) {
        if (!this._opt.performanceStats) {
            return;
        }
        q.end();
        this._queues.notify(q);
    };
    return Queues;
}());
//# sourceMappingURL=base_notifier.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/filter/window.js
function windowFilter(notice) {
    if (window.navigator && window.navigator.userAgent) {
        notice.context.userAgent = window.navigator.userAgent;
    }
    if (window.location) {
        notice.context.url = String(window.location);
        // Set root directory to group errors on different subdomains together.
        notice.context.rootDirectory =
            window.location.protocol + '//' + window.location.host;
    }
    return notice;
}
//# sourceMappingURL=window.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/instrumentation/console.js
var CONSOLE_METHODS = ['debug', 'log', 'info', 'warn', 'error'];
function instrumentConsole(notifier) {
    var _loop_1 = function (m) {
        if (!(m in console)) {
            return "continue";
        }
        var oldFn = console[m];
        var newFn = (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            oldFn.apply(console, args);
            notifier.scope().pushHistory({
                type: 'log',
                severity: m,
                arguments: args,
            });
        });
        newFn.inner = oldFn;
        console[m] = newFn;
    };
    // tslint:disable-next-line:no-this-assignment
    for (var _i = 0, CONSOLE_METHODS_1 = CONSOLE_METHODS; _i < CONSOLE_METHODS_1.length; _i++) {
        var m = CONSOLE_METHODS_1[_i];
        _loop_1(m);
    }
}
//# sourceMappingURL=console.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/instrumentation/dom.js
var elemAttrs = ['type', 'name', 'src'];
function instrumentDOM(notifier) {
    var handler = makeEventHandler(notifier);
    if (window.addEventListener) {
        window.addEventListener('load', handler);
        window.addEventListener('error', function (event) {
            if (getProp(event, 'error')) {
                return;
            }
            handler(event);
        }, true);
    }
    if (typeof document === 'object' && document.addEventListener) {
        document.addEventListener('DOMContentLoaded', handler);
        document.addEventListener('click', handler);
        document.addEventListener('keypress', handler);
    }
}
function makeEventHandler(notifier) {
    return function (event) {
        var target = getProp(event, 'target');
        if (!target) {
            return;
        }
        var state = { type: event.type };
        try {
            state.target = elemPath(target);
        }
        catch (err) {
            state.target = "<".concat(String(err), ">");
        }
        notifier.scope().pushHistory(state);
    };
}
function elemName(elem) {
    if (!elem) {
        return '';
    }
    var s = [];
    if (elem.tagName) {
        s.push(elem.tagName.toLowerCase());
    }
    if (elem.id) {
        s.push('#');
        s.push(elem.id);
    }
    if (elem.classList && Array.from) {
        s.push('.');
        s.push(Array.from(elem.classList).join('.'));
    }
    else if (elem.className) {
        var str = classNameString(elem.className);
        if (str !== '') {
            s.push('.');
            s.push(str);
        }
    }
    if (elem.getAttribute) {
        for (var _i = 0, elemAttrs_1 = elemAttrs; _i < elemAttrs_1.length; _i++) {
            var attr = elemAttrs_1[_i];
            var value = elem.getAttribute(attr);
            if (value) {
                s.push("[".concat(attr, "=\"").concat(value, "\"]"));
            }
        }
    }
    return s.join('');
}
function classNameString(name) {
    if (name.split) {
        return name.split(' ').join('.');
    }
    if (name.baseVal && name.baseVal.split) {
        // SVGAnimatedString
        return name.baseVal.split(' ').join('.');
    }
    console.error('unsupported HTMLElement.className type', typeof name);
    return '';
}
function elemPath(elem) {
    var maxLen = 10;
    var path = [];
    var parent = elem;
    while (parent) {
        var name_1 = elemName(parent);
        if (name_1 !== '') {
            path.push(name_1);
            if (path.length > maxLen) {
                break;
            }
        }
        parent = parent.parentNode;
    }
    if (path.length === 0) {
        return String(elem);
    }
    return path.reverse().join(' > ');
}
function getProp(obj, prop) {
    try {
        return obj[prop];
    }
    catch (_) {
        // Permission denied to access property
        return null;
    }
}
//# sourceMappingURL=dom.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/instrumentation/fetch.js
function instrumentFetch(notifier) {
    // tslint:disable-next-line:no-this-assignment
    var oldFetch = window.fetch;
    window.fetch = function (req, options) {
        var state = {
            type: 'xhr',
            date: new Date(),
        };
        state.method = options && options.method ? options.method : 'GET';
        if (typeof req === 'string') {
            state.url = req;
        }
        else {
            state.method = req.method;
            state.url = req.url;
        }
        // Some platforms (e.g. react-native) implement fetch via XHR.
        notifier._ignoreNextXHR++;
        setTimeout(function () { return notifier._ignoreNextXHR--; });
        return oldFetch
            .apply(this, arguments)
            .then(function (resp) {
            state.statusCode = resp.status;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            return resp;
        })
            .catch(function (err) {
            state.error = err;
            state.duration = new Date().getTime() - state.date.getTime();
            notifier.scope().pushHistory(state);
            throw err;
        });
    };
}
//# sourceMappingURL=fetch.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/instrumentation/location.js
var lastLocation = '';
// In some environments (i.e. Cypress) document.location may sometimes be null
function getCurrentLocation() {
    return document.location && document.location.pathname;
}
function instrumentLocation(notifier) {
    lastLocation = getCurrentLocation();
    var oldFn = window.onpopstate;
    window.onpopstate = function abOnpopstate(_event) {
        var url = getCurrentLocation();
        if (url) {
            recordLocation(notifier, url);
        }
        if (oldFn) {
            return oldFn.apply(this, arguments);
        }
    };
    var oldPushState = history.pushState;
    history.pushState = function abPushState(_state, _title, url) {
        if (url) {
            recordLocation(notifier, url.toString());
        }
        oldPushState.apply(this, arguments);
    };
}
function recordLocation(notifier, url) {
    var index = url.indexOf('://');
    if (index >= 0) {
        url = url.slice(index + 3);
        index = url.indexOf('/');
        url = index >= 0 ? url.slice(index) : '/';
    }
    else if (url.charAt(0) !== '/') {
        url = '/' + url;
    }
    notifier.scope().pushHistory({
        type: 'location',
        from: lastLocation,
        to: url,
    });
    lastLocation = url;
}
//# sourceMappingURL=location.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/instrumentation/xhr.js
function instrumentXHR(notifier) {
    function recordReq(req) {
        var state = req.__state;
        state.statusCode = req.status;
        state.duration = new Date().getTime() - state.date.getTime();
        notifier.scope().pushHistory(state);
    }
    var oldOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function abOpen(method, url, _async, _user, _password) {
        if (notifier._ignoreNextXHR === 0) {
            this.__state = {
                type: 'xhr',
                method: method,
                url: url,
            };
        }
        oldOpen.apply(this, arguments);
    };
    var oldSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function abSend(_data) {
        var oldFn = this.onreadystatechange;
        this.onreadystatechange = function (_ev) {
            if (this.readyState === 4 && this.__state) {
                recordReq(this);
            }
            if (oldFn) {
                return oldFn.apply(this, arguments);
            }
        };
        if (this.__state) {
            this.__state.date = new Date();
        }
        return oldSend.apply(this, arguments);
    };
}
//# sourceMappingURL=xhr.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/notifier.js
var notifier_extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var notifier_assign = (undefined && undefined.__assign) || function () {
    notifier_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return notifier_assign.apply(this, arguments);
};








var Notifier = /** @class */ (function (_super) {
    notifier_extends(Notifier, _super);
    function Notifier(opt) {
        var _this = _super.call(this, opt) || this;
        _this.offline = false;
        _this.todo = [];
        _this._ignoreWindowError = 0;
        _this._ignoreNextXHR = 0;
        if (typeof window === 'undefined') {
            return _this;
        }
        _this.addFilter(windowFilter);
        if (window.addEventListener) {
            _this.onOnline = _this.onOnline.bind(_this);
            window.addEventListener('online', _this.onOnline);
            _this.onOffline = _this.onOffline.bind(_this);
            window.addEventListener('offline', _this.onOffline);
            _this.onUnhandledrejection = _this.onUnhandledrejection.bind(_this);
            window.addEventListener('unhandledrejection', _this.onUnhandledrejection);
            _this._onClose.push(function () {
                window.removeEventListener('online', _this.onOnline);
                window.removeEventListener('offline', _this.onOffline);
                window.removeEventListener('unhandledrejection', _this.onUnhandledrejection);
            });
        }
        _this._instrument(opt.instrumentation);
        return _this;
    }
    Notifier.prototype._instrument = function (opt) {
        if (opt === void 0) { opt = {}; }
        if (opt.console === undefined) {
            opt.console = !isDevEnv(this._opt.environment);
        }
        if (enabled(opt.onerror)) {
            // tslint:disable-next-line:no-this-assignment
            var self_1 = this;
            var oldHandler_1 = window.onerror;
            window.onerror = function abOnerror() {
                if (oldHandler_1) {
                    oldHandler_1.apply(this, arguments);
                }
                self_1.onerror.apply(self_1, arguments);
            };
        }
        instrumentDOM(this);
        if (enabled(opt.fetch) && typeof fetch === 'function') {
            instrumentFetch(this);
        }
        if (enabled(opt.history) && typeof history === 'object') {
            instrumentLocation(this);
        }
        if (enabled(opt.console) && typeof console === 'object') {
            instrumentConsole(this);
        }
        if (enabled(opt.xhr) && typeof XMLHttpRequest !== 'undefined') {
            instrumentXHR(this);
        }
    };
    Notifier.prototype.notify = function (err) {
        var _this = this;
        if (this.offline) {
            return new src(function (resolve, reject) {
                _this.todo.push({
                    err: err,
                    resolve: resolve,
                    reject: reject,
                });
                while (_this.todo.length > 100) {
                    var j = _this.todo.shift();
                    if (j === undefined) {
                        break;
                    }
                    j.resolve({
                        error: new Error('airbrake: offline queue is too large'),
                    });
                }
            });
        }
        return _super.prototype.notify.call(this, err);
    };
    Notifier.prototype.onOnline = function () {
        this.offline = false;
        var _loop_1 = function (j) {
            this_1.notify(j.err).then(function (notice) {
                j.resolve(notice);
            });
        };
        var this_1 = this;
        for (var _i = 0, _a = this.todo; _i < _a.length; _i++) {
            var j = _a[_i];
            _loop_1(j);
        }
        this.todo = [];
    };
    Notifier.prototype.onOffline = function () {
        this.offline = true;
    };
    Notifier.prototype.onUnhandledrejection = function (e) {
        // Handle native or bluebird Promise rejections
        // https://developer.mozilla.org/en-US/docs/Web/Events/unhandledrejection
        // http://bluebirdjs.com/docs/api/error-management-configuration.html
        var reason = e.reason || (e.detail && e.detail.reason);
        if (!reason) {
            return;
        }
        var msg = reason.message || String(reason);
        if (msg.indexOf && msg.indexOf('airbrake: ') === 0) {
            return;
        }
        if (typeof reason !== 'object' || reason.error === undefined) {
            this.notify({
                error: reason,
                context: {
                    unhandledRejection: true,
                },
            });
            return;
        }
        this.notify(notifier_assign(notifier_assign({}, reason), { context: {
                unhandledRejection: true,
            } }));
    };
    Notifier.prototype.onerror = function (message, filename, line, column, err) {
        if (this._ignoreWindowError > 0) {
            return;
        }
        if (err) {
            this.notify({
                error: err,
                context: {
                    windowError: true,
                },
            });
            return;
        }
        // Ignore errors without file or line.
        if (!filename || !line) {
            return;
        }
        this.notify({
            error: {
                message: message,
                fileName: filename,
                lineNumber: line,
                columnNumber: column,
                noStack: true,
            },
            context: {
                windowError: true,
            },
        });
    };
    Notifier.prototype._ignoreNextWindowError = function () {
        var _this = this;
        this._ignoreWindowError++;
        setTimeout(function () { return _this._ignoreWindowError--; });
    };
    return Notifier;
}(BaseNotifier));

function isDevEnv(env) {
    return env && env.startsWith && env.startsWith('dev');
}
function enabled(v) {
    return v === undefined || v === true;
}
//# sourceMappingURL=notifier.js.map
;// CONCATENATED MODULE: ./node_modules/@airbrake/browser/esm/index.js




//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./components/ErrorBoundary/ErrorBoundary.tsx





var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        var projectId = parseInt("327584", 10);
        var projectKey = "e45190d5d4b5b187f73eae82cb09977e";
        _this.environment = "production";
        _this.airbrake = new Notifier({
            projectId: projectId,
            projectKey: projectKey,
            environment: _this.environment
        });
        _this.airbrake.addFilter(function(notice) {
            if (_this.environment === "development") {
                return null;
            }
            return notice;
        });
        // This check may need to be updated when we upgrade our version of NextJS
        // https://github.com/vercel/next.js/issues/5354#issuecomment-520305040
        if (true) {
            window.airbrake = _this.airbrake;
        }
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, info) {
        this.airbrake.notify({
            error: error,
            params: {
                info: info
            }
        });
    };
    _proto.render = function render() {
        var children = this.props.children;
        return children;
    };
    return ErrorBoundary;
}(react.Component);
/* harmony default export */ var ErrorBoundary_ErrorBoundary = (ErrorBoundary);

;// CONCATENATED MODULE: ./components/ErrorBoundary/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./components/CommunityContext.tsx + 17 modules
var CommunityContext = __webpack_require__(9973);
// EXTERNAL MODULE: ./components/PageSkeleton/index.ts + 1 modules
var PageSkeleton = __webpack_require__(62185);
// EXTERNAL MODULE: ./utils/routerHelpers.ts
var routerHelpers = __webpack_require__(4154);
// EXTERNAL MODULE: ./utils/userHelpers.js
var userHelpers = __webpack_require__(73652);
;// CONCATENATED MODULE: ./components/RedirectUser/RedirectUser.tsx








var RedirectUser = function(param) {
    var children = param.children;
    var ref = (0,CommunityContext/* useCommunityContext */.v1)(), id = ref.community.id, currentUser = ref.currentUser;
    var router = (0,next_router.useRouter)();
    var isAdminPermitted = (0,userHelpers/* isAdmin */.GJ)(currentUser);
    var studentPermittedPaths = [
        routerHelpers/* pathnames.home */.$O.home,
        routerHelpers/* pathnames.following */.$O.following,
        routerHelpers/* pathnames.spaces.space */.$O.spaces.space,
        routerHelpers/* pathnames.post */.$O.post,
        routerHelpers/* pathnames.events.events */.$O.events.events,
        routerHelpers/* pathnames.events.event */.$O.events.event,
        routerHelpers/* pathnames.search */.$O.search, 
    ];
    var isStudentPermitted = studentPermittedPaths.includes(router.pathname);
    var moderatorPermittedPaths = (0,_to_consumable_array/* default */.Z)(studentPermittedPaths).concat([
        routerHelpers/* pathnames.members */.$O.members,
        routerHelpers/* pathnames.events.new */.$O.events["new"],
        routerHelpers/* pathnames.events.edit */.$O.events.edit, 
    ]);
    var isModeratorPermitted = currentUser.isModerator && moderatorPermittedPaths.includes(router.pathname);
    // Send user to Home if they are not members
    if (!isAdminPermitted && !isStudentPermitted && !isModeratorPermitted) {
        (0,routerHelpers/* goToHome */.rC)(router, id);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSkeleton/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var RedirectUser_RedirectUser = (RedirectUser);

;// CONCATENATED MODULE: ./components/RedirectUser/index.ts


// EXTERNAL MODULE: ./components/SiteFeaturesContext/index.ts + 2 modules
var SiteFeaturesContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(4067);
// EXTERNAL MODULE: ./utils/toastHelpers.ts
var toastHelpers = __webpack_require__(55049);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/context/index.js



function setContext(setter) {
    return new ApolloLink/* ApolloLink */.i(function (operation, forward) {
        var request = (0,tslib_es6/* __rest */._T)(operation, []);
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            var handle;
            var closed = false;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                // if the observer is already closed, no need to subscribe.
                if (closed)
                    return;
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                closed = true;
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/utils.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}
// EXTERNAL MODULE: ./node_modules/i18next-http-backend/esm/getFetch.cjs
var getFetch = __webpack_require__(83154);
var getFetch_namespaceObject = /*#__PURE__*/__webpack_require__.t(getFetch, 2);
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/request.js
function request_typeof(o) { "@babel/helpers - typeof"; return request_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, request_typeof(o); }


var fetchApi;
if (typeof fetch === 'function') {
  if (typeof global !== 'undefined' && global.fetch) {
    fetchApi = global.fetch;
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
var XmlHttpRequestApi;
if (hasXMLHttpRequest()) {
  if (typeof global !== 'undefined' && global.XMLHttpRequest) {
    XmlHttpRequestApi = global.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof global !== 'undefined' && global.ActiveXObject) {
    ActiveXObjectApi = global.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && getFetch_namespaceObject && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = getFetch || getFetch_namespaceObject;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && request_typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback) {
  var resolver = function resolver(response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  };
  if (typeof fetch === 'function') {
    fetch(url, fetchOptions).then(resolver).catch(callback);
  } else {
    fetchApi(url, fetchOptions).then(resolver).catch(callback);
  }
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = defaults({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (typeof window === 'undefined' && typeof global !== 'undefined' && typeof global.process !== 'undefined' && global.process.versions && global.process.versions.node) {
    headers['User-Agent'] = "i18next-http-backend (node/".concat(global.process.version, "; ").concat(global.process.platform, " ").concat(global.process.arch, ")");
  }
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = defaults({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  try {
    fetchIt(url, fetchOptions, callback);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && request_typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request_request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if (hasXMLHttpRequest() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
/* harmony default export */ var esm_request = (request_request);
;// CONCATENATED MODULE: ./node_modules/i18next-http-backend/esm/index.js
function esm_typeof(o) { "@babel/helpers - typeof"; return esm_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, esm_typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return esm_typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (esm_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (esm_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: esm_request,
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = defaults(options, this.options || {}, getDefaults());
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = makePromise(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';
/* harmony default export */ var i18next_http_backend_esm = (Backend);
;// CONCATENATED MODULE: ./next-i18next.config.js

var backend = new i18next_http_backend_esm(null, {
    loadPath: "/translations/communities.json"
});
/* harmony default export */ var next_i18next_config = ({
    i18n: {
        defaultLocale: "en",
        locales: [
            "en"
        ]
    },
    use: [
        backend
    ],
    serializeConfig: false,
    nsSeparator: false,
    keySeparator: false,
    compatibilityJSON: "v3"
});

// EXTERNAL MODULE: ./pages/styles.scss
var styles = __webpack_require__(90110);
;// CONCATENATED MODULE: ./pages/_app.js



























var graphqlApiPath = "/api/graphql";
// Analytics only works when the browser has loaded.
// Dynamic import used here to ensure this module is loaded after the browser has loaded
// https://nextjs.org/docs/advanced-features/dynamic-import
var TrackingLayer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4955), __webpack_require__.e(9194)]).then(__webpack_require__.bind(__webpack_require__, 49194));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49194)
            ];
        }
    },
    ssr: false
});
var httpLink = (0,createHttpLink/* createHttpLink */.L)({
    uri: graphqlApiPath
});
var authorizationLink = (0,error/* onError */.q)(function(param) {
    var forward = param.forward, networkError = param.networkError, operation = param.operation;
    var isClient = typeof document !== "undefined";
    if (isClient && networkError) {
        handleAuthErrorClientSide(networkError.statusCode);
    }
    forward(operation);
});
// This is a customization of the original implementation of relayStylePagination in apollo:
//  - https://github.com/apollographql/apollo-client/blob/v3.2.7/src/utilities/policies/pagination.ts#L91
// It solves a particular bug related to pagination of comments/replies.
// If you you delete the topmost comment and then click "View previous comments", the now-topmost comment
// will be returned in the fetchMore call, which causes a comment to be duplicated in the list.
// This occurs because the "read" function in relayStylePagination() sets the startCursor to be the
// "cursor" attribute of the first comment we have in the cache. This happens on the following line:
//  - https://github.com/apollographql/apollo-client/blob/v3.2.7/src/utilities/policies/pagination.ts#L109
// When the first comment is deleted from the cache (and the backend), the startCursor is updated to be the
// cursor of the now-first comment in the cache. However, because there are less comments now in the backend,
// the comments returned before a particular cursor are all shifted by 1.
// This customization ensures that the startCursor is not updated and will always equal the value defined
// in the pageInfo.
var relayPagination = (0,pagination/* relayStylePagination */.ZB)([
    "orderBy"
]);
var customizedRelayPagination = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, relayPagination), {
    read: function read(existing, options) {
        if (!existing) return undefined;
        var startCursor = existing.pageInfo.startCursor;
        var originalRead = relayPagination.read(existing, options);
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, originalRead), {
            pageInfo: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, originalRead.pageInfo), {
                startCursor: startCursor
            })
        });
    }
});
var headersLink = setContext(function(_, param) {
    var headers = param.headers;
    return {
        headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, headers), {
            "X-Client-ID": "COMMUNITIES"
        })
    };
});
var apolloClient = new ApolloClient/* ApolloClient */.f({
    link: authorizationLink.concat(headersLink).concat(httpLink),
    cache: new inMemoryCache/* InMemoryCache */.h({
        typePolicies: {
            Community: {
                fields: {
                    posts: (0,pagination/* relayStylePagination */.ZB)([
                        "first",
                        "filter",
                        "orderBy"
                    ])
                }
            },
            Post: {
                fields: {
                    replies: customizedRelayPagination
                }
            },
            Reply: {
                fields: {
                    replies: customizedRelayPagination
                }
            },
            User: {
                fields: {
                    enrollments: (0,pagination/* relayStylePagination */.ZB)()
                }
            },
            CommunitySection: {
                fields: {
                    communitySpaces: {
                        merge: true
                    }
                }
            }
        }
    })
});
// This function is used to redirect the browser to sign-in when there is
// a graph authorization error client-side
var handleAuthErrorClientSide = function(statusCode) {
    esm/* i18n.loadNamespaces */.ag.loadNamespaces("common", function(err) {
        if (err) {
            toaster_a57afb61.t.alert("Something went wrong. Please try again.", {
                autoClose: false
            });
        } else if (statusCode === 401) {
            // 401 Unauthorized means they are not logged-in
            router_default().replace("/users/sign_in?redirect_to=".concat(document.location.pathname, "&error=").concat(esm/* i18n.t */.ag.t("Please sign in to continue")));
        } else if (statusCode === 403) {
            // 403 Forbidden means they are logged-in but not allowed to view the community
            router_default().replace("/enrollments?error=".concat(esm/* i18n.t */.ag.t("You are not authorized to see this page")));
        } else if (statusCode === 404 || statusCode === 410) {
            // 410 response means the tenant has been marked as inactive
            router_default().replace("/404.html");
        } else {
            (0,toastHelpers/* genericToastAlert */.d9)();
        }
    });
};
var MyApp = /*#__PURE__*/ function(App) {
    "use strict";
    (0,_inherits/* default */.Z)(MyApp, App);
    var _super = (0,_create_super/* default */.Z)(MyApp);
    function MyApp(props) {
        (0,_class_call_check/* default */.Z)(this, MyApp);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            postListState: {
                useCacheFirst: false
            }
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(MyApp, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, Component = _props.Component, pageProps = _props.pageProps;
                var communityId = pageProps.communityId;
                var passedPageProps = (0,_object_spread/* default */.Z)({}, this.state, pageProps);
                var getLayout = Component.getLayout || function(page) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLayout/* default */.Z, {
                        children: page
                    });
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary_ErrorBoundary, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider, {
                        client: apolloClient,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunityContext/* CommunityProvider */.gR, {
                            communityId: communityId,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteFeaturesContext/* SiteFeaturesProvider */.cm, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RedirectUser_RedirectUser, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingLayer, {}),
                                        getLayout(/*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, passedPageProps))),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(W, {})
                                    ]
                                })
                            })
                        })
                    })
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var Component = param.Component, ctx = param.ctx;
                return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    var communityId, pageProps;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                communityId = ctx.query.communityId;
                                pageProps = {};
                                if (!Component.getInitialProps) {
                                    _ctx.next = 6;
                                    break;
                                }
                                _ctx.next = 5;
                                return Component.getInitialProps(ctx);
                            case 5:
                                pageProps = _ctx.sent;
                            case 6:
                                pageProps = (0,_object_spread/* default */.Z)({
                                    communityId: communityId
                                }, pageProps);
                                return _ctx.abrupt("return", {
                                    pageProps: pageProps
                                });
                            case 8:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return MyApp;
}(app["default"]);
/* harmony default export */ var _app = ((0,esm/* appWithTranslation */.Jc)(MyApp, next_i18next_config));


/***/ }),

/***/ 14130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N6": function() { return /* binding */ CREATE_EVENT_MUTATION; },
/* harmony export */   "Nj": function() { return /* binding */ DELETE_LIVE_EVENT_MUTATION; },
/* harmony export */   "SE": function() { return /* binding */ DUPLICATE_EVENT_MUTATION; },
/* harmony export */   "eS": function() { return /* binding */ CREATE_ATTENDANCE_MUTATION; },
/* harmony export */   "eX": function() { return /* binding */ UPDATE_LIVE_EVENT_MUTATION; },
/* harmony export */   "uw": function() { return /* binding */ DELETE_ATTENDANCE_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateLiveEvent($input: CreateLiveEventInput!) {\n    createLiveEvent(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      liveEvent {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DuplicateLiveEvent($input: DuplicateLiveEventInput!) {\n    duplicateLiveEvent(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      liveEvent {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdateLiveEvent($input: UpdateLiveEventInput!) {\n    updateLiveEvent(input: $input) {\n      liveEvent {\n        id\n      }\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteLiveEvent($input: DeleteLiveEventInput!) {\n    deleteLiveEvent(input: $input) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateAttendance($input: CreateAttendanceInput!) {\n    createAttendance(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      liveEvent {\n        id\n        isInterested\n        interestedUsers {\n          totalCount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteAttendance($input: DeleteAttendanceInput!) {\n    deleteAttendance(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      liveEvent {\n        id\n        isInterested\n        interestedUsers {\n          totalCount\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var CREATE_EVENT_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var DUPLICATE_EVENT_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var UPDATE_LIVE_EVENT_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var DELETE_LIVE_EVENT_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var CREATE_ATTENDANCE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var DELETE_ATTENDANCE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());


/***/ }),

/***/ 20143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_G": function() { return /* binding */ LIVE_EVENTS_COUNT_QUERY; },
  "lq": function() { return /* binding */ LIVE_EVENTS_LIST_QUERY; },
  "U7": function() { return /* binding */ LIVE_EVENT_QUERY; }
});

// UNUSED EXPORTS: LIVE_EVENT_INTERESTED_USERS_FRAGMENT

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(75063);
;// CONCATENATED MODULE: ./schema/Event/fragments.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment EventFields on LiveEvent {\n    id\n    title\n    description\n    imageUrl\n    imageAltText\n    startTime\n    endTime\n    timezone\n    meetingUrl\n    location\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LiveEventsEdgesNodeFields on LiveEvent {\n    interestedUsers {\n      totalCount\n    }\n    isInterested\n    ...EventFields\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment LiveEventsEdgesFields on LiveEventEdge {\n    node {\n      ...LiveEventsEdgesNodeFields\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment InterestedUsersEdgesNodeFields on User {\n    id\n    fullName\n    profile {\n      id\n      avatarUrl\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment InterestedUsersEdgesFields on UserEdge {\n    node {\n      ...InterestedUsersEdgesNodeFields\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var LIVE_EVENT_FRAGMENT = (0,lib/* gql */.Ps)(_templateObject());
var LIVE_EVENTS_EDGES_NODE_FRAGMENT = (0,lib/* gql */.Ps)(_templateObject1(), LIVE_EVENT_FRAGMENT);
var LIVE_EVENTS_EDGES_FRAGMENT = (0,lib/* gql */.Ps)(_templateObject2(), LIVE_EVENTS_EDGES_NODE_FRAGMENT);
var LIVE_EVENTS_INTERESTED_USERS_EDGES_NODE_FRAGEMENT = (0,lib/* gql */.Ps)(_templateObject3());
var LIVE_EVENTS_INTERESTED_USERS_EDGES_FRAGEMENT = (0,lib/* gql */.Ps)(_templateObject4(), LIVE_EVENTS_INTERESTED_USERS_EDGES_NODE_FRAGEMENT);

;// CONCATENATED MODULE: ./schema/Event/queries.ts

function queries_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LiveEvents(\n    $eventStatus: EventStatusTypes\n    $eventSourceId: ID!\n    $numberOfEvents: Int\n    $startDateTime: DateTime\n    $endDateTime: DateTime\n    $sortDirection: OrderDirection = ASC\n  ) {\n    site {\n      id\n      liveEvents(\n        eventSourceType: Community\n        eventSourceId: $eventSourceId\n        first: $numberOfEvents\n        orderBy: { field: start_time, direction: $sortDirection }\n        filter: {\n          eventStatus: $eventStatus\n          startTime: $startDateTime\n          endTime: $endDateTime\n        }\n      ) {\n        totalCount\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        edges {\n          ...LiveEventsEdgesFields\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    queries_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function queries_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment EventInterestedUsersFields on LiveEvent {\n    isInterested\n    interestedUsers(first: $numberOfUsers, after: $endCursor) {\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n      edges {\n        ...InterestedUsersEdgesFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    queries_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function queries_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LiveEvent($eventId: ID!, $numberOfUsers: Int = 5, $endCursor: String) {\n    site {\n      id\n      liveEvent(id: $eventId) {\n        ...EventFields\n        ...EventInterestedUsersFields\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    queries_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function queries_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LiveEventsCount($eventSourceId: ID!) {\n    site {\n      id\n      liveEvents(eventSourceType: Community, eventSourceId: $eventSourceId) {\n        totalCount\n      }\n    }\n  }\n"
    ]);
    queries_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LIVE_EVENTS_LIST_QUERY = (0,lib/* gql */.Ps)(queries_templateObject(), LIVE_EVENTS_EDGES_FRAGMENT);
var LIVE_EVENT_INTERESTED_USERS_FRAGMENT = (0,lib/* gql */.Ps)(queries_templateObject1(), LIVE_EVENTS_INTERESTED_USERS_EDGES_FRAGEMENT);
var LIVE_EVENT_QUERY = (0,lib/* gql */.Ps)(queries_templateObject2(), LIVE_EVENT_FRAGMENT, LIVE_EVENT_INTERESTED_USERS_FRAGMENT);
var LIVE_EVENTS_COUNT_QUERY = (0,lib/* gql */.Ps)(queries_templateObject3());


/***/ }),

/***/ 95313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ POST_QUERY; },
/* harmony export */   "c": function() { return /* binding */ POST_LIST_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75063);
/* harmony import */ var utils_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57917);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query PostList(\n    $communityId: ID!\n    $numOfPosts: Int\n    $endCursor: String\n    $postOrderField: PostOrderField = PINNED_AT\n    $filter: PostFilter\n    $numberOfReactions: Int!\n  ) {\n    community(id: $communityId) {\n      id\n      posts(\n        first: $numOfPosts\n        after: $endCursor\n        filter: $filter\n        orderBy: { field: $postOrderField, direction: DESC }\n      ) {\n        edges {\n          cursor\n          node {\n            ...PostFieldsWithUserPermissions\n          }\n        }\n        pageInfo {\n          hasPreviousPage\n          hasNextPage\n          startCursor\n          endCursor\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Post($communityId: ID!, $postId: ID!, $numberOfReactions: Int!) {\n    community(id: $communityId) {\n      id\n      post(id: $postId) {\n        ...PostFieldsWithUserPermissions\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var POST_LIST_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT_WITH_USER_PERMISSIONS */ .R7);
var POST_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), utils_queries__WEBPACK_IMPORTED_MODULE_1__/* .POST_FRAGMENT_WITH_USER_PERMISSIONS */ .R7);


/***/ }),

/***/ 5867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NT": function() { return /* binding */ PRODUCTS_QUERY; },
  "Pj": function() { return /* binding */ PRODUCT_QUERY; }
});

// UNUSED EXPORTS: COURSE_FRAGMENT

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 13 modules
var lib = __webpack_require__(75063);
;// CONCATENATED MODULE: ./schema/Product/fragments.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductsEdgeFields on ProductEdge {\n    node {\n      id\n      publishedStatus\n      productable {\n        __typename\n        ... on Course {\n          ...CourseFields\n        }\n      }\n      communityProductRelation {\n        id\n        relation {\n          __typename\n          ... on CommunitySpace {\n            id\n            name\n            community {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ProductsFields on ProductConnection {\n    edges {\n      ...ProductsEdgeFields\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var PRODUCTS_EDGE_FRAGMENT = (0,lib/* gql */.Ps)(_templateObject());
var PRODUCTS_FRAGMENT = (0,lib/* gql */.Ps)(_templateObject1(), PRODUCTS_EDGE_FRAGMENT);

;// CONCATENATED MODULE: ./schema/Product/queries.ts

function queries_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment CourseFields on Course {\n    id\n    name\n    description\n    cardImageUrl\n    enrollmentsCount @include(if: $isModerator)\n    resumeCourseUrl\n    percentageCompleted\n    isPrivate @include(if: $isModerator)\n    isHidden @include(if: $isModerator)\n    status @include(if: $isModerator)\n  }\n"
    ]);
    queries_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function queries_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query CommunityProductRelations(\n    $communityId: ID!\n    $relatableId: ID!\n    $isModerator: Boolean!\n    $relatableType: String\n  ) {\n    community(id: $communityId) {\n      id\n      communityProductRelations(\n        relatableId: $relatableId\n        relatableType: $relatableType\n      ) {\n        edges {\n          cursor\n          node {\n            id\n            product {\n              id\n              slug\n              productable {\n                __typename\n                ... on Course {\n                  ...CourseFields\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    queries_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query Products($isModerator: Boolean!) {\n    site {\n      id\n      products(filter: { publicationStatus: [published], type: Course }) {\n        ...ProductsFields\n      }\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var COURSE_FRAGMENT = (0,lib/* gql */.Ps)(queries_templateObject());
var PRODUCT_QUERY = (0,lib/* gql */.Ps)(queries_templateObject1(), COURSE_FRAGMENT);
var PRODUCTS_QUERY = (0,lib/* gql */.Ps)(_templateObject2(), COURSE_FRAGMENT, PRODUCTS_FRAGMENT);


/***/ }),

/***/ 47653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ SECTION_QUERY; }
/* harmony export */ });
/* unused harmony export SECTION_FRAGMENT */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75063);
/* harmony import */ var _Space_queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73820);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment SectionFields on CommunitySection {\n    id\n    name\n    communitySpaces @connection(key: "communitySpaces") {\n      totalCount\n      edges {\n        node {\n          ...SpaceFields\n          posts {\n            edges {\n              node {\n                id\n              }\n            }\n            totalCount\n          }\n        }\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query SectionList(\n    $communityId: ID!\n    $isCoursesToCommunitiesEnabled: Boolean!\n  ) {\n    community(id: $communityId) {\n      id\n      communitySections {\n        edges {\n          node {\n            ...SectionFields\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SECTION_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject(), _Space_queries__WEBPACK_IMPORTED_MODULE_1__/* .SPACE_FRAGMENT */ .a);
var SECTION_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps)(_templateObject1(), SECTION_FRAGMENT);


/***/ }),

/***/ 59252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mb": function() { return /* binding */ DELETE_SPACE_MUTATION; },
/* harmony export */   "dY": function() { return /* binding */ UPDATE_SPACE_MUTATION; },
/* harmony export */   "oz": function() { return /* binding */ CREATE_SPACE_MUTATION; },
/* harmony export */   "td": function() { return /* binding */ REORDER_SPACE_MUTATION; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreateCommunitySpace($input: CreateCommunitySpaceInput!) {\n    createCommunitySpace(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      communitySpace {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdateCommunitySpace($input: UpdateCommunitySpaceInput!) {\n    updateCommunitySpace(input: $input) {\n      userErrors {\n        code\n        message\n      }\n      communitySpace {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeleteCommunitySpace($input: DeleteCommunitySpaceInput!) {\n    deleteCommunitySpace(input: $input) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ReorderCommunitySpace($input: ReorderCommunitySpaceInput!) {\n    reorderCommunitySpace(input: $input) {\n      userErrors {\n        code\n        message\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var CREATE_SPACE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var UPDATE_SPACE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var DELETE_SPACE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var REORDER_SPACE_MUTATION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());


/***/ }),

/***/ 73820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SPACE_FRAGMENT; },
/* harmony export */   "y": function() { return /* binding */ SPACE_QUERY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment SpaceFields on CommunitySpace {\n    id\n    name\n    description\n    iconName\n    position\n    imageUrl\n    imageAltText\n    s3UploadPath\n    isExclusive\n    posts {\n      totalCount\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    communityProductRelation @include(if: $isCoursesToCommunitiesEnabled) {\n      id\n      product {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query CommunitySpace(\n    $communityId: ID!\n    $spaceId: ID!\n    $isCoursesToCommunitiesEnabled: Boolean!\n  ) {\n    community(id: $communityId) {\n      id\n      communitySpace(id: $spaceId) {\n        ...SpaceFields\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var SPACE_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var SPACE_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1(), SPACE_FRAGMENT);


/***/ }),

/***/ 72175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ USERS_QUERY; },
/* harmony export */   "Qt": function() { return /* binding */ USER_QUERY; }
/* harmony export */ });
/* unused harmony exports COMMUNITY_EDGES_NODE_USER_FRAGMENT, COMMUNITY_EDGES_NODE_FRAGMENT, COMMUNITY_EDGES_FRAGMENT, USER_ENROLLMENT_FRAGMENT */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CommunityEdgesNodeUserFields on User {\n    id\n    fullName\n    profile {\n      id\n      avatarUrl\n    }\n    roles\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CommunityEdgesNodeFields on CommunityUser {\n    id\n    user {\n      permissions(resourceId: $communityId, resourceType: Community)\n      ...CommunityEdgesNodeUserFields\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment CommunityEdgesFields on CommunityUserEdge {\n    node {\n      ...CommunityEdgesNodeFields\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment UserEnrollmentFields on EnrollmentConnection {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        completedAt\n        course {\n          id\n          name\n          cardImageUrl\n          resumeCourseUrl\n          landingPageUrl\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query Users(\n    $communityId: ID!\n    $searchTerm: String = ""\n    $numberOfUsers: Int = 5\n    $after: String\n  ) {\n    community(id: $communityId) {\n      id\n      communityUsers(\n        first: $numberOfUsers\n        after: $after\n        filter: { active: true }\n      ) {\n        totalCount\n        pageInfo {\n          endCursor\n          startCursor\n        }\n        edges {\n          ...CommunityEdgesFields\n        }\n      }\n      mentionableUsers(searchTerm: $searchTerm, first: $numberOfUsers) {\n        edges {\n          node {\n            id\n            user {\n              id\n              fullName\n              profile {\n                id\n                avatarUrl\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ',
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query User(\n    $communityId: ID!\n    $userId: ID!\n    $numOfCourses: Int\n    $endCursor: String\n  ) {\n    community(id: $communityId) {\n      id\n      communityUser(userId: $userId) {\n        id\n        canModerate\n        user {\n          id\n          fullName\n          firstName\n          roles\n          profile {\n            id\n            avatarUrl\n            company\n            headline\n            timezone\n          }\n          enrollments(\n            filter: {\n              status: COMPLETED\n              productStatus: [published]\n              productVisible: true\n            }\n            orderBy: { field: COMPLETED_AT, direction: DESC }\n            first: $numOfCourses\n            after: $endCursor\n          ) {\n            ...UserEnrollmentFields\n          }\n        }\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var COMMUNITY_EDGES_NODE_USER_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var COMMUNITY_EDGES_NODE_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1(), COMMUNITY_EDGES_NODE_USER_FRAGMENT);
var COMMUNITY_EDGES_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2(), COMMUNITY_EDGES_NODE_FRAGMENT);
var USER_ENROLLMENT_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var USERS_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4(), COMMUNITY_EDGES_FRAGMENT);
var USER_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5(), USER_ENROLLMENT_FRAGMENT);


/***/ }),

/***/ 82083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$W": function() { return /* binding */ hexToRGB; },
/* harmony export */   "aS": function() { return /* binding */ isTextDark; }
/* harmony export */ });
/* unused harmony export hexToLightness */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

var hexToRGB = function(h) {
    var r = 0;
    var g = 0;
    var b = 0;
    if (h && h.length === 4) {
        r = Number("0x".concat(h[1]).concat(h[1]));
        g = Number("0x".concat(h[2]).concat(h[2]));
        b = Number("0x".concat(h[3]).concat(h[3]));
    } else if (h && h.length === 7) {
        r = Number("0x".concat(h[1]).concat(h[2]));
        g = Number("0x".concat(h[3]).concat(h[4]));
        b = Number("0x".concat(h[5]).concat(h[6]));
    }
    return [
        r,
        g,
        b
    ];
};
var hexToLightness = function(hexColor) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(hexToRGB(hexColor), 3), r = ref[0], g = ref[1], b = ref[2];
    return 1 / 2 * (Math.max(r, g, b) + Math.min(r, g, b));
};
var isTextDark = function(hexColor) {
    return Math.round(hexToLightness(hexColor) / 255 * 100) > 60;
};


/***/ }),

/***/ 59830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ SORT_BY_TO_POST_ORDER_FIELDS; },
/* harmony export */   "AS": function() { return /* binding */ POWERED_BY_THINKIFIC; },
/* harmony export */   "Aj": function() { return /* binding */ EVENT_POST_TYPES; },
/* harmony export */   "B0": function() { return /* binding */ REACTION_TYPES; },
/* harmony export */   "Bl": function() { return /* binding */ POWERED_BY_THINKIFIC_ALT; },
/* harmony export */   "C1": function() { return /* binding */ MAX_FILE_SIZE_MB; },
/* harmony export */   "D0": function() { return /* binding */ MAX_POST_TITLE_LENGTH; },
/* harmony export */   "DB": function() { return /* binding */ POSTS_PER_PAGE; },
/* harmony export */   "Fg": function() { return /* binding */ BREAKPOINT_SM; },
/* harmony export */   "GI": function() { return /* binding */ BREAKPOINT_MD; },
/* harmony export */   "Gu": function() { return /* binding */ COMMENTS_PER_PAGE; },
/* harmony export */   "Gy": function() { return /* binding */ SUCCESS_TOAST; },
/* harmony export */   "ID": function() { return /* binding */ SPACES_EMPTY_STATE_MODERATOR; },
/* harmony export */   "IP": function() { return /* binding */ FILE_TYPES_ARTICLE; },
/* harmony export */   "Jq": function() { return /* binding */ POST_ORDER_FIELDS; },
/* harmony export */   "L8": function() { return /* binding */ DEFAULT_PAGE_SIZE; },
/* harmony export */   "MR": function() { return /* binding */ SUCCESS; },
/* harmony export */   "PZ": function() { return /* binding */ IMAGE_ATTACHMENT; },
/* harmony export */   "Q": function() { return /* binding */ EVENT_ADOPTION_IMAGE; },
/* harmony export */   "QM": function() { return /* binding */ HOME_FEED_LATEST_POSTS_STUDENT; },
/* harmony export */   "Qq": function() { return /* binding */ BREAKPOINT_LG; },
/* harmony export */   "S1": function() { return /* binding */ SITE_ADMIN; },
/* harmony export */   "SO": function() { return /* binding */ SCREEN_PHONE; },
/* harmony export */   "TY": function() { return /* binding */ EVENT_LEARN_MORE_PREVIEW_EMAIL_SHARE_LINK; },
/* harmony export */   "YL": function() { return /* binding */ SPACE_ICONS; },
/* harmony export */   "YV": function() { return /* binding */ EVENT_USER_ROLES; },
/* harmony export */   "Yc": function() { return /* binding */ EVENT_REMINDER_EMAIL_LEARN_MORE_LINK; },
/* harmony export */   "ZF": function() { return /* binding */ SORT_BY_PARAMS; },
/* harmony export */   "Zb": function() { return /* binding */ MEMBERS_MAX_LIMIT; },
/* harmony export */   "_0": function() { return /* binding */ ACCEPTED_FILE_TYPES; },
/* harmony export */   "an": function() { return /* binding */ FAILURE; },
/* harmony export */   "d7": function() { return /* binding */ FILE_ATTACHMENT; },
/* harmony export */   "dZ": function() { return /* binding */ FOLLOWING_EMPTY_STATE_FRENCH; },
/* harmony export */   "dm": function() { return /* binding */ EVENT_IMAGE_PLACEHOLDER; },
/* harmony export */   "dp": function() { return /* binding */ COMMENT_FORM_ID; },
/* harmony export */   "dr": function() { return /* binding */ ACCEPTED_IMAGE_TYPES; },
/* harmony export */   "ed": function() { return /* binding */ NUMBER_OF_REACTIONS; },
/* harmony export */   "f5": function() { return /* binding */ USER_ERRORS_API_CODES; },
/* harmony export */   "g2": function() { return /* binding */ NUMBER_OF_INTERESTED_USERS_ON_EVENT; },
/* harmony export */   "gu": function() { return /* binding */ FEED_REPLY_COUNT; },
/* harmony export */   "iS": function() { return /* binding */ REACTION_ICONS; },
/* harmony export */   "iX": function() { return /* binding */ NESTED_REPLIES_PER_PAGE; },
/* harmony export */   "jo": function() { return /* binding */ TRENDING_POSTS_IMAGE; },
/* harmony export */   "k4": function() { return /* binding */ SCREEN_LG; },
/* harmony export */   "k5": function() { return /* binding */ TRENDING_POSTS_MAX; },
/* harmony export */   "le": function() { return /* binding */ SPACES_EMPTY_STATE_STUDENT; },
/* harmony export */   "ng": function() { return /* binding */ DEFAULT_SPACE_ICON; },
/* harmony export */   "oo": function() { return /* binding */ WELCOME_TO_SPACES; },
/* harmony export */   "pR": function() { return /* binding */ USER_ROLES; },
/* harmony export */   "pg": function() { return /* binding */ FOLLOWING_EMPTY_STATE_SPANISH; },
/* harmony export */   "pj": function() { return /* binding */ EVENT_LEARN_MORE_LINK; },
/* harmony export */   "qL": function() { return /* binding */ AWS_S3_URL; },
/* harmony export */   "qv": function() { return /* binding */ USER_AVATAR_COLORS; },
/* harmony export */   "rv": function() { return /* binding */ NUMBER_OF_EVENTS_ON_HOME; },
/* harmony export */   "s6": function() { return /* binding */ FOLLOWING_EMPTY_STATE_ENGLISH; },
/* harmony export */   "tH": function() { return /* binding */ EVENT_LEARN_MORE_PREVIEW_EMAIL_LINK; },
/* harmony export */   "uX": function() { return /* binding */ HOME_FEED_LATEST_POSTS_MODERATOR; },
/* harmony export */   "uq": function() { return /* binding */ USER_PERMISSIONS; },
/* harmony export */   "wh": function() { return /* binding */ VIDEO_ATTACHMENT; },
/* harmony export */   "x8": function() { return /* binding */ FEED_COMMENT_COUNT; },
/* harmony export */   "xc": function() { return /* binding */ COURSES_ON_PROFILE_VIEW; },
/* harmony export */   "yC": function() { return /* binding */ POSTS_PER_PAGE_ON_HOME; },
/* harmony export */   "yW": function() { return /* binding */ POSTS_ON_PROFILE_VIEW; },
/* harmony export */   "zq": function() { return /* binding */ SPACE_IMAGE_PLACEHOLDER; }
/* harmony export */ });
/* unused harmony exports BREAKPOINT_XL, FILTER_FOLLOWING, EVENT_NOTIFICATION_SETTINGS, CREATE_POST_SECTION, MENTIONS_PLACEHOLDER_POST_TEXT, MENTIONS_PLACEHOLDER_COMMENT_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var MAX_POST_TITLE_LENGTH = 124;
var POSTS_PER_PAGE = 10;
var POSTS_PER_PAGE_ON_HOME = 3;
var COURSES_ON_PROFILE_VIEW = 3;
var POSTS_ON_PROFILE_VIEW = 5;
var TRENDING_POSTS_MAX = 5;
var NUMBER_OF_REACTIONS = 7;
var NUMBER_OF_EVENTS_ON_HOME = 2;
var NUMBER_OF_INTERESTED_USERS_ON_EVENT = 15;
var COMMENTS_PER_PAGE = 10;
var NESTED_REPLIES_PER_PAGE = 3;
var FEED_COMMENT_COUNT = 2;
var FEED_REPLY_COUNT = 2;
var DEFAULT_PAGE_SIZE = 10;
var SITE_ADMIN = "Site admin";
var VIDEO_ATTACHMENT = "video";
var IMAGE_ATTACHMENT = "image";
var FILE_ATTACHMENT = "file";
var MAX_FILE_SIZE_MB = 100;
var ACCEPTED_IMAGE_TYPES = "image/png,image/jpeg,image/gif,image/tiff,image/bmp";
var ACCEPTED_FILE_TYPES = [
    "audio/aac",
    "application/x-abiword",
    "image/avif",
    "video/x-msvideo",
    "application/vnd.amazon.ebook",
    "image/bmp",
    "application/x-cdf",
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/epub+zip",
    "image/gif",
    "image/vnd.microsoft.icon",
    "text/calendar",
    "image/jpeg",
    "audio/midi audio/x-midi",
    "audio/mpeg",
    "video/mp4",
    "video/mpeg",
    "application/vnd.oasis.opendocument.presentation",
    "application/vnd.oasis.opendocument.spreadsheet",
    "application/vnd.oasis.opendocument.text",
    "audio/ogg",
    "video/ogg",
    "application/ogg",
    "audio/opus",
    "font/otf",
    "image/png",
    "application/pdf",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/rtf",
    "image/tiff",
    "video/mp2t",
    "font/ttf",
    "text/plain",
    "audio/wav",
    "audio/webm",
    "video/webm",
    "image/webp",
    "font/woff",
    "font/woff2",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "video/3gpp",
    "audio/3gpp",
    "video/3gpp2",
    "audio/3gpp2",
    "video/quicktime", 
].join(",");
var EVENT_IMAGE_PLACEHOLDER = "https://cdn.thinkific.com/93/20220421/9868e43f4247dbf1d086360508bd03e5.svg";
var SPACE_IMAGE_PLACEHOLDER = "https://cdn.thinkific.com/90/20220929/d3ea6e7552f6a1f8aff61af579236d75.png";
var HOME_FEED_LATEST_POSTS_MODERATOR = "https://cdn.thinkific.com/90/20220818/94f6972461742c3c8d334a8bc892ae77.jpg";
var HOME_FEED_LATEST_POSTS_STUDENT = "https://cdn.thinkific.com/90/20220818/8ca39b4a34589399fe7bb08390bf88da.jpg";
var WELCOME_TO_SPACES = "https://cdn.thinkific.com/88/20220913/94833666faa126890ce3ea133d69734f.png";
var SPACES_EMPTY_STATE_MODERATOR = "https://cdn.thinkific.com/88/20220915/ab8c7adb71ef4a833802c1f60247569d.jpg";
var SPACES_EMPTY_STATE_STUDENT = "https://cdn.thinkific.com/88/20220915/5ce16b721823f2d43c989dcdb6426b93.jpg";
var FOLLOWING_EMPTY_STATE_ENGLISH = "https://cdn.thinkific.com/90/20221012/a8e520e6342120c9a851543f97af4abf.png";
var FOLLOWING_EMPTY_STATE_SPANISH = "https://cdn.thinkific.com/90/20221101/7544d2bed8d2efd6b10db69d89888af5.png";
var FOLLOWING_EMPTY_STATE_FRENCH = "https://cdn.thinkific.com/90/20221101/2cde57a4a7e53f8a835df45bd11bd43f.png";
var COMMENT_FORM_ID = "new-comment";
var AWS_S3_URL = "s3.amazonaws.com";
// User roles
var USER_ROLES = {
    SITE_OWNER_SITE_ADMIN: "Site owner, Site admin",
    SITE_ADMIN: "Site admin",
    PARTNER: "Partner"
};
var USER_PERMISSIONS = {
    CREATE_LIVE_EVENT: "create:community_live_event",
    CREATE_POST: "create:community_post",
    DELETE_POST: "delete:community_post",
    DELETE_REPLY: "delete:community_reply",
    DELETE_COMMENT: "delete:community_comment",
    DELETE_LIVE_EVENT: "delete:community_live_event",
    DUPLICATE_LIVE_EVENT: "duplicate:community_live_event",
    EDIT_LIVE_EVENT: "edit:community_live_event",
    PIN_POST: "pin:community_post",
    UNPIN_POST: "unpin:community_post",
    VIEW_COMMUNITY: "view:community"
};
// A "postOrderField" is passed into the POST_LIST_QUERY as a field to order posts by
var POST_ORDER_FIELDS = {
    REPLY_COUNT: "REPLY_COUNT",
    PINNED_AT: "PINNED_AT",
    LAST_INTERACTION_AT: "LAST_INTERACTION_AT",
    CREATED_AT: "CREATED_AT"
};
// A "sortBy" param is included in the url to sort posts by
var SORT_BY_PARAMS = {
    RECENT: "recent",
    MOST_COMMENTS: "most-comments",
    RECENT_COMMENTS: "recent-comments"
};
var _obj;
// This constant maps the "sortBy" param with it's corresponding "postOrderField"
var SORT_BY_TO_POST_ORDER_FIELDS = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SORT_BY_PARAMS.RECENT, POST_ORDER_FIELDS.PINNED_AT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SORT_BY_PARAMS.MOST_COMMENTS, POST_ORDER_FIELDS.REPLY_COUNT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, SORT_BY_PARAMS.RECENT_COMMENTS, POST_ORDER_FIELDS.LAST_INTERACTION_AT), _obj);
/** Communities breakpoint */ var SCREEN_PHONE = 481;
var SCREEN_LG = 1024;
/** from toga lib */ var BREAKPOINT_SM = 664;
var BREAKPOINT_MD = 952;
var BREAKPOINT_LG = 1265;
var BREAKPOINT_XL = 1440;
var FILTER_FOLLOWING = "following";
var EVENT_POST_TYPES = {
    COMMENT: "comment",
    POST: "post",
    REPLY: "reply"
};
var EVENT_USER_ROLES = {
    SITE_ADMIN: "site admin",
    COMMUNITY_MODERATOR: "community moderator",
    STUDENT: "student"
};
var EVENT_NOTIFICATION_SETTINGS = {
    ALL_COMMENTS: "all comments",
    OFF: "off"
};
/** for shared resources */ var POWERED_BY_THINKIFIC = "https://cdn.thinkific.com/66/20191001/9f313492f05380a8361fe9ffb644026f.svg";
var POWERED_BY_THINKIFIC_ALT = "Powered by Thinkific";
var EVENT_ADOPTION_IMAGE = "https://cdn.thinkific.com/90/20220622/2f6c70fcac06237a3918b92bf0dd4561.png";
var TRENDING_POSTS_IMAGE = "https://cdn.thinkific.com/93/20220816/3af65c258d55e6a20cc947de7ecbb1d1.png";
var EVENT_LEARN_MORE_LINK = "https://support.thinkific.com/hc/en-us/articles/6746444680087";
var CREATE_POST_SECTION = "https://support.thinkific.com/hc/en-us/articles/360034240434-Manage-Your-Community#01GEHN3AH92HMY9SAPA010D7TP";
var FILE_TYPES_ARTICLE = "https://support.thinkific.com/hc/en-us/articles/10380215164951";
var EVENT_REMINDER_EMAIL_LEARN_MORE_LINK = "https://support.thinkific.com/hc/en-us/articles/6746444680087";
var EVENT_LEARN_MORE_PREVIEW_EMAIL_LINK = "https://support.thinkific.com/hc/en-us/articles/6746444680087-Communities-Live-Events";
var EVENT_LEARN_MORE_PREVIEW_EMAIL_SHARE_LINK = "https://support.thinkific.com/hc/en-us/articles/6746444680087-Communities-Live-Events#notifyandshare";
var SUCCESS = "SUCCESS";
var FAILURE = "FAILURE";
var SUCCESS_TOAST = {
    DELETE_POST: "Successfully deleted post.",
    DELETE_COMMENT: "Successfully deleted comment.",
    DELETE_REPLY: "Successfully deleted reply.",
    EDIT_POST: "Successfully edited post.",
    EDIT_COMMENT: "Successfully edited comment.",
    EDIT_REPLY: "Successfully edited reply.",
    CREATE_POST: "Successfully created post.",
    CREATE_SPACE: "Successfully created Space.",
    UPDATE_SPACE: "Successfully updated Space.",
    NOTIFICATION_UPDATE: "Successfully updated your notification settings.",
    ERROR_MSG: "Something went wrong. Please try again."
};
var REACTION_TYPES = {
    LIKE_POST: "like"
};
var REACTION_ICONS = {
    LIKE_POST_TRUE: "heart-fill",
    LIKE_POST_FALSE: "heart-outline"
};
// format => react-toga: rails-api
var SPACE_ICONS = {
    "content-discussions": "discussions",
    "content-download": "download",
    "content-audio": "audio",
    "content-live": "live",
    "circle-outline-price": "price",
    envelope: "envelope",
    "content-video": "video",
    "content-pdf": "pdf",
    trophy: "trophy",
    image: "image",
    certificate: "certificate",
    shield: "shield",
    "content-presentation": "presentation",
    location: "location",
    key: "key",
    flag: "flag"
};
var DEFAULT_SPACE_ICON = SPACE_ICONS["content-discussions"];
// will be used when toga avatar component is updated with background-color prop
var USER_AVATAR_COLORS = [
    "#36394d",
    "#57608c",
    "#3d47a3",
    "#00699e",
    "#006f63",
    "#216e2f",
    "#100D59",
    "#af4d1e",
    "#a62626",
    "#810073"
];
var USER_ERRORS_API_CODES = {
    space_invalid: "SPACE_INVALID",
    space_name_error: "SPACE_NAME_ERROR",
    not_allowed_on_plan: "NOT_ALLOWED_ON_PLAN",
    event_time_error: "EVENT_TIME_ERROR",
    event_attendance_already_attending: "ALREADY_ATTENDING",
    event_attendance_not_attending: "NOT_ATTENDING"
};
var MENTIONS_PLACEHOLDER_POST_TEXT = "Type @ to mention another member in your post";
var MENTIONS_PLACEHOLDER_COMMENT_TEXT = "Type @ to mention another member in your comment";
var MEMBERS_MAX_LIMIT = 25;


/***/ }),

/***/ 57917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ REPLY_EDGE_FRAGMENT; },
/* harmony export */   "R7": function() { return /* binding */ POST_FRAGMENT_WITH_USER_PERMISSIONS; },
/* harmony export */   "Tj": function() { return /* binding */ POST_FRAGMENT; },
/* harmony export */   "s9": function() { return /* binding */ MAIN_QUERY; },
/* harmony export */   "sN": function() { return /* binding */ REPLY_FRAGMENT; },
/* harmony export */   "yV": function() { return /* binding */ POST_ATTACHMENTS_FRAGMENT; }
/* harmony export */ });
/* unused harmony exports USER_FRAGMENT, USER_FRAGMENT_WITH_PERMISSIONS, MENTIONED_USERS_FRAGMENT, REPLY_FRAGMENT_WITH_USER_PERMISSIONS, REPLY_EDGE_NODE_REPLIES_FRAGMENT, ACCOUNT_NOTIFICATIONS_QUERY */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75063);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment UserFields on User {\n    id\n    fullName\n    firstName\n    avatarUrl\n    roles\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment UserFieldsWithPermissions on User {\n    id\n    fullName\n    firstName\n    avatarUrl\n    roles\n    permissions(resourceId: $communityId, resourceType: Community)\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment MentionedUsersField on UserConnection {\n    edges {\n      node {\n        id\n        fullName\n        avatarUrl\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment PostAttachmentsFields on PostAttachment {\n    attachmentType\n    fileName\n    fileSizeInBytes\n    id\n    url\n    altText\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment PostFieldsWithUserPermissions on Post {\n    id\n    title\n    content\n    createdAt\n    pinnedAt\n    editedAt\n    isFollowing\n    hasReacted\n    communitySpace {\n      id\n      name\n      iconName\n    }\n    postAttachments {\n      ...PostAttachmentsFields\n    }\n    replies @connection(key: "replies") {\n      totalCount\n      nodes {\n        id\n        replies {\n          nodes {\n            id\n          }\n          totalCount\n        }\n      }\n    }\n    mentionedUsers @connection(key: "mentionedUsers") {\n      ...MentionedUsersField\n    }\n    postReactions(first: $numberOfReactions) @connection(key: "postReactions") {\n      totalCount\n      edges {\n        node {\n          user {\n            id\n            fullName\n          }\n        }\n      }\n    }\n    user {\n      permissions(resourceId: $communityId, resourceType: Community)\n      ...UserFields\n    }\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment PostFields on Post {\n    id\n    title\n    content\n    createdAt\n    pinnedAt\n    editedAt\n    isFollowing\n    hasReacted\n    communitySpace {\n      id\n      name\n      iconName\n    }\n    postAttachments {\n      ...PostAttachmentsFields\n    }\n    replies @connection(key: "replies") {\n      totalCount\n      nodes {\n        id\n        replies {\n          nodes {\n            id\n          }\n          totalCount\n        }\n      }\n    }\n    mentionedUsers @connection(key: "mentionedUsers") {\n      ...MentionedUsersField\n    }\n    postReactions(first: $numberOfReactions) @connection(key: "postReactions") {\n      totalCount\n      edges {\n        node {\n          user {\n            id\n            fullName\n          }\n        }\n      }\n    }\n    user {\n      ...UserFields\n    }\n  }\n  ',
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment ReplyFields on Reply {\n    content\n    createdAt\n    editedAt\n    isFollowing\n    id\n    postReactions(first: $numberOfReactions) @connection(key: "postReactions") {\n      totalCount\n      edges {\n        node {\n          user {\n            id\n            fullName\n          }\n        }\n      }\n    }\n    mentionedUsers @connection(key: "mentionedUsers") {\n      ...MentionedUsersField\n    }\n    user {\n      ...UserFields\n    }\n    hasReacted\n    postAttachments {\n      id\n      altText\n      attachmentType\n      fileName\n      fileSizeInBytes\n      url\n    }\n  }\n  ',
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  fragment ReplyFieldsWithUserPermissions on Reply {\n    content\n    createdAt\n    editedAt\n    isFollowing\n    id\n    postReactions(first: $numberOfReactions) @connection(key: "postReactions") {\n      totalCount\n      edges {\n        node {\n          user {\n            id\n            fullName\n          }\n        }\n      }\n    }\n    mentionedUsers @connection(key: "mentionedUsers") {\n      ...MentionedUsersField\n    }\n    user {\n      ...UserFieldsWithPermissions\n    }\n    hasReacted\n    postAttachments {\n      id\n      altText\n      attachmentType\n      fileName\n      fileSizeInBytes\n      url\n    }\n  }\n  ',
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ReplyEdgeNodeReliesFields on ReplyConnection {\n    edges {\n      cursor\n      node {\n        ...ReplyFields\n      }\n    }\n    pageInfo {\n      hasPreviousPage\n      hasNextPage\n      startCursor\n      endCursor\n    }\n    totalCount\n  }\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ReplyEdgeFields on Reply {\n    ...ReplyFieldsWithUserPermissions\n    replies(\n      last: $numOfNestedReplies\n      orderBy: { field: CREATED_AT, direction: ASC }\n    ) {\n      ...ReplyEdgeNodeReliesFields\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  query Main($communityId: ID!) {\n    site {\n      id\n      favicon\n      filestackPolicy {\n        policy\n        signature\n      }\n      featureFlags\n      subdomain\n      trackingKey\n      whiteLabellingActivated\n      googleAnalyticsKey\n      appcuesDisabled\n      integrations {\n        facebookPixelCode\n        gaMeasurementId\n      }\n    }\n\n    community(id: $communityId) {\n      id\n      name\n      description\n      primaryColor\n      font\n      imageUrl\n      s3UploadPath\n      published\n      status\n      communityUsers(filter: { active: true }) {\n        totalCount\n      }\n      mentionableUsers(searchTerm: "", first: 5) {\n        edges {\n          node {\n            id\n            user {\n              id\n              fullName\n              profile {\n                id\n                avatarUrl\n              }\n            }\n          }\n        }\n      }\n    }\n\n    me {\n      id\n      fullName\n      email\n      avatarUrl\n      roles\n      locale\n      profile {\n        id\n        timezone\n      }\n      permissions(resourceId: $communityId, resourceType: Community)\n    }\n  }\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query AccountNotifications {\n    accountNotifications {\n      isEnabled\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var USER_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var USER_FRAGMENT_WITH_PERMISSIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var MENTIONED_USERS_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var POST_ATTACHMENTS_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var POST_FRAGMENT_WITH_USER_PERMISSIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4(), USER_FRAGMENT, MENTIONED_USERS_FRAGMENT, POST_ATTACHMENTS_FRAGMENT);
var POST_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5(), USER_FRAGMENT, MENTIONED_USERS_FRAGMENT, POST_ATTACHMENTS_FRAGMENT);
var REPLY_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6(), USER_FRAGMENT, MENTIONED_USERS_FRAGMENT);
var REPLY_FRAGMENT_WITH_USER_PERMISSIONS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7(), USER_FRAGMENT_WITH_PERMISSIONS, MENTIONED_USERS_FRAGMENT);
var REPLY_EDGE_NODE_REPLIES_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8(), REPLY_FRAGMENT);
var REPLY_EDGE_FRAGMENT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject9(), REPLY_FRAGMENT_WITH_USER_PERMISSIONS, REPLY_EDGE_NODE_REPLIES_FRAGMENT);
var MAIN_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject10());
var ACCOUNT_NOTIFICATIONS_QUERY = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject11());


/***/ }),

/***/ 93593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ rawId; }
/* harmony export */ });
/**
 * Returns the numeric ID of a base-64 encoded GraphQL ID.
 * Expects the decoded string to be of shape [Object]-[NumericID]
 * For example, Tenant-7 encoded in base64.
 *
 * @param {string} encodedId - A base-64 encoded ID string
 */ var rawId = function(encodedId) {
    var decoded;
    try {
        decoded = atob(encodedId);
    } catch (e) {
        decoded = null;
    }
    var parts = decoded ? decoded.split("-") : [];
    if (parts.length !== 2) {
        return null;
    }
    return Number(parts[1]);
};


/***/ }),

/***/ 4154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$O": function() { return /* binding */ pathnames; },
/* harmony export */   "Ey": function() { return /* binding */ goToFollowing; },
/* harmony export */   "Ff": function() { return /* binding */ goToMembers; },
/* harmony export */   "I6": function() { return /* binding */ goToSearch; },
/* harmony export */   "MW": function() { return /* binding */ goToEvents; },
/* harmony export */   "Rn": function() { return /* binding */ wasPageRefreshed; },
/* harmony export */   "YY": function() { return /* binding */ goToPostPage; },
/* harmony export */   "Z4": function() { return /* binding */ goToEditSpace; },
/* harmony export */   "ZN": function() { return /* binding */ getPublishUrl; },
/* harmony export */   "ZY": function() { return /* binding */ goToSpaces; },
/* harmony export */   "_j": function() { return /* binding */ routes; },
/* harmony export */   "aE": function() { return /* binding */ getCommentUrl; },
/* harmony export */   "op": function() { return /* binding */ goToNewEvent; },
/* harmony export */   "rC": function() { return /* binding */ goToHome; },
/* harmony export */   "ro": function() { return /* binding */ getSettingsUrl; },
/* harmony export */   "s6": function() { return /* binding */ goToEvent; },
/* harmony export */   "sZ": function() { return /* binding */ setQueryParam; },
/* harmony export */   "td": function() { return /* binding */ goToCommentPage; },
/* harmony export */   "uR": function() { return /* binding */ getPostUrl; },
/* harmony export */   "uq": function() { return /* binding */ goToNewSpace; },
/* harmony export */   "x9": function() { return /* binding */ goToPostListPage; },
/* harmony export */   "yB": function() { return /* binding */ pushRouteWithSortBy; },
/* harmony export */   "zf": function() { return /* binding */ goToEditEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17563);




/* Pages within communities */ var pathnames = {
    home: "/[communityId]",
    search: "/[communityId]/search",
    following: "/[communityId]/following",
    members: "/[communityId]/members",
    spaces: {
        new: "/[communityId]/spaces/new",
        space: "/[communityId]/spaces/[spaceId]",
        edit: "/[communityId]/spaces/[spaceId]/edit"
    },
    post: "/[communityId]/post/[postId]",
    events: {
        new: "/[communityId]/events/new",
        edit: "/[communityId]/events/[eventId]/edit",
        events: "/[communityId]/events",
        event: "/[communityId]/events/[eventId]"
    }
};
/* External routes */ var routes = {
    myAccount: "/account",
    dashboard: "/enrollments",
    admin: "/manage",
    signOut: "/users/sign_out",
    users: "/manage/users",
    communities: "/manage/communities",
    courses: "/manage/courses",
    coursesPreview: "/manage/courses/preview",
    subscription: "/manage/subscription",
    publishCommunity: function(communityId) {
        return "/manage/communities/".concat(communityId, "/publish");
    }
};
var getSettingsUrl = function(communityId) {
    return "/manage/communities/".concat(communityId, "/settings");
};
var getPublishUrl = function(communityId) {
    return "/manage/communities/".concat(communityId, "/publish");
};
var getPostUrl = function(communityId, postId) {
    return "/communities/".concat(communityId, "/post/").concat(postId, "/");
};
var getCommentUrl = function(communityId, postId, commentId) {
    return "/communities/".concat(communityId, "/post/").concat(postId, "/?comment=").concat(commentId);
}; // This works for replies as well
var pushRouteWithSortBy = function(router, sortBy) {
    var query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, router.query), {
        sortBy: sortBy,
        page: 1
    });
    var path = router.asPath.split("?")[0];
    var asPath = "".concat(path, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_0__.stringify({
        sortBy: sortBy
    }));
    router.push({
        pathname: router.pathname,
        query: query
    }, asPath);
};
var setQueryParam = function(router, key, value) {
    var query = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, router.query), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
    var urlQuery = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, query);
    delete urlQuery.communityId; // Just so ?communityId=... isn't appended to the browser
    var path = router.asPath.split("?")[0];
    var asPath = "".concat(path, "?").concat(query_string__WEBPACK_IMPORTED_MODULE_0__.stringify(urlQuery));
    router.push({
        pathname: router.pathname,
        query: query
    }, asPath);
};
var goToHome = function(router, communityId) {
    return router.push({
        pathname: pathnames.home,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/"));
};
var goToSearch = function(router, communityId) {
    return router.push({
        pathname: pathnames.search,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/search/"));
};
var goToFollowing = function(router, communityId) {
    return router.push({
        pathname: pathnames.following,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/following/"));
};
var goToMembers = function(router, communityId) {
    return router.push({
        pathname: pathnames.members,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/members/"));
};
var goToNewSpace = function(router, communityId) {
    return router.push({
        pathname: pathnames.spaces.new,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/spaces/new/"));
};
var goToSpaces = function(router, spaceId, communityId) {
    var shouldScrollTop = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return router.push({
        pathname: pathnames.spaces.space,
        query: {
            communityId: communityId,
            spaceId: spaceId
        }
    }, "/communities/".concat(communityId, "/spaces/").concat(spaceId, "/")).then(function() {
        if (shouldScrollTop) window.scrollTo(0, 0);
    });
};
var goToEditSpace = function(router, spaceId, communityId, query) {
    return router.push({
        pathname: pathnames.spaces.edit,
        query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, query), {
            communityId: communityId,
            spaceId: spaceId
        })
    }, "/communities/".concat(communityId, "/spaces/").concat(spaceId, "/edit/"));
};
var goToPostPage = function(router, communityId, postId, shouldScrollTop, canUseBrowserBack) {
    return router.push({
        pathname: "/[communityId]/post/[postId]",
        query: {
            canUseBrowserBack: canUseBrowserBack,
            communityId: communityId,
            postId: postId
        }
    }, getPostUrl(communityId, postId)).then(function() {
        if (shouldScrollTop) window.scrollTo(0, 0);
    });
};
var goToCommentPage = function(router, communityId, postId, commentId) {
    // Adding the comment query param causes a full page refresh so we need to pass this via query
    // This also prevents the need for shouldScrollTop
    return router.push({
        pathname: "/[communityId]/post/[postId]/?comment=[commentId]",
        query: {
            communityId: communityId,
            postId: postId,
            commentId: commentId
        }
    }, "".concat(getCommentUrl(communityId, postId, commentId), "&canUseBrowserBack=true"));
};
var goToNewEvent = function(router, communityId, query) {
    return router.push({
        pathname: pathnames.events.new,
        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            communityId: communityId
        }, query)
    }, "/communities/".concat(communityId, "/events/new/"));
};
var goToEvents = function(router, communityId) {
    return router.push({
        pathname: pathnames.events.events,
        query: {
            communityId: communityId
        }
    }, "/communities/".concat(communityId, "/events"));
};
var goToEvent = function(router, eventId, communityId) {
    return router.push({
        pathname: pathnames.events.event,
        query: {
            communityId: communityId,
            eventId: eventId,
            canUseBrowserBack: true
        }
    }, "/communities/".concat(communityId, "/events/").concat(eventId, "/"));
};
var goToEditEvent = function(router, eventId, communityId) {
    return router.push({
        pathname: pathnames.events.edit,
        query: {
            communityId: communityId,
            eventId: eventId
        }
    }, "/communities/".concat(communityId, "/events/").concat(eventId, "/edit/"));
};
// Returns a boolean if we can tell by looking at browser info
// Returns null if uncertain
var wasPageRefreshed = function() {
    var performance = window === null || window === void 0 ? void 0 : window.performance;
    if (performance) {
        var ref, ref1, ref2;
        // Deprecated approach but still works in most browsers
        if ((performance === null || performance === void 0 ? void 0 : (ref = performance.navigation) === null || ref === void 0 ? void 0 : ref.type) != null && ((ref1 = performance.navigation) === null || ref1 === void 0 ? void 0 : ref1.type) === ((ref2 = performance.navigation) === null || ref2 === void 0 ? void 0 : ref2.TYPE_RELOAD)) {
            return true;
        }
        return window.performance.getEntriesByType("navigation").map(function(nav) {
            // @ts-ignore ... apparently type does exist
            return nav.type;
        }).includes("reload");
    }
    return null;
};
var goToPostListPage = function(router, communityId) {
    return function() {
        // If this post page has been navigated to by clicking a post on the listing page
        // then we can safely use the browser back button, which will maintain the scroll
        // postion of the post list. Otherwise, we want to manually navigate to the listing page.
        if (router.query.canUseBrowserBack) {
            router.back();
        } else {
            goToHome(router, communityId);
        }
    };
};


/***/ }),

/***/ 51661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gq": function() { return /* binding */ isValidText; },
/* harmony export */   "j0": function() { return /* binding */ insertAtPosition; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _toastHelpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55049);


/* eslint-disable no-console */ 
var isValidText = function(text) {
    return !!text && text.trim() !== "";
};
var insertAtPosition = function(string, position, insertValue) {
    var leftSubString = string.slice(0, position);
    var rightSubString = string.slice(position);
    return leftSubString + insertValue + rightSubString;
};
var oldCopyToClipboard = function(content, successMessage) {
    var failureMessage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    try {
        var el = document.createElement("textarea");
        el.value = content;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .successToastMessage */ .wu)(successMessage);
    } catch (e) {
        if (failureMessage) {
            (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .failureToastMessage */ .MO)(failureMessage);
        } else {
            (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .genericToastAlert */ .d9)();
        }
    }
};
var newCopyToClipboard = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(content, successMessage) {
        var failureMessage, _args = arguments;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    failureMessage = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return navigator.clipboard.writeText(content);
                case 4:
                    (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .successToastMessage */ .wu)(successMessage);
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](1);
                    if (failureMessage) {
                        (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .failureToastMessage */ .MO)(failureMessage);
                    } else {
                        (0,_toastHelpers__WEBPACK_IMPORTED_MODULE_1__/* .genericToastAlert */ .d9)();
                    }
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return function newCopyToClipboard(content, successMessage) {
        return _ref.apply(this, arguments);
    };
}();
var copyToClipboard = function(content, successMessage) {
    var failureMessage = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
    if (!navigator.clipboard) {
        oldCopyToClipboard(content, successMessage, failureMessage);
    } else {
        newCopyToClipboard(content, successMessage, failureMessage);
    }
};



/***/ }),

/***/ 55049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MO": function() { return /* binding */ failureToastMessage; },
/* harmony export */   "b7": function() { return /* binding */ infoToastMessage; },
/* harmony export */   "d9": function() { return /* binding */ genericToastAlert; },
/* harmony export */   "wu": function() { return /* binding */ successToastMessage; }
/* harmony export */ });
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81792);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4067);


var genericToastAlert = function() {
    _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_1__.t.alert(next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n */ .ag === null || next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n */ .ag === void 0 ? void 0 : next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.t */ .ag.t("Something went wrong. Please try again."), {
        autoClose: false
    });
};
var successToastMessage = function(content) {
    _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_1__.t.notice(content, {
        autoClose: true
    });
};
var failureToastMessage = function(content) {
    _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_1__.t.alert(content, {
        autoClose: false
    });
};
var infoToastMessage = function(content) {
    _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_1__.t.info(content, {
        autoClose: true
    });
};


/***/ }),

/***/ 73652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ isSiteAdmin; },
/* harmony export */   "CY": function() { return /* binding */ canEditPost; },
/* harmony export */   "F5": function() { return /* binding */ canEditEvent; },
/* harmony export */   "GJ": function() { return /* binding */ isAdmin; },
/* harmony export */   "QK": function() { return /* binding */ canPinPost; },
/* harmony export */   "Rz": function() { return /* binding */ canDeletePost; },
/* harmony export */   "Ss": function() { return /* binding */ canDeleteComment; },
/* harmony export */   "WL": function() { return /* binding */ canAccess; },
/* harmony export */   "e$": function() { return /* binding */ canViewMemberList; },
/* harmony export */   "gt": function() { return /* binding */ canCreateEvent; },
/* harmony export */   "vJ": function() { return /* binding */ isModerator; },
/* harmony export */   "x": function() { return /* binding */ hasModeratorBadge; }
/* harmony export */ });
/* unused harmony export hasPermission */
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59830);

var isModerator = function(userPermissions) {
    return userPermissions && userPermissions.some(function(permission) {
        return permission.split(", ").includes(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.VIEW_COMMUNITY */ .uq.VIEW_COMMUNITY);
    });
};
var isSiteAdmin = function(userRoles) {
    return userRoles && userRoles.some(function(role) {
        return role.split(", ").includes(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .SITE_ADMIN */ .S1);
    });
};
var isAdmin = function(user) {
    return canAccess([
        utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_ROLES.SITE_OWNER_SITE_ADMIN */ .pR.SITE_OWNER_SITE_ADMIN,
        utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_ROLES.SITE_ADMIN */ .pR.SITE_ADMIN,
        utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_ROLES.PARTNER */ .pR.PARTNER, 
    ], user);
};
var canAccess = function(roles, currentUser) {
    var ref;
    var userRoles = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.roles) === null || ref === void 0 ? void 0 : ref.map(function(userRole) {
        return userRole.toLowerCase();
    });
    // If the user does not have roles and we need to return false.
    // There is a case where the author does not have roles.
    if (!userRoles) {
        return false;
    }
    var checkRole = function(role) {
        return userRoles.includes(role.toLowerCase());
    };
    if (!roles.some(checkRole)) return false;
    return true;
};
var canDeletePost = function(currentUser) {
    return isSiteAdmin(currentUser.roles) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.DELETE_POST */ .uq.DELETE_POST);
};
var canDeleteComment = function(currentUser, author) {
    return isSiteAdmin(currentUser.roles) || currentUser.id && currentUser.id === (author === null || author === void 0 ? void 0 : author.id) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.DELETE_POST */ .uq.DELETE_POST);
};
var canEditPost = function(currentUser, author) {
    return isSiteAdmin(currentUser.roles) || currentUser.id && currentUser.id === (author === null || author === void 0 ? void 0 : author.id);
};
var canPinPost = function(currentUser) {
    return isSiteAdmin(currentUser.roles) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.PIN_POST */ .uq.PIN_POST);
};
var canCreateEvent = function(currentUser) {
    return isAdmin(currentUser) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.CREATE_LIVE_EVENT */ .uq.CREATE_LIVE_EVENT);
};
var canEditEvent = function(currentUser) {
    return isAdmin(currentUser) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.EDIT_LIVE_EVENT */ .uq.EDIT_LIVE_EVENT);
};
var canViewMemberList = function(currentUser) {
    return isAdmin(currentUser) || hasPermission(currentUser.permissions, utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .USER_PERMISSIONS.VIEW_COMMUNITY */ .uq.VIEW_COMMUNITY);
};
var hasModeratorBadge = function(user) {
    return isSiteAdmin(user.roles) || isModerator(user.permissions);
};
var hasPermission = function(userPermissions, permission) {
    return userPermissions && userPermissions.some(function(role) {
        return role.split(", ").includes(permission);
    });
};


/***/ }),

/***/ 19150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CommunityActions_sr-only--mobile__F6Udj","sr-only":"CommunityActions_sr-only__MuZjh","error-message":"CommunityActions_error-message__QFeY4","form-inline-edit":"CommunityActions_form-inline-edit__Tvm7V","form-group":"CommunityActions_form-group__f3_GH","form-row":"CommunityActions_form-row___91BJ","form-inline":"CommunityActions_form-inline__FRyRM","error":"CommunityActions_error__nASvB","input-group-append":"CommunityActions_input-group-append__92jM5","input-group-currency":"CommunityActions_input-group-currency__2dRDH","form-control":"CommunityActions_form-control__pGLxk","custom-select":"CommunityActions_custom-select__YvKup","is-invalid":"CommunityActions_is-invalid__EQzId","is-valid":"CommunityActions_is-valid__6r_Qk","input-group":"CommunityActions_input-group__T5cSo","input-group-text":"CommunityActions_input-group-text__bzpMZ","input-group-prepend":"CommunityActions_input-group-prepend__Ra_mw","valid-feedback":"CommunityActions_valid-feedback__BB3tY","invalid-feedback":"CommunityActions_invalid-feedback__MC8N7","form-text":"CommunityActions_form-text__bvi3D","label":"CommunityActions_label__RGPzQ","custom-control":"CommunityActions_custom-control__kYcht","custom-control-label":"CommunityActions_custom-control-label__OYc3i","custom-control-label--empty":"CommunityActions_custom-control-label--empty__uoLe5","custom-control-input":"CommunityActions_custom-control-input__4UN6M","community-actions__wrapper":"CommunityActions_community-actions__wrapper__ZG_EL","desktop-navigation":"CommunityActions_desktop-navigation__babv8"};

/***/ }),

/***/ 5792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CommunityActionsList_sr-only--mobile__jSm2p","sr-only":"CommunityActionsList_sr-only__EyxDT","error-message":"CommunityActionsList_error-message__K97lh","form-inline-edit":"CommunityActionsList_form-inline-edit__fI3Wn","form-group":"CommunityActionsList_form-group__4Ik1_","form-row":"CommunityActionsList_form-row__jI3sO","form-inline":"CommunityActionsList_form-inline__nrakF","error":"CommunityActionsList_error__kPzlL","input-group-append":"CommunityActionsList_input-group-append__FZiCf","input-group-currency":"CommunityActionsList_input-group-currency__LpQDI","form-control":"CommunityActionsList_form-control__Pq_ck","custom-select":"CommunityActionsList_custom-select__8BfoL","is-invalid":"CommunityActionsList_is-invalid__xQQcM","is-valid":"CommunityActionsList_is-valid__l6wLi","input-group":"CommunityActionsList_input-group__XOaBZ","input-group-text":"CommunityActionsList_input-group-text__mKbJ0","input-group-prepend":"CommunityActionsList_input-group-prepend__nTpVc","valid-feedback":"CommunityActionsList_valid-feedback__RdUI8","invalid-feedback":"CommunityActionsList_invalid-feedback__ZuJCX","form-text":"CommunityActionsList_form-text__px51d","label":"CommunityActionsList_label___1zQ1","custom-control":"CommunityActionsList_custom-control__3SQxf","custom-control-label":"CommunityActionsList_custom-control-label__khJVg","custom-control-label--empty":"CommunityActionsList_custom-control-label--empty__vPVKM","custom-control-input":"CommunityActionsList_custom-control-input__cGZIn","community-actions-list":"CommunityActionsList_community-actions-list__Nm3U_","community-actions-list__wrapper":"CommunityActionsList_community-actions-list__wrapper__7L2Vf","community-actions-list__create-space":"CommunityActionsList_community-actions-list__create-space__J8kOZ","is-active":"CommunityActionsList_is-active__Qshtk","common-actions__button":"CommunityActionsList_common-actions__button__tX0Aq","space__button":"CommunityActionsList_space__button__EkY4_","add-space__button":"CommunityActionsList_add-space__button__ORfZj","common-actions":"CommunityActionsList_common-actions__ZFN3Y","common-actions__wrapper":"CommunityActionsList_common-actions__wrapper__wtFXi","common-actions__members-count":"CommunityActionsList_common-actions__members-count__Sa_Rz","spaces-list__wrapper":"CommunityActionsList_spaces-list__wrapper__w6kcY","space__drag":"CommunityActionsList_space__drag__PXx1Q","space__button--dragging":"CommunityActionsList_space__button--dragging__bHAci","space__title":"CommunityActionsList_space__title__ugFYY","space__dragging":"CommunityActionsList_space__dragging__osRfX","space__notification":"CommunityActionsList_space__notification__q1Kuy","space__notification-text--light":"CommunityActionsList_space__notification-text--light__evYP9","space__notification-text--dark":"CommunityActionsList_space__notification-text--dark__s7nUj"};

/***/ }),

/***/ 80390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"SkeletonSpacesList_sr-only--mobile__qlNf_","sr-only":"SkeletonSpacesList_sr-only__Zkcsi","error-message":"SkeletonSpacesList_error-message__lHRsr","form-inline-edit":"SkeletonSpacesList_form-inline-edit__HMYKy","form-group":"SkeletonSpacesList_form-group__5WmF5","form-row":"SkeletonSpacesList_form-row__ujYfR","form-inline":"SkeletonSpacesList_form-inline__DHAf3","error":"SkeletonSpacesList_error__KRuHn","input-group-append":"SkeletonSpacesList_input-group-append__4ZN9p","input-group-currency":"SkeletonSpacesList_input-group-currency__0orOE","form-control":"SkeletonSpacesList_form-control__VoE2I","custom-select":"SkeletonSpacesList_custom-select__eO4FC","is-invalid":"SkeletonSpacesList_is-invalid__hDP_I","is-valid":"SkeletonSpacesList_is-valid__yKj0_","input-group":"SkeletonSpacesList_input-group__4DZzE","input-group-text":"SkeletonSpacesList_input-group-text__z8BqM","input-group-prepend":"SkeletonSpacesList_input-group-prepend__kRGFA","valid-feedback":"SkeletonSpacesList_valid-feedback__Be2ep","invalid-feedback":"SkeletonSpacesList_invalid-feedback__NsIZI","form-text":"SkeletonSpacesList_form-text__74u9s","label":"SkeletonSpacesList_label__JRatr","custom-control":"SkeletonSpacesList_custom-control__hwkJF","custom-control-label":"SkeletonSpacesList_custom-control-label__kMZRs","custom-control-label--empty":"SkeletonSpacesList_custom-control-label--empty__gFRgY","custom-control-input":"SkeletonSpacesList_custom-control-input__8pxR9","spaces-list-skeleton__content":"SkeletonSpacesList_spaces-list-skeleton__content__oR7OB"};

/***/ }),

/***/ 10073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CommunityStatusBadge_sr-only--mobile__AMjNO","sr-only":"CommunityStatusBadge_sr-only__Zwqf5","error-message":"CommunityStatusBadge_error-message__bYt6a","form-inline-edit":"CommunityStatusBadge_form-inline-edit__xWRSf","form-group":"CommunityStatusBadge_form-group__7kuRC","form-row":"CommunityStatusBadge_form-row__TapaG","form-inline":"CommunityStatusBadge_form-inline__g2xRE","error":"CommunityStatusBadge_error___m6QI","input-group-append":"CommunityStatusBadge_input-group-append__vIiRn","input-group-currency":"CommunityStatusBadge_input-group-currency__85H_l","form-control":"CommunityStatusBadge_form-control__84G8E","custom-select":"CommunityStatusBadge_custom-select___oYQI","is-invalid":"CommunityStatusBadge_is-invalid__QD_eh","is-valid":"CommunityStatusBadge_is-valid__coy1E","input-group":"CommunityStatusBadge_input-group__e_rDY","input-group-text":"CommunityStatusBadge_input-group-text__CYvz2","input-group-prepend":"CommunityStatusBadge_input-group-prepend__hVFnr","valid-feedback":"CommunityStatusBadge_valid-feedback__L4ZXb","invalid-feedback":"CommunityStatusBadge_invalid-feedback__CVcKh","form-text":"CommunityStatusBadge_form-text___h4Yo","label":"CommunityStatusBadge_label__ar0V8","custom-control":"CommunityStatusBadge_custom-control__SAoMv","custom-control-label":"CommunityStatusBadge_custom-control-label__euuzU","custom-control-label--empty":"CommunityStatusBadge_custom-control-label--empty__KXbYC","custom-control-input":"CommunityStatusBadge_custom-control-input__2I6zU","community-status-badge__link":"CommunityStatusBadge_community-status-badge__link__4ySrF","is-live":"CommunityStatusBadge_is-live__lZ1HX"};

/***/ }),

/***/ 84945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"community-users__wrapper":"CommunityUsersAvatars_community-users__wrapper__OT7uL","community-users__avatar-container":"CommunityUsersAvatars_community-users__avatar-container__XlpZL"};

/***/ }),

/***/ 9484:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course-card__add":"CourseCardPlaceholder_course-card__add__FYoGA","course-card__add__icon":"CourseCardPlaceholder_course-card__add__icon__iMTW4","course-card__add__title":"CourseCardPlaceholder_course-card__add__title__bFLR0","course-card__add__subtitle":"CourseCardPlaceholder_course-card__add__subtitle__GIpRk"};

/***/ }),

/***/ 62670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course-card__container":"CourseDetails_course-card__container__fkysR","is-not-clickable":"CourseDetails_is-not-clickable__wlybJ"};

/***/ }),

/***/ 71107:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CurrentUserDropdown_sr-only--mobile__Babtw","sr-only":"CurrentUserDropdown_sr-only__mcG12","error-message":"CurrentUserDropdown_error-message__iAtHX","form-inline-edit":"CurrentUserDropdown_form-inline-edit__x_HMb","form-group":"CurrentUserDropdown_form-group__sXGSV","form-row":"CurrentUserDropdown_form-row__T05Sd","form-inline":"CurrentUserDropdown_form-inline__ILnv_","error":"CurrentUserDropdown_error__RN7zz","input-group-append":"CurrentUserDropdown_input-group-append__AM_gy","input-group-currency":"CurrentUserDropdown_input-group-currency__WCC0w","form-control":"CurrentUserDropdown_form-control__0CkRS","custom-select":"CurrentUserDropdown_custom-select__377XA","is-invalid":"CurrentUserDropdown_is-invalid__fbnoM","is-valid":"CurrentUserDropdown_is-valid__KE3td","input-group":"CurrentUserDropdown_input-group__oyKWB","input-group-text":"CurrentUserDropdown_input-group-text__C4RzC","input-group-prepend":"CurrentUserDropdown_input-group-prepend__Hc0Rm","valid-feedback":"CurrentUserDropdown_valid-feedback__avvkJ","invalid-feedback":"CurrentUserDropdown_invalid-feedback__jmkr7","form-text":"CurrentUserDropdown_form-text__x5e7X","label":"CurrentUserDropdown_label___p749","custom-control":"CurrentUserDropdown_custom-control___e2Ev","custom-control-label":"CurrentUserDropdown_custom-control-label__FFzAT","custom-control-label--empty":"CurrentUserDropdown_custom-control-label--empty__MfGiM","custom-control-input":"CurrentUserDropdown_custom-control-input__zScjk","current-user":"CurrentUserDropdown_current-user__QdqPs","current-user__name":"CurrentUserDropdown_current-user__name__i3K8K","current-user__avatar":"CurrentUserDropdown_current-user__avatar__nM7Mg","current-user__avatar-container":"CurrentUserDropdown_current-user__avatar-container__5rsaE","current-user--dark-text":"CurrentUserDropdown_current-user--dark-text__CqbSY","current-user__button":"CurrentUserDropdown_current-user__button__Y7R9K"};

/***/ }),

/***/ 41018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventPanel_sr-only--mobile__mQSfC","sr-only":"EventPanel_sr-only__0__e4","error-message":"EventPanel_error-message___7mIZ","form-inline-edit":"EventPanel_form-inline-edit__u8tu4","form-group":"EventPanel_form-group__m4trC","form-row":"EventPanel_form-row__1Lh0A","form-inline":"EventPanel_form-inline__RZcjq","error":"EventPanel_error__F6dkE","input-group-append":"EventPanel_input-group-append__tFPNP","input-group-currency":"EventPanel_input-group-currency__fc_pu","form-control":"EventPanel_form-control__LDr__","custom-select":"EventPanel_custom-select__Ap6hZ","is-invalid":"EventPanel_is-invalid__H_LeS","is-valid":"EventPanel_is-valid__JzOE1","input-group":"EventPanel_input-group__NkQ0c","input-group-text":"EventPanel_input-group-text__qeWqP","input-group-prepend":"EventPanel_input-group-prepend__dvIgW","valid-feedback":"EventPanel_valid-feedback__ri6TL","invalid-feedback":"EventPanel_invalid-feedback__zk_nN","form-text":"EventPanel_form-text__6TC21","label":"EventPanel_label__dNu3e","custom-control":"EventPanel_custom-control__X4qaY","custom-control-label":"EventPanel_custom-control-label__m40v_","custom-control-label--empty":"EventPanel_custom-control-label--empty__f7Vc3","custom-control-input":"EventPanel_custom-control-input__n2I0c","event-panel":"EventPanel_event-panel__ytKVT","event-panel__wrapper":"EventPanel_event-panel__wrapper__era_g","event-panel__header":"EventPanel_event-panel__header__EV0BP","event-panel__close":"EventPanel_event-panel__close__3lZUj","event-panel__title":"EventPanel_event-panel__title__jX8c0","event-panel__content":"EventPanel_event-panel__content__sc4U9","event-panel__footer":"EventPanel_event-panel__footer__Fd_xb","event-panel__delete":"EventPanel_event-panel__delete__jG6vp"};

/***/ }),

/***/ 18384:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"edit-event-button":"EditEventButton_edit-event-button__ergtc","full-width":"EditEventButton_full-width__t9VI4"};

/***/ }),

/***/ 71476:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventContent_sr-only--mobile__WPjHj","sr-only":"EventContent_sr-only__I9oMm","error-message":"EventContent_error-message__7_ZRY","form-inline-edit":"EventContent_form-inline-edit__WOuIF","form-group":"EventContent_form-group__vVTtx","form-row":"EventContent_form-row__rNKmJ","form-inline":"EventContent_form-inline__s0nqj","error":"EventContent_error__bFqZI","input-group-append":"EventContent_input-group-append__JPBc0","input-group-currency":"EventContent_input-group-currency__cD8zB","form-control":"EventContent_form-control__PXEuj","custom-select":"EventContent_custom-select__FtrS_","is-invalid":"EventContent_is-invalid__uANZe","is-valid":"EventContent_is-valid__MZMsX","input-group":"EventContent_input-group__0irGn","input-group-text":"EventContent_input-group-text__dsYNl","input-group-prepend":"EventContent_input-group-prepend__C4nqo","valid-feedback":"EventContent_valid-feedback__y5_Wq","invalid-feedback":"EventContent_invalid-feedback__wIJHm","form-text":"EventContent_form-text__4PYCU","label":"EventContent_label__DnkLV","custom-control":"EventContent_custom-control__V5i6k","custom-control-label":"EventContent_custom-control-label__8JW8w","custom-control-label--empty":"EventContent_custom-control-label--empty__rskcm","custom-control-input":"EventContent_custom-control-input__wWmqD","event-content":"EventContent_event-content__ee0fi","event-content__wrapper":"EventContent_event-content__wrapper__4j_ba","event-content__date":"EventContent_event-content__date___vhHy","event-content__meeting":"EventContent_event-content__meeting__qzKlO","event-content__meeting-url":"EventContent_event-content__meeting-url__lHKAX","event-content__meeting-button":"EventContent_event-content__meeting-button__gqEK7","event-content__about":"EventContent_event-content__about__2bQLq"};

/***/ }),

/***/ 84660:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"EventInterestedButton_sr-only--mobile__9jfrZ","sr-only":"EventInterestedButton_sr-only__jXw6a","error-message":"EventInterestedButton_error-message__XzLaL","form-inline-edit":"EventInterestedButton_form-inline-edit__0K8Gi","form-group":"EventInterestedButton_form-group__P_nef","form-row":"EventInterestedButton_form-row__pqzSo","form-inline":"EventInterestedButton_form-inline__9au37","error":"EventInterestedButton_error__yLOpO","input-group-append":"EventInterestedButton_input-group-append__lXHPu","input-group-currency":"EventInterestedButton_input-group-currency__Yp56L","form-control":"EventInterestedButton_form-control__YHtDM","custom-select":"EventInterestedButton_custom-select__7hs21","is-invalid":"EventInterestedButton_is-invalid__R0YlL","is-valid":"EventInterestedButton_is-valid__gNFy6","input-group":"EventInterestedButton_input-group__ktOH1","input-group-text":"EventInterestedButton_input-group-text__J_qd_","input-group-prepend":"EventInterestedButton_input-group-prepend__332QC","valid-feedback":"EventInterestedButton_valid-feedback__y1zOn","invalid-feedback":"EventInterestedButton_invalid-feedback__wriEE","form-text":"EventInterestedButton_form-text__w_ljH","label":"EventInterestedButton_label__v6SlD","custom-control":"EventInterestedButton_custom-control__Ivndu","custom-control-label":"EventInterestedButton_custom-control-label__3VF26","custom-control-label--empty":"EventInterestedButton_custom-control-label--empty__RXaf9","custom-control-input":"EventInterestedButton_custom-control-input__tQ_QS","event-panel__interested-button":"EventInterestedButton_event-panel__interested-button__ohNQ2","interested":"EventInterestedButton_interested__H_jiG","event-panel__interested-button-icon":"EventInterestedButton_event-panel__interested-button-icon__qzIkF","not-yet-interested":"EventInterestedButton_not-yet-interested__5ct1I","event-panel__interested-button-container":"EventInterestedButton_event-panel__interested-button-container__YIfJY","event-panel__interested-button-icon-container":"EventInterestedButton_event-panel__interested-button-icon-container__Vk6KR"};

/***/ }),

/***/ 1196:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"event-interested-users__container":"EventInterestedUsers_event-interested-users__container__6fSf4","event-interested-users":"EventInterestedUsers_event-interested-users__6C3aZ"};

/***/ }),

/***/ 1922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"Image_img__4B696"};

/***/ }),

/***/ 87835:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MobileMenuUserSection_sr-only--mobile___ItWO","sr-only":"MobileMenuUserSection_sr-only__6Q2Nm","error-message":"MobileMenuUserSection_error-message__1juNh","form-inline-edit":"MobileMenuUserSection_form-inline-edit__zWo2k","form-group":"MobileMenuUserSection_form-group__bjOEA","form-row":"MobileMenuUserSection_form-row__0fsYR","form-inline":"MobileMenuUserSection_form-inline__mBQny","error":"MobileMenuUserSection_error__rykC4","input-group-append":"MobileMenuUserSection_input-group-append___vhdV","input-group-currency":"MobileMenuUserSection_input-group-currency__pPhY4","form-control":"MobileMenuUserSection_form-control__YTR_H","custom-select":"MobileMenuUserSection_custom-select__oBECG","is-invalid":"MobileMenuUserSection_is-invalid__DJkNB","is-valid":"MobileMenuUserSection_is-valid__Z1jL3","input-group":"MobileMenuUserSection_input-group__k2XwW","input-group-text":"MobileMenuUserSection_input-group-text__AK09x","input-group-prepend":"MobileMenuUserSection_input-group-prepend__Nfs5K","valid-feedback":"MobileMenuUserSection_valid-feedback__jZljH","invalid-feedback":"MobileMenuUserSection_invalid-feedback__sP9u6","form-text":"MobileMenuUserSection_form-text__bz66w","label":"MobileMenuUserSection_label__m05dI","custom-control":"MobileMenuUserSection_custom-control__zpM3x","custom-control-label":"MobileMenuUserSection_custom-control-label__n5nDF","custom-control-label--empty":"MobileMenuUserSection_custom-control-label--empty__9YKY7","custom-control-input":"MobileMenuUserSection_custom-control-input__Gkcq7","mobile-menu-user-section__wrapper":"MobileMenuUserSection_mobile-menu-user-section__wrapper__O_IP2","mobile-menu-user-section__separator":"MobileMenuUserSection_mobile-menu-user-section__separator__oFe6K","mobile-menu-user-section__info":"MobileMenuUserSection_mobile-menu-user-section__info__a0ipg","current-user__name":"MobileMenuUserSection_current-user__name__0KIch","mobile-menu-user-section__actions":"MobileMenuUserSection_mobile-menu-user-section__actions__Wnq3v","mobile-menu-user-section__button":"MobileMenuUserSection_mobile-menu-user-section__button__seup6"};

/***/ }),

/***/ 2146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MobileNav_sr-only--mobile__g7Mb6","sr-only":"MobileNav_sr-only__XKvMn","error-message":"MobileNav_error-message__cIeEu","form-inline-edit":"MobileNav_form-inline-edit__saCvb","form-group":"MobileNav_form-group__JbPuI","form-row":"MobileNav_form-row__dO2eo","form-inline":"MobileNav_form-inline__mJnEP","error":"MobileNav_error__byhlX","input-group-append":"MobileNav_input-group-append__Zl02y","input-group-currency":"MobileNav_input-group-currency__tS8sy","form-control":"MobileNav_form-control___yIE8","custom-select":"MobileNav_custom-select__GJsY0","is-invalid":"MobileNav_is-invalid__r6ojc","is-valid":"MobileNav_is-valid__YHdIh","input-group":"MobileNav_input-group__1Q3r_","input-group-text":"MobileNav_input-group-text__LcNMA","input-group-prepend":"MobileNav_input-group-prepend__phVqS","valid-feedback":"MobileNav_valid-feedback___HxSS","invalid-feedback":"MobileNav_invalid-feedback__gmMrl","form-text":"MobileNav_form-text__UNJq_","label":"MobileNav_label__V5H7m","custom-control":"MobileNav_custom-control__R_vOE","custom-control-label":"MobileNav_custom-control-label__HzG1r","custom-control-label--empty":"MobileNav_custom-control-label--empty__Fn7CM","custom-control-input":"MobileNav_custom-control-input__RW_eR","mobile-nav__separator":"MobileNav_mobile-nav__separator__mh_WR","mobile-nav__button":"MobileNav_mobile-nav__button__nq0hp"};

/***/ }),

/***/ 79178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moderator-badge":"ModeratorBadge_moderator-badge___WgtO"};

/***/ }),

/***/ 59587:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ModeratorPanel_sr-only--mobile__JVANB","sr-only":"ModeratorPanel_sr-only__PclGU","error-message":"ModeratorPanel_error-message__DfSlD","form-inline-edit":"ModeratorPanel_form-inline-edit__OJfzl","form-group":"ModeratorPanel_form-group__xkApG","form-row":"ModeratorPanel_form-row__kQiNf","form-inline":"ModeratorPanel_form-inline__6hh1Y","error":"ModeratorPanel_error__D_PYD","input-group-append":"ModeratorPanel_input-group-append__RoJDB","input-group-currency":"ModeratorPanel_input-group-currency__IyATd","form-control":"ModeratorPanel_form-control__3c5wg","custom-select":"ModeratorPanel_custom-select__hUfmh","is-invalid":"ModeratorPanel_is-invalid__l4RCq","is-valid":"ModeratorPanel_is-valid__rlU0c","input-group":"ModeratorPanel_input-group__YhEXS","input-group-text":"ModeratorPanel_input-group-text__ZaLkG","input-group-prepend":"ModeratorPanel_input-group-prepend__tLY46","valid-feedback":"ModeratorPanel_valid-feedback__NxxFA","invalid-feedback":"ModeratorPanel_invalid-feedback__mC7_v","form-text":"ModeratorPanel_form-text__vlrwO","label":"ModeratorPanel_label__edLoK","custom-control":"ModeratorPanel_custom-control__bOe0W","custom-control-label":"ModeratorPanel_custom-control-label__KqBhk","custom-control-label--empty":"ModeratorPanel_custom-control-label--empty__2r1d7","custom-control-input":"ModeratorPanel_custom-control-input__Rzdaz","moderator-panel":"ModeratorPanel_moderator-panel__OIhgK","moderator-panel__wrapper":"ModeratorPanel_moderator-panel__wrapper__1TJ6s","moderator-panel__header":"ModeratorPanel_moderator-panel__header__ysSwz","moderator-panel__search":"ModeratorPanel_moderator-panel__search__DJJOE","moderator-panel__footer":"ModeratorPanel_moderator-panel__footer__1t4dj"};

/***/ }),

/***/ 92280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"moderator-access-list":"ModeratorAccessList_moderator-access-list__Pv34O","moderator-access-list__allowed":"ModeratorAccessList_moderator-access-list__allowed__5XTLN","moderator-access-list__banned":"ModeratorAccessList_moderator-access-list__banned__as5xy"};

/***/ }),

/***/ 14730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notification-pane":"NotificationPane_notification-pane__yYj_l","notification-pane--dark":"NotificationPane_notification-pane--dark__DxeWB"};

/***/ }),

/***/ 11579:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"PageSkeleton_sr-only--mobile__QKqzb","sr-only":"PageSkeleton_sr-only___51R_","error-message":"PageSkeleton_error-message__a5S96","form-inline-edit":"PageSkeleton_form-inline-edit__JSfIp","form-group":"PageSkeleton_form-group__FYJ5v","form-row":"PageSkeleton_form-row__5JbOv","form-inline":"PageSkeleton_form-inline__784IF","error":"PageSkeleton_error__ydFWv","input-group-append":"PageSkeleton_input-group-append__n2buY","input-group-currency":"PageSkeleton_input-group-currency__Xdgyw","form-control":"PageSkeleton_form-control__iv3W_","custom-select":"PageSkeleton_custom-select__bXNPA","is-invalid":"PageSkeleton_is-invalid__Q8Vnq","is-valid":"PageSkeleton_is-valid__K_Lcz","input-group":"PageSkeleton_input-group__OqIGZ","input-group-text":"PageSkeleton_input-group-text__T1pjX","input-group-prepend":"PageSkeleton_input-group-prepend__BIWG0","valid-feedback":"PageSkeleton_valid-feedback__dZf0u","invalid-feedback":"PageSkeleton_invalid-feedback__9L8VR","form-text":"PageSkeleton_form-text__s0TpV","label":"PageSkeleton_label__6KPwD","custom-control":"PageSkeleton_custom-control__3MY_i","custom-control-label":"PageSkeleton_custom-control-label__21WF5","custom-control-label--empty":"PageSkeleton_custom-control-label--empty__lS_Fd","custom-control-input":"PageSkeleton_custom-control-input__yt5rC","page-skeleton__wrapper":"PageSkeleton_page-skeleton__wrapper__yVm8t","page-skeleton__navbar":"PageSkeleton_page-skeleton__navbar__VQ2La","page-skeleton__main":"PageSkeleton_page-skeleton__main__cnhhG","page-skeleton__aside":"PageSkeleton_page-skeleton__aside__uZTCo","page-skeleton__aside-first-block":"PageSkeleton_page-skeleton__aside-first-block__oelF_","page-skeleton__content":"PageSkeleton_page-skeleton__content__G72jl","page-skeleton__content-first-element":"PageSkeleton_page-skeleton__content-first-element__POuWG","page-skeleton__content-first-element-body":"PageSkeleton_page-skeleton__content-first-element-body__Peb7F","page-skeleton__content-empty-block":"PageSkeleton_page-skeleton__content-empty-block__GZyrT","page-skeleton__info-community":"PageSkeleton_page-skeleton__info-community__cSu3Z","page-skeleton__info-community-post":"PageSkeleton_page-skeleton__info-community-post__ch6B2","page-skeleton__info-community-container":"PageSkeleton_page-skeleton__info-community-container__10Va5","page-skeleton__info-community-container-avatar":"PageSkeleton_page-skeleton__info-community-container-avatar__lHKrI","page-skeleton__info-community-container-body":"PageSkeleton_page-skeleton__info-community-container-body__M4kw0"};

/***/ }),

/***/ 80868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePanel_sr-only--mobile__tnSpC","sr-only":"ProfilePanel_sr-only__rNEyv","error-message":"ProfilePanel_error-message__Vr2wv","form-inline-edit":"ProfilePanel_form-inline-edit__Yx89N","form-group":"ProfilePanel_form-group__jscgG","form-row":"ProfilePanel_form-row__18no_","form-inline":"ProfilePanel_form-inline__xVVfb","error":"ProfilePanel_error__c51ab","input-group-append":"ProfilePanel_input-group-append__TDvHU","input-group-currency":"ProfilePanel_input-group-currency__r04uO","form-control":"ProfilePanel_form-control__TQD4j","custom-select":"ProfilePanel_custom-select__z0WxQ","is-invalid":"ProfilePanel_is-invalid__qVkp_","is-valid":"ProfilePanel_is-valid__r_VJa","input-group":"ProfilePanel_input-group__dA2__","input-group-text":"ProfilePanel_input-group-text__vSRE0","input-group-prepend":"ProfilePanel_input-group-prepend__i6iUj","valid-feedback":"ProfilePanel_valid-feedback__Vf5mh","invalid-feedback":"ProfilePanel_invalid-feedback__IctJC","form-text":"ProfilePanel_form-text__f507y","label":"ProfilePanel_label__OLNV3","custom-control":"ProfilePanel_custom-control__o6x1_","custom-control-label":"ProfilePanel_custom-control-label__bChLI","custom-control-label--empty":"ProfilePanel_custom-control-label--empty__o1JyT","custom-control-input":"ProfilePanel_custom-control-input__j_pxw","profile-panel":"ProfilePanel_profile-panel__rU4kG","profile-panel__content":"ProfilePanel_profile-panel__content__9SJC0","profile-panel__header":"ProfilePanel_profile-panel__header___f6jy","profile-panel__avatar":"ProfilePanel_profile-panel__avatar__s7hAu","profile-panel__info":"ProfilePanel_profile-panel__info__g9zR4","profile-panel__title":"ProfilePanel_profile-panel__title__38Zp_","profile-panel__subtitle":"ProfilePanel_profile-panel__subtitle__etCZg","profile-panel__label":"ProfilePanel_profile-panel__label__YF8bc","profile-panel__roles":"ProfilePanel_profile-panel__roles__V2ORC","profile-panel__moderator-badge__container":"ProfilePanel_profile-panel__moderator-badge__container__nvKgu","profile-panel__no-info":"ProfilePanel_profile-panel__no-info__lxkyo","profile-panel__no-info__title":"ProfilePanel_profile-panel__no-info__title__OmhNX","profile-panel__no-info__text":"ProfilePanel_profile-panel__no-info__text__v_TNA","profile-panel__skeleton":"ProfilePanel_profile-panel__skeleton__dLOsM"};

/***/ }),

/***/ 1804:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"completed-courses__section":"ProfileCompletedCourses_completed-courses__section__SRETI","completed-courses__section-title":"ProfileCompletedCourses_completed-courses__section-title__ICJfv","completed-courses__section-card":"ProfileCompletedCourses_completed-courses__section-card___w8qe","completed-courses__section-button":"ProfileCompletedCourses_completed-courses__section-button__dr_Rw"};

/***/ }),

/***/ 20513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePanelSkeleton_sr-only--mobile__zTDau","sr-only":"ProfilePanelSkeleton_sr-only__2CU63","error-message":"ProfilePanelSkeleton_error-message__MpN2g","form-inline-edit":"ProfilePanelSkeleton_form-inline-edit__lKML_","form-group":"ProfilePanelSkeleton_form-group__rNIOW","form-row":"ProfilePanelSkeleton_form-row__d3bMq","form-inline":"ProfilePanelSkeleton_form-inline___Xyjk","error":"ProfilePanelSkeleton_error__3qR_A","input-group-append":"ProfilePanelSkeleton_input-group-append__dSQfo","input-group-currency":"ProfilePanelSkeleton_input-group-currency__miBhV","form-control":"ProfilePanelSkeleton_form-control__9fr0k","custom-select":"ProfilePanelSkeleton_custom-select__j4DAN","is-invalid":"ProfilePanelSkeleton_is-invalid__4E2kD","is-valid":"ProfilePanelSkeleton_is-valid__O9gF2","input-group":"ProfilePanelSkeleton_input-group__ugvef","input-group-text":"ProfilePanelSkeleton_input-group-text__Z7LJw","input-group-prepend":"ProfilePanelSkeleton_input-group-prepend__R0fqu","valid-feedback":"ProfilePanelSkeleton_valid-feedback__j6UgM","invalid-feedback":"ProfilePanelSkeleton_invalid-feedback__PYzgq","form-text":"ProfilePanelSkeleton_form-text__RQEFF","label":"ProfilePanelSkeleton_label___i1Mk","custom-control":"ProfilePanelSkeleton_custom-control__6dnzn","custom-control-label":"ProfilePanelSkeleton_custom-control-label__74i7A","custom-control-label--empty":"ProfilePanelSkeleton_custom-control-label--empty__YfAH6","custom-control-input":"ProfilePanelSkeleton_custom-control-input__wo1pv","skeleton-profile-panel":"ProfilePanelSkeleton_skeleton-profile-panel__9gEKi","skeleton-profile-panel__avatar":"ProfilePanelSkeleton_skeleton-profile-panel__avatar__TxQV1"};

/***/ }),

/***/ 85011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePastActivity_sr-only--mobile__TP7NW","sr-only":"ProfilePastActivity_sr-only__DkvG1","error-message":"ProfilePastActivity_error-message__klka4","form-inline-edit":"ProfilePastActivity_form-inline-edit__jcicn","form-group":"ProfilePastActivity_form-group__tsjOv","form-row":"ProfilePastActivity_form-row__A7_Ej","form-inline":"ProfilePastActivity_form-inline__EC7gu","error":"ProfilePastActivity_error___fdlK","input-group-append":"ProfilePastActivity_input-group-append__dwsKN","input-group-currency":"ProfilePastActivity_input-group-currency__g3Ft1","form-control":"ProfilePastActivity_form-control__IStbU","custom-select":"ProfilePastActivity_custom-select__DItP1","is-invalid":"ProfilePastActivity_is-invalid__2ii6I","is-valid":"ProfilePastActivity_is-valid__LbUD6","input-group":"ProfilePastActivity_input-group__GmkQH","input-group-text":"ProfilePastActivity_input-group-text__7TG_D","input-group-prepend":"ProfilePastActivity_input-group-prepend__hNgPY","valid-feedback":"ProfilePastActivity_valid-feedback__dsGak","invalid-feedback":"ProfilePastActivity_invalid-feedback__Tj_4v","form-text":"ProfilePastActivity_form-text__rbjIF","label":"ProfilePastActivity_label__Uq96o","custom-control":"ProfilePastActivity_custom-control__Vrq50","custom-control-label":"ProfilePastActivity_custom-control-label__LF3oD","custom-control-label--empty":"ProfilePastActivity_custom-control-label--empty__13pAO","custom-control-input":"ProfilePastActivity_custom-control-input__9bbBb","past-activity":"ProfilePastActivity_past-activity__akYoX","past-activity__title":"ProfilePastActivity_past-activity__title__cAb_C"};

/***/ }),

/***/ 80991:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePost_sr-only--mobile__SMRWO","sr-only":"ProfilePost_sr-only__dQI3H","error-message":"ProfilePost_error-message__Ge0RW","form-inline-edit":"ProfilePost_form-inline-edit__REbcq","form-group":"ProfilePost_form-group__ZuonX","form-row":"ProfilePost_form-row__mFVeA","form-inline":"ProfilePost_form-inline__GXwBY","error":"ProfilePost_error__SzjJO","input-group-append":"ProfilePost_input-group-append__fyh0F","input-group-currency":"ProfilePost_input-group-currency__tJac0","form-control":"ProfilePost_form-control__N_kEU","custom-select":"ProfilePost_custom-select__cNDHN","is-invalid":"ProfilePost_is-invalid__sHWOx","is-valid":"ProfilePost_is-valid__hzTfF","input-group":"ProfilePost_input-group__OZr2j","input-group-text":"ProfilePost_input-group-text__DO2ty","input-group-prepend":"ProfilePost_input-group-prepend__FVBT4","valid-feedback":"ProfilePost_valid-feedback__tuOco","invalid-feedback":"ProfilePost_invalid-feedback__lT6LD","form-text":"ProfilePost_form-text__yYTy8","label":"ProfilePost_label__EQbtw","custom-control":"ProfilePost_custom-control__sPDjR","custom-control-label":"ProfilePost_custom-control-label__g_06B","custom-control-label--empty":"ProfilePost_custom-control-label--empty__2CnTM","custom-control-input":"ProfilePost_custom-control-input__889rq","profile-post":"ProfilePost_profile-post__JDFQh","profile-post__label":"ProfilePost_profile-post__label__3taWp","profile-post__author-details":"ProfilePost_profile-post__author-details__MRk7i","profile-post__details":"ProfilePost_profile-post__details__Js_ce","profile-post__title":"ProfilePost_profile-post__title__ebqTe"};

/***/ }),

/***/ 76337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePostEmptyState_sr-only--mobile__ylavV","sr-only":"ProfilePostEmptyState_sr-only__9px22","error-message":"ProfilePostEmptyState_error-message__KoWDq","form-inline-edit":"ProfilePostEmptyState_form-inline-edit__DKA4t","form-group":"ProfilePostEmptyState_form-group__B2VF6","form-row":"ProfilePostEmptyState_form-row__xuCVJ","form-inline":"ProfilePostEmptyState_form-inline___EqMk","error":"ProfilePostEmptyState_error__0xQns","input-group-append":"ProfilePostEmptyState_input-group-append__Wcoy4","input-group-currency":"ProfilePostEmptyState_input-group-currency__H9tI_","form-control":"ProfilePostEmptyState_form-control___tGJC","custom-select":"ProfilePostEmptyState_custom-select__cnNXp","is-invalid":"ProfilePostEmptyState_is-invalid__xOWs2","is-valid":"ProfilePostEmptyState_is-valid__4si0P","input-group":"ProfilePostEmptyState_input-group__zMV97","input-group-text":"ProfilePostEmptyState_input-group-text__E5rn9","input-group-prepend":"ProfilePostEmptyState_input-group-prepend__DzN37","valid-feedback":"ProfilePostEmptyState_valid-feedback__pxU9K","invalid-feedback":"ProfilePostEmptyState_invalid-feedback__tc1z8","form-text":"ProfilePostEmptyState_form-text__Q7YUR","label":"ProfilePostEmptyState_label__fAr83","custom-control":"ProfilePostEmptyState_custom-control__WNEhE","custom-control-label":"ProfilePostEmptyState_custom-control-label__pBRqf","custom-control-label--empty":"ProfilePostEmptyState_custom-control-label--empty__Telr5","custom-control-input":"ProfilePostEmptyState_custom-control-input__qVQ4o","profile-empty-state":"ProfilePostEmptyState_profile-empty-state__mnS3G","profile-empty-state__icon":"ProfilePostEmptyState_profile-empty-state__icon__xH5o3","profile-empty-state__title":"ProfilePostEmptyState_profile-empty-state__title__VdAcu"};

/***/ }),

/***/ 8446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"ProfilePostSkeleton_sr-only--mobile__YQgyX","sr-only":"ProfilePostSkeleton_sr-only__euSdR","error-message":"ProfilePostSkeleton_error-message__Ts1mX","form-inline-edit":"ProfilePostSkeleton_form-inline-edit__QPItA","form-group":"ProfilePostSkeleton_form-group__txaqc","form-row":"ProfilePostSkeleton_form-row___0wcA","form-inline":"ProfilePostSkeleton_form-inline__zQyPf","error":"ProfilePostSkeleton_error__mzaqA","input-group-append":"ProfilePostSkeleton_input-group-append__9przU","input-group-currency":"ProfilePostSkeleton_input-group-currency__aCdcj","form-control":"ProfilePostSkeleton_form-control__OjySR","custom-select":"ProfilePostSkeleton_custom-select__1HeUD","is-invalid":"ProfilePostSkeleton_is-invalid__yymgn","is-valid":"ProfilePostSkeleton_is-valid__k5MIO","input-group":"ProfilePostSkeleton_input-group__zZ57x","input-group-text":"ProfilePostSkeleton_input-group-text__NGoIG","input-group-prepend":"ProfilePostSkeleton_input-group-prepend__MOIu_","valid-feedback":"ProfilePostSkeleton_valid-feedback__5wfOo","invalid-feedback":"ProfilePostSkeleton_invalid-feedback__EC51S","form-text":"ProfilePostSkeleton_form-text__C2zY8","label":"ProfilePostSkeleton_label__51Q27","custom-control":"ProfilePostSkeleton_custom-control__M5Nz9","custom-control-label":"ProfilePostSkeleton_custom-control-label__vr4zi","custom-control-label--empty":"ProfilePostSkeleton_custom-control-label--empty__9S8gA","custom-control-input":"ProfilePostSkeleton_custom-control-input__zocwW","profile-post-skeleton":"ProfilePostSkeleton_profile-post-skeleton__OgAN5","profile-post-skeleton__body":"ProfilePostSkeleton_profile-post-skeleton__body__c0wd_","profile-post-skeleton__avatar":"ProfilePostSkeleton_profile-post-skeleton__avatar__bgMzz"};

/***/ }),

/***/ 21540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"SpaceDetailsCard_sr-only--mobile___ER62","sr-only":"SpaceDetailsCard_sr-only__qeg5W","error-message":"SpaceDetailsCard_error-message__6Df7U","form-inline-edit":"SpaceDetailsCard_form-inline-edit__X_W7X","form-group":"SpaceDetailsCard_form-group__RdjY8","form-row":"SpaceDetailsCard_form-row__82yXq","form-inline":"SpaceDetailsCard_form-inline__4RHZr","error":"SpaceDetailsCard_error__KgZG8","input-group-append":"SpaceDetailsCard_input-group-append__gOcb8","input-group-currency":"SpaceDetailsCard_input-group-currency__FxE36","form-control":"SpaceDetailsCard_form-control__Qai2y","custom-select":"SpaceDetailsCard_custom-select__UEiy3","is-invalid":"SpaceDetailsCard_is-invalid__ZWsWZ","is-valid":"SpaceDetailsCard_is-valid__J_tnR","input-group":"SpaceDetailsCard_input-group__ZK6gK","input-group-text":"SpaceDetailsCard_input-group-text__5o33o","input-group-prepend":"SpaceDetailsCard_input-group-prepend__SQerO","valid-feedback":"SpaceDetailsCard_valid-feedback__8H7XY","invalid-feedback":"SpaceDetailsCard_invalid-feedback__Bw7vd","form-text":"SpaceDetailsCard_form-text__2FCcF","label":"SpaceDetailsCard_label__l9Oua","custom-control":"SpaceDetailsCard_custom-control__nQfVM","custom-control-label":"SpaceDetailsCard_custom-control-label__xlsD3","custom-control-label--empty":"SpaceDetailsCard_custom-control-label--empty__rl8N_","custom-control-input":"SpaceDetailsCard_custom-control-input__0O9AS","mx-3":"SpaceDetailsCard_mx-3__c7n0V","mb-1":"SpaceDetailsCard_mb-1__tkFuQ","mb-2":"SpaceDetailsCard_mb-2__8txVF","mb-3":"SpaceDetailsCard_mb-3__B7qc2","mb-4":"SpaceDetailsCard_mb-4__hTFeV","mb-5":"SpaceDetailsCard_mb-5__oOON7","mt-2":"SpaceDetailsCard_mt-2__7yC34","ml-1":"SpaceDetailsCard_ml-1__psfiF","p-2":"SpaceDetailsCard_p-2__TO5Y_","p-3":"SpaceDetailsCard_p-3__tJ46Z","border-box":"SpaceDetailsCard_border-box__cDgB2","d-inline-block":"SpaceDetailsCard_d-inline-block__k7sfg","space-details__container":"SpaceDetailsCard_space-details__container__gZVDZ","desktop-navigation":"SpaceDetailsCard_desktop-navigation__Ld5z7","space-details__title":"SpaceDetailsCard_space-details__title___ell_","space-details__wrapper":"SpaceDetailsCard_space-details__wrapper__UFHcr","space-details__image":"SpaceDetailsCard_space-details__image__2TFmp","space-details__header":"SpaceDetailsCard_space-details__header__g6OxB","space-details__icon--inherit":"SpaceDetailsCard_space-details__icon--inherit__0_BmM","space-details__body":"SpaceDetailsCard_space-details__body__AZueR","space-details__description":"SpaceDetailsCard_space-details__description__pgHpo","space-details__footer":"SpaceDetailsCard_space-details__footer__c0WSq"};

/***/ }),

/***/ 76259:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"SpaceDetailsSkeleton_sr-only--mobile__9Z_Uu","sr-only":"SpaceDetailsSkeleton_sr-only__ZU8po","error-message":"SpaceDetailsSkeleton_error-message__9d_cN","form-inline-edit":"SpaceDetailsSkeleton_form-inline-edit__Wfioj","form-group":"SpaceDetailsSkeleton_form-group__xAoqn","form-row":"SpaceDetailsSkeleton_form-row__DC2yR","form-inline":"SpaceDetailsSkeleton_form-inline__5F8YE","error":"SpaceDetailsSkeleton_error__xmVbp","input-group-append":"SpaceDetailsSkeleton_input-group-append__c_WUS","input-group-currency":"SpaceDetailsSkeleton_input-group-currency__IvdzA","form-control":"SpaceDetailsSkeleton_form-control__nrMNy","custom-select":"SpaceDetailsSkeleton_custom-select__y9aId","is-invalid":"SpaceDetailsSkeleton_is-invalid__5wndE","is-valid":"SpaceDetailsSkeleton_is-valid__Pusdr","input-group":"SpaceDetailsSkeleton_input-group__pyjjd","input-group-text":"SpaceDetailsSkeleton_input-group-text__UKHz1","input-group-prepend":"SpaceDetailsSkeleton_input-group-prepend__jG_zW","valid-feedback":"SpaceDetailsSkeleton_valid-feedback__b0ctB","invalid-feedback":"SpaceDetailsSkeleton_invalid-feedback__POtqe","form-text":"SpaceDetailsSkeleton_form-text__uPLto","label":"SpaceDetailsSkeleton_label__mcFLi","custom-control":"SpaceDetailsSkeleton_custom-control__ACUh1","custom-control-label":"SpaceDetailsSkeleton_custom-control-label__2_ybi","custom-control-label--empty":"SpaceDetailsSkeleton_custom-control-label--empty__PWCZB","custom-control-input":"SpaceDetailsSkeleton_custom-control-input__g5hSD","space-details-skeleton__container":"SpaceDetailsSkeleton_space-details-skeleton__container__9fzHH","space-details-skeleton__body":"SpaceDetailsSkeleton_space-details-skeleton__body__b0tnT","space-details-skeleton__description":"SpaceDetailsSkeleton_space-details-skeleton__description__CREg6"};

/***/ }),

/***/ 18926:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"TopBar_sr-only--mobile__mjLdz","sr-only":"TopBar_sr-only___2Ni_","error-message":"TopBar_error-message__TgqPa","form-inline-edit":"TopBar_form-inline-edit__79boA","form-group":"TopBar_form-group__Cbw7m","form-row":"TopBar_form-row__NCDDK","form-inline":"TopBar_form-inline__5T_Y_","error":"TopBar_error__cXgcB","input-group-append":"TopBar_input-group-append__SlFFW","input-group-currency":"TopBar_input-group-currency__jUZTw","form-control":"TopBar_form-control___tD_K","custom-select":"TopBar_custom-select__mLEAr","is-invalid":"TopBar_is-invalid__XyTG6","is-valid":"TopBar_is-valid__qt_Pg","input-group":"TopBar_input-group__ypdWz","input-group-text":"TopBar_input-group-text__pY0AC","input-group-prepend":"TopBar_input-group-prepend__AJh9l","valid-feedback":"TopBar_valid-feedback__Iah_1","invalid-feedback":"TopBar_invalid-feedback__wyzUc","form-text":"TopBar_form-text__C1Xcc","label":"TopBar_label__DjZOs","custom-control":"TopBar_custom-control__GCpTQ","custom-control-label":"TopBar_custom-control-label__fJlWV","custom-control-label--empty":"TopBar_custom-control-label--empty__6AdV1","custom-control-input":"TopBar_custom-control-input__3bRQp","top-bar":"TopBar_top-bar__nWyL_","top-bar--dark-text":"TopBar_top-bar--dark-text__f3ixT","top-bar__title":"TopBar_top-bar__title__UFzG3","top-bar-dashboard__title":"TopBar_top-bar-dashboard__title___m1oE","top-bar__link":"TopBar_top-bar__link__5fO7C","top-bar__container":"TopBar_top-bar__container__o2Qim","top-bar__right-container":"TopBar_top-bar__right-container__BRdjK","top-bar__link-container":"TopBar_top-bar__link-container__cbrxk","top-bar__link-dashboard":"TopBar_top-bar__link-dashboard__H6Ire","top-bar__link-visible":"TopBar_top-bar__link-visible__Luoc2","top-bar__link-title":"TopBar_top-bar__link-title__rkEk_","top-bar__dropdown":"TopBar_top-bar__dropdown__iMONb","top-bar__button-hover":"TopBar_top-bar__button-hover__OYHtB","button--knockout-danger":"TopBar_button--knockout-danger__SPEEv","top-bar__button-hover-danger":"TopBar_top-bar__button-hover-danger__09ClO"};

/***/ }),

/***/ 36701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"user-avatar__container":"UserAvatar_user-avatar__container__GtdQf"};

/***/ }),

/***/ 88826:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Button_sr-only--mobile__Me18I","sr-only":"Button_sr-only__8CaF9","error-message":"Button_error-message__CjxH0","form-inline-edit":"Button_form-inline-edit__ibOSG","form-group":"Button_form-group__Bw644","form-row":"Button_form-row__tPBem","form-inline":"Button_form-inline__5vrR2","error":"Button_error__brNGh","input-group-append":"Button_input-group-append__rmbkZ","input-group-currency":"Button_input-group-currency__cw7NL","form-control":"Button_form-control__9TTZM","custom-select":"Button_custom-select__tCW7P","is-invalid":"Button_is-invalid__GMdnq","is-valid":"Button_is-valid__DetIK","input-group":"Button_input-group__ujZF1","input-group-text":"Button_input-group-text__SosM9","input-group-prepend":"Button_input-group-prepend__XRbL2","valid-feedback":"Button_valid-feedback__RGfRw","invalid-feedback":"Button_invalid-feedback__c27pJ","form-text":"Button_form-text__Peigb","label":"Button_label__3LheN","custom-control":"Button_custom-control__YuHtq","custom-control-label":"Button_custom-control-label__o9HUb","custom-control-label--empty":"Button_custom-control-label--empty__8oT3Q","custom-control-input":"Button_custom-control-input__k2Bxp","button":"Button_button__j7fHx","button--link":"Button_button--link__8ov_D","button--default":"Button_button--default__FhEbs","button--default-danger":"Button_button--default-danger__GO9vZ","button--knockout":"Button_button--knockout__xKLNK","button--knockout-danger":"Button_button--knockout-danger__gwTMv","button--ghost":"Button_button--ghost__CbrIU","button--ghost-danger":"Button_button--ghost-danger__7U_My","button--block":"Button_button--block__ZSL1H","button--icon-left":"Button_button--icon-left__f_6Gt","button--icon-right":"Button_button--icon-right__fH_UG","button--icon-only":"Button_button--icon-only__jNcLQ","button--x-small":"Button_button--x-small__Ldsmk","button--small":"Button_button--small__B0_oj","button--dark-text":"Button_button--dark-text__XIEx3","spinner__container":"Button_spinner__container__R_Yi_","content__wrapper":"Button_content__wrapper__Bvwxc","content__container":"Button_content__container__Fg4_s"};

/***/ }),

/***/ 19115:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"CircularSpinner_sr-only--mobile__eKEXy","sr-only":"CircularSpinner_sr-only__wjJp6","error-message":"CircularSpinner_error-message__Oq834","form-inline-edit":"CircularSpinner_form-inline-edit__DDoIR","form-group":"CircularSpinner_form-group__Trgcz","form-row":"CircularSpinner_form-row__lYna4","form-inline":"CircularSpinner_form-inline__jfcO6","error":"CircularSpinner_error__raf51","input-group-append":"CircularSpinner_input-group-append__SypWn","input-group-currency":"CircularSpinner_input-group-currency__f_kKb","form-control":"CircularSpinner_form-control__VNs0o","custom-select":"CircularSpinner_custom-select__eGEJY","is-invalid":"CircularSpinner_is-invalid__BJ7ke","is-valid":"CircularSpinner_is-valid__hJPpq","input-group":"CircularSpinner_input-group__v0Wk1","input-group-text":"CircularSpinner_input-group-text__desGW","input-group-prepend":"CircularSpinner_input-group-prepend__1LsXm","valid-feedback":"CircularSpinner_valid-feedback__XjZmP","invalid-feedback":"CircularSpinner_invalid-feedback__5hqjj","form-text":"CircularSpinner_form-text__DXoMS","label":"CircularSpinner_label__2PkwI","custom-control":"CircularSpinner_custom-control__0W_lr","custom-control-label":"CircularSpinner_custom-control-label__1B7u0","custom-control-label--empty":"CircularSpinner_custom-control-label--empty__mhl7b","custom-control-input":"CircularSpinner_custom-control-input__JgGBv","spinner":"CircularSpinner_spinner__2_i54","anim-spinner":"CircularSpinner_anim-spinner__Q7tU5","circle":"CircularSpinner_circle___Xv4Y","circle-inner":"CircularSpinner_circle-inner__1_fuy","anim-circle-1":"CircularSpinner_anim-circle-1___Wogb","circle-2":"CircularSpinner_circle-2__KSpo1","anim-circle-2":"CircularSpinner_anim-circle-2__4rd5E","spinner--default":"CircularSpinner_spinner--default__kUGXM","spinner--small":"CircularSpinner_spinner--small__nQHU4","spinner--medium":"CircularSpinner_spinner--medium__M933f","spinner--large":"CircularSpinner_spinner--large__tedJb","spinner--xlarge":"CircularSpinner_spinner--xlarge__PslFM"};

/***/ }),

/***/ 70639:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Dropdown_sr-only--mobile__IEW9a","sr-only":"Dropdown_sr-only__VAUCs","error-message":"Dropdown_error-message__DpnrI","form-inline-edit":"Dropdown_form-inline-edit__VeabZ","form-group":"Dropdown_form-group__hQKNc","form-row":"Dropdown_form-row__pfqOx","form-inline":"Dropdown_form-inline__bXfHh","error":"Dropdown_error__rPiAj","input-group-append":"Dropdown_input-group-append__wfho_","input-group-currency":"Dropdown_input-group-currency__seaI3","form-control":"Dropdown_form-control__rINA5","custom-select":"Dropdown_custom-select__DWZiz","is-invalid":"Dropdown_is-invalid__ALBat","is-valid":"Dropdown_is-valid__jBHuB","input-group":"Dropdown_input-group__hD4XR","input-group-text":"Dropdown_input-group-text__y_Ksc","input-group-prepend":"Dropdown_input-group-prepend__MwIW7","valid-feedback":"Dropdown_valid-feedback__S7fHB","invalid-feedback":"Dropdown_invalid-feedback__QpuSY","form-text":"Dropdown_form-text__bBhBR","label":"Dropdown_label__TlL5y","custom-control":"Dropdown_custom-control__3CVch","custom-control-label":"Dropdown_custom-control-label__EtAJ7","custom-control-label--empty":"Dropdown_custom-control-label--empty__Dg2Dc","custom-control-input":"Dropdown_custom-control-input__NlzX_","dropdown":"Dropdown_dropdown___h54Y","dropdown__menu":"Dropdown_dropdown__menu__JMvRK","is-hidden":"Dropdown_is-hidden__D7izN","is-visible":"Dropdown_is-visible__BaL4D","dropdown__menu-right":"Dropdown_dropdown__menu-right__HRF3x","dropdown__header":"Dropdown_dropdown__header__OmG8n","dropdown__list":"Dropdown_dropdown__list__KoBpm","dropdown__list-item":"Dropdown_dropdown__list-item___fpvD","dropdown__list-item-header":"Dropdown_dropdown__list-item-header__4Kh53","dropdown__list-item--actions":"Dropdown_dropdown__list-item--actions__InjmI"};

/***/ }),

/***/ 49236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__9iBwa"};

/***/ }),

/***/ 54862:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MobileMenu_sr-only--mobile__MqvxS","sr-only":"MobileMenu_sr-only__z58xZ","error-message":"MobileMenu_error-message__yCQXE","form-inline-edit":"MobileMenu_form-inline-edit__m_MJc","form-group":"MobileMenu_form-group__ic_Fx","form-row":"MobileMenu_form-row__aIXnI","form-inline":"MobileMenu_form-inline__wFVpd","error":"MobileMenu_error__HJCFA","input-group-append":"MobileMenu_input-group-append__MId_D","input-group-currency":"MobileMenu_input-group-currency__1Hu7m","form-control":"MobileMenu_form-control__qBWXo","custom-select":"MobileMenu_custom-select__uuuCZ","is-invalid":"MobileMenu_is-invalid__1g2PX","is-valid":"MobileMenu_is-valid__4pkyr","input-group":"MobileMenu_input-group__3sCfk","input-group-text":"MobileMenu_input-group-text__70NM0","input-group-prepend":"MobileMenu_input-group-prepend__5LJZF","valid-feedback":"MobileMenu_valid-feedback__294gU","invalid-feedback":"MobileMenu_invalid-feedback__qfWkV","form-text":"MobileMenu_form-text__sv8Yc","label":"MobileMenu_label__JT_nw","custom-control":"MobileMenu_custom-control__fmn3l","custom-control-label":"MobileMenu_custom-control-label__7Cg36","custom-control-label--empty":"MobileMenu_custom-control-label--empty__kT7pn","custom-control-input":"MobileMenu_custom-control-input__PycVs","mobile-menu__wrapper":"MobileMenu_mobile-menu__wrapper__WRuTb","mobile-menu__header-title":"MobileMenu_mobile-menu__header-title__M9xyT","mobile-menu__header-title--icon":"MobileMenu_mobile-menu__header-title--icon__xgZnZ","mobile-menu__button":"MobileMenu_mobile-menu__button__YR_Z6","mobile-menu__back-button":"MobileMenu_mobile-menu__back-button__grbyk","mobile-menu__actions":"MobileMenu_mobile-menu__actions__h9R_3","is-menu-open":"MobileMenu_is-menu-open__mWvIY","mobile-menu__button-hover":"MobileMenu_mobile-menu__button-hover__gmfiY","button--knockout-danger":"MobileMenu_button--knockout-danger__tIf5b","mobile-menu__button-hover-danger":"MobileMenu_mobile-menu__button-hover-danger__x4h8O"};

/***/ }),

/***/ 39599:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"MenuTab_sr-only--mobile__pYbDw","sr-only":"MenuTab_sr-only__RY3lx","error-message":"MenuTab_error-message__nHJAF","form-inline-edit":"MenuTab_form-inline-edit__Eu9Os","form-group":"MenuTab_form-group__A9kt3","form-row":"MenuTab_form-row__3YBde","form-inline":"MenuTab_form-inline__nzK_c","error":"MenuTab_error__KtRz1","input-group-append":"MenuTab_input-group-append__irsLz","input-group-currency":"MenuTab_input-group-currency__XgC8P","form-control":"MenuTab_form-control__N27fi","custom-select":"MenuTab_custom-select__10vQK","is-invalid":"MenuTab_is-invalid__sukUH","is-valid":"MenuTab_is-valid__21hjj","input-group":"MenuTab_input-group__5V2tq","input-group-text":"MenuTab_input-group-text__aGc7O","input-group-prepend":"MenuTab_input-group-prepend__8w1vU","valid-feedback":"MenuTab_valid-feedback__62me5","invalid-feedback":"MenuTab_invalid-feedback__1MKCI","form-text":"MenuTab_form-text__9ikqT","label":"MenuTab_label__GViUU","custom-control":"MenuTab_custom-control__a9Kfh","custom-control-label":"MenuTab_custom-control-label__gFVWT","custom-control-label--empty":"MenuTab_custom-control-label--empty__HJdvG","custom-control-input":"MenuTab_custom-control-input__K3k05","menu-tab__overlay":"MenuTab_menu-tab__overlay__kj8Xw","is-menu-open":"MenuTab_is-menu-open__mR8uK","menu-tab__header-title":"MenuTab_menu-tab__header-title__g36aU","menu-tab__container":"MenuTab_menu-tab__container__1Yb0p","small":"MenuTab_small__NBO_5","menu-tab__content":"MenuTab_menu-tab__content__HuE5L","large":"MenuTab_large__Pjyup","slide-to-left":"MenuTab_slide-to-left__P5wOA","no-header":"MenuTab_no-header__51jYt","menu-tab__header":"MenuTab_menu-tab__header__s_aqb","menu-tab__button":"MenuTab_menu-tab__button__TOxWK","menu-tab__actions":"MenuTab_menu-tab__actions__LJZRv"};

/***/ }),

/***/ 64844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Section_sr-only--mobile__cs3k0","sr-only":"Section_sr-only__RtlbU","error-message":"Section_error-message__D5KgJ","form-inline-edit":"Section_form-inline-edit__wDdRl","form-group":"Section_form-group___KM3v","form-row":"Section_form-row__uZFkY","form-inline":"Section_form-inline__Ukhp8","error":"Section_error__rXr7H","input-group-append":"Section_input-group-append__qoaBI","input-group-currency":"Section_input-group-currency__gDF7t","form-control":"Section_form-control__0uyMl","custom-select":"Section_custom-select__cJya1","is-invalid":"Section_is-invalid__kGbt6","is-valid":"Section_is-valid__1roM2","input-group":"Section_input-group__CFD2A","input-group-text":"Section_input-group-text__2afLL","input-group-prepend":"Section_input-group-prepend__WzW8c","valid-feedback":"Section_valid-feedback___qAWm","invalid-feedback":"Section_invalid-feedback__P511Z","form-text":"Section_form-text__TrJgi","label":"Section_label__PEfUd","custom-control":"Section_custom-control__U8yxt","custom-control-label":"Section_custom-control-label__k7CRN","custom-control-label--empty":"Section_custom-control-label--empty__cE8Mo","custom-control-input":"Section_custom-control-input__jiyWs","section--toggle-item":"Section_section--toggle-item__K9EW4","section--toggle-item__wrapper":"Section_section--toggle-item__wrapper__AdbPG","section--toggle-item__toggleable":"Section_section--toggle-item__toggleable__ZR_IA","has-right-accessory":"Section_has-right-accessory__B2vHH","section--toggle-item__toggleable__title":"Section_section--toggle-item__toggleable__title__cIre5","section--toggle-item__actions":"Section_section--toggle-item__actions__Y7pe3","section--toggle-item__caption":"Section_section--toggle-item__caption__HA36E"};

/***/ }),

/***/ 4940:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"SkeletonPost_sr-only--mobile__2pg90","sr-only":"SkeletonPost_sr-only__QeWfi","error-message":"SkeletonPost_error-message__J85ZI","form-inline-edit":"SkeletonPost_form-inline-edit__0Ewr0","form-group":"SkeletonPost_form-group__v_uiU","form-row":"SkeletonPost_form-row__rKsmF","form-inline":"SkeletonPost_form-inline__u0YqV","error":"SkeletonPost_error__EvTR0","input-group-append":"SkeletonPost_input-group-append__FhGG7","input-group-currency":"SkeletonPost_input-group-currency__O11pO","form-control":"SkeletonPost_form-control__9K2Vq","custom-select":"SkeletonPost_custom-select__cihmQ","is-invalid":"SkeletonPost_is-invalid__lvuKu","is-valid":"SkeletonPost_is-valid__F3QWk","input-group":"SkeletonPost_input-group__yXIUc","input-group-text":"SkeletonPost_input-group-text__5wWZj","input-group-prepend":"SkeletonPost_input-group-prepend__K2WyQ","valid-feedback":"SkeletonPost_valid-feedback__QRjvj","invalid-feedback":"SkeletonPost_invalid-feedback__EkgEx","form-text":"SkeletonPost_form-text__sJoHs","label":"SkeletonPost_label__gjhnb","custom-control":"SkeletonPost_custom-control___iJH7","custom-control-label":"SkeletonPost_custom-control-label__zOhdx","custom-control-label--empty":"SkeletonPost_custom-control-label--empty___x4s1","custom-control-input":"SkeletonPost_custom-control-input__yZuoo","skeleton-line":"SkeletonPost_skeleton-line__CYE4g","skeleton-post":"SkeletonPost_skeleton-post__ZqS_I","skeleton-post__details":"SkeletonPost_skeleton-post__details__BdGSa","skeleton-post__avatar":"SkeletonPost_skeleton-post__avatar__wCFQt","skeleton-post__name":"SkeletonPost_skeleton-post__name__muvM0","skeleton-post__container":"SkeletonPost_skeleton-post__container__tkq2B"};

/***/ }),

/***/ 10706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Typography_sr-only--mobile__c8I2o","sr-only":"Typography_sr-only__uIJTI","error-message":"Typography_error-message__LXApF","form-inline-edit":"Typography_form-inline-edit__6Dh4v","form-group":"Typography_form-group__zlI3T","form-row":"Typography_form-row__vIvhw","form-inline":"Typography_form-inline__9nnL2","error":"Typography_error__WBUfy","input-group-append":"Typography_input-group-append__iInZO","input-group-currency":"Typography_input-group-currency__azrMw","form-control":"Typography_form-control__HUyjj","custom-select":"Typography_custom-select__WnPNn","is-invalid":"Typography_is-invalid__XvCuv","is-valid":"Typography_is-valid__pTxeK","input-group":"Typography_input-group__dhpzN","input-group-text":"Typography_input-group-text__mi5hZ","input-group-prepend":"Typography_input-group-prepend__hhaKC","valid-feedback":"Typography_valid-feedback__y66WI","invalid-feedback":"Typography_invalid-feedback__fCBjU","form-text":"Typography_form-text__5VhZq","label":"Typography_label__3GfEf","custom-control":"Typography_custom-control__4_BqI","custom-control-label":"Typography_custom-control-label__3_5NR","custom-control-label--empty":"Typography_custom-control-label--empty__Ikfji","custom-control-input":"Typography_custom-control-input__NeRJI","h1":"Typography_h1__DC7wb","h2":"Typography_h2__bq9pJ","h3":"Typography_h3__Ewtim","h4":"Typography_h4__K_IwJ","p":"Typography_p__PUJif","caption":"Typography_caption__WLdns"};

/***/ }),

/***/ 90110:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 1798:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
 * License: MIT - http://mrgnrdrck.mit-license.org
 *
 * https://github.com/mroderick/PubSubJS
 */

(function (root, factory){
    'use strict';

    var PubSub = {};

    if (root.PubSub) {
        PubSub = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
    } else {
        root.PubSub = PubSub;
        factory(PubSub);
    }
    // CommonJS and Node.js module support
    if (true){
        if (module !== undefined && module.exports) {
            exports = module.exports = PubSub; // Node.js specific `module.exports`
        }
        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
        module.exports = exports = PubSub; // CommonJS
    }
    // AMD support
    /* eslint-disable no-undef */
    else {}

}(( typeof window === 'object' && window ) || this, function (PubSub){
    'use strict';

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj){
        var key;

        for (key in obj){
            if ( Object.prototype.hasOwnProperty.call(obj, key) ){
                return true;
            }
        }
        return false;
    }

    /**
     * Returns a function that throws the passed exception, for use as argument for setTimeout
     * @alias throwException
     * @function
     * @param { Object } ex An Error object
     */
    function throwException( ex ){
        return function reThrowException(){
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
        try {
            subscriber( message, data );
        } catch( ex ){
            setTimeout( throwException( ex ), 0);
        }
    }

    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
        subscriber( message, data );
    }

    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if ( !Object.prototype.hasOwnProperty.call( messages, matchedMessage ) ) {
            return;
        }

        for (s in subscribers){
            if ( Object.prototype.hasOwnProperty.call(subscribers, s)){
                callSubscriber( subscribers[s], originalMessage, data );
            }
        }
    }

    function createDeliveryFunction( message, data, immediateExceptions ){
        return function deliverNamespaced(){
            var topic = String( message ),
                position = topic.lastIndexOf( '.' );

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while( position !== -1 ){
                topic = topic.substr( 0, position );
                position = topic.lastIndexOf('.');
                deliverMessage( message, topic, data, immediateExceptions );
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor( message ) {
        var topic = String( message ),
            found = Boolean(Object.prototype.hasOwnProperty.call( messages, topic ) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers( message ){
        var topic = String( message ),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf( '.' );

        while ( !found && position !== -1 ){
            topic = topic.substr( 0, position );
            position = topic.lastIndexOf( '.' );
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish( message, data, sync, immediateExceptions ){
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
            hasSubscribers = messageHasSubscribers( message );

        if ( !hasSubscribers ){
            return false;
        }

        if ( sync === true ){
            deliver();
        } else {
            setTimeout( deliver, 0 );
        }
        return true;
    }

    /**
     * Publishes the message, passing the data to it's subscribers
     * @function
     * @alias publish
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publish = function( message, data ){
        return publish( message, data, false, PubSub.immediateExceptions );
    };

    /**
     * Publishes the message synchronously, passing the data to it's subscribers
     * @function
     * @alias publishSync
     * @param { String } message The message to publish
     * @param {} data The data to pass to subscribers
     * @return { Boolean }
     */
    PubSub.publishSync = function( message, data ){
        return publish( message, data, true, PubSub.immediateExceptions );
    };

    /**
     * Subscribes the passed function to the passed message. Every returned token is unique and should be stored if you need to unsubscribe
     * @function
     * @alias subscribe
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { String }
     */
    PubSub.subscribe = function( message, func ){
        if ( typeof func !== 'function'){
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        // message is not registered yet
        if ( !Object.prototype.hasOwnProperty.call( messages, message ) ){
            messages[message] = {};
        }

        // forcing token as String, to allow for future expansions without breaking usage
        // and allow for easy use as key names for the 'messages' object
        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;

        // return token for unsubscribing
        return token;
    };

    PubSub.subscribeAll = function( func ){
        return PubSub.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    /**
     * Subscribes the passed function to the passed message once
     * @function
     * @alias subscribeOnce
     * @param { String } message The message to subscribe to
     * @param { Function } func The function to call when a new message is published
     * @return { PubSub }
     */
    PubSub.subscribeOnce = function( message, func ){
        var token = PubSub.subscribe( message, function(){
            // before func apply, unsubscribe message
            PubSub.unsubscribe( token );
            func.apply( this, arguments );
        });
        return PubSub;
    };

    /**
     * Clears all subscriptions
     * @function
     * @public
     * @alias clearAllSubscriptions
     */
    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
        messages = {};
    };

    /**
     * Clear subscriptions by the topic
     * @function
     * @public
     * @alias clearAllSubscriptions
     * @return { int }
     */
    PubSub.clearSubscriptions = function clearSubscriptions(topic){
        var m;
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                delete messages[m];
            }
        }
    };

    /**
       Count subscriptions by the topic
     * @function
     * @public
     * @alias countSubscriptions
     * @return { Array }
    */
    PubSub.countSubscriptions = function countSubscriptions(topic){
        var m;
        // eslint-disable-next-line no-unused-vars
        var token;
        var count = 0;
        for (m in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
                for (token in messages[m]) {
                    count++;
                }
                break;
            }
        }
        return count;
    };


    /**
       Gets subscriptions by the topic
     * @function
     * @public
     * @alias getSubscriptions
    */
    PubSub.getSubscriptions = function getSubscriptions(topic){
        var m;
        var list = [];
        for (m in messages){
            if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0){
                list.push(m);
            }
        }
        return list;
    };

    /**
     * Removes subscriptions
     *
     * - When passed a token, removes a specific subscription.
     *
	 * - When passed a function, removes all subscriptions for that function
     *
	 * - When passed a topic, removes all subscriptions for that topic (hierarchy)
     * @function
     * @public
     * @alias subscribeOnce
     * @param { String | Function } value A token, function or topic to unsubscribe from
     * @example // Unsubscribing with a token
     * var token = PubSub.subscribe('mytopic', myFunc);
     * PubSub.unsubscribe(token);
     * @example // Unsubscribing with a function
     * PubSub.unsubscribe(myFunc);
     * @example // Unsubscribing from a topic
     * PubSub.unsubscribe('mytopic');
     */
    PubSub.unsubscribe = function(value){
        var descendantTopicExists = function(topic) {
                var m;
                for ( m in messages ){
                    if ( Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0 ){
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic    = typeof value === 'string' && ( Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value) ),
            isToken    = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic){
            PubSub.clearSubscriptions(value);
            return;
        }

        for ( m in messages ){
            if ( Object.prototype.hasOwnProperty.call( messages, m ) ){
                message = messages[m];

                if ( isToken && message[value] ){
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for ( t in message ){
                        if (Object.prototype.hasOwnProperty.call(message, t) && message[t] === value){
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };
}));


/***/ }),

/***/ 17563:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

const strictUriEncode = __webpack_require__(70610);
const decodeComponent = __webpack_require__(44020);
const splitOnFirst = __webpack_require__(80500);
const filterObject = __webpack_require__(92806);

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ 49559:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
} // See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en


function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}

var redacted = "REDACTED (Potential Email Address)";

function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }

  return string;
}

function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _str = s || "";

  if (titleCase) {
    _str = toTitleCase(s);
  }

  if (redactingEmail) {
    _str = redactEmail(_str);
  }

  return _str;
}

/***/ }),

/***/ 41638:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.GA4 = void 0;

var _gtag = _interopRequireDefault(__webpack_require__(76161));

var _format = _interopRequireDefault(__webpack_require__(49559));

var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
    _excluded2 = ["title", "location"],
    _excluded3 = ["page", "hitType"],
    _excluded4 = ["action", "category", "label", "value", "nonInteraction", "transport"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/

/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */

/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */

/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;

    _classCallCheck(this, GA4);

    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });

    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });

    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }

      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "https://www.googletagmanager.com/gtag/js?id=".concat(GA_MEASUREMENT_ID);

        if (nonce) {
          script.setAttribute("nonce", nonce);
        }

        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];

        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };

        _this._hasLoadedGA = true;
      }
    });

    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }

      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }

        return prev;
      }, {});
      return gtagOptions;
    });

    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }

      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
          gtagOptions = options.gtagOptions,
          _options$legacyDimens = options.legacyDimensionMetric,
          legacyDimensionMetric = _options$legacyDimens === void 0 ? true : _options$legacyDimens,
          nonce = options.nonce,
          _options$testMode = options.testMode,
          testMode = _options$testMode === void 0 ? false : _options$testMode;
      _this._testMode = testMode;

      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce);
      }

      if (!_this.isInitialized) {
        _this._gtag("js", new Date());

        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _this._appendCustomMap(_objectSpread(_objectSpread(_objectSpread({
            // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#disable_pageview_measurement
            send_page_view: false
          }, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions), legacyDimensionMetric);

          _this._gtag("config", config.trackingId, mergedGtagOptions);
        });
      }

      _this.isInitialized = true;

      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);

        _this._queueGtag = [];
        _this._isQueuing = false;

        while (queues.length) {
          var queue = queues.shift();

          _this._gtag.apply(_this, _toConsumableArray(queue));

          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });

    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }

      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }

      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }

      _this._gaCommand("set", fieldsObject);
    });

    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });

    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
            eventCategory = _args$.eventCategory,
            eventAction = _args$.eventAction,
            eventLabel = _args$.eventLabel,
            eventValue = _args$.eventValue,
            hitType = _args$.hitType,
            rest = _objectWithoutProperties(_args$, _excluded);

        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });

    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });

    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
            title = _this$_toGtagOptions.title,
            location = _this$_toGtagOptions.location,
            rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);

        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });

    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
            page = _args$2.page,
            hitType = _args$2.hitType,
            rest = _objectWithoutProperties(_args$2, _excluded3);

        _this._gaCommandSendPageview(page, rest);
      }
    });

    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;

      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);

          break;

        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);

          break;

        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));

          break;

        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;

        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });

    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }

      _this._gtag("set", _this._toGtagOptions(args[0]));
    });

    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);

          break;

        case "set":
          _this._gaCommandSet.apply(_this, args);

          break;

        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });

    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];

        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });

          while (queues.length) {
            var queue = queues.shift();

            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });

        _this._isQueuing = true;
      }

      return _this.ga;
    });

    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
            category = optionsOrName.category,
            label = optionsOrName.label,
            value = optionsOrName.value,
            nonInteraction = optionsOrName.nonInteraction,
            transport = optionsOrName.transport,
            rest = _objectWithoutProperties(optionsOrName, _excluded4);

        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        } // Required Fields


        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        }; // Optional Fields

        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }

        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }

        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }

        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }

            fieldObject.transport = transport;
          }
        }

        Object.keys(rest).filter(function (key) {
          return key.substr(0, "dimension".length) === "dimension";
        }).forEach(function (key) {
          fieldObject[key] = rest[key];
        });
        Object.keys(rest).filter(function (key) {
          return key.substr(0, "metric".length) === "metric";
        }).forEach(function (key) {
          fieldObject[key] = rest[key];
        });

        _this._gaCommand("send", fieldObject);
      }
    });

    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });

    _defineProperty(this, "pageview", function (path, _, title) {
      var pathTrim = path === null || path === void 0 ? void 0 : path.trim();

      if (pathTrim === "") {
        console.warn("path cannot be an empty string in .pageview()");
        return;
      }

      _this._gaCommand("send", "pageview", pathTrim, {
        title: title
      });
    });

    this.reset();
  }

  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }, {
    key: "_appendCustomMap",
    value: function _appendCustomMap(options) {
      var legacyDimensionMetric = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!legacyDimensionMetric) {
        return options;
      }

      if (!options.custom_map) {
        options.custom_map = {};
      }

      for (var i = 1; i <= 200; i++) {
        if (!options.custom_map["dimension".concat(i)]) {
          options.custom_map["dimension".concat(i)] = "dimension".concat(i);
        }

        if (!options.custom_map["metric".concat(i)]) {
          options.custom_map["metric".concat(i)] = "metric".concat(i);
        }
      }

      return options;
    }
    /**
     * @since v1.0.2
     * @param {string} [path="location.href"]
     * @param {string[]} [_] unsupported
     * @param {string} [title="location.pathname"]
     * @deprecated Use `.send("pageview")` instead
     */

  }, {
    key: "outboundLink",
    value:
    /**
     * @since v1.0.6
     * @param {Object} options
     * @param {string} options.label
     * @param {function} hitCallback
     * @deprecated Use `enhanced measurement` feature in Google Analytics.
     */
    function outboundLink(_ref3, hitCallback) {
      var label = _ref3.label;

      if (typeof hitCallback !== "function") {
        console.warn("hitCallback function is required");
        return;
      }

      if (!label) {
        console.warn("args.label is required in outboundLink()");
        return;
      } // Required Fields


      var fieldObject = {
        hitType: "event",
        eventCategory: "Outbound",
        eventAction: "Click",
        eventLabel: (0, _format["default"])(label)
      };
      var safetyCallbackCalled = false;

      var safetyCallback = function safetyCallback() {
        // This prevents a delayed response from GA
        // causing hitCallback from being fired twice
        safetyCallbackCalled = true;
        hitCallback();
      }; // Using a timeout to ensure the execution of critical application code
      // in the case when the GA server might be down
      // or an ad blocker prevents sending the data
      // register safety net timeout:


      var t = setTimeout(safetyCallback, 250);

      var clearableCallbackForGA = function clearableCallbackForGA() {
        clearTimeout(t);

        if (!safetyCallbackCalled) {
          hitCallback();
        }
      };

      fieldObject.hitCallback = clearableCallbackForGA;

      this._gaCommand("send", fieldObject);
    }
  }]);

  return GA4;
}();

exports.GA4 = GA4;

var _default = new GA4();

exports["default"] = _default;

/***/ }),

/***/ 76161:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (typeof window !== "undefined") {
    var _window;

    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];

      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }

    (_window = window).gtag.apply(_window, args);
  }
};

var _default = gtag;
exports["default"] = _default;

/***/ }),

/***/ 49089:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

__webpack_unused_export__ = ({
  value: true
});
exports.ZP = __webpack_unused_export__ = void 0;

var _ga = _interopRequireWildcard(__webpack_require__(41638));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ReactGAImplementation = _ga.GA4;
__webpack_unused_export__ = ReactGAImplementation;
var _default = _ga["default"];
exports.ZP = _default;

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 96774:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 86851:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isArrayish = __webpack_require__(89594);

var concat = Array.prototype.concat;
var slice = Array.prototype.slice;

var swizzle = module.exports = function swizzle(args) {
	var results = [];

	for (var i = 0, len = args.length; i < len; i++) {
		var arg = args[i];

		if (isArrayish(arg)) {
			// http://jsperf.com/javascript-array-concat-vs-push/98
			results = concat.call(results, slice.call(arg));
		} else {
			results.push(arg);
		}
	}

	return results;
};

swizzle.wrap = function (fn) {
	return function () {
		return fn(swizzle(arguments));
	};
};


/***/ }),

/***/ 89594:
/***/ (function(module) {

module.exports = function isArrayish(obj) {
	if (!obj || typeof obj === 'string') {
		return false;
	}

	return obj instanceof Array || Array.isArray(obj) ||
		(obj.length >= 0 && (obj.splice instanceof Function ||
			(Object.getOwnPropertyDescriptor(obj, (obj.length - 1)) && obj.constructor.name !== 'String')));
};


/***/ }),

/***/ 80500:
/***/ (function(module) {

"use strict";


module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ 59829:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
    'use strict';
    // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

    /* istanbul ignore next */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
}(this, function() {
    'use strict';
    function _isNumber(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
        return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
        return function() {
            return this[p];
        };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var objectProps = ['evalOrigin'];

    var props = booleanProps.concat(numericProps, stringProps, arrayProps, objectProps);

    function StackFrame(obj) {
        if (!obj) return;
        for (var i = 0; i < props.length; i++) {
            if (obj[props[i]] !== undefined) {
                this['set' + _capitalize(props[i])](obj[props[i]]);
            }
        }
    }

    StackFrame.prototype = {
        getArgs: function() {
            return this.args;
        },
        setArgs: function(v) {
            if (Object.prototype.toString.call(v) !== '[object Array]') {
                throw new TypeError('Args must be an Array');
            }
            this.args = v;
        },

        getEvalOrigin: function() {
            return this.evalOrigin;
        },
        setEvalOrigin: function(v) {
            if (v instanceof StackFrame) {
                this.evalOrigin = v;
            } else if (v instanceof Object) {
                this.evalOrigin = new StackFrame(v);
            } else {
                throw new TypeError('Eval Origin must be an Object or StackFrame');
            }
        },

        toString: function() {
            var fileName = this.getFileName() || '';
            var lineNumber = this.getLineNumber() || '';
            var columnNumber = this.getColumnNumber() || '';
            var functionName = this.getFunctionName() || '';
            if (this.getIsEval()) {
                if (fileName) {
                    return '[eval] (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
                }
                return '[eval]:' + lineNumber + ':' + columnNumber;
            }
            if (functionName) {
                return functionName + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';
            }
            return fileName + ':' + lineNumber + ':' + columnNumber;
        }
    };

    StackFrame.fromString = function StackFrame$$fromString(str) {
        var argsStartIndex = str.indexOf('(');
        var argsEndIndex = str.lastIndexOf(')');

        var functionName = str.substring(0, argsStartIndex);
        var args = str.substring(argsStartIndex + 1, argsEndIndex).split(',');
        var locationString = str.substring(argsEndIndex + 1);

        if (locationString.indexOf('@') === 0) {
            var parts = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(locationString, '');
            var fileName = parts[1];
            var lineNumber = parts[2];
            var columnNumber = parts[3];
        }

        return new StackFrame({
            functionName: functionName,
            args: args || undefined,
            fileName: fileName,
            lineNumber: lineNumber || undefined,
            columnNumber: columnNumber || undefined
        });
    };

    for (var i = 0; i < booleanProps.length; i++) {
        StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
        StackFrame.prototype['set' + _capitalize(booleanProps[i])] = (function(p) {
            return function(v) {
                this[p] = Boolean(v);
            };
        })(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
        StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
        StackFrame.prototype['set' + _capitalize(numericProps[j])] = (function(p) {
            return function(v) {
                if (!_isNumber(v)) {
                    throw new TypeError(p + ' must be a Number');
                }
                this[p] = Number(v);
            };
        })(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
        StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
        StackFrame.prototype['set' + _capitalize(stringProps[k])] = (function(p) {
            return function(v) {
                this[p] = String(v);
            };
        })(stringProps[k]);
    }

    return StackFrame;
}));


/***/ }),

/***/ 70610:
/***/ (function(module) {

"use strict";

module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ 19521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, __PRIVATE__, createGlobalStyle, isStyledComponent, keyframes, useTheme, version, withTheme

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(96774);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ./node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(34155);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=s(Me),n=i((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?r.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=s(Me),d=c(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),l((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,r.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=r.forwardRef((function(t,n){var o=s(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,r.createElement(e,y({},t,{theme:a,ref:n}))}));return m(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return s(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 14378:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

//
// TDigest:
//
// approximate distribution percentiles from a stream of reals
//
var RBTree = (__webpack_require__(77424).RBTree);

function TDigest(delta, K, CX) {
    // allocate a TDigest structure.
    //
    // delta is the compression factor, the max fraction of mass that
    // can be owned by one centroid (bigger, up to 1.0, means more
    // compression). delta=false switches off TDigest behavior and treats
    // the distribution as discrete, with no merging and exact values
    // reported.
    //
    // K is a size threshold that triggers recompression as the TDigest
    // grows during input.  (Set it to 0 to disable automatic recompression)
    //
    // CX specifies how often to update cached cumulative totals used
    // for quantile estimation during ingest (see cumulate()).  Set to
    // 0 to use exact quantiles for each new point.
    //
    this.discrete = (delta === false);
    this.delta = delta || 0.01;
    this.K = (K === undefined) ? 25 : K;
    this.CX = (CX === undefined) ? 1.1 : CX;
    this.centroids = new RBTree(compare_centroid_means);
    this.nreset = 0;
    this.reset();
}

TDigest.prototype.reset = function() {
    // prepare to digest new points.
    //
    this.centroids.clear();
    this.n = 0;
    this.nreset += 1;
    this.last_cumulate = 0;
};

TDigest.prototype.size = function() {
    return this.centroids.size;
};

TDigest.prototype.toArray = function(everything) {
    // return {mean,n} of centroids as an array ordered by mean.
    //
    var result = [];
    if (everything) {
        this._cumulate(true); // be sure cumns are exact
        this.centroids.each(function(c) { result.push(c); });
    } else {
        this.centroids.each(function(c) { result.push({mean:c.mean, n:c.n}); });
    }
    return result;
};

TDigest.prototype.summary = function() {
    var approx = (this.discrete) ? "exact " : "approximating ";
    var s = [approx + this.n + " samples using " + this.size() + " centroids",
             "min = "+this.percentile(0),
             "Q1  = "+this.percentile(0.25),
             "Q2  = "+this.percentile(0.5),
             "Q3  = "+this.percentile(0.75),
             "max = "+this.percentile(1.0)];
    return s.join('\n');
};

function compare_centroid_means(a, b) {
    // order two centroids by mean.
    //
    return (a.mean > b.mean) ? 1 : (a.mean < b.mean) ? -1 : 0;
}

function compare_centroid_mean_cumns(a, b) {
    // order two centroids by mean_cumn.
    //
    return (a.mean_cumn - b.mean_cumn);
}

TDigest.prototype.push = function(x, n) {
    // incorporate value or array of values x, having count n into the
    // TDigest. n defaults to 1.
    //
    n = n || 1;
    x = Array.isArray(x) ? x : [x];
    for (var i = 0 ; i < x.length ; i++) {
        this._digest(x[i], n);
    }
};

TDigest.prototype.push_centroid = function(c) {
    // incorporate centroid or array of centroids c
    //
    c = Array.isArray(c) ? c : [c];
    for (var i = 0 ; i < c.length ; i++) {
        this._digest(c[i].mean, c[i].n);
    }
};

TDigest.prototype._cumulate = function(exact) {
    // update cumulative counts for each centroid
    //
    // exact: falsey means only cumulate after sufficient
    // growth. During ingest, these counts are used as quantile
    // estimates, and they work well even when somewhat out of
    // date. (this is a departure from the publication, you may set CX
    // to 0 to disable).
    //
    if (this.n === this.last_cumulate ||
        !exact && this.CX && this.CX > (this.n / this.last_cumulate)) {
        return;
    }
    var cumn = 0;
    this.centroids.each(function(c) {
        c.mean_cumn = cumn + c.n / 2; // half of n at the mean
        cumn = c.cumn = cumn + c.n;
    });
    this.n = this.last_cumulate = cumn;
};

TDigest.prototype.find_nearest = function(x) {
    // find the centroid closest to x. The assumption of
    // unique means and a unique nearest centroid departs from the
    // paper, see _digest() below
    //
    if (this.size() === 0) {
        return null;
    }
    var iter = this.centroids.lowerBound({mean:x}); // x <= iter || iter==null
    var c = (iter.data() === null) ? iter.prev() : iter.data();
    if (c.mean === x || this.discrete) {
        return c; // c is either x or a neighbor (discrete: no distance func)
    }
    var prev = iter.prev();
    if (prev && Math.abs(prev.mean - x) < Math.abs(c.mean - x)) {
        return prev;
    } else {
        return c;
    }
};

TDigest.prototype._new_centroid = function(x, n, cumn) {
    // create and insert a new centroid into the digest (don't update
    // cumulatives).
    //
    var c = {mean:x, n:n, cumn:cumn};
    this.centroids.insert(c);
    this.n += n;
    return c;
};

TDigest.prototype._addweight = function(nearest, x, n) {
    // add weight at location x to nearest centroid.  adding x to
    // nearest will not shift its relative position in the tree and
    // require reinsertion.
    //
    if (x !== nearest.mean) {
        nearest.mean += n * (x - nearest.mean) / (nearest.n + n);
    }
    nearest.cumn += n;
    nearest.mean_cumn += n / 2;
    nearest.n += n;
    this.n += n;
};

TDigest.prototype._digest = function(x, n) {
    // incorporate value x, having count n into the TDigest.
    //
    var min = this.centroids.min();
    var max = this.centroids.max();
    var nearest = this.find_nearest(x);
    if (nearest && nearest.mean === x) {
        // accumulate exact matches into the centroid without
        // limit. this is a departure from the paper, made so
        // centroids remain unique and code can be simple.
        this._addweight(nearest, x, n);
    } else if (nearest === min) {
        this._new_centroid(x, n, 0); // new point around min boundary
    } else if (nearest === max ) {
        this._new_centroid(x, n, this.n); // new point around max boundary
    } else if (this.discrete) {
        this._new_centroid(x, n, nearest.cumn); // never merge
    } else {
        // conider a merge based on nearest centroid's capacity. if
        // there's not room for all of n, don't bother merging any of
        // it into nearest, as we'll have to make a new centroid
        // anyway for the remainder (departure from the paper).
        var p = nearest.mean_cumn / this.n;
        var max_n = Math.floor(4 * this.n * this.delta * p * (1 - p));
        if (max_n - nearest.n >= n) {
            this._addweight(nearest, x, n);
        } else {
            this._new_centroid(x, n, nearest.cumn);
        }
    }
    this._cumulate(false);
    if (!this.discrete && this.K && this.size() > this.K / this.delta) {
        // re-process the centroids and hope for some compression.
        this.compress();
    }
};

TDigest.prototype.bound_mean = function(x) {
    // find centroids lower and upper such that lower.mean < x <
    // upper.mean or lower.mean === x === upper.mean. Don't call
    // this for x out of bounds.
    //
    var iter = this.centroids.upperBound({mean:x}); // x < iter
    var lower = iter.prev();      // lower <= x
    var upper = (lower.mean === x) ? lower : iter.next();
    return [lower, upper];
};

TDigest.prototype.p_rank = function(x_or_xlist) {
    // return approximate percentile-ranks (0..1) for data value x.
    // or list of x.  calculated according to
    // https://en.wikipedia.org/wiki/Percentile_rank
    //
    // (Note that in continuous mode, boundary sample values will
    // report half their centroid weight inward from 0/1 as the
    // percentile-rank. X values outside the observed range return
    // 0/1)
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var xs = Array.isArray(x_or_xlist) ? x_or_xlist : [x_or_xlist];
    var ps = xs.map(this._p_rank, this);
    return Array.isArray(x_or_xlist) ? ps : ps[0];
};

TDigest.prototype._p_rank = function(x) {
    if (this.size() === 0) {
        return undefined;
    } else if (x < this.centroids.min().mean) {
        return 0.0;
    } else if (x > this.centroids.max().mean) {
        return 1.0;
    }
    // find centroids that bracket x and interpolate x's cumn from
    // their cumn's.
    this._cumulate(true); // be sure cumns are exact
    var bound = this.bound_mean(x);
    var lower = bound[0], upper = bound[1];
    if (this.discrete) {
        return lower.cumn / this.n;
    } else {
        var cumn = lower.mean_cumn;
        if (lower !== upper) {
            cumn += (x - lower.mean) * (upper.mean_cumn - lower.mean_cumn) / (upper.mean - lower.mean);
        }
        return cumn / this.n;
    }
};

TDigest.prototype.bound_mean_cumn = function(cumn) {
    // find centroids lower and upper such that lower.mean_cumn < x <
    // upper.mean_cumn or lower.mean_cumn === x === upper.mean_cumn. Don't call
    // this for cumn out of bounds.
    //
    // XXX because mean and mean_cumn give rise to the same sort order
    // (up to identical means), use the mean rbtree for our search.
    this.centroids._comparator = compare_centroid_mean_cumns;
    var iter = this.centroids.upperBound({mean_cumn:cumn}); // cumn < iter
    this.centroids._comparator = compare_centroid_means;
    var lower = iter.prev();      // lower <= cumn
    var upper = (lower && lower.mean_cumn === cumn) ? lower : iter.next();
    return [lower, upper];
};

TDigest.prototype.percentile = function(p_or_plist) {
    // for percentage p (0..1), or for each p in a list of ps, return
    // the smallest data value q at which at least p percent of the
    // observations <= q.
    //
    // for discrete distributions, this selects q using the Nearest
    // Rank Method
    // (https://en.wikipedia.org/wiki/Percentile#The_Nearest_Rank_method)
    // (in scipy, same as percentile(...., interpolation='higher')
    //
    // for continuous distributions, interpolates data values between
    // count-weighted bracketing means.
    //
    // this triggers cumulate() if cumn's are out of date.
    //
    var ps = Array.isArray(p_or_plist) ? p_or_plist : [p_or_plist];
    var qs = ps.map(this._percentile, this);
    return Array.isArray(p_or_plist) ? qs : qs[0];
};

TDigest.prototype._percentile = function(p) {
    if (this.size() === 0) {
        return undefined;
    }
    this._cumulate(true); // be sure cumns are exact
    var h = this.n * p;
    var bound = this.bound_mean_cumn(h);
    var lower = bound[0], upper = bound[1];

    if (upper === lower || lower === null || upper === null) {
        return (lower || upper).mean;
    } else if (!this.discrete) {
        return lower.mean + (h - lower.mean_cumn) * (upper.mean - lower.mean) / (upper.mean_cumn - lower.mean_cumn);
    } else if (h <= lower.cumn) {
        return lower.mean;
    } else {
        return upper.mean;
    }
};

function pop_random(choices) {
    // remove and return an item randomly chosen from the array of choices
    // (mutates choices)
    //
    var idx = Math.floor(Math.random() * choices.length);
    return choices.splice(idx, 1)[0];
}

TDigest.prototype.compress = function() {
    // TDigests experience worst case compression (none) when input
    // increases monotonically.  Improve on any bad luck by
    // reconsuming digest centroids as if they were weighted points
    // while shuffling their order (and hope for the best).
    //
    if (this.compressing) {
        return;
    }
    var points = this.toArray();
    this.reset();
    this.compressing = true;
    while (points.length > 0) {
        this.push_centroid(pop_random(points));
    }
    this._cumulate(true);
    this.compressing = false;
};

function Digest(config) {
    // allocate a distribution digest structure. This is an extension
    // of a TDigest structure that starts in exact histogram (discrete)
    // mode, and automatically switches to TDigest mode for large
    // samples that appear to be from a continuous distribution.
    //
    this.config = config || {};
    this.mode = this.config.mode || 'auto'; // disc, cont, auto
    TDigest.call(this, this.mode === 'cont' ? config.delta : false);
    this.digest_ratio = this.config.ratio || 0.9;
    this.digest_thresh = this.config.thresh || 1000;
    this.n_unique = 0;
}
Digest.prototype = Object.create(TDigest.prototype);
Digest.prototype.constructor = Digest;

Digest.prototype.push = function(x_or_xlist) {
    TDigest.prototype.push.call(this, x_or_xlist);
    this.check_continuous();
};

Digest.prototype._new_centroid = function(x, n, cumn) {
    this.n_unique += 1;
    TDigest.prototype._new_centroid.call(this, x, n, cumn);
};

Digest.prototype._addweight = function(nearest, x, n) {
    if (nearest.n === 1) {
        this.n_unique -= 1;
    }
    TDigest.prototype._addweight.call(this, nearest, x, n);
};

Digest.prototype.check_continuous = function() {
    // while in 'auto' mode, if there are many unique elements, assume
    // they are from a continuous distribution and switch to 'cont'
    // mode (tdigest behavior). Return true on transition from
    // disctete to continuous.
    if (this.mode !== 'auto' || this.size() < this.digest_thresh) {
        return false;
    }
    if (this.n_unique / this.size() > this.digest_ratio) {
        this.mode = 'cont';
        this.discrete = false;
        this.delta = this.config.delta || 0.01;
        this.compress();
        return true;
    }
    return false;
};

module.exports = {
    'TDigest': TDigest,
    'Digest': Digest
};


/***/ }),

/***/ 53250:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(67294);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 61688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(53250);
} else {}


/***/ }),

/***/ 71739:
/***/ (function(module) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),

/***/ 83154:
/***/ (function(module, exports, __webpack_require__) {

var fetchApi
if (typeof fetch === 'function') {
  if (typeof __webpack_require__.g !== 'undefined' && __webpack_require__.g.fetch) {
    fetchApi = __webpack_require__.g.fetch
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch
  } else {
    fetchApi = fetch
  }
}

if ( true && (typeof window === 'undefined' || typeof window.document === 'undefined')) {
  var f = fetchApi || __webpack_require__(68203)
  if (f.default) f = f.default
  exports["default"] = f
  module.exports = exports.default
}


/***/ }),

/***/ 76118:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ InMemoryCache; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/optimism/lib/index.js + 8 modules
var lib = __webpack_require__(31662);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var equality_lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(23361);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/cache.js



var ApolloCache = /** @class */ (function () {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0,lib/* wrap */.re)(graphql_fragments/* getFragmentQueryDocument */.Yk);
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function (options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic
            : options.optimistic === false ? null
                : void 0;
        var updateResult;
        this.performTransaction(function () { return (updateResult = options.update(_this)); }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.identify = function (object) {
        return;
    };
    ApolloCache.prototype.gc = function () {
        return [];
    };
    ApolloCache.prototype.modify = function (options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { rootId: options.id || "ROOT_QUERY", optimistic: optimistic }));
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = !!options.optimistic; }
        return this.read((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: this.getFragmentDoc(options.fragment, options.fragmentName), rootId: options.id, optimistic: optimistic }));
    };
    ApolloCache.prototype.writeQuery = function (_a) {
        var id = _a.id, data = _a.data, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data"]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data,
        }));
    };
    ApolloCache.prototype.writeFragment = function (_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0,tslib_es6/* __rest */._T)(_a, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data,
        }));
    };
    ApolloCache.prototype.updateQuery = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeQuery((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    ApolloCache.prototype.updateFragment = function (options, update) {
        return this.batch({
            update: function (cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null)
                    return value;
                cache.writeFragment((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { data: data }));
                return data;
            },
        });
    };
    return ApolloCache;
}());

//# sourceMappingURL=cache.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/core/types/common.js

var MissingFieldError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for (var i = _this.path.length - 1; i >= 0; --i) {
                _this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
            }
        }
        else {
            _this.missing = _this.path;
        }
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error));

//# sourceMappingURL=common.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/DocumentTransform.js
var DocumentTransform = __webpack_require__(18056);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(76487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@wry/trie/lib/index.js
var trie_lib = __webpack_require__(75028);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/helpers.js

var hasOwn = Object.prototype.hasOwnProperty;
function isNullish(value) {
    return value === null || value === void 0;
}

function defaultDataIdFromObject(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) {
            context.keyObject =
                !isNullish(id) ? { id: id }
                    : !isNullish(_id) ? { _id: _id }
                        : void 0;
        }
        // If there is no object.id, fall back to object._id.
        if (isNullish(id) && !isNullish(_id)) {
            id = _id;
        }
        if (!isNullish(id)) {
            return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ?
                id
                : JSON.stringify(id));
        }
    }
}
var defaultConfig = {
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false,
};
function normalizeConfig(config) {
    return (0,compact/* compact */.o)(defaultConfig, config);
}
function shouldCanonizeResults(config) {
    var value = config.canonizeResults;
    return value === void 0 ? defaultConfig.canonizeResults : value;
}
function getTypenameFromStoreObject(store, objectOrReference) {
    return (0,storeUtils/* isReference */.Yk)(objectOrReference) ?
        store.get(objectOrReference.__ref, "__typename")
        : objectOrReference && objectOrReference.__typename;
}
var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;
function fieldNameFromStoreName(storeFieldName) {
    var match = storeFieldName.match(TypeOrFieldNameRegExp);
    return match ? match[0] : storeFieldName;
}
function selectionSetMatchesResult(selectionSet, result, variables) {
    if ((0,objects/* isNonNullObject */.s)(result)) {
        return (0,arrays/* isArray */.k)(result) ?
            result.every(function (item) {
                return selectionSetMatchesResult(selectionSet, item, variables);
            })
            : selectionSet.selections.every(function (field) {
                if ((0,storeUtils/* isField */.My)(field) && (0,directives/* shouldInclude */.LZ)(field, variables)) {
                    var key = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                    return (hasOwn.call(result, key) &&
                        (!field.selectionSet ||
                            selectionSetMatchesResult(field.selectionSet, result[key], variables)));
                }
                // If the selection has been skipped with @skip(true) or
                // @include(false), it should not count against the matching. If
                // the selection is not a field, it must be a fragment (inline or
                // named). We will determine if selectionSetMatchesResult for that
                // fragment when we get to it, so for now we return true.
                return true;
            });
    }
    return false;
}
function storeValueIsStoreObject(value) {
    return (0,objects/* isNonNullObject */.s)(value) && !(0,storeUtils/* isReference */.Yk)(value) && !(0,arrays/* isArray */.k)(value);
}
function makeProcessedFieldsMerger() {
    return new mergeDeep/* DeepMerger */.w0();
}
function extractFragmentContext(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)((0,getFromAST/* getFragmentDefinitions */.kU)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function (name) {
            var def = fragmentMap[name];
            if (!def && fragments) {
                def = fragments.lookup(name);
            }
            return def || null;
        },
    };
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/entityStore.js







var DELETE = Object.create(null);
var delModifier = function () { return DELETE; };
var INVALIDATE = Object.create(null);
var EntityStore = /** @class */ (function () {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function (objectOrReference, storeFieldName) {
            return (0,maybeDeepFreeze/* maybeDeepFreeze */.J)((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                _this.get(objectOrReference.__ref, storeFieldName)
                : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function (objOrRef) {
            return (0,storeUtils/* isReference */.Yk)(objOrRef) ?
                _this.has(objOrRef.__ref)
                : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function (objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") {
                return (0,storeUtils/* makeReference */.kQ)(objOrIdOrRef);
            }
            if ((0,storeUtils/* isReference */.Yk)(objOrIdOrRef)) {
                return objOrIdOrRef;
            }
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0,storeUtils/* makeReference */.kQ)(id);
                if (mergeIntoStore) {
                    _this.merge(id, objOrIdOrRef);
                }
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)({}, this.data);
    };
    EntityStore.prototype.has = function (dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function (dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if (hasOwn.call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && hasOwn.call(storeObject, fieldName)) {
                return storeObject[fieldName];
            }
        }
        if (fieldName === "__typename" &&
            hasOwn.call(this.policies.rootTypenamesById, dataId)) {
            return this.policies.rootTypenamesById[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.get(dataId, fieldName);
        }
    };
    EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence)
            this.group.depend(dataId, "__exists");
        if (hasOwn.call(this.data, dataId)) {
            return this.data[dataId];
        }
        if (this instanceof Layer) {
            return this.parent.lookup(dataId, dependOnExistence);
        }
        if (this.policies.rootTypenamesById[dataId]) {
            return Object.create(null);
        }
    };
    EntityStore.prototype.merge = function (older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0,storeUtils/* isReference */.Yk)(older))
            older = older.__ref;
        if ((0,storeUtils/* isReference */.Yk)(newer))
            newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup((dataId = older)) : older;
        var incoming = typeof newer === "string" ? this.lookup((dataId = newer)) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming)
            return;
        (0,globals/* invariant */.kG)(typeof dataId === "string", 1);
        var merged = new mergeDeep/* DeepMerger */.w0(storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing)
                    fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function (storeFieldName) {
                    if (!existing ||
                        existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = fieldNameFromStoreName(storeFieldName);
                        if (fieldName !== storeFieldName &&
                            !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
                            fieldsToDirty_1[fieldName] = 1;
                        }
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
                            delete merged[storeFieldName];
                        }
                    }
                });
                if (fieldsToDirty_1.__typename &&
                    !(existing && existing.__typename) &&
                    // Since we return default root __typename strings
                    // automatically from store.get, we don't need to dirty the
                    // ROOT_QUERY.__typename field if merged.__typename is equal
                    // to the default string (usually "Query").
                    this.policies.rootTypenamesById[dataId] === merged.__typename) {
                    delete fieldsToDirty_1.__typename;
                }
                Object.keys(fieldsToDirty_1).forEach(function (fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function (dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: DELETE,
                INVALIDATE: INVALIDATE,
                isReference: storeUtils/* isReference */.Yk,
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function (fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ?
                        {
                            fieldName: fieldNameOrOptions,
                            from: from || (0,storeUtils/* makeReference */.kQ)(dataId),
                        }
                        : fieldNameOrOptions, { store: _this });
                },
            };
            Object.keys(storeObject).forEach(function (storeFieldName) {
                var fieldName = fieldNameFromStoreName(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0)
                    return;
                var modify = typeof fields === "function" ? fields : (fields[storeFieldName] || fields[fieldName]);
                if (modify) {
                    var newValue = modify === delModifier ? DELETE : (modify((0,maybeDeepFreeze/* maybeDeepFreeze */.J)(fieldValue), (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, sharedDetails_1), { fieldName: fieldName, storeFieldName: storeFieldName, storage: _this.getStorage(dataId, storeFieldName) })));
                    if (newValue === INVALIDATE) {
                        _this.group.dirty(dataId, storeFieldName);
                    }
                    else {
                        if (newValue === DELETE)
                            newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function (ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0,storeUtils/* isReference */.Yk)(newValue)) {
                                    checkReference(newValue);
                                }
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for (var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++) {
                                        var value = newValue_1[_i];
                                        if ((0,storeUtils/* isReference */.Yk)(value)) {
                                            seenReference = true;
                                            if (checkReference(value))
                                                break;
                                        }
                                        else {
                                            // Do not warn on primitive values, since those could never be represented
                                            // by a reference. This is a valid (albeit uncommon) use case.
                                            if (typeof value === "object" && !!value) {
                                                var id = _this.policies.identify(value)[0];
                                                // check if object could even be referenced, otherwise we are not interested in it for this warning
                                                if (id) {
                                                    someNonReference = value;
                                                }
                                            }
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) {
                    allDeleted_1 = false;
                }
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof Layer) {
                        this.data[dataId] = void 0;
                    }
                    else {
                        delete this.data[dataId];
                    }
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function (dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ?
                this.policies.getStoreFieldName({ typename: typename, fieldName: fieldName, args: args })
                : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {},
                _a[storeFieldName] = delModifier,
                _a) : delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function (options, limit) {
        var evicted = false;
        if (options.id) {
            if (hasOwn.call(this.data, options.id)) {
                evicted = this.delete(options.id, options.fieldName, options.args);
            }
            if (this instanceof Layer && this !== limit) {
                evicted = this.parent.evict(options, limit) || evicted;
            }
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) {
                this.group.dirty(options.id, options.fieldName || "__exists");
            }
        }
        return evicted;
    };
    EntityStore.prototype.clear = function () {
        this.replace(null);
    };
    EntityStore.prototype.extract = function () {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function (id) {
            if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
                extraRootIds.push(id);
            }
        });
        if (extraRootIds.length) {
            obj.__META = { extraRootIds: extraRootIds.sort() };
        }
        return obj;
    };
    EntityStore.prototype.replace = function (newData) {
        var _this = this;
        Object.keys(this.data).forEach(function (dataId) {
            if (!(newData && hasOwn.call(newData, dataId))) {
                _this.delete(dataId);
            }
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0,tslib_es6/* __rest */._T)(newData, ["__META"]);
            Object.keys(rest_1).forEach(function (dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) {
                __META.extraRootIds.forEach(this.retain, this);
            }
        }
    };
    EntityStore.prototype.retain = function (rootId) {
        return (this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1);
    };
    EntityStore.prototype.release = function (rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count)
                delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function (ids) {
        if (ids === void 0) { ids = new Set(); }
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof Layer) {
            this.parent.getRootIdSet(ids);
        }
        else {
            // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
            // always considered roots for garbage collection, regardless of
            // their retainment counts in this.rootIds.
            Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        }
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function () {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function (id) {
            if (hasOwn.call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while (root_1 instanceof Layer)
                root_1 = root_1.parent;
            idsToRemove.forEach(function (id) { return root_1.delete(id); });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function (dataId) {
        if (!hasOwn.call(this.refs, dataId)) {
            var found_1 = (this.refs[dataId] = Object.create(null));
            var root = this.data[dataId];
            if (!root)
                return found_1;
            var workSet_1 = new Set([root]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function (obj) {
                if ((0,storeUtils/* isReference */.Yk)(obj)) {
                    found_1[obj.__ref] = true;
                    // In rare cases, a { __ref } Reference object may have other fields.
                    // This often indicates a mismerging of References with StoreObjects,
                    // but garbage collection should not be fooled by a stray __ref
                    // property in a StoreObject (ignoring all the other fields just
                    // because the StoreObject looks like a Reference). To avoid this
                    // premature termination of findChildRefIds recursion, we fall through
                    // to the code below, which will handle any other properties of obj.
                }
                if ((0,objects/* isNonNullObject */.s)(obj)) {
                    Object.keys(obj).forEach(function (key) {
                        var child = obj[key];
                        // No need to add primitive values to the workSet, since they cannot
                        // contain reference objects.
                        if ((0,objects/* isNonNullObject */.s)(child)) {
                            workSet_1.add(child);
                        }
                    });
                }
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function () {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}());

// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var CacheGroup = /** @class */ (function () {
    function CacheGroup(caching, parent) {
        if (parent === void 0) { parent = null; }
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function () {
        this.d = this.caching ? (0,lib/* dep */.dP)() : null;
        this.keyMaker = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
    };
    CacheGroup.prototype.depend = function (dataId, storeFieldName) {
        if (this.d) {
            this.d(makeDepKey(dataId, storeFieldName));
            var fieldName = fieldNameFromStoreName(storeFieldName);
            if (fieldName !== storeFieldName) {
                // Fields with arguments that contribute extra identifying
                // information to the fieldName (thus forming the storeFieldName)
                // depend not only on the full storeFieldName but also on the
                // short fieldName, so the field can be invalidated using either
                // level of specificity.
                this.d(makeDepKey(dataId, fieldName));
            }
            if (this.parent) {
                this.parent.depend(dataId, storeFieldName);
            }
        }
    };
    CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
        if (this.d) {
            this.d.dirty(makeDepKey(dataId, storeFieldName), 
            // When storeFieldName === "__exists", that means the entity identified
            // by dataId has either disappeared from the cache or was newly added,
            // so the result caching system would do well to "forget everything it
            // knows" about that object. To achieve that kind of invalidation, we
            // not only dirty the associated result cache entry, but also remove it
            // completely from the dependency graph. For the optimism implementation
            // details, see https://github.com/benjamn/optimism/pull/195.
            storeFieldName === "__exists" ? "forget" : "setDirty");
        }
    };
    return CacheGroup;
}());
function makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function maybeDependOnExistenceOfEntity(store, entityId) {
    if (supportsResultCaching(store)) {
        // We use this pseudo-field __exists elsewhere in the EntityStore code to
        // represent changes in the existence of the entity object identified by
        // entityId. This dependency gets reliably dirtied whenever an object with
        // this ID is deleted (or newly created) within this group, so any result
        // cache entries (for example, StoreReader#executeSelectionSet results) that
        // depend on __exists for this entityId will get dirtied as well, leading to
        // the eventual recomputation (instead of reuse) of those result objects the
        // next time someone reads them from the cache.
        store.group.depend(entityId, "__exists");
    }
}
(function (EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ (function (_super) {
        (0,tslib_es6/* __extends */.ZT)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;
            _this.stump = new Stump(_this);
            _this.storageTrie = new trie_lib/* Trie */.B(canUse/* canUseWeakMap */.mr);
            if (seed)
                _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function (layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function () {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function () {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore));
    EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var Layer = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function (layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function (layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) {
                // Dirty every ID we're removing. Technically we might be able to avoid
                // dirtying fields that have values in higher layers, but we don't have
                // easy access to higher layers here, and we're about to recreate those
                // layers anyway (see parent.addLayer below).
                Object.keys(this.data).forEach(function (dataId) {
                    var ownStoreObject = _this.data[dataId];
                    var parentStoreObject = parent["lookup"](dataId);
                    if (!parentStoreObject) {
                        // The StoreObject identified by dataId was defined in this layer
                        // but will be undefined in the parent layer, so we can delete the
                        // whole entity using this.delete(dataId). Since we're about to
                        // throw this layer away, the only goal of this deletion is to dirty
                        // the removed fields.
                        _this.delete(dataId);
                    }
                    else if (!ownStoreObject) {
                        // This layer had an entry for dataId but it was undefined, which
                        // means the entity was deleted in this layer, and it's about to
                        // become undeleted when we remove this layer, so we need to dirty
                        // all fields that are about to be reexposed.
                        _this.group.dirty(dataId, "__exists");
                        Object.keys(parentStoreObject).forEach(function (storeFieldName) {
                            _this.group.dirty(dataId, storeFieldName);
                        });
                    }
                    else if (ownStoreObject !== parentStoreObject) {
                        // If ownStoreObject is not exactly the same as parentStoreObject,
                        // dirty any fields whose values will change as a result of this
                        // removal.
                        Object.keys(ownStoreObject).forEach(function (storeFieldName) {
                            if (!(0,equality_lib/* equal */.D)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                                _this.group.dirty(dataId, storeFieldName);
                            }
                        });
                    }
                });
            }
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent)
            return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function () {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function (dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return hasOwn.call(this.data, dataId) ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function () {
        var p = this.parent;
        while (p.parent)
            p = p.parent;
        return p.getStorage.apply(p, 
        // @ts-expect-error
        arguments);
    };
    return Layer;
}(EntityStore));
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var Stump = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function () { }, new CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function () {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function (older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}(Layer));
function storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0,equality_lib/* equal */.D)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function supportsResultCaching(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof EntityStore && store.group.caching);
}
//# sourceMappingURL=entityStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/readFromStore.js









function execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults,
    ];
}
var StoreReader = /** @class */ (function () {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.config = (0,compact/* compact */.o)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: shouldCanonizeResults(config),
        });
        this.canon = config.canon || new object_canon/* ObjectCanon */.h();
        this.executeSelectionSet = (0,lib/* wrap */.re)(function (options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) {
                    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, other), { 
                        // If we previously read this result without canonizing it, we can
                        // reuse that result simply by canonizing it now.
                        result: _this.canon.admit(other.result) });
                }
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            keyArgs: execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function (selectionSet, parent, context, canonizeResults) {
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(selectionSet, (0,storeUtils/* isReference */.Yk)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
                }
            },
        });
        this.executeSubSelectedArray = (0,lib/* wrap */.re)(function (options) {
            maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if (supportsResultCaching(context.store)) {
                    return context.store.makeCacheKey(field, array, context.varString);
                }
            },
        });
    }
    StoreReader.prototype.resetCanon = function () {
        this.canon = new object_canon/* ObjectCanon */.h();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getQueryDefinition */.iW)(query))), variables);
        var rootRef = (0,storeUtils/* makeReference */.kQ)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0,getFromAST/* getMainDefinition */.p$)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0,tslib_es6/* __assign */.pi)({ store: store, query: query, policies: policies, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables), canonizeResults: canonizeResults }, extractFragmentContext(query, this.config.fragments)),
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables),
            ];
            if (!returnPartialData) {
                throw missing[0];
            }
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing,
        };
    };
    StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
        if (supportsResultCaching(context.store) &&
            this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, 
            // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) {
                return true;
            }
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0,storeUtils/* isReference */.Yk)(objectOrReference) &&
            !context.policies.rootTypenamesById[objectOrReference.__ref] &&
            !context.store.has(objectOrReference.__ref)) {
            return {
                result: this.canon.empty,
                missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object"),
            };
        }
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        if (this.config.addTypename &&
            typeof typename === "string" &&
            !policies.rootIdsByTypename[typename]) {
            // Ensure we always include a default value for the __typename
            // field, if we have one, and this.config.addTypename is true. Note
            // that this field can be overridden by other merged objects.
            objectsToMerge.push({ __typename: typename });
        }
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) {
                missing = missingMerger.merge(missing, (_a = {},
                    _a[resultName] = result.missing,
                    _a));
            }
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function (selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0,directives/* shouldInclude */.LZ)(selection, variables))
                return;
            if ((0,storeUtils/* isField */.My)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference,
                }, context);
                var resultName = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
                if (fieldValue === void 0) {
                    if (!transform/* addTypenameToDocument.added */.Gw.added(selection)) {
                        missing = missingMerger.merge(missing, (_a = {},
                            _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                                objectOrReference.__ref + " object"
                                : "object " + JSON.stringify(objectOrReference, null, 2)),
                            _a));
                    }
                }
                else if ((0,arrays/* isArray */.k)(fieldValue)) {
                    fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context,
                    }), resultName);
                }
                else if (!selection.selectionSet) {
                    // If the field does not have a selection set, then we handle it
                    // as a scalar value. To keep this.canon from canonicalizing
                    // this value, we use this.canon.pass to wrap fieldValue in a
                    // Pass object that this.canon.admit will later unwrap as-is.
                    if (context.canonizeResults) {
                        fieldValue = _this.canon.pass(fieldValue);
                    }
                }
                else if (fieldValue != null) {
                    // In this case, because we know the field has a selection set,
                    // it must be trying to query a GraphQLObjectType, which is why
                    // fieldValue must be != null.
                    fieldValue = handleMissing(_this.executeSelectionSet({
                        selectionSet: selection.selectionSet,
                        objectOrReference: fieldValue,
                        enclosingRef: (0,storeUtils/* isReference */.Yk)(fieldValue) ? fieldValue : enclosingRef,
                        context: context,
                    }), resultName);
                }
                if (fieldValue !== void 0) {
                    objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
                }
            }
            else {
                var fragment = (0,graphql_fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                    throw (0,globals/* newInvariantError */._K)(9, selection.name.value);
                }
                if (fragment && policies.fragmentMatches(fragment, typename)) {
                    fragment.selectionSet.selections.forEach(workSet.add, workSet);
                }
            }
        });
        var result = (0,mergeDeep/* mergeDeepArray */.bw)(objectsToMerge);
        var finalResult = { result: result, missing: missing };
        var frozen = context.canonizeResults ?
            this.canon.admit(finalResult)
            // Since this.canon is normally responsible for freezing results (only in
            // development), freeze them manually if canonization is disabled.
            : (0,maybeDeepFreeze/* maybeDeepFreeze */.J)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) {
            this.knownResults.set(frozen.result, selectionSet);
        }
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new mergeDeep/* DeepMerger */.w0();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) {
                missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            }
            return childResult.result;
        }
        if (field.selectionSet) {
            array = array.filter(context.store.canRead);
        }
        array = array.map(function (item, i) {
            // null value in array
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse
            if ((0,arrays/* isArray */.k)(item)) {
                return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    enclosingRef: enclosingRef,
                    context: context,
                }), i);
            }
            // This is an object, run the selection set on it
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    objectOrReference: item,
                    enclosingRef: (0,storeUtils/* isReference */.Yk)(item) ? item : enclosingRef,
                    context: context,
                }), i);
            }
            if (globalThis.__DEV__ !== false) {
                assertSelectionSetForIdValue(context.store, field, item);
            }
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing,
        };
    };
    return StoreReader;
}());

function firstMissing(tree) {
    try {
        JSON.stringify(tree, function (_, value) {
            if (typeof value === "string")
                throw value;
            return value;
        });
    }
    catch (result) {
        return result;
    }
}
function assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([fieldValue]);
        workSet_1.forEach(function (value) {
            if ((0,objects/* isNonNullObject */.s)(value)) {
                (0,globals/* invariant */.kG)(
                    !(0,storeUtils/* isReference */.Yk)(value),
                    10,
                    getTypenameFromStoreObject(store, value),
                    field.name.value
                );
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}
//# sourceMappingURL=readFromStore.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(79487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/stringifyForDisplay.js
var stringifyForDisplay = __webpack_require__(13887);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(66438);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/key-extractor.js



// Mapping from JSON-encoded KeySpecifier strings to associated information.
var specifierInfoCache = Object.create(null);
function lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return (specifierInfoCache[cacheKey] ||
        (specifierInfoCache[cacheKey] = Object.create(null)));
}
function keyFieldsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
            var extract = function (from, key) {
                return context.readField(key, from);
            };
            var keyObject = (context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
                var extracted = extractKeyPath(context.storeObject, schemaKeyPath, 
                // Using context.readField to extract paths from context.storeObject
                // allows the extraction to see through Reference objects and respect
                // custom read functions.
                extract);
                if (extracted === void 0 &&
                    object !== context.storeObject &&
                    hasOwn.call(object, schemaKeyPath[0])) {
                    // If context.storeObject fails to provide a value for the requested
                    // path, fall back to the raw result object, if it has a top-level key
                    // matching the first key in the path (schemaKeyPath[0]). This allows
                    // key fields included in the written data to be saved in the cache
                    // even if they are not selected explicitly in context.selectionSet.
                    // Not being mentioned by context.selectionSet is convenient here,
                    // since it means these extra fields cannot be affected by field
                    // aliasing, which is why we can use extractKey instead of
                    // context.readField for this extraction.
                    extracted = extractKeyPath(object, schemaKeyPath, extractKey);
                }
                (0,globals/* invariant */.kG)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
                return extracted;
            }));
            return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
        }));
}
// The keyArgs extraction process is roughly analogous to keyFields extraction,
// but there are no aliases involved, missing fields are tolerated (by merely
// omitting them from the key), and drawing from field.directives or variables
// is allowed (in addition to drawing from the field's arguments object).
// Concretely, these differences mean passing a different key path extractor
// function to collectSpecifierPaths, reusing the shared extractKeyPath helper
// wherever possible.
function keyArgsFnFromSpecifier(specifier) {
    var info = lookupSpecifierInfo(specifier);
    return (info.keyArgsFn ||
        (info.keyArgsFn = function (args, _a) {
            var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
            var collected = collectSpecifierPaths(specifier, function (keyPath) {
                var firstKey = keyPath[0];
                var firstChar = firstKey.charAt(0);
                if (firstChar === "@") {
                    if (field && (0,arrays/* isNonEmptyArray */.O)(field.directives)) {
                        var directiveName_1 = firstKey.slice(1);
                        // If the directive appears multiple times, only the first
                        // occurrence's arguments will be used. TODO Allow repetition?
                        // TODO Cache this work somehow, a la aliasMap?
                        var d = field.directives.find(function (d) { return d.name.value === directiveName_1; });
                        // Fortunately argumentsObjectFromField works for DirectiveNode!
                        var directiveArgs = d && (0,storeUtils/* argumentsObjectFromField */.NC)(d, variables);
                        // For directives without arguments (d defined, but directiveArgs ===
                        // null), the presence or absence of the directive still counts as
                        // part of the field key, so we return null in those cases. If no
                        // directive with this name was found for this field (d undefined and
                        // thus directiveArgs undefined), we return undefined, which causes
                        // this value to be omitted from the key object returned by
                        // collectSpecifierPaths.
                        return (directiveArgs &&
                            extractKeyPath(directiveArgs, 
                            // If keyPath.length === 1, this code calls extractKeyPath with an
                            // empty path, which works because it uses directiveArgs as the
                            // extracted value.
                            keyPath.slice(1)));
                    }
                    // If the key started with @ but there was no corresponding directive,
                    // we want to omit this value from the key object, not fall through to
                    // treating @whatever as a normal argument name.
                    return;
                }
                if (firstChar === "$") {
                    var variableName = firstKey.slice(1);
                    if (variables && hasOwn.call(variables, variableName)) {
                        var varKeyPath = keyPath.slice(0);
                        varKeyPath[0] = variableName;
                        return extractKeyPath(variables, varKeyPath);
                    }
                    // If the key started with $ but there was no corresponding variable, we
                    // want to omit this value from the key object, not fall through to
                    // treating $whatever as a normal argument name.
                    return;
                }
                if (args) {
                    return extractKeyPath(args, keyPath);
                }
            });
            var suffix = JSON.stringify(collected);
            // If no arguments were passed to this field, and it didn't have any other
            // field key contributions from directives or variables, hide the empty
            // :{} suffix from the field key. However, a field passed no arguments can
            // still end up with a non-empty :{...} suffix if its key configuration
            // refers to directives or variables.
            if (args || suffix !== "{}") {
                fieldName += ":" + suffix;
            }
            return fieldName;
        }));
}
function collectSpecifierPaths(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new mergeDeep/* DeepMerger */.w0();
    return getSpecifierPaths(specifier).reduce(function (collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for (var i = path.length - 1; i >= 0; --i) {
                toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            }
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function getSpecifierPaths(spec) {
    var info = lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = (info.paths = []);
        var currentPath_1 = [];
        spec.forEach(function (s, i) {
            if ((0,arrays/* isArray */.k)(s)) {
                getSpecifierPaths(s).forEach(function (p) { return paths_1.push(currentPath_1.concat(p)); });
                currentPath_1.length = 0;
            }
            else {
                currentPath_1.push(s);
                if (!(0,arrays/* isArray */.k)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function extractKey(object, key) {
    return object[key];
}
function extractKeyPath(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || extractKey;
    return normalize(path.reduce(function reducer(obj, key) {
        return (0,arrays/* isArray */.k)(obj) ?
            obj.map(function (child) { return reducer(child, key); })
            : obj && extract(obj, key);
    }, object));
}
function normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0,objects/* isNonNullObject */.s)(value)) {
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(normalize);
        }
        return collectSpecifierPaths(Object.keys(value).sort(), function (path) {
            return extractKeyPath(value, path);
        });
    }
    return value;
}
//# sourceMappingURL=key-extractor.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/policies.js





// Upgrade to a faster version of the default stable JSON.stringify function
// used by getStoreKeyName. This function is used when computing storeFieldName
// strings (when no keyArgs has been configured for a field).


storeUtils/* getStoreKeyName.setStringify */.PT.setStringify(object_canon/* canonicalStringify */.B);
function argsFromFieldSpecifier(spec) {
    return (spec.args !== void 0 ? spec.args
        : spec.field ? (0,storeUtils/* argumentsObjectFromField */.NC)(spec.field, spec.variables)
            : null);
}
var nullKeyFieldsFn = function () { return void 0; };
var simpleKeyArgsFn = function (_args, context) { return context.fieldName; };
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var mergeTrueFn = function (existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var mergeFalseFn = function (_, incoming) { return incoming; };
var Policies = /** @class */ (function () {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0,tslib_es6/* __assign */.pi)({ dataIdFromObject: defaultDataIdFromObject }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) {
            this.addPossibleTypes(config.possibleTypes);
        }
        if (config.typePolicies) {
            this.addTypePolicies(config.typePolicies);
        }
    }
    Policies.prototype.identify = function (object, partialContext) {
        var _a;
        var policies = this;
        var typename = (partialContext &&
            (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename))) ||
            object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) {
            return ["ROOT_QUERY"];
        }
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = (partialContext && partialContext.storeObject) || object;
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, partialContext), { typename: typename, storeObject: storeObject, readField: (partialContext && partialContext.readField) ||
                function () {
                    var options = normalizeReadFieldOptions(arguments, storeObject);
                    return policies.readField(options, {
                        store: policies.cache["data"],
                        variables: options.variables,
                    });
                } });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = (policy && policy.keyFn) || this.config.dataIdFromObject;
        while (keyFn) {
            var specifierOrId = keyFn((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, object), storeObject), context);
            if ((0,arrays/* isArray */.k)(specifierOrId)) {
                keyFn = keyFieldsFnFromSpecifier(specifierOrId);
            }
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [id, context.keyObject] : [id];
    };
    Policies.prototype.addTypePolicies = function (typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function (typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0,tslib_es6/* __rest */._T)(_a, ["queryType", "mutationType", "subscriptionType"]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType)
                _this.setRootTypename("Query", typename);
            if (mutationType)
                _this.setRootTypename("Mutation", typename);
            if (subscriptionType)
                _this.setRootTypename("Subscription", typename);
            if (hasOwn.call(_this.toBeAdded, typename)) {
                _this.toBeAdded[typename].push(incoming);
            }
            else {
                _this.toBeAdded[typename] = [incoming];
            }
        });
    };
    Policies.prototype.updateTypePolicy = function (typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge =
                typeof merge === "function" ? merge
                    // Pass merge:true as a shorthand for a merge implementation
                    // that returns options.mergeObjects(existing, incoming).
                    : merge === true ? mergeTrueFn
                        // Pass merge:false to make incoming always replace existing
                        // without any warnings about data clobbering.
                        : merge === false ? mergeFalseFn
                            : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn =
            // Pass false to disable normalization for this typename.
            keyFields === false ? nullKeyFieldsFn
                // Pass an array of strings to use those fields to compute a
                // composite ID for objects of this typename.
                : (0,arrays/* isArray */.k)(keyFields) ? keyFieldsFnFromSpecifier(keyFields)
                    // Pass a function to take full control over identification.
                    : typeof keyFields === "function" ? keyFields
                        // Leave existing.keyFn unchanged if above cases fail.
                        : existing.keyFn;
        if (fields) {
            Object.keys(fields).forEach(function (fieldName) {
                var existing = _this.getFieldPolicy(typename, fieldName, true);
                var incoming = fields[fieldName];
                if (typeof incoming === "function") {
                    existing.read = incoming;
                }
                else {
                    var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                    existing.keyFn =
                        // Pass false to disable argument-based differentiation of
                        // field identities.
                        keyArgs === false ? simpleKeyArgsFn
                            // Pass an array of strings to use named arguments to
                            // compute a composite identity for the field.
                            : (0,arrays/* isArray */.k)(keyArgs) ? keyArgsFnFromSpecifier(keyArgs)
                                // Pass a function to take full control over field identity.
                                : typeof keyArgs === "function" ? keyArgs
                                    // Leave existing.keyFn unchanged if above cases fail.
                                    : existing.keyFn;
                    if (typeof read === "function") {
                        existing.read = read;
                    }
                    setMerge(existing, merge);
                }
                if (existing.read && existing.merge) {
                    // If we have both a read and a merge function, assume
                    // keyArgs:false, because read and merge together can take
                    // responsibility for interpreting arguments in and out. This
                    // default assumption can always be overridden by specifying
                    // keyArgs explicitly in the FieldPolicy.
                    existing.keyFn = existing.keyFn || simpleKeyArgsFn;
                }
            });
        }
    };
    Policies.prototype.setRootTypename = function (which, typename) {
        if (typename === void 0) { typename = which; }
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0,globals/* invariant */.kG)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old)
                delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function (possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function (supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function (subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match(TypeOrFieldNameRegExp);
                if (!match || match[0] !== subtype) {
                    // TODO Don't interpret just any invalid typename as a RegExp.
                    _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
                }
            });
        });
    };
    Policies.prototype.getTypePolicy = function (typename) {
        var _this = this;
        if (!hasOwn.call(this.typePolicies, typename)) {
            var policy_1 = (this.typePolicies[typename] = Object.create(null));
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function (regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) {
                            fuzzySupertypes.forEach(function (supertype) {
                                return supertypes_1.add(supertype);
                            });
                        }
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) {
                supertypes_1.forEach(function (supertype) {
                    var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0,tslib_es6/* __rest */._T)(_a, ["fields"]);
                    Object.assign(policy_1, rest);
                    Object.assign(policy_1.fields, fields);
                });
            }
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) {
            // Merge the pending policies into this.typePolicies, in the order they
            // were originally passed to addTypePolicy.
            inbox.splice(0).forEach(function (policy) {
                _this.updateTypePolicy(typename, policy);
            });
        }
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return (fieldPolicies[fieldName] ||
                (createIfMissing && (fieldPolicies[fieldName] = Object.create(null))));
        }
    };
    Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) {
            this.supertypeMap.set(subtype, (supertypeSet = new Set()));
        }
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition)
            return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename)
            return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype)
            return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [typenameSupertypeSet];
            var maybeEnqueue_1 = function (subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet &&
                    supertypeSet.size &&
                    workQueue_1.indexOf(supertypeSet) < 0) {
                    workQueue_1.push(supertypeSet);
                }
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for (var i = 0; i < workQueue_1.length; ++i) {
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) {
                            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(6, typename, supertype);
                        }
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes &&
                    // Start checking fuzzy subtypes only after exhausting all
                    // non-fuzzy subtypes (after the final iteration of the loop).
                    i === workQueue_1.length - 1 &&
                    // We could wait to compare fragment.selectionSet to result
                    // after we verify the supertype, but this check is often less
                    // expensive than that search, and we will have to do the
                    // comparison anyway whenever we find a potential match.
                    selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) {
                            maybeEnqueue_1(fuzzyString);
                        }
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function (fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables,
            };
            var args = argsFromFieldSpecifier(fieldSpec);
            while (keyFn) {
                var specifierOrString = keyFn(args, context);
                if ((0,arrays/* isArray */.k)(specifierOrString)) {
                    keyFn = keyArgsFnFromSpecifier(specifierOrString);
                }
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) {
            storeFieldName =
                fieldSpec.field ?
                    (0,storeUtils/* storeKeyNameFromField */.vf)(fieldSpec.field, fieldSpec.variables)
                    : (0,storeUtils/* getStoreKeyName */.PT)(fieldName, argsFromFieldSpecifier(fieldSpec));
        }
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) {
            return fieldName;
        }
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === fieldNameFromStoreName(storeFieldName) ? storeFieldName
            : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function (options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference)
            return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField)
            return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename)
                options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0,storeUtils/* isReference */.Yk)(objectOrReference) ?
                objectOrReference.__ref
                : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, read, [
                existing,
                readOptions,
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function (typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === mergeTrueFn) {
            // Instead of going to the trouble of creating a full
            // FieldFunctionOptions object and calling mergeTrueFn, we can
            // simply call mergeObjects, as mergeTrueFn would.
            return makeMergeObjectsFunction(context.store)(existing, incoming);
        }
        if (merge === mergeFalseFn) {
            // Likewise for mergeFalseFn, whose implementation is even simpler.
            return incoming;
        }
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) {
            existing = void 0;
        }
        return merge(existing, incoming, makeFieldFunctionOptions(this, 
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables,
        }, context, storage || Object.create(null)));
    };
    return Policies;
}());

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: storeUtils/* isReference */.Yk,
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function () {
            return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, variables), context);
        },
        mergeObjects: makeMergeObjectsFunction(context.store),
    };
}
function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") {
        options = {
            fieldName: fieldNameOrOptions,
            // Default to objectOrReference only when no second argument was
            // passed for the from parameter, not when undefined is explicitly
            // passed as the second argument.
            from: argc > 1 ? from : objectOrReference,
        };
    }
    else {
        options = (0,tslib_es6/* __assign */.pi)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!hasOwn.call(options, "from")) {
            options.from = objectOrReference;
        }
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) {
        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(7, (0,stringifyForDisplay/* stringifyForDisplay */.v)(Array.from(readFieldArgs)));
    }
    if (void 0 === options.variables) {
        options.variables = variables;
    }
    return options;
}
function makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0,arrays/* isArray */.k)(existing) || (0,arrays/* isArray */.k)(incoming)) {
            throw (0,globals/* newInvariantError */._K)(8);
        }
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0,objects/* isNonNullObject */.s)(existing) && (0,objects/* isNonNullObject */.s)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) {
                return incoming;
            }
            if ((0,storeUtils/* isReference */.Yk)(existing) && storeValueIsStoreObject(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if (storeValueIsStoreObject(existing) && (0,storeUtils/* isReference */.Yk)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if (storeValueIsStoreObject(existing) &&
                storeValueIsStoreObject(incoming)) {
                return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, existing), incoming);
            }
        }
        return incoming;
    };
}
//# sourceMappingURL=policies.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/writeToStore.js









// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) {
        context.flavors.set(key, (flavored =
            context.clientOnly === clientOnly && context.deferred === deferred ?
                context
                : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { clientOnly: clientOnly, deferred: deferred })));
    }
    return flavored;
}
var StoreWriter = /** @class */ (function () {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function (store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0,getFromAST/* getOperationDefinition */.$H)(query);
        var merger = makeProcessedFieldsMerger();
        variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (0,getFromAST/* getDefaultValues */.O4)(operationDefinition)), variables);
        var context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ store: store, written: Object.create(null), merge: function (existing, incoming) {
                return merger.merge(existing, incoming);
            }, variables: variables, varString: (0,object_canon/* canonicalStringify */.B)(variables) }, extractFragmentContext(query, this.fragments)), { overwrite: !!overwrite, incomingById: new Map(), clientOnly: false, deferred: false, flavors: new Map() });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: { map: new Map() },
            context: context,
        });
        if (!(0,storeUtils/* isReference */.Yk)(ref)) {
            throw (0,globals/* newInvariantError */._K)(11, result);
        }
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function (_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0,storeUtils/* isReference */.Yk)(applied)) {
                    // Assume References returned by applyMerges have already been merged
                    // into the store. See makeMergeObjectsFunction in policies.ts for an
                    // example of how this can happen.
                    return;
                }
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function (field) {
                    if (field.selectionSet) {
                        fieldsWithSelectionSets_1[field.name.value] = true;
                    }
                });
                var hasSelectionSet_1 = function (storeFieldName) {
                    return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] ===
                        true;
                };
                var hasMergeFunction_1 = function (storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function (storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) &&
                        !hasMergeFunction_1(storeFieldName)) {
                        warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                    }
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function (_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, 
        // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = (dataId && policies.rootTypenamesById[dataId]) ||
            (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap) ||
            (dataId && context.store.get(dataId, "__typename"));
        if ("string" === typeof typename) {
            incoming.__typename = typename;
        }
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function () {
            var options = normalizeReadFieldOptions(arguments, incoming, context.variables);
            if ((0,storeUtils/* isReference */.Yk)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { from: info.storeObject }), context);
                    if (result_1 !== void 0) {
                        return result_1;
                    }
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, 
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function (context, field) {
            var _a;
            var resultFieldKey = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables,
                });
                var childTree = getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, 
                // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ?
                    getContextFlavor(context, false, false)
                    : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet &&
                    ((0,storeUtils/* isReference */.Yk)(incomingValue) || storeValueIsStoreObject(incomingValue))) {
                    childTypename = readField("__typename", incomingValue);
                }
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) {
                    childTree.info = {
                        // TODO Check compatibility against any existing childTree.field?
                        field: field,
                        typename: typename,
                        merge: merge,
                    };
                }
                else {
                    maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                }
                incoming = context.merge(incoming, (_a = {},
                    _a[storeFieldName] = incomingValue,
                    _a));
            }
            else if (globalThis.__DEV__ !== false &&
                !context.clientOnly &&
                !context.deferred &&
                !transform/* addTypenameToDocument.added */.Gw.added(field) &&
                // If the field has a read function, it may be a synthetic field or
                // provide a default value, so its absence from the written data should
                // not be cause for alarm.
                !policies.getReadFunction(typename, field.name.value)) {
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(12, (0,storeUtils/* resultKeyNameFromField */.u2)(field), result);
            }
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField,
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) {
                // TODO Reverse the order of the arguments?
                incoming = context.merge(incoming, keyObject);
            }
        }
        catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId)
                throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0,storeUtils/* makeReference */.kQ)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0)
                return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader &&
                this.reader.isFresh(result, dataRef, selectionSet, context)) {
                return dataRef;
            }
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function (field) { return previous_1.fieldNodeSet.add(field); });
            }
            else {
                context.incomingById.set(dataId, {
                    storeObject: incoming,
                    // Save a reference to mergeTree only if it is not empty, because
                    // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                    // reused for entirely different parts of the result tree.
                    mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                    fieldNodeSet: fieldNodeSet,
                });
            }
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) {
            // In development, we need to clone scalar values so that they can be
            // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
            // it's cheaper to store the scalar values directly in the cache.
            return globalThis.__DEV__ !== false ? (0,cloneDeep/* cloneDeep */.X)(value) : value;
        }
        if ((0,arrays/* isArray */.k)(value)) {
            return value.map(function (item, i) {
                var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));
                maybeRecycleChildMergeTree(mergeTree, i);
                return value;
            });
        }
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree,
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
        if (typename === void 0) { typename = (0,storeUtils/* getTypenameFromResult */.qw)(result, selectionSet, context.fragmentMap); }
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new trie_lib/* Trie */.B(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, 
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited)
                return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function (selection) {
                if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
                    return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) &&
                    (0,arrays/* isNonEmptyArray */.O)(selection.directives)) {
                    selection.directives.forEach(function (dir) {
                        var name = dir.name.value;
                        if (name === "client")
                            clientOnly = true;
                        if (name === "defer") {
                            var args = (0,storeUtils/* argumentsObjectFromField */.NC)(dir, context.variables);
                            // The @defer directive takes an optional args.if boolean
                            // argument, similar to @include(if: boolean). Note that
                            // @defer(if: false) does not make context.deferred false, but
                            // instead behaves as if there was no @defer directive.
                            if (!args || args.if !== false) {
                                deferred = true;
                            }
                            // TODO In the future, we may want to record args.label using
                            // context.deferred, if a label is specified.
                        }
                    });
                }
                if ((0,storeUtils/* isField */.My)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
                }
                else {
                    var fragment = (0,graphql_fragments/* getFragmentFromSelection */.hi)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD) {
                        throw (0,globals/* newInvariantError */._K)(13, selection.name.value);
                    }
                    if (fragment &&
                        policies.fragmentMatches(fragment, typename, result, context.variables)) {
                        flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
                    }
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0,storeUtils/* isReference */.Yk)(incoming)) {
            var e_1 = 
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            (!(0,arrays/* isArray */.k)(incoming) &&
                // Likewise, existing must be either a Reference or a StoreObject
                // in order for its fields to be safe to merge with the fields of
                // the incoming object.
                ((0,storeUtils/* isReference */.Yk)(existing) || storeValueIsStoreObject(existing))) ?
                existing
                : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) {
                getStorageArgs = [(0,storeUtils/* isReference */.Yk)(e_1) ? e_1.__ref : e_1];
            }
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function (from, name) {
                return ((0,arrays/* isArray */.k)(from) ?
                    typeof name === "number" ?
                        from[name]
                        : void 0
                    : context.store.getFieldValue(from, String(name)));
            };
            mergeTree.map.forEach(function (childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal)
                    return;
                if (getStorageArgs) {
                    getStorageArgs.push(storeFieldName);
                }
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) {
                    (0,globals/* invariant */.kG)(getStorageArgs.pop() === storeFieldName);
                }
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = ((0,arrays/* isArray */.k)(i_1) ? i_1.slice(0) : (0,tslib_es6/* __assign */.pi)({}, i_1));
                changedFields_1.forEach(function (value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) {
            return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        }
        return incoming;
    };
    return StoreWriter;
}());

var emptyMergeTreePool = [];
function getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) {
        map.set(name, emptyMergeTreePool.pop() || { map: new Map() });
    }
    return map.get(name);
}
function mergeMergeTrees(left, right) {
    if (left === right || !right || mergeTreeIsEmpty(right))
        return left;
    if (!left || mergeTreeIsEmpty(left))
        return right;
    var info = left.info && right.info ? (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map()
        : left.map.size ? left.map
            : right.map;
    var merged = { info: info, map: map };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function (leftTree, key) {
            merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function (key) {
            merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && mergeTreeIsEmpty(childTree)) {
        emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function (objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing)
        return;
    var incoming = getChild(incomingObj);
    if (!incoming)
        return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0,storeUtils/* isReference */.Yk)(existing))
        return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0,equality_lib/* equal */.D)(existing, incoming))
        return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function (key) { return store.getFieldValue(incoming, key) !== void 0; })) {
        return;
    }
    var parentType = store.getFieldValue(existingRef, "__typename") ||
        store.getFieldValue(incomingObj, "__typename");
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if (warnings.has(typeDotName))
        return;
    warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0,arrays/* isArray */.k)(existing) && !(0,arrays/* isArray */.k)(incoming)) {
        [existing, incoming].forEach(function (child) {
            var typename = store.getFieldValue(child, "__typename");
            if (typeof typename === "string" && !childTypenames.includes(typename)) {
                childTypenames.push(typename);
            }
        });
    }
    globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(14, fieldName, parentType, childTypenames.length ?
        "either ensure all objects of type " +
            childTypenames.join(" and ") +
            " have an ID or a custom merge function, or "
        : "", typeDotName, existing, incoming);
}
//# sourceMappingURL=writeToStore.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js


// Make builtins like Map and Set safe to use with non-extensible objects.













var InMemoryCache = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new DocumentTransform/* DocumentTransform */.A(transform/* addTypenameToDocument */.Gw);
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = reactiveVars/* makeVar */.QS;
        _this.txCount = 0;
        _this.config = normalizeConfig(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new Policies({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies,
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function () {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = (this.data = new EntityStore.Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching,
        }));
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new StoreWriter(this, (this.storeReader = new StoreReader({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: shouldCanonizeResults(this.config),
            canon: resetResultIdentities ? void 0 : (previousReader && previousReader.canon),
            fragments: fragments,
        })), fragments);
        this.maybeBroadcastWatch = (0,lib/* wrap */.re)(function (c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize,
            makeCacheKey: function (c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if (supportsResultCaching(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, 
                    // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0,object_canon/* canonicalStringify */.B)({ optimistic: optimistic, id: id, variables: variables }));
                }
            },
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([this.data.group, this.optimisticData.group]).forEach(function (group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function (data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function (options) {
        var 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, 
        // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return (this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: returnPartialData })).result || null);
        }
        catch (e) {
            if (e instanceof MissingFieldError) {
                // Swallow MissingFieldError and return null, so callers do not need to
                // worry about catching "normal" exceptions resulting from incomplete
                // cache data. Unexpected errors will be re-thrown. If you need more
                // information about which fields were missing, use cache.diff instead,
                // and examine diffResult.missing.
                return null;
            }
            throw e;
        }
    };
    InMemoryCache.prototype.write = function (options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.modify = function (options) {
        if (hasOwn.call(options, "id") && !options.id) {
            // To my knowledge, TypeScript does not currently provide a way to
            // enforce that an optional property?:type must *not* be undefined
            // when present. That ability would be useful here, because we want
            // options.id to default to ROOT_QUERY only when no options.id was
            // provided. If the caller attempts to pass options.id with a
            // falsy/undefined value (perhaps because cache.identify failed), we
            // should not assume the goal was to modify the ROOT_QUERY object.
            // We could throw, but it seems natural to return false to indicate
            // that nothing was modified.
            return false;
        }
        var store = ((options.optimistic) // Defaults to false.
        ) ?
            this.optimisticData
            : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.diff = function (options) {
        return this.storeReader.diffQueryAgainstStore((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { store: options.optimistic ? this.optimisticData : this.data, rootId: options.id || "ROOT_QUERY", config: this.config }));
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        if (!this.watches.size) {
            // In case we previously called forgetCache(this) because
            // this.watches became empty (see below), reattach this cache to any
            // reactive variables on which it previously depended. It might seem
            // paradoxical that we're able to recall something we supposedly
            // forgot, but the point of calling forgetCache(this) is to silence
            // useless broadcasts while this.watches is empty, and to allow the
            // cache to be garbage collected. If, however, we manage to call
            // recallCache(this) here, this cache object must not have been
            // garbage collected yet, and should resume receiving updates from
            // reactive variables, now that it has a watcher to notify.
            (0,reactiveVars/* recallCache */._v)(this);
        }
        this.watches.add(watch);
        if (watch.immediate) {
            this.maybeBroadcastWatch(watch);
        }
        return function () {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) {
                (0,reactiveVars/* forgetCache */.li)(_this);
            }
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function (options) {
        object_canon/* canonicalStringify.reset */.B.reset();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) {
                this.resetResultCache(options.resetResultIdentities);
            }
            else if (options.resetResultIdentities) {
                this.storeReader.resetCanon();
            }
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function (rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function (object) {
        if ((0,storeUtils/* isReference */.Yk)(object))
            return object.__ref;
        try {
            return this.policies.identify(object)[0];
        }
        catch (e) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(e);
        }
    };
    InMemoryCache.prototype.evict = function (options) {
        if (!options.id) {
            if (hasOwn.call(options, "id")) {
                // See comment in modify method about why we return false when
                // options.id exists but is falsy/undefined.
                return false;
            }
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { id: "ROOT_QUERY" });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        }
        finally {
            if (!--this.txCount && options.broadcast !== false) {
                this.broadcastWatches();
            }
        }
    };
    InMemoryCache.prototype.reset = function (options) {
        var _this = this;
        this.init();
        object_canon/* canonicalStringify.reset */.B.reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function (watch) { return _this.maybeBroadcastWatch.forget(watch); });
            this.watches.clear();
            (0,reactiveVars/* forgetCache */.li)(this);
        }
        else {
            // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
            // this.broadcastWatches() triggers a broadcast to every current watcher
            // (letting them know their data is now missing). This default behavior is
            // convenient because it means the watches do not have to be manually
            // reestablished after resetting the cache. To prevent this broadcast and
            // cancel all watches, pass true for options.discardWatches.
            this.broadcastWatches();
        }
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function (options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function (layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) {
                _this.data = _this.optimisticData = layer;
            }
            try {
                return (updateResult = update(_this));
            }
            finally {
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) {
            // If an options.onWatchUpdated callback is provided, we want to call it
            // with only the Cache.WatchOptions objects affected by options.update,
            // but there might be dirty watchers already waiting to be broadcast that
            // have nothing to do with the update. To prevent including those watchers
            // in the post-update broadcast, we perform this initial broadcast to
            // collect the dirty watchers, so we can re-dirty them later, after the
            // post-update broadcast, allowing them to receive their pending
            // broadcasts the next time broadcastWatches is called, just as they would
            // if we never called cache.batch.
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch) {
                    alreadyDirty.add(watch);
                    return false;
                } }));
        }
        if (typeof optimistic === "string") {
            // Note that there can be multiple layers with the same optimistic ID.
            // When removeOptimistic(id) is called for that id, all matching layers
            // will be removed, and the remaining layers will be reapplied.
            this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        }
        else if (optimistic === false) {
            // Ensure both this.data and this.optimisticData refer to the root
            // (non-optimistic) layer of the cache during the update. Note that
            // this.data could be a Layer if we are currently executing an optimistic
            // update function, but otherwise will always be an EntityStore.Root
            // instance.
            perform(this.data);
        }
        else {
            // Otherwise, leave this.data and this.optimisticData unchanged and run
            // the update with broadcast batching.
            perform();
        }
        if (typeof removeOptimistic === "string") {
            this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        }
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { onWatchUpdated: function (watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) {
                        // Since onWatchUpdated did not return false, this diff is
                        // about to be broadcast to watch.callback, so we don't need
                        // to re-dirty it with the other alreadyDirty watches below.
                        alreadyDirty.delete(watch);
                    }
                    return result;
                } }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) {
                alreadyDirty.forEach(function (watch) { return _this.maybeBroadcastWatch.dirty(watch); });
            }
        }
        else {
            // If alreadyDirty is empty or we don't have an onWatchUpdated
            // function, we don't need to go to the trouble of wrapping
            // options.onWatchUpdated.
            this.broadcastWatches(options);
        }
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null,
        });
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function (options) {
        var _this = this;
        if (!this.txCount) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c, options); });
        }
    };
    InMemoryCache.prototype.addFragmentsToDocument = function (document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function (document) {
        if (this.addTypename) {
            return this.addTypenameTransform.transformDocument(document);
        }
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function (c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") {
                diff.fromOptimisticTransaction = true;
            }
            if (options.onWatchUpdated &&
                options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
                // Returning false from the onWatchUpdated callback will prevent
                // calling c.callback(diff) for this watcher.
                return;
            }
        }
        if (!lastDiff || !(0,equality_lib/* equal */.D)(lastDiff.result, diff.result)) {
            c.callback((c.lastDiff = diff), lastDiff);
        }
    };
    return InMemoryCache;
}(ApolloCache));

//# sourceMappingURL=inMemoryCache.js.map

/***/ }),

/***/ 80900:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ canonicalStringify; },
/* harmony export */   "h": function() { return /* binding */ ObjectCanon; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75028);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30320);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21436);




function shallowCopy(value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value)) {
        return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .isArray */ .k)(value) ?
            value.slice(0)
            : (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .pi)({ __proto__: Object.getPrototypeOf(value) }, value);
    }
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var ObjectCanon = /** @class */ (function () {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .canUseWeakSet */ .sy ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new _wry_trie__WEBPACK_IMPORTED_MODULE_0__/* .Trie */ .B(_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .canUseWeakMap */ .mr);
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function (value) {
        return (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function (value) {
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value)) {
            var copy = shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function (value) {
        var _this = this;
        if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value)) {
            var original = this.passes.get(value);
            if (original)
                return original;
            var proto = Object.getPrototypeOf(value);
            switch (proto) {
                case Array.prototype: {
                    if (this.known.has(value))
                        return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add((node.array = array));
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(array);
                        }
                    }
                    return node.array;
                }
                case null:
                case Object.prototype: {
                    if (this.known.has(value))
                        return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [proto_1];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function (key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = (node.object = Object.create(proto_1));
                        this.known.add(obj_1);
                        keys.sorted.forEach(function (key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) {
                            Object.freeze(obj_1);
                        }
                    }
                    return node.object;
                }
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function (obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) {
                this.keysByJSON.set(json, (node.keys = { sorted: keys, json: json }));
            }
        }
        return node.keys;
    };
    return ObjectCanon;
}());

// Since the keys of canonical objects are always created in lexicographically
// sorted order, we can use the ObjectCanon to implement a fast and stable
// version of JSON.stringify, which automatically sorts object keys.
var canonicalStringify = Object.assign(function (value) {
    if ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value)) {
        if (stringifyCanon === void 0) {
            resetCanonicalStringify();
        }
        var canonical = stringifyCanon.admit(value);
        var json = stringifyCache.get(canonical);
        if (json === void 0) {
            stringifyCache.set(canonical, (json = JSON.stringify(canonical)));
        }
        return json;
    }
    return JSON.stringify(value);
}, {
    reset: resetCanonicalStringify,
});
// Can be reset by calling canonicalStringify.reset().
var stringifyCanon;
var stringifyCache;
function resetCanonicalStringify() {
    stringifyCanon = new ObjectCanon();
    stringifyCache = new (_utilities_index_js__WEBPACK_IMPORTED_MODULE_4__/* .canUseWeakMap */ .mr ? WeakMap : Map)();
}
//# sourceMappingURL=object-canon.js.map

/***/ }),

/***/ 66438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ makeVar; },
/* harmony export */   "_v": function() { return /* binding */ recallCache; },
/* harmony export */   "ab": function() { return /* binding */ cacheSlot; },
/* harmony export */   "li": function() { return /* binding */ forgetCache; }
/* harmony export */ });
/* harmony import */ var optimism__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31662);

// Contextual Slot that acquires its value when custom read functions are
// called in Policies#readField.
var cacheSlot = new optimism__WEBPACK_IMPORTED_MODULE_0__/* .Slot */ .g7();
var cacheInfoMap = new WeakMap();
function getCacheInfo(cache) {
    var info = cacheInfoMap.get(cache);
    if (!info) {
        cacheInfoMap.set(cache, (info = {
            vars: new Set(),
            dep: (0,optimism__WEBPACK_IMPORTED_MODULE_0__/* .dep */ .dP)(),
        }));
    }
    return info;
}
function forgetCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.forgetCache(cache); });
}
// Calling forgetCache(cache) serves to silence broadcasts and allows the
// cache to be garbage collected. However, the varsByCache WeakMap
// preserves the set of reactive variables that were previously associated
// with this cache, which makes it possible to "recall" the cache at a
// later time, by reattaching it to those variables. If the cache has been
// garbage collected in the meantime, because it is no longer reachable,
// you won't be able to call recallCache(cache), and the cache will
// automatically disappear from the varsByCache WeakMap.
function recallCache(cache) {
    getCacheInfo(cache).vars.forEach(function (rv) { return rv.attachCache(cache); });
}
function makeVar(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function (newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function (cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function (listener) { return listener(value); });
            }
        }
        else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = cacheSlot.getValue();
            if (cache) {
                attach(cache);
                getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function (listener) {
        listeners.add(listener);
        return function () {
            listeners.delete(listener);
        };
    };
    var attach = (rv.attachCache = function (cache) {
        caches.add(cache);
        getCacheInfo(cache).vars.add(rv);
        return rv;
    });
    rv.forgetCache = function (cache) { return caches.delete(cache); };
    return rv;
}
function broadcast(cache) {
    if (cache.broadcastWatches) {
        cache.broadcastWatches();
    }
}
//# sourceMappingURL=reactiveVars.js.map

/***/ }),

/***/ 20874:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ ApolloClient; }
});

// UNUSED EXPORTS: mergeOptions

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/execute.js

var execute = ApolloLink/* ApolloLink.execute */.i.execute;
//# sourceMappingURL=execute.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/version.js
var version = __webpack_require__(49379);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/HttpLink.js
var HttpLink = __webpack_require__(72198);
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(37280);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(76487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/object-canon.js
var object_canon = __webpack_require__(80900);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/DocumentTransform.js
var DocumentTransform = __webpack_require__(18056);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/asyncMap.js

// Like Observable.prototype.map, except that the mapping function can
// optionally return a Promise (or be async).
function asyncMap(observable, mapFn, catchFn) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function (callback) {
                return new Promise(function (resolve) { return resolve(callback()); });
            },
        };
        function makeCallback(examiner, key) {
            return function (arg) {
                if (examiner) {
                    var both = function () {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ?
                            /* will be swallowed */ 0
                            : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function (result) { return observer.next(result); }, function (error) { return observer.error(error); });
                }
                else {
                    observer[key](arg);
                }
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function () {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function () { return observer.complete(); });
            },
        };
        var sub = observable.subscribe(handler);
        return function () { return sub.unsubscribe(); };
    });
}
//# sourceMappingURL=asyncMap.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/common/errorHandling.js


function graphQLResultHasError(result) {
    var errors = getGraphQLErrorsFromResult(result);
    return (0,arrays/* isNonEmptyArray */.O)(errors);
}
function getGraphQLErrorsFromResult(result) {
    var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors) ? result.errors.slice(0) : [];
    if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) &&
        (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
        result.incremental.forEach(function (incrementalResult) {
            if (incrementalResult.errors) {
                graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
            }
        });
    }
    return graphQLErrors;
}
//# sourceMappingURL=errorHandling.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/objects.js
var objects = __webpack_require__(13154);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/makeUniqueId.js
var makeUniqueId = __webpack_require__(60897);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/iteration.js
function iterateObserversSafely(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function (obs) { return obs[method] && observersWithMethod.push(obs); });
    observersWithMethod.forEach(function (obs) { return obs[method](argument); });
}
//# sourceMappingURL=iteration.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/subclassing.js


// Generic implementations of Observable.prototype methods like map and
// filter need to know how to create a new Observable from an Observable
// subclass (like Concast or ObservableQuery). Those methods assume
// (perhaps unwisely?) that they can call the subtype's constructor with a
// Subscriber function, even though the subclass constructor might expect
// different parameters. Defining this static Symbol.species property on
// the subclass is a hint to generic Observable code to use the default
// constructor instead of trying to do `new Subclass(observer => ...)`.
function fixObservableSubclass(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, { value: zen_observable_ts_module/* Observable */.y });
    }
    if (canUse/* canUseSymbol */.aS && Symbol.species) {
        set(Symbol.species);
    }
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}
//# sourceMappingURL=subclassing.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/observables/Concast.js




function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var Concast = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function (observer) {
            _this.addObserver(observer);
            return function () { return _this.removeObserver(observer); };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function (result) {
                if (_this.sub !== null) {
                    _this.latest = ["next", result];
                    _this.notify("next", result);
                    iterateObserversSafely(_this.observers, "next", result);
                }
            },
            error: function (error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub)
                        setTimeout(function () { return sub.unsubscribe(); });
                    _this.sub = null;
                    _this.latest = ["error", error];
                    _this.reject(error);
                    _this.notify("error", error);
                    iterateObserversSafely(_this.observers, "error", error);
                }
            },
            complete: function () {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub)
                            setTimeout(function () { return sub.unsubscribe(); });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") {
                            _this.resolve(_this.latest[1]);
                        }
                        else {
                            _this.resolve();
                        }
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        iterateObserversSafely(_this.observers, "complete");
                    }
                    else if (isPromiseLike(value)) {
                        value.then(function (obs) { return (_this.sub = obs.subscribe(_this.handlers)); });
                    }
                    else {
                        _this.sub = value.subscribe(_this.handlers);
                    }
                }
            },
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function (reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function (_) { });
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") {
            sources = [new zen_observable_ts_module/* Observable */.y(sources)];
        }
        if (isPromiseLike(sources)) {
            sources.then(function (iterable) { return _this.start(iterable); }, _this.handlers.error);
        }
        else {
            _this.start(sources);
        }
        return _this;
    }
    Concast.prototype.start = function (sources) {
        if (this.sub !== void 0)
            return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function (observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) {
                method.call(observer, this.latest[1]);
            }
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) {
                observer.complete();
            }
        }
    };
    Concast.prototype.addObserver = function (observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function (observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) {
            // In case there are still any listeners in this.nextResultListeners, and
            // no error or completion has been broadcast yet, make sure those
            // observers have a chance to run and then remove themselves from
            // this.observers.
            this.handlers.complete();
        }
    };
    Concast.prototype.notify = function (method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function (listener) { return listener(method, arg); });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function (callback) {
        var called = false;
        this.nextResultListeners.add(function (method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}(zen_observable_ts_module/* Observable */.y));

// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
fixObservableSubclass(Concast);
//# sourceMappingURL=Concast.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var client_errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var core_networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/cloneDeep.js
var cloneDeep = __webpack_require__(79487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/fragments.js
var graphql_fragments = __webpack_require__(23361);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/equalByQuery.js



// Returns true if aResult and bResult are deeply equal according to the fields
// selected by the given query, ignoring any fields marked as @nonreactive.
function equalByQuery(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0,tslib_es6/* __rest */._T)(_a, ["data"]);
    var bData = _b.data, bRest = (0,tslib_es6/* __rest */._T)(_b, ["data"]);
    return ((0,lib/* default */.Z)(aRest, bRest) &&
        equalBySelectionSet((0,getFromAST/* getMainDefinition */.p$)(query).selectionSet, aData, bData, {
            fragmentMap: (0,graphql_fragments/* createFragmentMap */.F)((0,getFromAST/* getFragmentDefinitions */.kU)(query)),
            variables: variables,
        }));
}
function equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) {
        return true;
    }
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function (selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection))
            return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0,directives/* shouldInclude */.LZ)(selection, context.variables))
            return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if (selectionHasNonreactiveDirective(selection))
            return true;
        if ((0,storeUtils/* isField */.My)(selection)) {
            var resultKey = (0,storeUtils/* resultKeyNameFromField */.u2)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) {
                // These are scalar values, so we can compare them with deep equal
                // without redoing the main recursive work.
                return (0,lib/* default */.Z)(aResultChild, bResultChild);
            }
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray)
                return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) {
                    return false;
                }
                for (var i = 0; i < length_1; ++i) {
                    if (!equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) {
                        return false;
                    }
                }
                return true;
            }
            return equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        }
        else {
            var fragment = (0,graphql_fragments/* getFragmentFromSelection */.hi)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if (selectionHasNonreactiveDirective(fragment))
                    return true;
                return equalBySelectionSet(fragment.selectionSet, 
                // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function selectionHasNonreactiveDirective(selection) {
    return (!!selection.directives && selection.directives.some(directiveIsNonreactive));
}
function directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}
//# sourceMappingURL=equalByQuery.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ObservableQuery.js






var ObservableQuery_assign = Object.assign, ObservableQuery_hasOwnProperty = Object.hasOwnProperty;
var ObservableQuery = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function (observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) {
                    subObserver.error = defaultSubscriptionObserverErrorCallback;
                }
            }
            catch (_a) { }
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) {
                observer.error && observer.error(last.error);
            }
            else if (last && last.result) {
                observer.next && observer.next(last.result);
            }
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) {
                // Blindly catching here prevents unhandled promise rejections,
                // and is safe because the ObservableQuery handles this error with
                // this.observer.error, so we're not just swallowing the error by
                // ignoring it here.
                _this.reobserve().catch(function () { });
            }
            return function () {
                if (_this.observers.delete(observer) && !_this.observers.size) {
                    _this.tearDownQuery();
                }
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, 
        // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : (fetchPolicy) : _f;
        _this.options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { 
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy, 
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0,getFromAST/* getOperationDefinition */.$H)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function () {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        get: function () {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function (result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) {
                        _this.queryManager.removeQuery(_this.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject,
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
        if (saveAsLastResult === void 0) { saveAsLastResult = true; }
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus ||
            (lastResult && lastResult.networkStatus) ||
            core_networkStatus/* NetworkStatus.ready */.Ie.ready;
        var result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, lastResult), { loading: (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus), networkStatus: networkStatus });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        skipCacheDataFor(fetchPolicy) ||
            // If this.options.query has @client(always: true) fields, we cannot
            // trust diff.result, since it was read from the cache without running
            // local resolvers (and it's too late to run resolvers now, since we must
            // return a result synchronously).
            this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) {
            // Fall through.
        }
        else if (this.waitForOwnResult) {
            // This would usually be a part of `QueryInfo.getDiff()`.
            // which we skip in the waitForOwnResult case since we are not
            // interested in the diff.
            this.queryInfo["updateWatch"]();
        }
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) {
                result.data = diff.result;
            }
            if ((0,lib/* equal */.D)(result.data, {})) {
                result.data = void 0;
            }
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete &&
                    result.networkStatus === core_networkStatus/* NetworkStatus.loading */.Ie.loading &&
                    (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = core_networkStatus/* NetworkStatus.ready */.Ie.ready;
                    result.loading = false;
                }
            }
            else {
                result.partial = true;
            }
            if (globalThis.__DEV__ !== false &&
                !diff.complete &&
                !this.options.partialRefetch &&
                !result.loading &&
                !result.data &&
                !result.error) {
                logMissingFieldErrors(diff.missing);
            }
        }
        if (saveAsLastResult) {
            this.updateLastResult(result);
        }
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult, variables) {
        if (!this.last) {
            return true;
        }
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ?
            !equalByQuery(this.query, this.last.result, newResult, this.variables)
            : !(0,lib/* equal */.D)(this.last.result, newResult);
        return (resultIsDifferent || (variables && !(0,lib/* equal */.D)(this.last.variables, variables)));
    };
    ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
        var last = this.last;
        if (last &&
            last[key] &&
            (!variablesMustMatch || (0,lib/* equal */.D)(last.variables, this.variables))) {
            return last[key];
        }
    };
    ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function () {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.refetch = function (variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0,
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") {
            reobserveOptions.fetchPolicy = fetchPolicy;
        }
        else if (fetchPolicy === "no-cache") {
            reobserveOptions.fetchPolicy = "no-cache";
        }
        else {
            reobserveOptions.fetchPolicy = "network-only";
        }
        if (globalThis.__DEV__ !== false && variables && ObservableQuery_hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0,getFromAST/* getQueryDefinition */.iW)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function (v) { return v.variable.name.value === "variables"; })) {
                globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(
                    20,
                    variables,
                    ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef
                );
            }
        }
        if (variables && !(0,lib/* equal */.D)(this.options.variables, variables)) {
            // Update the existing options with new variables
            reobserveOptions.variables = this.options.variables = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), variables);
        }
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, core_networkStatus/* NetworkStatus.refetch */.Ie.refetch);
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (fetchMoreOptions.query ? fetchMoreOptions : ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options), { query: this.options.query }), fetchMoreOptions), { variables: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.options.variables), fetchMoreOptions.variables) })))), { 
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache" });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery =
            fetchMoreOptions.query ?
                this.transformDocument(this.options.query)
                : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) {
            this.observe();
        }
        var updatedQuerySet = new Set();
        return this.queryManager
            .fetchQuery(qid, combinedOptions, core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore)
            .then(function (fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore) {
                queryInfo.networkStatus = originalNetworkStatus;
            }
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function (cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) {
                        cache.updateQuery({
                            query: _this.query,
                            variables: _this.variables,
                            returnPartialData: true,
                            optimistic: false,
                        }, function (previous) {
                            return updateQuery(previous, {
                                fetchMoreResult: fetchMoreResult.data,
                                variables: combinedOptions.variables,
                            });
                        });
                    }
                    else {
                        // If we're using a field policy instead of updateQuery, the only
                        // thing we need to do is write the new data to the cache using
                        // combinedOptions.variables (instead of this.variables, which is
                        // what this.updateQuery uses, because it works by abusing the
                        // original field value, keyed by the original variables).
                        cache.writeQuery({
                            query: combinedOptions.query,
                            variables: combinedOptions.variables,
                            data: fetchMoreResult.data,
                        });
                    }
                },
                onWatchUpdated: function (watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                },
            });
            return fetchMoreResult;
        })
            .finally(function () {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) {
                reobserveCacheFirst(_this);
            }
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context,
        })
            .subscribe({
            next: function (subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(21, err);
            },
        });
        this.subscriptions.add(subscription);
        return function () {
            if (_this.subscriptions.delete(subscription)) {
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function (newOptions) {
        var mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        ObservableQuery_assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */
    ObservableQuery.prototype.setVariables = function (variables) {
        if ((0,lib/* equal */.D)(this.variables, variables)) {
            // If we have no observers, then we don't actually want to make a network
            // request. As soon as someone observes the query, the request will kick
            // off. For now, we just store any changes. (See #1077)
            return this.observers.size ? this.result() : Promise.resolve();
        }
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) {
            return Promise.resolve();
        }
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables,
        }, core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables);
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables,
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables,
            });
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function (reason, 
    // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") {
                // Do nothing, leaving options.fetchPolicy unchanged.
            }
            else if (typeof options.nextFetchPolicy === "function") {
                // When someone chooses "cache-and-network" or "network-only" as their
                // initial FetchPolicy, they often do not want future cache updates to
                // trigger unconditional network requests, which is what repeatedly
                // applying the "cache-and-network" or "network-only" policies would
                // seem to imply. Instead, when the cache reports an update after the
                // initial network request, it may be desirable for subsequent network
                // requests to be triggered only if the cache result is incomplete. To
                // that end, the options.nextFetchPolicy option provides an easy way to
                // update options.fetchPolicy after the initial network request, without
                // having to call observableQuery.setOptions.
                options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                    reason: reason,
                    options: options,
                    observable: this,
                    initialFetchPolicy: initialFetchPolicy,
                });
            }
            else if (reason === "variables-changed") {
                options.fetchPolicy = initialFetchPolicy;
            }
            else {
                options.fetchPolicy = options.nextFetchPolicy;
            }
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function (options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function () {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) {
            return;
        }
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) {
            return;
        }
        (0,globals/* invariant */.kG)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function () {
            if (_this.pollingInfo) {
                if (!(0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(_this.queryInfo.networkStatus)) {
                    _this.reobserve({
                        // Most fetchPolicy options don't make sense to use in a polling context, as
                        // users wouldn't want to be polling the cache directly. However, network-only and
                        // no-cache are both useful for when the user wants to control whether or not the
                        // polled results are written to the cache.
                        fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ?
                            "no-cache"
                            : "network-only",
                    }, core_networkStatus/* NetworkStatus.poll */.Ie.poll).then(poll, poll);
                }
                else {
                    poll();
                }
            }
        };
        var poll = function () {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
        if (variables === void 0) { variables = this.variables; }
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0,lib/* equal */.D)(variables, this.last.variables)) {
            error = void 0;
        }
        return (this.last = (0,tslib_es6/* __assign */.pi)({ result: this.queryManager.assumeImmutableResults ?
                newResult
                : (0,cloneDeep/* cloneDeep */.X)(newResult), variables: variables }, (error ? { error: error } : null)));
    };
    ObservableQuery.prototype.reobserveAsConcast = function (newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = 
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch ||
            // The fetchMore method does not actually call the reobserve method, but,
            // if it did, it would definitely use a disposable Concast.
            newNetworkStatus === core_networkStatus/* NetworkStatus.fetchMore */.Ie.fetchMore ||
            // Polling uses a disposable Concast so the polling options (which force
            // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
            newNetworkStatus === core_networkStatus/* NetworkStatus.poll */.Ie.poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0,compact/* compact */.o)(this.options, newOptions || {});
        var options = useDisposableConcast ?
            // Disposable Concast fetches receive a shallow copy of this.options
            // (merged with newOptions), leaving this.options unmodified.
            mergedOptions
            : ObservableQuery_assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions &&
                newOptions.variables &&
                !(0,lib/* equal */.D)(newOptions.variables, oldVariables) &&
                // Don't mess with the fetchPolicy if it's currently "standby".
                options.fetchPolicy !== "standby" &&
                // If we're changing the fetchPolicy anyway, don't try to change it here
                // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
                options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) {
                    newNetworkStatus = core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables;
                }
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function () {
            if (_this.concast === concast) {
                _this.waitForOwnResult = false;
            }
        };
        var variables = options.variables && (0,tslib_es6/* __assign */.pi)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function (result) {
                finishWaitingForOwnResult();
                _this.reportResult(result, variables);
            },
            error: function (error) {
                finishWaitingForOwnResult();
                _this.reportError(error, variables);
            },
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) {
                this.concast.removeObserver(this.observer);
            }
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus)
            .promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function () {
        this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function (result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) {
            this.updateLastResult(result, variables);
        }
        if (lastError || isDifferent) {
            iterateObserversSafely(this.observers, "next", result);
        }
    };
    ObservableQuery.prototype.reportError = function (error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getLastResult()), { error: error, errors: error.graphQLErrors, networkStatus: core_networkStatus/* NetworkStatus.error */.Ie.error, loading: false });
        this.updateLastResult(errorResult, variables);
        iterateObserversSafely(this.observers, "error", (this.last.error = error));
    };
    ObservableQuery.prototype.hasObservers = function () {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        if (this.isTornDown)
            return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function (document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}(zen_observable_ts_module/* Observable */.y));

// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
fixObservableSubclass(ObservableQuery);
// Reobserve with fetchPolicy effectively set to "cache-first", triggering
// delivery of any new data from the cache, possibly falling back to the network
// if any cache data are missing. This allows _complete_ cache results to be
// delivered without also kicking off unnecessary network requests when
// this.options.fetchPolicy is "cache-and-network" or "network-only". When
// this.options.fetchPolicy is any other policy ("cache-first", "cache-only",
// "standby", or "no-cache"), we call this.reobserve() as usual.
function reobserveCacheFirst(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") {
        return obsQuery.reobserve({
            fetchPolicy: "cache-first",
            // Use a temporary nextFetchPolicy function that replaces itself with the
            // previous nextFetchPolicy value and returns the original fetchPolicy.
            nextFetchPolicy: function (currentFetchPolicy, context) {
                // Replace this nextFetchPolicy function in the options object with the
                // original this.options.nextFetchPolicy value.
                this.nextFetchPolicy = nextFetchPolicy;
                // If the original nextFetchPolicy value was a function, give it a
                // chance to decide what happens here.
                if (typeof this.nextFetchPolicy === "function") {
                    return this.nextFetchPolicy(currentFetchPolicy, context);
                }
                // Otherwise go back to the original this.options.fetchPolicy.
                return fetchPolicy;
            },
        });
    }
    return obsQuery.reobserve();
}
function defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(23, error.message, error.stack);
}
function logMissingFieldErrors(missing) {
    if (globalThis.__DEV__ !== false && missing) {
        globalThis.__DEV__ !== false && globals/* invariant.debug */.kG.debug(24, missing);
    }
}
function skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */) {
    return (fetchPolicy === "network-only" ||
        fetchPolicy === "no-cache" ||
        fetchPolicy === "standby");
}
//# sourceMappingURL=ObservableQuery.js.map
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
;// CONCATENATED MODULE: ./node_modules/graphql/language/predicates.mjs

function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
  return node.kind === Kind.OPERATION_DEFINITION || node.kind === Kind.FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
  return node.kind === kinds/* Kind.FIELD */.h.FIELD || node.kind === kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD || node.kind === kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT;
}
function isValueNode(node) {
  return node.kind === Kind.VARIABLE || node.kind === Kind.INT || node.kind === Kind.FLOAT || node.kind === Kind.STRING || node.kind === Kind.BOOLEAN || node.kind === Kind.NULL || node.kind === Kind.ENUM || node.kind === Kind.LIST || node.kind === Kind.OBJECT;
}
function isTypeNode(node) {
  return node.kind === Kind.NAMED_TYPE || node.kind === Kind.LIST_TYPE || node.kind === Kind.NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
  return node.kind === Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === Kind.DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_DEFINITION || node.kind === Kind.OBJECT_TYPE_DEFINITION || node.kind === Kind.INTERFACE_TYPE_DEFINITION || node.kind === Kind.UNION_TYPE_DEFINITION || node.kind === Kind.ENUM_TYPE_DEFINITION || node.kind === Kind.INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
  return node.kind === Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return node.kind === Kind.SCALAR_TYPE_EXTENSION || node.kind === Kind.OBJECT_TYPE_EXTENSION || node.kind === Kind.INTERFACE_TYPE_EXTENSION || node.kind === Kind.UNION_TYPE_EXTENSION || node.kind === Kind.ENUM_TYPE_EXTENSION || node.kind === Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeDeep.js
var mergeDeep = __webpack_require__(182);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/reactiveVars.js
var reactiveVars = __webpack_require__(66438);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/LocalState.js





var LocalState = /** @class */ (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = (0,mergeDeep/* mergeDeep */.Ee)(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_c) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, remoteResult), { data: localResult.result })); })];
                }
                return [2 /*return*/, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function (document) {
        if ((0,directives/* hasDirectives */.FS)(["client"], document)) {
            if (this.resolvers) {
                return document;
            }
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function (document) {
        return (0,transform/* removeClientSetsFromDocument */.ob)(document);
    };
    LocalState.prototype.prepareContext = function (context) {
        var cache = this.cache;
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, 
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function (obj) {
                return cache.identify(obj);
            } });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (document) {
                    return [2 /*return*/, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, variables), data.exportedVariables)); })];
                }
                return [2 /*return*/, (0,tslib_es6/* __assign */.pi)({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        (0,visitor/* visit */.Vn)(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === "always" &&
                                arg.value.kind === "BooleanValue" &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return visitor/* BREAK */.$_;
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: (0,transform/* buildQueryFromSelectionSet */.aL)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_b) {
                mainDefinition = (0,getFromAST/* getMainDefinition */.p$)(document);
                fragments = (0,getFromAST/* getFragmentDefinitions */.kU)(document);
                fragmentMap = (0,graphql_fragments/* createFragmentMap */.F)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ?
                    definitionOperation.charAt(0).toUpperCase() +
                        definitionOperation.slice(1)
                    : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { cache: cache, client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                isClientFieldDescendant = false;
                return [2 /*return*/, this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return (0,tslib_es6/* __awaiter */.mG)(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                        if (!isClientFieldDescendant &&
                            !execContext.selectionsToResolve.has(selection)) {
                            // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [2 /*return*/];
                        }
                        if (!(0,directives/* shouldInclude */.LZ)(selection, variables)) {
                            // Skip this entirely.
                            return [2 /*return*/];
                        }
                        if ((0,storeUtils/* isField */.My)(selection)) {
                            return [2 /*return*/, this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") {
                                        resultsToMerge.push((_a = {},
                                            _a[(0,storeUtils/* resultKeyNameFromField */.u2)(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if ((0,storeUtils/* isInlineFragment */.Ao)(selection)) {
                            fragment = selection;
                        }
                        else {
                            // This is a named fragment.
                            fragment = fragmentMap[selection.name.value];
                            (0,globals/* invariant */.kG)(fragment, 18, selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2 /*return*/, this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2 /*return*/];
                    });
                }); };
                return [2 /*return*/, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return (0,mergeDeep/* mergeDeepArray */.bw)(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, isClientFieldDescendant, rootValue, execContext) {
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_a) {
                if (!rootValue) {
                    return [2 /*return*/, null];
                }
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0,storeUtils/* resultKeyNameFromField */.u2)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(
                            // In case the resolve function accesses reactive variables,
                            // set cacheSlot to the current cache instance.
                            reactiveVars/* cacheSlot.withValue */.ab.withValue(this.cache, resolve, [
                                rootValue,
                                (0,storeUtils/* argumentsObjectFromField */.NC)(field, variables),
                                execContext.context,
                                { field: field, fragmentMap: execContext.fragmentMap },
                            ]));
                        }
                    }
                }
                return [2 /*return*/, resultPromise.then(function (result) {
                        var _a, _b;
                        if (result === void 0) { result = defaultResult; }
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === "export" && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === "as" && arg.value.kind === "StringValue") {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        // Handle all scalar types here.
                        if (!field.selectionSet) {
                            return result;
                        }
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) {
                            // Basically any field in a GraphQL response can be null, or missing
                            return result;
                        }
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function (d) { return d.name.value === "client"; })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        }
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            // This is a nested array, recurse.
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            }
            // This is an object, run the selection set on it.
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
            }
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function (mainDefinition, fragmentMap) {
        var isSingleASTNode = function (node) { return !Array.isArray(node); };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0,visitor/* visit */.Vn)(definitionNode, {
                    Directive: function (node, _, __, ___, ancestors) {
                        if (node.name.value === "client") {
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                        }
                    },
                    FragmentSpread: function (spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0,globals/* invariant */.kG)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function (node) {
                                if (isSingleASTNode(node) && isSelectionNode(node)) {
                                    matches_1.add(node);
                                }
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function (selection) {
                                matches_1.add(selection);
                            });
                        }
                    },
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}());

//# sourceMappingURL=LocalState.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryInfo.js







var destructiveMethodCounts = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
function wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") {
        cache[methodName] = function () {
            destructiveMethodCounts.set(cache, 
            // The %1e15 allows the count to wrap around to 0 safely every
            // quadrillion evictions, so there's no risk of overflow. To be
            // clear, this is more of a pedantic principle than something
            // that matters in any conceivable practical scenario.
            (destructiveMethodCounts.get(cache) + 1) % 1e15);
            // @ts-expect-error this is just too generic to be typed correctly
            return original.apply(this, arguments);
        };
    }
}
function cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var QueryInfo = /** @class */ (function () {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) { queryId = queryManager.generateQueryId(); }
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = (this.cache = queryManager.cache);
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!destructiveMethodCounts.has(cache)) {
            destructiveMethodCounts.set(cache, 0);
            wrapDestructiveCacheMethod(cache, "evict");
            wrapDestructiveCacheMethod(cache, "modify");
            wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function (query) {
        var networkStatus = query.networkStatus || core_networkStatus/* NetworkStatus.loading */.Ie.loading;
        if (this.variables &&
            this.networkStatus !== core_networkStatus/* NetworkStatus.loading */.Ie.loading &&
            !(0,lib/* equal */.D)(this.variables, query.variables)) {
            networkStatus = core_networkStatus/* NetworkStatus.setVariables */.Ie.setVariables;
        }
        if (!(0,lib/* equal */.D)(query.variables, this.variables)) {
            this.lastDiff = void 0;
        }
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus,
        });
        if (query.observableQuery) {
            this.setObservableQuery(query.observableQuery);
        }
        if (query.lastRequestId) {
            this.lastRequestId = query.lastRequestId;
        }
        return this;
    };
    QueryInfo.prototype.reset = function () {
        cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.getDiff = function () {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0,lib/* equal */.D)(options, this.lastDiff.options)) {
            return this.lastDiff.diff;
        }
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return { complete: false };
        }
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function (diff, options) {
        this.lastDiff =
            diff ?
                {
                    diff: diff,
                    options: options || this.getDiffOptions(),
                }
                : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function (variables) {
        var _a;
        if (variables === void 0) { variables = this.variables; }
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults,
        };
    };
    QueryInfo.prototype.setDiff = function (diff) {
        var _this = this;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0,lib/* equal */.D)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) {
                this.notifyTimeout = setTimeout(function () { return _this.notify(); }, 0);
            }
        }
    };
    QueryInfo.prototype.setObservableQuery = function (oq) {
        var _this = this;
        if (oq === this.observableQuery)
            return;
        if (this.oqListener) {
            this.listeners.delete(this.oqListener);
        }
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add((this.oqListener = function () {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) {
                    // If this diff came from an optimistic transaction, deliver the
                    // current cache data to the ObservableQuery, but don't perform a
                    // reobservation, since oq.reobserveCacheFirst might make a network
                    // request, and we never want to trigger network requests in the
                    // middle of optimistic updates.
                    oq["observe"]();
                }
                else {
                    // Otherwise, make the ObservableQuery "reobserve" the latest data
                    // using a temporary fetch policy of "cache-first", so complete cache
                    // results have a chance to be delivered without triggering additional
                    // network requests, even when options.fetchPolicy is "network-only"
                    // or "cache-and-network". All other fetch policies are preserved by
                    // this method, and are handled by calling oq.reobserve(). If this
                    // reobservation is spurious, isDifferentFromLastResult still has a
                    // chance to catch it before delivery to ObservableQuery subscribers.
                    reobserveCacheFirst(oq);
                }
            }));
        }
        else {
            delete this.oqListener;
        }
    };
    QueryInfo.prototype.notify = function () {
        var _this = this;
        cancelNotifyTimeout(this);
        if (this.shouldNotify()) {
            this.listeners.forEach(function (listener) { return listener(_this); });
        }
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function () {
        if (!this.dirty || !this.listeners.size) {
            return false;
        }
        if ((0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") {
                return false;
            }
        }
        return true;
    };
    QueryInfo.prototype.stop = function () {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq)
                oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function () { };
    QueryInfo.prototype.updateWatch = function (variables) {
        var _this = this;
        if (variables === void 0) { variables = this.variables; }
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") {
            return;
        }
        var watchOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDiffOptions(variables)), { watcher: this, callback: function (diff) { return _this.setDiff(diff); } });
        if (!this.lastWatch || !(0,lib/* equal */.D)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch((this.lastWatch = watchOptions));
        }
    };
    QueryInfo.prototype.resetLastWrite = function () {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function (result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite &&
            // If cache.evict has been called since the last time we wrote this
            // data into the cache, there's a chance writing this result into
            // the cache will repair what was evicted.
            lastWrite.dmCount === destructiveMethodCounts.get(this.cache) &&
            (0,lib/* equal */.D)(variables, lastWrite.variables) &&
            (0,lib/* equal */.D)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function (result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new mergeDeep/* DeepMerger */.w0();
        var graphQLErrors = (0,arrays/* isNonEmptyArray */.O)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
            var mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(this.getDiff().result, result);
            result.data = mergedData;
            // Detect the first chunk of a deferred query and merge it with existing
            // cache data. This ensures a `cache-first` fetch policy that returns
            // partial cache data or a `cache-and-network` fetch policy that already
            // has full data in the cache does not complain when trying to merge the
            // initial deferred server data with existing cache data.
        }
        else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") {
            this.updateLastDiff({ result: result.data, complete: true }, this.getDiffOptions(options.variables));
        }
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */) {
            if (shouldWriteResult(result, options.errorPolicy)) {
                // Using a transaction here so we have a chance to read the result
                // back from the cache before the watch callback fires as a result
                // of writeQuery, so we can store the new diff quietly and ignore
                // it when we receive it redundantly from the watch callback.
                this.cache.performTransaction(function (cache) {
                    if (_this.shouldWrite(result, options.variables)) {
                        cache.writeQuery({
                            query: document,
                            data: result.data,
                            variables: options.variables,
                            overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */,
                        });
                        _this.lastWrite = {
                            result: result,
                            variables: options.variables,
                            dmCount: destructiveMethodCounts.get(_this.cache),
                        };
                    }
                    else {
                        // If result is the same as the last result we received from
                        // the network (and the variables match too), avoid writing
                        // result into the cache again. The wisdom of skipping this
                        // cache write is far from obvious, since any cache write
                        // could be the one that puts the cache back into a desired
                        // state, fixing corruption or missing data. However, if we
                        // always write every network result into the cache, we enable
                        // feuds between queries competing to update the same data in
                        // incompatible ways, which can lead to an endless cycle of
                        // cache broadcasts and useless network requests. As with any
                        // feud, eventually one side must step back from the brink,
                        // letting the other side(s) have the last word(s). There may
                        // be other points where we could break this cycle, such as
                        // silencing the broadcast for cache.writeQuery (not a good
                        // idea, since it just delays the feud a bit) or somehow
                        // avoiding the network request that just happened (also bad,
                        // because the server could return useful new data). All
                        // options considered, skipping this cache write seems to be
                        // the least damaging place to break the cycle, because it
                        // reflects the intuition that we recently wrote this exact
                        // result into the cache, so the cache *should* already/still
                        // contain this data. If some other query has clobbered that
                        // data in the meantime, that's too bad, but there will be no
                        // winners if every query blindly reverts to its own version
                        // of the data. This approach also gives the network a chance
                        // to return new data, which will be written into the cache as
                        // usual, notifying only those queries that are directly
                        // affected by the cache updates, as usual. In the future, an
                        // even more sophisticated cache could perhaps prevent or
                        // mitigate the clobbering somehow, but that would make this
                        // particular cache write even less important, and thus
                        // skipping it would be even safer than it is today.
                        if (_this.lastDiff && _this.lastDiff.diff.complete) {
                            // Reuse data from the last good (complete) diff that we
                            // received, when possible.
                            result.data = _this.lastDiff.diff.result;
                            return;
                        }
                        // If the previous this.diff was incomplete, fall through to
                        // re-reading the latest data with cache.diff, below.
                    }
                    var diffOptions = _this.getDiffOptions(options.variables);
                    var diff = cache.diff(diffOptions);
                    // In case the QueryManager stops this QueryInfo before its
                    // results are delivered, it's important to avoid restarting the
                    // cache watch when markResult is called. We also avoid updating
                    // the watch if we are writing a result that doesn't match the current
                    // variables to avoid race conditions from broadcasting the wrong
                    // result.
                    if (!_this.stopped && (0,lib/* equal */.D)(_this.variables, options.variables)) {
                        // Any time we're about to update this.diff, we need to make
                        // sure we've started watching the cache.
                        _this.updateWatch(options.variables);
                    }
                    // If we're allowed to write to the cache, and we can read a
                    // complete result from the cache, update result.data to be the
                    // result from the cache, rather than the raw network result.
                    // Set without setDiff to avoid triggering a notify call, since
                    // we have other ways of notifying for this result.
                    _this.updateLastDiff(diff, diffOptions);
                    if (diff.complete) {
                        result.data = diff.result;
                    }
                });
            }
            else {
                this.lastWrite = void 0;
            }
        }
    };
    QueryInfo.prototype.markReady = function () {
        this.networkError = null;
        return (this.networkStatus = core_networkStatus/* NetworkStatus.ready */.Ie.ready);
    };
    QueryInfo.prototype.markError = function (error) {
        this.networkStatus = core_networkStatus/* NetworkStatus.error */.Ie.error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) {
            this.graphQLErrors = error.graphQLErrors;
        }
        if (error.networkError) {
            this.networkError = error.networkError;
        }
        return error;
    };
    return QueryInfo;
}());

function shouldWriteResult(result, errorPolicy) {
    if (errorPolicy === void 0) { errorPolicy = "none"; }
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !graphQLResultHasError(result);
    if (!writeWithErrors && ignoreErrors && result.data) {
        writeWithErrors = true;
    }
    return writeWithErrors;
}
//# sourceMappingURL=QueryInfo.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/print.js + 1 modules
var print = __webpack_require__(5144);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/QueryManager.js















var QueryManager_hasOwnProperty = Object.prototype.hasOwnProperty;
var QueryManager = /** @class */ (function () {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new Map();
        var defaultDocumentTransform = new DocumentTransform/* DocumentTransform */.A(function (document) { return _this.cache.transformDocument(document); }, 
        // Allow the apollo cache to manage its own transform caches
        { cache: false });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: cache });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform =
            documentTransform ?
                defaultDocumentTransform
                    .concat(documentTransform)
                    // The custom document transform may add new fragment spreads or new
                    // field selections, so we want to give the cache a chance to run
                    // again. For example, the InMemoryCache adds __typename to field
                    // selections and fragments from the fragment registry.
                    .concat(defaultDocumentTransform)
                : defaultDocumentTransform;
        if ((this.onBroadcast = onBroadcast)) {
            this.mutationStore = Object.create(null);
        }
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0,globals/* newInvariantError */._K)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function (error) {
        this.fetchCancelFns.forEach(function (cancel) { return cancel(error); });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function (_a) {
        var _b, _c;
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueries = _a.updateQueries, _d = _a.refetchQueries, refetchQueries = _d === void 0 ? [] : _d, _e = _a.awaitRefetchQueries, awaitRefetchQueries = _e === void 0 ? false : _e, updateWithProxyFn = _a.update, onQueryUpdated = _a.onQueryUpdated, _f = _a.fetchPolicy, fetchPolicy = _f === void 0 ? ((_b = this.defaultOptions.mutate) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "network-only" : _f, _g = _a.errorPolicy, errorPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.errorPolicy) || "none" : _g, keepRootFields = _a.keepRootFields, context = _a.context;
        return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
            var mutationId, hasClientExports, mutationStoreValue, self;
            return (0,tslib_es6/* __generator */.Jh)(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        (0,globals/* invariant */.kG)(mutation, 26);
                        (0,globals/* invariant */.kG)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        variables = (_h.sent());
                        _h.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore &&
                            (this.mutationStore[mutationId] = {
                                mutation: mutation,
                                variables: variables,
                                loading: true,
                                error: null,
                            });
                        if (optimisticResponse) {
                            this.markMutationOptimistic(optimisticResponse, {
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                fetchPolicy: fetchPolicy,
                                errorPolicy: errorPolicy,
                                context: context,
                                updateQueries: updateQueries,
                                update: updateWithProxyFn,
                                keepRootFields: keepRootFields,
                            });
                        }
                        this.broadcastQueries();
                        self = this;
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                return asyncMap(self.getObservableFromLink(mutation, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { optimisticResponse: optimisticResponse }), variables, false), function (result) {
                                    if (graphQLResultHasError(result) && errorPolicy === "none") {
                                        throw new client_errors/* ApolloError */.cA({
                                            graphQLErrors: getGraphQLErrorsFromResult(result),
                                        });
                                    }
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0,tslib_es6/* __assign */.pi)({}, result);
                                    if (typeof refetchQueries === "function") {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    if (errorPolicy === "ignore" && graphQLResultHasError(storeResult)) {
                                        delete storeResult.errors;
                                    }
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: optimisticResponse ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields,
                                    });
                                }).subscribe({
                                    next: function (storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) {
                                            resolve(storeResult);
                                        }
                                    },
                                    error: function (err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (optimisticResponse) {
                                            self.cache.removeOptimistic(mutationId);
                                        }
                                        self.broadcastQueries();
                                        reject(err instanceof client_errors/* ApolloError */.cA ? err : (new client_errors/* ApolloError */.cA({
                                            networkError: err,
                                        })));
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function (mutation, cache) {
        var _this = this;
        if (cache === void 0) { cache = this.cache; }
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
            if (!(0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result)) {
                cacheWrites.push({
                    result: result.data,
                    dataId: "ROOT_MUTATION",
                    query: mutation.document,
                    variables: mutation.variables,
                });
            }
            if ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) &&
                (0,arrays/* isNonEmptyArray */.O)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true,
                });
                var mergedData = void 0;
                if (diff.result) {
                    mergedData = (0,incrementalResult/* mergeIncrementalData */.mT)(diff.result, result);
                }
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables,
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) {
                this.queries.forEach(function (_a, queryId) {
                    var observableQuery = _a.observableQuery;
                    var queryName = observableQuery && observableQuery.queryName;
                    if (!queryName || !QueryManager_hasOwnProperty.call(updateQueries_1, queryName)) {
                        return;
                    }
                    var updater = updateQueries_1[queryName];
                    var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                    // Read the current query result from the store.
                    var _c = cache.diff({
                        query: document,
                        variables: variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _c.result, complete = _c.complete;
                    if (complete && currentQueryResult) {
                        // Run our reducer using the current query result and the mutation result.
                        var nextQueryResult = updater(currentQueryResult, {
                            mutationResult: result,
                            queryName: (document && (0,getFromAST/* getOperationName */.rY)(document)) || void 0,
                            queryVariables: variables,
                        });
                        // Write the modified result back into the store if we got a new result.
                        if (nextQueryResult) {
                            cacheWrites.push({
                                result: nextQueryResult,
                                dataId: "ROOT_QUERY",
                                query: document,
                                variables: variables,
                            });
                        }
                    }
                });
            }
        }
        if (cacheWrites.length > 0 ||
            mutation.refetchQueries ||
            mutation.update ||
            mutation.onQueryUpdated ||
            mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function (cache) {
                    if (!skipCache) {
                        cacheWrites.forEach(function (write) { return cache.write(write); });
                    }
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0,incrementalResult/* isExecutionPatchResult */.M0)(result) ||
                        ((0,incrementalResult/* isExecutionPatchIncrementalResult */.GG)(result) && !result.hasNext);
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true,
                            });
                            if (diff.complete) {
                                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { data: diff.result });
                                if ("incremental" in result) {
                                    delete result.incremental;
                                }
                                if ("hasNext" in result) {
                                    delete result.hasNext;
                                }
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) {
                            update(cache, result, {
                                context: mutation.context,
                                variables: mutation.variables,
                            });
                        }
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) {
                        cache.modify({
                            id: "ROOT_MUTATION",
                            fields: function (value, _a) {
                                var fieldName = _a.fieldName, DELETE = _a.DELETE;
                                return fieldName === "__typename" ? value : DELETE;
                            },
                        });
                    }
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null,
            }).forEach(function (result) { return results_1.push(result); });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
                // Returning a promise here makes the mutation await that promise, so we
                // include results in that promise's work if awaitRefetchQueries or an
                // onQueryUpdated function was specified.
                return Promise.all(results_1).then(function () { return result; });
            }
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ?
            optimisticResponse(mutation.variables)
            : optimisticResponse;
        return this.cache.recordOptimisticTransaction(function (cache) {
            try {
                _this.markMutationResult((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mutation), { result: { data: data } }), cache);
            }
            catch (error) {
                globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(error);
            }
        }, mutation.mutationId);
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast
            .promise;
    };
    QueryManager.prototype.getQueryStore = function () {
        var store = Object.create(null);
        this.queries.forEach(function (info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors,
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function (document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function (document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0,directives/* hasClientExports */.mj)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0,directives/* hasDirectives */.FS)(["nonreactive"], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0,transform/* removeDirectivesFromDocument */.bi)([
                    { name: "client", remove: true },
                    { name: "connection" },
                    { name: "nonreactive" },
                ], document),
                defaultVars: (0,getFromAST/* getDefaultValues */.O4)((0,getFromAST/* getOperationDefinition */.$H)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, document), { definitions: document.definitions.map(function (def) {
                        if (def.kind === "OperationDefinition" &&
                            def.operation !== "query") {
                            return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, def), { operation: "query" });
                        }
                        return def;
                    }) }),
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function (document, variables) {
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function (options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { variables: this.getVariables(query, options.variables) });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") {
            options.notifyOnNetworkStatusChange = false;
        }
        var queryInfo = new QueryInfo(this);
        var observable = new ObservableQuery({
            queryManager: this,
            queryInfo: queryInfo,
            options: options,
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables,
        });
        return observable;
    };
    QueryManager.prototype.query = function (options, queryId) {
        var _this = this;
        if (queryId === void 0) { queryId = this.generateQueryId(); }
        (0,globals/* invariant */.kG)(options.query, 28);
        (0,globals/* invariant */.kG)(options.query.kind === "Document", 29);
        (0,globals/* invariant */.kG)(!options.returnPartialData, 30);
        (0,globals/* invariant */.kG)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { query: this.transform(options.query) })).finally(function () { return _this.stopQuery(queryId); });
    };
    QueryManager.prototype.generateQueryId = function () {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function () {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function () {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo)
            queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function (options) {
        if (options === void 0) { options = {
            discardWatches: true,
        }; }
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0,globals/* newInvariantError */._K)(32));
        this.queries.forEach(function (queryInfo) {
            if (queryInfo.observableQuery) {
                // Set loading to true so listeners don't trigger unless they want
                // results with partial data.
                queryInfo.networkStatus = core_networkStatus/* NetworkStatus.loading */.Ie.loading;
            }
            else {
                queryInfo.stop();
            }
        });
        if (this.mutationStore) {
            this.mutationStore = Object.create(null);
        }
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function (include) {
        var _this = this;
        if (include === void 0) { include = "active"; }
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) {
            include.forEach(function (desc) {
                if (typeof desc === "string") {
                    queryNamesAndDocs.set(desc, false);
                }
                else if ((0,storeUtils/* isDocumentNode */.JW)(desc)) {
                    queryNamesAndDocs.set(_this.transform(desc), false);
                }
                else if ((0,objects/* isNonNullObject */.s)(desc) && desc.query) {
                    legacyQueryOptions.add(desc);
                }
            });
        }
        this.queries.forEach(function (_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" ||
                    (include === "active" && !oq.hasObservers())) {
                    return;
                }
                if (include === "active" ||
                    (queryName && queryNamesAndDocs.has(queryName)) ||
                    (document && queryNamesAndDocs.has(document))) {
                    queries.set(queryId, oq);
                    if (queryName)
                        queryNamesAndDocs.set(queryName, true);
                    if (document)
                        queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) {
            legacyQueryOptions.forEach(function (options) {
                // We will be issuing a fresh network request for this query, so we
                // pre-allocate a new query ID here, using a special prefix to enable
                // cleaning up these temporary queries later, after fetching.
                var queryId = (0,makeUniqueId/* makeUniqueId */.X)("legacyOneTimeQuery");
                var queryInfo = _this.getQuery(queryId).init({
                    document: options.query,
                    variables: options.variables,
                });
                var oq = new ObservableQuery({
                    queryManager: _this,
                    queryInfo: queryInfo,
                    options: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "network-only" }),
                });
                (0,globals/* invariant */.kG)(oq.queryId === queryId);
                queryInfo.setObservableQuery(oq);
                queries.set(queryId, oq);
            });
        }
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) {
            queryNamesAndDocs.forEach(function (included, nameOrDoc) {
                if (!included) {
                    globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
                }
            });
        }
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var _this = this;
        if (includeStandby === void 0) { includeStandby = false; }
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby ||
                (fetchPolicy !== "standby" && fetchPolicy !== "cache-only")) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function (observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function (_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function (variables) {
            return _this.getObservableFromLink(query, context, variables).map(function (result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if (shouldWriteResult(result, errorPolicy)) {
                        _this.cache.write({
                            query: query,
                            result: result.data,
                            dataId: "ROOT_SUBSCRIPTION",
                            variables: variables,
                        });
                    }
                    _this.broadcastQueries();
                }
                var hasErrors = graphQLResultHasError(result);
                var hasProtocolErrors = (0,client_errors/* graphQLResultHasProtocolErrors */.ls)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) {
                        errors.graphQLErrors = result.errors;
                    }
                    if (hasProtocolErrors) {
                        errors.protocolErrors = result.extensions[client_errors/* PROTOCOL_ERRORS_SYMBOL */.YG];
                    }
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) {
                        throw new client_errors/* ApolloError */.cA(errors);
                    }
                }
                if (errorPolicy === "ignore") {
                    delete result.errors;
                }
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState
                .addExportedVariables(query, variables, context)
                .then(makeObservable);
            return new zen_observable_ts_module/* Observable */.y(function (observer) {
                var sub = null;
                observablePromise_1.then(function (observable) { return (sub = observable.subscribe(observer)); }, observer.error);
                return function () { return sub && sub.unsubscribe(); };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function () {
        if (this.onBroadcast)
            this.onBroadcast();
        this.queries.forEach(function (info) { return info.notify(); });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function (query, context, variables, 
    // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) { deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication; }
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0,getFromAST/* getOperationName */.rY)(serverQuery) || void 0,
                context: this.prepareContext((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), { forceFetch: !deduplication })),
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0,print/* print */.S)(serverQuery);
                var byVariables_1 = inFlightLinkObservables_1.get(printedServerQuery_1) || new Map();
                inFlightLinkObservables_1.set(printedServerQuery_1, byVariables_1);
                var varJson_1 = (0,object_canon/* canonicalStringify */.B)(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    var concast = new Concast([
                        execute(link, operation),
                    ]);
                    byVariables_1.set(varJson_1, (observable = concast));
                    concast.beforeNext(function () {
                        if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) {
                            inFlightLinkObservables_1.delete(printedServerQuery_1);
                        }
                    });
                }
            }
            else {
                observable = new Concast([
                    execute(link, operation),
                ]);
            }
        }
        else {
            observable = new Concast([zen_observable_ts_module/* Observable.of */.y.of({ data: {} })]);
            context = this.prepareContext(context);
        }
        if (clientQuery) {
            observable = asyncMap(observable, function (result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables,
                });
            });
        }
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
        var requestId = (queryInfo.lastRequestId = this.generateRequestId());
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return asyncMap(this.getObservableFromLink(linkDocument, options.context, options.variables), function (result) {
            var graphQLErrors = getGraphQLErrorsFromResult(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") {
                    // Throwing here effectively calls observer.error.
                    throw queryInfo.markError(new client_errors/* ApolloError */.cA({
                        graphQLErrors: graphQLErrors,
                    }));
                }
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: core_networkStatus/* NetworkStatus.ready */.Ie.ready,
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = core_networkStatus/* NetworkStatus.error */.Ie.error;
            }
            return aqr;
        }, function (networkError) {
            var error = (0,client_errors/* isApolloError */.MS)(networkError) ? networkError : (new client_errors/* ApolloError */.cA({ networkError: networkError }));
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) {
                queryInfo.markError(error);
            }
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function (queryId, options, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) { networkStatus = core_networkStatus/* NetworkStatus.loading */.Ie.loading; }
        if (query === void 0) { query = options.query; }
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? (defaults && defaults.fetchPolicy) || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? (defaults && defaults.errorPolicy) || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context,
        });
        var fromVariables = function (variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" &&
                // The "standby" policy currently returns [] from fetchQueryByPolicy, so
                // this is another way to detect when nothing was done/fetched.
                sourcesWithInfo.sources.length > 0 &&
                queryInfo.observableQuery) {
                queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            }
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function () { return _this.fetchCancelFns.delete(queryId); };
        this.fetchCancelFns.set(queryId, function (reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function () { return concast.cancel(reason); });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new Concast(this.localState
                .addExportedVariables(normalized.query, normalized.variables, normalized.context)
                .then(fromVariables)
                .then(function (sourcesWithInfo) { return sourcesWithInfo.sources; }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        }
        else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new Concast(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink,
        };
    };
    QueryManager.prototype.refetchQueries = function (_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0,makeUniqueId/* makeUniqueId */.X)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) {
            this.getObservableQueries(include).forEach(function (oq, queryId) {
                includedQueriesById.set(queryId, {
                    oq: oq,
                    lastDiff: _this.getQuery(queryId).getDiff(),
                });
            });
        }
        var results = new Map();
        if (updateCache) {
            this.cache.batch({
                update: updateCache,
                // Since you can perform any combination of cache reads and/or writes in
                // the cache.batch update function, its optimistic option can be either
                // a boolean or a string, representing three distinct modes of
                // operation:
                //
                // * false: read/write only the root layer
                // * true: read/write the topmost layer
                // * string: read/write a fresh optimistic layer with that ID string
                //
                // When typeof optimistic === "string", a new optimistic layer will be
                // temporarily created within cache.batch with that string as its ID. If
                // we then pass that same string as the removeOptimistic option, we can
                // make cache.batch immediately remove the optimistic layer after
                // running the updateCache function, triggering only one broadcast.
                //
                // However, the refetchQueries method accepts only true or false for its
                // optimistic option (not string). We interpret true to mean a temporary
                // optimistic layer should be created, to allow efficiently rolling back
                // the effect of the updateCache function, which involves passing a
                // string instead of true as the optimistic option to cache.batch, when
                // refetchQueries receives optimistic: true.
                //
                // In other words, we are deliberately not supporting the use case of
                // writing to an *existing* optimistic layer (using the refetchQueries
                // updateCache function), since that would potentially interfere with
                // other optimistic updates in progress. Instead, you can read/write
                // only the root layer by passing optimistic: false to refetchQueries,
                // or you can read/write a brand new optimistic layer that will be
                // automatically removed by passing optimistic: true.
                optimistic: (optimistic && removeOptimistic) || false,
                // The removeOptimistic option can also be provided by itself, even if
                // optimistic === false, to remove some previously-added optimistic
                // layer safely and efficiently, like we do in markMutationResult.
                //
                // If an explicit removeOptimistic string is provided with optimistic:
                // true, the removeOptimistic string will determine the ID of the
                // temporary optimistic layer, in case that ever matters.
                removeOptimistic: removeOptimistic,
                onWatchUpdated: function (watch, diff, lastDiff) {
                    var oq = watch.watcher instanceof QueryInfo && watch.watcher.observableQuery;
                    if (oq) {
                        if (onQueryUpdated) {
                            // Since we're about to handle this query now, remove it from
                            // includedQueriesById, in case it was added earlier because of
                            // options.include.
                            includedQueriesById.delete(oq.queryId);
                            var result = onQueryUpdated(oq, diff, lastDiff);
                            if (result === true) {
                                // The onQueryUpdated function requested the default refetching
                                // behavior by returning true.
                                result = oq.refetch();
                            }
                            // Record the result in the results Map, as long as onQueryUpdated
                            // did not return false to skip/ignore this result.
                            if (result !== false) {
                                results.set(oq, result);
                            }
                            // Allow the default cache broadcast to happen, except when
                            // onQueryUpdated returns false.
                            return result;
                        }
                        if (onQueryUpdated !== null) {
                            // If we don't have an onQueryUpdated function, and onQueryUpdated
                            // was not disabled by passing null, make sure this query is
                            // "included" like any other options.include-specified query.
                            includedQueriesById.set(oq.queryId, { oq: oq, lastDiff: lastDiff, diff: diff });
                        }
                    }
                },
            });
        }
        if (includedQueriesById.size) {
            includedQueriesById.forEach(function (_a, queryId) {
                var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
                var result;
                // If onQueryUpdated is provided, we want to use it for all included
                // queries, even the QueryOptions ones.
                if (onQueryUpdated) {
                    if (!diff) {
                        var info = oq["queryInfo"];
                        info.reset(); // Force info.getDiff() to read from cache.
                        diff = info.getDiff();
                    }
                    result = onQueryUpdated(oq, diff, lastDiff);
                }
                // Otherwise, we fall back to refetching.
                if (!onQueryUpdated || result === true) {
                    result = oq.refetch();
                }
                if (result !== false) {
                    results.set(oq, result);
                }
                if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
                    _this.stopQueryNoBroadcast(queryId);
                }
            });
        }
        if (removeOptimistic) {
            // In case no updateCache callback was provided (so cache.batch was not
            // called above, and thus did not already remove the optimistic layer),
            // remove it here. Since this is a no-op when the layer has already been
            // removed, we do it even if we called cache.batch above, since it's
            // possible this.cache is an instance of some ApolloCache subclass other
            // than InMemoryCache, and does not fully support the removeOptimistic
            // option for cache.batch.
            this.cache.removeOptimistic(removeOptimistic);
        }
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, 
    // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus,
        });
        var readCache = function () { return queryInfo.getDiff(); };
        var resultsFromCache = function (diff, networkStatus) {
            if (networkStatus === void 0) { networkStatus = queryInfo.networkStatus || core_networkStatus/* NetworkStatus.loading */.Ie.loading; }
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0,lib/* equal */.D)(data, {})) {
                logMissingFieldErrors(diff.missing);
            }
            var fromData = function (data) {
                return zen_observable_ts_module/* Observable.of */.y.of((0,tslib_es6/* __assign */.pi)({ data: data, loading: (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus), networkStatus: networkStatus }, (diff.complete ? null : { partial: true })));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) {
                return _this.localState
                    .runResolvers({
                    document: query,
                    remoteResult: { data: data },
                    context: context,
                    variables: variables,
                    onlyRunForcedResolvers: true,
                })
                    .then(function (resolved) { return fromData(resolved.data || void 0); });
            }
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" &&
                networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch &&
                Array.isArray(diff.missing)) {
                return fromData(void 0);
            }
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */
            // Watched queries must opt into overwriting existing data on refetch,
            // by passing refetchWritePolicy: "overwrite" in their WatchQueryOptions.
            : (networkStatus === core_networkStatus/* NetworkStatus.refetch */.Ie.refetch &&
                refetchWritePolicy !== "merge") ?
                1 /* CacheWriteBehavior.OVERWRITE */
                : 2 /* CacheWriteBehavior.MERGE */;
        var resultsFromLink = function () {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange &&
            typeof oldNetworkStatus === "number" &&
            oldNetworkStatus !== networkStatus &&
            (0,core_networkStatus/* isNetworkRequestInFlight */.Oj)(networkStatus);
        switch (fetchPolicy) {
            default:
            case "cache-first": {
                var diff = readCache();
                if (diff.complete) {
                    return {
                        fromLink: false,
                        sources: [resultsFromCache(diff, queryInfo.markReady())],
                    };
                }
                if (returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-and-network": {
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(diff), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            }
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [resultsFromCache(readCache(), queryInfo.markReady())],
                };
            case "network-only":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        sources: [resultsFromCache(readCache()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "no-cache":
                if (shouldNotify) {
                    return {
                        fromLink: true,
                        // Note that queryInfo.getDiff() for no-cache queries does not call
                        // cache.diff, but instead returns a { complete: false } stub result
                        // when there is no queryInfo.diff already defined.
                        sources: [resultsFromCache(queryInfo.getDiff()), resultsFromLink()],
                    };
                }
                return { fromLink: true, sources: [resultsFromLink()] };
            case "standby":
                return { fromLink: false, sources: [] };
        }
    };
    QueryManager.prototype.getQuery = function (queryId) {
        if (queryId && !this.queries.has(queryId)) {
            this.queries.set(queryId, new QueryInfo(this, queryId));
        }
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, newContext), { clientAwareness: this.clientAwareness });
    };
    return QueryManager;
}());

//# sourceMappingURL=QueryManager.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/core/ApolloClient.js







var hasSuggestedDevtools = false;
// Though mergeOptions now resides in @apollo/client/utilities, it was
// previously declared and exported from this module, and then reexported from
// @apollo/client/core. Since we need to preserve that API anyway, the easiest
// solution is to reexport mergeOptions where it was previously declared (here).


/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */
var ApolloClient = /** @class */ (function () {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */
    function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) {
            throw (0,globals/* newInvariantError */._K)(15);
        }
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, 
        // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, 
        // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" &&
            !window.__APOLLO_CLIENT__ &&
            globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) {
            link =
                uri ? new HttpLink/* HttpLink */.u({ uri: uri, credentials: credentials, headers: headers }) : ApolloLink/* ApolloLink.empty */.i.empty();
        }
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = version/* version */.i;
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
        this.queryManager = new QueryManager({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion,
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ?
                function () {
                    if (_this.devToolsHookCb) {
                        _this.devToolsHookCb({
                            action: {},
                            state: {
                                queries: _this.queryManager.getQueryStore(),
                                mutations: _this.queryManager.mutationStore || {},
                            },
                            dataWithOptimisticResults: _this.cache.extract(true),
                        });
                    }
                }
                : void 0,
        });
        if (connectToDevTools)
            this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function () {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] =
                windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */
        if (!hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            hasSuggestedDevtools = true;
            setTimeout(function () {
                if (typeof window !== "undefined" &&
                    window.document &&
                    window.top === window.self &&
                    !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) {
                            url =
                                "https://chrome.google.com/webstore/detail/" +
                                    "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        }
                        else if (ua.indexOf("Firefox/") > -1) {
                            url =
                                "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                        }
                    }
                    if (url) {
                        globalThis.__DEV__ !== false && globals/* invariant.log */.kG.log("Download the Apollo DevTools for a better development " +
                            "experience: %s", url);
                    }
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */
        get: function () {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */
    ApolloClient.prototype.stop = function () {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.watchQuery, options);
        }
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === "network-only" ||
                options.fetchPolicy === "cache-and-network")) {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.query, options);
        }
        (0,globals/* invariant */.kG)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") {
            options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), { fetchPolicy: "cache-first" });
        }
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error.
     *
     * It takes options as an object with the following keys and values:
     */
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = (0,mergeOptions/* mergeOptions */.J)(this.defaultOptions.mutate, options);
        }
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */
    ApolloClient.prototype.subscribe = function (options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */
    ApolloClient.prototype.writeQuery = function (options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */
    ApolloClient.prototype.writeFragment = function (options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) {
            this.queryManager.broadcastQueries();
        }
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return execute(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: false,
            });
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () { return _this.reFetchObservableQueries(); });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager.clearStore({
                discardWatches: true,
            });
        })
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */
    ApolloClient.prototype.refetchQueries = function (options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function (result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function (error) {
            globalThis.__DEV__ !== false && globals/* invariant.debug */.kG.debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */
    ApolloClient.prototype.getObservableQueries = function (include) {
        if (include === void 0) { include = "active"; }
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */
    ApolloClient.prototype.extract = function (optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */
    ApolloClient.prototype.restore = function (serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */
    ApolloClient.prototype.setLink = function (newLink) {
        this.link = this.queryManager.link = newLink;
    };
    return ApolloClient;
}());

//# sourceMappingURL=ApolloClient.js.map

/***/ }),

/***/ 1644:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ NetworkStatus; },
/* harmony export */   "Oj": function() { return /* binding */ isNetworkRequestInFlight; }
/* harmony export */ });
/* unused harmony export isNetworkRequestSettled */
/**
 * The current status of a query’s execution in our system.
 */
var NetworkStatus;
(function (NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
/**
 * Returns true if there is currently a network request in flight according to a given network
 * status.
 */
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
/**
 * Returns true if the network request is in ready or error state according to a given network
 * status.
 */
function isNetworkRequestSettled(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}
//# sourceMappingURL=networkStatus.js.map

/***/ }),

/***/ 30990:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ isApolloError; },
/* harmony export */   "YG": function() { return /* binding */ PROTOCOL_ERRORS_SYMBOL; },
/* harmony export */   "cA": function() { return /* binding */ ApolloError; },
/* harmony export */   "ls": function() { return /* binding */ graphQLResultHasProtocolErrors; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13154);



// This Symbol allows us to pass transport-specific errors from the link chain
// into QueryManager/client internals without risking a naming collision within
// extensions (which implementers can use as they see fit).
var PROTOCOL_ERRORS_SYMBOL = Symbol();
function graphQLResultHasProtocolErrors(result) {
    if (result.extensions) {
        return Array.isArray(result.extensions[PROTOCOL_ERRORS_SYMBOL]);
    }
    return false;
}
function isApolloError(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var generateErrorMessage = function (err) {
    var errors = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError)
        errors.push(err.networkError);
    return (errors
        // The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
        .map(function (err) {
        return ((0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonNullObject */ .s)(err) && err.message) || "Error message not found.";
    })
        .join("\n"));
};
var ApolloError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__extends */ .ZT)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 86909:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ ApolloLink; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/createOperation.js

function createOperation(starting, operation) {
    var context = (0,tslib_es6/* __assign */.pi)({}, starting);
    var setContext = function (next) {
        if (typeof next === "function") {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next(context));
        }
        else {
            context = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, context), next);
        }
    };
    var getContext = function () { return ((0,tslib_es6/* __assign */.pi)({}, context)); };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext,
    });
    return operation;
}
//# sourceMappingURL=createOperation.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/transformOperation.js

function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== "string" ?
                (0,getFromAST/* getOperationName */.rY)(transformedOperation.query) || undefined
                : "";
    }
    return transformedOperation;
}
//# sourceMappingURL=transformOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/validateOperation.js

function validateOperation(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context",
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw (0,globals/* newInvariantError */._K)(43, key);
        }
    }
    return operation;
}
//# sourceMappingURL=validateOperation.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js



function passthrough(op, forward) {
    return (forward ? forward(op) : zen_observable_ts_module/* Observable.of */.y.of());
}
function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink(handler) : handler;
}
function isTerminating(link) {
    return link.request.length <= 1;
}
var ApolloLink = /** @class */ (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.empty = function () {
        return new ApolloLink(function () { return zen_observable_ts_module/* Observable.of */.y.of(); });
    };
    ApolloLink.from = function (links) {
        if (links.length === 0)
            return ApolloLink.empty();
        return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
    };
    ApolloLink.split = function (test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) {
            return new ApolloLink(function (operation) {
                return test(operation) ?
                    leftLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return test(operation) ?
                    leftLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of()
                    : rightLink.request(operation, forward) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
    };
    ApolloLink.execute = function (link, operation) {
        return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || zen_observable_ts_module/* Observable.of */.y.of());
    };
    ApolloLink.concat = function (first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(35, firstLink);
            return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
            return new ApolloLink(function (operation) {
                return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_module/* Observable.of */.y.of(); }) || zen_observable_ts_module/* Observable.of */.y.of();
            });
        }
        else {
            return new ApolloLink(function (operation, forward) {
                return (firstLink.request(operation, function (op) {
                    return nextLink.request(op, forward) || zen_observable_ts_module/* Observable.of */.y.of();
                }) || zen_observable_ts_module/* Observable.of */.y.of());
            });
        }
    };
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw (0,globals/* newInvariantError */._K)(36);
    };
    ApolloLink.prototype.onError = function (error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function (fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}());

//# sourceMappingURL=ApolloLink.js.map

/***/ }),

/***/ 63200:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ onError; }
/* harmony export */ });
/* unused harmony export ErrorLink */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48216);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86909);



function onError(errorHandler) {
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink */ .i(function (operation, forward) {
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y(function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
var ErrorLink = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .ZT)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_0__/* .ApolloLink */ .i));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 72198:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ HttpLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86909);
/* harmony import */ var _createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75465);



var HttpLink = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, (0,_createHttpLink_js__WEBPACK_IMPORTED_MODULE_1__/* .createHttpLink */ .L)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}(_core_index_js__WEBPACK_IMPORTED_MODULE_2__/* .ApolloLink */ .i));

//# sourceMappingURL=HttpLink.js.map

/***/ }),

/***/ 75465:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ createHttpLink; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(86909);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/directives.js
var directives = __webpack_require__(19065);
// EXTERNAL MODULE: ./node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(48216);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/serializeFetchParameter.js

var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError = (0,globals/* newInvariantError */._K)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
//# sourceMappingURL=serializeFetchParameter.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectURI.js
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === "function") {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || "/graphql";
    }
};
//# sourceMappingURL=selectURI.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/async.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */
function asyncIterator(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
            next: function () {
                return iterator.next();
            }
        },
        _a[Symbol.asyncIterator] = function () {
            return this;
        },
        _a;
}
//# sourceMappingURL=async.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/nodeStream.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */

function nodeStreamIterator(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error)
            return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) {
                return shiftedArr[0]({ value: chunk, done: false });
            }
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function (pair) {
            pair[0]({ value: undefined, done: true });
        });
        !cleanup || cleanup();
    }
    cleanup = function () {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function (resolve, reject) {
            if (error)
                return reject(error);
            if (data.length)
                return resolve({ value: data.shift(), done: false });
            if (done)
                return resolve({ value: undefined, done: true });
            waiting.push([resolve, reject]);
        });
    }
    var iterator = {
        next: function () {
            return getNext();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=nodeStream.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/promise.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */

function promiseIterator(promise) {
    var resolved = false;
    var iterator = {
        next: function () {
            if (resolved)
                return Promise.resolve({
                    value: undefined,
                    done: true,
                });
            resolved = true;
            return new Promise(function (resolve, reject) {
                promise
                    .then(function (value) {
                    resolve({ value: value, done: false });
                })
                    .catch(reject);
            });
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=promise.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/iterators/reader.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */

function readerIterator(reader) {
    var iterator = {
        next: function () {
            return reader.read();
        },
    };
    if (canUse/* canUseAsyncIteratorSymbol */.DN) {
        iterator[Symbol.asyncIterator] = function () {
            return this;
        };
    }
    return iterator;
}
//# sourceMappingURL=reader.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/responseIterator.js
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */





function isNodeResponse(value) {
    return !!value.body;
}
function isReadableStream(value) {
    return !!value.getReader;
}
function isAsyncIterableIterator(value) {
    return !!(canUse/* canUseAsyncIteratorSymbol */.DN &&
        value[Symbol.asyncIterator]);
}
function isStreamableBlob(value) {
    return !!value.stream;
}
function isBlob(value) {
    return !!value.arrayBuffer;
}
function isNodeReadableStream(value) {
    return !!value.pipe;
}
function responseIterator(response) {
    var body = response;
    if (isNodeResponse(response))
        body = response.body;
    if (isAsyncIterableIterator(body))
        return asyncIterator(body);
    if (isReadableStream(body))
        return readerIterator(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if (isStreamableBlob(body)) {
        return readerIterator(body.stream().getReader());
    }
    if (isBlob(body))
        return promiseIterator(body.arrayBuffer());
    if (isNodeReadableStream(body))
        return nodeStreamIterator(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
//# sourceMappingURL=responseIterator.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/throwServerError.js
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
//# sourceMappingURL=throwServerError.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/incrementalResult.js
var incrementalResult = __webpack_require__(37280);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/parseAndCheckHttpResponse.js





var parseAndCheckHttpResponse_hasOwnProperty = Object.prototype.hasOwnProperty;
function readMultipartBody(response, nextValue) {
    var _a;
    return (0,tslib_es6/* __awaiter */.mG)(this, void 0, void 0, function () {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _b, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _c, _d;
        return (0,tslib_es6/* __generator */.Jh)(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (TextDecoder === undefined) {
                        throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    }
                    decoder = new TextDecoder("utf-8");
                    contentType = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ?
                        contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim()
                        : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = responseIterator(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [3 /*break*/, 3];
                    return [4 /*yield*/, iterator.next()];
                case 2:
                    _b = _e.sent(), value = _b.value, done = _b.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while (bi > -1) {
                        message = void 0;
                        _c = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length),
                        ], message = _c[0], buffer = _c[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = parseHeaders(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 &&
                            contentType_1.toLowerCase().indexOf("application/json") === -1) {
                            throw new Error("Unsupported patch content type: application/json is required.");
                        }
                        body = message.slice(i);
                        if (body) {
                            result = parseJsonBody(response, body);
                            if (Object.keys(result).length > 1 ||
                                "data" in result ||
                                "incremental" in result ||
                                "errors" in result ||
                                "payload" in result) {
                                if ((0,incrementalResult/* isApolloPayloadResult */.yU)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        next = (0,tslib_es6/* __assign */.pi)({}, result.payload);
                                    }
                                    if ("errors" in result) {
                                        next = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, next), { extensions: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, ("extensions" in next ? next.extensions : null)), (_d = {}, _d[errors/* PROTOCOL_ERRORS_SYMBOL */.YG] = result.errors, _d)) });
                                    }
                                    nextValue(next);
                                }
                                else {
                                    // for the last chunk with only `hasNext: false`
                                    // we don't need to call observer.next as there is no data/errors
                                    nextValue(result);
                                }
                            }
                            else if (
                            // If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 &&
                                "hasNext" in result &&
                                !result.hasNext) {
                                return [2 /*return*/];
                            }
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function parseHeaders(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function (line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function parseJsonBody(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function () {
            try {
                return JSON.parse(bodyText);
            }
            catch (err) {
                return bodyText;
            }
        };
        throwServerError(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    }
    catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function handleError(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) {
        // if we don't call next, the UI can only show networkError
        // because AC didn't get any graphqlErrors this is graphql
        // execution result info (i.e errors and possibly data) this is
        // because there is no formal spec how errors should translate to
        // http status codes. So an auth error (401) could have both data
        // from a public field, errors from a private field, and a status
        // of 401
        // {
        //  user { // this will have errors
        //    firstName
        //  }
        //  products { // this is public so will have data
        //    cost
        //  }
        // }
        //
        // the result of above *could* look like this:
        // {
        //   data: { products: [{ cost: "$10" }] },
        //   errors: [{
        //      message: 'your session has timed out',
        //      path: []
        //   }]
        // }
        // status code of above would be a 401
        // in the UI you want to show data where you can, errors as data where you can
        // and use correct http status codes
        observer.next(err.result);
    }
    observer.error(err);
}
function parseAndCheckHttpResponse(operations) {
    return function (response) {
        return response
            .text()
            .then(function (bodyText) { return parseJsonBody(response, bodyText); })
            .then(function (result) {
            if (response.status >= 300) {
                // Network error
                throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
            }
            if (!Array.isArray(result) &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "data") &&
                !parseAndCheckHttpResponse_hasOwnProperty.call(result, "errors")) {
                // Data error
                throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ?
                    operations.map(function (op) { return op.operationName; })
                    : operations.operationName, "'."));
            }
            return result;
        });
    };
}
//# sourceMappingURL=parseAndCheckHttpResponse.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/checkFetcher.js

var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === "undefined") {
        throw (0,globals/* newInvariantError */._K)(37);
    }
};
//# sourceMappingURL=checkFetcher.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/print.js + 1 modules
var print = __webpack_require__(5144);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/selectHttpOptionsAndBody.js


var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false,
};
var defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json",
};
var defaultOptions = {
    method: "POST",
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var defaultPrinter = function (ast, printer) { return printer(ast); };
function selectHttpOptionsAndBody(operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    configs.unshift(fallbackConfig);
    return selectHttpOptionsAndBodyInternal.apply(void 0, __spreadArray([operation,
        defaultPrinter], configs, false));
}
function selectHttpOptionsAndBodyInternal(operation, printer) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = {};
    var http = {};
    configs.forEach(function (config) {
        options = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options), config.options), { headers: (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, options.headers), config.headers) });
        if (config.credentials) {
            options.credentials = config.credentials;
        }
        http = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, http), config.http);
    });
    if (options.headers) {
        options.headers = removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    }
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery)
        body.query = printer(query, print/* print */.S);
    return {
        options: options,
        body: body,
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function (name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name],
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function (name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}
//# sourceMappingURL=selectHttpOptionsAndBody.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/rewriteURIForGET.js

// For GET operations, returns the given URI rewritten with parameters, or a
// parse error.
function rewriteURIForGET(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) {
        addQueryParam("query", body.query);
    }
    if (body.operationName) {
        addQueryParam("operationName", body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = serializeFetchParameter(body.variables, "Variables map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = serializeFetchParameter(body.extensions, "Extensions map");
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return { newURI: newURI };
}
//# sourceMappingURL=rewriteURIForGET.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/fromError.js

function fromError(errorValue) {
    return new zen_observable_ts_module/* Observable */.y(function (observer) {
        observer.error(errorValue);
    });
}
//# sourceMappingURL=fromError.js.map
// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/utils/filterOperationVariables.js


function filterOperationVariables(variables, query) {
    var result = (0,tslib_es6/* __assign */.pi)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0,visitor/* visit */.Vn)(query, {
        Variable: function (node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent &&
                parent.kind !== "VariableDefinition") {
                unusedNames.delete(node.name.value);
            }
        },
    });
    unusedNames.forEach(function (name) {
        delete result[name];
    });
    return result;
}
//# sourceMappingURL=filterOperationVariables.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/transform.js
var transform = __webpack_require__(76487);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/getFromAST.js
var getFromAST = __webpack_require__(36765);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js












var backupFetch = (0,globals/* maybe */.wY)(function () { return fetch; });
var createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, 
    // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? defaultPrinter : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0,tslib_es6/* __rest */._T)(linkOptions, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    if (globalThis.__DEV__ !== false) {
        // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
        // defined, so requests won't fail at runtime.
        checkFetcher(preferredFetch || backupFetch);
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions, preserveHeaderCase: preserveHeaderCase },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new ApolloLink/* ApolloLink */.i(function (operation) {
        var chosenURI = selectURI(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders["apollographql-client-name"] = name_1;
            }
            if (version) {
                clientAwarenessHeaders["apollographql-client-version"] = version;
            }
        }
        var contextHeaders = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        if ((0,directives/* hasDirectives */.FS)(["client"], operation.query)) {
            var transformedQuery = (0,transform/* removeClientSetsFromDocument */.ob)(operation.query);
            if (!transformedQuery) {
                return fromError(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            }
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) {
            body.variables = filterOperationVariables(body.variables, operation.query);
        }
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function (d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0,getFromAST/* getMainDefinition */.p$)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0,directives/* hasDirectives */.FS)(["defer"], operation.query);
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = "GET";
        }
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) {
                globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(38);
            }
            if (isSubscription) {
                acceptHeader +=
                    "boundary=graphql;subscriptionSpec=1.0,application/json";
            }
            else if (hasDefer) {
                acceptHeader += "deferSpec=20220824,application/json";
            }
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = rewriteURIForGET(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) {
                return fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = serializeFetchParameter(body, "Payload");
            }
            catch (parseError) {
                return fromError(parseError);
            }
        }
        return new zen_observable_ts_module/* Observable */.y(function (observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0,globals/* maybe */.wY)(function () { return fetch; }) || backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options)
                .then(function (response) {
                var _a;
                operation.setContext({ response: response });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) {
                    return readMultipartBody(response, observerNext);
                }
                else {
                    return parseAndCheckHttpResponse(operation)(response).then(observerNext);
                }
            })
                .then(function () {
                controller = undefined;
                observer.complete();
            })
                .catch(function (err) {
                controller = undefined;
                handleError(err, observer);
            });
            return function () {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller)
                    controller.abort();
            };
        });
    });
};
//# sourceMappingURL=createHttpLink.js.map

/***/ }),

/***/ 85317:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getApolloContext; }
/* harmony export */ });
/* unused harmony export resetApolloContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30320);
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78287);



// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var contextKey = _utilities_index_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseSymbol */ .aS ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function getApolloContext() {
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)( true, 45);
    var context = react__WEBPACK_IMPORTED_MODULE_0__.createContext[contextKey];
    if (!context) {
        Object.defineProperty(react__WEBPACK_IMPORTED_MODULE_0__.createContext, contextKey, {
            value: (context = react__WEBPACK_IMPORTED_MODULE_0__.createContext({})),
            enumerable: false,
            writable: false,
            configurable: true,
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
/**
 * @deprecated This function has no "resetting" effect since Apollo Client 3.4.12,
 * and will be removed in the next major version of Apollo Client.
 * If you want to get the Apollo Context, use `getApolloContext` instead.
 */
var resetApolloContext = (/* unused pure expression or super */ null && (getApolloContext));
//# sourceMappingURL=ApolloContext.js.map

/***/ }),

/***/ 66252:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useApolloClient; }
/* harmony export */ });
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85317);



function useApolloClient(override) {
    var context = react__WEBPACK_IMPORTED_MODULE_1__.useContext((0,_context_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getApolloContext */ .K)());
    var client = override || context.client;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!client, 49);
    return client;
}
//# sourceMappingURL=useApolloClient.js.map

/***/ }),

/***/ 50319:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useMutation; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14012);
/* harmony import */ var _wry_equality__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30020);
/* harmony import */ var _parser_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14692);
/* harmony import */ var _errors_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30990);
/* harmony import */ var _useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66252);







function useMutation(mutation, options) {
    var client = (0,_useApolloClient_js__WEBPACK_IMPORTED_MODULE_2__/* .useApolloClient */ .x)(options === null || options === void 0 ? void 0 : options.client);
    (0,_parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .verifyDocumentType */ .Vp)(mutation, _parser_index_js__WEBPACK_IMPORTED_MODULE_3__/* .DocumentType.Mutation */ .n_.Mutation);
    var _a = react__WEBPACK_IMPORTED_MODULE_0__.useState({
        called: false,
        loading: false,
        client: client,
    }), result = _a[0], setResult = _a[1];
    var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options,
    });
    // TODO: Trying to assign these in a useEffect or useLayoutEffect breaks
    // higher-order components.
    {
        Object.assign(ref.current, { client: client, options: options, mutation: mutation });
    }
    var execute = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (executeOptions) {
        if (executeOptions === void 0) { executeOptions = {}; }
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({}, options), { mutation: mutation });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading &&
            !baseOptions.ignoreResults &&
            ref.current.isMounted) {
            setResult((ref.current.result = {
                loading: true,
                error: void 0,
                data: void 0,
                called: true,
                client: client,
            }));
        }
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0,_utilities_index_js__WEBPACK_IMPORTED_MODULE_5__/* .mergeOptions */ .J)(baseOptions, executeOptions);
        return client
            .mutate(clientOptions)
            .then(function (response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ?
                new _errors_index_js__WEBPACK_IMPORTED_MODULE_6__/* .ApolloError */ .cA({ graphQLErrors: errors })
                : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) {
                onError(error, clientOptions);
            }
            if (mutationId === ref.current.mutationId &&
                !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client,
                };
                if (ref.current.isMounted && !(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_1)) {
                    setResult((ref.current.result = result_1));
                }
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) {
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(response.data, clientOptions);
            }
            return response;
        })
            .catch(function (error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client,
                };
                if (!(0,_wry_equality__WEBPACK_IMPORTED_MODULE_1__/* .equal */ .D)(ref.current.result, result_2)) {
                    setResult((ref.current.result = result_2));
                }
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return { data: void 0, errors: error };
            }
            throw error;
        });
    }, []);
    var reset = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function () {
        if (ref.current.isMounted) {
            var result_3 = { called: false, loading: false, client: client };
            Object.assign(ref.current, { mutationId: 0, result: result_3 });
            setResult(result_3);
        }
    }, []);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        ref.current.isMounted = true;
        return function () {
            ref.current.isMounted = false;
        };
    }, []);
    return [execute, (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__assign */ .pi)({ reset: reset }, result)];
}
//# sourceMappingURL=useMutation.js.map

/***/ }),

/***/ 37887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ useInternalState; },
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/globals/index.js + 4 modules
var globals = __webpack_require__(78287);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useSyncExternalStore.js



var didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var uSESKey = "useSyncExternalStore";
var realHook = react_namespaceObject[uSESKey];
// Adapted from https://www.npmjs.com/package/use-sync-external-store, with
// Apollo Client deviations called out by "// DEVIATION ..." comments.
// When/if React.useSyncExternalStore is defined, delegate fully to it.
var useSyncExternalStore = realHook ||
    (function (subscribe, getSnapshot, getServerSnapshot) {
        // Read the current snapshot from the store on every render. Again, this
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (
        // DEVIATION: Using __DEV__
        globalThis.__DEV__ !== false &&
            !didWarnUncachedGetSnapshot &&
            // DEVIATION: Not using Object.is because we know our snapshots will never
            // be exotic primitive values like NaN, which is !== itself.
            value !== getSnapshot()) {
            didWarnUncachedGetSnapshot = true;
            // DEVIATION: Using invariant.error instead of console.error directly.
            globalThis.__DEV__ !== false && globals/* invariant.error */.kG.error(58);
        }
        // Because updates are synchronous, we don't queue them. Instead we force a
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _a = react.useState({
            inst: { value: value, getSnapshot: getSnapshot },
        }), inst = _a[0].inst, forceUpdate = _a[1];
        // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        if (canUse/* canUseLayoutEffect */.JC) {
            // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
            // which may seem like a conditional hook, but this code ends up behaving
            // unconditionally (one way or the other) because canUseLayoutEffect is
            // constant.
            react.useLayoutEffect(function () {
                Object.assign(inst, { value: value, getSnapshot: getSnapshot });
                // Whenever getSnapshot or subscribe changes, we need to check in the
                // commit phase if there was an interleaved mutation. In concurrent mode
                // this can happen all the time, but even in synchronous mode, an earlier
                // effect may have mutated the store.
                if (checkIfSnapshotChanged(inst)) {
                    // Force a re-render.
                    forceUpdate({ inst: inst });
                }
            }, [subscribe, value, getSnapshot]);
        }
        else {
            Object.assign(inst, { value: value, getSnapshot: getSnapshot });
        }
        react.useEffect(function () {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) {
                // Force a re-render.
                forceUpdate({ inst: inst });
            }
            // Subscribe to the store and return a clean-up function.
            return subscribe(function handleStoreChange() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) {
                    // Force a re-render.
                    forceUpdate({ inst: inst });
                }
            });
        }, [subscribe]);
        return value;
    });
function checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    }
    catch (_b) {
        return true;
    }
}
//# sourceMappingURL=useSyncExternalStore.js.map
// EXTERNAL MODULE: ./node_modules/@wry/equality/lib/index.js
var lib = __webpack_require__(30020);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/mergeOptions.js
var mergeOptions = __webpack_require__(14012);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloContext.js
var ApolloContext = __webpack_require__(85317);
// EXTERNAL MODULE: ./node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/networkStatus.js
var networkStatus = __webpack_require__(1644);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/parser/index.js
var parser = __webpack_require__(14692);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/maybeDeepFreeze.js
var maybeDeepFreeze = __webpack_require__(48702);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/compact.js
var compact = __webpack_require__(53712);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/arrays.js
var arrays = __webpack_require__(21436);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js












var useQuery_hasOwnProperty = Object.prototype.hasOwnProperty;
function useQuery(query, options) {
    if (options === void 0) { options = Object.create(null); }
    return useInternalState((0,useApolloClient/* useApolloClient */.x)(options.client), query).useQuery(options);
}
function useInternalState(client, query) {
    var stateRef = react.useRef();
    if (!stateRef.current ||
        client !== stateRef.current.client ||
        query !== stateRef.current.query) {
        stateRef.current = new InternalState(client, query, stateRef.current);
    }
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = react.useReducer(function (tick) { return tick + 1; }, 0)[1];
    return state;
}
var InternalState = /** @class */ (function () {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */
        this.forceUpdate = function () { return _this.forceUpdateState(); };
        this.ssrDisabledResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.loading */.Ie.loading,
        });
        this.skipStandbyResult = (0,maybeDeepFreeze/* maybeDeepFreeze */.J)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: networkStatus/* NetworkStatus.ready */.Ie.ready,
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new (canUse/* canUseWeakMap */.mr ? WeakMap : Map)();
        (0,parser/* verifyDocumentType */.Vp)(query, parser/* DocumentType.Query */.n_.Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) {
            this.previousData = previousData;
        }
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */
    InternalState.prototype.forceUpdateState = function () {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(50);
    };
    InternalState.prototype.executeQuery = function (options) {
        var _this = this;
        var _a;
        if (options.query) {
            Object.assign(this, { query: options.query });
        }
        this.watchQueryOptions = this.createWatchQueryOptions((this.queryHookOptions = options));
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function (resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function (value) {
                    result = value;
                },
                error: function () {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function () {
                    resolve(_this.toQueryResult(result));
                },
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function (options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = react.useContext((0,ApolloContext/* getApolloContext */.K)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = useSyncExternalStore(react.useCallback(function (handleStoreChange) {
            if (_this.renderPromises) {
                return function () { };
            }
            _this.forceUpdate = handleStoreChange;
            var onNext = function () {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult &&
                    previousResult.loading === result.loading &&
                    previousResult.networkStatus === result.networkStatus &&
                    (0,lib/* equal */.D)(previousResult.data, result.data)) {
                    return;
                }
                _this.setResult(result);
            };
            var onError = function (error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!useQuery_hasOwnProperty.call(error, "graphQLErrors")) {
                    // The error is not a GraphQL error
                    throw error;
                }
                var previousResult = _this.result;
                if (!previousResult ||
                    (previousResult && previousResult.loading) ||
                    !(0,lib/* equal */.D)(error, previousResult.error)) {
                    _this.setResult({
                        data: (previousResult && previousResult.data),
                        error: error,
                        loading: false,
                        networkStatus: networkStatus/* NetworkStatus.error */.Ie.error,
                    });
                }
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function () {
                setTimeout(function () { return subscription.unsubscribe(); });
                _this.forceUpdate = function () { return _this.forceUpdateState(); };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches,
        ]), function () { return _this.getCurrentResult(); }, function () { return _this.getCurrentResult(); });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function (options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions((this.queryHookOptions = options));
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0,lib/* equal */.D)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted =
            options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) &&
            this.queryHookOptions.ssr === false &&
            !this.queryHookOptions.skip) {
            // If SSR has been explicitly disabled, and this function has been called
            // on the server side, return the default loading state.
            this.result = this.ssrDisabledResult;
        }
        else if (this.queryHookOptions.skip ||
            this.watchQueryOptions.fetchPolicy === "standby") {
            // When skipping a query (ie. we're not querying for data but still want to
            // render children), make sure the `data` is cleared out and `loading` is
            // set to `false` (since we aren't loading anything).
            //
            // NOTE: We no longer think this is the correct behavior. Skipping should
            // not automatically set `data` to `undefined`, but instead leave the
            // previous data in place. In other words, skipping should not mandate that
            // previously received data is all of a sudden removed. Unfortunately,
            // changing this is breaking, so we'll have to wait until Apollo Client 4.0
            // to address this.
            this.result = this.skipStandbyResult;
        }
        else if (this.result === this.ssrDisabledResult ||
            this.result === this.skipStandbyResult) {
            this.result = void 0;
        }
    };
    InternalState.prototype.getObsQueryOptions = function () {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults)
            toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) {
            toMerge.push(this.queryHookOptions.defaultOptions);
        }
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0,compact/* compact */.o)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce(mergeOptions/* mergeOptions */.J);
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function (_a) {
        var _b;
        if (_a === void 0) { _a = {}; }
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, 
        // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0,tslib_es6/* __rest */._T)(_a, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, { query: this.query });
        if (this.renderPromises &&
            (watchQueryOptions.fetchPolicy === "network-only" ||
                watchQueryOptions.fetchPolicy === "cache-and-network")) {
            // this behavior was added to react-apollo without explanation in this PR
            // https://github.com/apollographql/react-apollo/pull/1579
            watchQueryOptions.fetchPolicy = "cache-first";
        }
        if (!watchQueryOptions.variables) {
            watchQueryOptions.variables = {};
        }
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby",
            });
        }
        else if (!watchQueryOptions.fetchPolicy) {
            watchQueryOptions.fetchPolicy =
                ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) ||
                    this.getDefaultFetchPolicy();
        }
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function () {
        var _a, _b;
        return (((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) ||
            ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
            "cache-first");
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function (data) { };
    InternalState.prototype.onError = function (error) { };
    InternalState.prototype.useObservableQuery = function () {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = (this.observable =
            (this.renderPromises &&
                this.renderPromises.getSSRObservable(this.watchQueryOptions)) ||
                this.observable || // Reuse this.observable if possible (and not SSR)
                this.client.watchQuery(this.getObsQueryOptions()));
        this.obsQueryFields = react.useMemo(function () { return ({
            refetch: obsQuery.refetch.bind(obsQuery),
            reobserve: obsQuery.reobserve.bind(obsQuery),
            fetchMore: obsQuery.fetchMore.bind(obsQuery),
            updateQuery: obsQuery.updateQuery.bind(obsQuery),
            startPolling: obsQuery.startPolling.bind(obsQuery),
            stopPolling: obsQuery.stopPolling.bind(obsQuery),
            subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery),
        }); }, [obsQuery]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) {
                // TODO: This is a legacy API which could probably be cleaned up
                this.renderPromises.addObservableQueryPromise(obsQuery);
            }
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function (nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) {
            this.previousData = previousResult.data;
        }
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function (result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve()
                .then(function () {
                if (error_1) {
                    _this.onError(error_1);
                }
                else if (result.data &&
                    (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus &&
                    result.networkStatus === networkStatus/* NetworkStatus.ready */.Ie.ready) {
                    _this.onCompleted(result.data);
                }
            })
                .catch(function (error) {
                globalThis.__DEV__ !== false && globals/* invariant.warn */.kG.warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function (result) {
        return (0,arrays/* isNonEmptyArray */.O)(result.errors) ?
            new errors/* ApolloError */.cA({ graphQLErrors: result.errors })
            : result.error;
    };
    InternalState.prototype.getCurrentResult = function () {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) {
            this.handleErrorOrCompleted((this.result = this.observable.getCurrentResult()));
        }
        return this.result;
    };
    InternalState.prototype.toQueryResult = function (result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult)
            return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0,tslib_es6/* __rest */._T)(result, ["data", "partial"]);
        this.toQueryResultCache.set(result, (queryResult = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({ data: data }, resultWithoutPartial), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })));
        if (!queryResult.error && (0,arrays/* isNonEmptyArray */.O)(result.errors)) {
            // Until a set naming convention for networkError and graphQLErrors is
            // decided upon, we map errors (graphQLErrors) to the error options.
            // TODO: Is it possible for both result.error and result.errors to be
            // defined here?
            queryResult.error = new errors/* ApolloError */.cA({ graphQLErrors: result.errors });
        }
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function (result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial &&
            this.queryHookOptions.partialRefetch &&
            !result.loading &&
            (!result.data || Object.keys(result.data).length === 0) &&
            this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: networkStatus/* NetworkStatus.refetch */.Ie.refetch,
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}());
//# sourceMappingURL=useQuery.js.map

/***/ }),

/***/ 14692:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ verifyDocumentType; },
/* harmony export */   "n_": function() { return /* binding */ DocumentType; }
/* harmony export */ });
/* unused harmony exports operationName, parser */
/* harmony import */ var _utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);

var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));
var cache = new Map();
function operationName(type) {
    var name;
    switch (type) {
        case DocumentType.Query:
            name = "Query";
            break;
        case DocumentType.Mutation:
            name = "Mutation";
            break;
        case DocumentType.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
// This parser is mostly used to safety check incoming documents.
function parser(document) {
    var cached = cache.get(document);
    if (cached)
        return cached;
    var variables, type, name;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for (var _i = 0, _a = document.definitions; _i < _a.length; _i++) {
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") {
            switch (x.operation) {
                case "query":
                    queries.push(x);
                    break;
                case "mutation":
                    mutations.push(x);
                    break;
                case "subscription":
                    subscriptions.push(x);
                    break;
            }
        }
    }
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(!fragments.length ||
        queries.length ||
        mutations.length ||
        subscriptions.length, 60);
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(
        queries.length + mutations.length + subscriptions.length <= 1,
        61,
        document,
        queries.length,
        subscriptions.length,
        mutations.length
    );
    type = queries.length ? DocumentType.Query : DocumentType.Mutation;
    if (!queries.length && !mutations.length)
        type = DocumentType.Subscription;
    var definitions = queries.length ? queries
        : mutations.length ? mutations
            : subscriptions;
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") {
        name = definition.name.value;
    }
    else {
        name = "data"; // fallback to using data if no name
    }
    var payload = { name: name, type: type, variables: variables };
    cache.set(document, payload);
    return payload;
}
function verifyDocumentType(document, type) {
    var operation = parser(document);
    var requiredOperationName = operationName(type);
    var usedOperationName = operationName(operation.type);
    (0,_utilities_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(
        operation.type === type,
        63,
        requiredOperationName,
        requiredOperationName,
        usedOperationName
    );
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 21436:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "k": function() { return /* binding */ isArray; }
/* harmony export */ });
// A version of Array.isArray that works better with readonly arrays.
var isArray = Array.isArray;
function isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
//# sourceMappingURL=arrays.js.map

/***/ }),

/***/ 30320:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ canUseAsyncIteratorSymbol; },
/* harmony export */   "JC": function() { return /* binding */ canUseLayoutEffect; },
/* harmony export */   "aS": function() { return /* binding */ canUseSymbol; },
/* harmony export */   "mr": function() { return /* binding */ canUseWeakMap; },
/* harmony export */   "sy": function() { return /* binding */ canUseWeakSet; }
/* harmony export */ });
/* unused harmony export canUseDOM */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);

var canUseWeakMap = typeof WeakMap === "function" &&
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.product; }) !== "ReactNative";
var canUseWeakSet = typeof WeakSet === "function";
var canUseSymbol = typeof Symbol === "function" && typeof Symbol.for === "function";
var canUseAsyncIteratorSymbol = canUseSymbol && Symbol.asyncIterator;
var canUseDOM = typeof (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return window.document.createElement; }) === "function";
var usingJSDOM = 
// Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .maybe */ .wY)(function () { return navigator.userAgent.indexOf("jsdom") >= 0; }) || false;
// Our tests should all continue to pass if we remove this !usingJSDOM
// condition, thereby allowing useLayoutEffect when using jsdom. Unfortunately,
// if we allow useLayoutEffect, then useSyncExternalStore generates many
// warnings about useLayoutEffect doing nothing on the server. While these
// warnings are harmless, this !usingJSDOM condition seems to be the best way to
// prevent them (i.e. skipping useLayoutEffect when using jsdom).
var canUseLayoutEffect = canUseDOM && !usingJSDOM;
//# sourceMappingURL=canUse.js.map

/***/ }),

/***/ 79487:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ cloneDeep; }
/* harmony export */ });
var toString = Object.prototype.toString;
/**
 * Deeply clones a value to create a new instance.
 */
function cloneDeep(value) {
    return cloneDeepHelper(value);
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            seen = seen || new Map();
            if (seen.has(val))
                return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 53712:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ compact; }
/* harmony export */ });
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */
function compact() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var result = Object.create(null);
    objects.forEach(function (obj) {
        if (!obj)
            return;
        Object.keys(obj).forEach(function (key) {
            var value = obj[key];
            if (value !== void 0) {
                result[key] = value;
            }
        });
    });
    return result;
}
//# sourceMappingURL=compact.js.map

/***/ }),

/***/ 37280:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ isExecutionPatchIncrementalResult; },
/* harmony export */   "M0": function() { return /* binding */ isExecutionPatchResult; },
/* harmony export */   "mT": function() { return /* binding */ mergeIncrementalData; },
/* harmony export */   "yU": function() { return /* binding */ isApolloPayloadResult; }
/* harmony export */ });
/* unused harmony export isExecutionPatchInitialResult */
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);
/* harmony import */ var _arrays_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21436);
/* harmony import */ var _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(182);



function isExecutionPatchIncrementalResult(value) {
    return "incremental" in value;
}
function isExecutionPatchInitialResult(value) {
    return "hasNext" in value && "data" in value;
}
function isExecutionPatchResult(value) {
    return (isExecutionPatchIncrementalResult(value) ||
        isExecutionPatchInitialResult(value));
}
// This function detects an Apollo payload result before it is transformed
// into a FetchResult via HttpLink; it cannot detect an ApolloPayloadResult
// once it leaves the link chain.
function isApolloPayloadResult(value) {
    return (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value) && "payload" in value;
}
function mergeIncrementalData(prevResult, result) {
    var mergedData = prevResult;
    var merger = new _mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__/* .DeepMerger */ .w0();
    if (isExecutionPatchIncrementalResult(result) &&
        (0,_arrays_js__WEBPACK_IMPORTED_MODULE_2__/* .isNonEmptyArray */ .O)(result.incremental)) {
        result.incremental.forEach(function (_a) {
            var data = _a.data, path = _a.path;
            for (var i = path.length - 1; i >= 0; --i) {
                var key = path[i];
                var isNumericKey = !isNaN(+key);
                var parent_1 = isNumericKey ? [] : {};
                parent_1[key] = data;
                data = parent_1;
            }
            mergedData = merger.merge(mergedData, data);
        });
    }
    return mergedData;
}
//# sourceMappingURL=incrementalResult.js.map

/***/ }),

/***/ 60897:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ makeUniqueId; }
/* harmony export */ });
var prefixCounts = new Map();
// These IDs won't be globally unique, but they will be unique within this
// process, thanks to the counter, and unguessable thanks to the random suffix.
function makeUniqueId(prefix) {
    var count = prefixCounts.get(prefix) || 1;
    prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}
//# sourceMappingURL=makeUniqueId.js.map

/***/ }),

/***/ 48702:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ maybeDeepFreeze; }
/* harmony export */ });
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);

function deepFreeze(value) {
    var workSet = new Set([value]);
    workSet.forEach(function (obj) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(obj) && shallowFreeze(obj) === obj) {
            Object.getOwnPropertyNames(obj).forEach(function (name) {
                if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(obj[name]))
                    workSet.add(obj[name]);
            });
        }
    });
    return value;
}
function shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) {
        try {
            Object.freeze(obj);
        }
        catch (e) {
            // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
            // they all throw a TypeError when you try, so we re-throw any exceptions
            // that are not TypeErrors, since that would be unexpected.
            if (e instanceof TypeError)
                return null;
            throw e;
        }
    }
    return obj;
}
function maybeDeepFreeze(obj) {
    if (globalThis.__DEV__ !== false) {
        deepFreeze(obj);
    }
    return obj;
}
//# sourceMappingURL=maybeDeepFreeze.js.map

/***/ }),

/***/ 182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": function() { return /* binding */ mergeDeep; },
/* harmony export */   "bw": function() { return /* binding */ mergeDeepArray; },
/* harmony export */   "w0": function() { return /* binding */ DeepMerger; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _objects_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13154);


var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
// In almost any situation where you could succeed in getting the
// TypeScript compiler to infer a tuple type for the sources array, you
// could just use mergeDeep instead of mergeDeepArray, so instead of
// trying to convert T[] to an intersection type we just infer the array
// element type, which works perfectly when the sources array has a
// consistent element type.
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new DeepMerger();
        for (var i = 1; i < count; ++i) {
            target = merger.merge(target, sources[i]);
        }
    }
    return target;
}
var defaultReconciler = function (target, source, property) {
    return this.merge(target[property], source[property]);
};
var DeepMerger = /** @class */ (function () {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) { reconciler = defaultReconciler; }
        this.reconciler = reconciler;
        this.isObject = _objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s;
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function (target, source) {
        var _this = this;
        var context = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            context[_i - 2] = arguments[_i];
        }
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(source) && (0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(target)) {
            Object.keys(source).forEach(function (sourceKey) {
                if (hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([target,
                            source,
                            sourceKey], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                }
                else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function (value) {
        if ((0,_objects_js__WEBPACK_IMPORTED_MODULE_0__/* .isNonNullObject */ .s)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) {
                    value = value.slice(0);
                }
                else {
                    value = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ __proto__: Object.getPrototypeOf(value) }, value);
                }
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}());

//# sourceMappingURL=mergeDeep.js.map

/***/ }),

/***/ 14012:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mergeOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _compact_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53712);


function mergeOptions(defaults, options) {
    return (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)(defaults, options, options.variables && {
        variables: (0,_compact_js__WEBPACK_IMPORTED_MODULE_0__/* .compact */ .o)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, (defaults && defaults.variables)), options.variables)),
    });
}
//# sourceMappingURL=mergeOptions.js.map

/***/ }),

/***/ 13154:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ isNonNullObject; }
/* harmony export */ });
/* unused harmony export isPlainObject */
function isNonNullObject(obj) {
    return obj !== null && typeof obj === "object";
}
function isPlainObject(obj) {
    return (obj !== null &&
        typeof obj === "object" &&
        (Object.getPrototypeOf(obj) === Object.prototype ||
            Object.getPrototypeOf(obj) === null));
}
//# sourceMappingURL=objects.js.map

/***/ }),

/***/ 13887:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ stringifyForDisplay; }
/* harmony export */ });
/* harmony import */ var _makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60897);

function stringifyForDisplay(value, space) {
    if (space === void 0) { space = 0; }
    var undefId = (0,_makeUniqueId_js__WEBPACK_IMPORTED_MODULE_0__/* .makeUniqueId */ .X)("stringifyForDisplay");
    return JSON.stringify(value, function (key, value) {
        return value === void 0 ? undefId : value;
    }, space)
        .split(JSON.stringify(undefId))
        .join("<undefined>");
}
//# sourceMappingURL=stringifyForDisplay.js.map

/***/ }),

/***/ 78287:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kG": function() { return /* reexport */ invariantWrappers_invariant; },
  "wY": function() { return /* reexport */ maybe; },
  "_K": function() { return /* reexport */ newInvariantError; }
});

// UNUSED EXPORTS: DEV, InvariantError, __DEV__, global

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/ts-invariant/lib/invariant.js

var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));

function invariant_invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(name) {
    return function () {
        if (verbosityLevels.indexOf(name) >= verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.debug = wrapConsoleMethod("debug");
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant_invariant || (invariant_invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
/* harmony default export */ var invariant = ((/* unused pure expression or super */ null && (invariant_invariant)));
//# sourceMappingURL=invariant.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/version.js
var version = __webpack_require__(49379);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/maybe.js
function maybe(thunk) {
    try {
        return thunk();
    }
    catch (_a) { }
}
//# sourceMappingURL=maybe.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/global.js

/* harmony default export */ var globals_global = (maybe(function () { return globalThis; }) ||
    maybe(function () { return window; }) ||
    maybe(function () { return self; }) ||
    maybe(function () { return global; }) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
maybe(function () {
    return maybe.constructor("return this")();
}));
//# sourceMappingURL=global.js.map
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/stringifyForDisplay.js
var stringifyForDisplay = __webpack_require__(13887);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/invariantWrappers.js




function wrap(fn) {
    return function (message) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (typeof message === "number") {
            var arg0 = message;
            message = getHandledErrorMsg(arg0);
            if (!message) {
                message = getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [message].concat(args));
    };
}
var invariantWrappers_invariant = Object.assign(function invariant(condition, message) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (!condition) {
        invariant_invariant(condition, getHandledErrorMsg(message, args) || getFallbackErrorMsg(message, args));
    }
}, {
    debug: wrap(invariant_invariant.debug),
    log: wrap(invariant_invariant.log),
    warn: wrap(invariant_invariant.warn),
    error: wrap(invariant_invariant.error),
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */
function newInvariantError(message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    return new InvariantError(getHandledErrorMsg(message, optionalParams) ||
        getFallbackErrorMsg(message, optionalParams));
}
var ApolloErrorMessageHandler = Symbol.for("ApolloErrorMessageHandler_" + version/* version */.i);
function stringify(arg) {
    return typeof arg == "string" ? arg : ((0,stringifyForDisplay/* stringifyForDisplay */.v)(arg, 2).slice(0, 1000));
}
function getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return (globals_global[ApolloErrorMessageHandler] &&
        globals_global[ApolloErrorMessageHandler](message, messageArgs.map(stringify)));
}
function getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) { messageArgs = []; }
    if (!message)
        return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: version/* version */.i,
        message: message,
        args: messageArgs.map(stringify),
    })));
}

//# sourceMappingURL=invariantWrappers.js.map
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/globals/index.js




/**
 * @deprecated we do not use this internally anymore,
 * it is just exported for backwards compatibility
 */
// this file is extempt from automatic `__DEV__` replacement
// so we have to write it out here
// @ts-ignore
var DEV = globalThis.__DEV__ !== false;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 18056:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ DocumentTransform; }
/* harmony export */ });
/* harmony import */ var _wry_trie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75028);
/* harmony import */ var _common_canUse_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30320);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36765);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78287);




function identity(document) {
    return document;
}
var DocumentTransform = /** @class */ (function () {
    function DocumentTransform(transform, options) {
        if (options === void 0) { options = Object.create(null); }
        this.resultCache = _common_canUse_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseWeakSet */ .sy ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) {
            // Override default `getCacheKey` function, which returns [document].
            this.getCacheKey = options.getCacheKey;
        }
        if (options.cache !== false) {
            this.stableCacheKeys = new _wry_trie__WEBPACK_IMPORTED_MODULE_0__/* .Trie */ .B(_common_canUse_js__WEBPACK_IMPORTED_MODULE_2__/* .canUseWeakMap */ .mr, function (key) { return ({ key: key }); });
        }
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function (document) {
        return [document];
    };
    DocumentTransform.identity = function () {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform(identity, { cache: false });
    };
    DocumentTransform.split = function (predicate, left, right) {
        if (right === void 0) { right = DocumentTransform.identity(); }
        return new DocumentTransform(function (document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, 
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: false });
    };
    DocumentTransform.prototype.transformDocument = function (document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) {
            return document;
        }
        var cacheEntry = this.getStableCacheEntry(document);
        if (cacheEntry && cacheEntry.value) {
            return cacheEntry.value;
        }
        (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_3__/* .checkDocument */ .A$)(document);
        var transformedDocument = this.transform(document);
        this.resultCache.add(transformedDocument);
        if (cacheEntry) {
            cacheEntry.value = transformedDocument;
        }
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function (otherTransform) {
        var _this = this;
        return new DocumentTransform(function (document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, 
        // Reasonably assume both transforms handle their own caching
        { cache: false });
    };
    DocumentTransform.prototype.getStableCacheEntry = function (document) {
        if (!this.stableCacheKeys)
            return;
        var cacheKeys = this.getCacheKey(document);
        if (cacheKeys) {
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(Array.isArray(cacheKeys), 65);
            return this.stableCacheKeys.lookupArray(cacheKeys);
        }
    };
    return DocumentTransform;
}());

//# sourceMappingURL=DocumentTransform.js.map

/***/ }),

/***/ 19065:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FS": function() { return /* binding */ hasDirectives; },
/* harmony export */   "LZ": function() { return /* binding */ shouldInclude; },
/* harmony export */   "mj": function() { return /* binding */ hasClientExports; }
/* harmony export */ });
/* unused harmony exports getDirectiveNames, hasAnyDirectives, hasAllDirectives, getInclusionDirectives */
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77304);


function shouldInclude(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) {
        return true;
    }
    return getInclusionDirectives(directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue =
                variables && variables[ifArgument.value.name.value];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(evaledValue !== void 0, 66, directive.name.value);
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(root) {
    var names = [];
    visit(root, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
var hasAnyDirectives = function (names, root) {
    return hasDirectives(names, root, false);
};
var hasAllDirectives = function (names, root) {
    return hasDirectives(names, root, true);
};
function hasDirectives(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0,graphql__WEBPACK_IMPORTED_MODULE_1__/* .visit */ .Vn)(root, {
        Directive: function (node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) {
                return graphql__WEBPACK_IMPORTED_MODULE_1__/* .BREAK */ .$_;
            }
        },
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function hasClientExports(document) {
    return document && hasDirectives(["client", "export"], document, true);
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function getInclusionDirectives(directives) {
    var result = [];
    if (directives && directives.length) {
        directives.forEach(function (directive) {
            if (!isInclusionDirective(directive))
                return;
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(directiveArguments && directiveArguments.length === 1, 67, directiveName);
            var ifArgument = directiveArguments[0];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifArgument.name && ifArgument.name.value === "if", 68, directiveName);
            var ifValue = ifArgument.value;
            // means it has to be a variable value if this is a valid @skip or @include directive
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(ifValue &&
                (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 69, directiveName);
            result.push({ directive: directive, ifArgument: ifArgument });
        });
    }
    return result;
}
//# sourceMappingURL=directives.js.map

/***/ }),

/***/ 23361:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ createFragmentMap; },
/* harmony export */   "Yk": function() { return /* binding */ getFragmentQueryDocument; },
/* harmony export */   "hi": function() { return /* binding */ getFragmentFromSelection; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);


/**
 * Returns a query document which adds a single query operation that only
 * spreads the target fragment inside of it.
 *
 * So for example a document of:
 *
 * ```graphql
 * fragment foo on Foo { a b c }
 * ```
 *
 * Turns into:
 *
 * ```graphql
 * { ...foo }
 *
 * fragment foo on Foo { a b c }
 * ```
 *
 * The target fragment will either be the only fragment in the document, or a
 * fragment specified by the provided `fragmentName`. If there is more than one
 * fragment, but a `fragmentName` was not defined then an error will be thrown.
 */
function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function (definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") {
            throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(
                70,
                definition.operation,
                definition.name ? " named '".concat(definition.name.value, "'") : ""
            );
        }
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") {
            fragments.push(definition);
        }
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragments.length === 1, 71, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({}, document), { definitions: (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions, true) });
    return query;
}
// Utility function that takes a list of fragment definitions and makes a hash out of them
// that maps the name of the fragment to the fragment definition.
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getFragmentFromSelection(selection, fragmentMap) {
    switch (selection.kind) {
        case "InlineFragment":
            return selection;
        case "FragmentSpread": {
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") {
                return fragmentMap(fragmentName);
            }
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragment, 72, fragmentName);
            return fragment || null;
        }
        default:
            return null;
    }
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ 36765:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$H": function() { return /* binding */ getOperationDefinition; },
/* harmony export */   "A$": function() { return /* binding */ checkDocument; },
/* harmony export */   "O4": function() { return /* binding */ getDefaultValues; },
/* harmony export */   "iW": function() { return /* binding */ getQueryDefinition; },
/* harmony export */   "kU": function() { return /* binding */ getFragmentDefinitions; },
/* harmony export */   "p$": function() { return /* binding */ getMainDefinition; },
/* harmony export */   "pD": function() { return /* binding */ getFragmentDefinition; },
/* harmony export */   "rY": function() { return /* binding */ getOperationName; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51761);


// Checks the document for errors and throws an exception if there is an error.
function checkDocument(doc) {
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc && doc.kind === "Document", 73);
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== "FragmentDefinition"; })
        .map(function (definition) {
        if (definition.kind !== "OperationDefinition") {
            throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(74, definition.kind);
        }
        return definition;
    });
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(operations.length <= 1, 75, operations.length);
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
// Returns the FragmentDefinitions from a particular document as an array
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(queryDef && queryDef.operation === "query", 76);
    return queryDef;
}
function getFragmentDefinition(doc) {
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.kind === "Document", 77);
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(doc.definitions.length <= 1, 78);
    var fragmentDef = doc.definitions[0];
    (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant */ .kG)(fragmentDef.kind === "FragmentDefinition", 79);
    return fragmentDef;
}
/**
 * Returns the first operation definition found in this document.
 * If no operation definition is found, the first fragment definition will be returned.
 * If no definitions are found, an error will be thrown.
 */
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" ||
                operation === "mutation" ||
                operation === "subscription") {
                return definition;
            }
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
            // we do this because we want to allow multiple fragment definitions
            // to precede an operation definition.
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(80);
}
function getDefaultValues(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) {
        defs.forEach(function (def) {
            if (def.defaultValue) {
                (0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .valueToObjectRepresentation */ .vb)(defaultValues, def.variable.name, def.defaultValue);
            }
        });
    }
    return defaultValues;
}
//# sourceMappingURL=getFromAST.js.map

/***/ }),

/***/ 5144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ print_print; }
});

// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? (0,blockString/* printBlockString */.LZ)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/common/canUse.js
var canUse = __webpack_require__(30320);
;// CONCATENATED MODULE: ./node_modules/@apollo/client/utilities/graphql/print.js


var printCache = canUse/* canUseWeakMap */.mr ? new WeakMap() : undefined;
var print_print = function (ast) {
    var result;
    result = printCache === null || printCache === void 0 ? void 0 : printCache.get(ast);
    if (!result) {
        result = print(ast);
        printCache === null || printCache === void 0 ? void 0 : printCache.set(ast, result);
    }
    return result;
};
//# sourceMappingURL=print.js.map

/***/ }),

/***/ 51761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ao": function() { return /* binding */ isInlineFragment; },
/* harmony export */   "JW": function() { return /* binding */ isDocumentNode; },
/* harmony export */   "My": function() { return /* binding */ isField; },
/* harmony export */   "NC": function() { return /* binding */ argumentsObjectFromField; },
/* harmony export */   "PT": function() { return /* binding */ getStoreKeyName; },
/* harmony export */   "Yk": function() { return /* binding */ isReference; },
/* harmony export */   "kQ": function() { return /* binding */ makeReference; },
/* harmony export */   "qw": function() { return /* binding */ getTypenameFromResult; },
/* harmony export */   "u2": function() { return /* binding */ resultKeyNameFromField; },
/* harmony export */   "vb": function() { return /* binding */ valueToObjectRepresentation; },
/* harmony export */   "vf": function() { return /* binding */ storeKeyNameFromField; }
/* harmony export */ });
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var _common_objects_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13154);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23361);



function makeReference(id) {
    return { __ref: String(id) };
}
function isReference(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function isDocumentNode(value) {
    return ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) &&
        value.kind === "Document" &&
        Array.isArray(value.definitions));
}
function isStringValue(value) {
    return value.kind === "StringValue";
}
function isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function isIntValue(value) {
    return value.kind === "IntValue";
}
function isFloatValue(value) {
    return value.kind === "FloatValue";
}
function isVariable(value) {
    return value.kind === "Variable";
}
function isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function isListValue(value) {
    return value.kind === "ListValue";
}
function isEnumValue(value) {
    return value.kind === "EnumValue";
}
function isNullValue(value) {
    return value.kind === "NullValue";
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw (0,_globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .newInvariantError */ ._K)(81, name.value, value.kind);
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive",
];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
    if (args &&
        directives &&
        directives["connection"] &&
        directives["connection"]["key"]) {
        if (directives["connection"]["filter"] &&
            directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ?
                directives["connection"]["filter"]
                : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat(stringify(filteredArgs_1), ")");
        }
        else {
            return directives["connection"]["key"];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = stringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
            }
            else {
                completeFieldName += "@".concat(key);
            }
        });
    }
    return completeFieldName;
}, {
    setStringify: function (s) {
        var previous = stringify;
        stringify = s;
        return previous;
    },
});
// Default stable JSON.stringify implementation. Can be updated/replaced with
// something better by calling getStoreKeyName.setStringify.
var stringify = function defaultStringify(value) {
    return JSON.stringify(value, stringifyReplacer);
};
function stringifyReplacer(_key, value) {
    if ((0,_common_objects_js__WEBPACK_IMPORTED_MODULE_1__/* .isNonNullObject */ .s)(value) && !Array.isArray(value)) {
        value = Object.keys(value)
            .sort()
            .reduce(function (copy, key) {
            copy[key] = value[key];
            return copy;
        }, {});
    }
    return value;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function getTypenameFromResult(result, selectionSet, fragmentMap) {
    var fragments;
    for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
        var selection = _a[_i];
        if (isField(selection)) {
            if (selection.name.value === "__typename") {
                return result[resultKeyNameFromField(selection)];
            }
        }
        else if (fragments) {
            fragments.push(selection);
        }
        else {
            fragments = [selection];
        }
    }
    if (typeof result.__typename === "string") {
        return result.__typename;
    }
    if (fragments) {
        for (var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++) {
            var selection = fragments_1[_b];
            var typename = getTypenameFromResult(result, (0,_fragments_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentFromSelection */ .hi)(selection, fragmentMap).selectionSet, fragmentMap);
            if (typeof typename === "string") {
                return typename;
            }
        }
    }
}
function isField(selection) {
    return selection.kind === "Field";
}
function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
}
//# sourceMappingURL=storeUtils.js.map

/***/ }),

/***/ 76487:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gw": function() { return /* binding */ addTypenameToDocument; },
/* harmony export */   "aL": function() { return /* binding */ buildQueryFromSelectionSet; },
/* harmony export */   "bi": function() { return /* binding */ removeDirectivesFromDocument; },
/* harmony export */   "ob": function() { return /* binding */ removeClientSetsFromDocument; }
/* harmony export */ });
/* unused harmony exports removeConnectionDirectiveFromDocument, removeArgumentsFromDocument, removeFragmentSpreadFromDocument */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97582);
/* harmony import */ var _globals_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78287);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97359);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77304);
/* harmony import */ var _getFromAST_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36765);
/* harmony import */ var _storeUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51761);
/* harmony import */ var _fragments_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23361);
/* harmony import */ var _common_arrays_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21436);







var TYPENAME_FIELD = {
    kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD,
    name: {
        kind: graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.NAME */ .h.NAME,
        value: "__typename",
    },
};
function isEmpty(op, fragmentMap) {
    return (!op ||
        op.selectionSet.selections.every(function (selection) {
            return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_SPREAD */ .h.FRAGMENT_SPREAD &&
                isEmpty(fragmentMap[selection.name.value], fragmentMap);
        }));
}
function nullIfDocIsEmpty(doc) {
    return (isEmpty((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getOperationDefinition */ .$H)(doc) || (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinition */ .pD)(doc), (0,_fragments_js__WEBPACK_IMPORTED_MODULE_3__/* .createFragmentMap */ .F)((0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getFragmentDefinitions */ .kU)(doc)))) ?
        null
        : doc;
}
function getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function (directive) {
        if (directive) {
            if (directive.name) {
                names.set(directive.name, directive);
            }
            else if (directive.test) {
                tests.set(directive.test, directive);
            }
        }
    });
    return function (directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) {
            tests.forEach(function (testConfig, test) {
                if (test(directive)) {
                    config = testConfig;
                }
            });
        }
        return config;
    };
}
function makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) { key = defaultKey; }
        var inUse = map.get(key);
        if (!inUse) {
            map.set(key, (inUse = {
                // Variable and fragment spread names used directly within this
                // operation or fragment definition, as identified by key. These sets
                // will be populated during the first traversal of the document in
                // removeDirectivesFromDocument below.
                variables: new Set(),
                fragmentSpreads: new Set(),
            }));
        }
        return inUse;
    };
}
function removeDirectivesFromDocument(directives, doc) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = makeInUseGetterFunction("");
    var getInUseByFragmentName = makeInUseGetterFunction("");
    var getInUse = function (ancestors) {
        for (var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p) {
            if ((0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isArray */ .k)(ancestor))
                continue;
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                // If an operation is anonymous, we use the empty string as its key.
                return getInUseByOperationName(ancestor.name && ancestor.name.value);
            }
            if (ancestor.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION) {
                return getInUseByFragmentName(ancestor.name.value);
            }
        }
        globalThis.__DEV__ !== false && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.error */ .kG.error(82);
        return null;
    };
    var operationCount = 0;
    for (var i = doc.definitions.length - 1; i >= 0; --i) {
        if (doc.definitions[i].kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            ++operationCount;
        }
    }
    var directiveMatcher = getDirectiveMatcher(directives);
    var shouldRemoveField = function (nodeDirectives) {
        return (0,_common_arrays_js__WEBPACK_IMPORTED_MODULE_4__/* .isNonEmptyArray */ .O)(nodeDirectives) &&
            nodeDirectives
                .map(directiveMatcher)
                .some(function (config) { return config && config.remove; });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function (node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        },
    };
    var docWithoutDirectiveSubtrees = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function () {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            },
        },
        Variable: {
            enter: function (node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.variables.add(node.name.value);
                }
            },
        },
        FragmentSpread: {
            enter: function (node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) {
                    inUse.fragmentSpreads.add(node.name.value);
                }
                // We might like to remove this FragmentSpread by returning null here if
                // the corresponding FragmentDefinition node is also going to be removed
                // by the logic below, but we can't control the relative order of those
                // events, so we have to postpone the removal of dangling FragmentSpread
                // nodes until after the current visit of the document has finished.
            },
        },
        FragmentDefinition: {
            enter: function (node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function (node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) {
                    // If the FragmentNode received by this leave function is identical to
                    // the one received by the corresponding enter function (above), then
                    // the visitor must not have made any changes within this
                    // FragmentDefinition node. This fragment definition may still be
                    // removed if there are no ...spread references to it, but it won't be
                    // removed just because it has only a __typename field.
                    return node;
                }
                if (
                // This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 &&
                    node.selectionSet.selections.every(function (selection) {
                        return selection.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FIELD */ .h.FIELD &&
                            selection.name.value === "__typename";
                    })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
        Directive: {
            leave: function (node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            },
        },
    });
    if (!firstVisitMadeChanges) {
        // If our first pass did not change anything about the document, then there
        // is no cleanup we need to do, and we can return the original doc.
        return doc;
    }
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function (inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) {
                inUse.fragmentSpreads.forEach(function (childFragmentName) {
                    populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function (varName) {
                        inUse.transitiveVars.add(varName);
                    });
                });
            }
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function (def) {
        if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
            populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function (childFragmentName) {
                allFragmentNamesUsed.add(childFragmentName);
            });
        }
        else if (def.kind === graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.FRAGMENT_DEFINITION */ .h.FRAGMENT_DEFINITION &&
            // If there are no operations in the document, then all fragment
            // definitions count as usages of their own fragment names. This heuristic
            // prevents accidentally removing all fragment definitions from the
            // document just because it contains no operations that use the fragments.
            operationCount === 0 &&
            !getInUseByFragmentName(def.name.value).removed) {
            allFragmentNamesUsed.add(def.name.value);
        }
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function (fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function (childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function (fragmentName) {
        return !!(
        // A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) ||
            getInUseByFragmentName(fragmentName).removed));
    };
    var enterVisitor = {
        enter: function (node) {
            if (fragmentWillBeRemoved(node.name.value)) {
                return null;
            }
        },
    };
    return nullIfDocIsEmpty((0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function (node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(
                    // If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) {
                        return (0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                                return usedVariableNames_1.has(varDef.variable.name.value);
                            }) });
                    }
                }
            },
        },
    }));
}
var addTypenameToDocument = Object.assign(function (doc) {
    return (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(doc, {
        SelectionSet: {
            enter: function (node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent &&
                    parent.kind ===
                        graphql__WEBPACK_IMPORTED_MODULE_1__/* .Kind.OPERATION_DEFINITION */ .h.OPERATION_DEFINITION) {
                    return;
                }
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function (selection) {
                    return ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(selection) &&
                        (selection.name.value === "__typename" ||
                            selection.name.value.lastIndexOf("__", 0) === 0));
                });
                if (skip) {
                    return;
                }
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0,_storeUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .isField */ .My)(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === "export"; })) {
                    return;
                }
                // Create and return a new SelectionSet with a __typename Field.
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)({}, node), { selections: (0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__spreadArray */ .ev)([], selections, true), [TYPENAME_FIELD], false) });
            },
        },
    });
}, {
    added: function (field) {
        return field === TYPENAME_FIELD;
    },
});
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === "key"; })) {
                globalThis.__DEV__ !== false && _globals_index_js__WEBPACK_IMPORTED_MODULE_0__/* .invariant.warn */ .kG.warn(83);
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (!!selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === Kind.VARIABLE &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(visit(doc, {
        OperationDefinition: {
            enter: function (node) {
                return __assign(__assign({}, node), { 
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ?
                        node.variableDefinitions.filter(function (varDef) {
                            return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                        })
                        : [] });
            },
        },
        Field: {
            enter: function (node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) {
                        node.arguments.forEach(function (arg) {
                            if (argMatcher(arg)) {
                                argMatchCount_1 += 1;
                            }
                        });
                    }
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                // Remove all matching arguments.
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(visit(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
// If the incoming document is a query, return it as is. Otherwise, build a
// new document containing a query operation based on the selection set
// of the previous main operation.
function buildQueryFromSelectionSet(document) {
    var definition = (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .getMainDefinition */ .p$)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") {
        // Already a query, so return the existing document.
        return document;
    }
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0,graphql__WEBPACK_IMPORTED_MODULE_5__/* .visit */ .Vn)(document, {
        OperationDefinition: {
            enter: function (node) {
                return (0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_6__/* .__assign */ .pi)({}, node), { operation: "query" });
            },
        },
    });
    return modifiedDoc;
}
// Remove fields / selection sets that include an @client directive.
function removeClientSetsFromDocument(document) {
    (0,_getFromAST_js__WEBPACK_IMPORTED_MODULE_2__/* .checkDocument */ .A$)(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === "client"; },
            remove: true,
        },
    ], document);
    return modifiedDoc;
}
//# sourceMappingURL=transform.js.map

/***/ }),

/***/ 97091:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZB": function() { return /* binding */ relayStylePagination; }
/* harmony export */ });
/* unused harmony exports concatPagination, offsetLimitPagination */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _common_mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(182);



// A very basic pagination field policy that always concatenates new
// results onto the existing array, without examining options.args.
function concatPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming) {
            return existing ? __spreadArray(__spreadArray([], existing, true), incoming, true) : incoming;
        },
    };
}
// A basic field policy that uses options.args.{offset,limit} to splice
// the incoming data into the existing array. If your arguments are called
// something different (like args.{start,count}), feel free to copy/paste
// this implementation and make the appropriate changes.
function offsetLimitPagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        merge: function (existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (incoming) {
                if (args) {
                    // Assume an offset of 0 if args.offset omitted.
                    var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                    for (var i = 0; i < incoming.length; ++i) {
                        merged[offset + i] = incoming[i];
                    }
                }
                else {
                    // It's unusual (probably a mistake) for a paginated field not
                    // to receive any arguments, so you might prefer to throw an
                    // exception here, instead of recovering by appending incoming
                    // onto the existing array.
                    merged.push.apply(merged, incoming);
                }
            }
            return merged;
        },
    };
}
// As proof of the flexibility of field policies, this function generates
// one that handles Relay-style pagination, without Apollo Client knowing
// anything about connections, edges, cursors, or pageInfo objects.
function relayStylePagination(keyArgs) {
    if (keyArgs === void 0) { keyArgs = false; }
    return {
        keyArgs: keyArgs,
        read: function (existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing)
                return existing;
            var edges = [];
            var firstEdgeCursor = "";
            var lastEdgeCursor = "";
            existing.edges.forEach(function (edge) {
                // Edges themselves could be Reference objects, so it's important
                // to use readField to access the edge.edge.node property.
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        firstEdgeCursor = firstEdgeCursor || edge.cursor || "";
                        lastEdgeCursor = edge.cursor || lastEdgeCursor;
                    }
                }
            });
            if (edges.length > 1 && firstEdgeCursor === lastEdgeCursor) {
                firstEdgeCursor = "";
            }
            var _b = existing.pageInfo || {}, startCursor = _b.startCursor, endCursor = _b.endCursor;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, getExtras(existing)), { edges: edges, pageInfo: (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, existing.pageInfo), { 
                    // If existing.pageInfo.{start,end}Cursor are undefined or "", default
                    // to firstEdgeCursor and/or lastEdgeCursor.
                    startCursor: startCursor || firstEdgeCursor, endCursor: endCursor || lastEdgeCursor }) });
        },
        merge: function (existing, incoming, _a) {
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            if (!existing) {
                existing = makeEmptyData();
            }
            if (!incoming) {
                return existing;
            }
            var incomingEdges = incoming.edges ?
                incoming.edges.map(function (edge) {
                    if (isReference((edge = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, edge)))) {
                        // In case edge is a Reference, we read out its cursor field and
                        // store it as an extra property of the Reference object.
                        edge.cursor = readField("cursor", edge);
                    }
                    return edge;
                })
                : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                // In case we did not request the cursor field for edges in this
                // query, we can still infer cursors from pageInfo.
                if (firstEdge && startCursor) {
                    firstEdge.cursor = startCursor;
                }
                if (lastEdge && endCursor) {
                    lastEdge.cursor = endCursor;
                }
                // Cursors can also come from edges, so we default
                // pageInfo.{start,end}Cursor to {first,last}Edge.cursor.
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) {
                    incoming = (0,_common_mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeDeep */ .Ee)(incoming, {
                        pageInfo: {
                            startCursor: firstCursor,
                        },
                    });
                }
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) {
                    incoming = (0,_common_mergeDeep_js__WEBPACK_IMPORTED_MODULE_1__/* .mergeDeep */ .Ee)(incoming, {
                        pageInfo: {
                            endCursor: lastCursor,
                        },
                    });
                }
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                // This comparison does not need to use readField("cursor", edge),
                // because we stored the cursor field of any Reference edges as an
                // extra property of the Reference object.
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.after; });
                if (index >= 0) {
                    prefix = prefix.slice(0, index + 1);
                    // suffix = []; // already true
                }
            }
            else if (args && args.before) {
                var index = prefix.findIndex(function (edge) { return edge.cursor === args.before; });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            }
            else if (incoming.edges) {
                // If we have neither args.after nor args.before, the incoming
                // edges cannot be spliced into the existing edges, so they must
                // replace the existing edges. See #6592 for a motivating example.
                prefix = [];
            }
            var edges = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__spreadArray */ .ev)([], prefix, true), incomingEdges, true), suffix, true);
            var pageInfo = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._T)(_b, ["hasPreviousPage", "hasNextPage", "startCursor", "endCursor"]);
                // If incoming.pageInfo had any extra non-standard properties,
                // assume they should take precedence over any existing properties
                // of the same name, regardless of where this page falls with
                // respect to the existing data.
                Object.assign(pageInfo, extras);
                // Keep existing.pageInfo.has{Previous,Next}Page unless the
                // placement of the incoming edges means incoming.hasPreviousPage
                // or incoming.hasNextPage should become the new values for those
                // properties in existing.pageInfo. Note that these updates are
                // only permitted when the beginning or end of the incoming page
                // coincides with the beginning or end of the existing data, as
                // determined using prefix.length and suffix.length.
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage)
                        pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor)
                        pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage)
                        pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor)
                        pageInfo.endCursor = endCursor;
                }
            }
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__assign */ .pi)({}, getExtras(existing)), getExtras(incoming)), { edges: edges, pageInfo: pageInfo });
        },
    };
}
// Returns any unrecognized properties of the given object.
var getExtras = function (obj) { return (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__rest */ ._T)(obj, notExtras); };
var notExtras = ["edges", "pageInfo"];
function makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: "",
        },
    };
}
//# sourceMappingURL=pagination.js.map

/***/ }),

/***/ 49379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ version; }
/* harmony export */ });
var version = "3.8.8";
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 30907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),

/***/ 83878:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 97326:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),

/***/ 15671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 43144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83997);

function _defineProperty(obj, key, value) {
  key = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 94578:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89611);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(subClass, superClass);
}

/***/ }),

/***/ 59199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),

/***/ 25267:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 45987:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 89611:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ 97685:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(83878);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(25267);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return (0,arrayWithHoles/* default */.Z)(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || (0,nonIterableRest/* default */.Z)();
}

/***/ }),

/***/ 74902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(30907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(59199);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(40181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,iterableToArray/* default */.Z)(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 83997:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : String(i);
}

/***/ }),

/***/ 71002:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ }),

/***/ 40181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 4111:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ }),

/***/ 60460:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return (0,_assert_this_initialized/* default */.Z)(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 88029:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 30020:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ equal; }
/* harmony export */ });
const { toString, hasOwnProperty } = Object.prototype;
const fnToStr = Function.prototype.toString;
const previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
// Allow default imports as well.
/* harmony default export */ __webpack_exports__["Z"] = (equal);
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = toString.call(a);
    const bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            const aKeys = definedKeys(a);
            const bKeys = definedKeys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            const keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (let k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (let k = 0; k < keyCount; ++k) {
                const key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            const aIterator = a.entries();
            const isMap = aTag === '[object Map]';
            while (true) {
                const info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                const [aKey, aValue] = info.value;
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
        case '[object Uint16Array]':
        case '[object Uint8Array]': // Buffer, in Node.js.
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]': {
            let len = a.byteLength;
            if (len === b.byteLength) {
                while (len-- && a[len] === b[len]) {
                    // Keep looping as long as the bytes are equal.
                }
            }
            return len === -1;
        }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]': {
            const aCode = fnToStr.call(a);
            if (aCode !== fnToStr.call(b)) {
                return false;
            }
            // We consider non-native functions equal if they have the same code
            // (native functions require === because their code is censored).
            // Note that this behavior is not entirely sound, since !== function
            // objects with the same code can behave differently depending on
            // their closure scope. However, any function can behave differently
            // depending on the values of its input arguments (including this)
            // and its calling context (including its closure scope), even
            // though the function object is === to itself; and it is entirely
            // possible for functions that are not === to behave exactly the
            // same under all conceivable circumstances. Because none of these
            // factors are statically decidable in JavaScript, JS function
            // equality is not well-defined. This ambiguity allows us to
            // consider the best possible heuristic among various imperfect
            // options, and equating non-native functions that have the same
            // code has enormous practical benefits, such as when comparing
            // functions that are repeatedly passed as fresh function
            // expressions within objects that are otherwise deeply equal. Since
            // any function created from the same syntactic expression (in the
            // same code location) will always stringify to the same code
            // according to fnToStr.call, we can reasonably expect these
            // repeatedly passed function expressions to have the same code, and
            // thus behave "the same" (with all the caveats mentioned above),
            // even though the runtime function objects are !== to one another.
            return !endsWith(aCode, nativeCodeSuffix);
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter(isDefinedKey, obj);
}
function isDefinedKey(key) {
    return this[key] !== void 0;
}
const nativeCodeSuffix = "{ [native code] }";
function endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 &&
        full.indexOf(suffix, fromIndex) === fromIndex;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 75028:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ Trie; }
/* harmony export */ });
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray(slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
                    map.delete(head);
                }
            }
        }
        else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && isObjRef(key)
            ? this.weak || (create ? this.weak = new WeakMap : void 0)
            : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ inspect; }
/* harmony export */ });
/* harmony import */ var _nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45695);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 45695:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__) {

"use strict";
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["Z"] = (nodejsCustomInspectSymbol);


/***/ }),

/***/ 29749:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ye": function() { return /* binding */ Location; },
  "WU": function() { return /* binding */ Token; },
  "UG": function() { return /* binding */ isNode; }
});

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/nodejsCustomInspectSymbol.mjs
var nodejsCustomInspectSymbol = __webpack_require__(45695);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/defineInspect.mjs


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || invariant(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (nodejsCustomInspectSymbol/* default */.Z) {
    classObject.prototype[nodejsCustomInspectSymbol/* default */.Z] = fn;
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/ast.mjs


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

defineInspect(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "W7": function() { return /* binding */ dedentBlockStringValue; }
/* harmony export */ });
/* unused harmony export getBlockStringIndentation */
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),

/***/ 77304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports QueryDocumentKeys, visitInParallel, getVisitFn */
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25821);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29749);


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!(0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node)) {
        throw new Error("Invalid AST Node: ".concat((0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),

/***/ 31662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g7": function() { return /* reexport */ Slot; },
  "dP": function() { return /* reexport */ dep; },
  "re": function() { return /* binding */ wrap; }
});

// UNUSED EXPORTS: KeyTrie, asyncFromGen, bindContext, defaultMakeCacheKey, noContext, nonReactive, setTimeout

;// CONCATENATED MODULE: ./node_modules/optimism/node_modules/@wry/trie/lib/index.js
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const defaultMakeData = () => Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach, slice } = Array.prototype;
const { hasOwnProperty: lib_hasOwnProperty } = Object.prototype;
class Trie {
    constructor(weakness = true, makeData = defaultMakeData) {
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        forEach.call(array, key => node = node.getChildTrie(key));
        return lib_hasOwnProperty.call(node, "data")
            ? node.data
            : node.data = this.makeData(slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for (let i = 0, len = array.length; node && i < len; ++i) {
            const map = this.weakness && isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && isObjRef(key)
            ? this.weak || (this.weak = new WeakMap())
            : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child)
            map.set(key, child = new Trie(this.weakness, this.makeData));
        return child;
    }
}
function isObjRef(value) {
    switch (typeof value) {
        case "object":
            if (value === null)
                break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@wry/caches/lib/strong.js
function defaultDispose() { }
class StrongCache {
    constructor(max = Infinity, dispose = defaultDispose) {
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older, newer } = node;
            if (newer) {
                newer.older = older;
            }
            if (older) {
                older.newer = newer;
            }
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) {
                this.oldest = newer;
            }
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) {
            return node.value = value;
        }
        node = {
            key,
            value,
            newer: null,
            older: this.newest
        };
        if (this.newest) {
            this.newest.newer = node;
        }
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
        }
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) {
                this.newest = node.older;
            }
            if (node === this.oldest) {
                this.oldest = node.newer;
            }
            if (node.newer) {
                node.newer.older = node.older;
            }
            if (node.older) {
                node.older.newer = node.newer;
            }
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}
//# sourceMappingURL=strong.js.map
;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/slot.js
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const MISSING_VALUE = {};
let idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const makeSlotClass = () => class Slot {
    constructor() {
        // If you have a Slot object, you can find out its slot.id, but you cannot
        // guess the slot.id of a Slot you don't have access to, thanks to the
        // randomized suffix.
        this.id = [
            "slot",
            idCounter++,
            Date.now(),
            Math.random().toString(36).slice(2),
        ].join(":");
    }
    hasValue() {
        for (let context = currentContext; context; context = context.parent) {
            // We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === MISSING_VALUE)
                    break;
                if (context !== currentContext) {
                    // Cache the value in currentContext.slots so the next lookup will
                    // be faster. This caching is safe because the tree of contexts and
                    // the values of the slots are logically immutable.
                    currentContext.slots[this.id] = value;
                }
                return true;
            }
        }
        if (currentContext) {
            // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            currentContext.slots[this.id] = MISSING_VALUE;
        }
        return false;
    }
    getValue() {
        if (this.hasValue()) {
            return currentContext.slots[this.id];
        }
    }
    withValue(value, callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        const slots = {
            __proto__: null,
            [this.id]: value,
        };
        const parent = currentContext;
        currentContext = { parent, slots };
        try {
            // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.
            return callback.apply(thisArg, args);
        }
        finally {
            currentContext = parent;
        }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(callback) {
        const context = currentContext;
        return function () {
            const saved = currentContext;
            try {
                currentContext = context;
                return callback.apply(this, arguments);
            }
            finally {
                currentContext = saved;
            }
        };
    }
    // Immediately run a callback function without any captured context.
    static noContext(callback, 
    // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
        if (currentContext) {
            const saved = currentContext;
            try {
                currentContext = null;
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            }
            finally {
                currentContext = saved;
            }
        }
        else {
            return callback.apply(thisArg, args);
        }
    }
};
function maybe(fn) {
    try {
        return fn();
    }
    catch (ignored) { }
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const globalKey = "@wry/context:Slot";
const host = 
// Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(() => globalThis) ||
    // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    maybe(() => global) ||
    // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const globalHost = host;
const Slot = globalHost[globalKey] ||
    // Earlier versions of this package stored the globalKey property on the Array
    // constructor, so we check there as well, to prevent Slot class duplication.
    Array[globalKey] ||
    (function (Slot) {
        try {
            Object.defineProperty(globalHost, globalKey, {
                value: Slot,
                enumerable: false,
                writable: false,
                // When it was possible for globalHost to be the Array constructor (a
                // legacy Slot dedup strategy), it was important for the property to be
                // configurable:true so it could be deleted. That does not seem to be as
                // important when globalHost is the global object, but I don't want to
                // cause similar problems again, and configurable:true seems safest.
                // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
                configurable: true
            });
        }
        finally {
            return Slot;
        }
    })(makeSlotClass());
//# sourceMappingURL=slot.js.map
;// CONCATENATED MODULE: ./node_modules/@wry/context/lib/index.js


const { bind, noContext } = Slot;
// Like global.setTimeout, except the callback runs with captured context.

function setTimeoutWithContext(callback, delay) {
    return setTimeout(bind(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function asyncFromGen(genFn) {
    return function () {
        const gen = genFn.apply(this, arguments);
        const boundNext = bind(gen.next);
        const boundThrow = bind(gen.throw);
        return new Promise((resolve, reject) => {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                }
                catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if (isPromiseLike(result.value)) {
                    result.value.then(next, result.done ? reject : invokeThrow);
                }
                else {
                    next(result.value);
                }
            }
            const invokeNext = (value) => invoke(boundNext, value);
            const invokeThrow = (error) => invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const wrappedFibers = (/* unused pure expression or super */ null && ([]));
function wrapYieldingFiberMethods(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if (wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method) => {
            const fn = obj[method];
            obj[method] = function () {
                return noContext(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        wrappedFibers.push(Fiber);
    }
    return Fiber;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/optimism/lib/context.js

const parentEntrySlot = new Slot();
function nonReactive(fn) {
    return parentEntrySlot.withValue(void 0, fn);
}


//# sourceMappingURL=context.js.map
;// CONCATENATED MODULE: ./node_modules/optimism/lib/helpers.js
const { hasOwnProperty: helpers_hasOwnProperty, } = Object.prototype;
const arrayFromSet = Array.from ||
    function (set) {
        const array = [];
        set.forEach(item => array.push(item));
        return array;
    };
function maybeUnsubscribe(entryOrDep) {
    const { unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}
//# sourceMappingURL=helpers.js.map
;// CONCATENATED MODULE: ./node_modules/optimism/lib/entry.js


const emptySetPool = [];
const POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
    if (!condition) {
        throw new Error(optionalMessage || "assertion failure");
    }
}
function valueIs(a, b) {
    const len = a.length;
    return (
    // Unknown values are not equal to each other.
    len > 0 &&
        // Both values must be ordinary (or both exceptional) to be equal.
        len === b.length &&
        // The underlying value or exception must be the same.
        a[len - 1] === b[len - 1]);
}
function valueGet(value) {
    switch (value.length) {
        case 0: throw new Error("unknown value");
        case 1: return value[0];
        case 2: throw value[1];
    }
}
function valueCopy(value) {
    return value.slice(0);
}
class Entry {
    constructor(fn) {
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++Entry.count;
    }
    peek() {
        if (this.value.length === 1 && !mightBeDirty(this)) {
            rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        assert(!this.recomputing, "already recomputing");
        rememberParent(this);
        return mightBeDirty(this)
            ? reallyRecompute(this, args)
            : valueGet(this.value);
    }
    setDirty() {
        if (this.dirty)
            return;
        this.dirty = true;
        reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        maybeUnsubscribe(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        eachParent(this, (parent, child) => {
            parent.setDirty();
            forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) {
            this.deps = emptySetPool.pop() || new Set();
        }
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            arrayFromSet(this.deps).forEach(dep => dep.delete(this));
            this.deps.clear();
            emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
Entry.count = 0;
function rememberParent(child) {
    const parent = parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) {
            parent.childValues.set(child, []);
        }
        if (mightBeDirty(child)) {
            reportDirtyChild(parent, child);
        }
        else {
            reportCleanChild(parent, child);
        }
        return parent;
    }
}
function reallyRecompute(entry, args) {
    forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);
    if (maybeSubscribe(entry, args)) {
        // If we successfully recomputed entry.value and did not fail to
        // (re)subscribe, then this Entry is no longer explicitly dirty.
        setClean(entry);
    }
    return valueGet(entry.value);
}
function recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) {
        oldValueCopy = valueCopy(entry.value);
    }
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !valueIs(oldValueCopy, entry.value)) {
            try {
                entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
            }
            catch (_a) {
                // If normalizeResult throws, just use the newer value, rather than
                // saving the exception as entry.value[1].
            }
        }
    }
    catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function setClean(entry) {
    entry.dirty = false;
    if (mightBeDirty(entry)) {
        // This Entry may still have dirty children, in which case we can't
        // let our parents know we're clean just yet.
        return;
    }
    reportClean(entry);
}
function reportDirty(child) {
    eachParent(child, reportDirtyChild);
}
function reportClean(child) {
    eachParent(child, reportCleanChild);
}
function eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = arrayFromSet(child.parents);
        for (let i = 0; i < parentCount; ++i) {
            callback(parents[i], child);
        }
    }
}
// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    assert(parent.childValues.has(child));
    assert(mightBeDirty(child));
    const parentWasClean = !mightBeDirty(parent);
    if (!parent.dirtyChildren) {
        parent.dirtyChildren = emptySetPool.pop() || new Set;
    }
    else if (parent.dirtyChildren.has(child)) {
        // If we already know this child is dirty, then we must have already
        // informed our own parents that we are dirty, so we can terminate
        // the recursion early.
        return;
    }
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) {
        reportDirty(parent);
    }
}
// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    assert(parent.childValues.has(child));
    assert(!mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) {
        parent.childValues.set(child, valueCopy(child.value));
    }
    else if (!valueIs(childValue, child.value)) {
        parent.setDirty();
    }
    removeDirtyChild(parent, child);
    if (mightBeDirty(parent)) {
        return;
    }
    reportClean(parent);
}
function removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if (emptySetPool.length < POOL_TARGET_SIZE) {
                emptySetPool.push(dc);
            }
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(parent) {
    if (parent.childValues.size > 0) {
        parent.childValues.forEach((_value, child) => {
            forgetChild(parent, child);
        });
    }
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    assert(parent.dirtyChildren === null);
}
function forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    removeDirtyChild(parent, child);
}
function maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") {
        try {
            maybeUnsubscribe(entry); // Prevent double subscriptions.
            entry.unsubscribe = entry.subscribe.apply(null, args);
        }
        catch (e) {
            // If this Entry has a subscribe function and it threw an exception
            // (or an unsubscribe function it previously returned now throws),
            // return false to indicate that we were not able to subscribe (or
            // unsubscribe), and this Entry should remain dirty.
            entry.setDirty();
            return false;
        }
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
//# sourceMappingURL=entry.js.map
;// CONCATENATED MODULE: ./node_modules/optimism/lib/dep.js


const EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true, // Fully remove parent Entry from LRU cache and computation graph
};
function dep(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = parentEntrySlot.getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) {
                depsByKey.set(key, dep = new Set);
            }
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                maybeUnsubscribe(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = (entryMethodName &&
                helpers_hasOwnProperty.call(EntryMethods, entryMethodName)) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            arrayFromSet(dep).forEach(entry => entry[m]());
            depsByKey.delete(key);
            maybeUnsubscribe(dep);
        }
    };
    return depend;
}
//# sourceMappingURL=dep.js.map
;// CONCATENATED MODULE: ./node_modules/optimism/lib/index.js




// These helper functions are important for making optimism work with
// asynchronous code. In order to register parent-child dependencies,
// optimism needs to know about any currently active parent computations.
// In ordinary synchronous code, the parent context is implicit in the
// execution stack, but asynchronous code requires some extra guidance in
// order to propagate context from one async task segment to the next.

// A lighter-weight dependency, similar to OptimisticWrapperFunction, except
// with only one argument, no makeCacheKey, no wrapped function to recompute,
// and no result value. Useful for representing dependency leaves in the graph
// of computation. Subscriptions are supported.

// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let defaultKeyTrie;
function defaultMakeCacheKey(...args) {
    const trie = defaultKeyTrie || (defaultKeyTrie = new Trie(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
// If you're paranoid about memory leaks, or you want to avoid using WeakMap
// under the hood, but you still need the behavior of defaultMakeCacheKey,
// import this constructor to create your own tries.

;
const caches = new Set();
function wrap(originalFunction, { max = Math.pow(2, 16), keyArgs, makeCacheKey = defaultMakeCacheKey, normalizeResult, subscribe, cache: cacheOption = StrongCache, } = Object.create(null)) {
    const cache = typeof cacheOption === "function"
        ? new cacheOption(max, entry => entry.dispose())
        : cacheOption;
    const optimistic = function () {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) {
            return originalFunction.apply(null, arguments);
        }
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new Entry(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = () => cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!parentEntrySlot.hasValue()) {
            caches.forEach(cache => cache.clean());
            caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: () => cache.size,
        configurable: false,
        enumerable: false,
    });
    Object.freeze(optimistic.options = {
        max,
        keyArgs,
        makeCacheKey,
        normalizeResult,
        subscribe,
        cache,
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            entry.setDirty();
        }
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) {
            return entry.peek();
        }
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 67421:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a3": function() { return /* reexport */ I18nextProvider; },
  "$G": function() { return /* reexport */ useTranslation_useTranslation; },
  "Zh": function() { return /* reexport */ withTranslation; }
});

// UNUSED EXPORTS: I18nContext, Trans, TransWithoutContext, Translation, composeInitialProps, date, getDefaults, getI18n, getInitialProps, initReactI18next, number, plural, select, selectOrdinal, setDefaults, setI18n, time, useSSR, withSSR

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/void-elements/index.js
var void_elements = __webpack_require__(71739);
var void_elements_default = /*#__PURE__*/__webpack_require__.n(void_elements);
;// CONCATENATED MODULE: ./node_modules/html-parse-stringify/dist/html-parse-stringify.module.js
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],((void_elements_default())[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ var html_parse_stringify_module = ((/* unused pure expression or super */ null && (c)));
//# sourceMappingURL=html-parse-stringify.module.js.map

;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/utils.js
function utils_warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function utils_warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  utils_warn.apply(void 0, args);
}

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  };
};

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    utils_warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function utils_getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/unescape.js
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape_unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/defaults.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape_unescape
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function defaults_getDefaults() {
  return defaultOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/TransWithoutContext.js



var _excluded = (/* unused pure expression or super */ null && (["format"])),
    _excluded2 = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function TransWithoutContext_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TransWithoutContext_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TransWithoutContext_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TransWithoutContext_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = TransWithoutContext_objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (_typeof(child) === 'object' && !isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = HTML.parse("<0>".concat(targetString, "</0>"));

  var opts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(cloneElement(child, TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, _excluded2);

  var i18n = i18nFromProps || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread(TransWithoutContext_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? createElement(useAsParent, additionalProps, content) : content;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/i18nInstance.js
var i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function i18nInstance_getI18n() {
  return i18nInstance;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/initReactI18next.js


var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/context.js




function context_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function context_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { context_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { context_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var context_I18nContext = (0,react.createContext)();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    (0,classCallCheck/* default */.Z)(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  (0,createClass/* default */.Z)(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function context_composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(context_objectSpread(context_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = getI18n();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Trans.js


var Trans_excluded = (/* unused pure expression or super */ null && (["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"]));

function Trans_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Trans_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Trans_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Trans_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function Trans_Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = _objectWithoutProperties(_ref, Trans_excluded);

  var _ref2 = useContext(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  var t = tFromProps || i18n && i18n.t.bind(i18n);
  return TransWithoutContext(Trans_objectSpread({
    children: children,
    count: count,
    parent: parent,
    i18nKey: i18nKey,
    context: context,
    tOptions: tOptions,
    values: values,
    defaults: defaults,
    components: components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n: i18n,
    t: tFromProps,
    shouldUnescape: shouldUnescape
  }, additionalProps));
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js




function useTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = (0,react.useRef)();
  (0,react.useEffect)(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation_useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = (0,react.useContext)(context_I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || i18nInstance_getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    utils_warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && (0,esm_typeof/* default */.Z)(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) utils_warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = useTranslation_objectSpread(useTranslation_objectSpread(useTranslation_objectSpread({}, defaults_getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = (0,react.useState)(getT),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      loadNamespaces(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js



var withTranslation_excluded = ["forwardedRef"];

function withTranslation_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withTranslation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withTranslation_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withTranslation_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = (0,objectWithoutProperties/* default */.Z)(_ref, withTranslation_excluded);

      var _useTranslation = useTranslation_useTranslation(ns, withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = (0,slicedToArray/* default */.Z)(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = withTranslation_objectSpread(withTranslation_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return (0,react.createElement)(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(utils_getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return (0,react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? (0,react.forwardRef)(forwardRef) : I18nextWithTranslation;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/Translation.js


var Translation_excluded = (/* unused pure expression or super */ null && (["ns", "children"]));

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = _objectWithoutProperties(props, Translation_excluded);

  var _useTranslation = useTranslation(ns, options),
      _useTranslation2 = _slicedToArray(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/I18nextProvider.js


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = (0,react.useMemo)(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return (0,react.createElement)(context_I18nContext.Provider, {
    value: value
  }, children);
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/useSSR.js


function useSSR_useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/withSSR.js


var withSSR_excluded = (/* unused pure expression or super */ null && (["initialI18nStore", "initialLanguage"]));

function withSSR_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function withSSR_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { withSSR_ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { withSSR_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = _objectWithoutProperties(_ref, withSSR_excluded);

      useSSR(initialI18nStore, initialLanguage);
      return createElement(WrappedComponent, withSSR_objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = composeInitialProps(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-i18next/dist/es/index.js












var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var es_select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ }),

/***/ 97582:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jh": function() { return /* binding */ __generator; },
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "mG": function() { return /* binding */ __awaiter; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
  function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose;
    if (async) {
        if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
        dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
        if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
        dispose = value[Symbol.dispose];
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  function next() {
    while (env.stack.length) {
      var rec = env.stack.pop();
      try {
        var result = rec.dispose && rec.dispose.call(rec.value);
        if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
      }
      catch (e) {
          fail(e);
      }
    }
    if (env.hasError) throw env.error;
  }
  return next();
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
});


/***/ }),

/***/ 48216:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ Observable; }
/* harmony export */ });
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass(Subscription, [{
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass(SubscriptionObserver, [{
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function (value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function (value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function (value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function (value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function (v) {
            observer.next(v);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function (value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function (value) {
              observer.next(value);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function (e) {
          observer.error(e);
        },
        complete: function () {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass(Observable, null, [{
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(91118), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);